module.exports = {
    BubblesData: () => {
        return [[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[586.185,293.612], [583.848,241.736], [553.038,293.636], [550.515,241.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.497,344.938], [586.185,293.613], [555.729,344.923], [553.234,293.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.497,344.938], [590.782,395.658], [555.535,344.927], [558.003,395.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.783,395.69], [593.043,445.846], [558.004,395.645], [560.444,445.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.044,445.878], [595.279,495.479], [560.445,445.799], [562.858,495.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.28,495.51], [597.49,544.566], [562.86,495.399], [565.246,544.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.491,544.597], [599.677,593.116], [565.248,544.454], [567.608,592.942]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[677.948,292.204], [676.057,238.175], [568.731,292.284], [566.2,238.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.678,593.147], [601.84,641.138], [567.61,592.973], [569.944,640.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[679.817,345.635], [677.948,292.205], [571.235,345.596], [568.731,292.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[601.842,641.169], [569.946,640.964], [603.98,688.641], [572.255,688.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[679.817,345.635], [681.664,398.41], [571.234,345.596], [573.707,398.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[603.981,688.671], [572.257,688.437], [606.097,735.633], [574.541,735.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[681.665,398.444], [683.49,450.609], [573.708,398.288], [576.152,450.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[606.098,735.662], [574.543,735.399], [608.191,782.121], [576.803,781.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.491,450.642], [685.296,502.207], [576.154,450.373], [578.57,501.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[608.191,782.121], [576.803,781.83], [610.112,824.759], [578.877,824.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.297,502.239], [687.081,553.214], [578.571,501.859], [580.959,552.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.082,553.246], [688.845,603.642], [580.961,552.758], [583.322,603.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.846,603.674], [690.59,653.5], [583.324,603.08], [585.658,652.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.591,653.531], [692.315,702.797], [585.66,652.834], [587.968,701.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.316,702.828], [694.02,751.543], [587.97,702.029], [590.252,750.646]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.021,751.573], [695.707,799.747], [590.254,750.676], [592.511,798.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.707,799.747], [697.253,843.941], [592.511,798.753], [594.582,842.86]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[732.643,291.558], [731.047,236.54], [671.901,291.603], [669.942,236.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.22,345.955], [732.643,291.558], [673.838,345.933], [671.901,291.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.22,345.955], [735.778,399.674], [673.838,345.933], [675.751,399.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.779,399.708], [737.318,452.794], [675.752,399.62], [677.642,452.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.319,452.828], [738.841,505.293], [677.643,452.676], [679.511,505.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.842,505.326], [740.346,557.18], [679.513,505.111], [681.359,556.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.346,557.213], [741.833,608.468], [681.36,556.937], [683.185,608.132]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.834,608.5], [743.303,659.165], [683.187,608.164], [684.991,658.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.304,659.197], [744.756,709.282], [684.992,658.803], [686.775,708.832]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.757,709.314], [686.776,708.863], [746.193,758.83], [688.54,758.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.194,758.861], [688.541,758.355], [747.614,807.817], [690.284,807.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.614,807.817], [690.284,807.256], [748.916,852.721], [691.883,852.111]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[797.243,290.976], [796.017,235.068], [733.934,291.024], [732.323,235.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.454,346.242], [797.243,290.976], [735.527,346.219], [733.934,291.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.454,346.243], [799.651,400.81], [735.527,346.219], [737.099,400.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.651,400.844], [800.833,454.759], [737.1,400.751], [738.654,454.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.834,454.793], [802.002,508.066], [738.655,454.632], [740.19,507.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.003,508.1], [803.157,560.744], [740.191,507.873], [741.708,560.453]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.157,560.777], [804.298,612.803], [741.709,560.486], [743.209,612.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.299,612.836], [743.21,612.481], [805.426,664.253], [744.692,663.837]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.427,664.286], [744.693,663.87], [806.541,715.107], [746.157,714.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.541,715.139], [746.158,714.663], [807.643,765.373], [747.606,764.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.643,765.404], [747.607,764.87], [808.732,815.062], [749.038,814.47]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.732,815.062], [749.038,814.47], [809.73,860.602], [750.351,859.958]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[797.243,290.976], [796.017,235.068], [801.168,291.582], [799.986,236.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.454,346.242], [797.243,290.976], [802.336,345.943], [801.168,291.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.454,346.243], [799.65,400.81], [802.336,345.943], [803.49,399.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.651,400.844], [800.833,454.759], [803.491,399.661], [804.631,452.713]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[914.605,291.498], [914.105,236.388], [801.168,291.582], [799.986,236.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.099,345.984], [914.605,291.498], [802.336,345.943], [801.168,291.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.834,454.793], [802.002,508.066], [804.632,452.747], [805.759,505.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.099,345.984], [915.587,399.791], [802.336,345.943], [803.49,399.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.003,508.1], [803.157,560.744], [805.76,505.211], [806.874,557.033]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.588,399.825], [916.07,452.996], [803.491,399.661], [804.631,452.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.157,560.777], [804.298,612.803], [806.874,557.066], [807.975,608.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.07,453.03], [916.547,505.578], [804.632,452.747], [805.759,505.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.299,612.835], [805.426,664.253], [807.976,608.321], [809.064,658.955]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.427,664.286], [806.541,715.107], [809.065,658.987], [810.141,709.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.547,505.612], [917.018,557.547], [805.76,505.212], [806.874,557.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.541,715.139], [807.643,765.373], [810.141,709.074], [811.205,758.56]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.019,557.58], [917.484,608.914], [806.874,557.066], [807.975,608.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.643,765.404], [808.732,815.062], [811.206,758.591], [812.258,807.518]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.485,608.947], [917.945,659.689], [807.976,608.321], [809.064,658.955]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.945,659.721], [918.4,709.882], [809.065,658.987], [810.141,709.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.732,815.062], [809.73,860.602], [812.258,807.519], [813.222,852.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.401,709.914], [810.142,709.074], [918.85,759.504], [811.205,758.56]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.851,759.535], [811.206,758.591], [919.296,808.564], [812.258,807.518]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.296,808.564], [812.258,807.519], [919.703,853.533], [813.222,852.396]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[914.605,291.498], [914.105,236.389], [917.646,292.406], [917.177,238.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.099,345.984], [914.605,291.498], [918.11,345.535], [917.646,292.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.1,345.984], [915.588,399.791], [918.11,345.535], [918.569,398.016]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.588,399.825], [916.07,452.996], [918.569,398.05], [919.023,449.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.071,453.03], [916.547,505.578], [919.023,449.96], [919.471,501.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.548,505.612], [917.019,557.547], [919.471,501.277], [919.914,551.977]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[953.959,292.38], [953.703,238.62], [917.646,292.406], [917.176,238.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.019,557.58], [917.485,608.914], [919.915,552.009], [920.353,602.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.485,608.947], [917.945,659.689], [920.353,602.169], [920.786,651.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.212,345.548], [953.959,292.38], [918.11,345.535], [917.646,292.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.212,345.548], [954.462,398.068], [918.11,345.535], [918.569,398.016]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.463,398.101], [918.569,398.05], [954.71,450.016], [919.022,449.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.946,659.721], [918.401,709.882], [920.787,651.764], [921.215,700.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.401,709.914], [918.851,759.504], [921.215,700.804], [921.639,749.269]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.71,450.049], [919.023,449.96], [954.955,501.369], [919.471,501.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.955,501.402], [919.471,501.277], [955.196,552.138], [919.914,551.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.851,759.535], [919.296,808.564], [921.639,749.3], [922.058,797.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.296,808.564], [919.704,853.533], [922.058,797.228], [922.442,841.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.196,552.17], [919.914,552.01], [955.435,602.332], [920.353,602.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.435,602.364], [920.353,602.169], [955.672,651.962], [920.786,651.733]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.672,651.993], [920.786,651.764], [955.905,701.036], [921.215,700.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.906,701.067], [921.215,700.805], [956.136,749.565], [921.638,749.269]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.137,749.595], [921.639,749.3], [956.365,797.555], [922.057,797.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.365,797.556], [922.057,797.229], [956.575,841.556], [922.442,841.2]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[953.959,292.38], [953.703,238.62], [956.334,293.403], [956.099,241.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.212,345.548], [953.959,292.38], [956.566,345.042], [956.334,293.402]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.212,345.548], [954.462,398.068], [956.566,345.042], [956.796,396.069]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.462,398.101], [954.71,450.016], [956.796,396.101], [957.023,446.557]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.71,450.049], [954.954,501.369], [957.023,446.589], [957.248,496.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.954,501.402], [955.196,552.138], [957.248,496.515], [957.47,545.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.196,552.17], [955.435,602.332], [957.471,545.889], [957.69,594.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.435,602.364], [955.671,651.962], [957.69,594.72], [957.908,642.986]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.671,651.993], [955.905,701.036], [957.908,643.016], [958.123,690.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.905,701.067], [956.136,749.565], [958.123,690.787], [958.336,738.011]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.136,749.595], [956.365,797.555], [958.336,738.041], [958.546,784.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.365,797.556], [956.574,841.556], [958.546,784.757], [958.739,827.628]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.66,798.148], [1067.14,798.477], [1032.48,842.201], [1066.78,842.559]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.66,552.461], [1069.13,552.623], [1033.46,602.687], [1068.72,602.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.46,602.719], [1068.72,602.915], [1033.25,652.378], [1068.32,652.609]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.25,652.409], [1068.32,652.64], [1033.05,701.513], [1067.92,701.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.05,701.544], [1067.92,701.808], [1032.85,750.1], [1067.53,750.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.85,750.13], [1067.53,750.427], [1032.66,798.148], [1067.14,798.477]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.51,345.572], [1070.8,345.585], [1034.29,398.16], [1070.37,398.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.29,398.194], [1070.37,398.245], [1034.08,450.176], [1069.95,450.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.08,450.209], [1069.95,450.298], [1033.87,501.596], [1069.54,501.721]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.87,501.628], [1069.54,501.754], [1033.66,552.429], [1069.13,552.591]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1034.72,292.333], [1071.23,292.306], [1034.94,238.5], [1071.67,238.433]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.51,345.572], [1034.72,292.333], [1070.8,345.585], [1071.23,292.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.66,710.63], [1176.5,711.466], [1068.26,760.308], [1175.48,761.247]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.26,760.339], [1175.48,761.278], [1067.86,809.454], [1174.47,810.493]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.86,809.454], [1174.47,810.494], [1067.49,854.501], [1173.54,855.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.49,609.479], [1178.59,610.101], [1069.08,660.314], [1177.54,661.044]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.08,660.346], [1177.54,661.076], [1068.66,710.598], [1176.5,711.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.77,453.271], [1070.34,505.919], [1181.8,453.553], [1180.72,506.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.34,505.952], [1180.72,506.35], [1069.91,557.985], [1179.65,558.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.91,558.018], [1179.65,558.529], [1069.49,609.447], [1178.59,610.069]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.65,346.02], [1071.2,399.93], [1184.01,346.061], [1182.9,400.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.2,399.964], [1070.77,453.238], [1182.9,400.127], [1181.8,453.52]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1072.09,291.427], [1072.54,236.208], [1185.14,291.343], [1186.28,235.997]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.65,346.02], [1072.09,291.427], [1184.01,346.061], [1185.14,291.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.66,818.171], [1240.24,818.801], [1175.71,863.983], [1238.94,864.668]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.7,768.213], [1241.65,768.782], [1176.66,818.171], [1240.24,818.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.76,717.639], [1243.08,718.146], [1177.71,768.181], [1241.65,768.75]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.82,666.471], [1244.53,666.913], [1178.76,717.607], [1243.08,718.113]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.9,614.697], [1245.99,615.074], [1179.82,666.438], [1244.53,666.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.99,562.308], [1247.47,562.618], [1180.9,614.664], [1245.99,615.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.1,509.291], [1181.99,562.274], [1248.97,509.533], [1247.47,562.584]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.22,455.637], [1183.1,509.257], [1250.48,455.808], [1248.97,509.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.35,401.332], [1184.22,455.602], [1252.02,401.431], [1250.48,455.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.49,346.366], [1185.35,401.298], [1253.57,346.391], [1252.02,401.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.49,346.366], [1187.65,290.726], [1253.57,346.391], [1255.14,290.675]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1187.65,290.726], [1188.82,234.436], [1255.14,290.676], [1256.73,234.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.16,812.948], [1299.82,813.522], [1239.87,858.302], [1298.23,858.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.56,763.495], [1301.56,764.014], [1241.16,812.948], [1299.82,813.522]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.98,713.439], [1303.32,713.9], [1242.56,763.463], [1301.56,763.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.41,662.801], [1305.1,663.204], [1243.98,713.407], [1303.32,713.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.86,611.57], [1306.9,611.914], [1245.41,662.768], [1305.1,663.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.33,559.737], [1246.86,611.537], [1308.72,560.019], [1306.9,611.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.81,507.29], [1248.33,559.703], [1310.57,507.51], [1308.73,559.986]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.31,454.219], [1249.81,507.257], [1312.44,454.375], [1310.57,507.476]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.83,400.512], [1251.31,454.185], [1314.32,400.603], [1312.44,454.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.37,346.159], [1252.83,400.478], [1316.24,346.182], [1314.33,400.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.37,346.158], [1255.93,291.146], [1316.24,346.181], [1318.17,291.1]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1255.93,291.146], [1257.5,235.498], [1318.17,291.1], [1320.13,235.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.62,805.772], [1294.07,850.496], [1401.22,806.789], [1399.12,851.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.31,757.014], [1295.62,805.772], [1403.51,757.933], [1401.22,806.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.01,707.67], [1297.31,756.983], [1405.82,708.488], [1403.51,757.902]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.74,657.761], [1299.01,707.639], [1408.17,658.475], [1405.82,708.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.49,607.277], [1300.74,657.729], [1410.54,607.885], [1408.17,658.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.25,556.208], [1302.49,607.244], [1412.93,556.708], [1410.54,607.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.04,504.543], [1304.25,556.175], [1415.36,504.933], [1412.94,556.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.85,452.274], [1306.04,504.51], [1417.82,452.549], [1415.36,504.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.68,399.387], [1307.85,452.24], [1420.3,399.547], [1417.82,452.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.53,345.874], [1309.68,399.353], [1422.81,345.914], [1420.3,399.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.53,345.874], [1313.41,291.722], [1422.81,345.914], [1425.36,291.64]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1313.41,291.722], [1315.3,236.955], [1425.36,291.64], [1427.93,236.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.65,790.287], [1423.07,790.607], [1386.68,833.647], [1420.94,833.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1390.79,743.033], [1425.41,743.322], [1388.65,790.287], [1423.07,790.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.95,695.228], [1427.76,695.486], [1390.79,743.003], [1425.41,743.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.17,658.475], [1405.82,708.456], [1395.14,646.894], [1392.95,695.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1395.14,646.894], [1430.15,647.119], [1392.95,695.198], [1427.77,695.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.36,598.022], [1432.56,598.213], [1395.14,646.863], [1430.15,647.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.6,548.602], [1397.36,597.99], [1435,548.759], [1432.56,598.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1401.86,498.626], [1399.6,548.57], [1437.46,498.748], [1435,548.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1404.15,448.083], [1401.86,498.594], [1439.96,448.17], [1437.47,498.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1406.47,396.965], [1404.15,448.051], [1442.48,397.015], [1439.96,448.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.81,345.261], [1406.47,396.932], [1445.03,345.274], [1442.48,396.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.81,345.261], [1411.18,292.961], [1445.03,345.273], [1447.61,292.936]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1411.18,292.961], [1413.58,240.089], [1447.61,292.935], [1450.22,240.024]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[594.401,294.373], [592.16,243.933], [563.321,294.463], [560.914,244.166]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.618,344.289], [594.4,294.373], [565.914,344.236], [563.534,294.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.619,344.289], [598.811,393.629], [565.703,344.24], [568.058,393.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.812,393.66], [600.98,442.462], [568.059,393.473], [570.388,442.141]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[676.109,292.859], [674.238,240.022], [573.055,293.171], [570.607,240.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.982,442.492], [603.127,490.766], [570.39,442.171], [572.694,490.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[603.128,490.796], [605.25,538.55], [572.695,490.344], [574.975,537.97]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[677.96,345.122], [676.109,292.86], [575.478,344.95], [573.056,293.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[677.96,345.122], [679.789,396.753], [575.477,344.95], [577.87,396.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[605.251,538.581], [607.35,585.823], [574.976,538], [577.231,585.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[679.79,396.785], [681.598,447.828], [577.872,396.141], [580.238,446.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.351,585.853], [609.428,632.592], [577.232,585.146], [579.463,631.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.429,632.621], [611.484,678.865], [579.465,631.792], [581.672,677.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[681.599,447.86], [683.386,498.325], [580.24,446.755], [582.579,496.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[611.485,678.894], [581.673,677.944], [613.518,724.65], [583.857,723.583]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.387,498.356], [685.155,548.253], [582.581,496.801], [584.894,546.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[613.52,724.679], [583.859,723.612], [615.531,769.956], [586.02,768.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.156,548.284], [686.903,597.622], [584.895,546.288], [587.183,595.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.531,769.956], [586.02,768.773], [617.378,811.517], [588.004,810.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.904,597.653], [688.632,646.441], [587.185,595.225], [589.447,643.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.633,646.472], [690.342,694.72], [589.449,643.623], [591.686,691.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.343,694.75], [692.033,742.467], [591.688,691.489], [593.901,738.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.034,742.497], [693.706,789.691], [593.902,738.833], [596.091,785.634]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[693.706,789.691], [695.239,832.993], [596.091,785.634], [598.1,828.579]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[725.985,292.131], [724.37,238.138], [668.098,292.309], [666.148,238.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.583,345.523], [725.985,292.131], [670.026,345.425], [668.098,292.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.583,345.523], [729.16,398.257], [670.026,345.425], [671.93,397.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.161,398.29], [730.72,450.41], [671.932,397.922], [673.814,449.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.721,450.443], [732.263,501.961], [673.815,449.812], [675.676,501.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.264,501.993], [733.787,552.919], [675.677,501.105], [677.516,551.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.788,552.951], [735.294,603.294], [677.517,551.812], [679.336,601.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.295,603.326], [736.784,653.097], [679.337,601.941], [681.135,651.472]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.785,653.128], [738.258,702.336], [681.136,651.503], [682.914,700.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.258,702.367], [739.714,751.023], [682.915,700.508], [684.673,748.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.715,751.053], [741.154,799.165], [684.674,748.965], [686.412,796.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.154,799.165], [742.475,843.299], [686.412,796.853], [688.007,840.785]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[786.032,291.435], [784.748,236.339], [725.214,291.625], [723.57,236.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.301,345.905], [786.032,291.435], [726.839,345.801], [725.214,291.625]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.301,345.905], [788.554,399.691], [726.839,345.801], [728.444,399.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.554,399.725], [789.793,452.872], [728.445,399.333], [730.031,452.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.794,452.906], [791.017,505.426], [730.032,452.234], [731.6,504.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.018,505.459], [792.227,557.365], [731.601,504.514], [733.15,556.152]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.228,557.397], [793.423,608.697], [733.151,556.184], [734.682,607.223]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.424,608.73], [794.605,659.435], [734.683,607.255], [736.196,657.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.606,659.467], [795.774,709.589], [736.197,657.738], [737.694,707.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.774,709.62], [796.929,759.167], [737.695,707.642], [739.174,756.946]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.929,759.199], [739.175,756.977], [798.071,808.182], [740.637,805.722]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.071,808.182], [740.637,805.722], [799.117,853.106], [741.978,850.432]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[786.032,291.435], [784.748,236.339], [792.126,291.999], [790.899,237.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.301,345.905], [786.032,291.435], [793.339,345.595], [792.126,291.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.301,345.905], [788.554,399.691], [793.339,345.595], [794.536,398.529]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.554,399.725], [789.793,452.872], [794.537,398.562], [795.721,450.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.794,452.906], [791.017,505.426], [795.722,450.91], [796.892,502.619]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[902.46,291.66], [901.887,236.921], [792.126,291.999], [790.9,237.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.018,505.459], [792.227,557.365], [796.893,502.651], [798.049,553.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.027,345.781], [902.46,291.66], [793.339,345.595], [792.126,291.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.228,557.397], [793.423,608.697], [798.05,553.795], [799.193,604.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.027,345.781], [903.586,399.227], [793.339,345.595], [794.537,398.529]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.424,608.73], [794.605,659.435], [799.194,604.351], [800.324,654.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.587,399.261], [904.14,452.076], [794.537,398.562], [795.721,450.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.606,659.467], [795.774,709.589], [800.325,654.331], [801.442,703.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.14,452.11], [904.686,504.306], [795.722,450.91], [796.892,502.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.774,709.62], [796.929,759.167], [801.443,703.744], [802.548,752.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.687,504.339], [905.227,555.928], [796.893,502.651], [798.049,553.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.929,759.199], [798.071,808.182], [802.548,752.6], [803.641,800.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.227,555.96], [905.761,606.951], [798.05,553.795], [799.193,604.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.071,808.182], [799.117,853.106], [803.641,800.877], [804.643,845.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.761,606.983], [906.289,657.387], [799.194,604.351], [800.324,654.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.289,657.419], [906.81,707.245], [800.325,654.331], [801.442,703.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.811,707.277], [907.326,756.536], [801.443,703.744], [802.548,752.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.327,756.567], [907.836,805.268], [802.548,752.6], [803.641,800.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.836,805.268], [908.304,849.938], [803.641,800.877], [804.643,845.162]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[902.461,291.66], [901.888,236.921], [908.935,292.519], [908.415,239.14]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.027,345.781], [902.46,291.66], [909.45,345.309], [908.935,292.519]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.027,345.781], [903.587,399.227], [909.451,345.31], [909.959,397.457]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.587,399.261], [904.14,452.076], [909.96,397.49], [910.462,449.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.14,452.11], [904.687,504.306], [910.463,449.07], [910.96,500.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.687,504.339], [905.227,555.928], [910.96,500.06], [911.452,550.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.227,555.96], [905.761,606.951], [911.452,550.47], [911.938,600.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.761,606.983], [906.289,657.387], [911.938,600.31], [912.418,649.558]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.289,657.419], [906.811,707.245], [912.419,649.589], [912.894,698.287]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.811,707.277], [907.327,756.536], [912.894,698.318], [913.364,746.475]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.327,756.567], [907.837,805.268], [913.364,746.505], [913.829,794.129]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[944.636,292.412], [944.324,238.864], [908.935,292.519], [908.415,239.14]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.837,805.268], [908.304,849.938], [913.829,794.129], [914.255,837.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.943,345.368], [944.635,292.412], [909.45,345.309], [908.935,292.519]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.944,345.368], [945.248,397.677], [909.45,345.309], [909.959,397.457]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.249,397.71], [945.549,449.415], [909.959,397.49], [910.462,449.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.55,449.448], [945.847,500.56], [910.462,449.07], [910.959,500.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.847,500.593], [910.96,500.06], [946.141,551.122], [911.451,550.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.142,551.154], [911.451,550.47], [946.432,601.109], [911.937,600.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.432,601.141], [911.938,600.31], [946.72,650.534], [912.418,649.559]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.72,650.565], [912.418,649.59], [947.004,699.403], [912.893,698.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.005,699.434], [912.894,698.318], [947.286,747.728], [913.363,746.475]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.286,747.759], [913.364,746.505], [947.564,795.517], [913.828,794.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.564,795.517], [913.828,794.129], [947.819,839.332], [914.254,837.822]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[944.635,292.412], [944.324,238.864], [950.924,293.383], [950.658,241.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.943,345.368], [944.635,292.412], [951.188,344.834], [950.924,293.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.944,345.368], [945.248,397.677], [951.188,344.834], [951.449,395.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.248,397.71], [945.549,449.415], [951.449,395.704], [951.707,445.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.549,449.448], [945.847,500.56], [951.707,446.004], [951.962,495.712]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.847,500.593], [946.141,551.122], [951.962,495.743], [952.214,544.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.141,551.153], [946.432,601.109], [952.214,544.93], [952.464,593.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.432,601.141], [946.72,650.534], [952.464,593.575], [952.71,641.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.72,650.565], [947.004,699.403], [952.71,641.686], [952.954,689.242]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.004,699.434], [947.285,747.728], [952.954,689.272], [953.195,736.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.285,747.759], [947.563,795.517], [953.196,736.342], [953.434,782.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.563,795.517], [947.818,839.332], [953.434,782.875], [953.653,825.577]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.61,653.65], [1023.61,652.655], [1058.27,702.934], [1023.47,701.796]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.27,702.965], [1023.47,701.827], [1057.92,751.694], [1023.32,750.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.92,751.724], [1023.32,750.446], [1057.58,799.908], [1023.18,798.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.58,799.908], [1023.18,798.492], [1057.27,844.108], [1023.04,842.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.78,345.554], [1060.4,398.375], [1024.54,345.494], [1024.38,398.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.4,398.408], [1024.38,398.183], [1060.04,450.613], [1024.22,450.227]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.04,450.646], [1024.22,450.26], [1059.67,502.246], [1024.07,501.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.67,502.279], [1024.07,501.735], [1059.32,553.285], [1023.91,552.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.32,553.317], [1023.91,552.619], [1058.96,603.739], [1023.76,602.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.96,603.771], [1023.76,602.923], [1058.61,653.619], [1023.61,652.624]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1061.15,292.074], [1061.53,237.99], [1024.7,292.183], [1024.86,238.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.78,345.554], [1061.15,292.074], [1024.54,345.494], [1024.7,292.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.37,715.45], [1055.75,711.813], [1163.4,765.713], [1055.41,761.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.4,765.745], [1055.41,761.661], [1162.44,815.426], [1055.08,810.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.44,815.427], [1055.08,810.907], [1161.56,860.985], [1054.78,856.07]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.35,560.973], [1056.78,558.742], [1166.34,613.042], [1056.43,610.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.34,613.075], [1056.43,610.364], [1165.35,664.531], [1056.09,661.352]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.35,664.564], [1056.09,661.384], [1164.37,715.418], [1055.75,711.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.4,454.887], [1057.49,453.651], [1168.37,508.214], [1057.13,506.475]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.37,508.248], [1057.13,506.508], [1167.35,560.94], [1056.78,558.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.49,346.213], [1172.56,290.876], [1058.21,346.021], [1058.58,291.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.49,346.213], [1170.44,400.845], [1058.21,346.021], [1057.85,400.124]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.44,400.879], [1169.4,454.853], [1057.85,400.159], [1057.49,453.617]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1172.56,290.876], [1173.64,234.891], [1058.58,291.225], [1058.96,235.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.39,823.23], [1227.15,826], [1161.5,869.469], [1225.9,872.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.35,721.732], [1229.89,723.962], [1163.37,772.764], [1228.51,775.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.37,772.797], [1228.51,775.3], [1162.39,823.23], [1227.15,826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.35,670.056], [1231.29,672.006], [1164.35,721.699], [1229.89,723.929]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.36,617.759], [1232.7,619.422], [1165.35,670.023], [1231.29,671.973]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.38,564.829], [1234.14,566.198], [1166.36,617.726], [1232.71,619.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.42,511.255], [1235.59,512.323], [1167.38,564.795], [1234.14,566.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.46,457.024], [1237.05,457.783], [1168.42,511.22], [1235.59,512.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.52,402.125], [1238.54,402.567], [1169.46,456.989], [1237.05,457.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.6,346.545], [1170.53,402.09], [1240.04,346.663], [1238.54,402.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.6,346.545], [1172.68,290.271], [1240.04,346.663], [1241.56,290.057]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1172.68,290.271], [1241.56,290.057], [1173.78,233.328], [1243.1,232.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.84,820.111], [1290.11,822.658], [1228.59,866.078], [1288.53,868.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.21,769.978], [1291.84,772.28], [1229.84,820.111], [1290.11,822.658]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.59,719.221], [1293.58,721.271], [1231.21,769.946], [1291.84,772.247]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.98,667.861], [1295.35,669.653], [1232.59,719.188], [1293.58,721.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.4,615.887], [1297.14,617.415], [1233.98,667.828], [1295.35,669.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.83,563.288], [1298.95,564.546], [1235.4,615.853], [1297.14,617.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.27,510.052], [1300.78,511.034], [1236.83,563.254], [1298.95,564.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.74,456.17], [1302.64,456.867], [1238.28,510.018], [1300.79,511]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.22,401.627], [1239.74,456.135], [1304.52,402.033], [1302.64,456.832]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.72,346.412], [1241.22,401.592], [1306.42,346.521], [1304.52,401.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.72,346.412], [1244.24,290.513], [1306.42,346.52], [1308.35,290.316]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1244.24,290.513], [1245.78,233.953], [1308.35,290.316], [1310.29,233.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.1,814.649], [1397.77,819.209], [1286.55,860.139], [1395.62,865.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.78,765.042], [1400.11,769.163], [1288.1,814.649], [1397.77,819.209]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.49,714.824], [1402.48,718.495], [1289.78,765.01], [1400.11,769.131]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.22,664.017], [1291.49,714.792], [1404.88,667.226], [1402.48,718.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.96,612.609], [1293.22,663.984], [1407.31,615.345], [1404.89,667.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.73,560.59], [1294.96,612.576], [1409.77,562.842], [1407.32,615.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1298.52,507.948], [1296.73,560.556], [1412.26,509.705], [1409.78,562.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.33,454.674], [1298.52,507.915], [1414.78,455.923], [1412.26,509.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.16,400.755], [1300.33,454.64], [1417.33,401.483], [1414.78,455.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.02,346.18], [1302.17,400.721], [1419.91,346.374], [1417.33,401.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.02,346.18], [1305.9,290.936], [1419.91,346.374], [1422.53,290.583]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1305.9,290.936], [1307.8,235.047], [1422.53,290.583], [1425.17,234.134]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.61,801.923], [1425.67,803.371], [1387.58,846.299], [1423.45,847.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1391.83,753.545], [1428.1,754.853], [1389.61,801.923], [1425.67,803.371]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.07,704.586], [1430.55,705.75], [1391.83,753.514], [1428.1,754.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.34,655.067], [1433.04,656.085], [1394.07,704.554], [1430.56,705.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.63,604.978], [1435.55,605.846], [1396.34,655.035], [1433.04,656.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1400.95,554.311], [1438.09,555.024], [1398.63,604.946], [1435.55,605.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1403.3,503.053], [1440.66,503.61], [1400.95,554.278], [1438.09,554.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.67,451.196], [1403.3,503.02], [1443.26,451.592], [1440.67,503.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.08,398.729], [1405.67,451.163], [1445.9,398.959], [1443.27,451.558]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.51,345.64], [1408.08,398.695], [1448.56,345.701], [1445.9,398.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.51,345.639], [1412.97,291.918], [1448.56,345.701], [1451.26,291.807]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1412.97,291.918], [1415.45,237.588], [1451.26,291.806], [1453.98,237.299]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1414.68,783.232], [1428.78,783.774], [1412.6,825.965], [1426.63,826.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416.94,736.664], [1431.12,737.154], [1414.68,783.232], [1428.78,783.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1419.23,689.559], [1433.49,689.995], [1416.94,736.635], [1431.12,737.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.55,641.936], [1435.89,642.317], [1419.23,689.529], [1433.49,689.965]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1423.89,593.788], [1438.31,594.113], [1421.55,641.906], [1435.89,642.287]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1426.25,545.106], [1440.76,545.372], [1423.89,593.758], [1438.31,594.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1428.65,495.88], [1443.23,496.088], [1426.26,545.075], [1440.76,545.342]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1431.07,446.101], [1445.74,446.249], [1428.65,495.848], [1443.24,496.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1433.51,395.761], [1448.27,395.847], [1431.07,446.07], [1445.74,446.217]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1435.99,344.849], [1433.52,395.729], [1450.83,344.872], [1448.27,395.815]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1435.99,344.849], [1438.49,293.356], [1450.54,344.871], [1453.13,293.316]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1438.49,293.356], [1441.02,241.304], [1453.43,293.314], [1456.05,241.197]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[607.103,295.308], [604.968,246.423], [578.289,295.441], [576.007,246.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.216,343.694], [607.103,295.308], [580.771,343.592], [578.514,295.447]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[678.513,293.85], [676.677,242.392], [582.524,294.313], [580.173,243.673]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.216,343.694], [611.306,391.529], [580.548,343.597], [582.781,391.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.329,344.755], [678.513,293.851], [584.85,344.418], [582.524,294.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[611.307,391.559], [613.374,438.881], [582.782,391.235], [584.991,438.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.329,344.755], [682.124,395.052], [584.85,344.418], [587.149,393.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[613.375,438.911], [615.42,485.729], [584.993,438.366], [587.179,484.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[682.125,395.083], [683.9,444.813], [587.15,393.964], [589.424,442.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.422,485.759], [617.445,532.081], [587.18,484.997], [589.343,531.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.901,444.845], [685.655,494.018], [589.425,442.961], [591.673,491.387]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.446,532.11], [619.448,577.943], [589.344,531.137], [591.484,576.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.656,494.049], [687.392,542.674], [591.675,491.417], [593.898,539.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.449,577.972], [621.43,623.325], [591.486,576.792], [593.603,621.941]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.393,542.705], [689.109,590.792], [593.899,539.342], [596.099,586.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.432,623.353], [623.392,668.233], [593.605,621.97], [595.7,666.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.393,668.261], [625.333,712.675], [595.702,666.679], [597.776,710.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.11,590.822], [690.807,638.379], [596.1,586.745], [598.276,633.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.334,712.703], [627.254,756.658], [597.777,710.926], [599.83,754.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.808,638.409], [692.486,685.445], [598.277,633.633], [600.429,679.986]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[627.254,756.658], [629.017,797.013], [599.83,754.691], [601.714,794.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.487,685.475], [694.147,731.999], [600.43,680.015], [602.559,725.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.148,732.028], [695.79,778.048], [602.56,725.9], [604.666,771.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.79,778.048], [697.297,820.277], [604.666,771.266], [606.599,812.902]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[723.195,293.123], [721.577,240.378], [668.804,293.39], [666.882,241.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.796,345.285], [723.195,293.123], [670.705,345.091], [668.804,293.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.796,345.285], [726.377,396.81], [670.705,345.091], [672.583,396.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.378,396.842], [727.94,447.772], [672.584,396.198], [674.44,446.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.941,447.804], [729.486,498.15], [674.442,446.72], [676.277,496.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.487,498.182], [731.014,547.954], [676.278,496.667], [678.093,546.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.015,547.985], [732.525,597.193], [678.094,546.05], [679.888,594.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.526,597.224], [734.018,645.876], [679.889,594.878], [681.663,643.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.019,645.907], [735.495,694.013], [681.664,643.159], [683.419,690.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.496,694.044], [736.956,741.614], [683.42,690.904], [685.155,738.091]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.956,741.644], [738.4,788.687], [685.156,738.121], [686.872,784.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.4,788.687], [739.724,831.845], [686.872,784.789], [688.446,827.608]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[778.059,292.399], [776.733,238.376], [720.509,292.686], [718.851,239.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.37,345.812], [778.059,292.399], [722.149,345.603], [720.509,292.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.37,345.812], [780.664,398.556], [722.149,345.603], [723.768,397.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.665,398.59], [781.944,450.711], [723.769,397.898], [725.369,449.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.945,450.744], [783.209,502.254], [725.37,449.58], [726.951,500.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.21,502.286], [784.459,553.195], [726.952,500.661], [728.516,551.12]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.46,553.227], [785.695,603.545], [728.517,551.152], [730.062,601.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.695,603.577], [786.916,653.314], [730.063,601.062], [731.59,650.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.917,653.346], [788.123,702.513], [731.591,650.401], [733.102,699.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.124,702.544], [789.317,751.15], [733.103,699.179], [734.596,747.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.318,751.18], [790.497,799.235], [734.597,747.406], [736.073,795.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.497,799.236], [791.579,843.311], [736.073,795.061], [737.427,838.774]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[778.059,292.399], [776.733,238.376], [786.117,292.878], [784.86,239.7]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.37,345.812], [778.059,292.399], [787.36,345.463], [786.117,292.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.37,345.812], [780.664,398.556], [787.36,345.464], [788.588,397.401]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.665,398.59], [781.944,450.711], [788.589,397.434], [789.802,448.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.945,450.744], [783.209,502.254], [789.803,448.8], [791.003,499.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.21,502.286], [784.459,553.195], [791.003,499.573], [792.189,549.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.46,553.227], [785.695,603.545], [792.19,549.761], [793.362,599.345]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[891.821,292.36], [891.182,238.268], [786.117,292.878], [784.86,239.7]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.695,603.577], [786.916,653.314], [793.363,599.377], [794.522,648.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.453,345.84], [891.821,292.36], [787.36,345.463], [786.117,292.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.453,345.84], [893.077,398.65], [787.36,345.463], [788.588,397.401]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.917,653.346], [788.123,702.512], [794.522,648.428], [795.668,696.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.077,398.684], [893.694,450.87], [788.589,397.434], [789.802,448.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.124,702.543], [789.317,751.15], [795.669,696.925], [796.802,744.846]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.318,751.18], [790.497,799.235], [796.803,744.877], [797.923,792.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.694,450.903], [894.303,502.475], [789.803,448.8], [791.003,499.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.497,799.235], [791.579,843.311], [797.923,792.263], [798.951,835.733]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.304,502.508], [894.906,553.478], [791.003,499.573], [792.189,549.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.906,553.51], [895.502,603.888], [792.19,549.761], [793.362,599.345]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.502,603.92], [896.09,653.715], [793.363,599.377], [794.522,648.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.091,653.747], [896.672,702.971], [794.523,648.428], [795.668,696.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.673,703.002], [897.247,751.664], [795.669,696.925], [796.802,744.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.248,751.695], [897.816,799.804], [796.803,744.877], [797.923,792.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.816,799.804], [898.338,843.929], [797.923,792.263], [798.951,835.733]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[891.821,292.361], [891.182,238.268], [901.544,293.101], [900.977,240.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.453,345.84], [891.821,292.36], [902.104,345.301], [901.544,293.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.453,345.84], [893.077,398.65], [902.104,345.301], [902.657,396.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.077,398.684], [893.694,450.87], [902.657,396.897], [903.204,447.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.694,450.903], [894.304,502.475], [903.204,447.896], [903.745,498.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.304,502.508], [894.906,553.478], [903.745,498.31], [904.28,548.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.907,553.51], [895.502,603.888], [904.28,548.148], [904.808,597.39]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.502,603.92], [896.091,653.715], [904.809,597.421], [905.331,646.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.091,653.747], [896.672,702.971], [905.331,646.138], [905.848,694.277]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.673,703.002], [897.248,751.664], [905.848,694.308], [906.359,741.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.248,751.695], [897.817,799.804], [906.359,741.94], [906.864,789.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.817,799.804], [898.338,843.929], [906.864,789.015], [907.327,832.202]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[936.128,292.936], [935.763,239.86], [901.543,293.101], [900.977,240.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.487,345.422], [936.127,292.935], [902.104,345.301], [901.544,293.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.487,345.422], [936.843,397.262], [902.103,345.302], [902.656,396.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.843,397.295], [937.195,448.534], [902.657,396.896], [903.204,447.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.195,448.566], [937.542,499.214], [903.204,447.896], [903.745,498.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.543,499.246], [937.886,549.313], [903.745,498.31], [904.279,548.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.886,549.344], [938.226,598.84], [904.28,548.148], [904.808,597.39]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.226,598.871], [904.808,597.421], [938.562,647.805], [905.331,646.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.562,647.836], [905.331,646.138], [938.894,696.217], [905.847,694.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.894,696.248], [905.848,694.308], [939.222,744.087], [906.358,741.911]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.222,744.117], [906.359,741.941], [939.547,791.423], [906.864,789.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.547,791.423], [906.864,789.015], [939.844,834.819], [907.327,832.202]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[936.127,292.936], [935.763,239.86], [946.177,293.779], [945.881,242.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.487,345.422], [936.127,292.935], [946.47,344.808], [946.177,293.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.487,345.422], [936.843,397.262], [946.47,344.808], [946.759,395.227]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.843,397.295], [937.194,448.534], [946.759,395.258], [947.045,445.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.195,448.566], [937.542,499.214], [947.045,445.139], [947.328,494.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.542,499.246], [937.886,549.313], [947.328,494.46], [947.608,543.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.886,549.344], [938.225,598.84], [947.608,543.231], [947.884,591.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.226,598.871], [938.561,647.805], [947.884,591.459], [948.158,639.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.561,647.835], [938.893,696.217], [948.158,639.156], [948.428,686.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.894,696.248], [939.222,744.087], [948.429,686.329], [948.696,732.957]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.222,744.117], [939.546,791.423], [948.696,732.986], [948.961,779.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.546,791.423], [939.844,834.819], [948.961,779.108], [949.203,821.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.75,702.527], [1013.54,700.519], [1047.46,751.131], [1013.45,748.879]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.46,751.161], [1013.45,748.909], [1047.18,799.214], [1013.36,796.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.18,799.215], [1013.36,796.724], [1046.92,843.289], [1013.28,840.581]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1050.17,292.401], [1050.49,238.38], [1014.31,292.572], [1014.42,238.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.85,345.811], [1050.17,292.401], [1014.21,345.686], [1014.31,292.572]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.85,345.811], [1049.54,398.553], [1014.21,345.686], [1014.12,398.14]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.54,398.586], [1049.24,450.705], [1014.12,398.173], [1014.02,450.011]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.23,450.738], [1048.93,502.246], [1014.02,450.044], [1013.92,501.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.93,502.278], [1013.92,501.309], [1048.63,553.185], [1013.82,551.947]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.63,553.217], [1013.82,551.978], [1048.33,603.532], [1013.73,602.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.33,603.564], [1013.73,602.064], [1048.04,653.3], [1013.64,651.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.04,653.331], [1013.64,651.574], [1047.75,702.496], [1013.54,700.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.74,768.235], [1041.73,760.98], [1147.85,818.093], [1041.47,810.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.85,818.094], [1041.47,810.072], [1147.03,863.804], [1041.24,855.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.48,614.952], [1150.56,666.627], [1042.52,610.111], [1042.25,660.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1150.56,666.659], [1149.65,717.718], [1042.25,660.994], [1041.99,711.249]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.64,717.75], [1041.99,711.28], [1148.74,768.203], [1041.73,760.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.29,401.723], [1154.32,455.979], [1043.61,400.389], [1043.33,453.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1154.32,456.013], [1153.37,509.606], [1043.33,453.77], [1043.06,506.476]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.37,509.64], [1152.42,562.582], [1043.06,506.51], [1042.79,558.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.42,562.616], [1151.48,614.918], [1042.79,558.62], [1042.52,610.078]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1157.27,291.101], [1158.28,234.781], [1044.18,291.654], [1044.47,236.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.28,346.756], [1157.27,291.101], [1043.89,346.354], [1044.18,291.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.28,346.756], [1155.29,401.688], [1043.89,346.354], [1043.61,400.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.35,830.871], [1145.49,825.901], [1209.17,877.684], [1144.67,872.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.65,779.795], [1146.38,775.299], [1210.35,830.871], [1145.49,825.901]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.29,675.691], [1148.2,672.177], [1212.96,728.028], [1147.29,724.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.96,728.062], [1147.28,724.05], [1211.65,779.763], [1146.38,775.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.63,622.671], [1149.12,619.667], [1214.29,675.657], [1148.2,672.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.99,568.99], [1150.06,566.509], [1215.63,622.637], [1149.12,619.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.37,514.635], [1151.01,512.691], [1216.99,568.955], [1150.06,566.475]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1219.76,459.593], [1151.97,458.2], [1218.37,514.6], [1151.01,512.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1221.18,403.852], [1219.76,459.558], [1152.94,403.024], [1151.97,458.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1222.61,347.399], [1221.18,403.817], [1153.92,347.149], [1152.94,402.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1222.61,347.398], [1224.05,290.218], [1153.92,347.148], [1154.92,290.562]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1224.05,290.219], [1225.52,232.334], [1154.92,290.562], [1155.93,233.287]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1275.78,829.655], [1214.86,825.044], [1274.23,876.363], [1213.66,871.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.46,778.695], [1216.17,774.524], [1275.78,829.655], [1214.86,825.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.17,727.08], [1217.49,723.359], [1277.46,778.662], [1216.17,774.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.9,674.831], [1218.83,671.571], [1279.17,727.047], [1217.49,723.326]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.66,621.936], [1220.19,619.15], [1280.91,674.797], [1218.83,671.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.43,568.383], [1221.56,566.082], [1282.66,621.902], [1220.19,619.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.23,514.159], [1222.95,512.356], [1284.43,568.348], [1221.56,566.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.05,459.252], [1224.35,457.96], [1286.23,514.124], [1222.95,512.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.89,403.65], [1225.78,402.881], [1288.05,459.217], [1224.36,457.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.75,347.338], [1227.22,347.106], [1289.89,403.614], [1225.78,402.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.75,347.337], [1293.64,290.302], [1227.22,347.105], [1228.68,290.621]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1293.64,290.303], [1228.68,290.622], [1295.56,232.568], [1230.16,233.451]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1275.78,829.655], [1274.23,876.363], [1276.12,821.504], [1274.6,867.509]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.12,821.504], [1388.27,829.854], [1274.6,867.508], [1386.09,876.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.46,778.695], [1275.78,829.655], [1277.79,771.32], [1276.12,821.504]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.79,771.32], [1390.64,778.875], [1276.12,821.504], [1388.27,829.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.17,727.08], [1277.46,778.662], [1279.47,720.502], [1277.79,771.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.47,720.502], [1393.04,727.241], [1277.79,771.288], [1390.64,778.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.9,674.831], [1279.17,727.047], [1281.18,669.069], [1279.47,720.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.18,669.069], [1395.47,674.972], [1279.47,720.469], [1393.04,727.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.66,621.936], [1280.91,674.797], [1282.9,617.011], [1281.18,669.036]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.9,617.011], [1397.93,622.056], [1281.18,669.036], [1395.47,674.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.43,568.383], [1282.66,621.902], [1284.65,564.316], [1282.9,616.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.65,564.316], [1400.42,568.482], [1282.9,616.978], [1397.93,622.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.23,514.159], [1284.43,568.348], [1286.41,510.972], [1284.65,564.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.41,510.972], [1402.95,514.237], [1284.65,564.282], [1400.43,568.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.05,459.252], [1286.23,514.124], [1288.2,456.968], [1286.42,510.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.2,456.968], [1405.5,459.308], [1286.42,510.938], [1402.95,514.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.89,403.65], [1288.05,459.217], [1290.02,402.291], [1288.2,456.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.02,402.291], [1288.21,456.933], [1408.09,403.683], [1405.5,459.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.75,347.338], [1289.89,403.614], [1291.85,346.928], [1290.02,402.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.85,346.928], [1290.02,402.256], [1410.71,347.348], [1408.09,403.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.75,347.337], [1293.64,290.302], [1291.85,346.927], [1293.71,290.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.85,346.927], [1293.71,290.866], [1410.71,347.347], [1413.36,290.289]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1293.64,290.303], [1295.55,232.568], [1293.71,290.866], [1295.59,234.129]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1293.71,290.866], [1295.59,234.129], [1413.36,290.289], [1416.05,232.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.07,812.004], [1422.3,814.68], [1382.99,857.187], [1420.01,860.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.33,762.727], [1424.8,765.148], [1385.07,812.003], [1422.3,814.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.63,712.838], [1427.33,714.997], [1387.34,762.695], [1424.8,765.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1391.95,662.358], [1429.89,664.248], [1389.63,712.806], [1427.33,714.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.31,611.276], [1432.49,612.891], [1391.96,662.326], [1429.9,664.215]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.69,559.582], [1435.11,560.915], [1394.31,611.243], [1432.49,612.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.1,507.263], [1437.77,508.308], [1396.69,559.548], [1435.11,560.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1401.53,454.31], [1440.45,455.058], [1399.1,507.23], [1437.77,508.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1404,400.71], [1443.17,401.155], [1401.53,454.276], [1440.46,455.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1406.5,346.451], [1404,400.675], [1445.93,346.585], [1443.18,401.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1406.5,346.451], [1409.03,291.521], [1445.93,346.585], [1448.72,291.337]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1409.03,291.521], [1411.59,235.944], [1448.72,291.337], [1451.54,235.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416.99,793.791], [1431.6,794.797], [1414.83,837.394], [1429.35,838.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1419.36,746.258], [1434.05,747.167], [1416.99,793.791], [1431.6,794.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.75,698.156], [1436.53,698.967], [1419.36,746.228], [1434.05,747.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.17,649.505], [1439.04,650.215], [1421.75,698.125], [1436.53,698.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1426.62,600.297], [1441.58,600.903], [1424.17,649.475], [1439.04,650.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1429.09,550.521], [1444.14,551.02], [1426.62,600.266], [1441.58,600.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1431.59,500.167], [1446.74,500.559], [1429.09,550.489], [1444.15,550.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1434.13,449.226], [1449.37,449.506], [1431.6,500.135], [1446.74,500.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1436.69,397.687], [1452.03,397.854], [1434.13,449.194], [1449.37,449.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1439.28,345.54], [1454.71,345.59], [1436.69,397.654], [1452.03,397.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1439.28,345.54], [1441.91,292.773], [1454.41,345.589], [1457.13,292.706]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1441.91,292.773], [1457.44,292.704], [1444.56,239.41], [1460.19,239.219]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[684.665,294.987], [682.878,245.03], [596.299,295.492], [594.057,246.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[684.665,294.987], [686.432,344.41], [596.299,295.492], [598.518,343.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.432,344.41], [688.179,393.247], [598.517,343.851], [600.71,391.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.18,393.278], [689.907,441.569], [600.711,391.677], [602.88,438.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.909,441.6], [691.616,489.354], [602.881,438.98], [605.026,485.739]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.617,489.384], [693.307,536.611], [605.027,485.768], [607.149,532.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[693.308,536.641], [694.978,583.348], [607.15,532.05], [609.249,577.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.979,583.378], [696.631,629.575], [609.251,577.834], [611.327,623.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.632,629.604], [698.267,675.299], [611.328,623.128], [613.383,667.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.268,675.327], [699.884,720.528], [613.384,667.94], [615.417,712.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.885,720.556], [701.485,765.271], [615.418,712.277], [617.429,756.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.485,765.271], [702.952,806.305], [617.429,756.119], [619.275,796.362]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[723.973,294.346], [722.367,243.009], [673.529,294.64], [671.651,243.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.973,294.346], [725.56,345.119], [673.529,294.64], [675.386,344.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.56,345.119], [727.128,395.275], [675.386,344.794], [677.221,394.346]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.13,395.307], [728.68,444.886], [677.223,394.377], [679.037,443.366]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.681,444.918], [730.213,493.932], [679.038,443.397], [680.832,491.834]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.214,493.963], [731.729,542.42], [680.833,491.865], [682.607,539.759]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.73,542.451], [733.228,590.362], [682.608,539.789], [684.362,587.149]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.229,590.392], [734.711,637.766], [684.363,587.179], [686.098,634.013]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.712,637.796], [736.176,684.641], [686.099,634.043], [687.815,680.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.177,684.67], [737.626,730.995], [687.816,680.391], [689.512,726.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.627,731.025], [739.059,776.839], [689.513,726.23], [691.192,771.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.059,776.839], [740.374,818.872], [691.192,771.541], [692.731,813.117]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[773.246,293.689], [771.894,240.936], [719.552,294.007], [717.898,241.938]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[773.246,293.689], [774.583,345.846], [719.552,294.007], [721.188,345.495]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.583,345.846], [775.903,397.353], [721.188,345.495], [722.804,396.349]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.904,397.385], [777.209,448.284], [722.805,396.381], [724.402,446.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.21,448.316], [778.499,498.619], [724.403,446.675], [725.981,496.356]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[778.5,498.651], [779.774,548.368], [725.982,496.387], [727.542,545.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.775,548.399], [781.035,597.54], [727.543,545.527], [729.086,594.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.035,597.571], [782.28,646.146], [729.087,594.105], [730.612,642.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.281,646.177], [783.512,694.196], [730.613,642.13], [732.12,689.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.513,694.227], [784.73,741.699], [732.121,689.613], [733.612,736.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.73,741.729], [785.933,788.664], [733.613,736.562], [735.087,782.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.933,788.664], [787.037,831.714], [735.087,782.956], [736.439,825.515]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[773.246,293.689], [771.894,240.936], [783.032,294.054], [781.758,242.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[773.246,293.689], [774.583,345.846], [783.032,294.054], [784.292,345.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.583,345.846], [775.903,397.353], [784.292,345.442], [785.536,396.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.904,397.385], [777.209,448.284], [785.537,396.23], [786.767,446.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.21,448.316], [778.499,498.619], [786.768,446.428], [787.983,496.016]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[778.5,498.651], [779.774,548.368], [787.984,496.047], [789.186,545.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.775,548.399], [781.035,597.54], [789.187,545.095], [790.374,593.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.035,597.571], [782.28,646.146], [790.375,593.584], [791.55,641.492]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[882.85,293.474], [882.153,240.258], [783.033,294.054], [781.759,242.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.281,646.177], [783.512,694.196], [791.55,641.523], [792.712,688.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.85,293.474], [883.539,346.084], [783.032,294.054], [784.292,345.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.513,694.227], [784.73,741.699], [792.712,688.92], [793.861,735.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.539,346.084], [884.22,398.032], [784.292,345.442], [785.537,396.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.22,398.065], [884.893,449.395], [785.537,396.23], [786.767,446.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.731,741.729], [785.934,788.664], [793.861,735.785], [794.997,782.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.934,788.664], [787.037,831.714], [794.997,782.099], [796.038,824.584]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.893,449.427], [885.558,500.151], [786.768,446.428], [787.984,496.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.558,500.183], [886.215,550.311], [787.984,496.047], [789.186,545.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.215,550.343], [886.864,599.885], [789.187,545.095], [790.375,593.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.865,599.917], [887.506,648.884], [790.375,593.584], [791.55,641.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.507,648.915], [888.141,697.317], [791.551,641.523], [792.712,688.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.141,697.347], [888.768,745.194], [792.713,688.92], [793.861,735.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.768,745.224], [889.388,792.525], [793.861,735.785], [794.997,782.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.388,792.525], [889.956,835.906], [794.997,782.099], [796.038,824.584]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[882.851,293.475], [882.153,240.258], [895.562,294.048], [894.957,242.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.85,293.474], [883.539,346.084], [895.562,294.047], [896.161,345.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.54,346.084], [884.22,398.032], [896.161,345.45], [896.753,396.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.221,398.065], [884.893,449.395], [896.753,396.252], [897.338,446.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.894,449.427], [885.558,500.151], [897.338,446.463], [897.916,496.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.559,500.183], [886.215,550.311], [897.916,496.095], [898.487,545.125]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.216,550.343], [886.865,599.885], [898.488,545.156], [899.052,593.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.865,599.917], [887.507,648.884], [899.053,593.658], [899.611,641.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.507,648.915], [888.141,697.317], [899.611,641.608], [900.163,688.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.142,697.347], [888.768,745.194], [900.163,689.018], [900.709,735.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.769,745.224], [889.388,792.525], [900.709,735.895], [901.249,782.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.388,792.525], [889.957,835.906], [901.249,782.219], [901.744,824.715]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[928.59,293.861], [928.178,241.477], [895.562,294.048], [894.957,242.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.59,293.861], [928.997,345.657], [895.562,294.047], [896.161,345.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.998,345.657], [929.4,396.811], [896.161,345.45], [896.752,396.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.401,396.843], [929.799,447.398], [896.753,396.252], [897.337,446.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.799,447.43], [930.192,497.397], [897.338,446.463], [897.915,496.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.192,497.429], [930.581,546.817], [897.916,496.095], [898.487,545.125]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.581,546.848], [930.966,595.669], [898.487,545.156], [899.052,593.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.966,595.7], [931.346,643.962], [899.052,593.658], [899.61,641.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.346,643.992], [899.611,641.608], [931.722,691.706], [900.163,688.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.722,691.736], [900.163,689.018], [932.093,738.91], [900.709,735.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.094,738.939], [900.709,735.895], [932.461,785.583], [901.249,782.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.461,785.583], [901.249,782.219], [932.797,828.368], [901.744,824.715]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[928.59,293.861], [928.177,241.477], [942.163,294.518], [941.841,243.55]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.59,293.861], [928.997,345.657], [942.163,294.518], [942.482,344.93]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.997,345.657], [929.4,396.811], [942.482,344.93], [942.797,394.733]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.4,396.843], [929.798,447.398], [942.797,394.764], [943.108,444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.799,447.43], [930.192,497.397], [943.108,444.031], [943.416,492.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.192,497.428], [930.581,546.817], [943.416,492.739], [943.72,540.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.581,546.848], [930.966,595.669], [943.72,540.898], [944.021,588.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.966,595.7], [931.346,643.962], [944.021,588.518], [944.319,635.577]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.346,643.992], [931.721,691.706], [944.319,635.607], [944.613,682.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.722,691.736], [932.093,738.91], [944.613,682.174], [944.904,728.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.093,738.939], [932.46,785.583], [944.904,728.228], [945.192,773.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.46,785.583], [932.797,828.368], [945.192,773.748], [945.456,815.515]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.66,700.66], [1003.54,697.808], [1036.43,748.903], [1003.51,745.71]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.43,748.934], [1003.51,745.74], [1036.21,796.621], [1003.47,793.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.21,796.621], [1003.47,793.095], [1036,840.354], [1003.44,836.524]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1038.58,293.246], [1038.83,239.538], [1003.84,293.443], [1003.88,240.158]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.58,293.246], [1038.33,346.336], [1003.84,293.443], [1003.8,346.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.33,346.336], [1038.08,398.753], [1003.8,346.119], [1003.76,398.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.08,398.786], [1037.84,450.574], [1003.76,398.165], [1003.72,449.559]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.84,450.607], [1037.6,501.778], [1003.72,449.591], [1003.69,500.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.6,501.81], [1037.36,552.375], [1003.69,500.41], [1003.65,550.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.36,552.406], [1037.12,602.375], [1003.65,550.63], [1003.61,600.232]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.12,602.406], [1003.61,600.263], [1036.89,651.79], [1003.58,649.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.89,651.821], [1003.58,649.319], [1036.66,700.629], [1003.54,697.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.94,768.862], [1131.13,818.624], [1027.58,758.496], [1027.4,807.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.13,818.624], [1130.38,864.235], [1027.4,807.181], [1027.24,851.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.01,456.958], [1136.14,510.532], [1028.69,453.652], [1028.5,505.975]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.13,510.566], [1135.27,563.474], [1028.5,506.009], [1028.31,557.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.27,563.508], [1134.42,615.763], [1028.31,557.73], [1028.12,608.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.42,615.796], [1133.58,667.411], [1028.12,608.829], [1027.94,659.284]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.58,667.444], [1132.75,718.43], [1027.94,659.315], [1027.76,709.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.75,718.462], [1131.94,768.83], [1027.76,709.201], [1027.58,758.465]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1139.69,292.016], [1140.6,235.653], [1029.28,292.657], [1029.48,237.676]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1139.69,292.016], [1138.78,347.697], [1029.28,292.657], [1029.08,346.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1138.78,347.697], [1137.89,402.638], [1029.08,346.988], [1028.88,400.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.89,402.673], [1137.01,456.924], [1028.88,400.649], [1028.69,453.619]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.32,833.475], [1126.45,826.313], [1189.22,880.348], [1125.73,872.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.74,730.489], [1128.05,724.688], [1191.53,782.287], [1127.25,775.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.53,782.319], [1127.25,775.829], [1190.32,833.475], [1126.45,826.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.98,678.003], [1128.86,672.909], [1192.75,730.456], [1128.05,724.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.23,624.851], [1129.69,620.482], [1193.98,677.97], [1128.86,672.876]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.49,571.018], [1195.23,624.817], [1130.52,567.394], [1129.69,620.449]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.07,461.259], [1197.78,516.457], [1132.22,459.184], [1131.37,513.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.77,516.492], [1196.49,570.983], [1131.37,513.633], [1130.52,567.36]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.39,405.306], [1199.07,461.224], [1133.09,404.036], [1132.22,459.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.72,348.619], [1200.39,405.271], [1133.96,348.174], [1133.09,404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.07,291.182], [1201.72,348.618], [1134.85,291.584], [1133.96,348.173]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1203.07,291.182], [1204.44,233.018], [1134.85,291.585], [1135.75,234.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.17,834.515], [1196.62,827.81], [1255.68,881.475], [1195.5,874.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.79,783.262], [1197.85,777.185], [1257.17,834.515], [1196.62,827.81]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.43,731.331], [1199.1,725.9], [1258.79,783.229], [1197.85,777.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.1,678.743], [1200.36,673.974], [1260.43,731.298], [1199.1,725.867]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.78,625.485], [1201.63,621.395], [1262.1,678.709], [1200.36,673.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.49,571.544], [1202.92,568.151], [1263.78,625.451], [1201.63,621.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.22,516.907], [1204.23,514.23], [1265.49,571.509], [1202.92,568.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.97,461.561], [1267.22,516.872], [1205.55,459.617], [1204.23,514.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.75,405.491], [1268.97,461.525], [1206.9,404.301], [1205.56,459.582]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.54,348.684], [1270.75,405.455], [1208.26,348.267], [1206.9,404.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.37,291.123], [1272.54,348.683], [1209.63,291.5], [1208.26,348.266]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1274.37,291.123], [1276.21,232.833], [1209.63,291.501], [1211.03,234.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.17,834.515], [1255.68,881.475], [1259.98,826.35], [1258.5,872.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.79,783.262], [1257.17,834.515], [1261.59,775.862], [1259.98,826.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.43,731.331], [1258.79,783.229], [1263.23,724.717], [1261.6,775.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.79,838.638], [1259.98,826.35], [1370.62,885.948], [1258.5,872.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.15,786.999], [1261.6,775.862], [1372.79,838.638], [1259.98,826.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.1,678.743], [1260.43,731.298], [1264.88,672.936], [1263.23,724.685]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.78,625.485], [1262.1,678.709], [1266.56,620.505], [1264.89,672.902]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.54,734.672], [1263.23,724.717], [1375.15,786.966], [1261.6,775.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.97,681.677], [1264.89,672.935], [1377.55,734.638], [1263.23,724.685]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.49,571.544], [1263.78,625.451], [1268.26,567.413], [1266.56,620.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1382.43,628.001], [1266.56,620.505], [1379.97,681.643], [1264.89,672.902]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.22,516.907], [1265.49,571.509], [1269.98,513.647], [1268.26,567.379]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.97,461.561], [1267.22,516.872], [1271.72,459.195], [1269.98,513.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.91,573.632], [1268.26,567.413], [1382.43,627.967], [1266.56,620.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.75,405.491], [1268.97,461.525], [1273.48,404.042], [1271.72,459.16]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.44,518.555], [1269.98,513.647], [1384.92,573.597], [1268.26,567.379]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.99,462.757], [1387.44,518.52], [1271.72,459.195], [1269.98,513.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.54,348.684], [1270.75,405.455], [1275.26,348.176], [1273.48,404.007]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.58,406.224], [1389.99,462.721], [1273.48,404.042], [1271.72,459.16]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.37,291.123], [1272.54,348.683], [1277.07,291.582], [1275.27,348.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1395.2,348.94], [1392.58,406.188], [1275.27,348.176], [1273.48,404.007]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1274.37,291.123], [1276.21,232.833], [1277.07,291.583], [1278.91,234.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.85,290.891], [1395.2,348.94], [1277.07,291.582], [1275.26,348.176]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1397.85,290.891], [1400.54,232.1], [1277.07,291.583], [1278.91,234.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.79,838.638], [1370.62,885.948], [1374.96,820.483], [1372.86,866.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.15,786.999], [1372.79,838.638], [1377.25,770.547], [1374.96,820.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1412.83,824.463], [1374.96,820.483], [1410.5,870.57], [1372.86,866.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1415.37,774.152], [1377.25,770.547], [1412.83,824.463], [1374.96,820.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.54,734.672], [1375.15,786.966], [1379.58,719.967], [1377.26,770.514]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.97,681.677], [1377.55,734.638], [1381.93,668.765], [1379.58,719.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1417.95,723.189], [1379.58,719.967], [1415.38,774.12], [1377.26,770.514]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1382.43,628.001], [1379.97,681.643], [1384.31,616.929], [1381.93,668.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1420.56,671.594], [1381.93,668.765], [1417.95,723.157], [1379.58,719.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1423.2,619.354], [1384.31,616.929], [1420.56,671.561], [1381.93,668.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.91,573.632], [1382.43,627.967], [1386.72,564.447], [1384.31,616.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.44,518.555], [1384.92,573.597], [1389.16,511.307], [1386.72,564.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1425.88,566.459], [1386.72,564.447], [1423.2,619.321], [1384.31,616.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1428.58,512.894], [1389.16,511.307], [1425.88,566.425], [1386.72,564.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.99,462.757], [1387.44,518.52], [1391.63,457.496], [1389.16,511.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.58,406.224], [1389.99,462.721], [1394.13,403.002], [1391.63,457.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1431.33,458.648], [1391.63,457.497], [1428.59,512.86], [1389.16,511.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1434.1,403.708], [1394.13,403.002], [1431.33,458.613], [1391.63,457.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1395.2,348.94], [1392.58,406.188], [1396.67,347.812], [1394.14,402.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1436.92,348.059], [1396.67,347.812], [1434.11,403.672], [1394.14,402.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.85,290.891], [1395.2,348.94], [1399.24,291.912], [1396.67,347.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1439.77,291.688], [1436.92,348.059], [1399.24,291.912], [1396.67,347.812]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1397.85,290.891], [1400.54,232.1], [1399.24,291.912], [1401.84,235.324]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1439.77,291.688], [1399.24,291.911], [1442.65,234.619], [1401.84,235.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.77,803.101], [1428.69,804.603], [1411.53,847.388], [1426.37,849.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416.21,754.801], [1431.23,756.161], [1413.77,803.101], [1428.69,804.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1418.68,705.9], [1433.8,707.115], [1416.21,754.77], [1431.23,756.13]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.18,656.419], [1436.4,657.485], [1418.68,705.869], [1433.8,707.084]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1423.71,606.346], [1439.03,607.26], [1421.19,656.388], [1436.4,657.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1426.28,555.672], [1441.69,556.429], [1423.72,606.315], [1439.03,607.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1428.87,504.385], [1444.38,504.983], [1426.28,555.64], [1441.69,556.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1431.49,452.475], [1447.11,452.908], [1428.87,504.353], [1444.38,504.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1434.15,399.929], [1449.87,400.194], [1431.49,452.442], [1447.11,452.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1436.84,346.736], [1452.66,346.829], [1434.15,399.896], [1449.87,400.161]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1439.56,292.885], [1436.84,346.736], [1455.18,292.803], [1452.35,346.827]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1439.56,292.884], [1455.49,292.801], [1442.31,238.396], [1458.36,238.131]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[693.971,296.088], [692.246,247.693], [613.492,296.521], [611.368,249.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[693.971,296.089], [695.678,343.971], [613.492,296.522], [615.594,343.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.678,343.971], [697.364,391.287], [615.593,343.124], [617.671,389.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[697.366,391.317], [699.033,438.107], [617.672,389.219], [619.727,434.786]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.034,438.137], [700.684,484.409], [619.729,434.815], [621.762,479.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.685,484.438], [702.316,530.202], [621.763,479.92], [623.774,524.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.317,530.231], [703.93,575.494], [623.775,524.541], [625.765,568.66]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[703.931,575.522], [705.527,620.292], [625.766,568.687], [627.735,612.338]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.528,620.321], [707.107,664.607], [627.736,612.365], [629.684,655.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.108,664.634], [708.669,708.444], [629.685,655.583], [631.613,698.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.671,708.471], [710.215,751.811], [631.614,698.347], [633.521,740.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.215,751.811], [711.633,791.587], [633.521,740.639], [635.272,779.462]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[727.883,295.612], [726.305,245.775], [681.663,295.865], [679.843,246.793]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.883,295.612], [729.444,344.903], [681.663,295.865], [683.463,344.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.444,344.903], [730.986,393.597], [683.463,344.409], [685.242,392.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.986,393.628], [732.51,441.764], [685.243,392.402], [687.002,439.824]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.511,441.794], [734.018,489.382], [687.003,439.854], [688.742,486.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.019,489.412], [735.509,536.462], [688.743,486.774], [690.463,533.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.51,536.491], [736.982,583.011], [690.464,533.171], [692.165,579.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.983,583.041], [738.44,629.04], [692.166,579.054], [693.848,624.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.44,629.069], [739.881,674.557], [693.849,624.431], [695.513,669.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.882,674.586], [741.306,719.57], [695.514,669.31], [697.159,713.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.307,719.599], [742.715,764.088], [697.16,713.699], [698.787,757.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.715,764.088], [744.008,804.906], [698.787,757.58], [700.281,797.846]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[771.362,295.111], [769.999,243.759], [721.922,295.386], [720.288,244.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[771.362,295.111], [772.71,345.883], [721.922,295.386], [723.539,345.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[772.71,345.883], [774.042,396.022], [723.539,345.346], [725.136,394.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.042,396.053], [775.358,445.601], [725.137,394.723], [726.715,443.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.359,445.632], [776.659,494.599], [726.716,443.527], [728.276,491.738]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.66,494.63], [777.945,543.027], [728.277,491.768], [729.819,539.426]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.945,543.057], [779.216,590.893], [729.82,539.456], [731.345,586.571]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.216,590.923], [780.472,638.209], [731.346,586.601], [732.853,633.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.473,638.239], [781.714,684.983], [732.854,633.211], [734.344,679.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.715,685.012], [782.942,731.224], [734.346,679.296], [735.819,724.835]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.942,731.253], [784.155,776.942], [735.82,724.864], [737.277,769.895]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.155,776.942], [785.268,818.849], [737.277,769.895], [738.614,811.206]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[771.362,295.111], [769.999,243.759], [782.631,295.349], [781.354,244.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[771.362,295.111], [772.71,345.883], [782.631,295.349], [783.894,345.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[772.71,345.883], [774.042,396.022], [783.894,345.417], [785.142,394.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.042,396.053], [775.358,445.601], [785.143,394.9], [786.376,443.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.359,445.632], [776.659,494.599], [786.377,443.808], [787.595,492.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.66,494.63], [777.945,543.027], [787.596,492.15], [788.801,539.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.946,543.057], [779.216,590.893], [788.802,539.937], [789.993,587.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.216,590.923], [780.472,638.209], [789.994,587.178], [791.171,633.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.473,638.239], [781.714,684.983], [791.172,633.882], [792.336,680.029]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[875.605,294.842], [874.859,242.674], [782.631,295.349], [781.354,244.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.715,685.012], [782.942,731.224], [792.337,680.058], [793.488,725.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.605,294.842], [876.343,346.41], [782.631,295.349], [783.894,345.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.942,731.253], [784.156,776.942], [793.489,725.716], [794.627,770.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.343,346.41], [877.072,397.326], [783.894,345.417], [785.142,394.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.156,776.942], [785.268,818.849], [794.627,770.836], [795.671,812.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.072,397.358], [877.792,447.664], [785.143,394.9], [786.376,443.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.792,447.696], [878.504,497.404], [786.377,443.808], [787.596,492.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.504,497.435], [879.207,546.555], [787.596,492.15], [788.801,539.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.207,546.586], [879.902,595.128], [788.802,539.937], [789.993,587.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.902,595.159], [880.589,643.134], [789.994,587.178], [791.171,633.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.589,643.164], [881.268,690.582], [791.172,633.882], [792.336,680.029]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.268,690.612], [881.939,737.482], [792.337,680.058], [793.488,725.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.939,737.511], [882.602,783.843], [793.489,725.716], [794.627,770.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.602,783.843], [883.21,826.332], [794.627,770.836], [795.672,812.226]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[875.606,294.842], [874.859,242.674], [891.002,295.221], [890.364,244.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.605,294.842], [876.343,346.41], [891.002,295.221], [891.633,345.668]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.343,346.41], [877.072,397.326], [891.633,345.668], [892.256,395.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.072,397.358], [877.792,447.664], [892.256,395.522], [892.872,444.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.793,447.696], [878.504,497.404], [892.872,444.791], [893.481,493.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.504,497.435], [879.207,546.555], [893.481,493.487], [894.082,541.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.208,546.586], [879.902,595.128], [894.083,541.619], [894.677,589.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.903,595.159], [880.589,643.134], [894.677,589.197], [895.265,636.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.589,643.164], [881.268,690.582], [895.265,636.231], [895.846,682.7]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.268,690.612], [881.939,737.482], [895.847,682.729], [896.421,728.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.939,737.511], [882.602,783.843], [896.421,728.702], [896.989,774.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.602,783.843], [883.21,826.332], [896.989,774.129], [897.51,815.797]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[922.112,295.056], [921.656,243.536], [891.002,295.221], [890.364,244.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.111,295.056], [922.562,345.992], [891.002,295.221], [891.633,345.668]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.562,345.992], [923.007,396.29], [891.633,345.668], [892.255,395.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.008,396.322], [923.447,446.026], [892.256,395.522], [892.871,444.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.448,446.058], [923.882,495.178], [892.872,444.791], [893.48,493.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.882,495.209], [924.312,543.755], [893.48,493.487], [894.082,541.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.312,543.785], [924.737,591.767], [894.082,541.619], [894.677,589.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.737,591.798], [925.156,639.225], [894.677,589.197], [895.264,636.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.157,639.255], [925.571,686.138], [895.265,636.231], [895.846,682.7]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.572,686.168], [925.982,732.516], [895.846,682.73], [896.42,728.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.982,732.545], [896.421,728.702], [926.387,778.367], [896.989,774.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.387,778.367], [896.989,774.129], [926.759,820.394], [897.51,815.798]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[922.111,295.056], [921.655,243.536], [938.911,295.493], [938.566,245.297]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.111,295.056], [922.562,345.992], [938.911,295.493], [939.252,345.136]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.562,345.992], [923.007,396.291], [939.252,345.136], [939.589,394.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.007,396.322], [923.447,446.026], [939.589,394.203], [939.923,442.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.447,446.058], [923.882,495.178], [939.923,442.705], [940.252,490.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.882,495.209], [924.312,543.755], [940.252,490.65], [940.578,538.02]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.312,543.785], [924.736,591.767], [940.578,538.05], [940.9,584.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.737,591.797], [925.156,639.225], [940.9,584.912], [941.219,631.217]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.156,639.255], [925.571,686.138], [941.219,631.246], [941.534,677.033]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.571,686.168], [925.982,732.516], [941.534,677.062], [941.845,722.338]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.982,732.545], [926.387,778.367], [941.845,722.366], [942.153,767.141]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.387,778.367], [926.759,820.394], [942.153,767.141], [942.435,808.218]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1026.67,294.505], [1026.85,241.321], [993.506,294.682], [993.482,242.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.67,294.505], [1026.49,347.067], [993.506,294.682], [993.53,346.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.49,347.067], [1026.31,398.952], [993.53,346.723], [993.554,398.099]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.31,398.984], [1026.14,450.236], [993.554,398.132], [993.577,448.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.14,450.268], [1025.96,500.898], [993.577,448.92], [993.6,499.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.96,500.931], [1025.79,550.951], [993.6,499.098], [993.623,548.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.79,550.982], [1025.62,600.404], [993.623,548.678], [993.646,597.639]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.62,600.435], [1025.45,649.268], [993.646,597.67], [993.668,646.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.45,649.299], [993.668,646.084], [1025.29,697.554], [993.69,693.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.29,697.584], [993.69,693.93], [1025.12,745.272], [993.712,741.19]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.12,745.302], [993.712,741.219], [1024.96,792.431], [993.734,787.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1024.96,792.431], [993.734,787.931], [1024.81,835.644], [993.754,830.765]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.93,667.047], [1114.2,717.717], [1013.53,656.533], [1013.43,705.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.2,717.749], [1113.48,767.791], [1013.43,705.805], [1013.33,754.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.48,767.823], [1112.76,817.25], [1013.33,754.485], [1013.24,802.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.76,817.25], [1112.11,862.542], [1013.24,802.553], [1013.15,846.616]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1120.32,293.53], [1121.13,237.39], [1014.24,294.108], [1014.35,239.721]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.32,293.53], [1119.52,348.974], [1014.24,294.108], [1014.14,347.843]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.52,348.974], [1118.73,403.666], [1014.14,347.843], [1014.03,400.871]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.73,403.7], [1117.95,457.69], [1014.03,400.905], [1013.93,453.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.95,457.724], [1117.18,511.023], [1013.93,453.305], [1013.83,505.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.18,511.057], [1116.42,563.681], [1013.83,505.056], [1013.73,556.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.42,563.714], [1115.67,615.673], [1013.73,556.17], [1013.63,606.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.67,615.706], [1114.93,667.015], [1013.63,606.659], [1013.53,656.502]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.68,833.986], [1105.85,824.703], [1166.68,880.673], [1105.23,870.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.76,783.018], [1106.53,774.589], [1167.68,833.986], [1105.85,824.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.98,679.034], [1169.87,731.327], [1107.92,672.384], [1107.22,723.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.87,731.361], [1168.76,782.985], [1107.22,723.809], [1106.53,774.557]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.12,626.026], [1170.98,679.001], [1108.63,620.3], [1107.92,672.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.42,517.908], [1173.26,572.287], [1110.07,514.106], [1109.35,567.511]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.26,572.321], [1172.12,625.992], [1109.35,567.545], [1108.63,620.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.6,462.77], [1174.42,517.873], [1110.81,459.969], [1110.07,514.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.79,406.894], [1175.6,462.735], [1111.55,405.122], [1110.81,459.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.23,292.868], [1178,350.265], [1113.07,293.236], [1112.3,349.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178,350.266], [1176.79,406.859], [1112.3,349.549], [1111.55,405.087]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1179.23,292.868], [1180.47,234.724], [1113.07,293.236], [1113.84,236.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.84,837.344], [1175.69,828.575], [1233.44,884.31], [1174.66,874.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.37,786.067], [1176.82,778.104], [1234.84,837.344], [1175.69,828.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.91,734.093], [1177.96,726.959], [1236.37,786.034], [1176.82,778.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.48,681.441], [1179.12,675.157], [1237.91,734.06], [1177.96,726.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.07,628.098], [1239.48,681.407], [1180.29,622.687], [1179.12,675.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.68,574.051], [1241.07,628.064], [1181.48,569.537], [1180.29,622.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.31,519.284], [1242.68,574.016], [1182.68,515.691], [1181.48,569.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.96,463.784], [1244.31,519.249], [1183.9,461.137], [1182.68,515.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.64,407.536], [1245.96,463.749], [1185.13,405.861], [1183.9,461.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.34,350.525], [1247.64,407.501], [1186.38,349.848], [1185.13,405.825]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.06,292.735], [1249.34,350.525], [1187.65,293.082], [1186.38,349.847]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1251.06,292.735], [1252.8,234.188], [1187.65,293.083], [1188.93,235.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.84,837.344], [1233.44,884.31], [1240.14,829.297], [1238.74,875.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.37,786.067], [1234.84,837.344], [1241.68,778.76], [1240.14,829.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.91,734.093], [1236.37,786.034], [1243.24,727.546], [1241.68,778.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.48,681.441], [1237.91,734.06], [1244.82,675.674], [1243.24,727.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.71,845.558], [1240.15,829.297], [1349.59,893.205], [1238.74,875.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.07,628.098], [1239.48,681.407], [1246.41,623.132], [1244.82,675.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1354.02,793.528], [1241.68,778.76], [1351.71,845.558], [1240.15,829.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.68,574.051], [1241.07,628.064], [1248.03,569.908], [1246.42,623.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.37,740.779], [1354.02,793.494], [1243.24,727.546], [1241.68,778.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.31,519.284], [1242.68,574.016], [1249.67,515.986], [1248.03,569.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.75,687.331], [1356.37,740.745], [1244.82,675.674], [1243.24,727.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.96,463.784], [1244.31,519.249], [1251.33,461.355], [1249.67,515.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.16,633.171], [1358.75,687.297], [1246.42,623.132], [1244.82,675.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.64,407.536], [1245.96,463.749], [1253.02,405.998], [1251.34,461.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.6,578.284], [1361.16,633.136], [1248.03,569.908], [1246.42,623.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.34,350.525], [1247.64,407.501], [1254.72,349.903], [1253.02,405.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.07,522.654], [1363.6,578.248], [1249.67,515.986], [1248.03,569.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.06,292.735], [1249.34,350.525], [1256.45,293.054], [1254.72,349.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.58,466.268], [1366.07,522.619], [1251.33,461.355], [1249.67,515.952]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1251.06,292.735], [1252.8,234.188], [1256.45,293.054], [1258.2,235.473]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.12,409.109], [1368.58,466.232], [1253.02,405.998], [1251.34,461.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.7,351.162], [1371.12,409.073], [1254.72,349.903], [1253.02,405.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.31,292.409], [1373.7,351.161], [1256.45,293.054], [1254.72,349.903]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.31,292.409], [1378.96,232.873], [1256.45,293.054], [1258.2,235.473]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.71,845.558], [1349.59,893.205], [1359.52,827.386], [1357.43,873.524]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1354.02,793.528], [1351.71,845.558], [1361.81,777.025], [1359.52,827.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.37,740.779], [1354.02,793.494], [1364.12,725.991], [1361.81,776.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.75,687.332], [1356.37,740.745], [1366.47,674.305], [1364.12,725.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.43,832.712], [1359.52,827.386], [1395.09,879.292], [1357.43,873.524]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.16,633.171], [1358.75,687.297], [1368.84,621.954], [1366.47,674.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.98,781.86], [1361.81,777.025], [1397.43,832.711], [1359.52,827.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.6,578.284], [1361.16,633.136], [1371.25,568.925], [1368.84,621.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402.56,730.324], [1364.12,725.991], [1399.98,781.828], [1361.81,776.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.07,522.654], [1363.6,578.249], [1373.68,515.204], [1371.25,568.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.18,678.121], [1366.47,674.305], [1402.56,730.291], [1364.12,725.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.58,466.268], [1366.07,522.619], [1376.15,460.778], [1373.68,515.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1407.83,625.239], [1368.84,621.954], [1405.18,678.087], [1366.47,674.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.12,409.109], [1368.58,466.232], [1378.65,405.634], [1376.15,460.743]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.52,571.665], [1371.25,568.925], [1407.83,625.205], [1368.84,621.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.7,351.162], [1371.12,409.073], [1381.19,349.756], [1378.66,405.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.24,517.385], [1373.68,515.204], [1410.52,571.631], [1371.25,568.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.31,292.409], [1373.7,351.161], [1383.76,293.129], [1381.19,349.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416,462.385], [1376.15,460.778], [1413.24,517.351], [1373.69,515.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1418.79,406.651], [1378.65,405.634], [1416,462.35], [1376.15,460.743]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.31,292.409], [1378.96,232.873], [1383.76,293.13], [1386.36,235.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.62,350.167], [1418.79,406.615], [1381.19,349.756], [1378.66,405.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.49,292.919], [1421.62,350.167], [1383.76,293.129], [1381.19,349.755]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1424.49,292.918], [1427.4,234.927], [1383.76,293.129], [1386.36,235.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.43,832.711], [1395.09,879.292], [1405.02,811.189], [1402.74,855.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.98,781.86], [1397.43,832.711], [1407.51,762.322], [1405.02,811.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402.56,730.323], [1399.98,781.827], [1410.03,712.822], [1407.51,762.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.18,678.12], [1402.56,730.29], [1412.59,662.71], [1410.03,712.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1420.05,813.209], [1405.02,811.189], [1417.67,858.164], [1402.74,855.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1422.64,764.155], [1407.51,762.322], [1420.05,813.209], [1405.02,811.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1407.83,625.239], [1405.18,678.087], [1415.17,611.973], [1412.59,662.678]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.52,571.665], [1407.83,625.205], [1417.79,560.601], [1415.17,611.941]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1425.27,714.464], [1410.03,712.822], [1422.64,764.124], [1407.51,762.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1427.93,664.155], [1412.59,662.71], [1425.27,714.432], [1410.03,712.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.24,517.385], [1410.52,571.631], [1420.44,508.58], [1417.79,560.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1430.62,613.217], [1415.17,611.973], [1427.93,664.123], [1412.59,662.678]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416,462.385], [1413.24,517.35], [1423.12,455.9], [1420.44,508.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1418.79,406.65], [1416,462.35], [1425.84,402.546], [1423.13,455.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1433.34,561.638], [1417.79,560.601], [1430.62,613.185], [1415.17,611.941]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1436.1,509.405], [1420.44,508.58], [1433.35,561.605], [1417.79,560.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1419.75,813.16], [1417.38,858.111], [1426.83,791.181], [1424.52,834.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.62,350.167], [1418.79,406.615], [1428.6,348.507], [1425.84,402.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1438.9,456.507], [1423.13,455.9], [1436.11,509.372], [1420.44,508.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1422.34,764.111], [1419.75,813.16], [1429.35,744.167], [1426.83,791.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.49,292.919], [1421.62,350.167], [1431.39,293.769], [1428.6,348.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.97,714.424], [1422.35,764.08], [1431.9,696.568], [1429.35,744.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1441.73,402.931], [1425.84,402.546], [1438.9,456.474], [1423.13,455.866]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1424.49,292.918], [1427.4,234.927], [1431.39,293.768], [1434.21,238.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1444.6,348.662], [1428.6,348.507], [1441.73,402.897], [1425.85,402.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1427.62,664.12], [1424.97,714.393], [1434.48,648.405], [1431.9,696.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1430.31,613.187], [1427.63,664.088], [1437.09,599.666], [1434.48,648.375]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1447.19,293.691], [1444.28,348.659], [1431.39,293.769], [1428.6,348.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1433.04,561.613], [1430.32,613.155], [1439.73,550.342], [1437.09,599.635]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1447.5,293.689], [1431.39,293.768], [1450.45,238.031], [1434.21,238.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1435.8,509.386], [1433.04,561.58], [1442.4,500.421], [1439.73,550.311]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1438.59,456.493], [1435.8,509.352], [1445.11,449.893], [1442.4,500.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1441.42,402.921], [1438.59,456.459], [1447.85,398.747], [1445.11,449.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1444.28,348.658], [1441.42,402.887], [1450.62,346.971], [1447.85,398.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1447.19,293.691], [1444.28,348.659], [1453.33,294.549], [1450.53,346.982]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1447.19,293.691], [1450.13,238.039], [1453.42,294.554], [1456.27,241.517]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[705.891,297.067], [704.239,250.246], [633.349,297.32], [631.351,251.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.891,297.068], [707.526,343.393], [633.349,297.32], [635.327,342.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.526,343.393], [709.142,389.173], [635.327,342.2], [637.283,386.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.143,389.202], [710.74,434.474], [637.284,386.595], [639.218,430.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.742,434.503], [712.322,479.275], [639.219,430.513], [641.133,473.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.323,479.304], [713.885,523.585], [641.134,473.961], [643.028,516.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.886,523.613], [715.432,567.412], [643.029,516.947], [644.902,559.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.433,567.44], [716.962,610.763], [644.903,559.478], [646.757,601.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.963,610.79], [718.475,653.646], [646.758,601.562], [648.592,643.18]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.476,653.673], [719.972,696.069], [648.593,643.206], [650.408,684.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.973,696.096], [721.453,738.039], [650.41,684.416], [652.206,725.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.453,738.04], [722.812,776.534], [652.206,725.173], [653.855,762.591]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[734.502,296.816], [732.965,248.522], [692.645,296.965], [690.895,249.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.502,296.816], [736.023,344.582], [692.645,296.965], [694.376,343.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.023,344.582], [737.524,391.769], [694.376,343.881], [696.086,390.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.525,391.799], [739.01,438.447], [696.087,390.268], [697.778,436.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.011,438.476], [740.479,484.594], [697.779,436.134], [699.452,481.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.479,484.623], [741.931,530.219], [699.453,481.488], [701.106,526.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.932,530.248], [743.366,575.332], [701.107,526.338], [702.743,570.664]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.367,575.36], [744.786,619.94], [702.744,570.692], [704.361,614.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.787,619.968], [746.19,664.053], [704.362,614.56], [705.962,657.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.191,664.081], [747.578,707.678], [705.963,657.948], [707.545,700.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.579,707.705], [748.952,750.823], [707.546,700.865], [709.111,743.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.952,750.824], [750.211,790.385], [709.111,743.291], [710.548,782.225]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[772.138,296.547], [770.778,246.674], [727.197,296.709], [725.597,247.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[772.138,296.547], [773.483,345.856], [727.197,296.709], [728.78,345.091]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[773.483,345.856], [774.811,394.549], [728.78,345.091], [730.343,392.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.812,394.579], [776.124,442.698], [730.344,392.91], [731.889,440.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.125,442.728], [777.422,490.283], [731.89,440.176], [733.417,486.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.422,490.313], [778.704,537.313], [733.418,486.897], [734.928,533.055]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[778.705,537.342], [779.972,583.797], [734.929,533.084], [736.422,578.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.972,583.827], [781.225,629.747], [736.423,578.745], [737.899,623.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.225,629.776], [782.463,675.169], [737.899,623.89], [739.359,668.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.464,675.198], [783.688,720.075], [739.36,668.526], [740.802,712.636]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.689,720.103], [784.899,764.471], [740.803,712.663], [742.23,756.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.899,764.471], [786.008,805.166], [742.23,756.282], [743.539,796.297]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[772.139,296.547], [770.779,246.674], [784.647,296.658], [783.379,247.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[772.138,296.547], [773.483,345.856], [784.647,296.658], [785.901,345.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[773.483,345.856], [774.811,394.549], [785.901,345.332], [787.139,393.405]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.812,394.579], [776.124,442.698], [787.14,393.435], [788.363,440.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.125,442.728], [777.422,490.283], [788.364,440.979], [789.574,487.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.422,490.313], [778.704,537.313], [789.574,487.972], [790.77,534.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[778.705,537.342], [779.972,583.797], [790.771,534.424], [791.953,580.315]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.973,583.827], [781.225,629.747], [791.954,580.344], [793.122,625.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.226,629.775], [782.463,675.169], [793.123,625.742], [794.278,670.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.464,675.198], [783.688,720.074], [794.279,670.626], [795.421,714.977]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[870.086,296.356], [869.3,245.363], [784.647,296.658], [783.379,247.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.689,720.103], [784.899,764.471], [795.422,715.005], [796.551,758.86]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.086,296.356], [870.863,346.758], [784.647,296.658], [785.901,345.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.899,764.471], [786.008,805.166], [796.551,758.86], [797.588,799.089]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.862,346.758], [871.629,396.518], [785.901,345.331], [787.139,393.405]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.63,396.55], [872.388,445.71], [787.14,393.435], [788.363,440.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.388,445.741], [873.137,494.313], [788.364,440.979], [789.574,487.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.137,494.343], [873.877,542.336], [789.575,487.972], [790.77,534.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.878,542.366], [874.609,589.791], [790.771,534.424], [791.953,580.315]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.609,589.821], [875.332,636.687], [791.954,580.344], [793.122,625.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.332,636.717], [876.046,683.035], [793.123,625.742], [794.278,670.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.046,683.064], [876.752,728.843], [794.279,670.626], [795.421,714.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.752,728.872], [877.45,774.122], [795.422,715.005], [796.552,758.859]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.45,774.122], [878.09,815.616], [796.552,758.86], [797.588,799.089]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[870.086,296.356], [869.3,245.363], [887.835,296.535], [887.172,246.592]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.086,296.356], [870.863,346.758], [887.835,296.535], [888.49,345.913]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.863,346.758], [871.63,396.518], [888.49,345.913], [889.137,394.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.63,396.55], [872.388,445.71], [889.138,394.704], [889.777,442.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.389,445.741], [873.137,494.313], [889.777,442.919], [890.409,490.538]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.138,494.343], [873.878,542.336], [890.409,490.568], [891.034,537.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.878,542.366], [874.609,589.791], [891.034,537.66], [891.651,584.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.609,589.821], [875.332,636.687], [891.652,584.206], [892.262,630.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.332,636.717], [876.046,683.035], [892.262,630.215], [892.865,675.667]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.047,683.064], [876.752,728.843], [892.865,675.696], [893.461,720.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.753,728.872], [877.45,774.122], [893.462,720.658], [894.051,765.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.45,774.122], [878.09,815.616], [894.051,765.083], [894.592,805.828]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[916.739,296.436], [916.246,245.91], [887.835,296.535], [887.172,246.592]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.739,296.435], [917.227,346.382], [887.835,296.535], [888.49,345.913]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.227,346.382], [917.709,395.698], [888.49,345.913], [889.137,394.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.709,395.729], [918.185,444.455], [889.137,394.704], [889.776,442.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.185,444.486], [918.656,492.634], [889.777,442.919], [890.409,490.538]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.656,492.664], [919.121,540.244], [890.409,490.568], [891.033,537.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.121,540.273], [919.58,587.294], [891.034,537.66], [891.651,584.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.581,587.324], [920.034,633.796], [891.651,584.206], [892.261,630.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.035,633.826], [920.483,679.759], [892.261,630.215], [892.864,675.668]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.484,679.788], [920.927,725.192], [892.865,675.696], [893.461,720.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.927,725.22], [921.366,770.103], [893.461,720.659], [894.051,765.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.366,770.103], [921.768,811.265], [894.051,765.083], [894.591,805.828]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[916.739,296.436], [916.245,245.91], [936.426,296.643], [936.062,247.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.739,296.435], [917.227,346.382], [936.426,296.643], [936.786,345.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.227,346.382], [917.708,395.698], [936.786,345.4], [937.142,393.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.709,395.729], [918.185,444.455], [937.142,393.584], [937.493,441.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.185,444.486], [918.655,492.634], [937.493,441.207], [937.841,488.247]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.656,492.664], [919.12,540.243], [937.841,488.277], [938.184,534.775]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.121,540.273], [919.58,587.294], [938.185,534.804], [938.524,580.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.58,587.324], [920.034,633.796], [938.524,580.798], [938.86,626.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.034,633.826], [920.483,679.759], [938.86,626.268], [939.192,671.194]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.483,679.788], [920.927,725.192], [939.192,671.222], [939.52,715.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.927,725.22], [921.365,770.103], [939.52,715.67], [939.845,759.591]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.365,770.103], [921.768,811.264], [939.845,759.591], [940.142,799.881]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1014.71,296.102], [1014.82,243.618], [983.518,296.209], [983.431,244.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.71,296.102], [1014.6,347.959], [983.518,296.209], [983.605,347.453]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.6,347.959], [1014.5,399.137], [983.605,347.453], [983.69,398.033]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.5,399.17], [1014.39,449.714], [983.69,398.065], [983.774,448.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.39,449.745], [1014.29,499.667], [983.774,448.057], [983.857,497.409]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.29,499.698], [1014.18,549.008], [983.857,497.441], [983.94,546.195]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.18,549.039], [1014.08,597.749], [983.94,546.226], [984.021,594.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.08,597.779], [1013.98,645.9], [984.021,594.425], [984.101,642.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.98,645.93], [1013.88,693.472], [984.101,642.047], [984.18,689.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.88,693.502], [1013.78,740.476], [984.18,689.103], [984.259,735.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.78,740.505], [984.259,735.603], [1013.69,786.921], [984.336,781.528]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.69,786.921], [984.336,781.528], [1013.6,829.471], [984.407,823.634]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1099.68,295.557], [1100.36,239.88], [999.414,295.911], [999.427,242.311]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.68,295.557], [1098.99,350.529], [999.414,295.911], [999.401,348.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.99,350.529], [1098.32,404.74], [999.401,348.858], [999.389,401.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.32,404.774], [1097.66,458.273], [999.389,401.132], [999.377,452.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.66,458.307], [1097.01,511.108], [999.376,452.743], [999.365,503.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.01,511.141], [1096.36,563.258], [999.364,503.706], [999.352,554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.36,563.291], [1095.73,614.736], [999.352,554.031], [999.34,603.701]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.73,614.769], [1095.1,665.556], [999.34,603.732], [999.329,652.789]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.1,665.588], [1094.48,715.73], [999.329,652.82], [999.317,701.275]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.48,715.762], [1093.86,765.27], [999.317,701.305], [999.306,749.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.86,765.301], [1093.26,814.188], [999.306,749.199], [999.294,796.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.26,814.188], [1092.7,858.974], [999.294,796.484], [999.284,839.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144,782.027], [1143.05,832.571], [1084.8,771.77], [1084.24,821.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.05,832.571], [1142.17,878.855], [1084.24,821.299], [1083.73,866.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.94,678.864], [1144.96,730.753], [1085.93,670.721], [1085.36,721.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.96,730.786], [1144,781.995], [1085.36,721.572], [1084.8,771.739]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.93,626.249], [1145.94,678.831], [1086.51,619.207], [1085.93,670.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.96,518.883], [1147.94,572.893], [1087.69,514.133], [1087.1,566.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.94,572.927], [1146.93,626.216], [1087.09,567.016], [1086.51,619.174]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.04,408.57], [1149.99,464.067], [1088.9,406.241], [1088.29,460.512]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.99,464.102], [1148.96,518.848], [1088.29,460.546], [1087.69,514.099]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.1,352.271], [1151.04,408.535], [1089.52,351.202], [1088.9,406.206]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1153.17,295.188], [1154.26,237.343], [1090.14,295.415], [1090.78,238.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.17,295.188], [1152.1,352.271], [1090.14,295.415], [1089.52,351.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.42,838.241], [1208.13,884.985], [1152.64,827.5], [1151.72,873.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.82,787.189], [1209.42,838.241], [1153.65,777.413], [1152.64,827.5]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.24,735.423], [1210.82,787.156], [1154.67,726.64], [1153.65,777.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.68,682.963], [1212.24,735.39], [1155.7,675.201], [1154.67,726.608]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.14,629.795], [1213.68,682.929], [1156.75,623.081], [1155.7,675.167]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.62,575.904], [1215.14,629.761], [1157.81,570.267], [1156.75,623.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.12,521.275], [1216.62,575.869], [1158.88,516.745], [1157.81,570.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.64,465.894], [1218.12,521.24], [1159.97,462.502], [1158.88,516.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.18,409.744], [1219.64,465.858], [1161.07,407.522], [1159.97,462.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.75,352.81], [1221.18,409.708], [1162.19,351.79], [1161.08,407.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.33,295.074], [1222.75,352.809], [1163.33,295.29], [1162.19,351.789]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1224.33,295.074], [1225.94,236.558], [1163.33,295.29], [1164.48,238.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.42,838.241], [1208.13,884.985], [1217.16,830.442], [1215.85,876.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.82,787.189], [1209.42,838.241], [1218.59,780.09], [1217.16,830.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.24,735.423], [1210.82,787.156], [1220.04,729.045], [1218.59,780.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.68,682.963], [1212.24,735.39], [1221.52,677.326], [1220.05,729.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.14,629.795], [1213.68,682.929], [1223.01,624.919], [1221.52,677.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.62,575.904], [1215.14,629.761], [1224.52,571.81], [1223.01,624.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1325.56,850.593], [1323.52,898.337], [1217.16,830.442], [1215.85,876.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.12,521.275], [1216.62,575.869], [1226.05,517.985], [1224.52,571.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1327.78,798.433], [1325.56,850.593], [1218.59,780.09], [1217.16,830.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.64,465.894], [1218.12,521.24], [1227.6,463.43], [1226.05,517.951]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.03,745.529], [1327.78,798.4], [1220.05,729.045], [1218.59,780.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.18,409.744], [1219.64,465.858], [1229.17,408.13], [1227.6,463.395]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.31,691.898], [1330.03,745.495], [1221.52,677.326], [1220.05,729.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.75,352.81], [1221.18,409.708], [1230.76,352.069], [1229.17,408.094]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.63,637.525], [1332.31,691.863], [1223.01,624.919], [1221.52,677.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.33,295.074], [1222.75,352.809], [1232.38,295.231], [1230.76,352.068]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.97,582.396], [1334.63,637.49], [1224.52,571.81], [1223.01,624.885]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1224.33,295.074], [1225.94,236.558], [1232.38,295.231], [1234.02,237.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.35,526.494], [1336.97,582.361], [1226.05,517.985], [1224.52,571.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.77,469.803], [1339.35,526.458], [1227.6,463.43], [1226.05,517.951]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.21,412.306], [1341.77,469.767], [1229.17,408.13], [1227.6,463.395]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.7,353.986], [1344.21,412.269], [1230.76,352.069], [1229.17,408.094]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1349.21,294.824], [1346.7,353.986], [1232.38,295.231], [1230.76,352.068]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1349.21,294.825], [1351.77,234.842], [1232.38,295.231], [1234.02,237.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1325.56,850.593], [1323.52,898.337], [1339.1,832.708], [1337.06,879.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1327.78,798.433], [1325.56,850.593], [1341.34,782.152], [1339.1,832.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.03,745.529], [1327.78,798.4], [1343.61,730.898], [1341.34,782.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.31,691.898], [1330.03,745.495], [1345.9,678.963], [1343.61,730.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.63,637.525], [1332.31,691.863], [1348.23,626.335], [1345.91,678.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.97,582.396], [1334.63,637.49], [1350.59,572.999], [1348.23,626.301]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.35,526.494], [1336.97,582.361], [1352.98,518.941], [1350.59,572.965]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.41,839.384], [1339.1,832.708], [1374.11,886.221], [1337.06,879.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1378.92,788.229], [1341.34,782.152], [1376.41,839.384], [1339.1,832.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.77,469.803], [1339.35,526.458], [1355.4,464.146], [1352.98,518.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.21,412.306], [1341.77,469.767], [1357.86,408.599], [1355.41,464.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.46,736.358], [1343.61,730.898], [1378.92,788.196], [1341.34,782.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.04,683.79], [1345.9,678.963], [1381.47,736.325], [1343.61,730.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.7,353.986], [1344.21,412.269], [1360.35,352.284], [1357.86,408.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1386.66,630.51], [1348.23,626.335], [1384.05,683.756], [1345.91,678.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1349.21,294.824], [1346.7,353.986], [1362.88,295.185], [1360.35,352.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.31,576.504], [1350.59,572.999], [1386.66,630.476], [1348.23,626.301]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1349.21,294.824], [1351.77,234.842], [1362.88,295.186], [1365.43,237.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392,521.758], [1352.98,518.941], [1389.31,576.47], [1350.59,572.965]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.72,466.256], [1392,521.723], [1355.4,464.146], [1352.98,518.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.49,409.981], [1394.73,466.22], [1357.86,408.599], [1355.41,464.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1400.29,352.919], [1397.49,409.945], [1360.35,352.284], [1357.86,408.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1403.13,295.051], [1400.29,352.918], [1362.88,295.185], [1360.35,352.284]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1403.13,295.05], [1406.01,236.399], [1362.88,295.185], [1365.43,237.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.41,839.384], [1374.11,886.221], [1390.88,818.045], [1388.59,863.146]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1378.92,788.228], [1376.41,839.384], [1393.38,768.809], [1390.88,818.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.46,736.357], [1378.92,788.196], [1395.92,718.912], [1393.38,768.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.04,683.789], [1381.47,736.324], [1398.49,668.372], [1395.92,718.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1386.66,630.509], [1384.05,683.756], [1401.09,617.175], [1398.49,668.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.31,576.504], [1386.66,630.476], [1403.73,565.31], [1401.09,617.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.78,820.593], [1390.88,818.045], [1403.39,865.902], [1388.59,863.146]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392,521.757], [1389.31,576.469], [1406.4,512.763], [1403.73,565.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.39,771.128], [1393.38,768.81], [1405.78,820.593], [1390.88,818.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.72,466.255], [1392,521.723], [1409.1,459.521], [1406.4,512.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1411.04,720.994], [1395.92,718.912], [1408.39,771.096], [1393.38,768.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1397.49,409.98], [1394.73,466.22], [1411.85,405.569], [1409.1,459.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.72,670.211], [1398.49,668.372], [1411.04,720.963], [1395.92,718.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1400.29,352.918], [1397.49,409.945], [1414.62,350.893], [1411.85,405.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416.43,618.766], [1401.09,617.176], [1413.72,670.179], [1398.49,668.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1403.13,295.051], [1400.29,352.918], [1417.44,295.48], [1414.62,350.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1419.18,566.645], [1403.73,565.31], [1416.43,618.733], [1401.09,617.143]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1403.13,295.05], [1406.01,236.398], [1417.44,295.48], [1420.29,239.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.97,513.836], [1406.4,512.763], [1419.18,566.612], [1403.73,565.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.49,820.534], [1403.1,865.838], [1419.65,798.638], [1417.28,842.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1408.1,771.074], [1405.49,820.534], [1422.23,751.158], [1419.65,798.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.79,460.323], [1409.1,459.521], [1421.97,513.802], [1406.4,512.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.74,720.946], [1408.1,771.043], [1424.85,703.063], [1422.23,751.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1427.65,406.095], [1411.85,405.569], [1424.79,460.29], [1409.11,459.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.42,670.169], [1410.74,720.914], [1427.5,654.372], [1424.85,703.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1430.55,351.135], [1427.65,406.06], [1414.62,350.893], [1411.85,405.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1416.13,618.729], [1413.42,670.137], [1430.18,605.074], [1427.5,654.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1433.18,295.43], [1430.24,351.129], [1417.44,295.48], [1414.62,350.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1418.88,566.614], [1416.13,618.696], [1432.9,555.156], [1430.18,605.043]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1433.49,295.429], [1436.47,238.997], [1417.44,295.48], [1420.29,239.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1421.66,513.811], [1418.88,566.581], [1435.65,504.609], [1432.9,555.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1424.49,460.305], [1421.67,513.777], [1438.43,453.419], [1435.65,504.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1427.34,406.082], [1424.49,460.271], [1441.25,401.574], [1438.43,453.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1430.24,351.129], [1427.35,406.048], [1444.11,349.061], [1441.25,401.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1433.18,295.43], [1430.24,351.129], [1446.86,295.865], [1443.97,349.075]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1433.18,295.43], [1436.16,239.005], [1447,295.868], [1449.93,242.015]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[719.877,297.845], [718.306,252.57], [655.163,297.827], [653.295,254.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.877,297.845], [721.43,342.641], [655.163,297.827], [657.012,341.054]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.43,342.641], [722.966,386.911], [657.012,341.054], [658.839,383.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.967,386.938], [724.485,430.718], [658.84,383.817], [660.649,426.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.486,430.746], [725.988,474.043], [660.65,426.122], [662.439,467.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.989,474.07], [727.474,516.894], [662.44,467.978], [664.21,509.365]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.475,516.921], [728.944,559.278], [664.211,509.391], [665.963,550.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.945,559.304], [730.398,601.203], [665.964,550.369], [667.697,590.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.399,601.229], [731.836,642.676], [667.698,590.917], [669.413,631.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.837,642.702], [733.259,683.705], [669.414,631.044], [671.112,670.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.26,683.731], [734.667,724.296], [671.113,670.755], [672.793,710.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.667,724.297], [735.959,761.528], [672.793,710.033], [674.335,746.094]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[743.363,297.861], [741.879,251.106], [705.898,297.851], [704.23,252.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.363,297.861], [744.832,344.105], [705.898,297.851], [707.549,343.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.832,344.105], [746.282,389.789], [707.549,343.169], [709.181,387.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.283,389.818], [747.717,434.979], [709.182,387.977], [710.795,432.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.718,435.008], [749.135,479.657], [710.796,432.283], [712.391,476.068]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.136,479.685], [750.538,523.829], [712.392,476.095], [713.969,519.395]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.538,523.857], [751.924,567.506], [713.97,519.423], [715.53,562.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.925,567.533], [753.295,610.694], [715.531,562.273], [717.074,604.627]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.296,610.721], [754.651,653.403], [717.075,604.654], [718.601,646.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.652,653.43], [755.992,695.64], [718.602,646.573], [720.112,688.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.993,695.667], [757.318,737.413], [720.113,688.038], [721.606,729.03]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.318,737.413], [758.534,775.716], [721.606,729.03], [722.976,766.648]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[775.233,297.879], [773.89,249.512], [734.902,297.867], [733.349,250.537]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.233,297.879], [776.561,345.698], [734.902,297.867], [736.437,344.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.561,345.698], [777.872,392.92], [736.437,344.674], [737.954,390.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.873,392.949], [779.169,439.613], [737.955,390.936], [739.454,436.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.169,439.643], [780.45,485.758], [739.455,436.663], [740.937,481.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.451,485.788], [781.716,531.365], [740.938,481.864], [742.403,526.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.717,531.394], [782.968,576.443], [742.404,526.549], [743.852,570.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.969,576.471], [784.205,621], [743.853,570.726], [745.285,614.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.206,621.028], [785.428,665.047], [745.286,614.404], [746.702,657.563]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.429,665.074], [786.637,708.591], [746.703,657.59], [748.103,700.268]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.638,708.618], [787.832,751.641], [748.104,700.295], [749.488,742.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.832,751.641], [788.928,791.101], [749.488,742.498], [750.758,781.215]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[775.233,297.879], [773.89,249.512], [788.752,297.872], [787.506,250.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.233,297.879], [776.561,345.698], [788.752,297.872], [789.984,345.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.561,345.698], [777.872,392.92], [789.984,345.127], [791.202,391.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.873,392.949], [779.169,439.613], [791.202,391.826], [792.405,437.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.17,439.642], [780.45,485.758], [792.406,437.981], [793.595,483.571]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.451,485.788], [781.716,531.365], [793.595,483.6], [794.771,528.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.717,531.394], [782.968,576.443], [794.771,528.692], [795.933,573.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.969,576.471], [784.205,621], [795.934,573.268], [797.082,617.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.206,621.028], [785.428,665.047], [797.083,617.335], [798.218,660.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.429,665.074], [786.637,708.591], [798.219,660.902], [799.341,703.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.638,708.618], [799.342,703.978], [787.833,751.641], [800.452,746.544]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[866.212,297.894], [865.397,248.151], [788.752,297.872], [787.506,250.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.833,751.641], [800.452,746.544], [788.928,791.101], [801.47,785.59]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.212,297.894], [867.018,347.056], [788.752,297.872], [789.984,345.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.018,347.057], [867.814,395.588], [789.985,345.127], [791.202,391.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.815,395.619], [868.601,443.562], [791.203,391.826], [792.405,437.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.601,443.592], [869.378,490.956], [792.406,437.981], [793.595,483.571]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.378,490.986], [870.146,537.782], [793.596,483.6], [794.771,528.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.146,537.812], [870.905,584.05], [794.771,528.692], [795.933,573.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.905,584.08], [871.654,629.77], [795.934,573.268], [797.082,617.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.655,629.799], [872.395,674.951], [797.083,617.335], [798.218,660.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.396,674.98], [873.127,719.603], [798.219,660.902], [799.342,703.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.128,719.631], [873.851,763.735], [799.342,703.978], [800.452,746.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.851,763.736], [874.514,804.176], [800.452,746.544], [801.471,785.59]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[866.213,297.894], [865.397,248.152], [885.976,297.884], [885.296,249.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.212,297.894], [867.018,347.056], [885.976,297.884], [886.648,346.123]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.019,347.057], [867.815,395.588], [886.648,346.123], [887.312,393.755]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.815,395.619], [868.601,443.562], [887.312,393.785], [887.968,440.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.602,443.592], [869.378,490.956], [887.968,440.879], [888.616,487.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.379,490.986], [870.146,537.782], [888.616,487.416], [889.256,533.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.147,537.812], [870.905,584.05], [889.257,533.404], [889.889,578.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.905,584.08], [871.655,629.77], [889.89,578.855], [890.515,623.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.655,629.799], [872.395,674.951], [890.515,623.776], [891.133,668.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.396,674.98], [873.128,719.603], [891.134,668.178], [891.745,712.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.128,719.632], [873.851,763.735], [891.745,712.069], [892.349,755.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.851,763.736], [874.514,804.176], [892.349,755.431], [892.903,795.199]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[912.464,297.891], [911.939,248.444], [885.976,297.884], [885.296,249.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.463,297.891], [912.982,346.764], [885.976,297.884], [886.648,346.123]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.983,346.764], [913.495,395.014], [886.648,346.123], [887.311,393.755]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.495,395.045], [914.002,442.713], [887.311,393.785], [887.967,440.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.002,442.743], [914.502,489.839], [887.967,440.879], [888.615,487.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.502,489.869], [914.996,536.403], [888.616,487.416], [889.256,533.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.997,536.432], [915.485,582.415], [889.256,533.404], [889.889,578.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.485,582.444], [915.968,627.886], [889.889,578.855], [890.514,623.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.968,627.914], [916.445,672.823], [890.515,623.776], [891.133,668.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.445,672.851], [916.917,717.237], [891.133,668.178], [891.744,712.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.917,717.265], [917.383,761.137], [891.745,712.069], [892.349,755.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.383,761.137], [917.81,801.367], [892.349,755.431], [892.902,795.199]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[912.463,297.891], [911.938,248.444], [934.68,297.879], [934.301,249.537]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.463,297.891], [912.982,346.764], [934.68,297.879], [935.055,345.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.982,346.764], [913.495,395.014], [935.055,345.673], [935.425,392.871]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.495,395.045], [914.001,442.713], [935.425,392.901], [935.791,439.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.001,442.743], [914.502,489.839], [935.791,439.57], [936.153,485.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.502,489.869], [914.996,536.403], [936.153,485.693], [936.51,531.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.996,536.432], [915.484,582.415], [936.511,531.277], [936.864,576.304]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.485,582.444], [915.967,627.885], [936.864,576.332], [937.213,620.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.968,627.914], [916.445,672.823], [937.213,620.868], [937.558,664.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.445,672.851], [916.916,717.237], [937.558,664.893], [937.9,708.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.916,717.265], [917.382,761.137], [937.9,708.417], [938.237,751.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.382,761.137], [917.809,801.367], [938.237,751.42], [938.546,790.862]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1002.94,297.915], [1002.97,246.268], [974.035,297.907], [973.886,246.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.94,297.915], [1002.9,348.935], [974.035,297.907], [974.182,348.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.9,348.935], [1002.87,399.278], [974.182,348.237], [974.327,397.906]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.87,399.309], [1002.83,449.018], [974.328,397.937], [974.471,446.989]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.83,449.049], [1002.8,498.136], [974.471,447.02], [974.613,495.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.8,498.167], [1002.76,546.643], [974.613,495.497], [974.753,543.349]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.76,546.674], [1002.73,594.551], [974.753,543.38], [974.891,590.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.73,594.581], [1002.7,641.87], [974.891,590.678], [975.028,637.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.7,641.9], [1002.67,688.612], [975.028,637.403], [975.163,683.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.67,688.642], [1002.64,734.787], [975.163,683.565], [975.296,729.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.64,734.816], [1002.6,780.405], [975.296,729.175], [975.428,774.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.6,780.405], [1002.58,822.19], [975.428,774.213], [975.549,815.499]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1078.27,297.952], [1078.82,242.934], [985.067,297.926], [984.985,245.259]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.27,297.952], [1077.72,352.258], [985.067,297.926], [985.147,349.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.72,352.258], [1077.18,405.798], [985.147,349.942], [985.227,401.254]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.18,405.832], [1076.64,458.655], [985.227,401.286], [985.305,451.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.64,458.688], [1076.12,510.809], [985.305,451.971], [985.382,501.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.12,510.842], [1075.6,562.274], [985.382,502.01], [985.459,551.384]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.6,562.306], [1075.08,613.063], [985.459,551.415], [985.534,600.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.08,613.095], [1074.58,663.19], [985.534,600.198], [985.609,648.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.58,663.221], [1074.08,712.667], [985.609,648.371], [985.682,695.915]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.08,712.698], [1073.58,761.508], [985.682,695.945], [985.755,742.901]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.58,761.538], [1073.1,809.723], [985.755,742.93], [985.827,789.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.1,809.724], [1072.65,853.857], [985.827,789.31], [985.892,831.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.9,779.56], [1117.1,829.484], [1062.58,767.626], [1062.16,816.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.1,829.484], [1116.37,875.188], [1062.16,816.4], [1061.77,861.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.37,625.604], [1119.53,677.586], [1063.88,617.318], [1063.44,668.051]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.53,677.619], [1118.71,728.9], [1063.44,668.083], [1063.01,718.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.71,728.932], [1117.9,779.528], [1063.01,718.181], [1062.58,767.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.07,519.417], [1121.21,572.842], [1064.78,513.736], [1064.33,565.841]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.21,572.875], [1120.37,625.571], [1064.33,565.874], [1063.88,617.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.81,410.25], [1122.94,465.179], [1065.7,407.323], [1065.23,460.856]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.93,465.214], [1122.07,519.383], [1065.23,460.89], [1064.78,513.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.61,297.977], [1124.71,354.51], [1066.64,297.96], [1066.17,353.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.71,354.51], [1123.82,410.215], [1066.17,353.018], [1065.7,407.288]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1125.61,297.977], [1126.53,240.671], [1066.64,297.961], [1067.12,242.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.63,837.397], [1180.48,883.728], [1128.11,824.827], [1127.32,870.161]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.88,786.78], [1181.63,837.397], [1128.98,775.312], [1128.11,824.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.14,735.438], [1182.88,786.747], [1129.86,725.105], [1128.98,775.28]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.43,683.39], [1184.14,735.406], [1130.74,674.223], [1129.86,725.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.73,630.621], [1185.43,683.357], [1131.65,622.654], [1130.75,674.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.05,577.116], [1186.73,630.587], [1132.56,570.382], [1131.65,622.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.39,522.859], [1188.05,577.081], [1133.49,517.394], [1132.56,570.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.75,467.834], [1189.39,522.824], [1134.43,463.674], [1133.49,517.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.52,355.415], [1192.12,411.99], [1136.34,353.979], [1135.38,409.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.12,412.025], [1190.75,467.799], [1135.38,409.207], [1134.43,463.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.94,297.987], [1193.52,355.415], [1137.32,297.971], [1136.34,353.978]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1194.94,297.987], [1196.38,239.76], [1137.32,297.971], [1138.31,241.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.63,837.397], [1180.48,883.728], [1191.69,829.966], [1190.5,875.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.88,786.78], [1181.63,837.397], [1192.98,780.001], [1191.69,829.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.14,735.438], [1182.88,786.747], [1194.3,729.329], [1192.99,779.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.43,683.39], [1184.14,735.406], [1195.64,677.971], [1194.3,729.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.73,630.621], [1185.43,683.357], [1196.99,625.91], [1195.64,677.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.05,577.116], [1186.73,630.587], [1198.36,573.134], [1196.99,625.877]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.39,522.859], [1188.05,577.081], [1199.75,519.627], [1198.36,573.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.75,467.834], [1189.39,522.824], [1201.17,465.374], [1199.76,519.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.12,412.025], [1190.75,467.799], [1202.6,410.359], [1201.17,465.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.08,853.815], [1293.17,901.44], [1191.69,829.967], [1190.5,875.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.52,355.415], [1192.13,411.989], [1204.05,354.566], [1202.6,410.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.16,801.762], [1295.08,853.815], [1192.99,780.001], [1191.69,829.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.27,748.944], [1297.16,801.729], [1194.3,729.329], [1192.99,779.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.94,297.987], [1193.52,355.415], [1205.52,297.978], [1204.05,354.565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.41,695.376], [1299.27,748.91], [1195.64,677.971], [1194.3,729.297]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1194.94,297.987], [1196.38,239.76], [1205.52,297.978], [1207.01,240.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.58,641.042], [1301.41,695.341], [1196.99,625.91], [1195.64,677.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.78,585.927], [1303.58,641.007], [1198.36,573.134], [1196.99,625.877]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.02,530.012], [1305.78,585.891], [1199.76,519.627], [1198.36,573.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.28,473.282], [1308.02,529.977], [1201.17,465.374], [1199.76,519.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1312.58,415.716], [1310.29,473.245], [1202.6,410.359], [1201.17,465.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.92,357.299], [1312.59,415.68], [1204.05,354.566], [1202.6,410.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.29,298.008], [1314.92,357.298], [1205.52,297.978], [1204.05,354.565]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1317.29,298.008], [1319.69,237.865], [1205.52,297.978], [1207.01,240.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.07,853.815], [1293.17,901.44], [1314.27,836.517], [1312.31,882.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.16,801.762], [1295.07,853.815], [1316.42,785.977], [1314.27,836.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.27,748.944], [1297.16,801.729], [1318.59,734.715], [1316.42,785.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.41,695.376], [1299.27,748.91], [1320.8,682.748], [1318.6,734.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.58,641.042], [1301.41,695.341], [1323.04,630.063], [1320.8,682.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.78,585.927], [1303.58,641.007], [1325.3,576.644], [1323.04,630.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.02,530.012], [1305.78,585.891], [1327.6,522.476], [1325.31,576.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.28,473.282], [1308.02,529.977], [1329.94,467.543], [1327.61,522.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1312.58,415.716], [1310.29,473.245], [1332.3,411.828], [1329.94,467.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.92,357.298], [1312.59,415.68], [1334.7,355.315], [1332.3,411.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.33,844.513], [1314.27,836.517], [1348.11,891.405], [1312.31,882.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.29,298.008], [1314.92,357.298], [1337.13,297.986], [1334.7,355.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1352.76,793.273], [1316.42,785.977], [1350.33,844.512], [1314.27,836.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.22,741.29], [1318.59,734.715], [1352.76,793.24], [1316.42,785.944]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1317.29,298.008], [1319.69,237.865], [1337.13,297.986], [1339.6,239.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.71,688.583], [1320.8,682.748], [1355.22,741.257], [1318.6,734.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.24,635.135], [1323.04,630.063], [1357.71,688.549], [1320.8,682.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1362.81,580.932], [1360.24,635.101], [1325.3,576.644], [1323.04,630.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365.41,525.957], [1362.81,580.897], [1327.6,522.476], [1325.31,576.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.05,470.193], [1365.41,525.922], [1329.94,467.543], [1327.61,522.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.73,413.624], [1368.05,470.157], [1332.3,411.828], [1329.94,467.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.44,356.231], [1370.73,413.587], [1334.7,355.315], [1332.3,411.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.2,297.996], [1373.44,356.23], [1337.13,297.986], [1334.7,355.314]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.2,297.996], [1378.99,238.94], [1337.13,297.986], [1339.6,239.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.33,844.512], [1348.11,891.405], [1371.71,823.708], [1369.45,868.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1352.76,793.272], [1350.33,844.512], [1374.19,774.291], [1371.71,823.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.22,741.29], [1352.76,793.239], [1376.7,724.185], [1374.19,774.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.71,688.582], [1355.22,741.257], [1379.24,673.408], [1376.7,724.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.24,635.135], [1357.71,688.549], [1381.81,621.945], [1379.24,673.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1362.81,580.932], [1360.24,635.101], [1384.42,569.783], [1381.82,621.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365.41,525.956], [1362.81,580.897], [1387.07,516.908], [1384.43,569.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.05,470.192], [1365.41,525.922], [1389.76,463.304], [1387.07,516.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.72,413.623], [1368.05,470.157], [1392.48,408.957], [1389.76,463.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1386.24,826.781], [1371.71,823.708], [1383.88,872.271], [1369.45,868.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.44,356.23], [1370.73,413.587], [1395.23,353.85], [1392.48,408.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.83,777.094], [1374.19,774.291], [1386.24,826.781], [1371.71,823.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.2,297.996], [1373.44,356.23], [1398.03,297.97], [1395.23,353.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1391.45,726.71], [1376.7,724.185], [1388.83,777.063], [1374.19,774.26]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.2,297.996], [1378.99,238.939], [1398.03,297.969], [1400.87,241.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.11,675.647], [1379.24,673.408], [1391.45,726.678], [1376.7,724.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.8,623.891], [1381.81,621.945], [1394.11,675.615], [1379.24,673.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.53,571.428], [1384.43,569.783], [1396.8,623.859], [1381.82,621.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.96,826.711], [1383.6,872.196], [1407.33,805.242], [1404.93,849.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402.3,518.242], [1387.07,516.908], [1399.53,571.395], [1384.43,569.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1405.1,464.319], [1389.76,463.304], [1402.3,518.208], [1387.07,516.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.55,777.031], [1385.96,826.711], [1409.94,757.452], [1407.33,805.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1391.17,726.653], [1388.55,776.999], [1412.59,709.018], [1409.94,757.422]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1407.94,409.645], [1392.48,408.957], [1405.1,464.285], [1389.76,463.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1393.82,675.597], [1391.17,726.621], [1415.27,659.959], [1412.59,708.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.83,354.201], [1407.95,409.61], [1395.23,353.85], [1392.48,408.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.51,623.847], [1393.82,675.565], [1417.99,610.261], [1415.27,659.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.45,297.973], [1410.53,354.193], [1398.03,297.97], [1395.23,353.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.24,571.39], [1396.51,623.814], [1420.74,559.912], [1417.99,610.229]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1413.75,297.973], [1416.72,240.98], [1398.03,297.969], [1400.87,241.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402,518.212], [1399.24,571.357], [1423.53,508.9], [1420.75,559.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1404.8,464.296], [1402,518.178], [1426.36,457.211], [1423.53,508.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1407.65,409.629], [1404.81,464.262], [1429.22,404.832], [1426.36,457.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1410.53,354.193], [1407.65,409.594], [1432.13,351.748], [1429.23,404.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1413.45,297.973], [1410.53,354.193], [1434.87,297.946], [1431.93,351.764]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1413.45,297.973], [1416.41,240.988], [1435.07,297.946], [1438.05,243.445]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[735.47,298.409], [733.99,254.625], [678.376,298.054], [676.643,255.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.47,298.409], [736.935,341.73], [678.376,298.055], [680.091,339.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.935,341.73], [738.382,384.544], [680.091,339.72], [681.787,380.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.383,384.57], [739.814,426.91], [681.788,380.939], [683.466,421.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.815,426.937], [741.231,468.811], [683.467,421.72], [685.128,462.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.232,468.837], [742.632,510.253], [685.129,462.069], [686.771,501.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.633,510.279], [744.018,551.245], [686.772,501.994], [688.398,541.476]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.018,551.271], [745.388,591.793], [688.399,541.5], [690.007,580.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.389,591.819], [746.744,631.905], [690.008,580.596], [691.6,619.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.745,631.93], [748.086,671.588], [691.601,619.285], [693.177,657.552]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.087,671.613], [749.413,710.848], [693.178,657.577], [694.737,695.451]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.413,710.848], [750.63,746.859], [694.737,695.451], [696.169,730.226]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[754.06,298.716], [752.639,253.465], [720.939,298.506], [719.36,254.257]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.06,298.716], [755.466,343.473], [720.939,298.506], [722.501,342.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.466,343.473], [756.854,387.688], [722.501,342.283], [724.045,385.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.855,387.716], [758.228,431.426], [724.046,385.568], [725.572,428.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.229,431.454], [759.586,474.668], [725.573,428.37], [727.082,470.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.587,474.695], [760.929,517.421], [727.083,470.696], [728.576,512.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.93,517.448], [762.257,559.694], [728.576,512.554], [730.053,553.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.258,559.721], [763.569,601.496], [730.054,553.952], [731.514,594.872]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.57,601.522], [764.868,642.833], [731.515,594.898], [732.959,635.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.869,642.859], [766.152,683.713], [732.96,635.399], [734.388,675.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.153,683.739], [767.422,724.145], [734.389,675.462], [735.802,715.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.422,724.145], [768.586,761.218], [735.802,715.07], [737.099,751.418]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[780.325,299.055], [779.011,252.184], [744.616,298.825], [743.122,253.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.325,299.055], [781.623,345.395], [744.616,298.825], [746.093,344.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.623,345.395], [782.905,391.156], [746.093,344.09], [747.551,388.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.906,391.185], [784.173,436.404], [747.552,388.829], [748.994,433.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.174,436.432], [785.426,481.121], [748.995,433.052], [750.421,476.739]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.427,481.149], [786.664,525.315], [750.422,476.767], [751.831,519.955]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.665,525.343], [787.888,568.996], [751.832,519.983], [753.225,562.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.889,569.024], [789.098,612.173], [753.225,562.708], [754.603,604.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.099,612.2], [790.294,654.854], [754.604,604.951], [755.966,646.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.295,654.881], [791.476,697.048], [755.967,646.72], [757.313,687.997]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.477,697.074], [792.645,738.763], [757.314,688.023], [758.646,728.841]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.645,738.763], [793.716,776.999], [758.646,728.841], [759.868,766.288]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[780.325,299.055], [779.012,252.184], [794.644,298.949], [793.43,252.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.325,299.055], [781.623,345.395], [794.644,298.949], [795.844,344.793]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[781.623,345.395], [782.905,391.156], [795.844,344.793], [797.029,390.07]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.906,391.185], [784.173,436.404], [797.029,390.098], [798.2,434.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.174,436.432], [785.426,481.121], [798.201,434.873], [799.359,479.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.427,481.149], [786.665,525.315], [799.359,479.128], [800.503,522.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.665,525.343], [787.888,568.996], [800.504,522.871], [801.635,566.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.889,569.024], [789.098,612.173], [801.636,566.112], [802.754,608.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.099,612.2], [790.294,654.854], [802.755,608.858], [803.86,651.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.295,654.881], [791.476,697.048], [803.861,651.118], [804.953,692.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.477,697.074], [804.954,692.902], [792.645,738.763], [806.035,734.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.645,738.763], [806.035,734.189], [793.717,776.999], [807.026,772.062]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[863.881,299.386], [863.046,250.931], [794.644,298.949], [793.431,252.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.881,299.386], [864.706,347.273], [794.644,298.949], [795.844,344.793]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.706,347.273], [865.521,394.541], [795.844,344.793], [797.029,390.07]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.522,394.571], [866.326,441.263], [797.03,390.098], [798.201,434.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.327,441.292], [867.122,487.417], [798.201,434.873], [799.359,479.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.123,487.446], [867.908,533.014], [799.36,479.128], [800.504,522.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.909,533.043], [868.685,578.065], [800.504,522.871], [801.635,566.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.685,578.094], [869.452,622.579], [801.636,566.112], [802.754,608.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.452,622.607], [870.21,666.565], [802.755,608.858], [803.86,651.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.211,666.593], [870.959,710.034], [803.861,651.118], [804.954,692.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.96,710.061], [871.7,752.993], [804.954,692.902], [806.035,734.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.7,752.993], [872.378,792.357], [806.035,734.189], [807.026,772.062]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[863.881,299.386], [863.046,250.932], [885.326,299.211], [884.638,251.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.881,299.386], [864.706,347.273], [885.326,299.211], [886.008,346.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.707,347.273], [865.522,394.541], [886.008,346.279], [886.68,392.749]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.522,394.571], [866.327,441.263], [886.681,392.778], [887.345,438.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.327,441.292], [867.122,487.417], [887.345,438.719], [888.002,484.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.123,487.446], [867.908,533.014], [888.002,484.113], [888.651,528.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.909,533.043], [868.685,578.065], [888.651,528.967], [889.292,573.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.685,578.094], [869.452,622.579], [889.292,573.293], [889.926,617.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.453,622.607], [870.21,666.565], [889.926,617.099], [890.552,660.368]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.211,666.593], [870.96,710.034], [890.553,660.395], [891.172,703.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.96,710.061], [871.7,752.993], [891.172,703.189], [891.784,745.464]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.7,752.993], [872.379,792.357], [891.784,745.464], [892.345,784.232]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[909.252,299.358], [908.702,251.041], [885.326,299.211], [884.637,251.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.251,299.358], [909.795,347.11], [885.326,299.211], [886.008,346.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.795,347.11], [910.332,394.247], [886.007,346.279], [886.68,392.749]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.332,394.277], [910.862,440.84], [886.68,392.778], [887.344,438.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.862,440.87], [911.386,486.87], [887.345,438.719], [888.001,484.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.386,486.899], [911.903,532.345], [888.002,484.113], [888.65,528.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.904,532.374], [912.415,577.277], [888.651,528.967], [889.292,573.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.415,577.306], [912.92,621.675], [889.292,573.293], [889.925,617.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.92,621.703], [913.419,665.548], [889.926,617.099], [890.552,660.368]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.42,665.576], [913.913,708.906], [890.552,660.395], [891.171,703.163]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.913,708.934], [914.401,751.758], [891.171,703.19], [891.783,745.464]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.401,751.758], [914.848,791.023], [891.783,745.464], [892.344,784.232]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[909.251,299.358], [908.701,251.04], [933.635,299.151], [933.246,251.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.251,299.358], [909.795,347.11], [933.635,299.151], [934.021,345.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.795,347.11], [910.331,394.247], [934.021,345.94], [934.401,392.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.332,394.277], [910.862,440.84], [934.401,392.166], [934.777,437.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.862,440.87], [911.386,486.87], [934.777,437.842], [935.149,482.947]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.386,486.899], [911.903,532.345], [935.149,482.975], [935.516,527.549]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.904,532.374], [912.415,577.277], [935.516,527.577], [935.879,571.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.415,577.306], [912.92,621.675], [935.879,571.655], [936.238,615.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.92,621.703], [913.419,665.548], [936.238,615.22], [936.592,658.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.42,665.576], [913.913,708.906], [936.593,658.28], [936.943,700.817]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.913,708.933], [914.4,751.758], [936.943,700.844], [937.289,742.893]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.4,751.758], [914.847,791.023], [937.289,742.894], [937.607,781.457]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[991.529,299.858], [991.49,249.148], [965.174,299.696], [964.966,249.759]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.529,299.858], [991.567,349.944], [965.174,299.696], [965.379,349.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.567,349.944], [991.605,399.356], [965.379,349.03], [965.582,397.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.605,399.387], [991.642,448.168], [965.582,397.739], [965.782,445.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.642,448.199], [991.679,496.361], [965.782,445.835], [965.98,493.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.679,496.392], [991.715,543.947], [965.98,493.331], [966.175,540.207]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.715,543.977], [991.751,590.937], [966.176,540.237], [966.368,586.534]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.751,590.966], [991.786,637.342], [966.369,586.564], [966.559,632.293]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.786,637.371], [991.821,683.173], [966.559,632.322], [966.747,677.494]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.821,683.202], [991.856,728.44], [966.747,677.523], [966.933,722.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.856,728.469], [991.89,773.154], [966.933,722.176], [967.117,766.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[991.89,773.155], [991.921,814.106], [967.117,766.264], [967.285,806.673]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1056.56,300.587], [1056.97,246.389], [971.42,300.05], [971.247,248.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.56,300.587], [1056.15,354.07], [971.42,300.05], [971.591,351.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.15,354.071], [1055.75,406.788], [971.591,351.03], [971.76,401.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.75,406.821], [1055.35,458.82], [971.76,401.344], [971.927,450.973]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.35,458.853], [1054.96,510.149], [971.927,451.005], [972.092,499.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.96,510.181], [1054.57,560.788], [972.092,500.024], [972.254,548.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.57,560.82], [1054.19,610.751], [972.254,548.415], [972.415,596.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.19,610.783], [1053.81,660.052], [972.415,596.19], [972.573,643.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.81,660.083], [1053.44,708.703], [972.573,643.359], [972.729,689.906]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.44,708.734], [1053.08,756.718], [972.729,689.936], [972.884,735.901]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.08,756.749], [1052.72,804.109], [972.884,735.93], [973.037,781.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.72,804.109], [1052.38,847.478], [973.037,781.324], [973.176,822.915]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.73,725.954], [1091.09,775.777], [1040.64,713.825], [1040.35,762.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.09,775.809], [1090.46,824.958], [1040.35,762.384], [1040.07,810.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.46,824.958], [1089.88,869.943], [1040.07,810.274], [1039.81,854.122]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.71,572.203], [1093.04,624.133], [1041.52,564.183], [1041.22,614.705]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.04,624.166], [1092.38,675.379], [1041.22,614.737], [1040.93,664.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.38,675.411], [1091.73,725.922], [1040.93,664.613], [1040.64,713.793]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.48,356.868], [1095.78,411.821], [1042.75,354.896], [1042.44,408.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.78,411.856], [1095.08,466.03], [1042.44,408.308], [1042.13,460.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.08,466.064], [1094.39,519.474], [1042.13,460.983], [1041.82,512.903]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.39,519.508], [1093.71,572.17], [1041.82,512.936], [1041.52,564.151]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1097.2,301.081], [1097.93,244.516], [1043.07,300.733], [1043.4,245.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.2,301.081], [1096.48,356.867], [1043.07,300.733], [1042.75,354.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.17,834.989], [1151.19,880.746], [1102.68,820.773], [1102.03,865.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.33,734.245], [1153.24,784.95], [1104.11,722.496], [1103.39,771.951]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.24,784.982], [1152.17,834.989], [1103.39,771.982], [1102.68,820.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.43,682.795], [1154.33,734.213], [1104.84,672.333], [1104.11,722.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.55,630.615], [1155.43,682.762], [1105.58,621.477], [1104.84,672.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.84,524.005], [1157.69,577.656], [1107.09,517.633], [1106.33,569.883]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.69,577.691], [1156.55,630.581], [1106.33,569.916], [1105.58,621.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.01,469.543], [1158.84,523.971], [1107.87,464.614], [1107.1,517.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.19,414.286], [1160.01,469.508], [1108.65,410.844], [1107.87,464.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.4,358.218], [1161.19,414.251], [1109.44,356.305], [1108.65,410.809]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1163.62,301.32], [1164.86,243.611], [1110.25,300.982], [1111.07,244.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.62,301.32], [1162.4,358.218], [1110.25,300.982], [1109.44,356.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.17,834.989], [1164.36,828.034], [1151.19,880.746], [1163.31,873.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.24,784.982], [1165.5,778.622], [1152.17,834.989], [1164.36,828.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.33,734.245], [1153.24,784.95], [1166.66,728.496], [1165.5,778.59]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.43,682.795], [1154.33,734.213], [1167.83,677.675], [1166.66,728.464]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.55,630.615], [1155.43,682.762], [1169.03,626.143], [1167.84,677.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.69,577.691], [1156.55,630.581], [1170.23,573.885], [1169.03,626.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.84,524.005], [1157.69,577.656], [1171.46,520.886], [1170.24,573.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.01,469.543], [1158.84,523.971], [1172.7,467.13], [1171.46,520.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.19,414.286], [1160.01,469.508], [1173.96,412.601], [1172.7,467.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.4,358.218], [1161.19,414.251], [1175.24,357.281], [1173.96,412.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.62,301.32], [1162.4,358.218], [1176.54,301.154], [1175.24,357.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.07,855.285], [1259.34,902.6], [1164.36,828.034], [1163.31,873.256]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1163.62,301.32], [1164.86,243.611], [1176.54,301.154], [1177.86,244.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.97,803.552], [1261.07,855.285], [1165.5,778.622], [1164.36,828.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.89,751.036], [1262.97,803.519], [1166.66,728.496], [1165.5,778.59]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.84,697.752], [1264.89,751.002], [1167.84,677.675], [1166.66,728.464]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.83,643.685], [1266.85,697.718], [1169.03,626.143], [1167.84,677.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.84,588.816], [1268.83,643.65], [1170.23,573.885], [1169.03,626.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.88,533.128], [1270.84,588.781], [1171.46,520.886], [1170.24,573.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.95,476.603], [1272.88,533.093], [1172.7,467.13], [1171.46,520.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.05,419.22], [1274.95,476.566], [1173.96,412.601], [1172.7,467.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.19,360.961], [1277.05,419.183], [1175.24,357.281], [1173.96,412.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.36,301.805], [1279.19,360.961], [1176.54,301.154], [1175.24,357.281]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1281.36,301.805], [1283.56,241.771], [1176.54,301.154], [1177.86,244.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.07,855.285], [1259.34,902.6], [1285.66,838.865], [1283.82,884.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.97,803.552], [1261.07,855.285], [1287.67,788.528], [1285.66,838.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.89,751.036], [1262.97,803.519], [1289.71,737.45], [1287.67,788.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.84,697.752], [1264.89,751.002], [1291.79,685.649], [1289.72,737.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.83,643.685], [1266.85,697.718], [1293.89,633.109], [1291.79,685.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.84,588.816], [1268.83,643.65], [1296.02,579.813], [1293.89,633.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.88,533.128], [1270.84,588.781], [1298.18,525.745], [1296.02,579.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.95,476.603], [1272.88,533.093], [1300.37,470.889], [1298.18,525.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.05,419.22], [1274.95,476.566], [1302.6,415.227], [1300.37,470.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.19,360.961], [1277.05,419.183], [1304.86,358.741], [1302.6,415.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.36,301.805], [1279.19,360.961], [1307.15,301.412], [1304.86,358.741]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1281.36,301.805], [1283.56,241.771], [1307.15,301.412], [1309.47,243.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1319.86,848.109], [1285.66,838.865], [1317.77,894.874], [1283.82,884.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.15,796.985], [1287.67,788.528], [1319.86,848.109], [1285.66,838.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.47,745.097], [1289.71,737.45], [1322.15,796.952], [1287.67,788.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.83,692.461], [1291.79,685.649], [1324.48,745.064], [1289.72,737.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1329.22,639.061], [1326.83,692.427], [1293.89,633.109], [1291.79,685.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1331.65,584.879], [1329.22,639.026], [1296.02,579.813], [1293.89,633.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.11,529.899], [1331.65,584.844], [1298.18,525.745], [1296.02,579.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.61,474.104], [1334.11,529.864], [1300.37,470.889], [1298.18,525.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.15,417.473], [1336.61,474.068], [1302.6,415.227], [1300.37,470.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.72,359.99], [1339.15,417.437], [1304.86,358.741], [1302.6,415.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.33,301.633], [1341.72,359.989], [1307.15,301.412], [1304.86,358.741]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1344.33,301.633], [1346.98,242.422], [1307.15,301.412], [1309.47,243.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1319.86,848.109], [1317.77,894.874], [1347.98,828.189], [1345.78,873.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.15,796.984], [1319.86,848.109], [1350.38,778.763], [1347.98,828.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.47,745.096], [1322.15,796.952], [1352.81,728.624], [1350.38,778.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.83,692.46], [1324.48,745.063], [1355.28,677.789], [1352.81,728.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1329.22,639.06], [1326.83,692.427], [1357.78,626.242], [1355.28,677.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1331.65,584.878], [1329.22,639.026], [1360.32,573.969], [1357.78,626.21]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.11,529.899], [1331.65,584.844], [1362.9,520.955], [1360.32,573.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.61,474.103], [1334.11,529.864], [1365.51,467.184], [1362.9,520.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.15,417.473], [1336.61,474.067], [1368.15,412.638], [1365.51,467.149]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.72,359.989], [1339.15,417.437], [1370.84,357.302], [1368.16,412.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.33,301.633], [1341.72,359.989], [1373.57,301.158], [1370.84,357.302]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1344.33,301.633], [1346.98,242.422], [1373.57,301.158], [1376.33,244.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.9,831.77], [1347.98,828.19], [1359.6,877.28], [1345.78,873.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1364.41,782.038], [1350.38,778.763], [1361.9,831.77], [1347.98,828.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.96,731.584], [1352.81,728.624], [1364.41,782.006], [1350.38,778.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.54,680.424], [1355.28,677.789], [1366.96,731.552], [1352.81,728.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.16,628.544], [1357.78,626.242], [1369.55,680.392], [1355.28,677.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1374.82,575.928], [1360.32,573.97], [1372.17,628.511], [1357.78,626.21]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.63,831.69], [1359.34,877.194], [1390.13,810.999], [1387.75,854.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.52,522.561], [1362.9,520.955], [1374.82,575.895], [1360.32,573.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1364.14,781.965], [1361.63,831.69], [1392.73,763.046], [1390.13,810.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1380.25,468.425], [1365.51,467.184], [1377.52,522.527], [1362.9,520.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.69,731.518], [1364.15,781.934], [1395.37,714.423], [1392.74,763.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1383.02,413.505], [1380.25,468.391], [1368.15,412.638], [1365.51,467.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.27,680.366], [1366.69,731.486], [1398.05,665.146], [1395.37,714.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.84,357.784], [1383.03,413.471], [1370.84,357.302], [1368.16,412.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.89,628.493], [1369.27,680.333], [1400.76,615.202], [1398.05,665.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.41,301.241], [1385.55,357.773], [1373.57,301.158], [1370.84,357.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1374.54,575.885], [1371.89,628.46], [1403.5,564.578], [1400.76,615.17]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1388.69,301.243], [1391.59,243.901], [1373.57,301.158], [1376.33,244.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.24,522.525], [1374.55,575.852], [1406.29,513.26], [1403.51,564.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.97,468.398], [1377.24,522.491], [1409.11,461.233], [1406.29,513.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1382.74,413.486], [1379.97,468.364], [1411.97,408.482], [1409.11,461.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.55,357.773], [1382.74,413.451], [1414.88,354.993], [1411.98,408.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.41,301.241], [1385.55,357.773], [1417.57,300.753], [1414.63,355.011]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1388.41,301.241], [1391.3,243.908], [1417.82,300.749], [1420.8,245.77]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[752.263,298.76], [750.88,256.389], [702.517,298.026], [700.921,257.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.263,298.76], [753.632,340.684], [702.517,298.026], [704.096,338.236]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.632,340.684], [754.985,382.117], [704.096,338.237], [705.657,377.994]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.986,382.143], [756.324,423.118], [705.658,378.019], [707.203,417.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.325,423.144], [757.648,463.669], [707.204,417.379], [708.732,456.301]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.649,463.694], [758.957,503.777], [708.733,456.325], [710.246,494.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.958,503.802], [760.253,543.449], [710.247,494.862], [711.744,532.974]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.254,543.474], [761.534,582.693], [711.745,532.998], [713.226,570.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.535,582.717], [762.802,621.514], [713.227,570.738], [714.693,608.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.803,621.539], [764.056,659.921], [714.694,608.088], [716.145,645.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.057,659.946], [765.297,697.92], [716.145,645.055], [717.582,681.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.297,697.92], [766.435,732.774], [717.582,681.621], [718.9,715.195]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[766.209,299.363], [764.86,255.553], [737.331,298.928], [735.849,256.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.209,299.363], [767.544,342.696], [737.331,298.928], [738.797,341.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.544,342.696], [768.862,385.505], [738.797,341.244], [740.245,383.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.863,385.532], [770.167,427.852], [740.246,383.087], [741.678,424.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.167,427.878], [771.456,469.718], [741.679,424.463], [743.096,465.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.457,469.744], [772.731,511.112], [743.097,465.38], [744.498,505.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.731,511.138], [773.991,552.042], [744.499,505.846], [745.884,545.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.992,552.067], [775.238,592.515], [745.885,545.869], [747.255,585.43]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.238,592.54], [776.47,632.539], [747.256,585.455], [748.612,624.587]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.471,632.564], [777.689,672.121], [748.613,624.612], [749.954,663.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.69,672.146], [778.895,711.269], [749.955,663.347], [751.281,701.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.895,711.269], [780,747.165], [751.281,701.642], [752.499,736.786]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[787.088,300.037], [785.815,254.619], [755.94,299.558], [754.516,255.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.087,300.037], [788.346,344.94], [755.94,299.558], [757.348,343.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.346,344.941], [789.588,389.282], [757.348,343.346], [758.74,386.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.589,389.31], [790.817,433.128], [758.74,386.625], [760.116,429.379]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.817,433.156], [792.031,476.458], [760.117,429.406], [761.476,471.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.031,476.486], [793.23,519.282], [761.477,471.696], [762.821,513.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.231,519.309], [794.416,561.609], [762.822,513.504], [764.15,554.812]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.417,561.636], [795.589,603.447], [764.151,554.838], [765.465,595.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.589,603.473], [796.747,644.804], [765.466,595.707], [766.765,636.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.748,644.831], [797.893,685.69], [766.766,636.117], [768.05,676.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.894,685.716], [799.026,726.111], [768.051,676.077], [769.321,715.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.026,726.111], [800.064,763.161], [769.321,715.57], [770.487,751.801]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[787.088,300.037], [785.815,254.619], [802.019,299.853], [800.848,254.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.087,300.037], [788.346,344.94], [802.019,299.853], [803.177,344.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.346,344.941], [789.588,389.282], [803.177,344.327], [804.32,388.25]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.589,389.31], [790.817,433.128], [804.321,388.278], [805.451,431.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.817,433.155], [792.031,476.458], [805.451,431.713], [806.568,474.617]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.031,476.485], [793.231,519.282], [806.569,474.644], [807.672,517.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.231,519.309], [794.417,561.609], [807.673,517.077], [808.764,558.996]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.417,561.636], [795.589,603.447], [808.765,559.022], [809.844,600.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.59,603.473], [796.748,644.804], [809.844,600.487], [810.911,641.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.748,644.83], [810.911,641.481], [797.893,685.69], [811.966,681.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.894,685.716], [811.966,682.011], [799.026,726.111], [813.009,722.06]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.026,726.111], [813.009,722.06], [800.064,763.161], [813.965,758.795]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[862.954,300.769], [862.109,253.603], [802.019,299.853], [800.848,254.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.954,300.769], [863.789,347.38], [802.019,299.853], [803.177,344.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.789,347.38], [864.613,393.386], [803.177,344.327], [804.32,388.25]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.613,393.415], [865.427,438.857], [804.321,388.278], [805.451,431.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.428,438.885], [866.232,483.773], [805.451,431.713], [806.568,474.617]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.233,483.802], [867.027,528.146], [806.569,474.644], [807.673,517.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.028,528.174], [867.813,571.984], [807.673,517.077], [808.764,558.996]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.813,572.011], [868.589,615.297], [808.765,559.022], [809.844,600.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.589,615.324], [869.355,658.094], [809.844,600.487], [810.911,641.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.356,658.121], [870.113,700.385], [810.911,641.481], [811.966,681.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.113,700.412], [870.862,742.179], [811.966,682.011], [813.009,722.06]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.862,742.179], [871.548,780.473], [813.009,722.06], [813.965,758.795]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[862.954,300.769], [862.109,253.603], [885.766,300.462], [885.075,254.029]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.954,300.769], [863.789,347.38], [885.766,300.462], [886.448,346.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.789,347.38], [864.613,393.386], [886.449,346.357], [887.123,391.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.614,393.415], [865.428,438.857], [887.123,391.694], [887.789,436.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.428,438.885], [866.232,483.773], [887.789,436.483], [888.447,480.707]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.233,483.802], [867.027,528.146], [888.448,480.735], [889.098,524.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.028,528.174], [867.813,571.984], [889.098,524.458], [889.74,567.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.813,572.011], [868.589,615.297], [889.741,567.663], [890.375,610.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.589,615.324], [869.355,658.094], [890.376,610.358], [891.003,652.525]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.356,658.121], [870.113,700.385], [891.004,652.552], [891.623,694.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.114,700.412], [870.862,742.179], [891.624,694.255], [892.237,735.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.862,742.179], [871.548,780.473], [892.237,735.448], [892.799,773.221]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[907.04,300.772], [906.472,253.599], [885.765,300.462], [885.075,254.029]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.04,300.772], [907.601,347.388], [885.766,300.462], [886.448,346.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.601,347.388], [908.156,393.4], [886.448,346.357], [887.122,391.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.156,393.429], [908.703,438.876], [887.122,391.694], [887.788,436.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.703,438.905], [909.244,483.798], [887.789,436.483], [888.447,480.707]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.245,483.827], [909.779,528.176], [888.447,480.735], [889.097,524.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.779,528.204], [910.307,572.019], [889.097,524.458], [889.74,567.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.307,572.046], [910.828,615.337], [889.74,567.663], [890.375,610.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.828,615.364], [911.344,658.139], [890.375,610.358], [891.003,652.525]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.344,658.166], [911.853,700.435], [891.003,652.552], [891.623,694.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.853,700.462], [912.356,742.234], [891.623,694.255], [892.236,735.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.356,742.234], [912.818,780.531], [892.236,735.448], [892.798,773.221]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[907.04,300.772], [906.472,253.599], [933.237,300.408], [932.841,254.104]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.04,300.772], [907.601,347.388], [933.237,300.408], [933.628,346.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.601,347.388], [908.155,393.4], [933.628,346.177], [934.015,391.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.156,393.429], [908.703,438.876], [934.015,391.391], [934.397,436.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.703,438.905], [909.244,483.798], [934.397,436.06], [934.774,480.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.244,483.827], [909.778,528.176], [934.775,480.195], [935.147,523.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.779,528.204], [910.306,572.019], [935.148,523.804], [935.516,566.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.307,572.046], [910.828,615.337], [935.516,566.897], [935.88,609.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.828,615.364], [911.343,658.139], [935.88,609.483], [936.24,651.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.344,658.166], [911.853,700.435], [936.24,651.571], [936.596,693.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.853,700.462], [912.356,742.234], [936.596,693.17], [936.947,734.262]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.356,742.234], [912.817,780.531], [936.947,734.262], [937.27,771.944]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[980.641,301.835], [980.53,252.124], [957.014,301.491], [956.751,252.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.641,301.835], [980.751,350.927], [957.014,301.491], [957.274,349.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.751,350.927], [980.859,399.35], [957.274,349.783], [957.531,397.427]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.859,399.381], [980.966,447.179], [957.531,397.457], [957.784,444.496]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1034.96,303.32], [1035.23,250.06], [958.633,302.174], [958.372,251.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.966,447.209], [981.072,494.394], [957.784,444.526], [958.034,490.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.072,494.424], [981.176,541.008], [958.035,491], [958.282,536.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.176,541.037], [981.279,587.031], [958.282,536.892], [958.526,582.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.279,587.06], [981.381,632.474], [958.526,582.211], [958.767,626.941]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.96,303.32], [1034.7,355.868], [958.633,302.174], [958.891,352.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.7,355.868], [1034.44,407.652], [958.891,352.056], [959.145,401.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.44,407.685], [1034.18,458.754], [959.145,401.279], [959.396,449.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.18,458.786], [1033.93,509.154], [959.396,449.857], [959.644,497.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.381,632.503], [981.481,677.349], [958.767,626.969], [959.005,671.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.482,677.378], [981.581,721.667], [959.005,671.176], [959.24,714.815]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.581,721.695], [981.679,765.436], [959.24,714.842], [959.472,757.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[981.679,765.436], [981.768,805.517], [959.472,757.95], [959.685,797.457]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.93,509.186], [1033.68,558.869], [959.644,497.802], [959.889,545.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.68,558.9], [1033.44,607.91], [959.889,545.125], [960.13,591.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.44,607.941], [1033.2,656.292], [960.131,591.84], [960.369,637.929]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.2,656.323], [1032.96,704.029], [960.369,637.958], [960.604,683.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.96,704.059], [1032.72,751.132], [960.605,683.49], [960.837,728.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.72,751.162], [1032.49,797.615], [960.837,728.448], [961.066,772.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.49,797.615], [1032.28,840.146], [961.066,772.813], [961.277,813.458]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.12,770.997], [1063.67,819.26], [1018.52,756.289], [1018.38,803.211]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.67,819.26], [1063.25,863.426], [1018.38,803.211], [1018.25,846.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.51,413.303], [1067.01,466.579], [1019.56,409.135], [1019.4,460.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.01,466.612], [1066.51,519.126], [1019.4,460.806], [1019.25,511.729]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.51,519.159], [1066.02,570.926], [1019.25,511.761], [1019.1,561.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.02,570.958], [1065.54,621.995], [1019.1,562.014], [1018.95,611.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.54,622.027], [1065.06,672.348], [1018.95,611.58], [1018.8,660.44]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.06,672.38], [1064.59,722], [1018.8,660.471], [1018.66,708.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.59,722.032], [1064.13,770.966], [1018.66,708.703], [1018.52,756.259]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1068.55,304.327], [1069.07,248.661], [1019.87,303.58], [1020.03,249.699]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.55,304.326], [1068.03,359.213], [1019.87,303.58], [1019.71,356.731]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.03,359.213], [1067.51,413.269], [1019.71,356.731], [1019.56,409.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.73,831.238], [1120.93,876.302], [1076.89,815.592], [1076.39,859.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.5,731.985], [1122.61,781.946], [1077.99,718.984], [1077.43,767.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.61,781.978], [1121.73,831.238], [1077.43,767.635], [1076.89,815.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1124.4,681.276], [1123.5,731.953], [1078.55,669.656], [1077.99,718.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.25,577.646], [1125.32,629.802], [1079.69,568.912], [1079.12,619.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.32,629.835], [1124.4,681.244], [1079.12,619.637], [1078.55,669.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.15,470.957], [1127.19,524.658], [1080.87,465.284], [1080.28,517.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.19,524.692], [1126.25,577.612], [1080.28,517.466], [1079.69,568.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1129.12,416.423], [1128.15,470.922], [1081.47,412.349], [1080.87,465.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.11,304.886], [1130.11,361.072], [1082.7,304.155], [1082.08,358.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1130.11,361.072], [1129.12,416.388], [1082.08,358.645], [1081.47,412.315]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1131.11,304.886], [1132.12,247.882], [1082.7,304.156], [1083.33,248.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.73,831.238], [1135.82,824.85], [1120.93,876.302], [1134.93,869.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.61,781.978], [1136.78,776.122], [1121.73,831.238], [1135.82,824.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.5,731.985], [1137.76,726.676], [1122.61,781.946], [1136.78,776.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.32,629.835], [1124.4,681.244], [1139.77,625.67], [1138.76,676.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1124.4,681.276], [1123.5,731.953], [1138.76,676.531], [1137.76,726.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.25,577.646], [1125.32,629.802], [1140.79,574.078], [1139.77,625.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.19,524.692], [1126.25,577.612], [1141.83,521.74], [1140.79,574.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.15,470.957], [1127.19,524.658], [1142.88,468.639], [1141.83,521.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1129.12,416.423], [1128.15,470.922], [1143.95,414.758], [1142.88,468.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1130.11,361.072], [1129.12,416.388], [1145.03,360.08], [1143.95,414.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.11,304.886], [1130.11,361.072], [1146.13,304.587], [1145.03,360.08]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1131.11,304.886], [1132.12,247.882], [1146.13,304.588], [1147.24,248.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.41,855.133], [1222.88,901.98], [1135.82,824.85], [1134.94,869.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.08,803.895], [1224.41,855.133], [1136.78,776.122], [1135.82,824.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.78,751.862], [1226.09,803.861], [1137.76,726.676], [1136.79,776.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.51,699.05], [1227.78,751.828], [1138.76,676.531], [1137.77,726.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.26,645.442], [1229.51,699.016], [1139.77,625.67], [1138.76,676.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.03,591.019], [1231.26,645.407], [1140.79,574.078], [1139.77,625.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.84,535.762], [1233.03,590.984], [1141.83,521.74], [1140.79,574.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.67,479.654], [1234.84,535.727], [1142.88,468.639], [1141.83,521.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.53,422.672], [1236.67,479.617], [1143.95,414.758], [1142.88,468.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.42,364.797], [1238.53,422.635], [1145.03,360.08], [1143.95,414.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.34,306.008], [1240.42,364.797], [1146.13,304.587], [1145.03,360.08]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1242.34,306.008], [1244.29,246.321], [1146.13,304.587], [1147.24,248.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.41,855.133], [1222.88,901.98], [1253.99,839.849], [1252.3,885.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.08,803.895], [1224.41,855.133], [1255.83,789.875], [1253.99,839.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.78,751.862], [1226.09,803.861], [1257.69,739.145], [1255.83,789.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.51,699.05], [1227.78,751.828], [1259.59,687.678], [1257.69,739.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.26,645.442], [1229.51,699.016], [1261.51,635.455], [1259.59,687.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.03,591.019], [1231.26,645.407], [1263.46,582.46], [1261.51,635.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.84,535.762], [1233.03,590.984], [1265.44,528.677], [1263.46,582.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.67,479.654], [1234.84,535.727], [1267.45,474.086], [1265.44,528.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.53,422.672], [1236.67,479.617], [1269.49,418.671], [1267.45,474.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.42,364.797], [1238.53,422.635], [1271.56,362.412], [1269.49,418.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.34,306.008], [1240.42,364.797], [1273.67,305.289], [1271.56,362.412]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1242.34,306.008], [1244.29,246.321], [1273.67,305.289], [1275.8,247.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.77,850.24], [1253.99,839.849], [1283.84,896.723], [1252.3,885.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.87,799.406], [1255.83,789.875], [1285.77,850.24], [1253.99,839.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.01,747.79], [1287.88,799.373], [1257.69,739.145], [1255.83,789.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.18,695.408], [1290.01,747.757], [1259.59,687.678], [1257.69,739.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.39,642.243], [1292.19,695.374], [1261.51,635.455], [1259.59,687.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.62,588.277], [1294.39,642.209], [1263.46,582.46], [1261.51,635.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1298.89,533.492], [1296.62,588.243], [1265.44,528.677], [1263.46,582.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.2,477.87], [1298.9,533.457], [1267.45,474.086], [1265.44,528.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.54,421.39], [1301.2,477.834], [1269.49,418.671], [1267.45,474.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.92,364.033], [1303.54,421.353], [1271.56,362.412], [1269.49,418.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.33,305.777], [1305.92,364.032], [1273.67,305.289], [1271.56,362.412]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1308.33,305.777], [1310.78,246.641], [1273.67,305.289], [1275.8,247.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.77,850.24], [1283.84,896.723], [1320.26,831.535], [1318.17,876.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.87,799.405], [1285.77,850.24], [1322.54,782.25], [1320.26,831.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.01,747.789], [1287.87,799.373], [1324.85,732.232], [1322.54,782.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.18,695.407], [1290.01,747.757], [1327.2,681.497], [1324.85,732.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.39,642.243], [1292.18,695.374], [1329.58,630.029], [1327.2,681.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.62,588.277], [1294.39,642.209], [1332,577.812], [1329.58,629.996]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1298.89,533.492], [1296.62,588.243], [1334.45,524.829], [1332,577.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.2,477.869], [1298.89,533.457], [1336.94,471.064], [1334.45,524.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.54,421.389], [1301.2,477.834], [1339.46,416.5], [1336.94,471.03]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.92,364.032], [1303.54,421.353], [1342.02,361.118], [1339.46,416.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.33,305.777], [1305.92,364.032], [1344.62,304.9], [1342.02,361.118]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1308.33,305.777], [1310.78,246.641], [1344.62,304.9], [1347.26,247.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1333.34,835.593], [1320.26,831.535], [1331.15,880.983], [1318.17,876.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1335.73,785.971], [1322.54,782.25], [1333.34,835.593], [1320.26,831.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1338.16,735.606], [1324.85,732.232], [1335.73,785.94], [1322.54,782.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.62,684.513], [1327.2,681.497], [1338.16,735.574], [1324.85,732.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.12,632.676], [1329.58,630.029], [1340.62,684.481], [1327.2,681.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.65,580.08], [1332,577.812], [1343.12,632.643], [1329.58,629.996]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1333.09,835.505], [1330.91,880.888], [1368.47,815.933], [1366.14,859.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.22,526.706], [1334.45,524.829], [1345.65,580.047], [1332,577.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1335.48,785.89], [1333.09,835.505], [1371.02,767.947], [1368.47,815.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.83,472.539], [1336.94,471.064], [1348.22,526.672], [1334.45,524.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1337.91,735.532], [1335.48,785.859], [1373.6,719.267], [1371.02,767.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.48,417.559], [1350.83,472.504], [1339.46,416.5], [1336.94,471.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.37,684.447], [1337.91,735.5], [1376.22,669.909], [1373.6,719.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.17,361.749], [1353.48,417.524], [1342.02,361.118], [1339.46,416.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1342.86,632.619], [1340.37,684.415], [1378.87,619.859], [1376.22,669.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.63,305.086], [1355.9,361.735], [1344.62,304.9], [1342.02,361.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.39,580.03], [1342.86,632.586], [1381.57,569.102], [1378.88,619.828]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1358.9,305.09], [1361.67,247.598], [1344.63,304.9], [1347.26,247.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1347.96,526.665], [1345.4,579.997], [1384.3,517.623], [1381.57,569.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.57,472.506], [1347.96,526.631], [1387.07,465.407], [1384.3,517.591]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.22,417.536], [1350.57,472.472], [1389.88,412.437], [1387.07,465.374]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.9,361.735], [1353.22,417.501], [1392.73,358.697], [1389.88,412.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.63,305.086], [1355.9,361.735], [1395.33,304.177], [1392.43,358.717]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1358.63,305.085], [1361.4,247.603], [1395.63,304.171], [1398.56,248.875]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[768.664,257.906], [769.945,298.952], [725.792,258.556], [727.247,297.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.945,298.953], [771.213,339.567], [727.247,297.819], [728.688,336.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.213,339.567], [772.466,379.706], [728.688,336.688], [730.113,375.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.467,379.732], [773.706,419.428], [730.114,375.144], [731.524,413.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.707,419.453], [774.933,458.715], [731.525,413.194], [732.919,450.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.933,458.74], [776.146,497.573], [732.92,450.844], [734.301,488.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.146,497.598], [777.346,536.01], [734.302,488.102], [735.668,524.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.346,536.034], [778.533,574.032], [735.668,524.972], [737.02,561.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.533,574.056], [779.707,611.646], [737.021,561.462], [738.359,597.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.708,611.67], [780.869,648.859], [738.36,597.576], [739.684,633.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.869,648.882], [782.018,685.677], [739.685,633.321], [740.996,668.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.018,685.677], [783.072,719.448], [740.996,668.68], [742.2,701.147]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[778.242,257.395], [779.511,299.842], [753.362,257.782], [754.741,299.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.511,299.842], [780.767,341.827], [754.741,299.169], [756.105,340.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.767,341.827], [782.007,383.305], [756.105,340.117], [757.453,380.582]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.008,383.331], [783.235,424.336], [757.453,380.608], [758.786,420.623]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.235,424.362], [784.448,464.902], [758.787,420.648], [760.105,460.221]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.449,464.928], [785.648,505.012], [760.106,460.246], [761.409,499.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.648,505.037], [786.834,544.672], [761.41,499.409], [762.699,538.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.835,544.697], [788.007,583.89], [762.7,538.143], [763.976,576.432]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.008,583.915], [789.167,622.674], [763.976,576.456], [765.238,614.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.168,622.698], [790.314,661.03], [765.239,614.356], [766.487,651.824]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.315,661.055], [791.449,698.967], [766.487,651.847], [767.722,688.914]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[794.03,256.818], [795.252,300.845], [767.211,257.244], [768.557,300.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.449,698.967], [792.489,733.753], [767.722,688.914], [768.855,722.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.252,300.845], [796.46,344.373], [768.557,300.104], [769.889,342.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.46,344.373], [797.653,387.356], [769.889,342.492], [771.204,384.363]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.654,387.384], [798.833,429.86], [771.205,384.39], [772.505,425.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.833,429.887], [799.998,471.864], [772.506,425.806], [773.791,466.722]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.999,471.891], [801.151,513.378], [773.792,466.748], [775.063,507.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.151,513.405], [802.289,554.411], [775.064,507.224], [776.32,547.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.29,554.437], [803.415,594.97], [776.321,547.243], [777.563,586.787]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.416,594.995], [804.528,635.064], [777.564,586.812], [778.792,625.914]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.528,635.089], [805.628,674.701], [778.793,625.939], [780.008,664.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.628,674.725], [806.715,713.888], [780.008,664.631], [781.21,702.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.715,713.888], [807.712,749.807], [781.21,702.87], [782.312,737.953]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[794.03,256.818], [795.252,300.845], [809.51,256.955], [810.629,300.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.252,300.845], [796.46,344.373], [810.629,300.607], [811.735,343.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.46,344.373], [797.653,387.356], [811.735,343.768], [812.829,386.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.654,387.384], [798.833,429.86], [812.829,386.422], [813.909,428.549]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.834,429.887], [799.999,471.864], [813.91,428.576], [814.978,470.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.999,471.891], [801.151,513.378], [814.978,470.239], [816.034,511.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.151,513.405], [802.289,554.411], [816.034,511.42], [817.078,552.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.29,554.437], [803.415,594.97], [817.078,552.127], [818.109,592.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.416,594.995], [818.11,592.368], [804.528,635.064], [819.13,632.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.529,635.089], [819.13,632.151], [805.628,674.7], [820.138,671.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.629,674.725], [820.139,671.485], [806.716,713.888], [821.135,710.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.716,713.888], [821.135,710.351], [807.712,749.807], [822.05,746.002]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[862.454,256.134], [863.3,302.034], [809.51,256.955], [810.629,300.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.3,302.034], [864.135,347.391], [810.629,300.607], [811.735,343.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.135,347.391], [864.959,392.158], [811.736,343.768], [812.829,386.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.96,392.187], [865.774,436.403], [812.829,386.422], [813.91,428.549]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.775,436.431], [866.579,480.107], [813.91,428.576], [814.978,470.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.58,480.135], [867.374,523.28], [814.979,470.239], [816.034,511.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.375,523.308], [868.16,565.932], [816.035,511.42], [817.078,552.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.16,565.959], [868.936,608.071], [817.078,552.127], [818.109,592.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.936,608.098], [869.702,649.708], [818.11,592.368], [819.13,632.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.703,649.734], [870.46,690.851], [819.13,632.151], [820.138,671.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.461,690.877], [871.209,731.508], [820.139,671.485], [821.135,710.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.209,731.508], [871.895,768.759], [821.135,710.351], [822.05,746.002]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[862.455,256.135], [863.3,302.034], [886.498,256.365], [887.183,301.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.3,302.034], [864.135,347.391], [887.183,301.634], [887.86,346.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.135,347.391], [864.96,392.158], [887.861,346.375], [888.529,390.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.96,392.187], [865.775,436.403], [888.529,390.57], [889.19,434.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.775,436.431], [866.579,480.107], [889.19,434.229], [889.843,477.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.58,480.135], [867.375,523.28], [889.843,477.361], [890.488,519.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.375,523.308], [868.16,565.932], [890.488,519.976], [891.125,562.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.16,565.959], [868.936,608.071], [891.125,562.083], [891.755,603.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.937,608.098], [869.703,649.708], [891.755,603.691], [892.377,644.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.703,649.734], [870.46,690.851], [892.378,644.81], [892.992,685.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.461,690.877], [871.209,731.508], [892.993,685.446], [893.6,725.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.209,731.508], [871.895,768.759], [893.6,725.585], [894.157,762.389]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[905.184,256.086], [905.764,302.12], [886.498,256.365], [887.183,301.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.763,302.12], [906.336,347.608], [887.183,301.634], [887.86,346.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.336,347.608], [906.901,392.503], [887.86,346.375], [888.529,390.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.902,392.531], [907.46,436.873], [888.529,390.57], [889.189,434.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.46,436.901], [908.011,480.699], [889.19,434.229], [889.842,477.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.012,480.727], [908.556,523.991], [889.843,477.361], [890.487,519.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.556,524.018], [909.094,566.758], [890.488,519.976], [891.125,562.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.095,566.785], [909.626,609.011], [891.125,562.083], [891.754,603.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.626,609.037], [910.152,650.757], [891.755,603.691], [892.377,644.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.152,650.784], [910.671,692.008], [892.377,644.81], [892.992,685.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.671,692.034], [911.184,732.77], [892.992,685.446], [893.6,725.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.184,732.77], [911.654,770.116], [893.6,725.585], [894.157,762.389]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[905.184,256.085], [905.763,302.12], [933.035,256.36], [933.433,301.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.763,302.12], [906.336,347.608], [933.433,301.643], [933.826,346.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.336,347.608], [906.901,392.503], [933.826,346.398], [934.215,390.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.901,392.531], [907.459,436.873], [934.215,390.606], [934.598,434.25]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.46,436.901], [908.011,480.699], [934.599,434.278], [934.977,477.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.011,480.726], [908.556,523.991], [934.978,477.423], [935.352,520.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.556,524.018], [909.094,566.758], [935.352,520.05], [935.722,562.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.094,566.785], [909.626,609.01], [935.722,562.17], [936.088,603.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.626,609.037], [910.151,650.757], [936.088,603.79], [936.449,644.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.152,650.784], [910.671,692.008], [936.449,644.92], [936.806,685.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.671,692.034], [911.184,732.77], [936.807,685.568], [937.159,725.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.184,732.77], [911.654,770.116], [937.159,725.717], [937.483,762.531]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1013.93,253.819], [1013.81,306.055], [946.473,254.863], [946.816,304.242]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.81,306.055], [1013.69,357.583], [946.816,304.242], [947.155,352.991]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.69,357.584], [1013.58,408.356], [947.155,352.991], [947.489,401.062]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.58,408.388], [1013.47,458.452], [947.49,401.092], [947.819,448.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.47,458.483], [1013.36,507.853], [947.82,448.557], [948.145,495.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.36,507.884], [1013.25,556.575], [948.145,495.399], [948.467,541.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.25,556.605], [1013.14,604.63], [948.467,541.63], [948.784,587.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.14,604.66], [1013.03,652.032], [948.784,587.263], [949.097,632.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.03,652.062], [1012.93,698.795], [949.097,632.308], [949.406,676.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.93,698.825], [1012.82,744.932], [949.406,676.776], [949.711,720.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.82,744.961], [1012.72,790.455], [949.711,720.68], [950.013,764.002]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.72,790.455], [1012.63,832.102], [950.013,764.002], [950.289,803.687]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1040.49,252.939], [1040.16,307.583], [997.389,253.622], [997.39,306.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1040.16,307.583], [1039.85,361.452], [997.39,306.398], [997.39,358.452]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.85,361.452], [1039.54,414.497], [997.39,358.452], [997.391,409.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.54,414.53], [1039.23,466.801], [997.391,409.767], [997.391,460.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.23,466.834], [1038.93,518.348], [997.391,460.359], [997.391,510.211]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.93,518.38], [1038.63,569.153], [997.391,510.242], [997.391,559.401]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.63,569.186], [1038.34,619.234], [997.391,559.432], [997.392,607.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.34,619.266], [1038.05,668.605], [997.392,607.943], [997.392,655.758]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.05,668.636], [1037.76,717.281], [997.392,655.788], [997.393,702.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.76,717.311], [1037.48,765.276], [997.393,702.982], [997.393,749.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.48,765.307], [1037.2,812.606], [997.393,749.537], [997.393,795.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.2,812.606], [1036.95,855.883], [997.393,795.438], [997.393,837.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.58,777.912], [1090.91,826.324], [1051.57,762.438], [1051.19,809.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.91,826.324], [1090.3,870.603], [1051.19,809.484], [1050.85,852.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.65,628.328], [1092.95,678.882], [1052.72,617.205], [1052.33,666.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.95,678.914], [1092.26,728.739], [1052.33,666.298], [1051.95,714.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.26,728.77], [1091.58,777.881], [1051.95,714.704], [1051.57,762.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.08,524.899], [1094.36,576.962], [1053.52,516.899], [1053.12,567.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.36,576.995], [1093.65,628.295], [1053.11,567.41], [1052.72,617.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.3,363.859], [1096.55,418.314], [1054.75,360.906], [1054.33,413.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.55,418.349], [1095.81,471.989], [1054.33,413.663], [1053.92,465.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.81,472.023], [1095.08,524.866], [1053.92,465.655], [1053.52,516.866]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1098.84,252.391], [1098.07,308.534], [1055.61,253.064], [1055.18,307.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.07,308.534], [1097.3,363.858], [1055.18,307.367], [1054.75,360.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.91,826.324], [1106.63,820.577], [1090.3,870.603], [1105.92,864.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.58,777.912], [1107.4,772.63], [1090.91,826.324], [1106.63,820.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.95,678.914], [1108.99,674.607], [1092.26,728.739], [1108.19,723.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.26,728.77], [1108.19,723.969], [1091.58,777.881], [1107.4,772.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.65,628.328], [1092.95,678.882], [1109.79,624.53], [1108.99,674.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.08,524.899], [1094.36,576.962], [1111.45,522.166], [1110.62,573.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.36,576.995], [1093.65,628.295], [1110.61,573.721], [1109.8,624.497]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.81,472.023], [1095.08,524.866], [1112.29,469.847], [1111.45,522.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.55,418.349], [1095.81,471.989], [1113.15,416.747], [1112.29,469.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.07,308.533], [1097.3,363.858], [1114.9,308.135], [1114.02,362.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.3,363.859], [1096.55,418.314], [1114.02,362.85], [1113.15,416.714]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1098.84,252.391], [1098.07,308.534], [1115.8,252.621], [1114.9,308.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.92,853.454], [1184.63,899.703], [1106.63,820.577], [1105.92,864.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.78,751.457], [1187.34,802.823], [1108.19,723.969], [1107.41,772.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.34,802.855], [1185.92,853.454], [1107.4,772.63], [1106.63,820.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.24,699.275], [1188.78,751.424], [1108.99,674.607], [1108.19,723.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.72,646.289], [1190.24,699.241], [1109.8,624.53], [1108.99,674.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.23,592.482], [1191.72,646.255], [1110.62,573.722], [1109.8,624.497]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.76,537.834], [1193.23,592.447], [1111.45,522.166], [1110.62,573.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.89,425.934], [1196.31,482.289], [1113.15,416.748], [1112.29,469.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.31,482.325], [1194.76,537.799], [1112.29,469.847], [1111.45,522.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.49,368.642], [1197.89,425.898], [1114.02,362.85], [1113.15,416.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.12,310.425], [1199.49,368.641], [1114.9,308.135], [1114.02,362.849]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1202.78,251.299], [1201.12,310.425], [1115.8,252.621], [1114.9,308.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.92,853.454], [1184.63,899.702], [1219.94,839.534], [1218.45,884.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.34,802.855], [1185.92,853.454], [1221.58,790.055], [1219.94,839.534]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.78,751.457], [1187.34,802.823], [1223.23,739.813], [1221.58,790.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.24,699.275], [1188.78,751.424], [1224.91,688.823], [1223.23,739.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.72,646.289], [1190.24,699.241], [1226.62,637.067], [1224.92,688.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.23,592.482], [1191.72,646.255], [1228.35,584.529], [1226.62,637.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.76,537.834], [1193.23,592.447], [1230.11,531.19], [1228.35,584.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.31,482.325], [1194.76,537.799], [1231.9,477.032], [1230.11,531.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.89,425.934], [1196.31,482.289], [1233.71,422.037], [1231.9,476.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.49,368.642], [1197.89,425.898], [1235.55,366.184], [1233.71,422.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.12,310.425], [1199.49,368.641], [1237.43,309.453], [1235.55,366.183]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1202.78,251.299], [1201.12,310.425], [1239.33,251.86], [1237.43,309.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.81,850.941], [1247.09,897.008], [1219.94,839.534], [1218.45,884.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.7,800.544], [1248.81,850.941], [1221.58,790.055], [1219.94,839.534]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.61,749.354], [1250.7,800.511], [1223.23,739.813], [1221.58,790.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.55,697.387], [1252.61,749.322], [1224.91,688.823], [1223.23,739.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.51,644.623], [1254.55,697.353], [1226.62,637.067], [1224.92,688.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.51,591.045], [1256.52,644.589], [1228.35,584.529], [1226.62,637.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.55,536.633], [1258.52,591.01], [1230.11,531.19], [1228.35,584.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.61,481.368], [1260.55,536.598], [1231.9,477.032], [1230.11,531.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.7,425.23], [1262.61,481.333], [1233.71,422.037], [1231.9,476.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.83,368.198], [1264.7,425.194], [1235.55,366.184], [1233.71,422.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.99,310.249], [1266.83,368.197], [1237.43,309.453], [1235.55,366.183]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1271.19,251.4], [1268.99,310.249], [1239.33,251.86], [1237.43,309.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.81,850.94], [1247.09,897.007], [1289.14,833.751], [1287.2,878.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.7,800.543], [1248.81,850.94], [1291.26,784.739], [1289.14,833.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.61,749.354], [1250.7,800.511], [1293.41,734.978], [1291.26,784.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.55,697.386], [1252.61,749.321], [1295.59,684.484], [1293.41,734.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.51,644.622], [1254.55,697.353], [1297.8,633.24], [1295.59,684.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.51,591.044], [1256.52,644.589], [1300.05,581.229], [1297.8,633.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.55,536.633], [1258.52,591.01], [1302.33,528.434], [1300.05,581.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.61,481.368], [1260.55,536.598], [1304.64,474.838], [1302.33,528.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.7,425.229], [1262.61,481.332], [1307,420.421], [1304.65,474.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.83,368.197], [1264.7,425.194], [1309.38,365.164], [1307,420.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.99,310.249], [1266.83,368.197], [1311.81,309.05], [1309.38,365.165]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1271.19,251.4], [1268.99,310.249], [1314.27,252.092], [1311.81,309.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.18,838.244], [1289.14,833.752], [1299.15,883.391], [1287.2,878.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.4,788.869], [1291.26,784.739], [1301.18,838.244], [1289.14,833.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.66,738.734], [1293.41,734.978], [1303.41,788.838], [1291.26,784.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.95,687.854], [1295.59,684.484], [1305.66,738.703], [1293.41,734.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.28,636.213], [1297.8,633.24], [1307.95,687.822], [1295.59,684.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1312.64,583.792], [1300.05,581.229], [1310.28,636.18], [1297.8,633.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.96,838.148], [1298.93,883.288], [1342.77,820.022], [1340.54,863.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.03,530.575], [1302.33,528.434], [1312.64,583.759], [1300.05,581.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.18,788.78], [1300.96,838.148], [1345.22,772.12], [1342.77,820.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.46,476.542], [1315.03,530.541], [1304.64,474.838], [1302.33,528.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.43,738.654], [1303.18,788.749], [1347.7,723.505], [1345.22,772.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1319.93,421.676], [1317.46,476.508], [1307,420.421], [1304.65,474.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.72,687.782], [1305.44,738.622], [1350.22,674.19], [1347.7,723.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.44,365.956], [1319.93,421.641], [1309.38,365.164], [1307,420.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.04,636.149], [1307.72,687.75], [1352.77,624.162], [1350.22,674.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.74,309.356], [1322.2,365.939], [1311.81,309.05], [1309.38,365.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1312.4,583.737], [1310.05,636.116], [1355.36,573.405], [1352.77,624.131]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1327.57,251.911], [1324.99,309.363], [1314.27,252.092], [1311.81,309.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.8,530.529], [1312.4,583.704], [1357.99,521.902], [1355.36,573.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.23,476.506], [1314.8,530.495], [1360.66,469.637], [1357.99,521.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1319.69,421.649], [1317.23,476.471], [1363.36,416.593], [1360.66,469.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.2,365.939], [1319.69,421.614], [1366.11,362.752], [1363.37,416.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.74,309.356], [1322.2,365.939], [1368.55,308.104], [1365.77,362.771]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1327.33,251.915], [1324.74,309.356], [1371.73,252.642], [1368.9,308.096]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[787.044,259.176], [788.22,299.001], [750.945,259.442], [752.26,297.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.22,299.001], [789.384,338.408], [752.26,297.47], [753.563,335.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.384,338.408], [790.533,377.355], [753.563,335.117], [754.85,372.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.534,377.38], [791.671,415.898], [754.851,372.367], [756.125,409.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.672,415.922], [792.797,454.02], [756.126,409.225], [757.387,445.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.797,454.043], [793.91,491.726], [757.387,445.698], [758.635,481.768]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.911,491.75], [795.011,529.025], [758.636,481.791], [759.871,517.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.012,529.048], [796.1,565.922], [759.871,517.511], [761.093,552.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.101,565.945], [797.178,602.424], [761.094,552.863], [762.304,587.831]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[797.179,602.447], [798.244,638.538], [762.304,587.853], [763.502,622.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.245,638.56], [799.299,674.269], [763.502,622.487], [764.688,656.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.299,674.269], [800.267,707.044], [764.688,656.748], [765.776,688.208]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[792.483,258.976], [793.667,300.155], [771.58,259.134], [772.852,299.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.667,300.155], [794.839,340.886], [772.852,299.244], [774.109,338.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.839,340.886], [795.996,381.126], [774.109,338.93], [775.352,378.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.997,381.151], [797.141,420.934], [775.353,378.174], [776.582,416.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[797.142,420.959], [798.273,460.293], [776.583,416.984], [777.799,455.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.273,460.317], [799.392,499.209], [777.799,455.365], [779.002,493.303]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.393,499.233], [800.499,537.69], [779.003,493.327], [780.192,530.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[800.499,537.714], [801.593,575.743], [780.193,530.875], [781.369,567.992]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[803.374,258.748], [804.537,301.466], [780.889,258.922], [782.151,300.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.594,575.767], [802.675,613.376], [781.37,568.016], [782.533,604.733]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.537,301.466], [805.687,343.701], [782.151,300.463], [783.4,341.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.676,613.4], [803.746,650.595], [782.534,604.756], [783.685,641.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.687,343.701], [806.823,385.409], [783.4,341.549], [784.633,382.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[803.746,650.619], [804.804,687.407], [783.686,641.103], [784.825,677.039]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.824,385.435], [807.946,426.652], [784.634,382.161], [785.853,422.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.804,687.407], [805.775,721.163], [784.825,677.04], [785.87,710.022]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.947,426.678], [809.056,467.412], [785.854,422.307], [787.059,461.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.057,467.437], [810.153,507.697], [787.06,461.996], [788.251,501.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.154,507.722], [811.237,547.516], [788.252,501.235], [789.43,540.007]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.238,547.541], [812.309,586.876], [789.431,540.031], [790.596,578.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.31,586.901], [813.368,625.786], [790.596,578.393], [791.748,616.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.369,625.81], [814.416,664.253], [791.749,616.327], [792.888,653.817]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.417,664.277], [815.451,702.285], [792.889,653.841], [794.016,690.918]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.451,702.285], [816.401,737.146], [794.016,690.918], [795.049,724.935]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[803.374,258.748], [804.537,301.466], [819.155,258.795], [820.216,301.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.537,301.466], [805.687,343.701], [820.216,301.198], [821.265,343.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.688,343.701], [806.823,385.409], [821.265,343.126], [822.3,384.534]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.824,385.435], [807.946,426.652], [822.301,384.56], [823.325,425.485]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.947,426.678], [809.056,467.412], [823.325,425.51], [824.337,465.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.057,467.437], [810.153,507.697], [824.338,465.984], [825.338,505.964]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.154,507.722], [811.237,547.516], [825.339,505.99], [826.327,545.51]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.238,547.541], [826.328,545.535], [812.309,586.876], [827.305,584.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.31,586.901], [827.306,584.629], [813.369,625.786], [828.272,623.254]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.369,625.81], [828.273,623.279], [814.416,664.253], [829.228,661.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.417,664.277], [829.229,661.491], [815.452,702.285], [830.173,699.251]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.452,702.285], [830.173,699.251], [816.401,737.146], [831.04,733.887]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[863.921,258.457], [864.758,303.14], [819.155,258.795], [820.216,301.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.758,303.14], [865.586,347.293], [820.216,301.198], [821.265,343.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.586,347.293], [866.402,390.873], [821.265,343.126], [822.301,384.534]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.402,390.9], [867.209,433.943], [822.301,384.56], [823.325,425.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.209,433.97], [868.006,476.486], [823.326,425.51], [824.337,465.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.006,476.512], [868.793,518.511], [824.338,465.984], [825.338,505.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.794,518.537], [869.571,560.028], [825.339,505.99], [826.327,545.51]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.571,560.054], [870.339,601.046], [826.328,545.536], [827.305,584.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.34,601.072], [871.098,641.574], [827.306,584.629], [828.272,623.254]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.099,641.6], [871.849,681.621], [828.273,623.279], [829.228,661.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.849,681.646], [872.59,721.195], [829.229,661.491], [830.173,699.251]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.59,721.195], [873.269,757.453], [830.173,699.251], [831.04,733.887]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[863.922,258.457], [864.759,303.14], [888.773,258.536], [889.446,302.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.758,303.14], [865.586,347.293], [889.446,302.686], [890.111,346.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.586,347.293], [866.402,390.873], [890.112,346.32], [890.769,389.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.403,390.9], [867.209,433.943], [890.769,389.419], [891.418,431.967]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.21,433.97], [868.006,476.485], [891.418,431.994], [892.059,474.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.007,476.512], [868.793,518.511], [892.059,474.054], [892.693,515.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.794,518.537], [869.571,560.028], [892.693,515.608], [893.319,556.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.572,560.054], [870.339,601.046], [893.319,556.666], [893.937,597.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.34,601.072], [871.099,641.574], [893.938,597.235], [894.548,637.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.099,641.6], [871.849,681.621], [894.549,637.326], [895.152,676.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.849,681.646], [872.59,721.195], [895.153,676.946], [895.749,716.078]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.59,721.195], [873.27,757.453], [895.749,716.078], [896.297,751.959]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[904.745,258.421], [905.329,303.351], [888.773,258.536], [889.446,302.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.329,303.351], [905.906,347.747], [889.446,302.686], [890.111,346.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.907,347.747], [906.477,391.563], [890.111,346.32], [890.768,389.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.477,391.59], [907.04,434.863], [890.768,389.419], [891.417,431.967]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.04,434.89], [907.596,477.631], [891.417,431.994], [892.058,474.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.596,477.658], [908.145,519.875], [892.059,474.054], [892.692,515.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.146,519.902], [908.688,561.606], [892.692,515.608], [893.318,556.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.689,561.633], [909.224,602.833], [893.318,556.666], [893.937,597.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.225,602.859], [909.754,643.565], [893.937,597.235], [894.548,637.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.754,643.59], [910.278,683.81], [894.548,637.326], [895.152,676.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.278,683.835], [910.795,723.578], [895.152,676.946], [895.749,716.078]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.795,723.578], [911.269,760.011], [895.749,716.078], [896.296,751.959]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[904.745,258.42], [905.329,303.351], [933.76,258.515], [934.156,302.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.329,303.351], [905.906,347.747], [934.156,302.808], [934.547,346.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.907,347.747], [906.477,391.563], [934.547,346.581], [934.933,389.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.477,391.59], [907.04,434.863], [934.933,389.817], [935.315,432.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.04,434.89], [907.596,477.631], [935.315,432.525], [935.692,474.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.596,477.658], [908.145,519.875], [935.692,474.714], [936.064,516.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.146,519.902], [908.688,561.606], [936.064,516.395], [936.432,557.55]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.688,561.633], [909.224,602.833], [936.432,557.576], [936.796,598.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.225,602.859], [909.754,643.565], [936.796,598.266], [937.155,638.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.754,643.59], [910.277,683.81], [937.155,638.474], [937.51,678.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.278,683.835], [910.795,723.578], [937.51,678.208], [937.861,717.453]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.795,723.578], [911.268,760.011], [937.861,717.453], [938.182,753.435]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[993.356,257.496], [993.385,308.662], [935.608,257.93], [936.026,306.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.385,308.662], [993.414,359.131], [936.026,306.167], [936.439,353.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.414,359.131], [993.443,408.854], [936.439,353.784], [936.846,400.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.443,408.886], [993.471,457.909], [936.847,400.765], [937.249,447.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.471,457.94], [993.499,506.279], [937.249,447.123], [937.645,492.841]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.499,506.31], [993.526,553.979], [937.646,492.87], [938.037,537.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.526,554.009], [993.553,601.021], [938.037,538.017], [938.424,582.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.553,601.051], [993.579,647.42], [938.424,582.576], [938.805,626.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.579,647.449], [993.606,693.189], [938.805,626.56], [939.182,669.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.606,693.218], [993.632,738.34], [939.182,669.978], [939.554,712.815]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.632,738.368], [993.657,782.886], [939.554,712.842], [939.921,755.136]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[993.657,782.886], [993.68,823.636], [939.921,755.136], [940.257,793.877]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1012.61,257.143], [1012.49,310.69], [975.745,257.428], [975.902,309.055]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.49,310.69], [1012.38,363.472], [975.902,309.055], [976.057,359.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.38,363.472], [1012.27,415.44], [976.057,359.972], [976.21,410.13]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.27,415.473], [1012.16,466.676], [976.21,410.161], [976.36,459.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.16,466.708], [1012.06,517.165], [976.36,459.639], [976.509,508.388]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.06,517.197], [1011.95,566.922], [976.509,508.419], [976.655,556.487]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.95,566.953], [1011.85,615.963], [976.655,556.517], [976.8,603.918]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.85,615.994], [1011.74,664.304], [976.8,603.948], [976.942,650.694]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.74,664.335], [1011.64,711.96], [976.942,650.723], [977.082,696.829]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.64,711.99], [1011.54,758.945], [977.082,696.858], [977.221,742.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.54,758.974], [1011.44,805.272], [977.221,742.366], [977.357,787.229]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.44,805.272], [1011.35,847.629], [977.357,787.229], [977.482,828.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1061.63,675.842], [1061.16,724.746], [1026.6,662.402], [1026.39,709.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1061.16,724.777], [1060.7,772.972], [1026.39,709.841], [1026.19,756.587]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1060.7,773.003], [1060.25,820.506], [1026.19,756.617], [1025.99,802.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1060.25,820.506], [1059.83,863.948], [1025.99,802.711], [1025.81,844.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.08,419.973], [1063.57,472.663], [1027.67,414.717], [1027.45,465.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.57,472.696], [1063.08,524.594], [1027.45,465.704], [1027.23,515.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.08,524.627], [1062.59,575.752], [1027.23,515.949], [1027.02,565.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1062.59,575.784], [1062.11,626.152], [1027.02,565.471], [1026.81,614.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1062.1,626.183], [1061.63,675.811], [1026.81,614.283], [1026.6,662.371]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1065.64,256.901], [1065.11,312.077], [1028.35,257.183], [1028.12,310.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.11,312.077], [1064.59,366.439], [1028.12,310.457], [1027.9,362.974]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.59,366.44], [1064.08,419.939], [1027.9,362.974], [1027.67,414.685]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1060.7,773.003], [1077.89,768.348], [1060.25,820.506], [1077.32,815.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1060.25,820.506], [1077.32,815.452], [1059.83,863.948], [1076.8,858.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1061.63,675.842], [1079.07,672.023], [1061.16,724.746], [1078.48,720.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1061.16,724.777], [1078.48,720.534], [1060.7,772.972], [1077.89,768.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1062.59,575.784], [1062.11,626.152], [1080.27,572.852], [1079.66,622.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1062.11,626.183], [1079.66,622.801], [1061.63,675.811], [1079.07,671.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.57,472.696], [1063.08,524.594], [1081.51,470.708], [1080.89,522.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.08,524.627], [1062.59,575.752], [1080.89,522.16], [1080.27,572.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.59,366.44], [1064.08,419.939], [1082.79,365.454], [1082.15,418.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.08,419.973], [1063.57,472.663], [1082.15,418.478], [1081.51,470.675]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1065.64,256.901], [1065.11,312.077], [1084.11,256.981], [1083.45,311.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.11,312.077], [1064.59,366.439], [1083.45,311.616], [1082.79,365.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1147.55,800.602], [1146.42,850.457], [1077.89,768.348], [1077.32,815.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1146.42,850.458], [1145.38,896.017], [1077.32,815.452], [1076.8,858.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1148.71,749.948], [1147.56,800.57], [1078.48,720.534], [1077.9,768.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1151.07,646.265], [1149.88,698.476], [1079.66,622.801], [1079.07,671.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1149.88,698.509], [1148.71,749.916], [1079.07,672.023], [1078.48,720.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.51,539.291], [1152.28,593.165], [1080.89,522.16], [1080.27,572.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.28,593.2], [1151.07,646.232], [1080.27,572.852], [1079.66,622.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.76,484.521], [1153.51,539.257], [1081.51,470.708], [1080.89,522.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.32,372.307], [1156.03,428.831], [1082.79,365.454], [1082.15,418.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.03,428.866], [1154.76,484.485], [1082.15,418.478], [1081.51,470.675]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1159.96,256.422], [1158.63,314.821], [1084.11,256.981], [1083.45,311.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.63,314.821], [1157.32,372.307], [1083.45,311.616], [1082.79,365.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1146.42,850.458], [1145.38,896.017], [1184.27,838.082], [1183,882.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1147.55,800.602], [1146.42,850.457], [1185.67,789.197], [1184.27,838.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1148.71,749.948], [1147.56,800.57], [1187.08,739.543], [1185.67,789.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1149.88,698.509], [1148.71,749.916], [1188.52,689.137], [1187.08,739.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1151.07,646.265], [1149.88,698.476], [1189.98,637.96], [1188.52,689.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.28,593.2], [1151.07,646.232], [1191.46,585.996], [1189.98,637.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.51,539.291], [1152.28,593.165], [1192.97,533.224], [1191.46,585.962]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.76,484.521], [1153.51,539.257], [1194.5,479.627], [1192.97,533.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.03,428.866], [1154.76,484.485], [1196.05,425.185], [1194.5,479.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.32,372.307], [1156.03,428.831], [1197.63,369.878], [1196.05,425.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.63,314.821], [1157.32,372.307], [1199.23,313.684], [1197.63,369.877]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1159.96,256.422], [1158.63,314.821], [1200.86,256.62], [1199.23,313.684]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.83,850.355], [1208.35,895.908], [1184.27,838.083], [1183,882.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.45,800.508], [1209.83,850.355], [1185.67,789.197], [1184.27,838.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.09,749.862], [1211.45,800.476], [1187.08,739.544], [1185.67,789.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.77,698.431], [1213.1,749.83], [1188.52,689.137], [1187.08,739.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.46,646.197], [1214.77,698.398], [1189.98,637.961], [1188.52,689.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.19,593.14], [1216.46,646.163], [1191.46,585.996], [1189.98,637.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.94,539.241], [1218.19,593.106], [1192.97,533.224], [1191.46,585.962]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.72,484.48], [1219.94,539.207], [1194.5,479.627], [1192.97,533.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.53,428.836], [1221.72,484.445], [1196.05,425.185], [1194.5,479.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.37,372.287], [1223.53,428.8], [1197.63,369.878], [1196.05,425.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.23,314.811], [1225.37,372.287], [1199.23,313.684], [1197.63,369.877]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1229.13,256.423], [1227.23,314.811], [1200.86,256.62], [1199.23,313.684]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.83,850.355], [1208.35,895.907], [1255.33,834.937], [1253.58,879.403]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.45,800.508], [1209.83,850.355], [1257.24,786.298], [1255.33,834.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.09,749.862], [1211.45,800.476], [1259.19,736.9], [1257.24,786.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.77,698.431], [1213.1,749.829], [1261.16,686.756], [1259.19,736.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.46,646.196], [1214.77,698.398], [1263.16,635.851], [1261.16,686.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.19,593.139], [1216.46,646.163], [1265.2,584.166], [1263.16,635.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.94,539.241], [1218.19,593.106], [1267.26,531.684], [1265.2,584.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.72,484.479], [1219.94,539.206], [1269.36,478.385], [1267.27,531.65]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.53,428.835], [1221.72,484.445], [1271.49,424.25], [1269.36,478.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.37,372.287], [1223.53,428.8], [1273.66,369.261], [1271.49,424.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.23,314.811], [1225.37,372.287], [1275.86,313.396], [1273.66,369.261]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1229.13,256.423], [1227.23,314.811], [1278.09,256.67], [1275.86,313.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.15,839.814], [1255.33,834.938], [1264.31,884.624], [1253.58,879.403]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.16,790.792], [1257.24,786.298], [1266.15,839.814], [1255.33,834.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.2,740.998], [1259.19,736.9], [1268.16,790.761], [1257.24,786.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.28,690.447], [1261.16,686.757], [1270.2,740.967], [1259.19,736.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.38,639.121], [1263.16,635.851], [1272.28,690.415], [1261.16,686.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.52,587.002], [1265.2,584.166], [1274.39,639.089], [1263.16,635.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.7,534.072], [1267.26,531.684], [1276.52,586.969], [1265.2,584.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.95,839.71], [1264.11,884.513], [1313.62,823.318], [1311.51,866.96]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.96,790.696], [1265.95,839.71], [1315.92,775.593], [1313.62,823.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.9,480.31], [1278.7,534.038], [1269.36,478.385], [1267.27,531.65]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270,740.911], [1267.96,790.665], [1318.25,727.138], [1315.92,775.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.14,425.699], [1280.9,480.276], [1271.49,424.25], [1269.36,478.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.07,690.369], [1270,740.88], [1320.62,677.968], [1318.25,727.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.42,370.217], [1283.15,425.664], [1273.66,369.261], [1271.49,424.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.18,639.052], [1272.08,690.337], [1323.02,628.066], [1320.62,677.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.52,313.834], [1285.21,370.197], [1275.86,313.396], [1273.66,369.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.32,586.942], [1274.18,639.019], [1325.46,577.416], [1323.03,628.034]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1290.09,256.592], [1287.74,313.843], [1278.09,256.67], [1275.86,313.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.49,534.021], [1276.32,586.909], [1327.94,526.001], [1325.47,577.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.69,480.269], [1278.49,533.987], [1330.46,473.803], [1327.94,525.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.93,425.668], [1280.69,480.235], [1333.01,420.805], [1330.46,473.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.21,370.196], [1282.93,425.633], [1335.6,366.988], [1333.01,420.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.52,313.834], [1285.21,370.197], [1337.85,312.342], [1335.21,367.008]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1289.87,256.594], [1287.52,313.833], [1340.91,256.855], [1338.24,312.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.13,812.386], [1285.24,855.25], [1319.61,801.611], [1317.55,843.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.19,765.525], [1287.13,812.386], [1321.86,755.603], [1319.61,801.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.29,717.96], [1289.19,765.495], [1324.14,708.918], [1321.86,755.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.41,669.707], [1291.29,717.93], [1326.46,661.571], [1324.14,708.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.57,620.75], [1293.42,669.676], [1328.81,613.548], [1326.46,661.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.76,571.075], [1295.57,620.719], [1331.19,564.833], [1328.81,613.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.98,520.664], [1297.76,571.043], [1333.61,515.413], [1331.19,564.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.24,469.502], [1299.98,520.632], [1336.06,465.272], [1333.61,515.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.53,417.572], [1302.24,469.47], [1338.55,414.393], [1336.07,465.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.85,364.856], [1304.53,417.539], [1341.08,362.76], [1338.55,414.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.21,311.337], [1306.85,364.856], [1343.64,310.357], [1341.08,362.76]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1311.6,257.029], [1309.21,311.337], [1346.24,257.2], [1343.64,310.357]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[805.814,260.247], [806.882,298.959], [776.18,260.132], [777.355,297.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[806.882,298.959], [807.938,337.266], [777.355,297.048], [778.519,333.596]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.938,337.266], [808.982,375.127], [778.519,333.596], [779.67,369.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.983,375.15], [810.016,412.596], [779.671,369.76], [780.81,405.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.016,412.619], [811.038,449.656], [780.81,405.546], [781.937,440.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.038,449.679], [812.049,486.315], [781.938,440.959], [783.053,475.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.049,486.338], [813.049,522.578], [783.054,476.005], [784.158,510.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.049,522.601], [814.038,558.452], [784.158,510.69], [785.251,544.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.039,558.474], [815.017,593.943], [785.251,545.02], [786.333,578.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.017,593.965], [815.985,629.057], [786.333,579], [787.404,612.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.986,629.079], [816.943,663.8], [787.404,612.634], [788.464,645.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.943,663.8], [817.822,695.67], [788.464,645.909], [789.437,676.464]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[807.366,260.331], [808.46,300.344], [790.277,260.263], [791.438,299.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.46,300.344], [809.543,339.924], [791.438,299.208], [792.587,337.743]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.543,339.924], [810.613,379.028], [792.587,337.743], [793.722,375.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.613,379.052], [811.671,417.713], [793.723,375.851], [794.846,413.515]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[813.628,260.428], [814.726,301.93], [795.316,260.352], [796.489,300.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.672,417.738], [812.717,455.963], [794.847,413.539], [795.957,450.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.726,301.93], [815.812,342.966], [796.489,300.68], [797.65,340.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.718,455.987], [813.752,493.784], [795.958,450.813], [797.057,487.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.812,342.966], [816.884,383.492], [797.65,340.568], [798.796,379.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.753,493.808], [814.775,531.185], [797.057,487.681], [798.144,524.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.776,531.208], [815.787,568.17], [798.144,524.148], [799.219,560.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.885,383.518], [817.944,423.567], [798.797,379.998], [799.93,418.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.787,568.194], [816.787,604.749], [799.22,560.222], [800.283,595.886]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.945,423.593], [818.992,463.175], [799.931,418.978], [801.051,457.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.788,604.772], [817.777,640.926], [800.284,595.909], [801.336,631.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.992,463.2], [820.027,502.322], [801.052,457.515], [802.159,495.594]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.778,640.949], [818.756,676.709], [801.337,631.214], [802.377,666.122]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.028,502.347], [821.051,541.018], [802.16,495.618], [803.255,533.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.756,676.709], [819.654,709.523], [802.377,666.123], [803.333,698.163]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.052,541.043], [822.063,579.27], [803.256,533.292], [804.339,570.523]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.064,579.294], [823.063,617.086], [804.34,570.546], [805.411,607.364]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.064,617.11], [824.052,654.472], [805.411,607.387], [806.47,643.798]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.053,654.496], [825.03,691.437], [806.471,643.821], [807.519,679.832]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.03,691.437], [825.927,725.322], [807.519,679.832], [808.48,712.874]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[813.628,260.428], [814.726,301.93], [829.586,260.411], [830.582,301.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.726,301.93], [815.812,342.966], [830.582,301.656], [831.568,342.439]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.812,342.966], [816.884,383.492], [831.568,342.44], [832.541,382.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.885,383.518], [817.944,423.567], [832.541,382.745], [833.503,422.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.945,423.593], [818.992,463.175], [833.503,422.579], [834.454,461.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.993,463.2], [820.028,502.322], [834.455,461.951], [835.394,500.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.028,502.347], [835.395,500.87], [821.051,541.018], [836.324,539.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.052,541.043], [836.324,539.341], [822.063,579.27], [837.242,577.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.064,579.294], [837.243,577.374], [823.064,617.086], [838.151,614.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.064,617.11], [838.151,614.976], [824.053,654.472], [839.049,652.13]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.053,654.496], [839.049,652.153], [825.031,691.437], [839.937,688.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.031,691.437], [839.937,688.891], [825.927,725.322], [840.751,722.591]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[866.372,260.558], [867.193,304.09], [829.586,260.411], [830.582,301.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.193,304.09], [868.004,347.107], [830.582,301.656], [831.568,342.439]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.004,347.107], [868.805,389.565], [831.568,342.439], [832.541,382.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.806,389.592], [869.597,431.527], [832.541,382.745], [833.503,422.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.597,431.553], [870.378,472.975], [833.504,422.579], [834.454,461.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.379,473.001], [871.151,513.92], [834.455,461.951], [835.394,500.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.151,513.946], [871.914,554.37], [835.395,500.87], [836.324,539.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.914,554.395], [872.668,594.334], [836.324,539.341], [837.242,577.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.668,594.359], [873.413,633.82], [837.243,577.374], [838.151,614.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.413,633.845], [874.149,672.839], [838.151,614.976], [839.049,652.13]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.149,672.863], [874.876,711.396], [839.049,652.153], [839.937,688.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.876,711.396], [875.542,746.723], [839.937,688.891], [840.751,722.591]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[866.372,260.559], [867.193,304.091], [891.79,260.53], [892.445,303.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.193,304.09], [868.004,347.107], [892.445,303.622], [893.092,346.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.005,347.107], [868.805,389.565], [893.093,346.209], [893.732,388.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.806,389.592], [869.597,431.527], [893.732,388.275], [894.364,429.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.597,431.553], [870.379,472.975], [894.364,429.827], [894.988,470.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.379,473.001], [871.151,513.92], [894.988,470.877], [895.605,511.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.152,513.946], [871.914,554.37], [895.605,511.432], [896.214,551.477]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.915,554.395], [872.668,594.334], [896.214,551.502], [896.816,591.071]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.669,594.359], [873.413,633.82], [896.816,591.096], [897.411,630.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.413,633.845], [897.411,630.221], [874.149,672.839], [897.999,668.862]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.149,672.863], [897.999,668.886], [874.876,711.396], [898.58,707.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.876,711.396], [898.58,707.076], [875.543,746.723], [899.112,742.091]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[905.072,260.581], [905.655,304.461], [891.789,260.53], [892.445,303.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.655,304.461], [906.231,347.818], [892.445,303.622], [893.092,346.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.232,347.818], [906.8,390.606], [893.092,346.209], [893.731,388.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.801,390.633], [907.363,432.891], [893.732,388.275], [894.363,429.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.363,432.918], [907.918,474.655], [894.364,429.827], [894.987,470.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.918,474.681], [908.466,515.907], [894.988,470.877], [895.604,511.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.466,515.933], [909.008,556.656], [895.604,511.432], [896.213,551.477]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.008,556.682], [909.543,596.913], [896.214,551.502], [896.815,591.071]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.543,596.938], [910.072,636.684], [896.816,591.096], [897.41,630.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.072,636.71], [910.594,675.981], [897.411,630.221], [897.998,668.862]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.594,676.006], [911.11,714.81], [897.999,668.886], [898.579,707.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.11,714.81], [911.583,750.383], [898.579,707.076], [899.112,742.091]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[905.072,260.581], [905.655,304.461], [934.958,260.547], [935.348,303.897]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.655,304.461], [906.231,347.818], [935.348,303.897], [935.733,346.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.231,347.818], [906.8,390.606], [935.733,346.737], [936.113,389.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.801,390.633], [907.362,432.891], [936.113,389.048], [936.489,430.814]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.363,432.918], [907.918,474.655], [936.489,430.841], [936.86,472.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.918,474.681], [908.466,515.907], [936.861,472.124], [937.227,512.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.466,515.932], [909.008,556.656], [937.227,512.908], [937.589,553.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.008,556.682], [909.543,596.912], [937.59,553.201], [937.947,592.987]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.543,596.938], [910.072,636.684], [937.948,593.012], [938.301,632.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.072,636.71], [910.594,675.981], [938.301,632.35], [938.651,671.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.594,676.006], [911.11,714.81], [938.651,671.222], [938.996,709.613]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.11,714.81], [911.583,750.383], [938.996,709.613], [939.313,744.812]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[973.713,260.982], [973.884,311.065], [925.799,260.79], [926.284,307.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.884,311.065], [974.053,360.463], [926.284,307.907], [926.764,354.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.053,360.463], [974.219,409.128], [926.764,354.419], [927.237,400.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.219,409.159], [974.383,457.136], [927.237,400.308], [927.704,445.558]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.383,457.167], [974.544,504.472], [927.704,445.586], [928.165,490.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.545,504.501], [974.704,551.148], [928.165,490.267], [928.619,534.333]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.704,551.177], [974.861,597.178], [928.62,534.361], [929.068,577.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.861,597.207], [975.016,642.577], [929.068,577.88], [929.511,620.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.016,642.605], [975.169,687.356], [929.511,620.834], [929.948,663.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.169,687.384], [975.32,731.528], [929.948,663.237], [930.38,705.07]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.32,731.556], [975.469,775.107], [930.38,705.096], [930.806,746.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.469,775.107], [975.605,814.97], [930.806,746.398], [931.196,784.23]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[985.781,261.133], [985.869,313.544], [955.294,261.007], [955.6,311.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[985.869,313.544], [985.955,365.203], [955.6,311.473], [955.902,361.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[985.955,365.204], [986.041,416.063], [955.902,361.244], [956.2,410.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.041,416.095], [986.125,466.203], [956.2,410.301], [956.493,458.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.125,466.235], [986.208,515.609], [956.493,458.66], [956.782,506.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.208,515.64], [986.289,564.295], [956.782,506.336], [957.068,553.314]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.289,564.326], [986.37,612.279], [957.068,553.343], [957.349,599.667]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.37,612.309], [986.449,659.574], [957.349,599.696], [957.626,645.378]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.449,659.604], [986.528,706.197], [957.626,645.407], [957.899,690.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.528,706.226], [986.605,752.16], [957.9,690.491], [958.169,734.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.605,752.189], [986.681,797.477], [958.169,734.959], [958.435,778.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.681,797.478], [986.75,838.908], [958.435,778.797], [958.679,818.919]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1033,261.245], [1032.72,315.384], [1001.91,261.119], [1001.88,313.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.72,315.384], [1032.45,368.719], [1001.88,313.322], [1001.85,364.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.45,368.72], [1032.18,421.203], [1001.85,364.78], [1001.81,415.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.18,421.237], [1031.92,472.92], [1001.81,415.475], [1001.78,465.393]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.92,472.953], [1031.66,523.855], [1001.78,465.424], [1001.75,514.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.66,523.888], [1031.4,574.026], [1001.75,514.644], [1001.72,563.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.4,574.058], [1031.15,623.449], [1001.72,563.151], [1001.69,610.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.15,623.48], [1030.9,672.141], [1001.69,610.96], [1001.66,658.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.9,672.172], [1030.65,720.118], [1001.66,658.087], [1001.63,704.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.65,720.148], [1030.41,767.396], [1001.63,704.544], [1001.6,750.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.41,767.426], [1030.17,813.99], [1001.6,750.347], [1001.57,795.482]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.17,813.99], [1029.95,856.571], [1001.57,795.482], [1001.54,836.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.65,720.148], [1049.06,716.501], [1030.41,767.396], [1048.68,763.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.41,767.426], [1048.68,763.435], [1030.17,813.99], [1048.32,809.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.17,813.99], [1048.32,809.666], [1029.95,856.571], [1047.98,851.945]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.66,523.888], [1031.4,574.026], [1050.6,521.725], [1050.21,571.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.4,574.058], [1050.21,571.507], [1031.15,623.449], [1049.82,620.521]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.15,623.48], [1049.82,620.552], [1030.9,672.141], [1049.43,668.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.9,672.172], [1049.43,668.879], [1030.65,720.118], [1049.06,716.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.72,315.384], [1032.45,368.719], [1052.25,314.901], [1051.83,367.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.45,368.72], [1032.18,421.203], [1051.83,367.798], [1051.41,419.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.18,421.237], [1031.92,472.92], [1051.41,419.888], [1051.01,471.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.92,472.953], [1031.66,523.855], [1051.01,471.192], [1050.6,521.693]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1033,261.245], [1032.72,315.384], [1052.68,261.215], [1052.25,314.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.44,797.275], [1106.6,846.317], [1048.68,763.435], [1048.32,809.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1106.6,846.318], [1105.83,891.127], [1048.32,809.666], [1047.98,851.946]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.05,645.406], [1109.17,696.79], [1049.82,620.552], [1049.44,668.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.17,696.822], [1108.3,747.407], [1049.44,668.879], [1049.06,716.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1108.3,747.439], [1107.45,797.244], [1049.06,716.501], [1048.68,763.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.86,540.099], [1110.95,593.138], [1050.6,521.725], [1050.21,571.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.95,593.171], [1110.05,645.373], [1050.21,571.507], [1049.82,620.521]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.68,375.645], [1113.72,431.322], [1051.83,367.798], [1051.41,419.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.72,431.357], [1112.78,486.133], [1051.41,419.888], [1051.01,471.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.78,486.168], [1111.86,540.065], [1051.01,471.192], [1050.61,521.693]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1116.64,261.465], [1115.65,319.01], [1052.68,261.215], [1052.25,314.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.65,319.01], [1114.68,375.645], [1052.25,314.901], [1051.83,367.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1106.6,846.318], [1105.83,891.127], [1147.61,835.625], [1146.57,879.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.44,797.275], [1106.6,846.317], [1148.74,787.399], [1147.61,835.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.17,696.822], [1108.3,747.407], [1151.07,688.661], [1149.9,738.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1108.3,747.439], [1107.45,797.244], [1149.9,738.407], [1148.75,787.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.05,645.406], [1109.17,696.79], [1152.26,638.145], [1151.07,688.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.95,593.171], [1110.05,645.373], [1153.47,586.84], [1152.26,638.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.86,540.099], [1110.95,593.138], [1154.7,534.727], [1153.47,586.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.78,486.168], [1111.86,540.065], [1155.95,481.788], [1154.7,534.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.72,431.357], [1112.78,486.133], [1157.21,428.001], [1155.95,481.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.68,375.645], [1113.72,431.322], [1158.5,373.348], [1157.21,427.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.65,319.01], [1114.68,375.645], [1159.81,317.807], [1158.5,373.348]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1116.64,261.465], [1115.65,319.01], [1161.14,261.392], [1159.81,317.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.55,848.6], [1168.33,893.567], [1147.61,835.625], [1146.57,879.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.88,799.384], [1169.55,848.6], [1148.74,787.399], [1147.61,835.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.23,749.368], [1170.88,799.352], [1149.9,738.407], [1148.75,787.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.61,698.565], [1172.23,749.336], [1151.07,688.662], [1149.9,738.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175,646.957], [1173.61,698.533], [1152.26,638.145], [1151.07,688.63]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.42,594.524], [1175,646.924], [1153.47,586.84], [1152.26,638.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1177.86,541.247], [1176.42,594.49], [1154.7,534.727], [1153.47,586.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1179.33,487.104], [1177.86,541.212], [1155.95,481.788], [1154.7,534.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1180.82,432.074], [1179.33,487.069], [1157.21,428.001], [1155.95,481.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.33,376.137], [1180.82,432.039], [1158.5,373.348], [1157.21,427.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.87,319.267], [1182.33,376.136], [1159.81,317.807], [1158.5,373.348]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1185.43,261.48], [1183.87,319.267], [1161.14,261.392], [1159.81,317.806]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.55,848.6], [1168.33,893.566], [1219.45,835.161], [1217.92,879.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.88,799.383], [1169.55,848.6], [1221.13,786.971], [1219.45,835.161]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.23,749.367], [1170.88,799.352], [1222.84,738.015], [1221.13,786.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.61,698.565], [1172.23,749.336], [1224.57,688.307], [1222.84,737.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175,646.957], [1173.61,698.533], [1226.33,637.83], [1224.57,688.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.42,594.524], [1175,646.924], [1228.11,586.565], [1226.33,637.798]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1177.86,541.246], [1176.42,594.49], [1229.92,534.494], [1228.11,586.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1179.33,487.103], [1177.86,541.212], [1231.77,481.597], [1229.93,534.461]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1180.82,432.074], [1179.33,487.069], [1233.64,427.856], [1231.77,481.564]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.33,376.136], [1180.82,432.039], [1235.54,373.248], [1233.64,427.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.87,319.267], [1182.33,376.136], [1237.47,317.755], [1235.54,373.248]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1185.43,261.48], [1183.87,319.267], [1239.44,261.388], [1237.47,317.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.9,840.363], [1219.45,835.161], [1227.29,884.764], [1217.92,879.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.67,791.774], [1221.13,786.971], [1228.9,840.362], [1219.45,835.161]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.46,742.408], [1222.84,738.015], [1230.67,791.744], [1221.13,786.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.28,692.276], [1224.57,688.307], [1232.46,742.377], [1222.84,737.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.13,641.361], [1226.33,637.83], [1234.28,692.244], [1224.57,688.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.01,589.644], [1228.11,586.565], [1236.13,641.329], [1226.33,637.798]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.73,840.253], [1227.12,884.647], [1281.55,825.844], [1279.61,869.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.92,537.106], [1229.92,534.494], [1238.01,589.611], [1228.11,586.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.5,791.674], [1228.73,840.253], [1283.66,778.367], [1281.55,825.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.86,483.727], [1239.92,537.072], [1231.77,481.597], [1229.93,534.461]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.29,742.316], [1230.5,791.643], [1285.8,730.149], [1283.66,778.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.83,429.487], [1241.86,483.693], [1233.64,427.856], [1231.77,481.564]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.11,692.193], [1232.29,742.284], [1287.98,681.202], [1285.81,730.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.84,374.365], [1243.83,429.452], [1235.54,373.248], [1233.64,427.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.96,641.287], [1234.11,692.161], [1290.2,631.51], [1287.98,681.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.69,318.327], [1245.65,374.341], [1237.47,317.755], [1235.54,373.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.84,589.579], [1235.96,641.254], [1292.44,581.056], [1290.2,631.479]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1249.94,261.423], [1247.87,318.339], [1239.44,261.388], [1237.47,317.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.74,537.051], [1237.84,589.546], [1294.72,529.821], [1292.44,581.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.68,483.682], [1239.74,537.017], [1297.04,477.788], [1294.72,529.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.65,429.452], [1241.68,483.648], [1299.39,424.938], [1297.04,477.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.65,374.341], [1243.65,429.418], [1301.78,371.252], [1299.39,424.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.69,318.327], [1245.65,374.341], [1303.78,316.719], [1301.35,371.27]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1249.75,261.423], [1247.69,318.327], [1306.67,261.324], [1304.21,316.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.99,814.079], [1256.25,856.665], [1293.99,804.567], [1292.05,846.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.88,767.508], [1257.99,814.079], [1296.11,758.73], [1293.99,804.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.81,720.223], [1259.88,767.478], [1298.26,712.202], [1296.11,758.701]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.76,672.239], [1261.81,720.193], [1300.45,664.998], [1298.27,712.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.75,623.54], [1263.77,672.208], [1302.67,617.103], [1300.45,664.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.76,574.109], [1265.75,623.509], [1304.92,568.501], [1302.67,617.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1269.81,523.932], [1267.76,574.078], [1307.2,519.178], [1304.92,568.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1271.88,472.989], [1269.81,523.9], [1309.52,469.116], [1307.2,519.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1273.99,421.264], [1271.88,472.957], [1311.87,418.3], [1309.52,469.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.13,368.738], [1273.99,421.231], [1314.26,366.711], [1311.87,418.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.3,315.394], [1276.13,368.738], [1316.69,314.333], [1314.26,366.711]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1280.51,261.244], [1278.3,315.394], [1319.15,261.18], [1316.69,314.333]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[824.804,261.158], [825.763,298.869], [801.345,260.683], [802.381,296.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.763,298.869], [826.711,336.187], [802.381,296.611], [803.408,332.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.711,336.187], [827.648,373.072], [803.408,332.183], [804.423,367.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.648,373.095], [828.575,409.577], [804.424,367.383], [805.428,402.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.576,409.6], [829.493,445.685], [805.429,402.216], [806.423,436.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.493,445.708], [830.4,481.403], [806.424,436.689], [807.408,470.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.401,481.426], [831.298,516.738], [807.408,470.806], [808.382,504.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.299,516.76], [832.186,551.694], [808.383,504.573], [809.347,537.974]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[822.705,261.491], [823.707,300.447], [809.269,261.209], [810.318,299.106]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.187,551.716], [833.065,586.279], [809.347,537.995], [810.301,571.058]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[824.601,261.875], [825.629,302.267], [810.293,261.564], [811.374,300.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.707,300.447], [824.698,338.984], [810.318,299.106], [811.357,336.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.065,586.3], [833.934,620.497], [810.302,571.078], [811.246,603.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.629,302.267], [826.645,342.206], [811.374,300.791], [812.442,339.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.698,338.984], [825.677,377.059], [811.357,336.606], [812.383,373.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.935,620.519], [834.795,654.356], [811.247,603.827], [812.182,636.227]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.645,342.206], [827.648,381.652], [812.442,339.593], [813.498,377.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.678,377.083], [826.646,414.728], [812.384,373.693], [813.399,410.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[834.795,654.356], [835.584,685.416], [812.182,636.227], [813.041,665.981]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.649,381.677], [828.641,420.661], [813.499,377.952], [814.543,415.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.647,414.752], [827.604,451.975], [813.4,410.372], [814.404,446.628]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.641,420.685], [829.622,459.217], [814.543,415.874], [815.576,453.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.605,451.999], [828.551,488.807], [814.404,446.651], [815.397,482.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.622,459.241], [830.591,497.327], [815.576,453.369], [816.597,490.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.552,488.83], [829.488,525.23], [815.398,482.536], [816.381,518.011]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.592,497.351], [831.549,534.999], [816.597,490.443], [817.607,527.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.489,525.253], [830.414,561.251], [816.381,518.033], [817.353,553.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.55,535.023], [832.497,572.241], [817.607,527.102], [818.605,563.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.415,561.274], [831.331,596.877], [817.354,553.149], [818.315,587.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.497,572.265], [833.434,609.061], [818.606,563.354], [819.593,599.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.331,596.9], [832.237,632.115], [818.316,587.89], [819.267,622.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.434,609.084], [834.36,645.464], [819.593,599.206], [820.569,634.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.237,632.137], [833.133,666.97], [819.268,622.262], [820.209,656.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.36,645.487], [835.275,681.458], [820.57,634.665], [821.535,669.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.133,666.97], [833.955,698.933], [820.209,656.248], [821.073,687.444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.275,681.458], [836.115,714.455], [821.535,669.714], [822.421,701.873]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[824.601,261.875], [825.629,302.267], [840.629,261.819], [841.556,302.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.629,302.267], [826.645,342.206], [841.556,302.005], [842.473,341.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.645,342.206], [827.648,381.652], [842.474,341.744], [843.38,380.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.649,381.677], [828.641,420.661], [843.38,381.018], [844.275,419.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.641,420.685], [829.622,459.217], [844.276,419.834], [845.161,458.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.622,459.241], [845.161,458.202], [830.591,497.327], [846.036,496.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.592,497.351], [846.037,496.129], [831.55,534.999], [846.902,533.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.55,535.023], [846.902,533.622], [832.497,572.241], [847.757,570.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.498,572.265], [847.758,570.689], [833.434,609.061], [848.603,607.314]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.434,609.084], [848.604,607.338], [834.36,645.464], [849.439,643.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.36,645.487], [849.44,643.574], [835.276,681.458], [850.266,679.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.276,681.458], [850.266,679.383], [836.115,714.455], [851.025,712.232]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[869.672,262.427], [870.47,304.89], [840.629,261.819], [841.556,302.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.47,304.89], [871.259,346.85], [841.556,302.005], [842.473,341.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.26,346.85], [872.038,388.267], [842.474,341.744], [843.38,380.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.039,388.293], [872.808,429.201], [843.38,381.017], [844.275,419.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.809,429.227], [873.569,469.635], [844.276,419.834], [845.161,458.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.569,469.661], [874.32,509.58], [845.161,458.202], [846.036,496.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.32,509.605], [875.062,549.042], [846.037,496.129], [846.902,533.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.063,549.067], [875.796,588.032], [846.902,533.622], [847.757,570.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.796,588.056], [876.52,626.557], [847.758,570.689], [848.603,607.314]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.521,626.581], [877.236,664.625], [848.604,607.338], [849.44,643.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.237,664.649], [877.944,702.246], [849.44,643.574], [850.267,679.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.944,702.246], [878.592,736.715], [850.267,679.383], [851.025,712.232]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[869.672,262.428], [870.471,304.89], [895.441,262.333], [896.073,304.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.47,304.89], [871.26,346.85], [896.073,304.442], [896.698,346.058]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.26,346.85], [872.039,388.267], [896.699,346.058], [897.315,387.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.039,388.293], [872.809,429.201], [897.316,387.164], [897.925,427.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.809,429.227], [873.569,469.635], [897.925,427.77], [898.527,467.859]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.57,469.661], [874.32,509.58], [898.528,467.884], [899.122,507.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.321,509.605], [875.062,549.042], [899.123,507.516], [899.71,546.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.063,549.067], [875.796,588.032], [899.711,546.673], [900.291,585.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.796,588.056], [900.292,585.365], [876.52,626.557], [900.865,623.576]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.521,626.581], [900.866,623.6], [877.236,664.625], [901.433,661.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.237,664.65], [901.433,661.386], [877.944,702.246], [901.993,698.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.944,702.246], [901.993,698.707], [878.592,736.715], [902.507,732.926]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[906.08,262.544], [906.657,305.441], [895.441,262.333], [896.073,304.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.656,305.441], [907.226,347.827], [896.073,304.442], [896.698,346.058]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.227,347.827], [907.789,389.657], [896.698,346.058], [897.315,387.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.789,389.684], [908.345,430.995], [897.315,387.164], [897.924,427.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.345,431.021], [908.894,471.824], [897.925,427.77], [898.527,467.859]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.895,471.849], [909.437,512.152], [898.527,467.884], [899.122,507.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.437,512.177], [909.972,551.989], [899.122,507.516], [899.71,546.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.973,552.014], [910.502,591.344], [899.71,546.673], [900.291,585.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.502,591.369], [911.024,630.226], [900.291,585.365], [900.865,623.576]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.025,630.25], [911.541,668.643], [900.865,623.6], [901.432,661.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.541,668.667], [912.052,706.603], [901.432,661.386], [901.993,698.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.052,706.603], [912.519,741.379], [901.993,698.707], [902.507,732.926]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[906.079,262.544], [906.656,305.441], [936.57,262.43], [936.951,304.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.656,305.441], [907.226,347.827], [936.951,304.9], [937.327,346.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.227,347.827], [907.789,389.657], [937.327,346.868], [937.698,388.292]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.789,389.684], [908.345,430.995], [937.698,388.318], [938.065,429.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.345,431.021], [908.894,471.824], [938.065,429.26], [938.427,469.676]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.894,471.849], [909.436,512.152], [938.427,469.701], [938.785,509.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.437,512.177], [909.972,551.989], [938.785,509.652], [939.139,549.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.973,552.014], [910.501,591.344], [939.139,549.121], [939.488,588.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.502,591.369], [911.024,630.226], [939.488,588.117], [939.833,626.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.025,630.25], [911.541,668.643], [939.834,626.648], [940.175,664.699]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.541,668.667], [940.175,664.723], [912.052,706.603], [940.512,702.326]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.052,706.603], [940.512,702.326], [912.519,741.379], [940.821,736.801]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[955.14,264.181], [955.445,313.197], [917.037,263.386], [917.582,309.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.445,313.197], [955.746,361.541], [917.582,309.431], [918.12,354.885]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.746,361.541], [956.043,409.167], [918.12,354.885], [918.651,399.702]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.043,409.197], [956.335,456.15], [918.651,399.73], [919.174,443.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.335,456.179], [956.624,502.473], [919.175,443.979], [919.691,487.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.624,502.502], [956.908,548.15], [919.692,487.644], [920.201,530.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[956.908,548.179], [957.189,593.195], [920.202,530.735], [920.705,573.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[957.189,593.223], [957.465,637.621], [920.705,573.265], [921.202,615.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[957.466,637.649], [957.738,681.44], [921.202,615.245], [921.692,656.657]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[957.739,681.467], [958.008,724.664], [921.693,656.684], [922.177,697.567]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[958.008,724.692], [958.273,767.307], [922.177,697.593], [922.655,737.957]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[958.273,767.307], [958.516,806.313], [922.655,737.957], [923.092,774.93]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[960.248,264.786], [960.529,316.058], [936.163,264.264], [936.608,313.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[960.529,316.058], [960.806,366.593], [936.608,313.589], [937.047,362.232]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[960.806,366.593], [961.078,416.345], [937.047,362.233], [937.479,410.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.079,416.376], [961.347,465.393], [937.479,410.18], [937.905,457.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.347,465.424], [961.612,513.722], [937.906,457.445], [938.326,504.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.612,513.752], [961.872,561.347], [938.326,504.042], [938.74,549.957]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.873,561.377], [962.13,608.284], [938.741,549.986], [939.149,595.262]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.13,608.313], [962.383,654.547], [939.149,595.291], [939.552,639.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.383,654.576], [962.633,700.151], [939.552,639.968], [939.95,684.004]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.633,700.18], [962.879,745.109], [939.95,684.032], [940.342,727.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.879,745.138], [963.122,789.437], [940.342,727.495], [940.729,770.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.122,789.437], [963.344,829.962], [940.729,770.341], [941.083,809.557]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1001.33,265.269], [1001.3,318.34], [976.55,264.747], [976.707,315.872]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.3,318.34], [1001.27,370.621], [976.707,315.872], [976.862,366.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.27,370.621], [1001.24,422.064], [976.862,366.265], [977.015,415.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.24,422.097], [1001.22,472.754], [977.015,415.909], [977.165,464.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.22,472.786], [1001.19,522.675], [977.165,464.823], [977.313,512.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.19,522.706], [1001.16,571.844], [977.313,513.021], [977.459,560.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.16,571.876], [1001.13,620.279], [977.459,560.519], [977.603,607.303]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.13,620.31], [1001.1,667.996], [977.603,607.332], [977.745,653.447]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.1,668.026], [1001.08,715.01], [977.745,653.476], [977.885,698.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.08,715.04], [1001.05,761.338], [977.885,698.964], [978.023,743.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.05,761.367], [1001.02,806.993], [978.023,743.81], [978.159,788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.02,806.993], [1001,848.714], [978.159,788], [978.284,828.426]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1001.33,265.269], [1001.3,318.34], [1021.89,265.17], [1021.7,317.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.3,318.34], [1001.27,370.621], [1021.7,317.874], [1021.52,369.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.27,370.621], [1001.24,422.064], [1021.52,369.799], [1021.33,420.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.24,422.097], [1001.22,472.754], [1021.33,420.929], [1021.15,471.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.22,472.786], [1001.19,522.675], [1021.15,471.284], [1020.97,520.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.19,522.706], [1020.97,520.88], [1001.16,571.844], [1020.8,569.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.16,571.876], [1020.8,569.734], [1001.13,620.279], [1020.62,617.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.13,620.31], [1020.62,617.864], [1001.1,667.996], [1020.45,665.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.1,668.026], [1020.45,665.284], [1001.08,715.01], [1020.28,711.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.08,715.04], [1020.28,712.011], [1001.05,761.338], [1020.12,758.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.05,761.367], [1020.12,758.06], [1001.02,806.993], [1019.96,803.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1001.02,806.993], [1019.96,803.416], [1001,848.714], [1019.81,844.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.29,643.775], [1068.72,694.284], [1020.62,617.864], [1020.45,665.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.72,694.316], [1068.17,744.035], [1020.45,665.284], [1020.28,711.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.17,744.066], [1067.62,793.013], [1020.28,712.011], [1020.12,758.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.62,793.044], [1067.08,841.237], [1020.12,758.06], [1019.96,803.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.08,841.238], [1066.58,885.268], [1019.96,803.416], [1019.81,844.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.89,322.823], [1072.26,378.528], [1021.7,317.874], [1021.52,369.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.26,378.528], [1071.65,433.284], [1021.52,369.799], [1021.33,420.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.65,433.319], [1071.05,487.184], [1021.33,420.929], [1021.15,471.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.05,487.218], [1070.45,540.213], [1021.15,471.284], [1020.97,520.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.45,540.246], [1069.87,592.392], [1020.97,520.88], [1020.8,569.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.87,592.425], [1069.29,643.743], [1020.8,569.734], [1020.62,617.833]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1073.52,266.218], [1072.89,322.824], [1021.89,265.17], [1021.7,317.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.62,793.044], [1067.08,841.237], [1111.4,784.792], [1110.54,832.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.08,841.237], [1066.58,885.268], [1110.54,832.319], [1109.75,875.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.72,694.316], [1068.17,744.035], [1113.17,687.462], [1112.28,736.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.17,744.066], [1067.62,793.013], [1112.28,736.502], [1111.4,784.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.87,592.425], [1069.29,643.743], [1115,587.064], [1114.08,637.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.29,643.775], [1068.72,694.284], [1114.08,637.656], [1113.17,687.431]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.04,487.218], [1070.45,540.213], [1116.88,483.45], [1115.93,535.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.45,540.246], [1069.87,592.392], [1115.93,535.669], [1115,587.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.65,433.319], [1071.05,487.184], [1117.84,430.388], [1116.88,483.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.89,322.823], [1072.26,378.528], [1119.82,321.651], [1118.82,376.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.26,378.528], [1071.65,433.284], [1118.82,376.462], [1117.84,430.354]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1073.52,266.218], [1072.89,322.824], [1120.83,265.97], [1119.82,321.652]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.64,845.829], [1127.7,890.167], [1110.54,832.319], [1109.75,875.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1130.71,747.962], [1129.66,797.262], [1112.28,736.502], [1111.4,784.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1129.66,797.294], [1128.64,845.829], [1111.4,784.792], [1110.54,832.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.77,697.847], [1130.71,747.93], [1113.17,687.463], [1112.28,736.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.84,646.928], [1131.77,697.814], [1114.08,637.656], [1113.17,687.431]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.93,595.188], [1132.84,646.896], [1115,587.065], [1114.08,637.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.05,542.605], [1133.93,595.155], [1115.93,535.669], [1115,587.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.17,489.16], [1135.05,542.572], [1116.88,483.45], [1115.93,535.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.32,434.83], [1136.17,489.126], [1117.84,430.388], [1116.88,483.417]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.49,379.594], [1137.32,434.795], [1118.82,376.463], [1117.84,430.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.68,323.428], [1138.49,379.593], [1119.82,321.651], [1118.82,376.462]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1140.88,266.346], [1139.68,323.428], [1120.83,265.969], [1119.82,321.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.64,845.829], [1127.7,890.166], [1182.13,834.525], [1180.84,878.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1129.66,797.293], [1128.64,845.829], [1183.55,786.832], [1182.13,834.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1130.71,747.961], [1129.66,797.262], [1184.98,738.372], [1183.55,786.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.77,697.846], [1130.71,747.93], [1186.45,689.157], [1184.99,738.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.84,646.928], [1131.77,697.814], [1187.93,639.169], [1186.45,689.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.93,595.187], [1132.84,646.895], [1189.44,588.389], [1187.93,639.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.05,542.605], [1133.93,595.155], [1190.97,536.8], [1189.44,588.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.17,489.159], [1135.05,542.572], [1192.52,484.381], [1190.97,536.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.32,434.83], [1136.17,489.125], [1194.11,431.112], [1192.53,484.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.49,379.593], [1137.32,434.795], [1195.71,376.972], [1194.11,431.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.68,323.428], [1138.49,379.593], [1197.35,321.941], [1195.71,376.973]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1140.88,266.345], [1139.68,323.427], [1199.01,266.03], [1197.35,321.941]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.09,839.988], [1182.13,834.525], [1188.73,883.935], [1180.84,878.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.58,791.887], [1183.55,786.832], [1190.09,839.988], [1182.13,834.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.1,743.006], [1184.98,738.372], [1191.58,791.857], [1183.55,786.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.64,693.355], [1186.45,689.157], [1193.1,742.975], [1184.99,738.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.2,642.917], [1187.93,639.169], [1194.64,693.324], [1186.45,689.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.79,591.673], [1189.44,588.389], [1196.2,642.885], [1187.93,639.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.96,839.874], [1188.6,883.813], [1247.12,827.649], [1245.39,870.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.4,539.604], [1197.79,591.641], [1190.97,536.8], [1189.44,588.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.45,791.782], [1189.96,839.874], [1249.01,780.471], [1247.12,827.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.04,486.689], [1199.4,539.571], [1192.52,484.381], [1190.97,536.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.96,742.909], [1191.45,791.752], [1250.93,732.542], [1249.01,780.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.71,432.908], [1201.04,486.655], [1194.11,431.112], [1192.53,484.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.5,693.268], [1192.96,742.878], [1252.88,683.875], [1250.93,732.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.4,378.238], [1202.71,432.873], [1195.71,376.972], [1194.11,431.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.06,642.839], [1194.5,693.236], [1254.86,634.454], [1252.88,683.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.97,322.644], [1204.25,378.212], [1197.35,321.941], [1195.71,376.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.64,591.605], [1196.06,642.807], [1256.87,584.259], [1254.86,634.422]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1207.88,266.182], [1206.13,322.659], [1199.01,266.03], [1197.35,321.941]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.26,539.546], [1197.65,591.573], [1258.92,533.274], [1256.88,584.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.9,486.641], [1199.26,539.513], [1260.99,481.479], [1258.92,533.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.56,432.87], [1200.9,486.607], [1263.1,428.855], [1261,481.447]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.25,378.212], [1202.56,432.836], [1265.25,375.382], [1263.1,428.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.97,322.644], [1204.25,378.212], [1266.97,321.048], [1264.79,375.398]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1207.72,266.179], [1205.97,322.644], [1269.64,265.839], [1267.43,321.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.79,815.179], [1225.24,857.455], [1265.84,807.07], [1264.05,848.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.49,768.936], [1226.79,815.179], [1267.8,761.437], [1265.84,807.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.22,721.974], [1228.49,768.907], [1269.79,715.104], [1267.8,761.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.97,674.304], [1230.22,721.944], [1271.81,668.085], [1269.79,715.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.75,625.911], [1231.97,674.273], [1273.86,620.362], [1271.81,668.055]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.56,576.779], [1233.75,625.88], [1275.94,571.921], [1273.86,620.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.39,526.89], [1235.56,576.748], [1278.06,522.745], [1275.94,571.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.25,476.227], [1237.39,526.858], [1280.2,472.818], [1278.06,522.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.14,424.771], [1239.25,476.195], [1282.38,422.121], [1280.2,472.786]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.06,372.505], [1241.14,424.739], [1284.59,370.638], [1282.38,422.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.01,319.408], [1243.06,372.505], [1286.83,318.35], [1284.59,370.638]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1247,265.494], [1245.01,319.408], [1289.11,265.27], [1286.83,318.35]]
            },],[{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[836.152,263.143], [837.105,302.531], [825.68,262.623], [826.666,300.862]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[843.906,261.979], [844.754,298.8], [826.353,261.181], [827.252,296.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.105,302.531], [838.048,341.48], [826.666,300.862], [827.64,338.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.048,341.48], [838.979,379.949], [827.64,338.689], [828.603,376.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.979,379.973], [839.899,417.996], [828.604,376.087], [829.556,413.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.9,418.02], [840.809,455.603], [829.557,413.063], [830.498,449.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.81,455.627], [841.709,492.778], [830.499,449.624], [831.43,485.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.709,492.802], [842.598,529.529], [831.43,485.776], [832.351,521.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.86,477.078], [849.654,511.568], [831.615,466.255], [832.46,499.197]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[842.599,529.552], [843.477,565.862], [832.352,521.528], [833.262,556.862]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[843.478,565.885], [844.347,601.785], [833.263,556.885], [834.163,591.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.347,601.808], [845.206,637.305], [834.164,591.854], [835.055,626.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[845.207,637.327], [846.056,672.428], [835.055,626.44], [835.936,660.63]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[836.152,263.143], [837.105,302.531], [852.157,263.072], [853.012,302.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[846.056,672.428], [846.835,704.627], [835.936,660.63], [836.745,692.004]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.105,302.531], [838.048,341.48], [853.012,302.301], [853.858,341.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.048,341.48], [838.979,379.949], [853.858,341.095], [854.693,379.414]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.979,379.973], [854.694,379.438], [839.899,417.996], [855.519,417.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.9,418.02], [855.52,417.337], [840.809,455.603], [856.336,454.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.81,455.627], [856.336,454.8], [841.709,492.778], [857.143,491.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.71,492.802], [857.144,491.835], [842.598,529.529], [857.941,528.425]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[842.599,529.552], [857.942,528.448], [843.478,565.862], [858.73,564.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[843.478,565.885], [858.731,564.646], [844.347,601.785], [859.511,600.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.347,601.808], [859.511,600.438], [845.206,637.305], [860.282,635.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[845.207,637.327], [860.282,635.829], [846.056,672.428], [861.045,670.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[846.056,672.428], [861.045,670.805], [846.836,704.627], [861.744,702.891]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[873.716,264.094], [874.486,305.573], [852.157,263.072], [853.013,302.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.486,305.573], [875.247,346.565], [853.012,302.301], [853.858,341.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.247,346.565], [875.998,387.028], [853.858,341.095], [854.693,379.414]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.998,387.053], [876.74,427.021], [854.694,379.438], [855.52,417.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.741,427.046], [877.474,466.528], [855.52,417.337], [856.336,454.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.474,466.553], [878.198,505.558], [856.337,454.8], [857.143,491.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.199,505.582], [878.914,544.119], [857.144,491.835], [857.941,528.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.915,544.143], [879.622,582.22], [857.942,528.448], [858.73,564.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.622,582.244], [880.321,619.868], [858.731,564.646], [859.511,600.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.321,619.892], [881.011,657.073], [859.511,600.438], [860.282,635.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.012,657.096], [881.694,693.841], [860.283,635.829], [861.045,670.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.694,693.842], [882.32,727.531], [861.045,670.805], [861.744,702.891]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[873.716,264.094], [874.486,305.573], [899.644,263.97], [900.249,305.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.486,305.573], [875.247,346.565], [900.249,305.177], [900.846,345.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.247,346.565], [875.998,387.028], [900.847,345.904], [901.437,386.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.999,387.053], [876.741,427.021], [901.437,386.133], [902.02,425.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.741,427.046], [877.474,466.528], [902.02,425.873], [902.596,465.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.475,466.553], [878.199,505.558], [902.597,465.133], [903.165,503.897]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.199,505.582], [903.166,503.922], [878.915,544.119], [903.728,542.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.915,544.143], [903.728,542.248], [879.622,582.22], [904.284,580.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.622,582.244], [904.284,580.12], [880.321,619.868], [904.833,617.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.321,619.892], [904.833,617.545], [881.012,657.073], [905.376,654.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.012,657.096], [905.376,654.531], [881.694,693.842], [905.912,691.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.694,693.842], [905.912,691.063], [882.32,727.531], [906.404,724.56]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[907.699,264.326], [908.264,306.317], [899.644,263.97], [900.249,305.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.264,306.316], [908.823,347.807], [900.249,305.177], [900.846,345.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.823,347.807], [909.374,388.756], [900.846,345.904], [901.436,386.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.375,388.782], [909.919,429.223], [901.437,386.133], [902.02,425.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.92,429.249], [910.458,469.193], [902.02,425.873], [902.596,465.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.458,469.218], [910.989,508.674], [902.596,465.133], [903.165,503.897]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.99,508.699], [911.514,547.675], [903.165,503.922], [903.727,542.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.515,547.7], [912.033,586.205], [903.728,542.248], [904.283,580.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.034,586.23], [912.546,624.273], [904.283,580.12], [904.832,617.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.546,624.297], [913.052,661.887], [904.833,617.545], [905.375,654.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.053,661.91], [913.553,699.054], [905.375,654.531], [905.912,691.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.553,699.054], [914.012,733.105], [905.912,691.063], [906.403,724.56]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[907.698,264.326], [908.264,306.317], [938.55,264.176], [938.918,305.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.264,306.316], [908.823,347.807], [938.918,305.836], [939.282,347.004]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[937.729,267.052], [938.159,315.034], [909.301,265.71], [909.897,310.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.823,347.807], [909.374,388.756], [939.282,347.004], [939.641,387.638]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.375,388.781], [909.919,429.223], [939.642,387.663], [939.996,427.798]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.159,315.034], [938.584,362.36], [909.897,310.742], [910.485,355.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.584,362.36], [939.002,408.984], [910.485,355.199], [911.065,399.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.92,429.249], [910.458,469.193], [939.996,427.824], [940.347,467.469]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.458,469.218], [910.989,508.674], [940.347,467.494], [940.693,506.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.002,409.013], [939.414,454.979], [911.066,399.062], [911.638,442.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.99,508.699], [911.514,547.675], [940.693,506.683], [941.035,545.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.515,547.7], [941.035,545.399], [912.033,586.205], [941.373,583.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.414,455.008], [939.82,500.33], [911.638,442.343], [912.203,485.028]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.821,500.358], [940.221,545.05], [912.203,485.055], [912.76,527.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.034,586.23], [941.373,583.651], [912.546,624.273], [941.707,621.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.546,624.297], [941.707,621.448], [913.052,661.886], [942.037,658.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.221,545.078], [940.617,589.151], [912.761,527.207], [913.311,568.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.617,589.179], [941.007,632.648], [913.311,568.812], [913.854,609.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.053,661.91], [942.038,658.796], [913.553,699.054], [942.364,695.682]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.553,699.054], [942.364,695.682], [914.012,733.104], [942.662,729.5]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[941.007,632.675], [941.391,675.552], [913.854,609.879], [914.391,650.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[941.391,675.579], [941.771,717.875], [914.391,650.42], [914.92,690.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[941.771,717.901], [942.145,759.628], [914.92,690.443], [915.443,729.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[942.145,759.628], [942.487,797.823], [915.443,729.934], [915.921,766.109]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[936.184,268.041], [936.645,318.192], [918.426,267.161], [918.998,315.381]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.645,318.192], [937.099,367.624], [918.998,315.381], [919.562,362.938]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.1,367.624], [937.547,416.292], [919.562,362.938], [920.118,409.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.547,416.322], [937.988,464.273], [920.118,409.816], [920.666,455.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.989,464.303], [938.423,511.552], [920.666,456.029], [921.206,501.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.424,511.582], [938.852,558.145], [921.207,501.591], [921.739,546.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.852,558.174], [939.274,604.065], [921.74,546.517], [922.265,590.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.274,604.095], [939.69,649.329], [922.265,590.818], [922.783,634.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.691,649.358], [940.101,693.949], [922.783,634.509], [923.294,677.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.101,693.977], [940.506,737.94], [923.294,677.602], [923.798,720.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.506,737.968], [940.904,781.314], [923.799,720.108], [924.296,762.014]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.904,781.314], [941.269,820.969], [924.296,762.014], [924.751,800.369]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[970.94,268.884], [971.147,320.881], [952.451,268], [952.789,318.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.147,320.881], [971.351,372.104], [952.789,318.061], [953.123,367.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.351,372.104], [971.552,422.508], [953.123,367.407], [953.451,415.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.552,422.54], [971.75,472.174], [953.451,416.021], [953.774,463.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.75,472.205], [971.944,521.087], [953.775,463.92], [954.093,511.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.944,521.118], [972.136,569.265], [954.093,511.119], [954.407,557.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.136,569.296], [972.325,616.724], [954.408,557.634], [954.717,603.451]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.325,616.754], [972.511,663.479], [954.717,603.48], [955.022,648.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.511,663.509], [972.694,709.547], [955.023,648.671], [955.323,693.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.694,709.576], [972.875,754.942], [955.323,693.22], [955.62,737.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.875,754.971], [973.053,799.68], [955.62,737.142], [955.913,780.422]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.053,799.68], [973.215,840.562], [955.913,780.422], [956.18,820.017]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[970.941,268.884], [971.147,320.881], [992.078,268.754], [992.12,320.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.147,320.881], [971.351,372.104], [992.12,320.466], [992.161,371.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.351,372.104], [971.552,422.508], [992.161,371.414], [992.201,421.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.552,422.54], [971.749,472.174], [992.201,421.582], [992.241,470.957]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.75,472.205], [992.241,470.988], [971.944,521.087], [992.28,519.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[971.944,521.118], [992.28,519.65], [972.136,569.265], [992.319,567.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.136,569.296], [992.319,567.583], [972.325,616.724], [992.357,614.775]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.325,616.754], [992.357,614.805], [972.511,663.479], [992.394,661.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.511,663.509], [992.394,661.331], [972.694,709.547], [992.431,707.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.694,709.576], [992.431,707.176], [972.875,754.942], [992.468,752.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.875,754.971], [992.468,752.356], [973.053,799.68], [992.504,796.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.053,799.68], [992.504,796.855], [973.215,840.562], [992.536,837.549]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1031.19,270.535], [1030.91,326.148], [992.078,268.754], [992.12,320.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.91,326.147], [1030.63,380.873], [992.12,320.466], [992.161,371.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.63,380.873], [1030.36,434.665], [992.161,371.414], [992.202,421.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.36,434.699], [1030.09,487.613], [992.202,421.582], [992.241,470.957]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.09,487.647], [1029.83,539.705], [992.241,470.988], [992.281,519.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.82,539.738], [1029.57,590.961], [992.281,519.65], [992.319,567.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.56,590.993], [1029.31,641.401], [992.319,567.583], [992.357,614.775]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.31,641.433], [1029.06,691.044], [992.357,614.805], [992.395,661.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.06,691.076], [1028.81,739.91], [992.395,661.331], [992.432,707.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.81,739.941], [1028.57,788.016], [992.432,707.176], [992.468,752.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.57,788.047], [1028.33,835.38], [992.468,752.356], [992.504,796.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.33,835.38], [1028.11,878.623], [992.504,796.855], [992.537,837.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.57,788.047], [1074.13,781.474], [1028.33,835.38], [1073.54,828.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.33,835.38], [1073.54,828.289], [1028.11,878.623], [1073.01,871.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.56,590.993], [1029.31,641.401], [1076.56,586.675], [1075.94,636.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.31,641.433], [1029.06,691.044], [1075.94,636.523], [1075.32,685.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.06,691.076], [1028.81,739.91], [1075.32,685.594], [1074.72,733.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.81,739.941], [1074.72,733.905], [1028.57,788.016], [1074.13,781.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.63,380.873], [1030.36,434.665], [1079.15,379.125], [1078.48,432.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.36,434.699], [1030.09,487.613], [1078.48,432.276], [1077.83,484.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.09,487.647], [1029.82,539.705], [1077.83,484.571], [1077.19,535.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.82,539.738], [1029.56,590.961], [1077.19,536.031], [1076.56,586.643]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1031.19,270.535], [1030.91,326.148], [1080.51,270.206], [1079.82,325.097]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.91,326.147], [1030.63,380.873], [1079.82,325.097], [1079.15,379.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.68,842.161], [1087.03,885.85], [1073.54,828.289], [1073.01,871.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.11,745.716], [1088.39,794.302], [1074.72,733.905], [1074.13,781.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.39,794.333], [1087.68,842.161], [1074.13,781.474], [1073.54,828.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.58,646.132], [1089.84,696.29], [1075.94,636.523], [1075.32,685.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.84,696.322], [1089.11,745.684], [1075.32,685.594], [1074.72,733.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.34,595.127], [1090.58,646.099], [1076.56,586.675], [1075.94,636.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.89,490.592], [1092.11,543.254], [1077.83,484.571], [1077.19,535.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.11,543.287], [1091.34,595.094], [1077.19,536.031], [1076.56,586.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.68,437.019], [1092.89,490.558], [1078.48,432.276], [1077.83,484.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.31,327.154], [1094.49,382.547], [1079.82,325.097], [1079.15,379.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.49,382.548], [1093.68,436.985], [1079.15,379.125], [1078.48,432.242]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1096.15,270.851], [1095.31,327.154], [1080.51,270.206], [1079.82,325.097]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.68,842.161], [1087.03,885.849], [1143.9,833.1], [1142.86,876.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.11,745.715], [1088.39,794.302], [1146.18,738], [1145.03,785.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.39,794.332], [1087.68,842.161], [1145.03,785.933], [1143.9,833.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.84,696.321], [1089.11,745.684], [1147.35,689.312], [1146.18,737.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.58,646.131], [1089.84,696.289], [1148.54,639.853], [1147.35,689.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.11,543.287], [1091.34,595.094], [1150.98,538.545], [1149.75,589.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.34,595.126], [1090.58,646.099], [1149.75,589.604], [1148.54,639.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.89,490.591], [1092.11,543.254], [1152.22,486.656], [1150.98,538.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.68,437.019], [1092.89,490.558], [1153.49,433.919], [1152.22,486.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.49,382.547], [1093.68,436.985], [1154.78,380.31], [1153.49,433.885]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1096.15,270.85], [1095.31,327.154], [1157.42,270.428], [1156.09,325.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.31,327.154], [1094.49,382.547], [1156.09,325.809], [1154.78,380.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1150.29,838.758], [1143.9,833.1], [1149.2,882.223], [1142.86,876.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1151.49,791.177], [1145.03,785.933], [1150.29,838.758], [1143.9,833.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.7,742.817], [1146.18,738], [1151.49,791.147], [1145.03,785.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.93,693.688], [1147.35,689.312], [1152.7,742.786], [1146.18,737.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.19,643.773], [1148.54,639.853], [1153.94,693.657], [1147.35,689.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.46,593.051], [1149.75,589.604], [1155.19,643.741], [1148.54,639.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1150.19,838.641], [1149.1,882.099], [1210.84,828.757], [1209.34,871.565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.75,541.505], [1156.46,593.019], [1150.98,538.545], [1149.75,589.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1151.38,791.069], [1150.19,838.641], [1212.48,781.908], [1210.84,828.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.07,489.113], [1157.75,541.472], [1152.22,486.657], [1150.98,538.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.41,435.854], [1159.07,489.079], [1153.49,433.919], [1152.22,486.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.59,742.718], [1151.38,791.039], [1214.14,734.303], [1212.48,781.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.83,693.598], [1152.6,742.687], [1215.83,685.955], [1214.14,734.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.77,381.706], [1160.41,435.82], [1154.78,380.31], [1153.49,433.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.08,643.692], [1153.83,693.567], [1217.55,636.847], [1215.84,685.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.03,326.631], [1161.65,381.678], [1156.09,325.809], [1154.78,380.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.35,592.98], [1155.08,643.66], [1219.3,586.96], [1217.55,636.816]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1164.55,270.692], [1163.15,326.648], [1157.42,270.428], [1156.09,325.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.64,541.444], [1156.35,592.948], [1221.07,536.275], [1219.3,586.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.96,489.062], [1157.64,541.411], [1222.87,484.773], [1221.07,536.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.29,435.814], [1158.96,489.029], [1224.7,432.435], [1222.87,484.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.65,381.677], [1160.29,435.78], [1226.57,379.24], [1224.71,432.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.03,326.631], [1161.65,381.678], [1227.97,325.174], [1226.08,379.253]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1164.43,270.686], [1163.03,326.631], [1230.38,270.227], [1228.46,325.166]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194,815.719], [1192.65,857.667], [1235.57,809.126], [1233.96,850.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.47,769.827], [1194,815.719], [1237.34,763.719], [1235.57,809.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.97,723.211], [1195.47,769.798], [1239.13,717.605], [1237.34,763.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1198.49,675.884], [1196.97,723.182], [1240.96,670.795], [1239.14,717.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.04,627.83], [1198.49,675.854], [1242.81,623.274], [1240.96,670.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.61,579.031], [1200.04,627.799], [1244.68,575.026], [1242.81,623.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.2,529.47], [1201.61,579], [1246.59,526.034], [1244.68,574.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.82,479.129], [1203.2,529.438], [1248.53,476.28], [1246.59,526.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.46,427.99], [1204.82,479.097], [1250.49,425.747], [1248.53,476.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.13,376.034], [1206.46,427.958], [1252.49,374.417], [1250.49,425.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.83,323.24], [1208.13,376.034], [1254.52,322.269], [1252.49,374.417]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1211.56,269.623], [1209.83,323.24], [1256.58,269.318], [1254.52,322.269]]
            },],[{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[848.147,264.256], [849.023,302.751], [841.349,263.559], [842.238,300.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.023,302.751], [849.889,340.82], [842.238,300.927], [843.117,337.895]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.889,340.82], [850.745,378.423], [843.117,337.895], [843.986,374.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.745,378.447], [851.591,415.617], [843.987,374.447], [844.846,410.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.591,415.641], [852.427,452.384], [844.846,410.589], [845.696,446.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.428,452.407], [853.254,488.732], [845.696,446.328], [846.537,481.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.255,488.754], [854.072,524.667], [846.537,481.671], [847.368,516.603]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.073,524.69], [854.88,560.197], [847.369,516.625], [848.19,551.174]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[848.147,264.256], [849.023,302.751], [864.052,264.186], [864.832,302.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.881,560.219], [855.68,595.329], [848.191,551.196], [849.004,585.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.023,302.751], [849.889,340.82], [864.832,302.566], [865.604,340.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.68,595.351], [856.47,630.068], [849.004,585.39], [849.808,619.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.889,340.82], [865.604,340.524], [850.745,378.423], [866.366,378.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.471,630.09], [857.252,664.423], [849.809,619.214], [850.604,652.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[857.252,664.423], [857.968,695.921], [850.604,652.651], [851.334,683.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.745,378.447], [866.366,378.043], [851.591,415.617], [867.12,415.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.592,415.641], [867.12,415.13], [852.428,452.384], [867.865,451.77]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.428,452.407], [867.866,451.793], [853.255,488.732], [868.602,488.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.255,488.754], [868.602,488.039], [854.072,524.667], [869.33,523.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.073,524.69], [869.331,523.876], [854.881,560.197], [870.051,559.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.881,560.219], [870.051,559.309], [855.68,595.329], [870.763,594.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.68,595.351], [870.763,594.346], [856.47,630.068], [871.467,628.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.471,630.09], [871.468,628.993], [857.252,664.423], [872.164,663.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[857.252,664.423], [872.164,663.236], [857.969,695.921], [872.802,694.651]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[878.393,265.558], [879.13,306.153], [864.052,264.186], [864.832,302.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.13,306.153], [879.858,346.273], [864.832,302.566], [865.604,340.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.858,346.273], [880.577,385.878], [865.604,340.524], [866.366,378.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.577,385.903], [881.287,425.026], [866.366,378.043], [867.12,415.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.287,425.051], [881.989,463.701], [867.12,415.13], [867.865,451.77]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.989,463.726], [882.682,501.912], [867.866,451.793], [868.602,488.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.683,501.936], [883.367,539.666], [868.602,488.039], [869.331,523.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.368,539.69], [884.044,576.973], [869.331,523.876], [870.051,559.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.045,576.996], [884.713,613.839], [870.051,559.309], [870.763,594.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.714,613.862], [885.374,650.272], [870.763,594.346], [871.467,628.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.375,650.295], [886.028,686.281], [871.468,628.993], [872.164,663.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.028,686.281], [886.627,719.277], [872.164,663.236], [872.803,694.651]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[878.393,265.558], [879.13,306.153], [904.313,265.436], [904.886,305.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.13,306.153], [879.858,346.273], [904.886,305.834], [905.453,345.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.858,346.273], [880.577,385.878], [905.453,345.763], [906.013,385.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.577,385.903], [881.287,425.026], [906.013,385.206], [906.566,424.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.288,425.051], [906.567,424.171], [881.989,463.701], [907.113,462.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.989,463.726], [907.113,462.668], [882.682,501.912], [907.653,500.68]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.683,501.936], [907.653,500.704], [883.367,539.666], [908.186,538.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.368,539.69], [908.186,538.289], [884.044,576.973], [908.713,575.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.045,576.996], [908.714,575.429], [884.713,613.839], [909.234,612.11]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.714,613.862], [909.235,612.133], [885.375,650.272], [909.749,648.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.375,650.295], [909.75,648.409], [886.028,686.281], [910.258,684.241]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.028,686.281], [910.258,684.241], [886.627,719.277], [910.725,717.098]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[921.525,269.539], [922.07,316.544], [902.544,267.732], [903.182,311.83]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[913.685,270.828], [914.312,319.904], [902.104,269.646], [902.791,316.822]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.312,319.903], [914.93,368.28], [902.791,316.822], [903.467,363.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.93,368.28], [915.539,415.912], [903.467,363.354], [904.134,409.195]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.539,415.942], [916.139,462.876], [904.134,409.224], [904.791,454.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.139,462.906], [916.73,509.158], [904.792,454.448], [905.44,499.011]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.73,509.187], [917.313,554.77], [905.44,499.04], [906.079,542.983]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.313,554.799], [917.887,599.729], [906.08,543.011], [906.71,586.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.888,599.758], [918.454,644.048], [906.71,586.375], [907.332,629.118]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.454,644.076], [919.012,687.74], [907.332,629.145], [907.945,671.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.012,687.768], [919.562,730.819], [907.945,671.333], [908.55,712.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.563,730.847], [920.105,773.298], [908.551,712.95], [909.147,753.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.105,773.298], [920.601,812.137], [909.147,753.982], [909.694,791.541]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[942.034,271.995], [942.465,322.943], [929.74,270.806], [930.246,319.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[942.465,322.943], [942.889,373.137], [930.246,319.844], [930.746,368.185]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[942.889,373.137], [943.307,422.531], [930.746,368.186], [931.237,415.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[943.307,422.562], [943.718,471.205], [931.238,415.814], [931.722,462.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[943.719,471.236], [944.124,519.145], [931.722,462.745], [932.2,508.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.124,519.175], [944.523,566.366], [932.2,508.993], [932.67,554.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.523,566.396], [944.916,612.886], [932.671,554.574], [933.134,599.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.916,612.916], [945.304,658.72], [933.135,599.502], [933.592,643.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.304,658.749], [945.685,703.882], [933.592,643.791], [934.043,687.427]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.686,703.911], [946.062,748.388], [934.043,687.454], [934.487,730.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.062,748.416], [946.432,792.251], [934.488,730.505], [934.926,772.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.432,792.251], [946.771,832.337], [934.926,772.929], [935.327,811.744]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[942.034,271.995], [942.465,322.943], [963.467,271.867], [963.73,322.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[942.465,322.943], [942.889,373.137], [963.73,322.609], [963.99,372.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[942.889,373.137], [963.99,372.603], [943.307,422.531], [964.245,421.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[943.307,422.562], [964.245,421.835], [943.718,471.205], [964.496,470.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[943.719,471.236], [964.496,470.321], [944.124,519.145], [964.743,518.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.124,519.175], [964.744,518.078], [944.523,566.366], [964.987,565.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.523,566.396], [964.987,565.123], [944.916,612.886], [965.228,611.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.916,612.916], [965.228,611.471], [945.303,658.72], [965.464,657.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.304,658.749], [965.464,657.138], [945.685,703.882], [965.698,702.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.686,703.911], [965.698,702.139], [946.062,748.388], [965.927,746.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.062,748.416], [965.928,746.488], [946.432,792.251], [966.154,790.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.432,792.251], [966.154,790.172], [946.771,832.337], [966.361,830.121]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[990.116,274.275], [990.177,328.878], [963.468,271.867], [963.731,322.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.177,328.878], [990.237,382.612], [963.73,322.609], [963.99,372.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.237,382.613], [990.296,435.432], [963.99,372.603], [964.245,421.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.296,435.465], [990.354,487.425], [964.245,421.835], [964.496,470.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.354,487.458], [990.411,538.579], [964.496,470.321], [964.744,518.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.411,538.611], [990.468,588.914], [964.744,518.078], [964.988,565.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.468,588.946], [990.523,638.45], [964.988,565.123], [965.228,611.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.523,638.481], [990.578,687.204], [965.228,611.471], [965.465,657.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.578,687.235], [990.631,735.197], [965.465,657.138], [965.698,702.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.631,735.227], [990.684,782.444], [965.698,702.139], [965.928,746.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.684,782.474], [990.736,828.965], [965.928,746.488], [966.154,790.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.736,828.965], [990.783,871.44], [966.154,790.172], [966.361,830.122]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[990.116,274.275], [990.177,328.878], [1040.67,273.948], [1040.31,328.026]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.177,328.878], [990.237,382.612], [1040.31,328.025], [1039.96,381.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.237,382.613], [990.296,435.432], [1039.96,381.252], [1039.61,433.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.296,435.465], [990.354,487.425], [1039.61,433.613], [1039.27,485.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.354,487.458], [990.411,538.579], [1039.27,485.131], [1038.94,535.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.411,538.611], [990.467,588.914], [1038.94,535.824], [1038.61,585.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.468,588.946], [1038.61,585.714], [990.523,638.449], [1038.28,634.787]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.523,638.481], [1038.28,634.818], [990.577,687.204], [1037.97,683.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.577,687.235], [1037.97,683.156], [990.631,735.197], [1037.65,730.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.631,735.227], [1037.65,730.744], [990.684,782.444], [1037.34,777.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.684,782.474], [1037.34,777.601], [990.736,828.965], [1037.04,823.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.736,828.965], [1037.04,823.714], [990.783,871.44], [1036.76,865.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.94,742.76], [1047.54,790.631], [1037.65,730.744], [1037.34,777.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.54,790.662], [1047.15,837.785], [1037.34,777.601], [1037.04,823.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.15,837.785], [1046.8,880.829], [1037.04,823.714], [1036.76,865.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.17,594.38], [1048.76,644.606], [1038.61,585.714], [1038.28,634.787]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.76,644.638], [1048.35,694.06], [1038.28,634.818], [1037.97,683.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.35,694.091], [1047.94,742.729], [1037.97,683.156], [1037.65,730.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.47,438.581], [1050.03,491.339], [1039.61,433.613], [1039.27,485.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.03,491.373], [1049.6,543.266], [1039.27,485.131], [1038.94,535.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.6,543.298], [1049.17,594.348], [1038.94,535.824], [1038.61,585.682]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1051.83,274.827], [1051.37,330.313], [1040.67,273.947], [1040.31,328.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1051.37,330.313], [1050.91,384.902], [1040.31,328.025], [1039.96,381.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.91,384.902], [1050.47,438.547], [1039.96,381.252], [1039.61,433.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.54,790.661], [1106.1,784.385], [1047.15,837.785], [1105.26,831.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.15,837.785], [1105.26,831.024], [1046.8,880.829], [1104.49,873.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.76,644.637], [1048.35,694.06], [1108.69,639.917], [1107.81,688.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.35,694.091], [1047.94,742.729], [1107.81,688.834], [1106.95,736.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.94,742.759], [1106.95,736.984], [1047.54,790.631], [1106.1,784.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.6,543.298], [1049.17,594.348], [1110.5,539.704], [1109.59,590.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.17,594.379], [1048.76,644.606], [1109.59,590.213], [1108.69,639.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.91,384.901], [1050.47,438.547], [1113.31,383.146], [1112.36,436.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.47,438.58], [1050.03,491.339], [1112.36,436.191], [1111.42,488.338]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.03,491.372], [1049.6,543.265], [1111.42,488.37], [1110.5,539.672]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1051.83,274.826], [1051.37,330.313], [1115.27,274.403], [1114.28,329.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1051.37,330.313], [1050.91,384.902], [1114.28,329.213], [1113.31,383.146]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.92,789.757], [1106.1,784.385], [1110.03,836.811], [1105.26,831.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.03,836.811], [1105.26,831.024], [1109.23,879.792], [1104.49,873.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.82,741.927], [1106.95,736.984], [1110.92,789.727], [1106.1,784.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.73,693.333], [1107.81,688.834], [1111.82,741.897], [1106.95,736.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.66,643.957], [1108.69,639.917], [1112.73,693.302], [1107.81,688.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.6,593.779], [1109.59,590.213], [1113.66,643.925], [1108.69,639.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.96,836.693], [1109.16,879.666], [1173.22,829.254], [1171.97,871.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.56,542.78], [1114.6,593.747], [1110.5,539.704], [1109.59,590.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.85,789.647], [1109.96,836.693], [1174.58,782.742], [1173.22,829.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1116.54,490.939], [1115.56,542.747], [1111.42,488.37], [1110.5,539.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.75,741.826], [1110.85,789.617], [1175.97,735.474], [1174.58,782.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1118.53,384.648], [1117.53,438.203], [1113.31,383.146], [1112.36,436.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1117.53,438.236], [1116.54,490.906], [1112.36,436.191], [1111.42,488.338]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.66,693.241], [1111.75,741.796], [1177.37,687.459], [1175.97,735.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.48,330.135], [1118.46,384.618], [1114.28,329.213], [1113.31,383.146]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.59,643.874], [1112.66,693.21], [1178.8,638.682], [1177.38,687.429]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1120.6,274.765], [1119.56,330.154], [1115.27,274.403], [1114.28,329.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.53,593.706], [1113.59,643.843], [1180.26,589.123], [1178.81,638.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.49,542.717], [1114.53,593.674], [1181.73,538.765], [1180.26,589.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1116.46,490.887], [1115.49,542.685], [1183.23,487.586], [1181.73,538.733]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1117.45,438.194], [1116.46,490.854], [1184.76,435.567], [1183.23,487.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1118.46,384.618], [1117.45,438.161], [1186.31,382.687], [1184.76,435.534]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.48,330.135], [1118.46,384.618], [1187.38,328.931], [1185.81,382.696]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1120.52,274.758], [1119.48,330.135], [1189.49,274.292], [1187.88,328.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.03,815.792], [1203.59,810.8], [1158.91,857.414], [1202.18,852.097]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.26,770.25], [1205.14,765.619], [1160.03,815.792], [1203.59,810.8]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.52,723.983], [1161.27,770.221], [1206.72,719.724], [1205.14,765.59]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.79,677.004], [1162.52,723.954], [1208.31,673.13], [1206.72,719.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.08,629.296], [1163.79,676.974], [1209.93,625.819], [1208.31,673.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1166.39,580.842], [1165.08,629.266], [1211.58,577.775], [1209.93,625.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.72,531.624], [1166.39,580.811], [1213.25,528.98], [1211.58,577.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.07,481.624], [1167.72,531.593], [1214.95,479.417], [1213.25,528.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.45,430.823], [1169.07,481.592], [1216.68,429.067], [1214.95,479.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.84,379.202], [1170.45,430.791], [1218.43,377.913], [1216.68,429.036]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1174.7,273.454], [1173.26,326.741], [1222.02,273.143], [1220.21,325.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.26,326.741], [1171.84,379.202], [1220.21,325.934], [1218.43,377.913]]
            },],[{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[860.503,265.282], [861.299,302.993], [857.225,264.447], [858.017,301.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.299,302.993], [862.087,340.292], [858.017,301.057], [858.8,337.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.086,340.292], [862.865,377.139], [858.8,337.279], [859.574,373.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.865,377.162], [863.634,413.587], [859.574,373.096], [860.34,408.493]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[860.503,265.282], [861.299,302.993], [876.238,265.227], [876.942,302.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.635,413.61], [864.395,449.621], [860.34,408.516], [861.097,443.522]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.299,302.993], [876.942,302.865], [862.086,340.292], [877.637,340.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.396,449.644], [865.147,485.247], [861.097,443.544], [861.846,478.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.087,340.292], [877.638,340.093], [862.865,377.139], [878.325,376.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.148,485.27], [865.891,520.473], [861.846,478.187], [862.587,512.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.892,520.495], [866.627,555.305], [862.587,512.452], [863.319,546.323]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.865,377.162], [878.325,376.894], [863.634,413.587], [879.005,413.251]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.635,413.61], [879.005,413.274], [864.395,449.621], [879.677,449.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.627,555.327], [867.354,589.749], [863.32,546.344], [864.044,579.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.396,449.644], [879.677,449.241], [865.148,485.247], [880.342,484.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.355,589.771], [868.073,623.813], [864.045,579.87], [864.761,613.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.148,485.27], [880.342,484.802], [865.891,520.473], [880.999,519.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.074,623.834], [868.785,657.502], [864.762,613.036], [865.47,645.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.785,657.502], [869.437,688.392], [865.47,645.826], [866.121,675.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.892,520.495], [880.999,519.964], [866.627,555.305], [881.649,554.712]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.627,555.327], [881.649,554.734], [867.354,589.749], [882.291,589.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.355,589.771], [882.292,589.118], [868.074,623.813], [882.927,623.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.074,623.834], [882.927,623.122], [868.785,657.502], [883.555,656.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.785,657.502], [883.555,656.732], [869.437,688.392], [884.132,687.569]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[883.629,266.871], [884.328,306.68], [876.238,265.226], [876.942,302.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.328,306.68], [885.018,346.027], [876.942,302.865], [877.637,340.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.018,346.027], [885.7,384.873], [877.638,340.093], [878.325,376.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.701,384.897], [886.374,423.274], [878.325,376.893], [879.005,413.251]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.375,423.298], [887.04,461.214], [879.005,413.274], [879.677,449.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.041,461.238], [887.698,498.703], [879.677,449.241], [880.342,484.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.699,498.726], [888.349,535.747], [880.342,484.802], [880.999,519.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.349,535.77], [888.991,572.354], [880.999,519.965], [881.649,554.712]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.992,572.377], [889.626,608.533], [881.649,554.734], [882.291,589.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.627,608.556], [890.254,644.29], [882.292,589.118], [882.927,623.101]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[883.629,266.872], [884.328,306.68], [909.389,266.776], [909.928,306.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.255,644.313], [890.875,679.634], [882.927,623.122], [883.555,656.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.875,679.634], [891.443,712.023], [883.555,656.732], [884.132,687.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.328,306.68], [885.018,346.027], [909.928,306.458], [910.46,345.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.018,346.027], [910.461,345.683], [885.7,384.873], [910.987,384.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.701,384.897], [910.987,384.433], [886.374,423.274], [911.507,422.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.375,423.298], [911.507,422.716], [887.04,461.214], [912.02,460.518]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[892.811,273.145], [893.587,321.204], [887.202,271.731], [887.989,317.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.041,461.238], [912.021,460.542], [887.699,498.703], [912.528,497.895]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.587,321.204], [894.353,368.585], [887.989,317.934], [888.764,363.512]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.699,498.726], [912.528,497.919], [888.349,535.747], [913.03,534.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.349,535.77], [913.03,534.854], [888.992,572.354], [913.525,571.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.353,368.586], [895.106,415.244], [888.764,363.512], [889.528,408.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.107,415.274], [895.849,461.254], [889.529,408.448], [890.282,452.728]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.992,572.377], [913.526,571.354], [889.627,608.533], [914.015,607.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.627,608.556], [914.016,607.429], [890.254,644.29], [914.5,643.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.85,461.283], [896.582,506.601], [890.283,452.756], [891.026,496.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.255,644.313], [914.5,643.085], [890.875,679.634], [914.978,678.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.583,506.63], [897.304,551.298], [891.026,496.45], [891.759,539.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.875,679.634], [914.978,678.307], [891.443,712.023], [915.417,710.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.305,551.327], [898.016,595.36], [891.759,539.541], [892.482,582.016]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.016,595.388], [898.718,638.8], [892.483,582.042], [893.196,623.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.718,638.828], [899.409,681.632], [893.196,623.966], [893.899,665.298]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.41,681.659], [900.092,723.866], [893.9,665.324], [894.594,706.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.092,723.893], [900.765,765.518], [894.594,706.127], [895.279,746.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.765,765.518], [901.38,803.604], [895.279,746.361], [895.905,783.193]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[914.766,274.58], [915.404,324.522], [908.495,273.155], [909.155,321.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.404,324.521], [916.032,373.729], [909.155,321.226], [909.806,368.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.032,373.73], [916.651,422.159], [909.806,368.62], [910.447,415.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.651,422.19], [917.26,469.889], [910.447,415.32], [911.079,461.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.26,469.919], [917.86,516.904], [911.079,461.341], [911.702,506.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.861,516.933], [918.452,563.22], [911.702,506.699], [912.316,551.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.452,563.249], [919.034,608.853], [912.316,551.407], [912.921,595.451]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.034,608.882], [919.608,653.817], [912.921,595.479], [913.518,638.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.609,653.846], [920.174,698.129], [913.518,638.929], [914.106,681.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.174,698.157], [920.732,741.8], [914.106,681.769], [914.686,723.987]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[914.766,274.58], [915.404,324.522], [936.233,274.48], [936.703,324.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.404,324.521], [936.703,324.289], [916.032,373.729], [937.167,373.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.732,741.828], [921.281,784.846], [914.686,724.014], [915.258,765.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.281,784.846], [921.783,824.189], [915.258,765.647], [915.781,803.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.032,373.73], [937.167,373.369], [916.651,422.159], [937.624,421.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.651,422.19], [937.624,421.705], [917.26,469.889], [938.074,469.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.26,469.919], [938.074,469.314], [917.86,516.904], [938.517,516.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.861,516.933], [938.518,516.212], [918.451,563.22], [938.954,562.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.452,563.249], [938.954,562.415], [919.034,608.853], [939.384,607.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.034,608.882], [939.385,607.937], [919.608,653.817], [939.808,652.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.609,653.846], [939.808,652.795], [920.174,698.129], [940.226,696.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.174,698.157], [940.226,697.003], [920.731,741.8], [940.638,740.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.732,741.828], [940.638,740.574], [921.281,784.846], [941.044,783.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.281,784.846], [941.044,783.495], [921.783,824.189], [941.415,822.75]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[950.66,277.374], [951.048,330.975], [936.233,274.48], [936.704,324.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.048,330.974], [951.429,383.728], [936.703,324.289], [937.167,373.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.429,383.728], [951.804,435.588], [937.168,373.369], [937.624,421.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.804,435.621], [952.173,486.643], [937.625,421.705], [938.074,469.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.173,486.675], [952.536,536.879], [938.074,469.314], [938.518,516.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.536,536.91], [952.893,586.315], [938.518,516.212], [938.954,562.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.893,586.346], [953.245,634.971], [938.954,562.415], [939.385,607.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.245,635.001], [953.591,682.864], [939.385,607.938], [939.808,652.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.591,682.895], [953.932,730.013], [939.809,652.795], [940.226,696.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.932,730.043], [954.267,776.436], [940.227,697.003], [940.638,740.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.267,776.465], [954.598,822.147], [940.638,740.574], [941.044,783.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.598,822.147], [954.899,863.887], [941.044,783.495], [941.415,822.75]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[950.66,277.374], [951.048,330.975], [1001.71,277.116], [1001.67,330.379]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.048,330.974], [951.429,383.728], [1001.67,330.379], [1001.64,382.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.429,383.728], [951.804,435.588], [1001.64,382.805], [1001.6,434.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.804,435.621], [1001.6,434.382], [952.173,486.643], [1001.57,485.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.173,486.675], [1001.57,485.13], [952.536,536.879], [1001.54,535.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.536,536.91], [1001.54,535.069], [952.893,586.315], [1001.5,584.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.893,586.346], [1001.5,584.218], [953.245,634.971], [1001.47,632.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.245,635.001], [1001.47,632.596], [953.591,682.864], [1001.44,680.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.591,682.894], [1001.44,680.221], [953.931,730.013], [1001.41,727.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.932,730.043], [1001.41,727.11], [954.267,776.436], [1001.38,773.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.267,776.465], [1001.38,773.28], [954.597,822.147], [1001.35,818.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.597,822.147], [1001.35,818.719], [954.899,863.887], [1001.32,860.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.04,491.496], [1007.95,542.622], [1001.57,485.13], [1001.54,535.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.95,542.654], [1007.87,592.95], [1001.54,535.069], [1001.5,584.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.87,592.982], [1007.78,642.469], [1001.5,584.218], [1001.47,632.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.78,642.501], [1007.7,691.198], [1001.47,632.596], [1001.44,680.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.7,691.229], [1007.62,739.156], [1001.44,680.221], [1001.41,727.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.62,739.187], [1007.54,786.361], [1001.41,727.11], [1001.38,773.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.54,786.391], [1007.46,832.83], [1001.38,773.28], [1001.35,818.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.46,832.83], [1007.39,875.249], [1001.35,818.719], [1001.32,860.24]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1008.4,278.18], [1008.31,332.835], [1001.71,277.116], [1001.67,330.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.31,332.835], [1008.22,386.608], [1001.67,330.379], [1001.64,382.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.22,386.609], [1008.13,439.455], [1001.64,382.805], [1001.6,434.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.13,439.488], [1008.04,491.463], [1001.6,434.382], [1001.57,485.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.54,786.39], [1067.15,782.258], [1007.46,832.829], [1066.62,828.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.46,832.829], [1066.62,828.383], [1007.39,875.249], [1066.12,870.52]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1008.4,278.18], [1008.31,332.835], [1073.05,277.844], [1072.41,332.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.31,332.835], [1008.22,386.608], [1072.41,332.06], [1071.79,385.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.22,386.608], [1008.13,439.455], [1071.79,385.408], [1071.18,437.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.13,439.488], [1008.04,491.463], [1071.18,437.877], [1070.58,489.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1008.04,491.496], [1007.95,542.621], [1070.57,489.487], [1069.98,540.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.95,542.653], [1007.87,592.95], [1069.98,540.261], [1069.4,590.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.87,592.981], [1069.4,590.218], [1007.78,642.469], [1068.82,639.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.78,642.5], [1068.82,639.377], [1007.7,691.198], [1068.26,687.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.7,691.229], [1068.26,687.758], [1007.62,739.156], [1067.7,735.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1007.62,739.186], [1067.7,735.379], [1007.54,786.36], [1067.16,782.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.75,834.233], [1066.62,828.383], [1069.23,876.742], [1066.12,870.52]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.9,740.388], [1067.7,735.379], [1070.32,787.665], [1067.16,782.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.32,787.694], [1067.15,782.258], [1069.75,834.233], [1066.62,828.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.09,643.486], [1068.82,639.377], [1071.49,692.294], [1068.26,687.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.49,692.324], [1068.26,687.758], [1070.9,740.358], [1067.7,735.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.31,543.409], [1072.69,593.823], [1069.98,540.261], [1069.4,590.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.69,593.854], [1069.4,590.218], [1072.09,643.455], [1068.82,639.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.72,834.114], [1134.68,829.181], [1069.2,876.616], [1133.71,871.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.94,492.13], [1073.31,543.377], [1070.57,489.488], [1069.98,540.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.86,740.286], [1136.84,736.063], [1070.28,787.554], [1135.76,782.971]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.28,787.584], [1135.75,783], [1069.72,834.114], [1134.68,829.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.22,386.987], [1074.57,439.963], [1071.79,385.408], [1071.18,437.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.57,439.996], [1073.94,492.097], [1071.18,437.877], [1070.57,489.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.45,692.232], [1137.95,688.381], [1070.86,740.256], [1136.84,736.033]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1076.55,278.286], [1075.88,333.08], [1073.05,277.844], [1072.41,332.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.84,333.059], [1075.18,386.955], [1072.41,332.06], [1071.79,385.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.65,593.78], [1072.05,643.372], [1140.21,590.714], [1139.07,639.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.05,643.403], [1071.45,692.201], [1139.07,639.938], [1137.95,688.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.89,492.076], [1073.27,543.313], [1142.55,489.848], [1141.37,540.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.27,543.345], [1072.65,593.749], [1141.37,540.691], [1140.21,590.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.53,439.953], [1073.9,492.044], [1143.75,438.166], [1142.55,489.816]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.84,333.059], [1075.18,386.955], [1145.69,332.202], [1144.46,385.628]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.18,386.955], [1074.53,439.92], [1144.97,385.623], [1143.75,438.133]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1076.51,278.277], [1075.84,333.059], [1147.46,277.904], [1146.2,332.199]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.27,815.442], [1170.26,812.109], [1124.38,856.753], [1169.06,853.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.25,770.235], [1171.57,767.14], [1125.27,815.442], [1170.26,812.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.24,724.306], [1172.9,721.456], [1126.25,770.207], [1171.57,767.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.24,677.666], [1174.25,675.068], [1127.24,724.277], [1172.9,721.427]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1129.26,630.298], [1175.62,627.962], [1128.24,677.636], [1174.25,675.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1130.3,582.185], [1129.26,630.268], [1177.01,580.119], [1175.62,627.932]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.35,533.31], [1130.3,582.154], [1178.42,531.522], [1177.01,580.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.42,483.654], [1131.35,533.279], [1179.86,482.154], [1178.42,531.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.51,433.198], [1132.42,483.622], [1181.32,431.995], [1179.86,482.122]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1136.87,276.869], [1135.73,329.809], [1185.84,276.619], [1184.31,329.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.61,381.923], [1133.51,433.166], [1182.8,381.028], [1181.32,431.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.73,329.809], [1134.61,381.923], [1184.31,329.231], [1182.8,381.028]]
            },],[{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[873.134,266.248], [888.642,266.218], [873.85,303.291], [889.268,303.226]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[873.56,274.973], [874.469,322.095], [873.678,273.407], [874.551,318.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.469,322.095], [875.364,368.559], [874.551,318.724], [875.411,363.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.85,303.291], [889.268,303.226], [874.557,339.933], [889.887,339.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.558,339.933], [889.887,339.834], [875.257,376.134], [890.498,376.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.364,368.56], [876.246,414.324], [875.411,363.435], [876.26,407.495]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.257,376.157], [890.498,376.026], [875.949,411.949], [891.103,411.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.247,414.353], [877.116,459.46], [876.26,407.523], [877.097,450.975]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.949,411.971], [891.103,411.808], [876.633,447.36], [891.701,447.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.633,447.382], [891.701,447.187], [877.309,482.375], [892.293,482.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.117,459.488], [877.974,503.952], [877.097,451.003], [877.922,493.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.309,482.397], [892.293,482.171], [877.978,517], [892.877,516.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.974,503.98], [878.819,547.815], [877.923,493.886], [878.737,536.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.978,517.022], [892.878,516.765], [878.639,551.241], [893.456,550.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.64,551.263], [893.456,550.977], [879.293,585.106], [894.028,584.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.654,591.088], [880.475,633.704], [879.541,577.91], [880.333,619.049]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.294,585.127], [894.028,584.813], [879.94,618.599], [894.594,618.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.476,633.731], [881.286,675.755], [880.333,619.075], [881.115,659.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.941,618.62], [894.594,618.278], [880.58,651.728], [895.153,651.358]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.58,651.728], [895.153,651.358], [881.167,682.107], [895.666,681.712]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.286,675.782], [882.085,717.228], [881.115,659.69], [881.886,699.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.086,717.254], [882.874,758.134], [881.887,699.767], [882.648,739.29]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[889.212,276.604], [910.477,276.55], [890.038,325.603], [911.139,325.486]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[889.212,276.604], [890.038,325.603], [888.737,275.023], [889.535,322.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.038,325.603], [890.851,373.891], [889.535,322.202], [890.322,368.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.038,325.603], [911.139,325.486], [890.851,373.891], [911.792,373.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.851,373.891], [891.652,421.423], [890.322,368.723], [891.097,414.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.851,373.891], [911.792,373.713], [891.652,421.423], [912.434,421.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.652,421.453], [892.441,468.276], [891.098,414.57], [891.862,459.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.652,421.453], [912.435,421.216], [892.441,468.276], [913.068,467.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.441,468.305], [913.068,468.012], [893.219,514.435], [913.692,514.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.441,468.305], [893.219,514.435], [891.862,459.759], [892.615,504.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.219,514.464], [893.985,559.915], [892.615,504.302], [893.358,548.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.219,514.464], [913.692,514.115], [893.985,559.915], [914.307,559.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.985,559.944], [894.74,604.731], [893.358,548.214], [894.09,591.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.985,559.944], [914.307,559.541], [894.74,604.731], [914.913,604.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.74,604.76], [895.483,648.898], [894.091,591.508], [894.812,634.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.74,604.76], [914.913,604.305], [895.483,648.898], [915.51,648.393]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.484,648.926], [915.51,648.421], [896.217,692.43], [916.098,691.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.484,648.926], [896.217,692.43], [894.813,634.197], [895.524,676.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.217,692.458], [896.94,735.341], [895.525,676.294], [896.227,717.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.217,692.458], [916.099,691.903], [896.94,735.341], [916.678,734.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.94,735.368], [897.652,777.642], [896.227,717.81], [896.919,758.733]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.94,735.368], [916.679,734.765], [897.652,777.642], [917.25,776.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.652,777.642], [898.304,816.311], [896.919,758.733], [897.552,796.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.652,777.642], [917.25,776.993], [898.304,816.311], [917.773,815.62]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[913.076,279.767], [913.768,332.401], [910.477,276.55], [911.139,325.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[913.768,332.401], [914.448,384.212], [911.139,325.486], [911.792,373.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[914.448,384.212], [915.118,435.154], [911.792,373.713], [912.435,421.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.118,435.186], [915.777,485.314], [912.435,421.216], [913.068,467.982]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[913.076,279.767], [963.939,279.627], [913.768,332.401], [964.213,332.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.777,485.345], [916.425,534.676], [913.068,468.012], [913.692,514.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[913.768,332.401], [964.213,332.1], [914.448,384.212], [964.482,383.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[914.448,384.212], [964.483,383.755], [915.118,435.154], [964.747,434.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.425,534.707], [917.063,583.261], [913.692,514.115], [914.307,559.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.064,583.292], [917.692,631.086], [914.307,559.541], [914.913,604.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.118,435.186], [964.748,434.579], [915.776,485.314], [965.008,484.56]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.692,631.117], [918.31,678.17], [914.913,604.305], [915.51,648.393]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.311,678.2], [918.919,724.528], [915.51,648.421], [916.098,691.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.777,485.345], [965.008,484.592], [916.425,534.676], [965.265,533.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.425,534.707], [965.265,533.813], [917.063,583.261], [965.518,582.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.92,724.558], [919.519,770.179], [916.099,691.903], [916.679,734.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.064,583.292], [965.518,582.26], [917.691,631.086], [965.767,629.923]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.519,770.208], [920.11,815.138], [916.679,734.765], [917.251,776.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.109,815.138], [920.649,856.196], [917.25,776.994], [917.773,815.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.692,631.117], [965.767,629.953], [918.31,678.17], [966.012,676.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.31,678.2], [966.012,676.908], [918.919,724.528], [966.253,723.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.919,724.558], [966.253,723.142], [919.519,770.179], [966.49,768.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.519,770.208], [966.49,768.672], [920.109,815.138], [966.724,813.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.109,815.138], [966.724,813.485], [920.649,856.196], [966.938,854.439]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.249,280.817], [966.51,334.655], [963.939,279.627], [964.213,332.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.511,334.656], [966.768,387.632], [964.213,332.1], [964.482,383.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.768,387.633], [967.021,439.703], [964.483,383.755], [964.747,434.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.021,439.736], [967.27,490.953], [964.747,434.579], [965.008,484.56]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.27,490.986], [967.515,541.371], [965.008,484.592], [965.265,533.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.515,541.403], [967.755,590.977], [965.265,533.813], [965.518,582.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.756,591.009], [967.993,639.791], [965.518,582.261], [965.766,629.923]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.249,280.816], [966.511,334.655], [1031.19,280.632], [1030.91,334.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.511,334.656], [966.768,387.632], [1030.91,334.261], [1030.63,387.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.993,639.822], [968.226,687.831], [965.767,629.953], [966.011,676.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.226,687.862], [968.456,735.116], [966.012,676.908], [966.253,723.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.456,735.146], [968.682,781.663], [966.253,723.142], [966.49,768.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.682,781.692], [968.904,827.489], [966.49,768.672], [966.724,813.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.768,387.632], [1030.63,387.034], [967.021,439.703], [1030.36,438.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.021,439.735], [1030.36,438.94], [967.27,490.953], [1030.09,489.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.27,490.985], [1030.09,489.999], [967.515,541.371], [1029.83,540.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.515,541.403], [1029.83,540.232], [967.756,590.977], [1029.57,589.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.904,827.489], [969.108,869.326], [966.724,813.485], [966.938,854.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.756,591.008], [1029.57,589.659], [967.993,639.791], [1029.31,638.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.993,639.822], [1029.31,638.3], [968.226,687.831], [1029.06,686.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.226,687.861], [1029.06,686.173], [968.456,735.116], [1028.81,733.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.456,735.145], [1028.81,733.295], [968.682,781.662], [1028.57,779.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.682,781.692], [1028.57,779.685], [968.905,827.489], [1028.33,825.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.905,827.489], [1028.33,825.331], [969.108,869.326], [1028.11,867.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.09,785.126], [1028.57,779.685], [1029.83,831.181], [1028.33,825.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.83,831.181], [1028.33,825.331], [1029.6,873.251], [1028.11,867.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.14,593.318], [1030.87,642.396], [1029.57,589.659], [1029.31,638.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.87,642.427], [1029.31,638.3], [1030.61,690.722], [1029.06,686.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.61,690.752], [1029.06,686.173], [1030.34,738.282], [1028.81,733.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.34,738.312], [1028.81,733.295], [1030.09,785.097], [1028.57,779.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.27,388.657], [1031.98,441.065], [1030.63,387.034], [1030.36,438.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.98,441.098], [1031.7,492.642], [1030.36,438.94], [1030.09,489.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.7,492.674], [1031.42,543.375], [1030.09,489.999], [1029.83,540.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.42,543.407], [1031.14,593.287], [1029.83,540.232], [1029.57,589.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.6,690.66], [1097.98,688.771], [1030.34,738.182], [1097.19,736.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.34,738.211], [1097.19,736.142], [1030.08,784.987], [1096.41,782.743]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.08,785.016], [1096.41,782.772], [1029.83,831.064], [1095.64,828.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.83,831.064], [1095.64,828.651], [1029.59,873.126], [1094.94,870.562]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1032.87,281.131], [1032.57,335.331], [1031.19,280.632], [1030.91,334.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.56,335.31], [1032.27,388.625], [1030.91,334.261], [1030.63,387.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.69,492.62], [1101.28,491.516], [1031.41,543.312], [1100.43,542.002]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.41,543.343], [1100.43,542.033], [1031.14,593.213], [1099.6,591.704]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.14,593.244], [1099.6,591.735], [1030.87,642.313], [1098.78,640.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.87,642.344], [1098.78,640.641], [1030.6,690.63], [1097.98,688.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.56,335.31], [1032.27,388.625], [1103.38,334.868], [1102.5,387.955]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.27,388.625], [1031.98,441.021], [1103.01,387.955], [1102.14,440.131]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.98,441.054], [1031.69,492.588], [1102.14,440.164], [1101.28,491.484]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1032.86,281.121], [1032.56,335.31], [1104.8,280.915], [1103.9,334.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.06,814.779], [1135.91,813.137], [1089.41,855.814], [1134.95,854.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.77,769.874], [1136.97,768.348], [1090.06,814.778], [1135.91,813.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.21,677.918], [1139.12,676.635], [1091.49,724.221], [1138.04,722.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.48,724.25], [1138.04,722.843], [1090.77,769.845], [1136.97,768.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.95,630.863], [1140.23,629.707], [1092.21,677.889], [1139.12,676.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.71,583.067], [1141.35,582.043], [1092.95,630.833], [1140.23,629.678]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.47,534.513], [1142.49,533.624], [1093.71,583.037], [1141.35,582.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.03,435.054], [1095.25,485.15], [1144.82,434.451], [1143.64,484.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.25,485.181], [1143.64,484.433], [1094.47,534.482], [1142.49,533.593]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1098.48,279.736], [1097.65,332.335], [1148.46,279.597], [1147.23,332.036]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.84,384.112], [1096.04,435.022], [1146.01,383.658], [1144.82,434.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.65,332.335], [1096.84,384.112], [1147.23,332.036], [1146.01,383.658]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.14,775.711], [1139.64,775.025], [1118.35,814.255], [1138.72,813.526]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120,733.574], [1140.65,732.937], [1119.14,775.711], [1139.64,775.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120.88,690.806], [1141.67,690.22], [1120,733.547], [1140.65,732.91]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.77,647.421], [1142.71,646.887], [1120.88,690.779], [1141.67,690.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.68,603.405], [1143.77,602.924], [1121.77,647.393], [1142.71,646.859]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.59,558.744], [1144.84,558.318], [1122.68,603.377], [1143.77,602.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1124.52,513.424], [1145.93,513.056], [1123.59,558.716], [1144.84,558.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.47,467.431], [1147.03,467.121], [1124.52,513.395], [1145.93,513.026]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.43,420.749], [1148.15,420.499], [1125.47,467.402], [1147.03,467.091]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.4,373.362], [1149.28,373.174], [1126.43,420.719], [1148.15,420.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.39,325.255], [1127.4,373.362], [1150.43,325.131], [1149.28,373.174]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1129.39,276.442], [1128.39,325.255], [1151.6,276.385], [1150.43,325.131]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[886.244,278.055], [865.388,278.053], [887.08,326.198], [866.381,326.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[887.08,326.198], [866.381,326.194], [887.904,373.652], [867.359,373.646]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[887.904,373.652], [867.359,373.647], [888.715,420.374], [868.323,420.366]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[888.716,420.404], [868.323,420.396], [889.515,466.438], [869.273,466.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[889.516,466.467], [869.273,466.457], [890.303,511.828], [870.208,511.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.304,511.857], [870.209,511.845], [891.08,556.561], [871.131,556.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.081,556.589], [871.132,556.576], [891.846,600.65], [872.04,600.634]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.846,600.677], [872.041,600.662], [892.6,644.108], [872.936,644.091]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.601,644.136], [872.937,644.119], [893.344,686.95], [873.82,686.931]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.345,686.977], [873.82,686.958], [894.078,729.188], [874.691,729.167]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.078,729.214], [874.691,729.194], [894.801,770.835], [875.549,770.813]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.801,770.835], [875.549,770.813], [895.462,808.911], [876.335,808.888]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[927.587,281.423], [928.152,333.158], [877.515,281.418], [878.484,333.148]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.152,333.158], [878.484,333.148], [928.708,384.096], [879.439,384.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.708,384.096], [879.439,384.081], [929.255,434.191], [880.377,434.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.255,434.223], [880.378,434.202], [929.793,483.527], [881.302,483.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.794,483.558], [881.302,483.533], [930.323,532.09], [882.212,532.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.324,532.121], [882.212,532.09], [930.845,579.897], [883.107,579.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.845,579.928], [883.108,579.893], [931.359,626.968], [883.989,626.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.359,626.997], [883.99,626.958], [931.865,673.317], [884.858,673.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.865,673.346], [884.858,673.303], [932.363,718.962], [885.713,718.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.363,718.991], [885.713,718.944], [932.854,763.919], [886.555,763.867]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.854,763.948], [886.556,763.896], [933.337,808.203], [887.385,808.148]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[933.337,808.203], [887.385,808.148], [933.778,848.653], [888.143,848.594]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[990.048,282.679], [925.652,282.672], [990.109,335.754], [926.247,335.74]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.109,335.754], [926.247,335.74], [990.169,387.988], [926.833,387.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.17,387.988], [926.833,387.967], [990.229,439.337], [927.41,439.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.229,439.369], [927.41,439.342], [990.287,489.887], [927.976,489.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.287,489.918], [927.977,489.885], [990.345,539.624], [928.534,539.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.345,539.655], [928.535,539.616], [990.401,588.569], [929.083,588.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.401,588.599], [929.084,588.554], [990.457,636.74], [929.624,636.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.457,636.77], [929.624,636.719], [990.512,684.155], [930.156,684.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.512,684.185], [930.156,684.128], [990.566,730.832], [930.679,730.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.566,730.862], [930.68,730.799], [990.619,776.789], [931.195,776.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.619,776.817], [931.195,776.75], [990.671,822.04], [931.702,821.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.671,822.041], [931.702,821.968], [990.719,863.36], [932.166,863.283]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[989.954,283.196], [1061.91,283.204], [990.016,336.822], [1061.37,336.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.016,336.822], [1060.86,336.834], [990.078,389.589], [1060.33,389.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.078,389.588], [1060.84,389.612], [990.139,441.453], [1060.32,441.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.139,441.485], [1060.32,441.516], [990.198,492.501], [1059.8,492.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.198,492.532], [1059.8,492.57], [990.257,542.72], [1059.3,542.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.257,542.752], [1059.3,542.796], [990.315,592.131], [1058.8,592.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.315,592.162], [1058.8,592.214], [990.372,640.753], [1058.31,640.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.372,640.784], [1058.31,640.842], [990.428,688.605], [1057.83,688.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.428,688.635], [1057.83,688.699], [990.483,735.705], [1057.35,735.775]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.483,735.734], [1057.35,735.805], [990.537,782.07], [1056.88,782.146]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.537,782.099], [1056.88,782.175], [990.591,827.717], [1056.42,827.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[990.591,827.718], [1056.42,827.799], [990.64,869.392], [1056,869.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1054.68,813.931], [1100.86,813.988], [1054.28,854.742], [1100.14,854.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.01,677.832], [1103.26,677.876], [1055.56,723.875], [1102.45,723.923]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.56,723.904], [1102.45,723.952], [1055.12,769.246], [1101.65,769.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.12,769.275], [1101.65,769.327], [1054.68,813.931], [1100.86,813.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.93,583.516], [1104.92,583.551], [1056.47,631.011], [1104.09,631.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.47,631.041], [1104.08,631.081], [1056.01,677.802], [1103.26,677.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.88,486.189], [1106.64,486.215], [1057.4,535.207], [1105.77,535.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.4,535.238], [1105.77,535.268], [1056.93,583.485], [1104.92,583.521]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1061.39,283.202], [1060.86,336.833], [1059.87,281.941], [1059.36,334.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1059.36,334.231], [1109.32,334.242], [1058.86,385.705], [1108.41,385.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.86,385.705], [1108.41,385.721], [1058.37,436.32], [1107.52,436.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.37,436.351], [1107.52,436.372], [1057.88,486.158], [1106.64,486.184]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1059.87,281.942], [1059.36,334.231], [1110.24,281.947], [1109.32,334.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.65,769.327], [1100.86,813.988], [1095.12,734.388], [1094.43,776.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.43,776.404], [1115.14,776.427], [1093.8,814.836], [1114.38,814.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.82,691.744], [1116.83,691.764], [1095.12,734.361], [1115.98,734.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.12,734.388], [1115.98,734.41], [1094.43,776.403], [1115.14,776.427]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1104.92,583.551], [1104.09,631.051], [1097.98,560.06], [1097.25,604.565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.53,648.483], [1117.69,648.501], [1095.82,691.716], [1116.83,691.737]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.25,604.593], [1118.57,604.61], [1096.53,648.455], [1117.69,648.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.73,514.869], [1120.36,514.882], [1097.99,560.031], [1119.46,560.046]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.98,560.06], [1119.46,560.074], [1097.25,604.565], [1118.57,604.581]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1099.48,469.006], [1121.27,469.017], [1098.73,514.84], [1120.36,514.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.25,422.456], [1122.2,422.464], [1099.48,468.977], [1121.27,468.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.02,375.202], [1123.14,375.209], [1100.25,422.426], [1122.2,422.435]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1102.61,278.554], [1125.07,278.556], [1101.81,327.23], [1124.1,327.235]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1110.24,281.947], [1109.32,334.242], [1102.61,278.554], [1101.81,327.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.81,327.23], [1124.1,327.235], [1101.02,375.202], [1123.14,375.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.48,757.102], [1125.67,794.298], [1121.99,738.299], [1121.24,774.281]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1125.07,278.556], [1124.1,327.235], [1120.31,276.826], [1119.41,323.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.37,716.459], [1126.48,757.102], [1122.82,699.001], [1121.99,738.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.26,675.228], [1127.37,716.433], [1123.65,659.154], [1122.82,698.976]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.17,633.423], [1128.26,675.201], [1124.5,618.773], [1123.65,659.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.03,548.042], [1130.1,591.005], [1126.23,536.365], [1125.36,577.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1130.1,591.032], [1129.18,633.396], [1125.36,577.847], [1124.5,618.747]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.98,504.442], [1131.04,548.015], [1127.11,494.315], [1126.23,536.338]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.95,460.217], [1131.98,504.414], [1128,451.685], [1127.11,494.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.92,415.354], [1132.95,460.188], [1128.91,408.464], [1128,451.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.92,369.839], [1133.93,415.325], [1129.83,364.639], [1128.91,408.436]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.92,323.658], [1134.92,369.839], [1130.76,320.197], [1129.82,364.639]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[863.531,279], [864.522,326.445], [843.264,278.94], [844.403,326.322]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[892.785,282.481], [893.619,333.551], [844.042,282.326], [845.261,333.235]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.522,326.444], [865.499,373.221], [844.403,326.322], [845.526,373.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.619,333.551], [894.44,383.846], [845.261,333.235], [846.461,383.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.499,373.222], [845.526,373.039], [866.461,419.287], [846.633,419.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.44,383.846], [895.248,433.321], [846.461,383.374], [847.641,432.697]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[866.461,419.316], [846.633,419.074], [867.409,464.715], [847.723,464.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.248,433.352], [896.044,482.056], [847.642,432.728], [848.804,481.285]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[867.41,464.744], [847.724,464.444], [868.344,509.489], [848.798,509.134]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.044,482.087], [848.804,481.316], [896.827,530.039], [849.948,529.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[868.344,509.517], [848.799,509.163], [869.265,553.624], [849.858,553.215]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.827,530.069], [849.949,529.156], [897.598,577.285], [851.076,576.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.266,553.652], [849.858,553.243], [870.174,597.134], [850.902,596.673]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.599,577.315], [851.077,576.264], [898.358,623.813], [852.186,622.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.174,597.161], [850.903,596.7], [871.069,640.031], [851.932,639.519]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.359,623.842], [852.187,622.658], [899.106,669.638], [853.279,668.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.07,640.058], [851.933,639.546], [871.952,682.328], [852.948,681.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.107,669.667], [853.28,668.353], [899.843,714.776], [854.357,713.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.953,682.355], [852.948,681.794], [872.823,724.039], [853.949,723.429]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.844,714.804], [854.357,713.366], [900.569,759.242], [855.418,757.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.824,724.065], [853.95,723.456], [873.682,765.174], [854.937,764.518]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.57,759.27], [855.419,757.71], [901.284,803.052], [856.463,801.375]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.682,765.174], [854.937,764.518], [874.468,802.791], [855.84,802.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.284,803.052], [856.463,801.375], [901.938,843.076], [857.419,841.293]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[949.864,283.928], [950.254,336.505], [886.783,283.722], [887.687,336.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.254,336.505], [950.639,388.259], [887.687,336.085], [888.577,387.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.639,388.259], [951.016,439.145], [888.577,387.632], [889.452,438.317]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.017,439.177], [951.388,489.247], [889.453,438.349], [890.314,488.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.389,489.279], [890.315,488.257], [951.754,538.553], [891.162,537.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.755,538.584], [891.163,537.375], [952.115,587.082], [891.997,585.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.115,587.112], [891.997,585.721], [952.469,634.851], [892.819,633.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.469,634.881], [892.819,633.313], [952.818,681.878], [893.628,680.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[952.819,681.907], [893.628,680.17], [953.162,728.181], [894.424,726.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.162,728.21], [894.425,726.307], [953.501,773.776], [895.209,771.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.501,773.804], [895.209,771.742], [953.834,818.679], [895.982,816.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[953.834,818.679], [895.982,816.462], [954.138,859.686], [896.687,857.33]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1019.13,284.68], [1018.95,338.039], [948.056,284.445], [948.465,337.561]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.44,338.032], [1018.27,390.539], [948.465,337.561], [948.868,389.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.77,390.549], [1018.6,442.167], [948.868,389.836], [949.264,441.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.6,442.199], [949.264,441.257], [1018.42,492.978], [949.654,491.815]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.42,493.009], [949.654,491.847], [1018.25,542.969], [950.037,541.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.25,543], [950.038,541.624], [1018.09,592.16], [950.415,590.578]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.09,592.191], [950.415,590.609], [1017.92,640.571], [950.786,638.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.92,640.601], [950.787,638.819], [1017.76,688.219], [951.152,686.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.76,688.249], [951.152,686.274], [1017.6,735.123], [951.512,732.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.6,735.152], [951.512,732.99], [1017.45,781.3], [951.867,778.957]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.45,781.329], [951.867,778.986], [1017.29,826.766], [952.216,824.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.29,826.767], [952.216,824.248], [1017.15,868.28], [952.535,865.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.13,735.121], [1016.98,781.266], [1019.69,723.365], [1019.52,768.524]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1016.98,781.295], [1016.83,826.73], [1019.52,768.552], [1019.36,813.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1016.83,826.73], [1016.69,868.241], [1019.36,813.033], [1019.21,853.686]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.44,338.032], [1018.27,390.539], [1021.14,335.436], [1020.95,386.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.1,442.186], [1017.93,492.961], [1020.76,437.07], [1020.57,486.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.93,492.992], [1017.77,542.949], [1020.57,486.678], [1020.39,535.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.77,542.98], [1017.6,592.137], [1020.39,535.505], [1020.21,583.54]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.6,592.168], [1017.44,640.545], [1020.21,583.57], [1020.04,630.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.44,640.575], [1017.29,688.191], [1020.04,630.89], [1019.86,677.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1017.29,688.22], [1017.13,735.092], [1019.86,677.483], [1019.69,723.336]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1018.62,284.676], [1018.44,338.032], [1021.33,283.404], [1021.14,335.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1018.27,390.539], [1018.1,442.153], [1020.95,386.663], [1020.76,437.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.86,770.169], [1019.52,768.553], [1065.34,814.771], [1019.36,813.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.34,814.771], [1019.36,813.033], [1064.87,855.533], [1019.21,853.686]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.12,487.478], [1020.57,486.678], [1068.56,536.422], [1020.39,535.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.56,536.453], [1020.39,535.505], [1068,584.63], [1020.21,583.54]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068,584.66], [1020.21,583.57], [1067.45,632.089], [1020.04,630.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.45,632.118], [1020.04,630.89], [1066.91,678.815], [1019.86,677.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.91,678.845], [1019.86,677.483], [1066.38,724.827], [1019.69,723.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.38,724.856], [1019.69,723.365], [1065.86,770.141], [1019.52,768.524]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1071.48,283.565], [1070.88,335.765], [1021.33,283.404], [1021.14,335.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.88,335.765], [1021.14,335.436], [1070.28,387.154], [1020.95,386.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.28,387.154], [1020.95,386.663], [1069.7,437.687], [1020.76,437.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.7,437.718], [1020.76,437.07], [1069.12,487.447], [1020.58,486.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.86,770.169], [1065.34,814.771], [1069.78,735.389], [1069.27,777.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.34,814.771], [1064.87,855.533], [1069.27,777.362], [1068.8,815.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.91,678.845], [1066.38,724.828], [1070.82,649.575], [1070.3,692.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.38,724.857], [1065.86,770.141], [1070.29,692.789], [1069.78,735.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068,584.66], [1067.45,632.089], [1071.89,561.253], [1071.35,605.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.45,632.119], [1066.91,678.816], [1071.35,605.734], [1070.82,649.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.56,536.453], [1068,584.63], [1072.44,516.116], [1071.89,561.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.7,437.718], [1069.12,487.447], [1073.56,423.82], [1073,470.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.12,487.478], [1068.56,536.422], [1073,470.31], [1072.44,516.087]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.65,736.07], [1069.78,735.389], [1089.99,778.094], [1069.27,777.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.99,778.095], [1069.27,777.362], [1089.39,816.537], [1068.8,815.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.88,335.765], [1070.28,387.154], [1074.72,328.723], [1074.13,376.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.28,387.154], [1069.7,437.687], [1074.13,376.629], [1073.56,423.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092,650.147], [1070.82,649.575], [1091.32,693.389], [1070.3,692.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.32,693.416], [1070.29,692.789], [1090.65,736.043], [1069.78,735.362]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1071.48,283.565], [1070.88,335.765], [1075.31,280.115], [1074.72,328.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.38,561.71], [1071.89,561.253], [1092.68,606.222], [1071.35,605.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.68,606.25], [1071.35,605.734], [1092,650.12], [1070.82,649.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.8,470.645], [1073,470.31], [1094.09,516.484], [1072.44,516.087]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.09,516.513], [1072.44,516.116], [1093.38,561.681], [1071.89,561.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.53,424.091], [1073.56,423.82], [1094.8,470.616], [1073,470.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.02,328.86], [1074.72,328.723], [1096.27,376.834], [1074.13,376.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.27,376.834], [1074.13,376.629], [1095.53,424.061], [1073.56,423.79]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1097.78,280.182], [1075.31,280.115], [1097.02,328.86], [1074.72,328.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.99,778.095], [1089.39,816.537], [1091.28,758.783], [1090.69,795.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.65,736.07], [1089.99,778.094], [1091.92,718.129], [1091.28,758.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092,650.147], [1091.32,693.389], [1093.24,635.071], [1092.58,676.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.32,693.416], [1090.65,736.043], [1092.58,676.886], [1091.92,718.103]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.68,606.25], [1092,650.12], [1093.91,592.67], [1093.24,635.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.09,516.513], [1093.38,561.681], [1095.28,506.062], [1094.59,549.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.38,561.71], [1092.68,606.222], [1094.59,549.671], [1093.91,592.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.8,470.645], [1094.09,516.484], [1095.98,461.829], [1095.28,506.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.53,424.091], [1094.8,470.616], [1096.69,416.96], [1095.98,461.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.02,328.86], [1096.27,376.834], [1098.14,325.253], [1097.41,371.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.27,376.835], [1095.53,424.061], [1097.41,371.439], [1096.69,416.931]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1097.78,280.183], [1097.02,328.86], [1098.88,278.417], [1098.14,325.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.43,308.551], [1076.87,308.432], [1100.81,346.417], [1076.4,346.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.43,308.551], [1100.81,346.417], [1102.73,304.642], [1102.14,340.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.79,304.711], [1102.73,304.642], [1117.12,340.655], [1102.14,340.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.71,759.309], [1106.03,796.55], [1107.41,740.495], [1106.75,776.523]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1107.57,267.285], [1106.97,302.462], [1108.09,266.361], [1107.5,300.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.46,718.617], [1106.71,759.309], [1108.14,701.146], [1107.41,740.495]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.99,635.482], [1108.22,677.31], [1109.62,620.814], [1108.88,661.222]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.22,677.337], [1107.46,718.591], [1108.88,661.248], [1108.14,701.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.77,593.04], [1108.99,635.454], [1110.38,579.835], [1109.62,620.788]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.96,614.271], [1097.63,613.917], [1111.35,646.804], [1097.1,646.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.35,646.804], [1097.1,646.422], [1110.79,676.661], [1096.61,676.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.57,549.999], [1109.78,593.012], [1111.15,538.299], [1110.38,579.809]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.21,548.101], [1098.72,547.806], [1112.58,581.344], [1098.18,581.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.58,581.365], [1098.18,581.04], [1111.96,614.25], [1097.63,613.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.19,462.069], [1111.37,506.319], [1112.72,453.511], [1111.93,496.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.37,506.347], [1110.57,549.971], [1111.93,496.195], [1111.15,538.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.84,514.473], [1099.28,514.208], [1113.21,548.08], [1098.72,547.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.96,614.271], [1111.35,646.804], [1112.37,603.512], [1111.77,635.184]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.35,646.804], [1110.79,676.661], [1111.77,635.184], [1111.22,664.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.01,417.154], [1112.19,462.041], [1113.51,410.234], [1112.72,453.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.13,446.1], [1100.4,445.897], [1114.48,480.453], [1099.84,480.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.48,480.474], [1099.84,480.24], [1113.84,514.451], [1099.28,514.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.58,581.365], [1111.96,614.25], [1112.97,571.486], [1112.37,603.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.85,371.586], [1113.01,417.125], [1114.33,366.353], [1113.52,410.206]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.79,411.343], [1100.98,411.172], [1115.13,446.078], [1100.4,445.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.84,514.473], [1113.21,548.08], [1114.2,506.412], [1113.58,539.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.21,548.101], [1112.58,581.344], [1113.58,539.121], [1112.97,571.465]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.7,325.351], [1113.85,371.585], [1115.15,321.854], [1114.33,366.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.12,340.655], [1102.14,340.551], [1116.45,376.174], [1101.55,376.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.45,376.196], [1101.55,376.059], [1115.79,411.32], [1100.98,411.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.48,480.474], [1113.84,514.451], [1114.82,473.353], [1114.2,506.391]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.79,411.343], [1115.13,446.078], [1116.09,406.165], [1115.45,439.918]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.13,446.1], [1114.48,480.453], [1115.45,439.94], [1114.82,473.332]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.45,376.197], [1115.79,411.32], [1116.74,372.024], [1116.09,406.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.79,304.711], [1117.12,340.655], [1118.05,302.616], [1117.39,337.509]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[859.591,282.794], [860.67,333.292], [812.648,282.506], [814.085,332.697]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[860.669,333.292], [861.732,383.038], [814.085,332.697], [815.501,382.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[861.732,383.038], [862.778,431.986], [815.501,382.144], [816.895,430.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[862.778,432.017], [863.808,480.216], [816.895,430.833], [818.268,478.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[863.809,480.246], [864.823,527.713], [818.268,478.782], [819.62,525.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.823,527.743], [865.822,574.495], [819.621,526.007], [820.952,572.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.823,574.525], [866.806,620.577], [820.953,572.524], [822.264,618.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[866.807,620.606], [822.265,618.35], [867.776,665.974], [823.557,663.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[867.777,666.003], [823.558,663.5], [868.731,710.703], [824.831,707.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[868.732,710.732], [824.831,707.987], [869.673,754.778], [826.086,751.8]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.674,754.805], [826.087,751.828], [870.601,798.212], [827.323,795.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.601,798.212], [827.323,795.009], [871.449,837.902], [828.454,834.496]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[910.806,284.345], [911.506,336.503], [849.726,283.96], [850.911,335.707]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.506,336.503], [912.196,387.857], [850.911,335.707], [852.077,386.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[912.196,387.856], [912.874,438.361], [852.077,386.663], [853.225,436.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[912.875,438.392], [913.542,488.099], [853.225,436.814], [854.355,486.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[913.542,488.13], [914.199,537.058], [854.355,486.178], [855.467,534.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[914.2,537.089], [914.847,585.256], [855.468,534.775], [856.563,582.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[914.847,585.286], [915.484,632.71], [856.563,582.622], [857.641,629.707]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[915.484,632.739], [916.111,679.437], [857.642,629.737], [858.704,676.106]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.112,679.466], [858.704,676.135], [916.729,725.454], [859.75,721.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.73,725.483], [859.75,721.834], [917.338,770.777], [860.78,766.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.338,770.806], [860.781,766.848], [917.937,815.422], [861.796,811.166]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.937,815.422], [861.796,811.166], [918.485,856.201], [862.723,851.677]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[976.701,285.275], [976.872,338.429], [907.347,284.834], [908.083,337.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.384,338.419], [976.556,390.731], [908.083,337.517], [908.807,389.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.04,390.746], [977.205,442.182], [908.807,389.377], [909.52,440.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.206,442.214], [977.368,492.823], [909.52,440.404], [910.221,490.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.368,492.854], [977.528,542.655], [910.221,490.617], [910.911,540.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.529,542.686], [977.686,591.698], [910.911,540.035], [911.59,588.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.686,591.729], [977.841,639.971], [911.591,588.678], [912.259,636.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.841,640.001], [912.259,636.562], [977.994,687.491], [912.917,683.677]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.994,687.521], [912.918,683.707], [978.144,734.276], [913.566,730.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[978.145,734.305], [913.566,730.128], [978.293,780.343], [914.204,775.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[978.293,780.371], [914.204,775.843], [978.438,825.707], [914.833,820.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[978.438,825.707], [914.833,820.838], [978.572,867.134], [915.407,861.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.384,338.419], [976.556,390.731], [983.182,335.906], [983.295,386.96]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[976.209,285.271], [976.384,338.419], [983.066,284.056], [983.182,335.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.556,390.731], [976.725,442.162], [983.295,386.96], [983.407,437.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.726,442.195], [976.892,492.798], [983.407,437.207], [983.517,486.634]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.892,492.83], [977.056,542.626], [983.517,486.664], [983.626,535.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.056,542.657], [977.217,591.665], [983.626,535.352], [983.733,583.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.218,591.696], [977.376,639.933], [983.733,583.286], [983.838,630.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.376,639.964], [977.533,687.449], [983.838,630.485], [983.941,676.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.533,687.479], [977.687,734.23], [983.941,676.965], [984.043,722.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.687,734.259], [977.838,780.293], [984.043,722.743], [984.144,767.806]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.838,780.322], [977.988,825.654], [984.144,767.834], [984.243,812.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[977.988,825.654], [978.124,867.077], [984.243,812.227], [984.333,852.804]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1032.42,284.362], [1032.14,336.539], [983.066,284.056], [983.182,335.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.14,336.539], [1031.86,387.91], [983.182,335.906], [983.295,386.96]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.86,387.91], [1031.59,438.432], [983.295,386.96], [983.407,437.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.59,438.463], [1031.32,488.187], [983.407,437.207], [983.517,486.634]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.32,488.218], [983.517,486.665], [1031.05,537.162], [983.626,535.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.05,537.192], [983.626,535.352], [1030.79,585.375], [983.733,583.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.79,585.405], [983.733,583.286], [1030.53,632.844], [983.838,630.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.53,632.874], [983.838,630.485], [1030.28,679.586], [983.941,676.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.28,679.615], [983.941,676.965], [1030.03,725.617], [984.043,722.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.03,725.646], [984.043,722.743], [1029.78,770.954], [984.144,767.806]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.78,770.983], [984.144,767.835], [1029.54,815.613], [984.243,812.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.54,815.613], [984.243,812.227], [1029.32,856.404], [984.333,852.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.54,815.613], [1029.32,856.404], [1043.75,778.69], [1043.45,817.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.53,632.874], [1030.28,679.586], [1045.09,606.869], [1044.75,650.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.28,679.615], [1030.03,725.617], [1044.75,650.754], [1044.41,693.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.03,725.646], [1029.78,770.954], [1044.41,694.015], [1044.08,736.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.78,770.983], [1029.54,815.613], [1044.08,736.664], [1043.75,778.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.59,438.463], [1031.32,488.187], [1046.5,424.814], [1046.14,471.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.32,488.218], [1031.05,537.162], [1046.14,471.334], [1045.79,517.145]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.05,537.193], [1030.79,585.375], [1045.79,517.174], [1045.44,562.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.79,585.405], [1030.53,632.844], [1045.44,562.347], [1045.09,606.841]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1032.42,284.362], [1032.14,336.539], [1047.62,281.044], [1047.24,329.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.14,336.539], [1031.86,387.91], [1047.24,329.669], [1046.87,377.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.86,387.91], [1031.59,438.432], [1046.87,377.597], [1046.5,424.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.3,780.125], [1043.75,778.69], [1063.87,818.663], [1043.45,817.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.74,651.874], [1044.75,650.754], [1065.26,695.215], [1044.41,693.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.25,695.243], [1044.41,694.014], [1064.78,737.971], [1044.08,736.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.77,737.998], [1044.08,736.664], [1064.3,780.125], [1043.75,778.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.24,517.95], [1045.79,517.174], [1066.74,563.213], [1045.44,562.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.74,563.241], [1045.44,562.347], [1066.24,607.85], [1045.09,606.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.24,607.878], [1045.09,606.869], [1065.74,651.846], [1044.75,650.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.28,425.342], [1046.5,424.814], [1067.76,471.959], [1046.14,471.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.76,471.988], [1046.14,471.334], [1067.25,517.921], [1045.79,517.145]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1069.9,281.172], [1069.36,329.935], [1047.62,281.044], [1047.24,329.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.36,329.935], [1047.24,329.669], [1068.82,377.996], [1046.87,377.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.82,377.996], [1046.87,377.597], [1068.28,425.312], [1046.5,424.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.77,737.998], [1064.3,780.125], [1071.42,720.229], [1070.92,760.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.3,780.125], [1063.87,818.663], [1070.92,760.995], [1070.46,798.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.74,651.874], [1065.25,695.216], [1072.45,636.952], [1071.93,678.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.25,695.243], [1064.77,737.971], [1071.93,678.877], [1071.43,720.203]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.74,563.242], [1066.24,607.85], [1073.5,551.337], [1072.97,594.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.24,607.878], [1065.74,651.846], [1072.97,594.443], [1072.45,636.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.76,471.988], [1067.25,517.921], [1074.58,463.285], [1074.04,507.594]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.24,517.95], [1066.74,563.213], [1074.04,507.622], [1073.5,551.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.82,377.997], [1068.28,425.312], [1075.7,372.689], [1075.14,418.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.28,425.342], [1067.76,471.959], [1075.14,418.311], [1074.58,463.256]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1069.9,281.172], [1069.36,329.935], [1076.85,279.467], [1076.27,326.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.36,329.935], [1068.82,377.996], [1076.27,326.402], [1075.7,372.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.5,311.26], [1078.02,349.904], [1048.79,310.974], [1048.48,349.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.5,311.26], [1078.02,349.904], [1081.96,309.771], [1081.46,347.661]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.46,310.001], [1105.82,348.008], [1081.96,309.771], [1081.46,347.661]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.57,322.934], [1078.01,367.474], [1089.39,317.547], [1088.79,359.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1086.88,721.189], [1086.28,762.028], [1092.81,703.841], [1092.18,743.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1086.28,762.029], [1085.72,799.405], [1092.18,743.343], [1091.61,779.512]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1087.5,679.761], [1086.88,721.163], [1093.44,663.79], [1092.81,703.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1088.76,595.168], [1088.12,637.731], [1094.73,582.07], [1094.08,623.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1088.12,637.758], [1087.5,679.734], [1094.08,623.203], [1093.44,663.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.05,508.179], [1089.4,551.952], [1096.06,498.121], [1095.39,540.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1089.4,551.98], [1088.76,595.141], [1095.39,540.38], [1094.73,582.044]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.71,463.754], [1090.05,508.151], [1096.74,455.282], [1096.06,498.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.06,372.975], [1091.38,418.662], [1098.12,367.813], [1097.43,411.822]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.38,418.691], [1090.71,463.725], [1097.43,411.85], [1096.74,455.254]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.75,326.592], [1092.06,372.974], [1098.83,323.159], [1098.12,367.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.92,636.609], [1077.68,635.42], [1100.34,670.84], [1077.23,669.556]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.34,670.84], [1077.23,669.556], [1099.81,702.239], [1076.82,700.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.1,566.932], [1078.59,565.938], [1101.51,601.946], [1078.13,600.854]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.51,601.968], [1078.13,600.876], [1100.92,636.588], [1077.68,635.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.7,531.492], [1079.06,530.6], [1102.1,566.909], [1078.59,565.916]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.93,459.378], [1080,458.696], [1103.31,495.621], [1079.53,494.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.31,495.644], [1079.53,494.855], [1102.7,531.47], [1079.06,530.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.18,385.568], [1080.97,385.107], [1104.55,422.666], [1080.48,422.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.55,422.689], [1080.48,422.116], [1103.93,459.355], [1080,458.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.82,348.008], [1081.46,347.661], [1105.18,385.545], [1080.97,385.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.92,636.609], [1100.34,670.84], [1108.45,616.739], [1107.85,649.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.34,670.84], [1099.81,702.239], [1107.85,649.386], [1107.31,679.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.51,601.968], [1100.92,636.588], [1109.04,583.72], [1108.45,616.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.7,531.492], [1102.1,566.909], [1110.26,516.601], [1109.65,550.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.1,566.932], [1101.51,601.946], [1109.65,550.342], [1109.04,583.699]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.93,459.378], [1103.31,495.621], [1111.51,448.001], [1110.88,482.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.31,495.644], [1102.7,531.47], [1110.88,482.489], [1110.26,516.579]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.55,422.689], [1103.93,459.355], [1112.14,413.13], [1111.51,447.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.82,348.008], [1105.18,385.544], [1113.43,342.215], [1112.78,377.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.18,385.568], [1104.55,422.666], [1112.78,377.87], [1112.14,413.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.46,310.001], [1105.82,348.008], [1114.08,306.158], [1113.43,342.215]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.12,650.138], [1107.85,649.386], [1121.5,680.151], [1107.31,679.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.79,617.436], [1108.45,616.739], [1122.12,650.138], [1107.85,649.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.15,550.924], [1109.65,550.342], [1123.47,584.339], [1109.04,583.699]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.47,584.36], [1109.04,583.72], [1122.79,617.415], [1108.45,616.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.54,482.95], [1110.88,482.489], [1124.84,517.101], [1110.26,516.579]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.84,517.122], [1110.26,516.601], [1124.15,550.903], [1109.65,550.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.25,448.399], [1111.51,448.001], [1125.54,482.928], [1110.88,482.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.69,378.14], [1112.78,377.87], [1126.97,413.442], [1112.14,413.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.97,413.465], [1112.14,413.13], [1126.25,448.377], [1111.51,447.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.42,342.418], [1113.43,342.215], [1127.69,378.117], [1112.78,377.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.16,306.293], [1114.08,306.158], [1128.42,342.418], [1113.43,342.215]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1122.55,268.691], [1121.87,304.028], [1126.15,267.794], [1125.47,302.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.79,617.436], [1122.12,650.138], [1126.44,606.716], [1125.77,638.558]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.12,650.138], [1121.5,680.151], [1125.77,638.558], [1125.15,667.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.47,584.36], [1122.79,617.415], [1127.11,574.518], [1126.44,606.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.84,517.123], [1124.15,550.903], [1128.49,509.098], [1127.8,541.96]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.15,550.924], [1123.47,584.339], [1127.8,541.981], [1127.12,574.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.54,482.95], [1124.84,517.101], [1129.19,475.864], [1128.49,509.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.97,413.465], [1126.25,448.377], [1130.61,408.32], [1129.9,442.252]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.25,448.399], [1125.54,482.928], [1129.9,442.273], [1129.19,475.843]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.69,378.14], [1126.97,413.442], [1131.33,373.999], [1130.61,408.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.42,342.418], [1127.69,378.117], [1132.07,339.303], [1131.34,373.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.16,306.293], [1128.42,342.418], [1132.8,304.227], [1132.07,339.303]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[828.108,282.478], [829.405,332.484], [783.398,282.093], [785.023,331.652]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.405,332.484], [830.683,381.76], [785.023,331.652], [786.624,380.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.683,381.76], [831.942,430.261], [786.624,380.496], [788.201,428.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.942,430.292], [833.181,478.067], [788.202,428.608], [789.754,475.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.182,478.097], [834.403,525.161], [789.755,476.006], [791.285,522.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[834.404,525.191], [835.607,571.56], [791.286,522.704], [792.794,568.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[835.607,571.59], [836.792,617.279], [792.795,568.72], [794.281,614.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[836.793,617.308], [837.961,662.333], [794.282,614.067], [795.746,658.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[837.962,662.362], [839.113,706.737], [795.747,658.76], [797.19,702.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.113,706.765], [840.248,750.503], [797.191,702.812], [798.614,746.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.249,750.531], [798.615,746.239], [841.367,793.647], [800.018,789.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.367,793.647], [800.018,789.025], [842.39,833.082], [801.301,828.163]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[873.046,284.031], [874.033,335.835], [814.61,283.514], [816.044,334.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.033,335.836], [875.005,386.856], [816.044,334.72], [817.457,385.16]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.005,386.856], [875.962,437.047], [817.457,385.16], [818.847,434.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.963,437.078], [876.904,486.491], [818.848,434.821], [820.217,483.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.905,486.521], [877.832,535.173], [820.218,483.72], [821.565,531.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.833,535.204], [878.746,583.112], [821.566,531.874], [822.894,579.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.746,583.142], [879.646,630.324], [822.895,579.301], [824.202,625.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.646,630.354], [880.532,676.826], [824.203,626.017], [825.491,672.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.532,676.855], [881.405,722.633], [825.492,672.038], [826.761,717.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.405,722.661], [882.265,767.761], [826.762,717.379], [828.013,762.027]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.266,767.789], [883.112,812.225], [828.014,762.055], [829.246,806.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[883.112,812.225], [883.887,852.848], [829.246,806.053], [830.373,846.283]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[934.846,285.067], [935.355,338.07], [868.015,284.469], [869.052,336.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[934.888,338.057], [935.392,390.232], [869.052,336.781], [870.074,388.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[935.855,390.25], [936.347,441.565], [870.074,388.292], [871.079,438.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.348,441.597], [936.832,492.097], [871.079,438.99], [872.068,488.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.832,492.129], [937.309,541.834], [872.069,488.894], [873.042,537.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.309,541.865], [937.779,590.794], [873.043,538.022], [874.002,586.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.779,590.824], [938.241,638.995], [874.002,586.393], [874.946,633.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.241,639.025], [938.696,686.455], [874.947,634.023], [875.876,680.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.697,686.484], [939.145,733.19], [875.877,680.93], [876.793,727.101]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.145,733.219], [939.586,779.218], [876.793,727.13], [877.695,772.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.586,779.246], [940.021,824.553], [877.696,772.639], [878.584,817.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.021,824.553], [940.418,865.961], [878.584,817.444], [879.397,858.4]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[934.376,285.061], [934.888,338.057], [945.25,283.965], [945.663,335.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[934.888,338.057], [935.392,390.232], [945.663,335.694], [946.071,386.64]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[935.392,390.232], [935.888,441.54], [946.071,386.64], [946.472,436.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[935.888,441.572], [936.376,492.066], [946.472,436.792], [946.866,486.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.377,492.097], [936.857,541.797], [946.867,486.166], [947.255,534.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.857,541.828], [937.33,590.751], [947.255,534.781], [947.638,582.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.33,590.781], [937.796,638.946], [947.638,582.654], [948.015,629.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.796,638.976], [938.254,686.401], [948.015,629.803], [948.386,676.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.255,686.43], [938.706,733.131], [948.386,676.243], [948.752,721.962]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.706,733.16], [939.151,779.154], [948.752,721.991], [949.113,767.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.151,779.182], [939.589,824.484], [949.113,767.061], [949.468,811.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.589,824.484], [939.989,865.888], [949.468,811.442], [949.792,852.015]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[993.244,284.384], [993.278,336.596], [945.25,283.966], [945.663,335.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.278,336.596], [993.311,388.011], [945.663,335.694], [946.071,386.64]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.311,388.011], [993.343,438.584], [946.071,386.64], [946.472,436.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.343,438.616], [993.375,488.398], [946.472,436.791], [946.866,486.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.375,488.43], [993.407,537.44], [946.867,486.166], [947.255,534.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.407,537.471], [993.438,585.726], [947.255,534.781], [947.638,582.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.438,585.757], [993.469,633.276], [947.638,582.655], [948.015,629.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.469,633.305], [948.015,629.803], [993.499,680.104], [948.386,676.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.498,680.133], [948.386,676.243], [993.528,726.227], [948.752,721.962]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.528,726.256], [948.752,721.991], [993.557,771.662], [949.113,767.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.557,771.69], [949.113,767.061], [993.586,816.423], [949.468,811.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.586,816.423], [949.468,811.442], [993.613,857.314], [949.792,852.016]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[993.244,284.384], [993.278,336.596], [1019.64,281.367], [1019.48,330.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.278,336.596], [993.311,388.011], [1019.48,330.085], [1019.32,378.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.311,388.011], [993.343,438.584], [1019.32,378.112], [1019.15,425.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.343,438.616], [993.375,488.399], [1019.15,425.432], [1019,472.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.375,488.43], [993.407,537.44], [1019,472.061], [1018.84,517.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.407,537.471], [993.438,585.727], [1018.84,518.014], [1018.69,563.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.438,585.757], [993.469,633.276], [1018.69,563.305], [1018.53,607.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.469,633.305], [993.499,680.104], [1018.53,607.949], [1018.38,651.932]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.499,680.133], [993.528,726.227], [1018.38,651.96], [1018.24,695.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.528,726.256], [993.557,771.662], [1018.24,695.351], [1018.09,738.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.557,771.691], [993.586,816.423], [1018.09,738.134], [1017.95,780.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[993.586,816.423], [993.613,857.314], [1017.95,780.296], [1017.82,818.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.29,609.438], [1018.53,607.949], [1039,653.587], [1018.38,651.932]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039,653.615], [1018.38,651.96], [1038.7,697.14], [1018.24,695.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.7,697.167], [1018.24,695.35], [1038.41,740.08], [1018.09,738.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.41,740.107], [1018.09,738.134], [1038.13,782.421], [1017.95,780.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.13,782.422], [1017.95,780.296], [1037.86,821.135], [1017.82,818.872]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1041.51,281.544], [1041.18,330.467], [1019.65,281.367], [1019.48,330.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1041.18,330.467], [1040.85,378.692], [1019.48,330.085], [1019.32,378.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.85,378.692], [1019.32,378.112], [1040.53,426.175], [1019.16,425.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.53,426.205], [1019.16,425.432], [1040.21,472.991], [1019,472.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.21,473.021], [1019,472.061], [1039.9,519.126], [1018.84,517.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.9,519.155], [1018.84,518.014], [1039.6,564.594], [1018.69,563.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.6,564.623], [1018.69,563.305], [1039.29,609.41], [1018.53,607.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.7,697.167], [1038.41,740.08], [1050.77,681.107], [1050.41,722.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.41,740.107], [1038.13,782.422], [1050.41,722.658], [1050.05,763.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.13,782.422], [1037.86,821.135], [1050.05,763.624], [1049.73,801.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.6,564.623], [1039.29,609.41], [1051.89,552.98], [1051.51,596.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.29,609.438], [1039,653.587], [1051.51,596.28], [1051.14,638.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039,653.615], [1038.7,697.14], [1051.14,638.985], [1050.77,681.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.53,426.205], [1040.21,472.991], [1053.05,419.383], [1052.66,464.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.21,473.021], [1039.9,519.126], [1052.66,464.545], [1052.27,509.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.9,519.155], [1039.6,564.594], [1052.27,509.073], [1051.89,552.953]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1041.51,281.544], [1041.18,330.467], [1054.26,279.986], [1053.85,327.103]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1041.18,330.467], [1040.85,378.692], [1053.85,327.103], [1053.45,373.573]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.85,378.692], [1040.53,426.175], [1053.45,373.573], [1053.05,419.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.74,312.514], [1080.25,351.341], [1051.37,312.103], [1051.05,350.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.65,724.084], [1065.19,765.16], [1076.83,706.997], [1076.31,746.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.19,765.16], [1064.77,802.756], [1076.31,746.744], [1075.84,783.141]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.59,640.18], [1066.12,682.392], [1077.88,625.867], [1077.35,666.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.12,682.419], [1065.65,724.057], [1077.35,666.699], [1076.83,706.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.56,553.931], [1067.07,597.327], [1078.97,542.55], [1078.42,584.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.07,597.354], [1066.59,640.153], [1078.42,584.487], [1077.88,625.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.55,465.236], [1068.05,509.867], [1080.08,456.959], [1079.52,500.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.05,509.895], [1067.56,553.903], [1079.52,500.045], [1078.97,542.523]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.58,373.991], [1069.06,419.91], [1081.23,368.997], [1080.65,413.252]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.06,419.939], [1068.55,465.207], [1080.65,413.28], [1080.08,456.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.1,327.377], [1069.58,373.99], [1081.81,324.097], [1081.23,368.997]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1061.8,323.773], [1061.36,368.503], [1081.45,318.633], [1080.91,360.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.47,646.02], [1076.02,680.954], [1082.16,638.468], [1081.69,672.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.02,680.954], [1075.61,712.994], [1081.69,672.797], [1081.25,704.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.38,574.9], [1076.92,610.642], [1083.12,568.6], [1082.63,603.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.92,610.664], [1076.47,645.998], [1082.63,603.731], [1082.16,638.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.31,502.12], [1077.84,538.698], [1084.1,497.132], [1083.6,533.047]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.84,538.721], [1077.38,574.878], [1083.6,533.069], [1083.12,568.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.27,427.621], [1078.79,465.065], [1085.1,424.009], [1084.6,460.758]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.79,465.089], [1078.31,502.097], [1084.6,460.781], [1084.1,497.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.74,312.514], [1080.25,351.341], [1086.65,311.092], [1086.13,349.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.25,351.341], [1079.75,389.683], [1086.13,349.172], [1085.61,386.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.75,389.707], [1079.27,427.597], [1085.61,386.808], [1085.1,423.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.63,674.709], [1081.69,672.797], [1104.08,706.331], [1081.25,704.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.84,605.356], [1082.63,603.731], [1105.23,640.217], [1082.16,638.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.23,640.239], [1082.16,638.468], [1104.63,674.709], [1081.69,672.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.08,534.394], [1083.6,533.069], [1106.46,570.054], [1083.12,568.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.46,570.077], [1083.12,568.6], [1105.84,605.334], [1082.63,603.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.35,461.79], [1084.6,460.781], [1107.71,498.278], [1084.1,497.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.71,498.301], [1084.1,497.132], [1107.08,534.371], [1083.6,533.047]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.65,387.488], [1109,424.832], [1085.61,386.808], [1085.1,423.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109,424.855], [1085.1,424.009], [1108.35,461.767], [1084.6,460.758]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.98,311.425], [1110.31,349.68], [1086.65,311.092], [1086.13,349.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.31,349.68], [1109.65,387.464], [1086.13,349.172], [1085.61,386.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.63,674.709], [1104.08,706.331], [1118.18,653.499], [1117.59,683.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.84,605.356], [1105.23,640.217], [1119.48,587.337], [1118.82,620.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.23,640.239], [1104.63,674.709], [1118.82,620.605], [1118.18,653.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.46,570.077], [1105.84,605.334], [1120.14,553.71], [1119.48,587.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.71,498.301], [1107.08,534.371], [1121.48,485.352], [1120.8,519.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.08,534.394], [1106.46,570.054], [1120.8,519.717], [1120.14,553.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109,424.855], [1108.35,461.767], [1122.85,415.485], [1122.16,450.588]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.35,461.791], [1107.71,498.278], [1122.16,450.61], [1121.48,485.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.65,387.488], [1109,424.832], [1123.54,379.969], [1122.85,415.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.98,311.425], [1110.31,349.68], [1124.96,307.741], [1124.25,344.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.31,349.68], [1109.65,387.464], [1124.25,344.057], [1123.54,379.946]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.13,621.647], [1118.82,620.606], [1132.41,654.624], [1118.18,653.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.41,654.624], [1118.18,653.499], [1131.74,684.891], [1117.59,683.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.86,588.293], [1119.48,587.337], [1133.13,621.626], [1118.82,620.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.35,520.495], [1120.8,519.717], [1134.6,554.556], [1120.14,553.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.6,554.577], [1120.14,553.71], [1133.86,588.271], [1119.48,587.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.1,486.038], [1121.48,485.352], [1135.35,520.473], [1120.8,519.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.64,415.981], [1122.85,415.485], [1136.87,451.18], [1122.16,450.588]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.87,451.203], [1122.16,450.61], [1136.1,486.016], [1121.48,485.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1138.42,380.367], [1123.54,379.969], [1137.64,415.958], [1122.85,415.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1140.01,307.936], [1139.21,344.354], [1124.96,307.741], [1124.25,344.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1139.21,344.354], [1124.25,344.057], [1138.42,380.344], [1123.54,379.946]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.41,654.624], [1131.74,684.891], [1139.33,643.145], [1138.65,672.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.86,588.293], [1133.13,621.626], [1140.81,578.549], [1140.07,611.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.13,621.647], [1132.41,654.624], [1140.06,611.025], [1139.33,643.145]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.6,554.577], [1133.86,588.271], [1141.57,545.73], [1140.81,578.528]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.1,486.038], [1135.35,520.473], [1143.1,479.044], [1142.33,512.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.35,520.495], [1134.6,554.556], [1142.33,512.564], [1141.57,545.709]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1137.09,270.103], [1136.33,305.712], [1143.81,269.276], [1143.03,303.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.87,451.203], [1136.1,486.016], [1143.88,445.166], [1143.1,479.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.64,415.981], [1136.87,451.18], [1144.67,410.924], [1143.88,445.145]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1138.42,380.367], [1137.64,415.958], [1145.46,376.311], [1144.67,410.902]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1140.01,307.936], [1139.21,344.354], [1147.08,305.95], [1146.27,341.322]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1139.21,344.354], [1138.42,380.344], [1146.27,341.322], [1145.46,376.289]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[798.481,281.678], [799.968,331.249], [756.401,281.244], [758.181,330.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.967,331.249], [801.433,380.115], [758.181,330.239], [759.936,378.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.433,380.115], [802.876,428.231], [759.937,378.546], [761.665,426.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.877,428.261], [804.299,475.674], [761.666,426.149], [763.37,473.035]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.3,475.704], [805.702,522.428], [763.371,473.064], [765.05,519.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.702,522.457], [807.084,568.507], [765.051,519.306], [766.706,564.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.084,568.536], [808.446,613.927], [766.707,564.889], [768.339,609.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.447,613.956], [809.789,658.702], [768.34,609.826], [769.948,654.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.79,658.731], [811.113,702.845], [769.95,654.132], [771.536,697.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.114,702.873], [812.418,746.369], [771.537,697.819], [773.101,740.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.419,746.397], [813.705,789.288], [773.102,740.901], [774.645,783.364]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.705,789.288], [814.882,828.531], [774.645,783.364], [776.057,822.219]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[836.795,283.127], [838.042,334.622], [781.605,282.542], [783.256,333.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[838.042,334.622], [839.271,385.355], [783.256,333.26], [784.882,383.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.271,385.354], [840.481,435.28], [784.882,383.24], [786.483,432.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.481,435.311], [841.672,484.479], [786.484,432.467], [788.061,480.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.673,484.509], [842.846,532.936], [788.062,480.957], [789.616,528.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.847,532.966], [844.002,580.668], [789.617,528.728], [791.147,575.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.003,580.698], [845.141,627.692], [791.148,575.794], [792.656,622.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.142,627.721], [846.263,674.023], [792.657,622.172], [794.144,667.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.264,674.052], [847.369,719.676], [794.144,667.875], [795.609,712.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.37,719.704], [848.459,764.666], [795.61,712.92], [797.054,757.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.46,764.694], [849.533,809.007], [797.055,757.32], [798.479,801.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.533,809.007], [850.515,849.53], [798.479,801.062], [799.78,841.07]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[893.823,284.176], [894.65,337.061], [830.286,283.494], [831.596,335.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.21,337.047], [895.027,389.12], [831.596,335.477], [832.886,386.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.464,389.142], [896.264,440.373], [832.886,386.682], [834.157,437.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.264,440.405], [897.052,490.837], [834.157,437.097], [835.408,486.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.053,490.869], [897.829,540.521], [835.408,486.739], [836.64,535.596]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.829,540.552], [898.593,589.442], [836.641,535.627], [837.853,583.746]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.594,589.473], [899.346,637.618], [837.854,583.776], [839.049,631.174]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.347,637.649], [900.088,685.066], [839.05,631.204], [840.227,677.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.088,685.096], [900.818,731.802], [840.227,677.926], [841.387,723.931]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.818,731.831], [901.537,777.842], [841.387,723.96], [842.53,769.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.538,777.871], [902.246,823.202], [842.531,769.318], [843.657,813.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.246,823.202], [902.894,864.641], [843.657,813.989], [844.686,854.834]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[893.38,284.169], [894.21,337.047], [908.099,283.242], [908.795,334.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.21,337.047], [895.027,389.12], [908.795,334.89], [909.48,385.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.027,389.12], [895.831,440.343], [909.48,385.772], [910.155,435.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.831,440.375], [896.623,490.8], [910.155,435.872], [910.82,485.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.623,490.831], [897.402,540.476], [910.82,485.21], [911.474,533.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.403,540.507], [898.17,589.391], [911.475,533.802], [912.119,581.635]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.17,589.421], [898.926,637.56], [912.119,581.665], [912.754,628.785]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.926,637.59], [899.67,685.001], [912.755,628.815], [913.38,675.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.671,685.031], [900.404,731.731], [913.38,675.269], [913.996,721.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.404,731.76], [901.126,777.764], [913.997,721.041], [914.604,766.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.126,777.793], [901.838,823.118], [914.604,766.146], [915.203,810.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.838,823.118], [902.488,864.552], [915.203,810.572], [915.75,851.196]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[954.17,283.723], [954.511,336.008], [908.099,283.243], [908.795,334.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.511,336.008], [954.847,387.507], [908.795,334.89], [909.48,385.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.847,387.507], [955.177,438.174], [909.48,385.772], [910.155,435.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.178,438.206], [955.503,488.092], [910.155,435.872], [910.819,485.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.503,488.123], [955.824,537.247], [910.82,485.21], [911.474,533.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.824,537.277], [956.14,585.655], [911.474,533.802], [912.119,581.635]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.14,585.685], [956.451,633.334], [912.119,581.665], [912.754,628.786]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.451,633.364], [956.758,680.3], [912.754,628.815], [913.38,675.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.758,680.33], [957.06,726.569], [913.38,675.269], [913.996,721.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.06,726.598], [957.357,772.157], [913.997,721.041], [914.604,766.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.357,772.185], [914.604,766.146], [957.65,817.078], [915.203,810.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.65,817.078], [915.203,810.572], [957.918,858.122], [915.75,851.196]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[954.17,283.723], [954.511,336.008], [991.485,281.148], [991.529,330.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.511,336.008], [954.847,387.507], [991.529,330.016], [991.572,378.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.847,387.507], [955.178,438.174], [991.572,378.2], [991.615,425.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.178,438.206], [955.503,488.092], [991.615,425.684], [991.657,472.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.504,488.123], [955.824,537.247], [991.657,472.483], [991.698,518.582]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.824,537.278], [956.14,585.655], [991.698,518.611], [991.739,564.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.14,585.685], [956.451,633.334], [991.739,564.084], [991.779,608.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.451,633.364], [956.758,680.3], [991.779,608.915], [991.819,653.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.758,680.33], [957.06,726.569], [991.819,653.118], [991.858,696.678]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.06,726.599], [957.357,772.157], [991.858,696.705], [991.897,739.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.357,772.186], [957.65,817.078], [991.897,739.69], [991.935,782.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.65,817.078], [957.918,858.123], [991.935,782.057], [991.97,820.828]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1012.7,281.353], [1012.59,330.492], [991.485,281.148], [991.529,330.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.59,330.492], [1012.48,378.94], [991.529,330.016], [991.572,378.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.48,378.94], [1012.37,426.65], [991.572,378.2], [991.615,425.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.37,426.68], [1012.26,473.698], [991.615,425.684], [991.657,472.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.26,473.727], [991.657,472.482], [1012.15,520.068], [991.698,518.582]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.15,520.098], [991.699,518.611], [1012.05,565.776], [991.739,564.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.05,565.805], [991.739,564.084], [1011.94,610.835], [991.78,608.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.94,610.864], [991.78,608.915], [1011.84,655.259], [991.819,653.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.84,655.287], [991.819,653.118], [1011.74,699.062], [991.858,696.677]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.74,699.089], [991.858,696.705], [1011.64,742.255], [991.897,739.662]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.64,742.283], [991.897,739.69], [1011.54,784.853], [991.935,782.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.54,784.853], [991.935,782.057], [1011.45,823.806], [991.97,820.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.54,784.853], [1011.45,823.806], [1028.71,766.542], [1028.52,804.295]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.59,330.492], [1012.48,378.94], [1030.94,327.38], [1030.71,374.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.48,378.94], [1012.37,426.65], [1030.71,374.102], [1030.47,420.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.37,426.68], [1012.26,473.698], [1030.47,420.166], [1030.24,465.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.26,473.727], [1012.15,520.068], [1030.24,465.586], [1030.01,510.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.15,520.098], [1012.05,565.776], [1030.01,510.375], [1029.79,554.518]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1012.05,565.805], [1011.94,610.835], [1029.79,554.546], [1029.57,598.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.94,610.864], [1011.84,655.259], [1029.57,598.112], [1029.35,641.059]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.84,655.287], [1011.74,699.062], [1029.35,641.086], [1029.13,683.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.74,699.089], [1011.64,742.255], [1029.13,683.479], [1028.92,725.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.64,742.283], [1011.54,784.853], [1028.92,725.302], [1028.71,766.542]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1012.7,281.353], [1012.59,330.492], [1031.19,280.016], [1030.94,327.38]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.5,768.57], [1043.22,806.456], [1059.8,750.57], [1059.43,787.269]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.77,599.523], [1044.44,642.63], [1061.46,587.01], [1061.04,628.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.44,642.658], [1044.12,685.18], [1061.04,628.715], [1060.62,669.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.12,685.207], [1043.81,727.156], [1060.62,669.874], [1060.21,710.471]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.81,727.182], [1043.5,768.57], [1060.21,710.497], [1059.8,750.57]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.76,466.486], [1045.43,511.422], [1062.76,458.508], [1062.32,501.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.43,511.45], [1045.09,555.764], [1062.32,501.918], [1061.88,544.721]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.09,555.792], [1044.77,599.496], [1061.88,544.748], [1061.46,586.983]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.8,327.724], [1046.45,374.637], [1064.11,324.678], [1063.65,369.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.45,374.637], [1046.1,420.857], [1063.65,369.9], [1063.2,414.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.1,420.886], [1045.76,466.457], [1063.2,414.506], [1062.76,458.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.55,313.698], [1082.05,352.804], [1053.67,313.182], [1053.34,352]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.53,324.271], [1044.21,369.266], [1072.96,319.499], [1072.47,361.841]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.08,667.819], [1041.79,708.235], [1069.25,643.664], [1068.81,681.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.79,708.261], [1041.5,748.157], [1068.81,681.958], [1068.38,719.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.5,748.157], [1041.24,784.696], [1068.38,719.763], [1067.98,754.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.67,585.334], [1042.37,626.821], [1070.14,565.648], [1069.69,604.872]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.37,626.847], [1042.08,667.793], [1069.69,604.897], [1069.25,643.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.58,457.44], [1043.27,500.614], [1071.52,444.914], [1071.06,485.639]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.27,500.642], [1042.97,543.242], [1071.06,485.665], [1070.6,525.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.97,543.269], [1042.67,585.307], [1070.59,525.907], [1070.14,565.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.21,369.267], [1043.89,413.624], [1072.47,361.841], [1071.99,403.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.89,413.652], [1043.58,457.412], [1071.99,403.642], [1071.52,444.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.77,684.941], [1050.53,681.831], [1077.35,717.243], [1050.26,713.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.68,614.089], [1051.13,611.45], [1078.22,649.704], [1050.83,646.827]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.22,649.727], [1050.83,646.849], [1077.77,684.941], [1050.53,681.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.09,504.702], [1079.61,541.56], [1052.06,502.812], [1051.74,539.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.61,541.584], [1079.14,578.021], [1051.74,539.439], [1051.44,575.626]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.14,578.044], [1051.43,575.649], [1078.68,614.066], [1051.13,611.427]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.06,429.642], [1080.57,467.366], [1052.69,428.283], [1052.37,465.739]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.57,467.39], [1080.09,504.678], [1052.37,465.763], [1052.06,502.789]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.05,352.804], [1081.55,391.425], [1053.34,352], [1053.01,390.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.55,391.449], [1081.06,429.618], [1053.01,390.364], [1052.69,428.259]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.77,684.941], [1077.35,717.243], [1085.75,676.96], [1085.3,708.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.68,614.089], [1078.22,649.704], [1086.73,607.318], [1086.24,642.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.22,649.727], [1077.77,684.941], [1086.24,642.343], [1085.75,676.96]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.61,541.584], [1079.14,578.021], [1087.74,536.08], [1087.24,571.876]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.14,578.044], [1078.68,614.066], [1087.23,571.899], [1086.73,607.295]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.57,467.39], [1080.09,504.678], [1088.77,463.216], [1088.26,499.832]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.09,504.702], [1079.61,541.56], [1088.25,499.855], [1087.74,536.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.55,391.449], [1081.06,429.618], [1089.83,388.667], [1089.3,426.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.06,429.642], [1080.57,467.366], [1089.3,426.155], [1088.77,463.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.55,313.698], [1082.05,352.804], [1090.91,312.376], [1090.37,350.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.05,352.804], [1081.55,391.425], [1090.37,350.743], [1089.83,388.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.42,679.496], [1085.75,676.96], [1107.85,711.428], [1085.3,708.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.66,609.469], [1086.73,607.318], [1109.04,644.667], [1086.24,642.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.04,644.69], [1086.24,642.343], [1108.42,679.496], [1085.75,676.96]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.94,537.829], [1087.74,536.08], [1110.3,573.829], [1087.24,571.876]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.3,573.851], [1087.23,571.899], [1109.66,609.447], [1086.73,607.295]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.24,464.542], [1111.59,501.371], [1088.77,463.216], [1088.26,499.832]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.59,501.395], [1088.25,499.855], [1110.94,537.806], [1087.74,536.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.58,389.551], [1112.91,427.239], [1089.83,388.667], [1089.3,426.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.91,427.263], [1112.24,464.518], [1089.3,426.155], [1088.77,463.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.94,312.796], [1114.26,351.398], [1090.91,312.376], [1090.37,350.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.26,351.398], [1113.58,389.527], [1090.37,350.743], [1089.83,388.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.04,644.689], [1108.42,679.496], [1128.74,625.415], [1128.05,658.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.42,679.496], [1107.85,711.428], [1128.05,658.655], [1127.41,689.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.66,609.469], [1109.04,644.667], [1129.45,591.799], [1128.74,625.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.94,537.829], [1110.3,573.829], [1130.87,523.476], [1130.16,557.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.3,573.851], [1109.66,609.447], [1130.15,557.821], [1129.45,591.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.59,501.395], [1110.94,537.806], [1131.6,488.758], [1130.87,523.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.91,427.263], [1112.24,464.518], [1133.07,418.179], [1132.33,453.639]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.24,464.542], [1111.59,501.371], [1132.33,453.662], [1131.6,488.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.58,389.551], [1112.91,427.239], [1133.82,382.305], [1133.07,418.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.94,312.796], [1114.26,351.398], [1135.34,309.354], [1134.58,346.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.26,351.398], [1113.58,389.527], [1134.58,346.032], [1133.82,382.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.96,626.8], [1128.74,625.415], [1142.19,660.153], [1128.05,658.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.19,660.153], [1128.05,658.655], [1141.48,690.766], [1127.41,689.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.74,593.069], [1129.45,591.799], [1142.96,626.779], [1128.74,625.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.33,524.507], [1130.87,523.476], [1144.53,558.951], [1130.16,557.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.53,558.973], [1130.15,557.821], [1143.74,593.047], [1129.45,591.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.13,489.666], [1131.6,488.759], [1145.33,524.485], [1130.87,523.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.77,418.831], [1133.07,418.179], [1146.95,454.42], [1132.33,453.639]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.95,454.443], [1132.33,453.662], [1146.13,489.644], [1131.6,488.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.6,382.825], [1133.82,382.305], [1147.77,418.808], [1133.07,418.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.45,346.417], [1148.61,382.802], [1134.58,346.032], [1133.82,382.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1150.3,309.601], [1149.45,346.417], [1135.34,309.354], [1134.58,346.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.96,626.8], [1142.19,660.153], [1153.23,616.34], [1152.42,648.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.19,660.153], [1141.48,690.766], [1152.42,648.838], [1151.68,678.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.74,593.069], [1142.96,626.779], [1154.04,583.482], [1153.23,616.319]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.53,558.973], [1143.74,593.047], [1154.86,550.279], [1154.04,583.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.13,489.666], [1145.33,524.485], [1156.53,482.819], [1155.69,516.705]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.33,524.507], [1144.53,558.951], [1155.69,516.727], [1154.86,550.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.95,454.443], [1146.13,489.644], [1157.38,448.549], [1156.53,482.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.77,418.831], [1146.95,454.42], [1158.23,413.913], [1157.38,448.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.6,382.825], [1147.77,418.808], [1159.1,378.903], [1158.23,413.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.45,346.417], [1148.6,382.802], [1159.97,343.514], [1159.1,378.881]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1151.16,271.483], [1150.32,307.471], [1161.04,270.764], [1160.17,305.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1150.3,309.601], [1149.45,346.417], [1160.86,307.74], [1159.97,343.514]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1144.55,270.656], [1143.78,305.538], [1161.37,269.492], [1160.55,302.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1150.32,307.471], [1149.5,343.094], [1160.17,305.792], [1159.32,340.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1143.78,305.538], [1143.01,340.078], [1160.55,302.817], [1159.73,335.83]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[770.828,280.498], [772.475,329.684], [731.732,280.072], [733.635,328.56]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.475,329.684], [774.1,378.191], [733.635,328.56], [735.513,376.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.1,378.192], [775.7,425.973], [735.513,376.39], [737.363,423.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.701,426.003], [777.278,473.105], [737.364,423.543], [739.189,470.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.279,473.135], [778.834,519.57], [739.19,470.034], [740.988,515.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.835,519.6], [780.368,565.384], [740.99,515.877], [742.763,561.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.369,565.413], [781.881,610.559], [742.764,561.085], [744.514,605.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.882,610.587], [783.373,655.108], [744.515,605.672], [746.241,649.623]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.374,655.136], [784.844,699.045], [746.242,649.651], [747.944,693.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.845,699.073], [786.295,742.382], [747.945,693.033], [749.624,735.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.296,742.41], [787.727,785.132], [749.625,735.83], [751.282,778.028]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[802.256,281.739], [803.733,332.96], [750.855,281.163], [752.687,331.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.727,785.132], [789.036,824.233], [751.282,778.028], [752.799,816.657]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[803.733,332.96], [805.19,383.442], [752.687,331.439], [754.494,381.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.19,383.442], [806.624,433.14], [754.493,381.005], [756.272,429.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[806.624,433.171], [808.037,482.133], [756.273,429.844], [758.026,477.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.038,482.163], [809.429,530.405], [758.027,477.974], [759.755,525.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.43,530.435], [810.801,577.973], [759.756,525.408], [761.458,572.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.802,578.002], [812.154,624.851], [761.459,572.162], [763.138,618.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.155,624.88], [813.487,671.055], [763.139,618.251], [764.794,663.66]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.487,671.084], [814.8,716.599], [764.795,663.688], [766.426,708.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.801,716.627], [816.096,761.497], [766.428,708.488], [768.036,752.635]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.097,761.525], [817.373,805.762], [768.037,752.663], [769.624,796.199]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.373,805.763], [818.54,846.23], [769.624,796.199], [771.075,836.035]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[853.904,282.7], [855.024,335.492], [794.375,282.024], [795.926,333.71]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[854.616,335.477], [855.722,387.474], [795.926,333.71], [797.455,384.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[856.127,387.499], [857.213,438.674], [797.455,384.644], [798.96,434.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[857.214,438.706], [858.283,489.1], [798.96,434.811], [800.443,484.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[858.284,489.131], [859.337,538.762], [800.444,484.229], [801.904,532.883]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[859.337,538.793], [860.375,587.678], [801.905,532.913], [803.344,580.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[860.375,587.708], [861.397,635.864], [803.345,580.88], [804.762,628.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[861.397,635.894], [862.404,683.337], [804.763,628.147], [806.16,674.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[862.405,683.367], [863.397,730.112], [806.161,674.727], [807.538,720.608]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[863.397,730.141], [864.374,776.204], [807.539,720.636], [808.896,765.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.375,776.233], [865.338,821.629], [808.897,765.889], [810.235,810.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.338,821.629], [866.219,863.14], [810.235,810.471], [811.459,851.248]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[853.493,282.694], [854.616,335.476], [871.843,281.97], [872.801,333.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[854.616,335.477], [855.722,387.474], [872.801,333.569], [873.745,384.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[855.722,387.474], [856.811,438.64], [873.745,384.418], [874.674,434.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[856.812,438.672], [857.884,489.057], [874.674,434.503], [875.59,483.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[857.884,489.088], [858.94,538.711], [875.59,483.84], [876.492,532.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[858.941,538.742], [859.981,587.618], [876.492,532.447], [877.381,580.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[859.982,587.649], [861.006,635.797], [877.382,580.339], [878.257,627.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[861.007,635.827], [862.016,683.261], [878.258,627.532], [879.121,674.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[862.017,683.291], [863.011,730.029], [879.121,674.041], [879.971,719.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[863.012,730.058], [863.992,776.114], [879.972,719.882], [880.81,765.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[863.992,776.143], [864.958,821.531], [880.811,765.068], [881.637,809.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.958,821.532], [865.841,863.036], [881.637,809.585], [882.393,850.304]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[915.449,282.452], [916.084,334.836], [871.843,281.971], [872.8,333.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.084,334.836], [916.71,386.448], [872.801,333.569], [873.745,384.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.71,386.448], [917.325,437.241], [873.744,384.418], [874.674,434.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.326,437.273], [917.932,487.296], [874.674,434.503], [875.59,483.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.932,487.328], [918.529,536.599], [875.59,483.84], [876.492,532.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.53,536.63], [919.118,585.167], [876.492,532.447], [877.381,580.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.118,585.197], [919.698,633.015], [877.382,580.339], [878.257,627.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.698,633.045], [920.269,680.16], [878.258,627.532], [879.12,674.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.27,680.19], [920.832,726.617], [879.121,674.042], [879.971,719.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.833,726.646], [921.387,772.401], [879.972,719.882], [880.81,765.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.387,772.43], [921.934,817.527], [880.811,765.068], [881.637,809.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.934,817.527], [922.434,858.768], [881.637,809.585], [882.393,850.304]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[915.449,282.452], [916.084,334.836], [963.281,280.424], [963.528,329.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.084,334.836], [916.71,386.448], [963.528,329.49], [963.773,377.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[916.71,386.449], [917.325,437.241], [963.772,377.881], [964.013,425.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.326,437.273], [917.932,487.297], [964.013,425.579], [964.25,472.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[917.932,487.328], [918.529,536.599], [964.251,472.6], [964.484,518.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[918.53,536.63], [919.118,585.167], [964.485,518.958], [964.715,564.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.118,585.197], [919.698,633.015], [964.715,564.666], [964.943,609.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.698,633.045], [920.269,680.16], [964.943,609.74], [965.167,654.162]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.269,680.19], [920.832,726.617], [965.167,654.19], [965.388,698.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.833,726.646], [921.387,772.401], [965.389,698.032], [965.607,741.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.387,772.43], [921.934,817.527], [965.607,741.276], [965.822,783.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.934,817.527], [922.434,858.769], [965.822,783.908], [966.019,822.927]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[983.626,280.63], [983.726,330.035], [963.281,280.424], [963.529,329.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.726,330.035], [983.826,378.754], [963.528,329.49], [963.773,377.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.826,378.754], [983.924,426.741], [963.773,377.88], [964.013,425.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.924,426.771], [984.02,474.073], [964.014,425.579], [964.251,472.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.02,474.102], [984.116,520.732], [964.251,472.6], [964.485,518.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.116,520.762], [964.485,518.958], [984.21,566.734], [964.716,564.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.21,566.763], [964.716,564.666], [984.302,612.092], [964.943,609.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.302,612.12], [964.943,609.74], [984.393,656.819], [965.167,654.162]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.394,656.847], [965.167,654.19], [984.484,700.929], [965.389,698.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.484,700.957], [965.389,698.031], [984.572,744.435], [965.607,741.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.572,744.462], [965.607,741.275], [984.66,787.348], [965.822,783.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.66,787.348], [965.822,783.908], [984.74,826.596], [966.019,822.927]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[983.626,280.631], [983.726,330.035], [1007.71,279.572], [1007.64,327.241]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.726,330.035], [983.826,378.754], [1007.64,327.241], [1007.56,374.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.826,378.754], [983.924,426.741], [1007.56,374.274], [1007.49,420.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[983.924,426.772], [984.02,474.073], [1007.49,420.653], [1007.42,466.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.02,474.103], [984.116,520.732], [1007.42,466.392], [1007.36,511.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.116,520.762], [984.21,566.734], [1007.36,511.503], [1007.29,555.972]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.21,566.763], [984.302,612.092], [1007.29,556.001], [1007.22,599.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.302,612.121], [984.393,656.819], [1007.22,599.896], [1007.16,643.175]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.393,656.848], [984.484,700.929], [1007.16,643.202], [1007.09,685.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.484,700.957], [984.572,744.435], [1007.09,685.931], [1007.03,728.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.572,744.462], [984.66,787.348], [1007.03,728.092], [1006.96,769.673]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.66,787.348], [984.74,826.596], [1006.96,769.673], [1006.91,807.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.58,688.06], [1021.42,730.386], [1043.27,673.244], [1042.98,714.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.42,730.413], [1021.26,772.178], [1042.98,714.266], [1042.69,754.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.26,772.178], [1021.12,810.416], [1042.69,754.737], [1042.42,791.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.59,421.519], [1022.42,467.454], [1045.13,415.5], [1044.81,459.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.42,467.483], [1022.25,512.785], [1044.81,459.895], [1044.49,503.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.25,512.814], [1022.08,557.496], [1044.49,503.7], [1044.18,546.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.08,557.525], [1021.91,601.6], [1044.18,546.926], [1043.87,589.557]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.91,601.628], [1021.74,645.108], [1043.87,589.584], [1043.57,631.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.74,645.136], [1021.58,688.033], [1043.57,631.687], [1043.27,673.217]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.95,327.636], [1022.77,374.908], [1045.78,324.891], [1045.45,370.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.77,374.908], [1022.59,421.489], [1045.45,370.503], [1045.13,415.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.8,324.422], [1026.6,369.751], [1063.9,320.12], [1063.48,362.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.47,629.386], [1025.28,670.682], [1061.06,608.208], [1060.67,647.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.28,670.708], [1025.11,711.476], [1060.67,647.362], [1060.29,686.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.11,711.502], [1024.93,751.751], [1060.29,686.042], [1059.91,724.233]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1024.93,751.751], [1024.77,788.619], [1059.91,724.234], [1059.57,759.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.02,502.142], [1025.83,545.086], [1062.25,487.82], [1061.85,528.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.83,545.113], [1025.65,587.497], [1061.85,528.446], [1061.45,568.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1025.65,587.524], [1025.47,629.359], [1061.45,568.573], [1061.06,608.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.6,369.751], [1026.4,414.444], [1063.48,362.844], [1063.07,405.001]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.4,414.472], [1026.21,458.571], [1063.07,405.028], [1062.65,446.657]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.21,458.598], [1026.02,502.114], [1062.65,446.683], [1062.25,487.793]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1000.02,274.327], [1000.01,313.384], [1058.64,272.243], [1058.32,307.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.91,314.769], [1083.41,354.244], [1055.68,314.174], [1055.35,353.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.55,654.131], [1052.77,650.57], [1079.1,689.716], [1052.47,685.862]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.1,689.716], [1052.47,685.862], [1078.68,722.36], [1052.19,718.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.96,544.876], [1080.48,581.684], [1053.71,542.236], [1053.4,578.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.48,581.707], [1080.02,618.1], [1053.39,578.753], [1053.08,614.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.02,618.123], [1079.55,654.108], [1053.08,614.862], [1052.77,650.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.41,431.823], [1081.92,469.917], [1054.68,430.169], [1054.35,467.928]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.92,469.942], [1081.44,507.6], [1054.35,467.951], [1054.03,505.281]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.44,507.624], [1080.96,544.853], [1054.03,505.304], [1053.71,542.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.41,354.244], [1082.91,393.235], [1055.35,353.288], [1055.01,391.926]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.9,393.26], [1082.41,431.798], [1055.01,391.951], [1054.68,430.145]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.55,654.131], [1079.1,689.716], [1089.9,646.963], [1089.4,681.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.1,689.716], [1078.68,722.36], [1089.4,681.958], [1088.93,714.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.48,581.707], [1080.02,618.1], [1090.93,575.761], [1090.41,611.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.02,618.123], [1079.55,654.108], [1090.41,611.559], [1089.9,646.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.92,469.942], [1081.44,507.6], [1092.52,465.937], [1091.98,502.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.44,507.623], [1080.96,544.853], [1091.98,502.956], [1091.45,539.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.96,544.876], [1080.48,581.684], [1091.45,539.562], [1090.93,575.738]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.9,393.259], [1082.41,431.798], [1093.6,390.626], [1093.06,428.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.41,431.823], [1081.92,469.917], [1093.06,428.496], [1092.52,465.913]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.91,314.769], [1083.41,354.244], [1094.72,313.573], [1094.16,352.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.41,354.244], [1082.91,393.235], [1094.16,352.321], [1093.6,390.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.3,649.879], [1089.9,646.963], [1111.67,685.114], [1089.4,681.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.67,685.114], [1089.4,681.958], [1111.09,717.441], [1088.93,714.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.59,578.179], [1090.93,575.761], [1112.94,614.206], [1090.41,611.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.94,614.229], [1090.41,611.559], [1112.3,649.856], [1089.9,646.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.24,541.723], [1113.59,578.156], [1091.45,539.562], [1090.93,575.738]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.58,467.565], [1114.91,504.831], [1092.52,465.937], [1091.98,502.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.91,504.854], [1114.25,541.7], [1091.98,502.956], [1091.45,539.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.94,391.697], [1116.25,429.825], [1093.6,390.626], [1093.06,428.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.25,429.849], [1115.58,467.542], [1093.06,428.496], [1092.52,465.913]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.33,314.059], [1117.63,353.103], [1094.72,313.573], [1094.16,352.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.63,353.103], [1116.94,391.673], [1094.16,352.321], [1093.6,390.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.67,685.114], [1111.09,717.441], [1137.44,664.765], [1136.77,695.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.94,614.229], [1112.3,649.856], [1138.93,597.021], [1138.18,631.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.3,649.879], [1111.67,685.114], [1138.18,631.082], [1137.44,664.765]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.59,578.179], [1112.94,614.206], [1139.69,562.595], [1138.93,596.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.91,504.854], [1114.25,541.7], [1141.22,492.631], [1140.45,527.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.24,541.723], [1113.59,578.156], [1140.45,527.801], [1139.69,562.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.58,467.565], [1114.91,504.831], [1142,457.079], [1141.22,492.608]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.94,391.697], [1116.25,429.824], [1143.58,384.806], [1142.79,421.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.25,429.849], [1115.58,467.541], [1142.79,421.14], [1142,457.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.63,353.103], [1116.94,391.673], [1144.39,348.072], [1143.59,384.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.33,314.059], [1117.63,353.103], [1145.2,310.931], [1144.39,348.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.43,666.638], [1137.44,664.765], [1150.68,697.686], [1136.77,695.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.07,598.604], [1138.93,597.021], [1152.25,632.79], [1138.18,631.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.25,632.812], [1138.18,631.082], [1151.43,666.638], [1137.44,664.765]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.91,564.029], [1139.69,562.595], [1153.07,598.582], [1138.93,596.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1154.75,529.081], [1140.45,527.801], [1153.91,564.007], [1139.69,562.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.46,458.043], [1142,457.079], [1155.6,493.732], [1141.22,492.608]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.6,493.754], [1141.22,492.631], [1154.75,529.059], [1140.45,527.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.34,421.94], [1156.46,458.02], [1142.79,421.14], [1142,457.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1158.22,385.44], [1157.34,421.917], [1143.58,384.806], [1142.79,421.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.01,311.218], [1159.11,348.534], [1145.2,310.931], [1144.39,348.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1159.11,348.535], [1158.22,385.416], [1144.39,348.073], [1143.59,384.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.43,666.638], [1150.68,697.687], [1165.04,655.551], [1164.24,685.828]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.07,598.604], [1152.25,632.79], [1166.78,589.235], [1165.9,622.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.25,632.812], [1151.43,666.638], [1165.9,622.574], [1165.04,655.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.91,564.029], [1153.07,598.582], [1167.66,555.547], [1166.78,589.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1154.75,529.081], [1153.91,564.007], [1168.55,521.506], [1167.66,555.526]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.6,493.754], [1154.75,529.059], [1169.45,487.106], [1168.55,521.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.46,458.043], [1155.6,493.732], [1170.36,452.342], [1169.45,487.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1158.22,385.44], [1157.34,421.917], [1172.22,381.696], [1171.29,417.185]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.34,421.94], [1156.46,458.02], [1171.29,417.207], [1170.36,452.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1159.11,348.535], [1158.22,385.416], [1173.16,345.803], [1172.22,381.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.01,311.218], [1159.11,348.534], [1174.11,309.521], [1173.16,345.803]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1164.73,272.757], [1163.83,309.23], [1177.83,272.179], [1176.89,307.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.79,554.093], [1156.96,587.607], [1170.53,546.423], [1169.66,579.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.14,620.819], [1155.33,653.65], [1168.8,611.555], [1167.95,643.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.33,653.65], [1154.58,683.794], [1167.95,643.614], [1167.16,673.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.96,587.629], [1156.14,620.798], [1169.66,579.153], [1168.8,611.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.62,520.208], [1157.79,554.072], [1171.41,513.36], [1170.53,546.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.29,609.763], [1152.52,641.673], [1174.62,594.703], [1173.78,625.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.52,641.673], [1151.81,670.98], [1173.78,625.351], [1173.01,653.511]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.47,485.967], [1158.62,520.186], [1172.3,479.959], [1171.41,513.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.07,577.514], [1153.29,609.743], [1175.47,563.741], [1174.63,594.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.83,309.23], [1162.94,345.335], [1176.89,307.698], [1175.95,342.87]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.32,451.365], [1159.47,485.945], [1173.2,446.215], [1172.3,479.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.86,544.94], [1154.07,577.494], [1176.33,532.48], [1175.48,563.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.19,416.397], [1160.32,451.343], [1174.11,412.122], [1173.2,446.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.66,512.036], [1154.86,544.919], [1177.2,500.916], [1176.33,532.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.94,345.335], [1162.06,381.033], [1175.95,342.87], [1175.03,377.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.06,381.055], [1161.19,416.374], [1175.03,377.676], [1174.11,412.101]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.46,478.798], [1155.66,512.015], [1178.08,469.046], [1177.2,500.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.27,445.22], [1156.46,478.777], [1178.96,436.863], [1178.08,469.025]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1161.47,272.067], [1160.61,307.403], [1183.51,271.13], [1182.58,304.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.93,377.023], [1158.1,411.275], [1180.75,371.544], [1179.85,404.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.1,411.296], [1157.27,445.198], [1179.85,404.364], [1178.96,436.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.76,342.393], [1158.93,377.001], [1181.66,338.398], [1180.75,371.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.61,307.402], [1159.76,342.393], [1182.58,304.921], [1181.66,338.398]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[745.321,279.081], [747.098,327.915], [709.518,278.723], [711.514,326.746]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.097,327.915], [748.851,376.095], [711.514,326.746], [713.483,374.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.851,376.096], [750.578,423.576], [713.483,374.138], [715.424,420.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.579,423.606], [752.283,470.431], [715.425,420.881], [717.339,466.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.284,470.461], [753.964,516.643], [717.341,466.99], [719.229,512.447]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.966,516.672], [755.623,562.226], [719.231,512.476], [721.094,557.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.624,562.254], [757.259,607.191], [721.095,557.352], [722.934,601.603]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[769.679,280.02], [771.355,330.981], [722.554,279.534], [724.532,329.394]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.26,607.22], [758.873,651.553], [722.935,601.631], [724.749,645.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.355,330.982], [773.007,381.23], [724.532,329.395], [726.483,378.573]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.874,651.581], [760.466,695.322], [724.75,645.324], [726.541,688.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.007,381.23], [774.634,430.719], [726.483,378.573], [728.405,427.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.467,695.349], [762.037,738.51], [726.542,688.443], [728.309,730.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.635,430.75], [776.238,479.526], [728.407,427.054], [730.302,474.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.038,738.538], [763.588,781.13], [728.31,731], [730.054,772.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.239,479.556], [777.82,527.635], [730.303,474.851], [732.171,521.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.588,781.13], [765.007,820.127], [730.054,772.977], [731.652,811.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.82,527.665], [779.379,575.061], [732.173,521.979], [734.015,568.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.38,575.091], [780.916,621.818], [734.016,568.452], [735.833,614.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.917,621.848], [782.431,667.921], [735.835,614.284], [737.627,659.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.432,667.95], [783.926,713.383], [737.628,659.487], [739.396,704.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.927,713.412], [785.4,758.218], [739.397,704.075], [741.141,748.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.401,758.246], [786.853,802.437], [741.142,748.059], [742.862,791.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.853,802.437], [788.183,842.877], [742.862,791.426], [744.437,831.121]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[815.41,280.788], [816.794,333.488], [760.549,280.215], [762.306,331.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.423,333.472], [817.79,385.398], [762.306,331.617], [764.039,382.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.159,385.425], [819.502,436.55], [764.039,382.294], [765.745,432.199]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.503,436.582], [820.827,486.947], [765.746,432.23], [767.428,481.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.828,486.979], [822.131,536.599], [767.429,481.44], [769.086,529.91]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[822.132,536.63], [823.417,585.523], [769.087,529.941], [770.721,577.717]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.418,585.554], [824.684,633.735], [770.722,577.747], [772.333,624.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.685,633.765], [825.932,681.25], [772.333,624.874], [773.921,671.306]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.933,681.279], [827.163,728.083], [773.922,671.335], [775.488,717.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.164,728.112], [828.376,774.248], [775.489,717.145], [777.032,762.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.377,774.277], [829.572,819.761], [777.033,762.318], [778.555,806.839]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.572,819.761], [830.665,861.366], [778.555,806.839], [779.948,847.575]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[815.036,280.783], [816.423,333.472], [836.756,280.284], [837.952,331.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.423,333.472], [817.79,385.398], [837.952,331.843], [839.131,382.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.79,385.398], [819.136,436.513], [839.131,382.672], [840.292,432.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.137,436.545], [820.463,486.9], [840.293,432.755], [841.437,482.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.464,486.931], [821.77,536.542], [841.437,482.109], [842.565,530.718]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.771,536.574], [823.058,585.457], [842.565,530.749], [843.677,578.66]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.059,585.488], [824.327,633.66], [843.677,578.69], [844.773,625.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.328,633.69], [825.578,681.165], [844.773,625.948], [845.853,672.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.579,681.195], [826.811,727.99], [845.854,672.537], [846.919,718.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.812,728.019], [828.026,774.147], [846.919,718.471], [847.969,763.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.027,774.176], [829.224,819.651], [847.97,763.764], [849.005,808.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.224,819.651], [830.32,861.249], [849.005,808.401], [849.952,849.242]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[877.381,280.695], [878.291,333.185], [836.756,280.284], [837.952,331.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.29,333.185], [879.187,384.918], [837.952,331.843], [839.131,382.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.187,384.918], [880.07,435.846], [839.131,382.672], [840.292,432.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.07,435.878], [880.94,486.051], [840.292,432.755], [841.436,482.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.94,486.082], [881.797,535.517], [841.437,482.109], [842.564,530.718]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.798,535.548], [882.642,584.26], [842.565,530.749], [843.676,578.66]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.642,584.291], [883.474,632.297], [843.677,578.69], [844.772,625.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[883.475,632.327], [884.295,679.641], [844.773,625.948], [845.853,672.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[884.295,679.671], [885.104,726.309], [845.854,672.537], [846.918,718.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.104,726.338], [885.901,772.315], [846.919,718.471], [847.969,763.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.901,772.344], [886.687,817.672], [847.97,763.764], [849.005,808.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.687,817.672], [887.406,859.136], [849.005,808.401], [849.952,849.242]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[877.381,280.696], [878.291,333.185], [935.2,279.284], [935.643,328.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.29,333.185], [879.187,384.918], [935.643,328.577], [936.08,377.204]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.187,384.918], [880.069,435.846], [936.08,377.204], [936.51,425.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.07,435.878], [880.94,486.051], [936.511,425.149], [936.935,472.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.94,486.082], [881.797,535.517], [936.935,472.426], [937.354,519.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.798,535.548], [882.642,584.26], [937.354,519.048], [937.767,565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.642,584.291], [883.474,632.297], [937.767,565.029], [938.174,610.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[883.475,632.327], [884.295,679.641], [938.174,610.382], [938.576,655.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[884.295,679.671], [885.104,726.309], [938.576,655.121], [938.973,699.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.104,726.339], [885.901,772.315], [938.973,699.256], [939.364,742.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.901,772.344], [886.687,817.672], [939.364,742.801], [939.75,785.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.687,817.672], [887.406,859.136], [939.75,785.741], [940.103,825.051]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[954.45,279.462], [954.758,329.159], [935.201,279.284], [935.643,328.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.758,329.159], [955.062,378.18], [935.643,328.577], [936.08,377.204]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.062,378.18], [955.362,426.476], [936.08,377.204], [936.511,425.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.362,426.506], [955.657,474.124], [936.511,425.149], [936.935,472.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.658,474.154], [955.949,521.107], [936.936,472.426], [937.354,519.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.949,521.136], [956.237,567.439], [937.354,519.048], [937.767,565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.237,567.468], [956.52,613.133], [937.767,565.029], [938.175,610.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.52,613.162], [938.175,610.382], [956.8,658.203], [938.576,655.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.8,658.231], [938.577,655.121], [957.075,702.661], [938.973,699.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.076,702.689], [938.973,699.256], [957.348,746.52], [939.364,742.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.348,746.547], [939.364,742.801], [957.616,789.791], [939.75,785.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.616,789.791], [939.75,785.741], [957.862,829.375], [940.103,825.05]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[954.449,279.462], [954.758,329.159], [983.94,278.72], [984.033,326.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[954.758,329.159], [955.062,378.18], [984.033,326.735], [984.125,374.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.062,378.18], [955.362,426.476], [984.126,374.12], [984.217,420.826]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.362,426.506], [955.657,474.124], [984.217,420.856], [984.306,466.928]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.657,474.154], [955.949,521.107], [984.306,466.957], [984.395,512.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[955.949,521.136], [956.236,567.439], [984.395,512.437], [984.482,557.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.237,567.468], [956.52,613.133], [984.482,557.307], [984.569,601.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.52,613.162], [956.799,658.203], [984.569,601.579], [984.654,645.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[956.8,658.231], [957.075,702.661], [984.654,645.266], [984.738,688.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.075,702.689], [957.347,746.52], [984.738,688.379], [984.821,730.902]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.348,746.547], [957.616,789.791], [984.821,730.929], [984.902,772.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[957.616,789.791], [957.861,829.375], [984.902,772.901], [984.977,811.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.639,327.16], [998.631,374.831], [1026.86,324.766], [1026.67,370.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.631,374.831], [998.623,421.816], [1026.67,370.821], [1026.47,416.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.623,421.846], [998.615,468.189], [1026.47,416.263], [1026.28,461.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.615,468.219], [998.607,513.933], [1026.28,461.105], [1026.09,505.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.607,513.962], [998.599,559.059], [1026.09,505.359], [1025.9,549.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.599,559.088], [998.591,603.582], [1025.9,549.036], [1025.72,592.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.591,603.61], [998.584,647.512], [1025.72,592.148], [1025.54,634.678]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.584,647.54], [998.576,690.862], [1025.54,634.705], [1025.36,676.691]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.576,690.889], [998.569,733.642], [1025.36,676.718], [1025.18,718.171]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.569,733.669], [998.561,775.865], [1025.18,718.197], [1025.01,759.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.561,775.865], [998.555,814.503], [1025.01,759.127], [1024.85,796.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.66,324.261], [1008.59,369.974], [1054.29,320.507], [1053.94,363.68]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.16,631.992], [1008.09,673.696], [1051.89,611.764], [1051.56,651.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.09,673.722], [1008.03,714.9], [1051.56,651.373], [1051.24,690.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.03,714.926], [1007.96,755.587], [1051.24,690.509], [1050.92,729.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.96,755.587], [1007.9,792.839], [1050.92,729.157], [1050.63,764.586]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.59,369.975], [1008.51,415.056], [1053.94,363.681], [1053.59,406.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.51,415.085], [1008.44,459.575], [1053.59,406.315], [1053.24,448.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.44,459.603], [1008.37,503.514], [1053.24,448.422], [1052.89,489.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.37,503.542], [1008.3,546.886], [1052.89,490.011], [1052.56,531.066]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.3,546.913], [1008.23,589.699], [1052.56,531.092], [1052.22,571.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1008.23,589.726], [1008.16,631.965], [1052.22,571.673], [1051.89,611.738]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1002.92,274.876], [1002.89,314.163], [1072.51,273.412], [1072.12,309.367]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.9,622.683], [1080.44,659.119], [1054.75,618.819], [1054.43,654.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.44,659.141], [1079.98,695.176], [1054.43,654.914], [1054.12,690.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.98,695.176], [1079.56,728.237], [1054.12,690.594], [1053.84,723.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.32,510.83], [1081.84,548.51], [1055.71,508.105], [1055.38,545.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.84,548.534], [1081.37,585.793], [1055.38,545.421], [1055.06,582.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.37,585.816], [1080.9,622.66], [1055.06,582.323], [1054.75,618.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.79,395.113], [1083.29,434.102], [1056.7,393.608], [1056.37,432.182]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.29,434.127], [1082.8,472.673], [1056.37,432.206], [1056.04,470.345]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.8,472.697], [1082.32,510.806], [1056.04,470.37], [1055.71,508.082]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.79,315.72], [1084.29,355.646], [1057.39,315.078], [1057.04,354.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.29,355.646], [1083.79,395.088], [1057.04,354.568], [1056.7,393.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.9,622.683], [1080.44,659.119], [1093.64,616.371], [1093.11,652.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.44,659.141], [1079.98,695.176], [1093.11,652.237], [1092.6,687.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.98,695.176], [1079.56,728.237], [1092.6,687.692], [1092.12,720.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.84,548.534], [1081.37,585.793], [1094.7,543.449], [1094.17,580.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.37,585.816], [1080.9,622.66], [1094.17,580.111], [1093.64,616.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.8,472.697], [1082.32,510.806], [1095.79,468.896], [1095.24,506.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.32,510.83], [1081.84,548.51], [1095.24,506.38], [1094.7,543.426]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.79,395.112], [1083.29,434.102], [1096.9,392.656], [1096.34,430.966]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.29,434.127], [1082.8,472.673], [1096.34,430.991], [1095.79,468.872]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.79,315.72], [1084.29,355.646], [1098.04,314.671], [1097.47,353.885]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.29,355.646], [1083.79,395.088], [1097.47,353.885], [1096.9,392.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.35,691.46], [1092.6,687.692], [1113.76,724.261], [1092.12,720.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.64,619.549], [1114.99,655.69], [1093.64,616.371], [1093.11,652.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.99,655.713], [1093.11,652.237], [1114.35,691.46], [1092.6,687.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.96,546.009], [1116.29,582.96], [1094.7,543.449], [1094.17,580.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.29,582.983], [1115.64,619.526], [1094.17,580.111], [1093.64,616.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.3,470.809], [1117.63,508.596], [1095.79,468.896], [1095.24,506.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.63,508.62], [1116.96,545.986], [1095.24,506.38], [1094.7,543.426]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.68,393.892], [1118.99,432.545], [1096.9,392.656], [1096.34,430.966]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.99,432.569], [1118.3,470.785], [1096.34,430.991], [1095.79,468.872]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.39,354.772], [1119.68,393.868], [1097.47,353.886], [1096.9,392.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.1,315.199], [1120.39,354.772], [1098.04,314.671], [1097.47,353.885]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.99,655.713], [1114.35,691.46], [1147.09,637.519], [1146.31,671.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.35,691.46], [1113.76,724.261], [1146.31,671.735], [1145.6,703.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.64,619.549], [1114.99,655.69], [1147.88,602.921], [1147.09,637.497]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.96,546.009], [1116.29,582.96], [1149.48,532.62], [1148.67,567.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.29,582.983], [1115.64,619.526], [1148.67,567.956], [1147.88,602.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.63,508.62], [1116.96,545.986], [1150.29,496.905], [1149.48,532.597]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.99,432.569], [1118.3,470.785], [1151.95,424.317], [1151.11,460.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.3,470.809], [1117.63,508.596], [1151.11,460.807], [1150.29,496.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.68,393.892], [1118.99,432.545], [1152.79,387.431], [1151.95,424.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.1,315.199], [1120.39,354.772], [1154.49,312.442], [1153.63,350.142]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.39,354.772], [1119.68,393.868], [1153.63,350.142], [1152.79,387.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.93,639.592], [1147.09,637.519], [1160.08,673.983], [1146.31,671.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.08,673.983], [1146.31,671.735], [1159.29,705.552], [1145.59,703.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.8,604.815], [1147.88,602.921], [1160.94,639.57], [1147.09,637.497]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.67,569.668], [1148.67,567.956], [1161.8,604.793], [1147.88,602.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.56,534.145], [1149.48,532.62], [1162.68,569.645], [1148.67,567.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.36,461.945], [1164.45,498.216], [1151.11,460.807], [1150.29,496.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.45,498.239], [1150.29,496.905], [1163.56,534.122], [1149.48,532.597]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.27,425.256], [1165.36,461.922], [1151.95,424.317], [1151.11,460.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.19,388.166], [1166.27,425.233], [1152.79,387.431], [1151.95,424.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.13,350.668], [1167.19,388.143], [1153.63,350.142], [1152.79,387.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.07,312.756], [1168.13,350.668], [1154.49,312.442], [1153.63,350.142]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.08,673.983], [1159.29,705.552], [1177.11,663.193], [1176.27,693.998]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.93,639.592], [1160.08,673.983], [1178.03,629.643], [1177.11,663.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.8,604.815], [1160.93,639.57], [1178.96,595.725], [1178.03,629.621]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.67,569.668], [1161.8,604.793], [1179.91,561.456], [1178.96,595.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.56,534.145], [1162.68,569.646], [1180.86,526.83], [1179.91,561.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.45,498.239], [1163.56,534.122], [1181.82,491.841], [1180.86,526.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.27,425.256], [1165.36,461.922], [1183.77,420.753], [1182.79,456.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.36,461.945], [1164.45,498.216], [1182.79,456.484], [1181.82,491.819]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.19,388.166], [1166.27,425.233], [1184.76,384.642], [1183.77,420.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.13,350.668], [1167.19,388.143], [1185.76,348.144], [1184.76,384.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.07,312.756], [1168.13,350.668], [1186.77,311.253], [1185.76,348.144]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1177.77,273.896], [1176.81,310.953], [1194.15,273.483], [1193.13,309.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.57,627.652], [1167.7,661.033], [1184.36,618.647], [1183.44,651.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.7,661.034], [1166.91,691.686], [1183.44,651.265], [1182.59,681.223]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.45,593.907], [1168.57,627.631], [1185.3,585.682], [1184.36,618.626]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.34,559.814], [1169.45,593.885], [1186.24,552.386], [1185.3,585.661]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.23,525.367], [1170.34,559.792], [1187.2,518.754], [1186.24,552.365]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.14,490.562], [1171.23,525.345], [1188.16,484.779], [1187.2,518.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.05,455.393], [1172.14,490.54], [1189.13,450.459], [1188.16,484.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.81,310.953], [1175.85,347.639], [1193.13,309.597], [1192.11,345.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.98,419.853], [1173.05,455.37], [1190.12,415.785], [1189.13,450.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.18,648.931], [1167.41,678.723], [1194.54,633.044], [1193.68,661.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.91,383.937], [1173.98,419.83], [1191.11,380.754], [1190.12,415.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.03,616.496], [1168.18,648.931], [1195.47,601.857], [1194.54,633.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.85,347.639], [1174.91,383.914], [1192.11,345.36], [1191.11,380.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.88,583.718], [1169.03,616.475], [1196.42,570.353], [1195.47,601.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.74,550.613], [1169.88,583.697], [1197.37,538.548], [1196.42,570.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.61,517.175], [1170.74,550.592], [1198.33,506.436], [1197.37,538.528]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.49,483.399], [1171.61,517.153], [1199.31,474.013], [1198.33,506.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.27,414.814], [1173.38,449.259], [1201.28,408.217], [1200.29,441.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.38,449.281], [1172.49,483.378], [1200.29,441.275], [1199.31,473.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.18,379.995], [1174.28,414.792], [1202.28,374.835], [1201.28,408.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.1,344.816], [1175.18,379.973], [1203.29,341.123], [1202.28,374.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1177.02,309.273], [1176.1,344.816], [1204.31,307.077], [1203.29,341.123]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1177.96,273.384], [1177.02,309.274], [1205.34,272.714], [1204.31,307.077]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[722.092,277.535], [723.969,326.038], [689.846,277.305], [691.902,324.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.969,326.038], [725.82,373.915], [691.902,324.893], [693.932,371.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.82,373.916], [727.646,421.119], [693.932,371.879], [695.934,418.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.648,421.149], [729.449,467.721], [695.936,418.245], [697.911,463.974]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[739.289,278.088], [741.128,328.796], [696.854,277.775], [698.942,327.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.45,467.751], [731.228,513.705], [697.913,464.003], [699.863,509.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.128,328.797], [742.942,378.819], [698.942,327.237], [701.004,376.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.229,513.734], [732.983,559.082], [699.864,509.164], [701.789,553.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.943,378.818], [744.73,428.107], [701.004,376.047], [703.035,424.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.984,559.111], [734.715,603.865], [701.79,553.741], [703.69,597.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.731,428.138], [746.494,476.738], [703.036,424.188], [705.04,471.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.716,603.894], [736.425,648.065], [703.692,597.744], [705.567,641.157]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.495,476.768], [748.233,524.695], [705.042,471.673], [707.018,518.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.426,648.094], [738.112,691.694], [705.569,641.185], [707.421,684.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.234,524.725], [749.948,571.992], [707.02,518.515], [708.97,564.699]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.113,691.722], [739.778,734.762], [707.422,684.074], [709.25,726.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.949,572.021], [751.64,618.642], [708.971,564.728], [710.895,610.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.779,734.789], [741.423,777.28], [709.252,726.423], [711.058,768.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.641,618.671], [753.309,664.658], [710.896,610.324], [712.795,655.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.423,777.28], [742.928,816.2], [711.058,768.213], [712.712,806.499]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.31,664.687], [754.955,710.054], [712.796,655.316], [714.67,699.687]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.956,710.083], [756.58,754.842], [714.671,699.714], [716.52,743.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.581,754.87], [758.182,799.034], [716.521,743.532], [718.347,786.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.182,799.034], [759.649,839.463], [718.347,786.753], [720.018,826.331]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[778.655,278.563], [780.272,331.162], [729.042,278.192], [730.97,329.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.942,331.147], [781.538,382.994], [730.969,329.314], [732.871,379.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.866,383.021], [783.436,434.093], [732.871,379.738], [734.744,429.417]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.437,434.125], [784.984,484.457], [734.746,429.448], [736.592,478.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.985,484.489], [786.51,534.098], [736.594,478.458], [738.415,526.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.511,534.129], [788.014,583.031], [738.416,526.784], [740.212,574.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.015,583.062], [789.497,631.272], [740.213,574.439], [741.984,621.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.498,631.302], [790.959,678.833], [741.985,621.437], [743.732,667.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.96,678.863], [792.401,725.731], [743.733,667.792], [745.456,713.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.402,725.76], [793.822,771.978], [745.457,713.518], [747.157,758.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.823,772.007], [795.224,817.589], [747.158,758.625], [748.835,803.101]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.224,817.589], [796.507,859.298], [748.835,803.101], [750.37,843.812]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[778.323,278.56], [779.942,331.147], [803.112,278.292], [804.518,329.81]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.942,331.147], [781.538,382.994], [804.518,329.811], [805.906,380.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.538,382.994], [783.11,434.054], [805.906,380.621], [807.272,430.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.111,434.086], [784.66,484.407], [807.273,430.705], [808.62,480.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.661,484.438], [786.188,534.037], [808.621,480.079], [809.949,528.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.189,534.068], [787.694,582.96], [809.95,528.759], [811.26,576.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.695,582.99], [789.179,631.189], [811.261,576.758], [812.552,624.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.18,631.22], [790.643,678.741], [812.553,624.09], [813.826,670.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.644,678.771], [792.086,725.629], [813.827,670.77], [815.083,716.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.087,725.659], [793.51,771.867], [815.084,716.811], [816.323,762.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.511,771.896], [794.914,817.468], [816.324,762.226], [817.547,806.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.914,817.469], [796.197,859.169], [817.547,806.999], [818.666,847.979]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[840.279,278.561], [841.44,331.148], [803.112,278.292], [804.518,329.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.44,331.148], [842.585,382.996], [804.518,329.811], [805.906,380.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.585,382.996], [843.712,434.056], [805.905,380.621], [807.272,430.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.713,434.088], [844.824,484.41], [807.273,430.705], [808.62,480.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.825,484.442], [845.92,534.041], [808.621,480.08], [809.949,528.729]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.921,534.072], [847,582.964], [809.95,528.759], [811.26,576.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.001,582.995], [848.065,631.195], [811.26,576.758], [812.552,624.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.066,631.225], [849.115,678.747], [812.553,624.09], [813.826,670.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.116,678.777], [850.151,725.635], [813.827,670.77], [815.083,716.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.151,725.665], [851.172,771.874], [815.084,716.811], [816.323,762.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.172,771.903], [852.179,817.476], [816.324,762.226], [817.547,806.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.179,817.476], [853.1,859.177], [817.547,806.999], [818.665,847.98]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[840.279,278.561], [841.44,331.148], [907.433,277.794], [908.06,327.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.44,331.148], [842.585,382.996], [908.06,327.332], [908.678,376.215]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.585,382.996], [843.712,434.056], [908.678,376.215], [909.287,424.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.713,434.089], [844.824,484.41], [909.287,424.427], [909.888,471.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.825,484.442], [845.92,534.041], [909.889,471.982], [910.481,518.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.921,534.072], [847,582.964], [910.482,518.892], [911.067,565.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.001,582.995], [848.065,631.195], [911.067,565.17], [911.644,610.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.066,631.225], [849.115,678.747], [911.644,610.83], [912.214,655.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.116,678.777], [850.151,725.636], [912.214,655.884], [912.776,700.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.151,725.665], [851.172,771.874], [912.776,700.343], [913.331,744.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.172,771.903], [852.179,817.476], [913.331,744.219], [913.878,787.497]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.179,817.476], [853.099,859.177], [913.878,787.497], [914.379,827.128]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[925.369,277.912], [925.875,327.918], [907.434,277.794], [908.06,327.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.875,327.918], [926.375,377.257], [908.06,327.332], [908.678,376.215]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.375,377.257], [926.867,425.882], [908.678,376.215], [909.287,424.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.867,425.912], [927.353,473.867], [909.288,424.427], [909.889,471.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.353,473.897], [927.832,521.197], [909.889,471.982], [910.482,518.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.833,521.227], [928.305,567.883], [910.482,518.892], [911.067,565.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.305,567.913], [928.771,613.94], [911.067,565.17], [911.644,610.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.772,613.969], [929.231,659.38], [911.645,610.83], [912.214,655.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.232,659.409], [912.214,655.884], [929.685,704.215], [912.776,700.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.686,704.243], [912.777,700.343], [930.133,748.457], [913.331,744.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.133,748.485], [913.331,744.219], [930.575,792.118], [913.879,787.497]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.575,792.118], [913.879,787.497], [930.98,832.069], [914.38,827.127]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[925.369,277.912], [925.875,327.918], [960.015,277.506], [960.269,325.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.875,327.918], [926.375,377.257], [960.269,325.896], [960.52,373.662]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.375,377.257], [926.867,425.882], [960.52,373.662], [960.768,420.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.867,425.912], [927.353,473.867], [960.768,420.788], [961.012,467.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.353,473.898], [927.832,521.197], [961.012,467.285], [961.253,513.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.833,521.227], [928.305,567.883], [961.254,513.166], [961.492,558.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.305,567.913], [928.771,613.94], [961.492,558.444], [961.726,603.101]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.772,613.969], [929.231,659.38], [961.727,603.129], [961.958,647.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.232,659.409], [929.685,704.215], [961.958,647.235], [962.187,690.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.686,704.243], [930.133,748.457], [962.187,690.771], [962.413,733.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.133,748.485], [930.575,792.118], [962.413,733.75], [962.636,776.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.575,792.118], [930.98,832.068], [962.636,776.154], [962.84,814.995]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[863.378,276.726], [864.23,322.01], [958.952,275.768], [959.176,317.233]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.011,326.326], [974.17,374.426], [1007.45,324.319], [1007.38,370.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.17,374.426], [974.327,421.847], [1007.38,370.858], [1007.32,416.759]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.327,421.877], [974.482,468.661], [1007.32,416.788], [1007.25,462.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.482,468.691], [974.635,514.851], [1007.25,462.122], [1007.19,506.842]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.635,514.88], [974.786,560.429], [1007.19,506.87], [1007.13,551.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.787,560.458], [974.935,605.407], [1007.13,551.045], [1007.06,594.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.936,605.435], [975.083,649.797], [1007.06,594.656], [1007,637.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.083,649.825], [975.228,693.61], [1007,637.716], [1006.94,680.206]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.228,693.638], [975.371,736.858], [1006.94,680.233], [1006.88,722.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.371,736.886], [975.513,779.552], [1006.88,722.22], [1006.83,763.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[975.513,779.552], [975.642,818.629], [1006.83,763.658], [1006.77,801.625]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.211,323.806], [990.258,369.946], [1044.14,320.653], [1043.85,364.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.258,369.946], [990.305,415.459], [1043.85,364.335], [1043.57,407.453]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.305,415.488], [990.351,460.414], [1043.57,407.481], [1043.29,450.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.351,460.443], [990.396,504.794], [1043.29,450.1], [1043.01,492.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.396,504.822], [990.441,548.61], [1043.01,492.202], [1042.73,533.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.441,548.638], [990.485,591.872], [1042.73,533.798], [1042.46,574.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.485,591.899], [990.529,634.591], [1042.46,574.895], [1042.19,615.477]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.529,634.618], [990.572,676.776], [1042.19,615.502], [1041.93,655.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.572,676.803], [990.615,718.439], [1041.93,655.629], [1041.67,695.259]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.615,718.465], [990.657,759.588], [1041.67,695.284], [1041.41,734.451]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[990.657,759.588], [990.695,797.27], [1041.41,734.451], [1041.17,770.362]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1005.82,275.299], [1005.78,314.888], [1086.22,274.493], [1085.77,310.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.85,664.681], [1080.4,701.24], [1055.79,659.808], [1055.47,695.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.4,701.24], [1079.98,734.787], [1055.47,695.949], [1055.19,729.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.24,552.496], [1081.77,590.28], [1056.75,548.934], [1056.42,586.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.77,590.304], [1081.31,627.673], [1056.42,586.295], [1056.1,623.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.31,627.697], [1080.85,664.658], [1056.1,623.251], [1055.79,659.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.68,436.507], [1083.2,475.58], [1057.74,434.35], [1057.4,472.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.2,475.605], [1082.72,514.24], [1057.4,472.968], [1057.07,511.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.72,514.265], [1082.24,552.471], [1057.07,511.161], [1056.75,548.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.17,316.52], [1084.67,356.973], [1058.77,315.865], [1058.42,355.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.67,356.973], [1084.17,396.941], [1058.42,355.805], [1058.08,395.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.17,396.966], [1083.68,436.483], [1058.08,395.298], [1057.74,434.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.85,664.681], [1080.4,701.24], [1095.84,658.087], [1095.31,694.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.4,701.24], [1079.98,734.787], [1095.31,694.081], [1094.83,727.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.77,590.304], [1081.31,627.673], [1096.91,584.88], [1096.37,621.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.31,627.697], [1080.85,664.658], [1096.37,621.682], [1095.84,658.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.72,514.265], [1082.24,552.471], [1098,510.065], [1097.45,547.653]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.24,552.496], [1081.77,590.28], [1097.45,547.677], [1096.91,584.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.68,436.507], [1083.2,475.58], [1099.12,433.588], [1098.56,472.014]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.2,475.605], [1082.72,514.24], [1098.56,472.038], [1098,510.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.67,356.973], [1084.17,396.941], [1100.26,355.393], [1099.69,394.684]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.17,396.966], [1083.68,436.483], [1099.69,394.709], [1099.12,433.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.17,316.52], [1084.67,356.973], [1100.84,315.634], [1100.26,355.393]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.05,662.113], [1116.4,698.452], [1095.84,658.087], [1095.31,694.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.4,698.452], [1115.81,731.8], [1095.31,694.081], [1094.83,727.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.36,588.192], [1117.7,625.331], [1096.91,584.88], [1096.37,621.659]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.7,625.354], [1117.05,662.09], [1096.37,621.682], [1095.84,658.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.03,550.619], [1118.36,588.168], [1097.45,547.677], [1096.91,584.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.39,474.215], [1119.7,512.605], [1098.56,472.038], [1098,510.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.7,512.629], [1119.03,550.595], [1098,510.065], [1097.45,547.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.77,396.087], [1121.08,435.345], [1099.69,394.709], [1099.12,433.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.07,435.37], [1120.39,474.191], [1099.12,433.588], [1098.56,472.014]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.19,316.175], [1122.48,356.357], [1100.84,315.634], [1100.26,355.393]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.48,356.357], [1121.77,396.062], [1100.26,355.393], [1099.69,394.684]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.05,662.113], [1116.4,698.452], [1155.41,644.646], [1154.6,679.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.4,698.452], [1115.81,731.8], [1154.6,679.483], [1153.85,711.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.7,625.354], [1117.05,662.09], [1156.24,609.423], [1155.42,644.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.03,550.619], [1118.36,588.168], [1157.91,537.863], [1157.07,573.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.36,588.191], [1117.7,625.331], [1157.07,573.83], [1156.24,609.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.7,512.629], [1119.03,550.595], [1158.76,501.514], [1157.91,537.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.08,435.37], [1120.39,474.191], [1160.49,427.647], [1159.62,464.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.39,474.215], [1119.7,512.605], [1159.62,464.777], [1158.76,501.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.77,396.087], [1121.08,435.345], [1161.37,390.117], [1160.49,427.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.48,356.357], [1121.77,396.062], [1162.26,352.181], [1161.37,390.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.19,316.175], [1122.48,356.357], [1163.16,313.832], [1162.26,352.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.08,682.106], [1154.6,679.483], [1167.26,714.279], [1153.85,711.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.97,647.061], [1155.41,644.646], [1168.08,682.106], [1154.6,679.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.78,575.815], [1157.07,573.83], [1169.87,611.602], [1156.24,609.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.87,611.625], [1156.24,609.423], [1168.97,647.039], [1155.42,644.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.7,539.625], [1157.91,537.863], [1170.78,575.792], [1157.07,573.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.63,503.049], [1171.7,539.602], [1158.76,501.514], [1157.91,537.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.57,466.081], [1172.63,503.026], [1159.62,464.777], [1158.76,501.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.52,428.714], [1173.57,466.057], [1160.49,427.647], [1159.62,464.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.45,352.757], [1175.48,390.917], [1162.26,352.181], [1161.37,390.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.48,390.941], [1174.52,428.69], [1161.37,390.117], [1160.49,427.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.43,314.155], [1176.45,352.757], [1163.16,313.832], [1162.26,352.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.08,682.106], [1167.26,714.279], [1188.59,671.683], [1187.7,703.104]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.97,647.061], [1168.08,682.106], [1189.57,637.466], [1188.59,671.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.87,611.625], [1168.97,647.039], [1190.55,602.876], [1189.57,637.444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.78,575.815], [1169.87,611.602], [1191.54,567.931], [1190.55,602.854]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.7,539.625], [1170.78,575.792], [1192.55,532.625], [1191.55,567.909]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.63,503.049], [1171.7,539.602], [1193.56,496.951], [1192.55,532.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.57,466.081], [1172.63,503.026], [1194.59,460.904], [1193.56,496.928]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.52,428.714], [1173.57,466.057], [1195.62,424.479], [1194.59,460.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.48,390.942], [1174.52,428.69], [1196.67,387.67], [1195.62,424.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.45,352.757], [1175.48,390.917], [1197.73,350.469], [1196.67,387.646]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.43,314.155], [1176.45,352.757], [1198.8,312.871], [1197.73,350.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1179.54,669.268], [1178.69,700.514], [1198.45,659.826], [1197.54,690.387]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1190.21,274.836], [1189.19,312.575], [1209.94,274.604], [1208.84,311.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1180.46,635.243], [1179.54,669.268], [1199.44,626.554], [1198.45,659.826]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.39,600.85], [1180.46,635.221], [1200.44,592.93], [1199.44,626.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.33,566.105], [1181.39,600.828], [1201.46,558.97], [1200.44,592.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.28,531.003], [1182.33,566.083], [1202.48,524.67], [1201.46,558.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.24,495.539], [1183.28,530.981], [1203.51,490.024], [1202.48,524.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.19,423.499], [1185.21,459.683], [1205.61,419.672], [1204.56,455.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.21,459.706], [1184.24,495.516], [1204.56,455.026], [1203.52,490.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.19,312.574], [1188.18,349.939], [1208.84,311.416], [1207.76,347.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.18,386.913], [1186.19,423.476], [1206.68,383.956], [1205.61,419.65]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.18,349.94], [1187.18,386.889], [1207.76,347.873], [1206.68,383.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.42,657.097], [1182.59,687.46], [1214.99,641.737], [1214.05,670.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.34,624.043], [1183.42,657.097], [1216.02,609.913], [1214.99,641.737]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.26,590.641], [1184.34,624.022], [1217.05,577.767], [1216.02,609.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.19,556.909], [1185.26,590.62], [1218.1,545.315], [1217.05,577.747]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.13,522.84], [1186.19,556.887], [1219.15,512.553], [1218.1,545.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.08,488.431], [1187.13,522.819], [1220.22,479.476], [1219.15,512.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.04,453.675], [1188.08,488.409], [1221.29,446.079], [1220.22,479.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.01,418.567], [1189.04,453.653], [1222.38,412.358], [1221.29,446.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.99,383.103], [1190.01,418.545], [1223.48,378.309], [1222.38,412.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.98,347.276], [1190.99,383.08], [1224.58,343.926], [1223.48,378.287]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.97,311.081], [1191.98,347.276], [1225.7,309.204], [1224.58,343.925]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1193.98,274.536], [1192.97,311.081], [1226.83,274.161], [1225.7,309.204]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[701.319,275.99], [703.264,324.17], [672.841,275.943], [674.928,323.113]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[711.351,276.093], [713.318,326.537], [673.949,276.03], [676.113,325.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[703.264,324.169], [705.185,371.751], [674.928,323.113], [676.99,369.71]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.318,326.537], [715.26,376.322], [676.113,325.095], [678.249,373.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.185,371.751], [707.079,418.685], [676.99,369.71], [679.024,415.686]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.26,376.322], [717.174,425.401], [678.249,373.539], [680.356,421.313]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.081,418.715], [708.951,465.044], [679.026,415.715], [681.034,461.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.175,425.431], [719.064,473.848], [680.357,421.343], [682.436,468.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.952,465.073], [710.798,510.809], [681.036,461.139], [683.019,505.965]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.065,473.879], [720.928,521.647], [682.438,468.519], [684.49,515.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.8,510.838], [712.622,555.992], [683.021,505.993], [684.979,550.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.929,521.677], [722.767,568.81], [684.491,515.08], [686.517,561.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.623,556.021], [714.423,600.603], [684.981,550.288], [686.915,594.006]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.769,568.839], [724.582,615.349], [686.518,561.039], [688.517,606.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.424,600.631], [716.201,644.654], [686.916,594.034], [688.827,637.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.584,615.379], [726.374,661.278], [688.519,606.405], [690.492,651.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.203,644.682], [717.958,688.155], [688.828,637.242], [690.716,679.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.375,661.307], [728.142,706.607], [690.494,651.192], [692.442,695.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.959,688.182], [719.692,731.115], [690.717,679.92], [692.581,722.052]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.143,706.636], [729.887,751.349], [692.444,695.41], [694.368,739.042]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.693,731.143], [721.405,773.546], [692.582,722.079], [694.424,763.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.888,751.377], [731.609,795.515], [694.369,739.069], [696.269,782.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.405,773.546], [722.973,812.402], [694.424,763.702], [696.112,801.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.609,795.515], [733.186,835.938], [696.269,782.154], [698.01,821.625]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[744.003,276.187], [745.816,328.654], [700.133,276.111], [702.193,326.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.53,328.641], [747.319,380.382], [702.193,326.938], [704.226,377.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.604,380.409], [749.366,431.402], [704.226,377.096], [706.23,426.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.367,431.434], [751.104,481.712], [706.231,426.569], [708.208,475.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.105,481.743], [752.818,531.322], [708.209,475.369], [710.159,523.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.819,531.353], [754.508,580.246], [710.161,523.511], [712.084,570.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.51,580.276], [756.176,628.498], [712.086,571.008], [713.984,617.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.177,628.529], [757.82,676.093], [713.985,617.872], [715.858,664.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.821,676.123], [759.442,723.044], [715.859,664.117], [717.708,709.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.443,723.073], [761.043,769.363], [717.709,709.754], [719.534,754.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.044,769.391], [762.621,815.063], [719.535,754.795], [721.335,799.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.621,815.063], [764.066,856.871], [721.335,799.225], [722.984,839.911]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[743.715,276.186], [745.53,328.64], [771.229,276.14], [772.816,327.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.53,328.641], [747.32,380.382], [772.816,327.598], [774.381,378.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.32,380.382], [749.083,431.362], [774.381,378.37], [775.924,428.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.084,431.394], [750.823,481.66], [775.925,428.439], [777.447,477.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.824,481.691], [752.538,531.257], [777.448,477.82], [778.949,526.496]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.539,531.288], [754.23,580.17], [778.95,526.527], [780.431,574.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.231,580.2], [755.899,628.411], [780.432,574.573], [781.893,621.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.9,628.441], [757.545,675.995], [781.894,621.971], [783.335,668.707]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.546,676.025], [759.168,722.935], [783.336,668.736], [784.758,714.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.169,722.964], [760.77,769.243], [784.759,714.879], [786.162,760.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.771,769.272], [762.351,814.933], [786.163,760.412], [787.548,805.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.351,814.933], [763.796,856.732], [787.548,805.32], [788.816,846.439]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[804.509,276.196], [805.894,328.85], [771.228,276.14], [772.815,327.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.894,328.85], [807.26,380.787], [772.816,327.598], [774.381,378.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.26,380.787], [808.606,431.956], [774.381,378.37], [775.924,428.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.606,431.988], [809.933,482.437], [775.925,428.439], [777.447,477.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.934,482.469], [811.243,532.214], [777.448,477.82], [778.949,526.496]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.243,532.245], [812.534,581.3], [778.95,526.527], [780.431,574.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.535,581.331], [813.807,629.711], [780.432,574.573], [781.893,621.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.808,629.741], [815.063,677.459], [781.894,621.971], [783.335,668.707]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.064,677.489], [816.302,724.558], [783.336,668.736], [784.758,714.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.302,724.588], [817.524,771.022], [784.759,714.879], [786.162,760.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.525,771.051], [818.729,816.863], [786.163,760.412], [787.548,805.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.729,816.863], [819.833,858.798], [787.548,805.321], [788.816,846.439]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[804.509,276.196], [805.894,328.85], [880.208,276.063], [881.003,325.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.894,328.85], [807.26,380.787], [881.003,325.842], [881.789,374.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.26,380.787], [808.605,431.956], [881.789,374.981], [882.563,423.431]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.606,431.988], [809.933,482.438], [882.563,423.462], [883.327,471.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.934,482.469], [811.242,532.214], [883.328,471.297], [884.082,518.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.243,532.245], [812.534,581.3], [884.082,518.499], [884.826,565.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.534,581.331], [813.807,629.711], [884.827,565.082], [885.561,611.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.808,629.741], [815.063,677.459], [885.562,611.057], [886.286,656.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.064,677.489], [816.302,724.558], [886.287,656.436], [887.002,701.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.302,724.588], [817.524,771.022], [887.003,701.23], [887.709,745.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.525,771.051], [818.729,816.863], [887.709,745.451], [888.407,789.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.729,816.863], [819.832,858.798], [888.407,789.082], [889.045,829.048]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[896.621,276.088], [897.313,326.397], [880.208,276.063], [881.004,325.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.313,326.397], [897.995,376.053], [881.003,325.842], [881.789,374.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.995,376.053], [898.668,425.005], [881.789,374.981], [882.563,423.431]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.669,425.036], [899.332,473.33], [882.564,423.461], [883.328,471.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.333,473.361], [899.988,521.009], [883.328,471.297], [884.082,518.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.988,521.039], [900.634,568.056], [884.083,518.5], [884.827,565.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.635,568.086], [901.272,614.482], [884.827,565.082], [885.561,611.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.273,614.512], [901.902,660.301], [885.562,611.057], [886.287,656.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.903,660.329], [902.524,705.523], [886.287,656.436], [887.003,701.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.524,705.551], [887.003,701.23], [903.137,750.16], [887.709,745.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.138,750.188], [887.71,745.451], [903.743,794.224], [888.407,789.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.743,794.224], [888.407,789.082], [904.297,834.556], [889.046,829.047]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[896.621,276.088], [897.313,326.397], [936.101,276.017], [936.508,324.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.313,326.397], [897.995,376.053], [936.509,324.791], [936.911,372.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.995,376.053], [898.668,425.005], [936.911,372.951], [937.308,420.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.668,425.036], [899.332,473.33], [937.309,420.478], [937.701,467.356]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.333,473.361], [899.987,521.009], [937.701,467.385], [938.088,513.655]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.988,521.04], [900.634,568.056], [938.088,513.685], [938.47,559.359]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.635,568.086], [901.272,614.482], [938.47,559.388], [938.847,604.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.273,614.512], [901.902,660.301], [938.847,604.506], [939.22,649.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.902,660.33], [902.523,705.523], [939.22,649.051], [939.587,693.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.524,705.551], [903.137,750.16], [939.588,693.032], [939.951,736.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.138,750.188], [903.743,794.224], [939.951,736.462], [940.309,779.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.743,794.224], [904.297,834.556], [940.309,779.323], [940.638,818.591]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[849.46,275.859], [850.375,321.205], [956.027,275.693], [956.263,317.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.228,325.2], [949.549,373.741], [987.632,323.597], [987.696,370.644]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.549,373.741], [949.866,421.609], [987.696,370.644], [987.758,417.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.867,421.64], [950.179,468.879], [987.758,417.088], [987.82,462.911]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.179,468.909], [950.488,515.53], [987.82,462.94], [987.881,508.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.488,515.56], [950.792,561.576], [987.881,508.212], [987.941,552.885]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.793,561.606], [951.093,607.029], [987.941,552.913], [988,597.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.093,607.058], [951.39,651.899], [988,597.055], [988.059,640.621]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.39,651.927], [951.683,696.198], [988.059,640.649], [988.117,683.677]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.684,696.226], [951.973,739.936], [988.117,683.704], [988.174,726.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.973,739.964], [952.258,783.125], [988.174,726.231], [988.231,768.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.258,783.125], [952.52,822.665], [988.231,768.212], [988.282,806.685]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[971.545,323.107], [971.71,369.698], [1033.46,320.581], [1033.25,364.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[971.71,369.698], [971.873,415.668], [1033.25,364.816], [1033.03,408.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[971.874,415.697], [972.035,461.087], [1033.03,408.518], [1032.82,451.668]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.035,461.115], [972.194,505.936], [1032.82,451.696], [1032.61,494.332]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.194,505.964], [972.352,550.226], [1032.61,494.359], [1032.4,536.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.352,550.254], [972.507,593.967], [1032.4,536.516], [1032.19,578.151]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.507,593.995], [972.66,637.169], [1032.19,578.178], [1031.99,619.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.661,637.197], [972.812,679.843], [1031.99,619.351], [1031.79,660.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.812,679.87], [972.962,721.998], [1031.79,660.045], [1031.59,700.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.962,722.025], [973.11,763.643], [1031.59,700.268], [1031.39,740.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.11,763.643], [973.245,801.788], [1031.39,740.003], [1031.21,776.443]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1008.71,275.611], [1008.65,315.563], [1099.73,275.469], [1099.21,312.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.31,707.805], [1079.9,741.899], [1056.5,701.826], [1056.21,735.482]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.12,556.695], [1081.66,595.071], [1057.77,552.714], [1057.45,590.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.66,595.095], [1081.2,633.056], [1057.45,590.598], [1057.13,628.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.2,633.08], [1080.75,670.631], [1057.13,628.078], [1056.81,665.136]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.75,670.655], [1080.31,707.805], [1056.81,665.159], [1056.5,701.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.53,438.93], [1083.06,478.594], [1058.76,436.568], [1058.43,475.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.06,478.619], [1082.59,517.847], [1058.43,475.706], [1058.1,514.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.59,517.872], [1082.12,556.67], [1058.1,514.419], [1057.77,552.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085,317.166], [1084.5,358.211], [1059.79,316.535], [1059.44,356.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.5,358.211], [1084.02,398.771], [1059.44,356.99], [1059.1,396.973]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.02,398.796], [1083.53,438.904], [1059.1,396.998], [1058.76,436.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.75,670.655], [1080.31,707.805], [1098.03,664.421], [1097.5,701.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.31,707.805], [1079.9,741.899], [1097.5,701.023], [1097.02,734.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.66,595.095], [1081.2,633.056], [1099.11,589.994], [1098.57,627.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.2,633.08], [1080.75,670.631], [1098.57,627.406], [1098.03,664.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.59,517.872], [1082.12,556.67], [1100.21,513.955], [1099.66,552.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.12,556.695], [1081.66,595.071], [1099.66,552.179], [1099.11,589.97]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.53,438.93], [1083.06,478.594], [1101.34,436.25], [1100.77,475.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.06,478.619], [1082.59,517.847], [1100.77,475.314], [1100.21,513.93]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.5,358.211], [1084.02,398.771], [1102.49,356.826], [1101.91,396.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.02,398.796], [1083.53,438.904], [1101.91,396.757], [1101.34,436.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085,317.166], [1084.5,358.211], [1103.07,316.451], [1102.49,356.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.78,705.985], [1117.19,739.946], [1097.5,701.023], [1097.02,734.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.08,631.557], [1118.42,668.959], [1098.57,627.406], [1098.03,664.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,668.982], [1117.78,705.985], [1098.03,664.421], [1097.5,701.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.4,555.483], [1119.74,593.702], [1099.66,552.179], [1099.11,589.97]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.74,593.726], [1119.08,631.533], [1099.11,589.994], [1098.57,627.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.76,477.732], [1121.08,516.796], [1100.77,475.314], [1100.21,513.93]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.08,516.82], [1120.4,555.458], [1100.21,513.955], [1099.66,552.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.14,398.249], [1122.45,438.185], [1101.91,396.757], [1101.34,436.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.45,438.211], [1121.76,477.707], [1101.34,436.25], [1100.77,475.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.85,357.839], [1123.14,398.223], [1102.49,356.826], [1101.91,396.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.56,316.974], [1123.85,357.839], [1103.07,316.451], [1102.49,356.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.78,705.985], [1117.19,739.946], [1162.23,687.912], [1161.46,720.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,668.982], [1117.78,705.985], [1163.08,652.372], [1162.23,687.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.74,593.726], [1119.08,631.533], [1164.8,580.139], [1163.93,616.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.08,631.557], [1118.43,668.959], [1163.93,616.442], [1163.08,652.349]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.08,516.82], [1120.4,555.458], [1166.55,506.391], [1165.67,543.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.4,555.483], [1119.74,593.702], [1165.67,543.458], [1164.8,580.116]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.76,477.732], [1121.08,516.796], [1167.44,468.934], [1166.55,506.368]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.45,438.211], [1121.76,477.707], [1168.34,431.08], [1167.44,468.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.85,357.839], [1123.14,398.223], [1170.18,354.155], [1169.26,392.798]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.14,398.249], [1122.45,438.185], [1169.26,392.822], [1168.35,431.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.56,316.974], [1123.85,357.839], [1171.11,315.071], [1170.18,354.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.25,655.126], [1163.08,652.372], [1175.33,690.909], [1162.23,687.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.33,690.909], [1162.23,687.912], [1174.49,723.762], [1161.45,720.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.18,618.948], [1163.93,616.442], [1176.25,655.103], [1163.08,652.349]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.12,582.391], [1164.8,580.139], [1177.18,618.924], [1163.93,616.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.07,545.45], [1178.12,582.368], [1165.67,543.458], [1164.8,580.116]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.03,508.119], [1179.07,545.427], [1166.55,506.391], [1165.67,543.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181,470.391], [1180.03,508.095], [1167.44,468.934], [1166.55,506.368]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.97,393.721], [1181.98,432.236], [1169.26,392.822], [1168.35,431.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.98,432.261], [1181,470.367], [1168.34,431.08], [1167.44,468.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.97,354.765], [1182.97,393.696], [1170.18,354.155], [1169.26,392.798]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.99,315.386], [1183.97,354.765], [1171.11,315.071], [1170.18,354.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.25,655.126], [1175.33,690.909], [1200.41,645.956], [1199.39,680.929]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.33,690.909], [1174.49,723.762], [1199.39,680.929], [1198.46,713.046]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.18,618.948], [1176.25,655.103], [1201.44,610.605], [1200.41,645.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.12,582.391], [1177.18,618.924], [1202.48,574.894], [1201.44,610.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.07,545.45], [1178.12,582.368], [1203.53,538.817], [1202.48,574.871]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.03,508.119], [1179.07,545.427], [1204.6,502.368], [1203.53,538.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181,470.391], [1180.03,508.095], [1205.67,465.541], [1204.6,502.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.98,432.261], [1181,470.367], [1206.75,428.331], [1205.67,465.517]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.97,393.721], [1181.98,432.236], [1207.85,390.731], [1206.75,428.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.97,354.765], [1182.97,393.696], [1208.96,352.735], [1207.85,390.707]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.99,315.386], [1183.97,354.765], [1210.07,314.338], [1208.96,352.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.74,678.26], [1189.85,710.179], [1212.89,669.211], [1211.92,700.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.68,572.89], [1192.69,608.352], [1216.09,566.099], [1215.02,600.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.71,643.503], [1190.74,678.259], [1213.95,635.191], [1212.89,669.21]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1201.97,275.545], [1200.9,314.058], [1225.11,275.503], [1223.94,313.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.69,608.375], [1191.71,643.481], [1215.02,600.815], [1213.95,635.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.68,537.044], [1193.68,572.867], [1217.18,531.037], [1216.09,566.077]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.74,427.281], [1196.71,464.222], [1220.51,423.725], [1219.39,459.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.69,500.831], [1194.68,537.021], [1218.28,495.624], [1217.18,531.015]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.71,464.245], [1195.69,500.808], [1219.39,459.856], [1218.28,495.602]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.9,314.058], [1199.83,352.193], [1223.94,313.11], [1222.79,350.359]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1198.78,389.932], [1197.74,427.257], [1221.64,387.228], [1220.51,423.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.83,352.193], [1198.78,389.908], [1222.79,350.359], [1221.64,387.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1198.17,666.083], [1197.28,697.101], [1235.08,651.351], [1234.05,681.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.15,632.319], [1198.17,666.083], [1236.19,618.792], [1235.08,651.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.14,598.204], [1199.15,632.298], [1237.31,585.906], [1236.19,618.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.13,563.753], [1200.14,598.182], [1238.44,552.709], [1237.31,585.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.14,528.962], [1201.13,563.731], [1239.59,519.197], [1238.44,552.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.15,493.826], [1202.14,528.94], [1240.74,485.366], [1239.59,519.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.18,458.34], [1203.15,493.804], [1241.91,451.21], [1240.74,485.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.21,422.498], [1204.18,458.317], [1243.09,416.725], [1241.91,451.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.26,386.295], [1205.21,422.475], [1244.27,381.906], [1243.09,416.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.32,349.725], [1206.26,386.272], [1245.48,346.749], [1244.28,381.884]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.38,312.784], [1207.32,349.725], [1246.69,311.247], [1245.48,346.749]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1209.46,275.488], [1208.38,312.784], [1247.91,275.421], [1246.69,311.248]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[686.107,274.164], [688.167,324.318], [654,274.416], [656.205,323.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.167,324.319], [690.202,373.845], [656.205,323.076], [658.383,371.144]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.202,373.844], [692.208,422.693], [658.383,371.144], [660.532,418.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.209,422.723], [694.19,470.937], [660.533,418.603], [662.655,465.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.191,470.967], [696.146,518.559], [662.657,465.464], [664.752,511.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.147,518.589], [698.077,565.571], [664.754,511.738], [666.823,557.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.078,565.601], [699.983,611.984], [666.824,557.436], [668.868,602.54]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.985,612.013], [701.866,657.81], [668.869,602.568], [670.888,647.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.867,657.838], [703.724,703.059], [670.889,647.146], [672.883,691.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[703.726,703.087], [705.56,747.743], [672.885,691.179], [674.854,734.649]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[711.803,273.803], [713.774,326.097], [674.073,274.105], [676.228,324.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.561,747.771], [707.372,791.871], [674.856,734.677], [676.802,777.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.535,326.085], [715.481,377.68], [676.227,324.61], [678.355,374.478]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.372,791.871], [709.032,832.278], [676.802,777.623], [678.585,816.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.719,377.706], [717.636,428.581], [678.355,374.478], [680.454,423.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.637,428.613], [719.528,478.799], [680.455,423.689], [682.525,472.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.53,478.83], [721.395,528.343], [682.527,472.258], [684.57,520.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.397,528.374], [723.237,577.225], [684.572,520.195], [686.589,567.484]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.239,577.256], [725.055,625.459], [686.591,567.514], [688.582,614.197]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.056,625.49], [726.849,673.059], [688.584,614.226], [690.55,660.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.85,673.088], [728.619,720.035], [690.551,660.343], [692.492,705.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.62,720.064], [730.366,766.4], [692.494,705.876], [694.411,750.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.367,766.429], [732.091,812.167], [694.412,750.836], [696.305,795.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.091,812.167], [733.669,854.054], [696.305,795.207], [698.039,835.857]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[711.564,273.806], [713.535,326.085], [741.421,273.96], [743.156,325.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.535,326.085], [715.481,377.68], [743.156,325.322], [744.869,376.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.481,377.68], [717.4,428.541], [744.869,376.024], [746.557,426.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.401,428.573], [719.293,478.746], [746.558,426.047], [748.224,475.374]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.294,478.777], [721.161,528.276], [748.226,475.405], [749.87,524.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.162,528.308], [723.004,577.146], [749.871,524.112], [751.493,572.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.005,577.177], [724.823,625.368], [751.494,572.18], [753.096,619.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.824,625.399], [726.618,672.955], [753.097,619.622], [754.677,666.42]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.619,672.985], [728.389,719.92], [754.678,666.449], [756.239,712.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.39,719.949], [730.137,766.274], [756.24,712.674], [757.78,758.28]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.138,766.303], [731.863,812.03], [757.781,758.308], [759.302,803.335]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.863,812.03], [733.442,853.907], [759.302,803.335], [760.695,844.579]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[770.448,273.739], [772.026,326.416], [741.421,273.961], [743.156,325.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.026,326.416], [773.582,378.398], [743.156,325.322], [744.869,376.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.582,378.398], [775.117,429.635], [744.868,376.024], [746.557,426.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.118,429.667], [776.631,480.206], [746.558,426.047], [748.224,475.374]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.632,480.238], [778.125,530.093], [748.225,475.405], [749.87,524.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.126,530.124], [779.599,579.309], [749.871,524.112], [751.493,572.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.6,579.34], [781.053,627.868], [751.494,572.18], [753.096,619.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.054,627.899], [782.488,675.784], [753.097,619.622], [754.677,666.42]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.489,675.814], [783.904,723.068], [754.678,666.449], [756.239,712.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.905,723.097], [785.302,769.733], [756.24,712.674], [757.78,758.28]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.302,769.762], [786.681,815.791], [757.781,758.308], [759.302,803.335]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.681,815.791], [787.943,857.941], [759.302,803.335], [760.695,844.579]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[770.448,273.739], [772.025,326.416], [853.774,274.19], [854.721,324.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.026,326.416], [773.582,378.398], [854.721,324.192], [855.657,373.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.582,378.398], [775.117,429.635], [855.657,373.57], [856.58,422.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.117,429.667], [776.631,480.206], [856.581,422.304], [857.492,470.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.632,480.238], [778.125,530.093], [857.493,470.408], [858.392,517.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.126,530.124], [779.599,579.309], [858.393,517.892], [859.281,564.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.6,579.34], [781.053,627.869], [859.281,564.77], [860.158,611.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.054,627.899], [782.488,675.784], [860.159,611.053], [861.024,656.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.489,675.814], [783.904,723.068], [861.025,656.751], [861.88,701.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.905,723.097], [785.301,769.733], [861.88,701.877], [862.724,746.412]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.302,769.762], [786.68,815.791], [862.725,746.44], [863.559,790.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.68,815.791], [787.943,857.941], [863.559,790.423], [864.322,830.724]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[868.472,274.091], [869.333,324.682], [853.774,274.19], [854.722,324.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.333,324.682], [870.183,374.635], [854.721,324.192], [855.657,373.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.183,374.635], [871.021,423.898], [855.658,373.57], [856.581,422.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.022,423.929], [871.849,472.547], [856.582,422.304], [857.493,470.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.849,472.577], [872.666,520.563], [857.493,470.408], [858.393,517.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.666,520.593], [873.472,567.958], [858.393,517.892], [859.281,564.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.473,567.988], [874.268,614.744], [859.282,564.77], [860.159,611.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.269,614.774], [875.054,660.934], [860.159,611.053], [861.025,656.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.055,660.963], [875.83,706.538], [861.025,656.751], [861.88,701.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.831,706.566], [876.596,751.567], [861.881,701.877], [862.725,746.411]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.597,751.595], [862.725,746.439], [877.353,796.032], [863.559,790.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.353,796.032], [863.559,790.423], [878.046,836.743], [864.323,830.724]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[868.472,274.091], [869.333,324.682], [912.393,274.333], [912.944,323.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.333,324.682], [870.183,374.635], [912.944,323.485], [913.489,372.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.183,374.635], [871.021,423.898], [913.489,372.033], [914.027,419.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.021,423.929], [871.849,472.547], [914.027,419.96], [914.558,467.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.849,472.577], [872.666,520.563], [914.558,467.276], [915.082,513.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.666,520.593], [873.472,567.958], [915.082,513.994], [915.599,560.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.473,567.988], [874.268,614.744], [915.6,560.125], [916.111,605.65]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.269,614.774], [875.054,660.934], [916.111,605.679], [916.615,650.64]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.055,660.963], [875.83,706.538], [916.616,650.668], [917.114,695.074]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.831,706.566], [876.596,751.567], [917.114,695.102], [917.607,738.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.597,751.595], [877.353,796.032], [917.607,738.991], [918.093,782.317]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.353,796.032], [878.046,836.743], [918.093,782.317], [918.539,822.024]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[836.616,274.961], [837.58,320.383], [953.346,275.529], [953.591,317.58]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.492,323.849], [924.966,372.824], [967.55,322.646], [967.739,370.211]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.966,372.824], [925.435,421.136], [967.739,370.212], [967.925,417.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.435,421.166], [925.897,468.857], [967.925,417.179], [968.109,463.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.897,468.888], [926.353,515.97], [968.109,463.562], [968.291,509.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.354,516], [926.804,562.486], [968.291,509.369], [968.471,554.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.804,562.515], [927.249,608.415], [968.471,554.612], [968.648,599.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.249,608.444], [927.688,653.77], [968.648,599.3], [968.823,643.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.689,653.799], [928.122,698.56], [968.823,643.445], [968.996,687.028]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.122,698.588], [928.551,742.796], [968.996,687.056], [969.167,730.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.551,742.825], [928.974,786.489], [969.167,730.143], [969.336,772.687]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.974,786.489], [929.362,826.502], [969.336,772.687], [969.491,811.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.791,322.209], [953.07,369.261], [1022.31,320.308], [1022.16,365.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.07,369.261], [953.346,415.7], [1022.16,365.129], [1022.01,409.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.346,415.729], [953.617,461.595], [1022.01,409.42], [1021.87,453.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.618,461.624], [953.886,506.926], [1021.87,453.19], [1021.72,496.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.887,506.955], [954.152,551.706], [1021.72,496.448], [1021.58,539.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.152,551.734], [954.414,595.943], [1021.58,539.204], [1021.44,581.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.414,595.971], [954.673,639.647], [1021.44,581.465], [1021.31,623.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.673,639.674], [954.929,682.827], [1021.31,623.241], [1021.17,664.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.929,682.855], [955.182,725.494], [1021.17,664.539], [1021.03,705.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.182,725.521], [955.432,767.656], [1021.03,705.369], [1020.9,745.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[955.432,767.656], [955.661,806.285], [1020.9,745.712], [1020.78,782.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.59,319.78], [1002.56,363.98], [1024.12,319.208], [1023.97,362.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.44,535.712], [1002.41,577.395], [1023.37,531.929], [1023.22,573.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.41,577.422], [1002.39,618.633], [1023.22,573.039], [1023.08,613.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.39,618.659], [1002.36,659.405], [1023.08,613.691], [1022.94,653.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.36,659.431], [1002.33,699.72], [1022.94,653.892], [1022.8,693.623]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.33,699.746], [1002.3,739.586], [1022.8,693.648], [1022.66,732.943]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.3,739.586], [1002.28,776.135], [1022.66,732.943], [1022.53,768.997]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.56,363.98], [1002.53,407.637], [1023.97,362.735], [1023.82,405.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.53,407.664], [1002.5,450.815], [1023.82,405.762], [1023.67,448.271]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.5,450.842], [1002.47,493.495], [1023.67,448.298], [1023.52,490.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1002.47,493.522], [1002.44,535.685], [1023.52,490.351], [1023.37,531.902]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1011.57,275.812], [1011.5,316.181], [1112.98,276.304], [1112.41,313.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.55,638.748], [1080.11,676.948], [1057.79,633.219], [1057.48,670.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.11,676.972], [1079.67,714.769], [1057.48,670.881], [1057.16,708.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.67,714.769], [1079.27,749.463], [1057.16,708.129], [1056.88,742.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.9,521.594], [1081.44,561.041], [1058.75,517.824], [1058.43,556.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.44,561.066], [1080.99,600.09], [1058.43,556.697], [1058.11,595.135]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.99,600.115], [1080.55,638.724], [1058.11,595.159], [1057.79,633.195]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.29,400.572], [1082.82,441.328], [1059.75,398.681], [1059.42,438.798]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.82,441.354], [1082.36,481.667], [1059.42,438.823], [1059.08,478.51]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.36,481.692], [1081.9,521.569], [1059.08,478.535], [1058.76,517.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.24,317.647], [1083.76,359.339], [1060.43,317.078], [1060.09,358.102]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.76,359.339], [1083.29,400.546], [1060.09,358.102], [1059.75,398.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.67,714.769], [1079.27,749.463], [1099.11,708.417], [1098.63,742.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.55,638.748], [1080.11,676.948], [1100.18,633.458], [1099.64,671.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.11,676.972], [1079.67,714.769], [1099.64,671.145], [1099.11,708.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.9,521.594], [1081.44,561.041], [1101.82,517.987], [1101.27,556.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.44,561.066], [1080.99,600.09], [1101.27,556.886], [1100.72,595.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.99,600.115], [1080.55,638.724], [1100.72,595.374], [1100.18,633.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.82,441.354], [1082.36,481.667], [1102.95,438.932], [1102.38,478.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.36,481.692], [1081.9,521.569], [1102.38,478.672], [1101.82,517.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.76,359.339], [1083.29,400.546], [1104.1,358.155], [1103.52,398.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.29,400.572], [1082.82,441.328], [1103.52,398.763], [1102.95,438.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.24,317.647], [1083.76,359.339], [1104.68,317.103], [1104.1,358.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.06,676.225], [1118.42,713.955], [1099.64,671.145], [1099.11,708.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,713.955], [1117.83,748.588], [1099.11,708.417], [1098.63,742.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.36,599.507], [1119.71,638.046], [1100.72,595.374], [1100.18,633.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.7,638.07], [1119.06,676.201], [1100.18,633.458], [1099.64,671.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.69,521.131], [1121.02,560.505], [1101.82,517.987], [1101.27,556.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.02,560.53], [1120.36,599.483], [1101.27,556.886], [1100.72,595.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.04,441.044], [1122.36,481.28], [1102.95,438.932], [1102.38,478.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.36,481.305], [1121.69,521.106], [1102.38,478.672], [1101.82,517.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.73,400.34], [1123.04,441.018], [1103.52,398.763], [1102.95,438.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.14,317.577], [1124.43,359.187], [1104.68,317.103], [1104.1,358.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.43,359.187], [1123.73,400.314], [1104.1,358.155], [1103.52,398.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,713.955], [1117.83,748.588], [1169.12,696.923], [1168.32,730.275]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.7,638.07], [1119.06,676.201], [1170.87,623.891], [1169.99,660.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.06,676.225], [1118.42,713.955], [1169.99,660.604], [1169.12,696.923]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.02,560.53], [1120.36,599.483], [1172.66,549.329], [1171.76,586.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.36,599.507], [1119.71,638.046], [1171.76,586.801], [1170.87,623.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.69,521.131], [1121.02,560.505], [1173.57,511.469], [1172.66,549.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.04,441.044], [1122.36,481.28], [1175.41,434.557], [1174.49,473.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.36,481.305], [1121.69,521.106], [1174.49,473.213], [1173.57,511.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.73,400.34], [1123.04,441.018], [1176.35,395.494], [1175.42,434.533]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.43,359.187], [1123.73,400.314], [1177.3,356.018], [1176.35,395.47]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.14,317.577], [1124.43,359.187], [1178.26,316.121], [1177.3,356.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.76,700.292], [1169.12,696.923], [1180.89,733.897], [1168.32,730.275]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.7,663.693], [1169.99,660.604], [1181.76,700.292], [1169.12,696.923]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.65,626.695], [1170.87,623.891], [1182.7,663.67], [1169.99,660.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.62,589.313], [1183.66,626.671], [1171.76,586.802], [1170.87,623.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.59,551.543], [1184.62,589.289], [1172.66,549.329], [1171.76,586.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.57,513.378], [1185.59,551.519], [1173.57,511.469], [1172.66,549.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.57,474.812], [1186.58,513.354], [1174.49,473.214], [1173.57,511.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.57,435.839], [1187.57,474.788], [1175.41,434.558], [1174.49,473.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.59,396.452], [1188.57,435.814], [1176.35,395.495], [1175.41,434.533]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.65,316.409], [1190.61,356.644], [1178.26,316.121], [1177.3,356.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.61,356.644], [1189.59,396.426], [1177.3,356.018], [1176.35,395.47]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.76,700.292], [1180.89,733.897], [1209.4,690.834], [1208.43,723.726]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.7,663.693], [1181.76,700.292], [1210.46,655.021], [1209.4,690.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.65,626.695], [1182.7,663.67], [1211.53,618.825], [1210.46,654.998]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.62,589.313], [1183.66,626.671], [1212.61,582.263], [1211.53,618.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.59,551.543], [1184.62,589.289], [1213.7,545.33], [1212.61,582.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.57,513.378], [1185.59,551.519], [1214.81,508.019], [1213.71,545.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.57,474.812], [1186.57,513.354], [1215.92,470.326], [1214.81,507.995]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.57,435.839], [1187.57,474.788], [1217.05,432.243], [1215.92,470.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.59,396.452], [1188.57,435.814], [1218.19,393.766], [1217.05,432.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.61,356.644], [1189.59,396.426], [1219.34,354.888], [1218.19,393.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.65,316.409], [1190.61,356.644], [1220.5,315.603], [1219.34,354.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.22,687.915], [1200.29,720.585], [1226.67,679.328], [1225.65,711.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.23,652.344], [1201.22,687.915], [1227.78,644.473], [1226.67,679.328]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.26,616.396], [1202.23,652.322], [1228.91,609.256], [1227.79,644.451]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1212.94,275.979], [1211.82,315.354], [1239.55,276.126], [1238.32,314.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.29,580.088], [1203.26,616.373], [1230.05,573.693], [1228.91,609.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.33,543.413], [1204.29,580.064], [1231.19,537.778], [1230.05,573.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.38,506.366], [1205.33,543.389], [1232.35,501.508], [1231.19,537.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.45,468.942], [1206.39,506.342], [1233.52,464.876], [1232.35,501.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.52,431.135], [1207.45,468.918], [1234.71,427.877], [1233.52,464.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.61,392.938], [1208.53,431.111], [1235.9,390.506], [1234.71,427.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.71,354.347], [1209.61,392.914], [1237.11,352.757], [1235.9,390.482]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.82,315.354], [1210.71,354.347], [1238.32,314.624], [1237.11,352.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.34,675.8], [1211.38,707.552], [1254.7,661.803], [1253.6,692.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.37,641.239], [1212.34,675.8], [1255.9,628.414], [1254.7,661.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.42,606.322], [1213.37,641.217], [1257.1,594.691], [1255.9,628.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.47,571.066], [1214.42,606.3], [1258.32,560.652], [1257.1,594.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.54,535.464], [1215.47,571.043], [1259.55,526.293], [1258.32,560.631]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1217.61,499.513], [1216.54,535.442], [1260.79,491.608], [1259.55,526.271]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.7,463.207], [1217.61,499.49], [1262.04,456.594], [1260.79,491.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.8,426.54], [1218.7,463.184], [1263.31,421.244], [1262.04,456.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.91,389.508], [1219.8,426.517], [1264.58,385.555], [1263.31,421.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.03,352.105], [1220.91,389.485], [1265.87,349.522], [1264.58,385.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.16,314.325], [1222.03,352.105], [1267.17,313.139], [1265.87,349.522]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1224.3,276.187], [1223.16,314.325], [1268.49,276.426], [1267.17,313.14]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[663.846,272.454], [665.964,322.277], [637.211,273.072], [639.424,321.299]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.964,322.277], [668.055,371.503], [639.424,321.3], [641.612,368.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.055,371.502], [670.12,420.08], [641.612,368.968], [643.772,416.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.121,420.11], [672.159,468.082], [643.773,416.057], [645.906,462.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.161,468.112], [674.174,515.49], [645.908,462.578], [648.016,508.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.175,515.52], [676.164,562.314], [648.017,508.541], [650.1,553.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.165,562.344], [678.129,608.566], [650.101,553.955], [652.159,598.803]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[682.461,271.59], [684.549,323.644], [651.158,272.332], [653.37,322.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.131,608.595], [680.071,654.254], [652.161,598.831], [654.195,643.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[684.36,323.635], [686.422,375.021], [653.37,322.471], [655.555,372.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.072,654.283], [681.989,699.391], [654.196,643.178], [656.206,686.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.611,375.045], [688.645,425.74], [655.555,372.004], [657.711,420.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[681.99,699.419], [683.884,743.985], [656.207,687.005], [658.194,730.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.646,425.772], [690.654,475.808], [657.712,420.912], [659.841,469.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.885,744.013], [685.756,788.047], [658.195,730.321], [660.159,773.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.655,475.839], [692.637,525.229], [659.843,469.206], [661.945,516.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.756,788.047], [687.472,828.411], [660.159,773.109], [661.959,812.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.638,525.26], [694.594,574.015], [661.946,516.899], [664.023,563.972]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.595,574.045], [696.526,622.178], [664.024,564.001], [666.075,610.494]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.527,622.208], [698.434,669.731], [666.076,610.523], [668.102,656.447]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.435,669.76], [700.318,716.684], [668.103,656.476], [670.104,701.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.319,716.714], [702.178,763.05], [670.105,701.87], [672.082,746.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.179,763.079], [704.015,808.838], [672.084,746.716], [674.037,790.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.015,808.838], [705.697,850.764], [674.037,790.995], [675.827,831.581]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[682.271,271.596], [684.36,323.635], [714.058,271.918], [715.906,323.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[684.36,323.635], [686.422,375.021], [715.906,323.126], [717.732,373.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.422,375.021], [688.457,425.702], [717.732,373.702], [719.533,423.594]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.458,425.733], [690.466,475.755], [719.534,423.626], [721.312,472.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.468,475.786], [692.45,525.162], [721.313,472.91], [723.068,521.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.451,525.193], [694.408,573.934], [723.069,521.568], [724.802,569.581]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.409,573.965], [696.341,622.085], [724.804,569.611], [726.515,617.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.342,622.115], [698.249,669.624], [726.516,617.05], [728.206,663.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.25,669.654], [700.133,716.566], [728.207,663.898], [729.876,710.134]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.134,716.595], [729.877,710.163], [701.994,762.919], [731.525,755.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.995,762.948], [731.526,755.859], [703.832,808.696], [733.155,800.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[703.832,808.696], [733.155,800.966], [705.514,850.611], [734.647,842.302]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[738.535,271.368], [740.27,323.996], [714.058,271.918], [715.906,323.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.27,323.996], [741.984,375.956], [715.906,323.126], [717.732,373.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.984,375.956], [743.674,427.196], [717.732,373.702], [719.533,423.594]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.675,427.228], [745.342,477.794], [719.534,423.626], [721.312,472.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.343,477.825], [746.989,527.731], [721.313,472.911], [723.068,521.538]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.99,527.762], [748.614,577.02], [723.069,521.568], [724.802,569.581]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.615,577.05], [750.219,625.673], [724.803,569.611], [726.515,617.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.22,625.703], [751.802,673.703], [726.516,617.05], [728.206,663.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.803,673.733], [753.366,721.121], [728.207,663.898], [729.876,710.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.367,721.151], [754.91,767.939], [729.877,710.163], [731.525,755.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.911,767.969], [756.435,814.169], [731.526,755.859], [733.155,800.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.435,814.169], [757.83,856.494], [733.155,800.966], [734.647,842.302]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[738.535,271.369], [740.27,323.996], [828.434,272.316], [829.514,322.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.27,323.996], [741.984,375.956], [829.514,322.498], [830.581,372.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.984,375.956], [743.673,427.196], [830.581,372.073], [831.634,420.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.674,427.228], [745.342,477.794], [831.635,421.022], [832.675,469.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.343,477.826], [746.989,527.731], [832.676,469.357], [833.703,517.059]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.99,527.762], [748.614,577.02], [833.703,517.089], [834.718,564.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.615,577.051], [750.218,625.673], [834.718,564.23], [835.72,610.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.219,625.704], [751.802,673.703], [835.721,610.789], [836.71,656.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.803,673.733], [753.366,721.121], [836.711,656.779], [837.688,702.18]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.367,721.151], [754.91,767.94], [837.689,702.209], [838.654,747.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.911,767.969], [756.434,814.169], [838.655,747.089], [839.609,791.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.434,814.169], [757.83,856.494], [839.609,791.402], [840.483,832.018]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[841.243,272.066], [842.255,322.893], [828.434,272.316], [829.514,322.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.255,322.893], [843.253,373.096], [829.514,322.498], [830.581,372.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.253,373.096], [844.239,422.627], [830.582,372.073], [831.635,420.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.239,422.659], [845.212,471.56], [831.635,421.022], [832.675,469.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.213,471.591], [846.174,519.874], [832.676,469.357], [833.703,517.059]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.174,519.905], [847.123,567.582], [833.704,517.09], [834.718,564.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.124,567.612], [848.06,614.695], [834.719,564.23], [835.72,610.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.061,614.725], [848.986,661.224], [835.721,610.789], [836.71,656.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.987,661.254], [849.9,707.18], [836.711,656.779], [837.688,702.18]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.901,707.209], [850.804,752.574], [837.689,702.209], [838.655,747.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.804,752.602], [851.696,797.415], [838.655,747.089], [839.609,791.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.696,797.415], [852.513,838.484], [839.609,791.402], [840.484,832.018]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[841.243,272.066], [842.255,322.892], [889.135,272.581], [889.818,322.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.255,322.893], [843.253,373.096], [889.818,322.078], [890.492,370.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.253,373.097], [844.239,422.627], [890.492,370.986], [891.158,419.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.24,422.659], [845.212,471.56], [891.159,419.284], [891.816,466.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.213,471.591], [846.174,519.874], [891.817,466.984], [892.466,514.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.174,519.905], [847.123,567.582], [892.467,514.096], [893.109,560.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.124,567.612], [848.06,614.695], [893.109,560.633], [893.743,606.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.061,614.725], [848.986,661.224], [893.743,606.604], [894.369,651.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.987,661.254], [849.9,707.18], [894.37,652.019], [894.988,696.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.901,707.209], [850.804,752.574], [894.989,696.888], [895.6,741.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.804,752.602], [851.696,797.415], [895.6,741.222], [896.205,785.002]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.696,797.415], [852.513,838.484], [896.205,785.002], [896.758,825.137]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[824.989,274.132], [825.989,319.621], [950.94,275.332], [951.192,317.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.051,322.373], [900.667,371.75], [947.369,321.55], [947.678,369.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.667,371.75], [901.276,420.475], [947.677,369.617], [947.982,417.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.276,420.506], [901.877,468.622], [947.982,417.095], [948.283,463.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.877,468.653], [902.471,516.171], [948.283,463.995], [948.58,510.298]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.471,516.201], [903.057,563.132], [948.581,510.328], [948.874,556.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.057,563.162], [903.636,609.518], [948.874,556.103], [949.165,601.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.636,609.547], [904.208,655.337], [949.165,601.331], [949.451,645.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.208,655.366], [904.773,700.601], [949.452,646.022], [949.735,690.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.774,700.63], [905.332,745.319], [949.735,690.185], [950.015,733.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.332,745.348], [905.883,789.502], [950.015,733.829], [950.292,776.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.883,789.502], [906.389,829.976], [950.292,776.936], [950.546,816.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.115,321.194], [934.5,368.693], [1010.71,319.887], [1010.64,365.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.5,368.694], [934.881,415.589], [1010.64,365.305], [1010.56,410.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.881,415.618], [935.257,461.949], [1010.56,410.197], [1010.48,454.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.257,461.978], [935.629,507.755], [1010.48,454.572], [1010.41,498.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.629,507.784], [935.996,553.017], [1010.41,498.44], [1010.34,541.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.997,553.045], [936.359,597.743], [1010.34,541.809], [1010.26,584.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.36,597.772], [936.718,641.945], [1010.26,584.687], [1010.19,627.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.718,641.973], [937.073,685.63], [1010.19,627.082], [1010.12,668.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.073,685.657], [937.423,728.807], [1010.12,669.004], [1010.05,710.433]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.424,728.835], [937.77,771.487], [1010.05,710.459], [1009.98,751.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.77,771.487], [938.087,810.599], [1009.98,751.43], [1009.92,789.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.681,319.454], [992.709,364.182], [1016.42,319.06], [1016.31,363.158]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.736,408.4], [992.762,452.089], [1016.21,406.762], [1016.1,449.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.762,452.116], [992.789,495.313], [1016.1,449.877], [1016,492.487]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.789,495.34], [992.815,538.052], [1016,492.514], [1015.89,534.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.815,538.079], [992.841,580.316], [1015.89,534.679], [1015.79,576.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.841,580.343], [992.866,622.111], [1015.79,576.381], [1015.69,617.6]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.866,622.137], [992.891,663.445], [1015.69,617.627], [1015.59,658.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.891,663.471], [992.916,704.326], [1015.59,658.424], [1015.5,698.755]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.916,704.352], [992.941,744.762], [1015.5,698.78], [1015.4,738.677]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.941,744.762], [992.963,781.841], [1015.4,738.677], [1015.31,775.291]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[992.709,364.182], [992.736,408.372], [1016.31,363.159], [1016.21,406.734]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1014.39,275.937], [1014.3,316.759], [1125.89,276.999], [1125.27,315.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.87,683.51], [1078.44,721.997], [1057.75,676.857], [1057.44,714.728]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.44,721.997], [1078.06,757.331], [1057.44,714.728], [1057.16,749.502]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.16,565.532], [1079.72,605.247], [1058.69,560.81], [1058.37,599.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.72,605.272], [1079.29,644.57], [1058.37,599.892], [1058.06,638.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.29,644.595], [1078.87,683.485], [1058.06,638.572], [1057.75,676.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.49,443.752], [1081.04,484.753], [1059.66,441.088], [1059.33,481.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.04,484.779], [1080.6,525.344], [1059.33,481.414], [1059.01,521.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.6,525.37], [1080.16,565.507], [1059.01,521.319], [1058.69,560.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.87,317.982], [1082.4,360.36], [1060.66,317.514], [1060.32,359.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.4,360.361], [1081.94,402.255], [1060.32,359.144], [1059.99,400.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.94,402.281], [1081.49,443.725], [1059.99,400.333], [1059.66,441.062]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.87,683.51], [1078.44,721.997], [1100.61,678.14], [1100.08,716.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.44,721.997], [1078.06,757.331], [1100.08,716.13], [1099.6,751.012]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.72,605.272], [1079.29,644.571], [1101.68,600.929], [1101.14,639.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.29,644.595], [1078.87,683.485], [1101.14,639.733], [1100.61,678.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.6,525.37], [1080.16,565.507], [1102.77,522.1], [1102.22,561.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.16,565.532], [1079.72,605.247], [1102.22,561.72], [1101.68,600.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.49,443.752], [1081.04,484.753], [1103.89,441.601], [1103.33,482.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.04,484.779], [1080.6,525.344], [1103.32,482.062], [1102.77,522.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.87,317.982], [1082.4,360.36], [1105.6,317.604], [1105.02,359.379]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.4,360.36], [1081.94,402.255], [1105.02,359.379], [1104.45,400.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.94,402.281], [1081.49,443.725], [1104.45,400.709], [1103.89,441.575]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.87,683.717], [1118.24,722.223], [1100.61,678.14], [1100.08,716.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.24,722.223], [1117.66,757.575], [1100.08,716.13], [1099.6,751.012]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.15,605.439], [1119.51,644.758], [1101.68,600.929], [1101.14,639.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.5,644.783], [1118.87,683.692], [1101.14,639.733], [1100.61,678.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.45,525.496], [1120.8,565.653], [1102.77,522.1], [1102.22,561.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.8,565.679], [1120.15,605.414], [1102.22,561.72], [1101.68,600.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.78,443.834], [1122.12,484.858], [1103.89,441.601], [1103.32,482.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.11,484.883], [1121.45,525.47], [1103.32,482.062], [1102.77,522.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.46,402.342], [1122.79,443.808], [1104.45,400.709], [1103.89,441.575]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.84,317.997], [1124.15,360.398], [1105.6,317.604], [1105.02,359.379]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.15,360.398], [1123.46,402.315], [1105.02,359.379], [1104.45,400.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.87,683.717], [1118.24,722.223], [1176.03,669.224], [1175.14,706.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.24,722.223], [1117.66,757.575], [1175.14,706.387], [1174.32,740.517]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.5,644.783], [1118.87,683.692], [1176.93,631.664], [1176.03,669.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.8,565.679], [1120.15,605.414], [1178.76,555.395], [1177.84,593.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.15,605.439], [1119.51,644.758], [1177.84,593.722], [1176.93,631.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.45,525.496], [1120.8,565.653], [1179.69,516.675], [1178.76,555.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.79,443.834], [1122.12,484.858], [1181.57,438.035], [1180.62,477.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.12,484.884], [1121.45,525.47], [1180.62,477.557], [1179.69,516.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.46,402.342], [1122.79,443.808], [1182.53,398.102], [1181.57,438.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.84,317.997], [1124.15,360.398], [1184.47,316.977], [1183.49,357.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.15,360.398], [1123.46,402.315], [1183.49,357.751], [1182.53,398.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.21,710.123], [1175.14,706.387], [1186.33,744.541], [1174.32,740.517]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.17,672.643], [1176.03,669.224], [1187.21,710.122], [1175.14,706.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.14,634.758], [1188.17,672.619], [1176.93,631.664], [1176.03,669.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.12,596.485], [1189.14,634.733], [1177.84,593.722], [1176.93,631.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.11,557.82], [1190.12,596.461], [1178.76,555.395], [1177.84,593.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.11,518.755], [1191.11,557.795], [1179.69,516.675], [1178.76,555.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.12,479.284], [1192.11,518.73], [1180.62,477.558], [1179.69,516.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.14,439.402], [1193.12,479.259], [1181.57,438.035], [1180.62,477.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.17,399.101], [1194.14,439.376], [1182.53,398.102], [1181.57,438.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.22,358.375], [1195.17,399.075], [1183.49,357.751], [1182.53,398.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.27,317.217], [1196.22,358.375], [1184.47,316.977], [1183.49,357.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.21,710.123], [1186.33,744.541], [1218.46,701.275], [1217.46,735.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.17,672.643], [1187.21,710.122], [1219.55,664.548], [1218.46,701.275]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.14,634.758], [1188.17,672.619], [1220.66,627.431], [1219.56,664.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.12,596.485], [1189.14,634.733], [1221.78,589.944], [1220.66,627.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.11,557.82], [1190.12,596.461], [1222.9,552.079], [1221.78,589.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.11,518.755], [1191.11,557.795], [1224.04,513.832], [1222.9,552.055]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.12,479.284], [1192.11,518.73], [1225.19,475.197], [1224.04,513.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.14,439.402], [1193.12,479.259], [1226.36,436.167], [1225.19,475.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.17,399.101], [1194.14,439.376], [1227.53,396.736], [1226.36,436.142]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.22,358.375], [1195.17,399.075], [1228.72,356.899], [1227.53,396.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.27,317.217], [1196.22,358.375], [1229.92,316.649], [1228.72,356.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.83,698.11], [1209.87,731.599], [1239.62,690.063], [1238.55,722.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.88,661.652], [1210.83,698.109], [1240.79,654.292], [1239.62,690.063]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.94,624.811], [1211.88,661.629], [1241.97,618.151], [1240.79,654.269]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214,587.604], [1212.94,624.787], [1243.16,581.66], [1241.97,618.128]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1222.96,276.134], [1221.8,316.446], [1253.1,276.459], [1251.81,315.931]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.08,550.026], [1214.01,587.581], [1244.36,544.812], [1243.16,581.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.18,512.072], [1215.09,550.003], [1245.57,507.601], [1244.36,544.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1217.28,473.735], [1216.18,512.048], [1246.79,470.024], [1245.57,507.578]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.39,435.01], [1217.28,473.711], [1248.03,432.074], [1246.79,470]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.51,395.891], [1218.39,434.986], [1249.28,393.746], [1248.03,432.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.65,356.372], [1219.52,395.866], [1250.54,355.033], [1249.28,393.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.8,316.446], [1220.65,356.372], [1251.81,315.931], [1250.54,355.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.77,686.132], [1224.77,718.691], [1273.72,672.991], [1272.55,704.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.85,650.696], [1225.77,686.132], [1274.99,638.681], [1273.72,672.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.95,614.899], [1226.85,650.674], [1276.28,604.031], [1274.99,638.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.06,578.757], [1227.95,614.876], [1277.57,569.06], [1276.28,604.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.18,542.265], [1229.06,578.734], [1278.88,533.761], [1277.57,569.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.31,505.419], [1230.18,542.242], [1280.2,498.131], [1278.88,533.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.46,468.212], [1231.31,505.395], [1281.54,462.165], [1280.2,498.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.61,430.641], [1232.46,468.189], [1282.88,425.857], [1281.54,462.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.77,392.698], [1233.61,430.617], [1284.24,389.204], [1282.88,425.834]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.95,354.38], [1234.78,392.674], [1285.61,352.201], [1284.24,389.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.14,315.679], [1235.95,354.38], [1287,314.841], [1285.61,352.201]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1238.34,276.617], [1237.14,315.68], [1288.4,277.145], [1287,314.841]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[646.903,320.498], [644.762,271.056], [625.878,319.834], [623.686,272.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.903,320.498], [649.019,369.374], [625.878,319.834], [628.046,367.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.02,369.374], [651.109,417.634], [628.046,367.071], [630.188,413.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.11,417.664], [653.175,465.347], [630.189,413.76], [632.306,459.882]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[658.459,321.407], [656.292,269.666], [633.819,320.608], [631.585,270.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.177,465.377], [655.217,512.495], [632.307,459.911], [634.399,505.504]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.319,321.401], [660.46,372.505], [633.819,320.608], [636.026,369.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[655.218,512.525], [657.235,559.087], [634.401,505.532], [636.469,550.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.6,372.527], [662.712,422.974], [636.026,369.756], [638.206,418.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[657.236,559.116], [659.228,605.133], [636.471,550.633], [638.516,595.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[662.714,423.006], [664.8,472.823], [638.208,418.311], [640.361,466.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[659.23,605.162], [661.199,650.642], [638.517,595.223], [640.539,639.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[664.801,472.854], [666.862,522.054], [640.362,466.284], [642.49,513.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.2,650.671], [663.147,695.624], [640.541,639.31], [642.54,682.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[666.863,522.085], [668.898,570.679], [642.492,513.684], [644.594,560.493]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.148,695.652], [665.072,740.088], [642.541,682.902], [644.519,725.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.899,570.709], [670.91,618.708], [644.596,560.523], [646.673,606.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.074,740.116], [666.976,784.043], [644.52,726.009], [646.475,768.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.911,618.738], [672.897,666.153], [646.675,606.809], [648.728,652.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[666.976,784.043], [668.72,824.328], [646.475,768.611], [648.269,807.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.898,666.182], [674.86,713.024], [648.73,652.553], [650.759,697.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.861,713.053], [676.799,759.331], [650.761,697.764], [652.767,742.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.8,759.36], [678.715,805.085], [652.768,742.452], [654.751,786.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.715,805.085], [680.471,846.998], [654.751,786.598], [656.569,827.081]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[658.319,321.401], [656.152,269.675], [691.364,321.109], [689.436,270.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.319,321.401], [660.46,372.505], [691.364,321.109], [693.269,371.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.46,372.505], [662.573,422.937], [693.269,371.495], [695.149,421.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[662.575,422.968], [664.661,472.771], [695.151,421.257], [697.008,470.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[664.662,472.802], [666.723,521.988], [697.009,470.407], [698.844,518.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[666.724,522.018], [668.76,570.598], [698.845,518.956], [700.657,566.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.761,570.629], [670.772,618.614], [700.659,566.916], [702.449,614.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.773,618.644], [672.759,666.045], [702.45,614.297], [704.219,661.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.76,666.075], [704.22,661.109], [674.722,712.903], [705.968,707.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.723,712.932], [705.969,707.362], [676.661,759.197], [707.696,753.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.663,759.226], [707.698,753.067], [678.578,804.938], [709.404,798.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.578,804.938], [709.404,798.205], [680.334,846.841], [710.969,839.588]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[711.011,321.706], [709.153,269.209], [691.363,321.109], [689.435,270.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.011,321.706], [712.846,373.564], [691.364,321.109], [693.269,371.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.846,373.564], [714.656,424.73], [693.269,371.495], [695.149,421.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.658,424.762], [716.446,475.28], [695.15,421.257], [697.008,470.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.447,475.312], [718.212,525.195], [697.009,470.407], [698.844,518.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.213,525.226], [719.956,574.486], [698.845,518.956], [700.657,566.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.957,574.516], [721.679,623.165], [700.658,566.916], [702.449,614.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.68,623.195], [723.381,671.243], [702.45,614.297], [704.219,661.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.381,671.273], [725.061,718.732], [704.22,661.109], [705.968,707.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.062,718.761], [726.721,765.641], [705.969,707.362], [707.696,753.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.722,765.671], [728.361,811.983], [707.697,753.068], [709.404,798.205]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[711.011,321.706], [709.153,269.209], [805.667,320.84], [804.475,270.534]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.361,811.983], [729.863,854.428], [709.404,798.205], [710.969,839.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.011,321.706], [712.846,373.564], [805.667,320.84], [806.845,370.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.846,373.564], [714.656,424.73], [806.845,370.559], [808.008,419.64]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.657,424.762], [716.445,475.28], [808.008,419.671], [809.157,468.157]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.446,475.312], [718.212,525.195], [809.158,468.187], [810.293,516.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.213,525.226], [719.956,574.486], [810.293,516.118], [811.415,563.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.957,574.517], [721.679,623.165], [811.415,563.474], [812.523,610.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.68,623.195], [723.38,671.243], [812.524,610.266], [813.619,656.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.381,671.273], [725.061,718.732], [813.619,656.504], [814.701,702.168]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.062,718.762], [726.721,765.642], [814.702,702.197], [815.771,747.326]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.722,765.671], [728.361,811.983], [815.772,747.354], [816.828,791.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.361,811.983], [729.863,854.429], [816.828,791.958], [817.797,832.857]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[816.392,321.114], [815.251,270.115], [805.668,320.84], [804.476,270.534]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.392,321.114], [817.519,371.51], [805.667,320.84], [806.845,370.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.519,371.51], [818.631,421.251], [806.845,370.559], [808.008,419.64]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.632,421.283], [819.731,470.412], [808.009,419.671], [809.158,468.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.732,470.443], [820.817,518.972], [809.158,468.187], [810.293,516.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.818,519.003], [821.89,566.942], [810.294,516.118], [811.415,563.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.891,566.973], [822.95,614.333], [811.416,563.474], [812.524,610.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[822.951,614.363], [823.997,661.155], [812.525,610.266], [813.619,656.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.998,661.184], [825.032,707.418], [813.62,656.504], [814.702,702.168]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.033,707.447], [826.054,753.132], [814.703,702.197], [815.772,747.326]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[816.392,321.114], [815.251,270.115], [867.377,320.638], [866.576,270.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.391,321.114], [817.519,371.51], [867.377,320.638], [868.167,369.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.055,753.161], [827.065,798.308], [815.772,747.354], [816.829,791.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.519,371.511], [818.631,421.252], [868.167,369.861], [868.948,418.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.065,798.308], [827.991,839.698], [816.829,791.958], [817.798,832.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.632,421.283], [819.731,470.412], [868.949,418.488], [869.72,466.501]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.732,470.444], [820.817,518.972], [869.721,466.531], [870.483,513.97]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.818,519.003], [821.89,566.942], [870.483,514], [871.237,560.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.891,566.973], [822.95,614.333], [871.237,560.906], [871.981,607.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[822.951,614.363], [823.997,661.155], [871.982,607.258], [872.717,653.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.998,661.184], [825.032,707.418], [872.718,653.067], [873.445,698.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.033,707.447], [826.054,753.132], [873.445,698.34], [874.164,743.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.055,753.161], [827.065,798.307], [874.164,743.089], [874.874,787.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.065,798.308], [827.991,839.698], [874.874,787.294], [875.526,827.831]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[815.713,318.955], [814.691,273.412], [949.091,317.844], [948.836,275.108]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.17,320.845], [876.915,370.576], [927.283,320.361], [927.703,368.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.915,370.577], [877.65,419.67], [927.703,368.899], [928.119,416.827]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.651,419.701], [878.378,468.198], [928.119,416.857], [928.529,464.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.378,468.229], [879.096,516.142], [928.53,464.248], [928.935,511.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.096,516.172], [879.805,563.509], [928.935,511.08], [929.336,557.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.806,563.54], [880.507,610.313], [929.337,557.364], [929.733,603.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.507,610.343], [881.2,656.562], [929.733,603.109], [930.125,648.295]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.2,656.591], [881.884,702.265], [930.125,648.324], [930.512,692.991]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.885,702.294], [882.561,747.434], [930.512,693.019], [930.895,737.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.561,747.463], [883.23,792.077], [930.895,737.203], [931.274,780.856]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.23,792.077], [883.843,832.985], [931.274,780.856], [931.621,820.893]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.695,320.11], [916.179,368.029], [998.764,319.339], [998.757,365.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.179,368.03], [916.657,415.355], [998.757,365.351], [998.749,410.814]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.657,415.385], [917.129,462.156], [998.749,410.843], [998.742,455.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.13,462.186], [917.597,508.413], [998.742,455.824], [998.735,500.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.597,508.443], [918.058,554.135], [998.735,500.302], [998.728,544.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.058,554.164], [918.515,599.332], [998.727,544.286], [998.721,587.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.515,599.36], [918.966,644.011], [998.72,587.783], [998.713,630.775]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.966,644.04], [919.412,688.183], [998.713,630.803], [998.707,673.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.412,688.211], [919.853,731.856], [998.706,673.352], [998.7,715.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.853,731.883], [920.289,775.037], [998.7,715.439], [998.693,757.044]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.289,775.037], [920.689,814.622], [998.693,757.044], [998.687,795.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[982.618,319.032], [982.701,364.287], [1008.4,318.799], [1008.34,363.476]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[982.701,364.288], [982.783,409.011], [1008.34,363.476], [1008.28,407.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[982.783,409.04], [982.864,453.269], [1008.28,407.663], [1008.22,451.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[982.864,453.297], [982.944,497.04], [1008.22,451.367], [1008.17,494.57]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[982.944,497.067], [983.024,540.332], [1008.17,494.598], [1008.11,537.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.024,540.359], [983.102,583.154], [1008.11,537.361], [1008.05,579.638]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.102,583.181], [983.18,625.512], [1008.05,579.665], [1007.99,621.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.18,625.539], [983.256,667.415], [1007.99,621.517], [1007.94,662.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.256,667.441], [983.332,708.869], [1007.94,662.925], [1007.88,703.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.332,708.895], [983.407,749.882], [1007.88,703.894], [1007.83,744.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[983.407,749.882], [983.476,787.5], [1007.83,744.408], [1007.78,781.596]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1017.04,317.278], [1017.14,275.972], [1137.72,316.272], [1138.39,277.505]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077,690.161], [1076.6,729.371], [1057.6,682.982], [1057.3,721.509]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.6,729.371], [1076.23,765.375], [1057.3,721.509], [1057.03,756.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.24,570.017], [1077.82,610.452], [1058.52,564.978], [1058.21,604.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.82,610.478], [1077.41,650.499], [1058.21,604.711], [1057.91,644.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.41,650.524], [1077,690.136], [1057.91,644.044], [1057.6,682.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.95,403.889], [1079.51,446.05], [1059.79,401.92], [1059.47,443.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.51,446.077], [1079.08,487.797], [1059.47,443.316], [1059.15,484.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.08,487.823], [1078.66,529.108], [1059.15,484.287], [1058.83,524.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.66,529.134], [1078.24,569.991], [1058.83,524.839], [1058.52,564.953]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.83,318.158], [1080.39,361.251], [1060.45,317.824], [1060.12,360.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.39,361.252], [1079.95,403.862], [1060.12,360.092], [1059.79,401.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.6,729.371], [1076.23,765.375], [1100.35,724.041], [1099.87,759.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.82,610.478], [1077.41,650.499], [1101.92,606.568], [1101.39,646.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.41,650.524], [1077,690.136], [1101.39,646.131], [1100.87,685.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077,690.161], [1076.6,729.371], [1100.87,685.295], [1100.35,724.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.66,529.134], [1078.24,569.991], [1103,526.222], [1102.46,566.575]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.24,570.017], [1077.82,610.452], [1102.46,566.601], [1101.92,606.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.51,446.077], [1079.08,487.797], [1104.09,444.205], [1103.54,485.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.08,487.823], [1078.66,529.108], [1103.54,485.426], [1103,526.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.83,318.158], [1080.39,361.251], [1105.78,317.932], [1105.22,360.465]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.39,361.251], [1079.95,403.862], [1105.22,360.465], [1104.65,402.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.95,403.889], [1079.51,446.05], [1104.65,402.554], [1104.1,444.179]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.8,691.344], [1117.18,730.666], [1100.87,685.295], [1100.35,724.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.18,730.666], [1116.62,766.772], [1100.35,724.041], [1099.87,759.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.04,611.428], [1118.42,651.566], [1101.92,606.568], [1101.39,646.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,651.592], [1117.8,691.319], [1101.39,646.131], [1100.87,685.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.67,570.847], [1119.04,611.403], [1102.46,566.601], [1101.92,606.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.96,488.406], [1120.31,529.816], [1103.54,485.426], [1103,526.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.31,529.842], [1119.67,570.822], [1103,526.222], [1102.46,566.575]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.27,404.213], [1121.61,446.505], [1104.65,402.554], [1104.1,444.179]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.61,446.532], [1120.96,488.38], [1104.09,444.205], [1103.54,485.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.61,318.213], [1122.94,361.443], [1105.78,317.932], [1105.22,360.465]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.94,361.443], [1122.27,404.186], [1105.22,360.465], [1104.65,402.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.8,691.344], [1117.18,730.666], [1181.08,678.119], [1180.18,716.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.18,730.666], [1116.62,766.772], [1180.18,716.181], [1179.35,751.142]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.04,611.428], [1118.42,651.566], [1182.92,600.805], [1182,639.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.42,651.592], [1117.8,691.319], [1182,639.655], [1181.08,678.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.67,570.847], [1119.04,611.403], [1183.85,561.566], [1182.92,600.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.96,488.406], [1120.31,529.816], [1185.74,481.894], [1184.79,521.906]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.31,529.842], [1119.67,570.822], [1184.79,521.931], [1183.85,561.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.61,446.532], [1120.96,488.38], [1186.7,441.448], [1185.74,481.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.94,361.443], [1122.27,404.186], [1188.65,359.307], [1187.67,400.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.27,404.213], [1121.61,446.505], [1187.67,400.588], [1186.7,441.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.61,318.213], [1122.94,361.443], [1189.64,317.598], [1188.65,359.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.54,681.859], [1191.57,720.278], [1181.08,678.119], [1180.18,716.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.57,720.278], [1190.68,755.563], [1180.18,716.182], [1179.35,751.142]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.52,643.03], [1192.54,681.834], [1182,639.655], [1181.08,678.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.51,603.809], [1193.52,643.005], [1182.92,600.806], [1182,639.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.51,564.19], [1194.51,603.784], [1183.85,561.566], [1182.92,600.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.52,524.167], [1195.51,564.164], [1184.79,521.931], [1183.85,561.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.54,483.734], [1196.52,524.141], [1185.74,481.894], [1184.79,521.906]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.57,442.884], [1197.54,483.708], [1186.7,441.448], [1185.74,481.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.61,401.612], [1198.57,442.858], [1187.67,400.588], [1186.7,441.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.66,359.91], [1199.61,401.586], [1188.65,359.307], [1187.67,400.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.73,317.772], [1200.66,359.91], [1189.64,317.598], [1188.65,359.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.57,720.278], [1190.68,755.563], [1226.43,712.132], [1225.4,746.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.54,681.859], [1191.57,720.278], [1227.55,674.423], [1226.43,712.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.52,643.03], [1192.54,681.834], [1228.69,636.319], [1227.55,674.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.51,603.809], [1193.52,643.005], [1229.83,597.837], [1228.69,636.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.51,564.19], [1194.51,603.784], [1230.99,558.974], [1229.83,597.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.52,524.167], [1195.51,564.164], [1232.15,519.721], [1230.99,558.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.54,483.734], [1196.52,524.141], [1233.33,480.075], [1232.15,519.696]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.57,442.885], [1197.54,483.708], [1234.52,440.029], [1233.33,480.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.61,401.612], [1198.57,442.858], [1235.72,399.576], [1234.52,440.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.66,359.91], [1199.61,401.586], [1236.94,358.711], [1235.72,399.55]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.73,317.772], [1200.66,359.91], [1238.17,317.427], [1236.94,358.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.42,708.727], [1218.43,743.096], [1251.6,701.301], [1250.48,735.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.5,671.315], [1219.42,708.727], [1252.81,664.538], [1251.6,701.301]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.59,633.514], [1220.5,671.291], [1254.03,627.4], [1252.81,664.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.69,595.343], [1221.59,633.49], [1255.27,589.904], [1254.03,627.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.8,556.795], [1222.69,595.318], [1256.51,552.045], [1255.27,589.88]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1230.7,317.283], [1231.89,275.964], [1264.26,316.969], [1265.59,276.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.92,517.865], [1223.8,556.77], [1257.77,513.818], [1256.51,552.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.05,478.547], [1224.92,517.84], [1259.05,475.217], [1257.77,513.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.2,438.836], [1226.06,478.522], [1260.33,436.238], [1259.05,475.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.35,398.726], [1227.2,438.811], [1261.63,396.874], [1260.33,436.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.52,358.21], [1228.35,398.7], [1262.94,357.12], [1261.63,396.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.7,317.283], [1229.52,358.21], [1264.26,316.969], [1262.94,357.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.32,696.967], [1237.28,730.4], [1291.97,684.811], [1290.73,717.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.46,660.583], [1238.32,696.967], [1293.31,649.494], [1291.97,684.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.6,623.832], [1239.46,660.56], [1294.67,613.829], [1293.32,649.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.76,586.73], [1240.6,623.808], [1296.05,577.836], [1294.67,613.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.93,549.274], [1241.76,586.707], [1297.43,541.509], [1296.05,577.813]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.11,511.457], [1242.93,549.25], [1298.83,504.844], [1297.43,541.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.3,473.275], [1244.11,511.433], [1300.24,467.836], [1298.83,504.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.51,434.723], [1245.3,473.251], [1301.66,430.48], [1300.24,467.813]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.72,395.794], [1246.51,434.698], [1303.1,392.771], [1301.66,430.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.95,356.484], [1247.72,395.77], [1304.55,354.704], [1303.1,392.747]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.19,316.786], [1248.95,356.484], [1306.01,316.274], [1304.55,354.704]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1250.19,316.786], [1251.44,276.721], [1306.01,316.274], [1307.49,277.501]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[631.202,319.071], [629.068,270.07], [615.694,318.749], [613.549,271.49]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[635.839,319.503], [633.631,268.162], [617.791,319.115], [615.568,269.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.202,319.071], [633.313,367.538], [615.694,318.75], [617.817,365.514]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.75,319.501], [637.932,370.238], [617.791,319.116], [619.99,367.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.313,367.538], [635.398,415.419], [617.817,365.513], [619.915,411.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.022,370.257], [640.177,420.371], [619.99,367.816], [622.162,415.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.399,415.449], [637.461,462.785], [619.916,411.76], [621.991,457.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[640.178,420.402], [642.307,469.918], [622.163,415.957], [624.31,463.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.462,462.814], [639.5,509.614], [621.992,457.498], [624.044,502.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.308,469.949], [644.412,518.877], [624.312,463.546], [626.434,510.564]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[639.502,509.643], [641.517,555.915], [624.045,502.736], [626.075,547.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.414,518.908], [646.493,567.26], [626.436,510.593], [628.534,557.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.518,555.944], [643.511,601.698], [626.077,547.482], [628.084,591.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.494,567.29], [648.549,615.076], [628.536,557.108], [630.611,603.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.512,601.726], [645.482,646.97], [628.086,591.743], [630.072,635.501]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.55,615.106], [650.581,662.334], [630.612,603.099], [632.664,648.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.483,646.998], [647.432,691.741], [630.073,635.528], [632.038,678.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[650.582,662.364], [652.59,709.046], [632.665,648.575], [634.694,693.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[647.433,691.769], [649.36,736.019], [632.039,678.845], [633.983,721.673]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[635.75,319.5], [633.542,268.175], [669.85,319.383], [667.875,268.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[652.591,709.075], [654.575,755.219], [634.695,693.545], [636.702,737.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.361,736.046], [651.267,779.811], [633.985,721.7], [635.908,764.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.75,319.501], [637.932,370.238], [669.85,319.383], [671.802,369.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[654.576,755.248], [656.538,800.864], [636.703,738.018], [638.687,781.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.267,779.811], [653.016,819.966], [635.908,764.075], [637.674,802.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.932,370.238], [640.087,420.336], [671.802,369.498], [673.73,418.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.538,800.864], [658.337,842.698], [638.687,781.973], [640.508,822.301]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[640.088,420.367], [642.217,469.867], [673.731,419.019], [675.636,467.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.218,469.898], [644.322,518.812], [675.638,467.957], [677.521,516.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.324,518.843], [646.403,567.18], [677.522,516.322], [679.383,564.094]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.404,567.21], [679.384,564.124], [648.459,614.981], [681.223,611.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.46,615.011], [681.224,611.373], [650.491,662.226], [683.043,658.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[650.492,662.256], [683.044,658.078], [652.499,708.924], [684.841,704.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[652.501,708.953], [684.842,704.248], [654.485,755.084], [686.62,749.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[654.486,755.113], [686.621,749.894], [656.447,800.715], [688.378,794.994]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.447,800.716], [688.378,794.994], [658.246,842.538], [689.989,836.362]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[684.657,319.675], [682.713,267.406], [669.849,319.383], [667.875,268.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[684.657,319.675], [686.578,371.334], [669.85,319.383], [671.802,369.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.578,371.334], [688.475,422.33], [671.802,369.498], [673.73,418.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.476,422.362], [690.35,472.739], [673.731,419.019], [675.636,467.927]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.351,472.771], [692.203,522.54], [675.638,467.957], [677.52,516.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.204,522.571], [694.033,571.743], [677.522,516.322], [679.383,564.094]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.034,571.774], [695.841,620.361], [679.384,564.124], [681.223,611.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.842,620.391], [697.628,668.402], [681.224,611.373], [683.043,658.049]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[684.656,319.675], [682.712,267.407], [783.501,319.321], [782.221,268.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[697.629,668.432], [699.394,715.877], [683.044,658.078], [684.841,704.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[684.657,319.675], [686.578,371.334], [783.501,319.321], [784.768,369.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.395,715.907], [701.139,762.796], [684.842,704.248], [686.619,749.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.578,371.334], [688.475,422.33], [784.768,369.11], [786.019,418.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.14,762.826], [702.864,809.169], [686.62,749.894], [688.377,794.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.476,422.362], [690.35,472.739], [786.02,418.312], [787.256,466.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.864,809.169], [704.445,851.663], [688.377,794.995], [689.989,836.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.351,472.771], [692.202,522.54], [787.257,466.939], [788.479,514.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.203,522.571], [694.033,571.744], [788.48,514.999], [789.688,562.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.034,571.775], [695.841,620.361], [789.688,562.504], [790.882,609.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.842,620.391], [697.628,668.402], [790.883,609.463], [792.063,655.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[697.629,668.432], [699.394,715.877], [792.064,655.884], [793.231,701.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.395,715.907], [701.139,762.796], [793.231,701.778], [794.385,747.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.14,762.826], [702.864,809.169], [794.386,747.153], [795.526,791.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.864,809.169], [704.445,851.663], [795.526,791.989], [796.573,833.117]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[792.096,319.457], [790.849,268.368], [783.502,319.321], [782.221,268.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.096,319.457], [793.33,369.964], [783.501,319.321], [784.768,369.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.33,369.964], [794.548,419.837], [784.769,369.109], [786.02,418.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.548,419.869], [795.752,469.15], [786.021,418.312], [787.257,466.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.753,469.181], [796.942,517.88], [787.258,466.939], [788.48,514.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.942,517.911], [798.118,566.039], [788.48,514.999], [789.688,562.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.118,566.07], [799.28,613.637], [789.689,562.504], [790.883,609.433]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[792.096,319.457], [790.849,268.368], [845.908,319.261], [845.007,269.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.281,613.667], [800.429,660.682], [790.883,609.463], [792.064,655.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.096,319.457], [793.33,369.964], [845.908,319.261], [846.8,368.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[800.43,660.712], [801.564,707.185], [792.064,655.884], [793.231,701.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.33,369.965], [794.548,419.838], [846.8,368.732], [847.68,417.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.565,707.215], [802.687,753.155], [793.232,701.778], [794.386,747.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.548,419.869], [795.752,469.15], [847.681,417.624], [848.551,465.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.688,753.184], [803.797,798.601], [794.386,747.153], [795.527,791.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[803.797,798.601], [804.814,840.255], [795.527,791.989], [796.573,833.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.752,469.181], [796.942,517.88], [848.551,465.948], [849.411,513.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.942,517.911], [798.118,566.039], [849.412,513.713], [850.262,560.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.118,566.07], [799.28,613.637], [850.263,560.928], [851.103,607.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.281,613.667], [800.429,660.682], [851.104,607.604], [851.935,653.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[800.429,660.712], [801.564,707.185], [851.935,653.75], [852.757,699.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.565,707.215], [802.687,753.155], [852.758,699.374], [853.57,744.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.688,753.184], [803.797,798.601], [853.57,744.486], [854.374,789.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[803.797,798.601], [804.814,840.255], [854.374,789.065], [855.111,829.96]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[806.889,318.436], [805.857,272.871], [947.323,317.977], [947.067,274.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.154,319.364], [854.012,369.38], [907.521,319.163], [908.044,368.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.012,369.38], [854.86,418.773], [908.044,368.117], [908.561,416.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.861,418.804], [855.698,467.616], [908.561,416.504], [909.072,464.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.699,467.647], [856.526,515.889], [909.073,464.334], [909.578,511.586]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.527,515.92], [857.345,563.601], [909.578,511.616], [910.078,558.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[857.345,563.631], [858.154,610.762], [910.078,558.361], [910.572,604.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[858.155,610.792], [858.954,657.381], [910.572,604.577], [911.061,650.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[858.955,657.41], [859.745,703.467], [911.061,650.273], [911.544,695.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[859.745,703.497], [860.527,749.031], [911.544,695.457], [912.021,740.111]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[860.527,749.06], [861.299,794.08], [912.022,740.14], [912.494,784.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.299,794.08], [862.008,835.374], [912.494,784.299], [912.927,824.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.745,319.038], [898.317,367.326], [986.553,318.715], [986.614,365.298]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.317,367.326], [898.883,415.033], [986.614,365.298], [986.674,411.339]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.883,415.063], [899.442,462.229], [986.674,411.368], [986.732,456.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.443,462.258], [899.995,508.891], [986.732,456.933], [986.791,501.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.996,508.921], [900.542,555.03], [986.791,502.001], [986.848,546.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.543,555.059], [901.083,600.654], [986.849,546.581], [986.906,590.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.084,600.683], [901.618,645.771], [986.906,590.68], [986.962,634.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.618,645.8], [902.147,690.39], [986.962,634.307], [987.018,677.44]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.147,690.418], [902.67,734.519], [987.018,677.468], [987.073,720.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.67,734.547], [903.188,778.167], [987.073,720.171], [987.128,762.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.188,778.167], [903.662,818.19], [987.128,762.397], [987.178,801.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.487,318.561], [972.623,364.323], [1000.13,318.463], [1000.12,363.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.623,364.324], [972.757,409.562], [1000.12,363.707], [1000.1,408.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.757,409.591], [972.89,454.342], [1000.1,408.466], [1000.09,452.721]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.89,454.371], [973.021,498.643], [1000.09,452.75], [1000.07,496.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.021,498.671], [973.151,542.472], [1000.07,496.564], [1000.06,539.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.151,542.5], [973.28,585.837], [1000.06,539.917], [1000.05,582.788]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.28,585.864], [973.407,628.744], [1000.05,582.815], [1000.03,625.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.407,628.772], [973.533,671.202], [1000.03,625.267], [1000.02,667.252]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.533,671.229], [973.658,713.217], [1000.02,667.278], [1000.01,708.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.658,713.244], [973.781,754.796], [1000.01,708.856], [999.992,749.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.781,754.796], [973.894,792.944], [999.992,749.982], [999.98,787.741]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1019.7,317.741], [1019.81,275.937], [1149.65,317.316], [1150.36,277.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.09,736.732], [1073.74,773.42], [1056.72,728.32], [1056.45,764.326]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.25,615.629], [1074.86,656.385], [1057.6,609.515], [1057.3,649.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.86,656.411], [1074.47,696.759], [1057.3,649.515], [1057.01,689.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.47,696.784], [1074.09,736.731], [1057.01,689.123], [1056.72,728.32]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.45,490.772], [1076.04,532.789], [1058.5,487.101], [1058.2,528.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.04,532.816], [1075.65,574.406], [1058.2,528.314], [1057.9,569.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.65,574.432], [1075.25,615.603], [1057.9,569.116], [1057.6,609.489]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.1,318.194], [1077.68,362.013], [1059.76,318.023], [1059.44,360.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.68,362.013], [1077.27,405.35], [1059.44,360.94], [1059.12,403.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.27,405.377], [1076.86,448.268], [1059.12,403.421], [1058.81,445.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.85,448.295], [1076.45,490.745], [1058.81,445.472], [1058.5,487.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.47,696.784], [1074.09,736.731], [1100.36,692.469], [1099.86,731.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.09,736.732], [1073.74,773.42], [1099.86,731.994], [1099.39,768.298]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.65,574.432], [1075.25,615.603], [1101.91,571.438], [1101.39,612.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.25,615.629], [1074.86,656.385], [1101.39,612.185], [1100.88,652.501]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.86,656.411], [1074.47,696.759], [1100.87,652.526], [1100.36,692.444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.86,448.295], [1076.45,490.745], [1103.51,446.705], [1102.97,488.678]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.45,490.772], [1076.04,532.789], [1102.97,488.704], [1102.44,530.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.04,532.816], [1075.65,574.406], [1102.44,530.28], [1101.91,571.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.68,362.013], [1077.27,405.35], [1104.6,361.408], [1104.05,404.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.27,405.377], [1076.86,448.268], [1104.05,404.275], [1103.51,446.678]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.1,318.194], [1077.68,362.013], [1105.16,318.098], [1104.6,361.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.17,739.12], [1114.63,776.001], [1099.86,731.994], [1099.39,768.298]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.36,658.369], [1115.77,698.934], [1100.87,652.526], [1100.36,692.444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.77,698.96], [1115.17,739.119], [1100.36,692.469], [1099.86,731.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.58,575.943], [1116.97,617.339], [1101.91,571.438], [1101.39,612.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.97,617.365], [1116.36,658.343], [1101.39,612.185], [1100.88,652.501]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.19,534.095], [1117.58,575.916], [1102.44,530.28], [1101.91,571.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.45,449.097], [1118.82,491.788], [1103.51,446.705], [1102.97,488.678]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.82,491.815], [1118.2,534.068], [1102.97,488.704], [1102.44,530.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.73,362.318], [1120.08,405.906], [1104.6,361.408], [1104.05,404.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.08,405.934], [1119.45,449.07], [1104.05,404.275], [1103.51,446.678]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.38,318.242], [1120.73,362.317], [1105.16,318.098], [1104.6,361.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.77,698.96], [1115.17,739.119], [1185,687.146], [1184.09,726.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.17,739.12], [1114.63,776.001], [1184.09,726.149], [1183.25,761.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.97,617.365], [1116.36,658.343], [1186.85,607.937], [1185.92,647.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.36,658.369], [1115.77,698.934], [1185.92,647.736], [1185,687.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.58,575.943], [1116.97,617.339], [1187.78,567.745], [1186.85,607.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.82,491.815], [1118.2,534.068], [1189.69,486.155], [1188.73,527.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.2,534.095], [1117.58,575.916], [1188.73,527.153], [1187.78,567.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.45,449.097], [1118.82,491.788], [1190.65,444.744], [1189.69,486.128]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.73,362.317], [1120.08,405.906], [1192.61,360.663], [1191.63,402.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.08,405.933], [1119.45,449.07], [1191.63,402.916], [1190.65,444.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.38,318.242], [1120.73,362.318], [1193.61,317.979], [1192.61,360.663]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.68,730.596], [1193.79,766.786], [1184.09,726.149], [1183.25,761.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.65,691.196], [1194.68,730.596], [1185,687.146], [1184.09,726.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.63,651.38], [1195.65,691.171], [1185.92,647.736], [1185,687.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.63,611.168], [1196.64,651.355], [1186.85,607.937], [1185.92,647.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.63,570.554], [1197.63,611.143], [1187.78,567.745], [1186.85,607.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.64,529.531], [1198.63,570.528], [1188.73,527.153], [1187.78,567.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.66,488.094], [1199.64,529.505], [1189.69,486.155], [1188.73,527.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.69,446.236], [1200.66,488.067], [1190.65,444.744], [1189.69,486.128]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.74,403.95], [1201.69,446.209], [1191.63,402.916], [1190.65,444.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.79,361.23], [1202.74,403.923], [1192.61,360.663], [1191.63,402.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.85,318.069], [1203.79,361.23], [1193.61,317.979], [1192.61,360.663]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.68,730.596], [1193.79,766.786], [1233.12,723.248], [1232.07,758.843]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.65,691.196], [1194.68,730.596], [1234.26,684.504], [1233.12,723.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.63,651.38], [1195.65,691.171], [1235.41,645.359], [1234.26,684.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.63,611.168], [1196.64,651.355], [1236.58,605.83], [1235.42,645.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.63,570.554], [1197.63,611.143], [1237.75,565.913], [1236.58,605.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.64,529.531], [1198.63,570.528], [1238.94,525.601], [1237.75,565.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.66,488.094], [1199.64,529.505], [1240.14,484.89], [1238.94,525.576]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.69,446.236], [1200.66,488.067], [1241.35,443.772], [1240.14,484.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.74,403.95], [1201.69,446.209], [1242.57,402.242], [1241.35,443.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.79,361.23], [1202.74,403.923], [1243.81,360.294], [1242.57,402.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.85,318.069], [1203.79,361.23], [1245.05,317.921], [1243.81,360.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.82,719.613], [1225.81,754.911], [1262.38,712.896], [1261.23,747.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.93,681.194], [1226.82,719.613], [1263.63,675.079], [1262.38,712.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.04,642.38], [1227.93,681.169], [1264.89,636.878], [1263.63,675.055]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.16,603.189], [1229.04,642.355], [1266.17,598.313], [1264.89,636.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.29,563.617], [1230.16,603.164], [1267.45,559.379], [1266.17,598.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.44,523.658], [1231.29,563.592], [1268.75,520.07], [1267.45,559.354]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1238.33,317.848], [1239.55,275.467], [1275.44,317.712], [1276.82,276.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.59,483.306], [1232.44,523.633], [1270.06,480.382], [1268.75,520.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.76,442.554], [1233.59,483.28], [1271.39,440.307], [1270.06,480.356]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.94,401.399], [1234.76,442.529], [1272.73,399.841], [1271.39,440.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.33,317.847], [1237.13,359.831], [1275.44,317.712], [1274.08,358.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.13,359.832], [1235.94,401.372], [1274.08,358.978], [1272.73,399.815]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.81,708.161], [1248.73,742.526], [1309.23,697.133], [1307.93,730.596]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.98,670.768], [1249.81,708.161], [1310.64,660.73], [1309.23,697.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.17,633], [1250.98,670.744], [1312.07,623.972], [1310.64,660.707]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.37,594.877], [1252.17,632.976], [1313.51,586.878], [1312.07,623.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.58,556.392], [1253.37,594.852], [1314.96,549.442], [1313.51,586.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.81,517.542], [1254.58,556.368], [1316.43,511.661], [1314.96,549.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.04,478.321], [1255.81,517.518], [1317.91,473.529], [1316.43,511.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.29,438.724], [1257.04,478.296], [1319.4,435.041], [1317.91,473.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.54,398.744], [1258.29,438.698], [1320.91,396.193], [1319.4,435.017]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.81,358.377], [1259.54,398.719], [1322.43,356.98], [1320.91,396.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.1,317.616], [1260.81,358.377], [1323.97,317.395], [1322.43,356.98]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1262.1,317.617], [1263.39,276.484], [1323.97,317.395], [1325.52,277.46]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[616.969,318.022], [614.755,267.176], [605.448,318.053], [603.263,269.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[616.929,318.022], [619.119,368.297], [605.448,318.053], [607.609,366.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.159,368.313], [621.323,417.999], [607.61,366.237], [609.746,413.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.324,418.03], [623.463,467.15], [609.748,413.892], [611.861,460.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.464,467.18], [625.579,515.744], [611.862,461.027], [613.953,507.622]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[616.929,318.022], [614.716,267.193], [651.641,318.029], [649.651,267.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.581,515.775], [627.672,563.792], [613.954,507.651], [616.022,553.743]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[627.673,563.822], [629.74,611.302], [616.023,553.771], [618.069,599.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[616.929,318.022], [619.119,368.297], [651.641,318.03], [653.611,367.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[629.742,611.332], [631.786,658.283], [618.07,599.397], [620.094,644.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.119,368.297], [621.282,417.966], [653.611,367.783], [655.556,416.943]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.787,658.313], [633.809,704.745], [620.095,644.536], [622.098,689.167]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.283,417.998], [623.422,467.101], [655.557,416.974], [657.481,465.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.811,704.774], [635.81,750.695], [622.099,689.195], [624.08,733.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.423,467.132], [625.537,515.681], [657.482,465.61], [659.384,513.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.812,750.724], [637.789,796.142], [624.081,733.382], [626.042,777.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.539,515.711], [659.386,513.702], [627.629,563.714], [661.267,561.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.789,796.142], [639.604,837.816], [626.042,777.078], [627.841,817.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[627.63,563.744], [661.268,561.258], [629.698,611.209], [663.128,608.258]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[629.699,611.239], [663.129,608.288], [631.743,658.176], [664.969,654.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.744,658.205], [664.97,654.799], [633.766,704.624], [666.789,700.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.767,704.653], [666.79,700.802], [635.766,750.56], [668.59,746.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.768,750.589], [668.591,746.303], [637.745,795.994], [670.371,791.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.745,795.994], [670.371,791.283], [639.559,837.655], [672.005,832.559]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[661.58,318.006], [659.583,266.079], [651.641,318.03], [649.651,267.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.579,318.006], [663.553,369.356], [651.641,318.03], [653.611,367.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.553,369.356], [665.503,420.074], [653.61,367.783], [655.556,416.943]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.504,420.105], [667.431,470.234], [655.557,416.974], [657.481,465.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[667.432,470.266], [669.337,519.815], [657.482,465.61], [659.384,513.672]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[661.579,318.006], [659.583,266.079], [763.332,318.03], [761.984,267.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[669.338,519.846], [671.221,568.827], [659.385,513.702], [661.266,561.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.579,318.006], [663.553,369.356], [763.332,318.03], [764.665,367.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[671.222,568.858], [673.084,617.279], [661.268,561.258], [663.128,608.258]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.553,369.356], [665.503,420.074], [764.665,367.796], [765.983,416.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[673.085,617.309], [674.925,665.181], [663.129,608.288], [664.968,654.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.504,420.106], [667.431,470.234], [765.984,416.999], [767.286,465.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.926,665.211], [676.745,712.542], [664.97,654.799], [666.789,700.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.746,712.572], [678.546,759.371], [666.79,700.802], [668.59,746.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[667.432,470.266], [669.337,519.815], [767.287,465.647], [768.576,513.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.547,759.401], [680.326,805.678], [668.591,746.303], [670.371,791.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[669.338,519.846], [671.221,568.827], [768.576,513.751], [769.85,561.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.326,805.678], [681.958,848.131], [670.371,791.283], [672.005,832.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[671.222,568.858], [673.083,617.279], [769.851,561.318], [771.11,608.33]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[673.084,617.31], [674.924,665.181], [771.111,608.359], [772.357,654.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.926,665.211], [676.745,712.542], [772.358,654.882], [773.59,700.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.746,712.572], [678.545,759.372], [773.591,700.895], [774.809,746.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.546,759.401], [680.325,805.678], [774.81,746.407], [776.016,791.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.325,805.678], [681.957,848.131], [776.016,791.397], [777.122,832.682]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[769.721,318.018], [768.39,266.941], [763.333,318.03], [761.985,267.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.721,318.018], [771.037,368.538], [763.332,318.03], [764.665,367.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.037,368.538], [772.338,418.445], [764.666,367.796], [765.983,416.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.339,418.477], [773.625,467.813], [765.984,416.998], [767.287,465.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.626,467.844], [774.897,516.62], [767.288,465.647], [768.576,513.72]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[769.721,318.018], [768.39,266.941], [825.71,318.032], [824.724,267.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.898,516.651], [776.155,564.875], [768.577,513.751], [769.851,561.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.721,318.018], [771.037,368.538], [825.71,318.032], [826.686,367.665]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.155,564.906], [777.398,612.588], [769.851,561.318], [771.111,608.33]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.037,368.538], [772.338,418.445], [826.686,367.665], [827.65,416.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.399,612.619], [778.628,659.768], [771.112,608.359], [772.357,654.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.339,418.477], [773.625,467.813], [827.65,416.737], [828.603,465.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.629,659.798], [779.844,706.423], [772.358,654.882], [773.59,700.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.626,467.844], [774.897,516.62], [828.604,465.258], [829.546,513.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.845,706.453], [781.046,752.563], [773.591,700.895], [774.81,746.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.898,516.651], [776.155,564.875], [829.547,513.237], [830.479,560.653]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.047,752.592], [782.236,798.195], [774.811,746.407], [776.016,791.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.155,564.906], [777.398,612.588], [830.48,560.683], [831.401,607.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.236,798.195], [783.326,840.037], [776.016,791.397], [777.122,832.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.399,612.619], [778.628,659.768], [831.402,607.605], [832.313,653.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.629,659.798], [779.844,706.423], [832.314,654.012], [833.215,699.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.844,706.453], [781.046,752.563], [833.216,699.911], [834.108,745.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.047,752.592], [782.235,798.195], [834.108,745.312], [834.991,790.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.235,798.195], [834.991,790.193], [783.326,840.037], [835.8,831.379]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[799.638,318.099], [798.607,272.555], [945.919,318.13], [945.663,274.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.326,318.023], [832.281,368.231], [888.336,318.037], [888.952,367.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.281,368.231], [833.224,417.834], [888.951,367.33], [889.56,416.039]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.225,417.866], [834.157,466.905], [889.56,416.07], [890.161,464.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.158,466.936], [835.079,515.421], [890.162,464.267], [890.757,511.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.08,515.452], [835.991,563.392], [890.757,511.928], [891.345,559.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.992,563.423], [836.893,610.827], [891.346,559.064], [891.927,605.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.894,610.857], [837.785,657.735], [891.928,605.682], [892.503,651.762]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.786,657.766], [838.667,704.126], [892.504,651.792], [893.073,697.372]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.667,704.155], [839.539,750.006], [893.073,697.4], [893.636,742.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.54,750.035], [840.402,795.385], [893.637,742.517], [894.194,787.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.402,795.385], [841.193,836.996], [894.194,787.121], [894.705,828.055]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.494,318.047], [881.145,366.634], [974.198,318.069], [974.323,365.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.145,366.635], [881.788,414.654], [974.323,365.178], [974.447,411.752]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.788,414.685], [882.424,462.176], [974.447,411.781], [974.569,457.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.424,462.206], [883.053,509.178], [974.569,457.887], [974.691,503.475]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.053,509.208], [883.675,555.669], [974.691,503.504], [974.811,548.611]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.675,555.698], [884.29,601.656], [974.811,548.64], [974.93,593.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.291,601.685], [884.899,647.149], [974.93,593.301], [975.047,637.468]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.9,647.178], [885.502,692.154], [975.047,637.496], [975.164,681.204]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.502,692.183], [886.098,736.681], [975.164,681.232], [975.279,724.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.098,736.709], [886.687,780.735], [975.279,724.515], [975.393,767.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.687,780.736], [887.228,821.146], [975.393,767.327], [975.497,806.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.387,318.082], [962.573,364.313], [991.667,318.089], [991.698,363.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.573,364.313], [962.756,410.029], [991.697,363.868], [991.727,409.141]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.756,410.057], [962.938,455.294], [991.727,409.17], [991.757,453.974]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.938,455.323], [963.117,500.088], [991.757,454.002], [991.786,498.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.117,500.116], [963.295,544.418], [991.786,498.372], [991.815,542.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.295,544.446], [963.471,588.291], [991.815,542.286], [991.844,585.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.471,588.318], [963.645,631.713], [991.844,585.751], [991.872,628.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.646,631.741], [963.818,674.693], [991.872,628.776], [991.9,671.338]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.818,674.72], [963.989,717.236], [991.9,671.365], [991.928,713.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.989,717.263], [991.928,713.526], [964.157,759.35], [991.956,755.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.157,759.35], [991.956,755.238], [964.313,797.998], [991.981,793.546]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1022.24,318.146], [1022.37,275.843], [1160.91,318.175], [1161.67,277.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.89,743.911], [1070.56,781.28], [1055.65,735.001], [1055.39,771.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.98,620.611], [1071.61,662.098], [1056.49,614.193], [1056.21,654.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.61,662.124], [1071.25,703.205], [1056.21,654.858], [1055.93,695.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.25,703.23], [1070.89,743.911], [1055.93,695.134], [1055.65,735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.48,450.368], [1073.1,493.543], [1057.66,447.515], [1057.36,489.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.1,493.57], [1072.72,536.313], [1057.36,489.798], [1057.07,531.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.72,536.34], [1072.35,578.658], [1057.07,531.669], [1056.78,573.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.35,578.685], [1071.98,620.584], [1056.78,573.131], [1056.49,614.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.65,318.107], [1074.26,362.644], [1058.56,318.122], [1058.26,361.683]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.26,362.644], [1073.87,406.701], [1058.26,361.683], [1057.96,404.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.87,406.728], [1073.48,450.341], [1057.96,404.812], [1057.66,447.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.61,662.124], [1071.25,703.205], [1099.52,658.786], [1099.03,699.486]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.25,703.23], [1070.89,743.911], [1099.03,699.512], [1098.54,739.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.89,743.911], [1070.56,781.28], [1098.54,739.818], [1098.09,776.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.72,536.34], [1072.35,578.658], [1101.04,534.194], [1100.53,576.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.35,578.685], [1071.98,620.584], [1100.53,576.133], [1100.02,617.636]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.98,620.611], [1071.61,662.098], [1100.02,617.662], [1099.52,658.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.48,450.368], [1073.1,493.543], [1102.07,449.057], [1101.55,491.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.1,493.57], [1072.72,536.313], [1101.55,491.837], [1101.04,534.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.65,318.107], [1074.26,362.644], [1103.66,318.114], [1103.13,362.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.26,362.644], [1073.87,406.701], [1103.13,362.202], [1102.6,405.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.87,406.728], [1073.48,450.341], [1102.6,405.848], [1102.07,449.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.14,747.407], [1111.62,785.066], [1098.54,739.818], [1098.09,776.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.28,664.975], [1112.71,706.381], [1099.52,658.786], [1099.03,699.486]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.71,706.408], [1112.14,747.407], [1099.03,699.512], [1098.54,739.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.44,580.865], [1113.86,623.103], [1100.53,576.133], [1100.02,617.636]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.86,623.13], [1113.28,664.949], [1100.02,617.662], [1099.52,658.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.63,495.051], [1115.03,538.147], [1101.55,491.837], [1101.04,534.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.03,538.174], [1114.44,580.838], [1101.04,534.194], [1100.53,576.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.83,407.481], [1116.23,451.461], [1102.6,405.848], [1102.07,449.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.23,451.489], [1115.63,495.024], [1102.07,449.057], [1101.55,491.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.07,318.102], [1117.45,363.021], [1103.66,318.114], [1103.13,362.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.45,363.021], [1116.84,407.453], [1103.13,362.202], [1102.6,405.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.71,706.408], [1112.14,747.407], [1187.62,696.147], [1186.71,736.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.14,747.407], [1111.62,785.066], [1186.71,736.115], [1185.88,772.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.86,623.13], [1113.28,664.949], [1189.47,614.995], [1188.54,655.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.28,664.975], [1112.71,706.382], [1188.54,655.767], [1187.62,696.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.44,580.865], [1113.86,623.103], [1190.4,573.826], [1189.47,614.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.63,495.051], [1115.03,538.147], [1192.31,490.27], [1191.35,532.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.03,538.174], [1114.44,580.838], [1191.35,532.253], [1190.41,573.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.84,407.481], [1116.23,451.461], [1194.24,405.051], [1193.27,447.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.23,451.489], [1115.63,495.024], [1193.27,447.871], [1192.31,490.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.45,363.021], [1116.84,407.453], [1195.23,361.803], [1194.24,405.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.07,318.102], [1117.45,363.021], [1196.22,318.12], [1195.23,361.803]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.37,740.898], [1195.49,778.016], [1186.71,736.115], [1185.88,772.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.34,700.492], [1196.37,740.898], [1187.62,696.147], [1186.71,736.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.32,659.667], [1197.34,700.467], [1188.54,655.767], [1187.62,696.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.3,618.44], [1198.32,659.641], [1189.47,614.995], [1188.54,655.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.3,576.806], [1199.3,618.414], [1190.4,573.826], [1189.47,614.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.31,534.76], [1200.3,576.78], [1191.35,532.253], [1190.41,573.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.35,449.403], [1202.32,492.267], [1193.27,447.871], [1192.31,490.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.32,492.294], [1201.31,534.733], [1192.31,490.27], [1191.35,532.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.38,406.08], [1203.35,449.375], [1194.24,405.051], [1193.27,447.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.43,362.319], [1204.39,406.052], [1195.23,361.803], [1194.24,405.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.49,318.112], [1205.43,362.318], [1196.22,318.12], [1195.23,361.803]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.37,740.898], [1195.49,778.016], [1238.31,734.451], [1237.26,771.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.32,659.667], [1197.34,700.467], [1240.63,654.411], [1239.47,694.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.34,700.492], [1196.37,740.898], [1239.47,694.635], [1238.31,734.451]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.3,618.44], [1198.32,659.641], [1241.81,613.797], [1240.63,654.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.3,576.806], [1199.3,618.414], [1242.99,572.789], [1241.81,613.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.31,534.76], [1200.3,576.78], [1244.19,531.381], [1242.99,572.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.32,492.294], [1201.31,534.733], [1245.4,489.566], [1244.19,531.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.35,449.403], [1202.32,492.267], [1246.63,447.339], [1245.4,489.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.38,406.08], [1203.35,449.375], [1247.86,404.694], [1246.63,447.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.43,362.319], [1204.38,406.052], [1249.11,361.624], [1247.86,404.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.49,318.112], [1205.43,362.318], [1250.37,318.123], [1249.11,361.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.82,730.597], [1231.8,766.858], [1271.73,724.684], [1270.55,760.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.94,691.133], [1232.82,730.597], [1273.01,685.762], [1271.73,724.684]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.07,651.269], [1233.94,691.108], [1274.31,646.45], [1273.01,685.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.2,611.022], [1235.07,651.243], [1275.61,606.767], [1274.31,646.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.35,570.388], [1236.2,610.996], [1276.93,566.707], [1275.61,606.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.51,529.361], [1237.35,570.362], [1278.26,526.266], [1276.93,566.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.68,487.936], [1238.51,529.335], [1279.61,485.438], [1278.26,526.24]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1244.49,318.129], [1245.71,274.648], [1285.11,318.139], [1286.52,275.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.06,403.866], [1240.87,446.079], [1282.33,402.597], [1280.96,444.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.87,446.106], [1239.68,487.91], [1280.96,444.216], [1279.61,485.411]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.27,361.209], [1242.06,403.839], [1283.72,360.573], [1282.33,402.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.49,318.128], [1243.27,361.208], [1285.11,318.138], [1283.72,360.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260,719.552], [1258.88,754.893], [1325.23,709.808], [1323.87,744.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.21,681.101], [1260,719.552], [1326.7,672.252], [1325.23,709.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.43,642.269], [1261.21,681.077], [1328.19,634.332], [1326.7,672.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.66,603.075], [1262.43,642.244], [1329.69,596.068], [1328.19,634.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.91,563.514], [1263.67,603.05], [1331.21,557.455], [1329.69,596.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.17,523.581], [1264.91,563.489], [1332.74,518.487], [1331.21,557.43]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.44,483.271], [1266.17,523.555], [1334.28,479.16], [1332.74,518.462]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.72,442.578], [1267.44,483.245], [1335.84,439.47], [1334.29,479.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.01,401.496], [1268.72,442.552], [1337.42,399.41], [1335.84,439.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1271.32,360.021], [1270.01,401.47], [1339.01,358.976], [1337.42,399.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.64,318.146], [1271.32,360.021], [1340.61,318.162], [1339.01,358.976]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1272.64,318.147], [1273.97,275.894], [1340.61,318.162], [1342.23,276.99]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[602.12,317.039], [599.93,266.797], [596.942,317.469], [594.819,269.41]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.127,317.042], [604.293,366.748], [596.942,317.469], [599.043,365.054]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.287,366.761], [606.429,415.909], [599.043,365.054], [601.122,412.113]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[602.127,317.042], [599.938,266.818], [637.013,317.126], [635.034,267.329]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[606.43,415.94], [608.55,464.556], [601.123,412.142], [603.179,458.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.127,317.042], [604.293,366.748], [637.013,317.127], [638.972,366.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[608.551,464.586], [610.647,512.678], [603.181,458.741], [605.216,504.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.293,366.748], [606.435,415.88], [638.972,366.413], [640.908,415.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.648,512.708], [612.722,560.283], [605.217,504.859], [607.232,550.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[606.436,415.911], [640.909,415.167], [608.555,464.511], [642.825,463.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.724,560.313], [614.775,607.381], [607.233,550.503], [609.227,595.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[608.556,464.541], [642.826,463.397], [610.652,512.617], [644.721,511.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[614.776,607.41], [616.806,653.978], [609.228,595.68], [611.202,640.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.653,512.647], [644.722,511.111], [612.726,560.207], [646.597,558.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[616.807,654.007], [618.816,700.083], [611.203,640.397], [613.156,684.634]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.727,560.237], [646.598,558.317], [614.778,607.29], [648.453,604.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.817,700.112], [620.805,745.705], [613.158,684.662], [615.092,728.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[614.779,607.319], [648.454,605.024], [616.809,653.873], [650.29,651.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.806,745.733], [622.772,790.849], [615.093,728.481], [617.007,771.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[616.81,653.902], [650.291,651.24], [618.818,699.964], [652.107,696.943]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.772,790.849], [624.577,832.264], [617.007,771.833], [618.765,811.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.819,699.993], [652.109,696.971], [620.806,745.571], [653.906,742.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.807,745.6], [653.907,742.226], [622.773,790.702], [655.686,786.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.773,790.702], [655.686,786.984], [624.577,832.105], [657.319,828.075]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[642.149,316.799], [640.133,265.339], [637.013,317.127], [635.034,267.33]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.149,316.799], [644.143,367.713], [637.013,317.127], [638.972,366.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.144,367.713], [646.115,418.027], [638.971,366.413], [640.908,415.137]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[642.149,316.799], [640.133,265.339], [745.493,317.057], [744.1,266.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.116,418.059], [648.065,467.814], [640.909,415.167], [642.825,463.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.149,316.799], [644.143,367.713], [745.493,317.057], [746.872,366.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.066,467.845], [649.994,517.052], [642.826,463.397], [644.721,511.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.143,367.713], [646.114,418.027], [746.872,366.689], [748.235,415.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.995,517.082], [651.902,565.748], [644.722,511.111], [646.597,558.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.115,418.059], [648.065,467.814], [748.236,415.781], [749.584,464.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.903,565.779], [653.788,613.913], [646.598,558.318], [648.453,604.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.066,467.846], [649.993,517.052], [749.585,464.341], [750.918,512.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.789,613.943], [655.655,661.555], [648.454,605.024], [650.29,651.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.995,517.083], [651.901,565.748], [750.919,512.378], [752.239,559.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[655.656,661.585], [657.501,708.682], [650.291,651.24], [652.107,696.943]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.902,565.779], [653.788,613.913], [752.239,559.901], [753.545,606.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[657.502,708.712], [659.327,755.303], [652.108,696.971], [653.906,742.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.789,613.944], [655.654,661.555], [753.545,606.918], [754.837,653.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[659.328,755.332], [661.134,801.425], [653.907,742.226], [655.686,786.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[655.655,661.585], [657.5,708.682], [754.838,653.436], [756.116,699.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.134,801.425], [662.791,843.728], [655.686,786.984], [657.319,828.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[657.501,708.712], [756.116,699.464], [659.327,755.303], [757.381,744.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[659.328,755.332], [757.382,745.009], [661.133,801.425], [758.633,790.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.133,801.426], [758.633,790.051], [662.79,843.729], [759.782,831.4]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[749.641,316.9], [748.249,265.956], [745.494,317.057], [744.101,266.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.641,316.9], [751.018,367.31], [745.493,317.057], [746.872,366.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.018,367.31], [752.379,417.132], [746.872,366.689], [748.235,415.75]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[749.64,316.9], [748.248,265.956], [807.113,317.046], [806.059,266.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.38,417.163], [753.726,466.437], [748.236,415.781], [749.585,464.31]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.64,316.9], [751.018,367.31], [807.113,317.046], [808.155,366.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.727,466.468], [755.059,515.203], [749.585,464.341], [750.919,512.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.018,367.311], [752.379,417.132], [808.155,366.732], [809.186,415.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.06,515.234], [756.377,563.438], [750.92,512.378], [752.239,559.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.38,417.163], [753.726,466.437], [809.187,415.875], [810.206,464.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.377,563.469], [757.68,611.152], [752.24,559.901], [753.545,606.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.727,466.468], [755.059,515.203], [810.207,464.486], [811.215,512.542]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.681,611.182], [758.97,658.353], [753.546,606.918], [754.838,653.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.059,515.234], [756.376,563.438], [811.216,512.573], [812.214,560.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.971,658.383], [760.246,705.048], [754.838,653.436], [756.116,699.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.377,563.469], [757.68,611.152], [812.214,560.144], [813.201,607.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.246,705.078], [761.508,751.247], [756.117,699.464], [757.381,744.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.681,611.182], [758.97,658.353], [813.202,607.208], [814.179,653.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.509,751.276], [762.757,796.956], [757.382,745.009], [758.634,790.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.757,796.956], [763.902,838.885], [758.634,790.051], [759.782,831.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.971,658.383], [814.179,653.773], [760.245,705.048], [815.146,699.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.246,705.078], [815.146,699.846], [761.508,751.247], [816.102,745.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.509,751.276], [816.103,745.436], [762.757,796.956], [817.049,790.521]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.757,796.956], [817.049,790.522], [763.902,838.885], [817.918,831.909]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[794.095,317.982], [793.076,272.521], [944.916,318.328], [944.663,274.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.044,316.926], [812.077,367.209], [870.022,317.078], [870.718,366.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.077,367.209], [813.098,416.907], [870.718,366.607], [871.405,415.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.099,416.938], [814.109,466.09], [871.406,415.599], [872.087,464.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.11,466.122], [815.109,514.738], [872.087,464.061], [872.76,511.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.11,514.769], [816.098,562.857], [872.76,512.002], [873.426,559.401]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.099,562.888], [817.077,610.458], [873.427,559.431], [874.086,606.326]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.077,610.488], [818.044,657.547], [874.086,606.356], [874.738,652.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.045,657.577], [819.002,704.134], [874.738,652.784], [875.383,698.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.002,704.164], [875.384,698.724], [819.949,750.227], [876.022,744.154]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.95,750.256], [876.023,744.183], [820.886,795.832], [876.654,789.14]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.886,795.832], [876.654,789.14], [821.746,837.666], [877.234,830.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.208,317.227], [864.925,366.017], [961.842,317.474], [962.029,365.036]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.925,366.017], [865.634,414.254], [962.029,365.036], [962.213,412.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.634,414.285], [866.335,462.009], [962.213,412.102], [962.396,458.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.336,462.039], [867.029,509.258], [962.396,458.68], [962.577,504.747]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.03,509.288], [867.716,556.009], [962.577,504.777], [962.756,550.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.717,556.039], [868.396,602.271], [962.756,550.4], [962.933,595.528]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.396,602.3], [869.068,648.05], [962.933,595.557], [963.109,640.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.069,648.079], [869.734,693.354], [963.109,640.254], [963.283,684.471]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.734,693.383], [870.393,738.191], [963.283,684.499], [963.455,728.271]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.393,738.22], [871.045,782.568], [963.455,728.299], [963.625,771.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.045,782.568], [871.643,823.287], [963.625,771.633], [963.781,811.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.444,317.661], [952.675,364.295], [983.101,317.736], [983.174,363.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.675,364.295], [952.904,410.423], [983.173,363.994], [983.246,409.753]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.904,410.452], [953.131,456.111], [983.246,409.782], [983.317,455.078]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.131,456.14], [953.355,501.336], [983.317,455.107], [983.388,499.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.356,501.365], [953.578,546.105], [983.388,499.977], [983.458,544.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.578,546.134], [953.798,590.425], [983.459,544.399], [983.528,588.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[953.798,590.454], [954.015,634.304], [983.528,588.378], [983.597,631.895]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.015,634.331], [983.597,631.922], [954.231,677.746], [983.665,675.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.231,677.774], [983.665,675.038], [954.444,720.76], [983.733,717.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.444,720.787], [983.733,717.73], [954.656,763.35], [983.799,759.98]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[954.656,763.35], [983.799,759.98], [954.849,802.446], [983.861,798.79]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1024.65,318.511], [1024.77,275.729], [1171.35,318.847], [1172.14,277.77]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.64,667.506], [1067.3,709.289], [1054.6,659.922], [1054.33,700.814]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.3,709.315], [1066.97,750.7], [1054.33,700.84], [1054.07,741.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.97,750.7], [1066.67,788.723], [1054.07,741.35], [1053.82,778.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.02,496.16], [1068.67,539.598], [1055.7,492.32], [1055.42,534.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.67,539.625], [1068.32,582.64], [1055.42,534.821], [1055.14,576.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.32,582.667], [1067.98,625.265], [1055.14,576.918], [1054.87,618.59]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.98,625.292], [1067.64,667.479], [1054.87,618.616], [1054.6,659.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.09,363.165], [1069.73,407.909], [1056.55,362.333], [1056.26,406.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.73,407.937], [1069.37,452.239], [1056.26,406.082], [1055.98,449.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.37,452.267], [1069.02,496.133], [1055.98,449.409], [1055.7,492.293]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.46,317.945], [1070.09,363.165], [1056.84,318.155], [1056.55,362.333]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.64,667.506], [1067.31,709.289], [1097.27,664.75], [1096.79,706.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.3,709.315], [1066.97,750.7], [1096.79,706.236], [1096.32,747.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.97,750.7], [1066.67,788.723], [1096.32,747.303], [1095.89,785.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.67,539.625], [1068.32,582.64], [1098.72,537.879], [1098.23,580.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.32,582.667], [1067.98,625.265], [1098.23,580.578], [1097.75,622.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.98,625.292], [1067.64,667.479], [1097.75,622.866], [1097.27,664.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.73,407.937], [1069.37,452.239], [1100.21,407.263], [1099.71,451.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.37,452.267], [1069.02,496.133], [1099.71,451.228], [1099.21,494.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.02,496.16], [1068.67,539.598], [1099.21,494.765], [1098.72,537.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.46,317.945], [1070.09,363.165], [1101.24,318.021], [1100.72,362.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.09,363.165], [1069.73,407.909], [1100.72,362.863], [1100.21,407.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.56,713.494], [1108.02,755.308], [1096.79,706.236], [1096.32,747.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.02,755.308], [1107.53,793.723], [1096.32,747.303], [1095.89,785.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.64,628.584], [1109.1,671.219], [1097.75,622.866], [1097.27,664.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.1,671.246], [1108.56,713.467], [1097.27,664.75], [1096.79,706.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.75,541.995], [1110.2,585.475], [1098.72,537.879], [1098.23,580.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.2,585.503], [1109.64,628.557], [1098.23,580.578], [1097.75,622.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.88,453.677], [1111.32,498.027], [1099.71,451.228], [1099.21,494.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.32,498.055], [1110.75,541.967], [1099.21,494.765], [1098.72,537.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.04,363.577], [1112.46,408.824], [1100.72,362.863], [1100.21,407.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.46,408.853], [1111.89,453.648], [1100.21,407.263], [1099.71,451.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.63,317.842], [1113.04,363.577], [1101.24,318.021], [1100.72,362.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.56,713.494], [1108.02,755.308], [1188.77,704.928], [1187.87,745.86]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.02,755.308], [1107.53,793.723], [1187.87,745.861], [1187.04,783.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.64,628.584], [1109.1,671.219], [1190.6,621.836], [1189.68,663.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.1,671.246], [1108.56,713.468], [1189.68,663.58], [1188.77,704.902]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.75,541.995], [1110.2,585.475], [1192.47,537.138], [1191.53,579.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.2,585.503], [1109.64,628.557], [1191.53,579.691], [1190.6,621.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.89,453.677], [1111.32,498.027], [1194.37,450.787], [1193.42,494.145]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.32,498.055], [1110.75,541.967], [1193.42,494.172], [1192.47,537.111]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.46,408.853], [1111.89,453.648], [1195.34,406.976], [1194.37,450.759]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.63,317.842], [1113.04,363.577], [1197.3,318.054], [1196.31,362.734]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.04,363.577], [1112.46,408.824], [1196.31,362.734], [1195.34,406.948]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.46,750.959], [1195.58,789.004], [1187.87,745.861], [1187.04,783.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.41,709.551], [1196.46,750.959], [1188.77,704.928], [1187.87,745.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.38,667.717], [1197.41,709.524], [1189.68,663.58], [1188.77,704.902]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.35,625.477], [1198.38,667.69], [1190.6,621.836], [1189.68,663.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.33,582.827], [1199.35,625.45], [1191.53,579.691], [1190.6,621.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.33,539.758], [1200.33,582.799], [1192.47,537.138], [1191.53,579.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.33,496.267], [1201.33,539.731], [1193.42,494.172], [1192.47,537.111]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.34,452.346], [1202.33,496.239], [1194.37,450.787], [1193.42,494.145]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.4,363.189], [1204.36,407.96], [1196.31,362.734], [1195.34,406.948]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.36,407.989], [1203.34,452.318], [1195.34,406.976], [1194.37,450.759]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.44,317.939], [1205.4,363.189], [1197.3,318.054], [1196.31,362.734]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.46,750.959], [1195.58,789.004], [1241.76,745.521], [1240.7,783.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.41,709.551], [1196.46,750.959], [1242.91,704.62], [1241.76,745.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.38,667.717], [1197.41,709.524], [1244.08,663.304], [1242.92,704.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.35,625.477], [1198.38,667.69], [1245.26,621.593], [1244.08,663.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.33,539.758], [1200.33,582.799], [1247.66,536.963], [1246.45,579.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.33,582.827], [1199.35,625.45], [1246.45,579.482], [1245.26,621.567]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.33,496.267], [1201.33,539.731], [1248.87,494.033], [1247.66,536.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.34,452.346], [1202.33,496.239], [1250.09,450.683], [1248.87,494.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.36,407.989], [1203.34,452.318], [1251.33,406.909], [1250.1,450.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.4,363.189], [1204.36,407.96], [1252.58,362.704], [1251.33,406.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.44,317.939], [1205.4,363.189], [1253.84,318.061], [1252.58,362.704]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.17,741.463], [1236.14,778.701], [1279.35,736.455], [1278.15,773.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.3,700.942], [1237.17,741.463], [1280.65,696.403], [1279.35,736.455]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.43,660.013], [1238.3,700.916], [1281.97,655.952], [1280.65,696.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.58,618.697], [1239.43,659.987], [1283.3,615.123], [1281.97,655.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.73,576.987], [1240.58,618.67], [1284.65,573.91], [1283.3,615.097]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.9,534.879], [1241.73,576.961], [1286,532.308], [1284.65,573.884]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.08,492.367], [1242.9,534.852], [1287.37,490.312], [1286,532.282]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1248.91,318.153], [1250.15,273.556], [1292.98,318.265], [1294.41,274.236]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.27,449.444], [1244.08,492.339], [1288.75,447.915], [1287.37,490.285]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.47,406.104], [1245.27,449.416], [1290.15,405.112], [1288.75,447.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.69,362.343], [1246.47,406.077], [1291.55,361.897], [1290.15,405.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.91,318.152], [1247.69,362.342], [1292.98,318.264], [1291.55,361.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.6,730.937], [1267.47,767.277], [1339.6,722.647], [1338.2,758.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1269.84,691.402], [1268.6,730.937], [1341.13,683.889], [1339.6,722.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1271.09,651.478], [1269.84,691.377], [1342.68,644.759], [1341.13,683.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.36,611.186], [1271.09,651.453], [1344.24,605.275], [1342.68,644.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1273.63,570.521], [1272.36,611.161], [1345.81,565.432], [1344.24,605.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.92,529.477], [1273.63,570.495], [1347.4,525.227], [1345.81,565.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.21,488.049], [1274.92,529.451], [1349,484.653], [1347.4,525.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.52,446.232], [1276.21,488.023], [1350.62,443.706], [1349,484.627]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.85,404.02], [1277.52,446.205], [1352.25,402.381], [1350.62,443.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.18,361.407], [1278.85,403.993], [1353.9,360.671], [1352.25,402.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.53,318.388], [1280.18,361.407], [1355.56,318.573], [1353.9,360.671]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1281.53,318.388], [1282.89,274.985], [1355.56,318.573], [1357.24,276.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.54,712.468], [1316.26,747.227], [1340.45,709.879], [1339.09,744.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1318.94,674.668], [1317.54,712.468], [1341.94,672.322], [1340.45,709.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1320.34,636.512], [1318.94,674.644], [1343.43,634.415], [1341.94,672.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1321.77,598.021], [1320.35,636.488], [1344.95,596.177], [1343.44,634.391]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1323.2,559.19], [1321.77,597.997], [1346.47,557.603], [1344.95,596.152]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.64,520.014], [1323.2,559.165], [1348.01,518.689], [1346.47,557.578]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.1,480.489], [1324.65,519.989], [1349.56,479.43], [1348.01,518.664]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1327.57,440.609], [1326.1,480.464], [1351.13,439.823], [1349.56,479.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1329.06,400.371], [1327.58,440.584], [1352.71,399.861], [1351.13,439.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.56,359.77], [1329.06,400.346], [1354.3,359.541], [1352.71,399.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.07,318.8], [1330.56,359.77], [1355.91,318.857], [1354.3,359.541]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1332.07,318.8], [1333.59,277.482], [1355.91,318.858], [1357.53,277.832]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[626.133,316.691], [591.488,316.576], [624.188,267.501], [589.348,267.065]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[591.436,316.57], [589.295,267.043], [592.314,317.352], [590.271,270.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.133,316.691], [591.488,316.576], [628.059,365.401], [593.608,365.601]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.059,365.401], [593.608,365.601], [629.964,413.578], [595.703,414.086]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.556,365.611], [595.653,414.112], [594.338,364.254], [596.34,410.661]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[629.965,413.608], [595.705,414.116], [631.85,461.29], [597.779,462.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.654,414.142], [597.73,462.142], [596.341,410.69], [598.323,456.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.852,461.32], [597.78,462.13], [633.718,508.516], [599.833,509.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.731,462.172], [599.785,509.679], [598.325,456.668], [600.288,502.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.719,508.545], [599.835,509.651], [635.566,555.261], [601.867,556.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.786,509.708], [601.819,556.729], [600.289,502.192], [602.232,547.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.567,555.29], [601.868,556.685], [637.396,601.533], [603.879,603.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[601.82,556.758], [603.832,603.3], [602.234,547.271], [604.158,591.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.397,601.562], [603.88,603.241], [639.207,647.34], [605.871,649.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[603.834,603.329], [605.825,649.399], [604.16,591.91], [606.066,636.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[639.208,647.369], [605.873,649.326], [641,692.689], [607.843,694.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[605.827,649.428], [607.798,695.034], [606.067,636.117], [607.954,679.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.001,692.717], [607.845,694.946], [642.775,737.585], [609.796,740.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.8,695.063], [609.752,740.211], [607.956,679.897], [609.825,723.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.776,737.614], [609.797,740.109], [644.533,782.037], [611.729,784.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.753,740.24], [611.685,784.938], [609.826,723.256], [611.678,766.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.533,782.037], [611.729,784.794], [646.146,822.838], [613.503,825.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[611.685,784.938], [613.46,825.989], [611.678,766.174], [613.379,805.605]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[626.625,316.093], [624.617,265.233], [730.262,316.449], [728.843,266.582]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[626.626,316.093], [624.618,265.232], [626.133,316.691], [624.188,267.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.626,316.093], [628.614,366.44], [730.262,316.449], [731.666,365.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.626,316.093], [628.614,366.44], [626.133,316.691], [628.059,365.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.613,366.44], [630.579,416.218], [731.667,365.822], [733.056,414.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.614,366.44], [630.579,416.219], [628.058,365.401], [629.963,413.578]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.58,416.25], [632.525,465.501], [733.057,414.68], [734.431,462.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.581,416.25], [632.525,465.5], [629.965,413.608], [631.85,461.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.527,465.532], [634.451,514.263], [631.851,461.32], [633.717,508.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.526,465.532], [734.432,463.029], [634.45,514.262], [735.793,510.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.452,514.293], [636.356,562.513], [633.719,508.545], [635.566,555.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.451,514.293], [735.793,510.877], [636.355,562.513], [737.14,558.203]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.357,562.543], [638.241,610.259], [635.567,555.29], [637.395,601.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.357,562.543], [737.141,558.233], [638.241,610.259], [738.473,605.074]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.242,610.289], [640.107,657.509], [637.396,601.562], [639.206,647.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.242,610.289], [738.474,605.103], [640.106,657.509], [739.793,651.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[640.108,657.539], [641.953,704.271], [639.208,647.369], [641,692.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[640.107,657.539], [739.794,651.496], [641.953,704.271], [741.1,697.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.954,704.301], [643.78,750.552], [641,692.717], [642.775,737.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.954,704.301], [741.101,697.418], [643.78,750.552], [742.393,742.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.782,750.582], [645.589,796.36], [642.776,737.614], [644.532,782.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.781,750.582], [742.394,742.877], [645.589,796.36], [743.673,787.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.589,796.36], [647.249,838.393], [644.532,782.037], [646.146,822.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.589,796.361], [743.673,787.851], [647.248,838.394], [744.849,829.153]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[732.176,316.159], [730.745,265.483], [730.262,316.449], [728.844,266.582]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[732.176,316.159], [730.745,265.483], [790.416,316.362], [789.311,266.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.176,316.159], [733.593,366.325], [730.262,316.449], [731.666,365.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.593,366.325], [734.994,415.928], [731.667,365.822], [733.056,414.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.176,316.159], [733.593,366.325], [790.416,316.362], [791.51,365.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.593,366.326], [734.994,415.928], [791.51,365.973], [792.591,415.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.995,415.959], [736.381,465.037], [733.057,414.68], [734.432,462.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.382,465.068], [737.754,513.63], [734.433,463.029], [735.793,510.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.995,415.959], [736.381,465.037], [792.592,415.062], [793.662,463.608]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.382,465.068], [737.754,513.63], [793.663,463.638], [794.722,511.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.755,513.661], [739.112,561.714], [735.794,510.877], [737.14,558.203]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.755,513.661], [794.722,511.709], [739.112,561.714], [795.77,559.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.113,561.745], [740.456,609.299], [737.141,558.233], [738.474,605.074]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.457,609.329], [741.786,656.39], [738.475,605.103], [739.794,651.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.113,561.745], [795.771,559.283], [740.456,609.299], [796.808,606.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.457,609.329], [796.809,606.367], [741.786,656.39], [797.836,652.939]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.787,656.42], [743.103,702.997], [739.795,651.496], [741.1,697.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.103,703.026], [744.406,749.126], [741.101,697.418], [742.394,742.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.787,656.42], [797.836,652.968], [743.103,702.997], [798.853,699.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.406,749.155], [745.695,794.785], [742.394,742.877], [743.674,787.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.103,703.026], [798.853,699.095], [744.406,749.126], [799.859,744.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.695,794.785], [746.879,836.683], [743.674,787.851], [744.849,829.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.406,749.155], [799.86,744.754], [745.695,794.785], [800.856,789.924]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.695,794.785], [800.856,789.924], [746.879,836.683], [801.77,831.404]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[790.351,318.083], [789.352,272.776], [944.342,318.569], [944.093,274.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.639,316.137], [793.734,366.362], [852.869,316.35], [853.633,365.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.734,366.363], [794.817,416.022], [853.633,365.993], [854.389,415.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.818,416.053], [795.889,465.187], [854.39,415.114], [855.137,463.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.89,465.218], [796.95,513.835], [855.138,463.721], [855.878,511.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.951,513.865], [798,561.973], [855.878,511.821], [856.611,559.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.001,562.003], [856.611,559.424], [799.039,609.609], [857.336,606.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.039,609.64], [857.336,606.537], [800.067,656.752], [858.054,653.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.067,656.782], [858.054,653.167], [801.084,703.409], [858.764,699.292]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.085,703.439], [858.765,699.321], [802.091,749.587], [859.468,744.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.092,749.617], [859.468,745.007], [803.088,795.295], [860.164,790.204]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.088,795.295], [860.164,790.204], [804.003,837.236], [860.803,831.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.142,316.63], [849.914,365.508], [949.65,316.979], [949.893,364.901]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.914,365.508], [850.677,413.85], [949.893,364.902], [950.135,412.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.678,413.881], [851.434,461.725], [950.135,412.337], [950.374,459.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.434,461.755], [852.182,509.108], [950.374,459.294], [950.61,505.749]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.182,509.138], [852.922,556.009], [950.611,505.778], [950.845,551.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.923,556.039], [853.656,602.434], [950.845,551.798], [951.077,597.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.656,602.463], [854.381,648.39], [951.077,597.359], [951.306,642.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.382,648.419], [855.1,693.884], [951.306,642.47], [951.533,687.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.1,693.913], [855.811,738.924], [951.534,687.136], [951.758,731.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.811,738.952], [856.515,783.516], [951.759,731.363], [951.981,775.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.515,783.516], [857.161,824.444], [951.981,775.132], [952.186,815.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[942.79,317.333], [943.063,364.286], [974.531,317.441], [974.645,364.099]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.063,364.287], [943.334,410.743], [974.645,364.099], [974.757,410.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.334,410.773], [943.602,456.77], [974.758,410.296], [974.869,456.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.602,456.799], [943.867,502.342], [974.869,456.038], [974.979,501.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.867,502.371], [944.13,547.468], [974.98,501.332], [975.089,546.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.13,547.497], [975.089,546.184], [944.39,592.154], [975.197,590.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.39,592.182], [975.197,590.602], [944.647,636.406], [975.305,634.563]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.647,636.434], [975.305,634.591], [944.902,680.23], [975.411,678.13]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.902,680.258], [975.411,678.158], [945.155,723.633], [975.516,721.281]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.155,723.66], [975.516,721.308], [945.405,766.62], [975.62,764.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.405,766.62], [975.62,764.021], [945.635,806.09], [975.716,803.266]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1026.87,318.829], [1027,275.605], [1180.78,319.315], [1181.6,277.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.25,629.541], [1062.94,672.375], [1052.71,622.656], [1052.46,664.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.94,672.402], [1062.63,714.833], [1052.46,664.554], [1052.2,706.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.63,714.86], [1062.33,756.894], [1052.2,706.066], [1051.95,747.174]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.33,756.894], [1062.05,795.522], [1051.95,747.174], [1051.72,784.957]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.2,498.483], [1063.88,542.56], [1053.49,494.602], [1053.23,537.659]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.88,542.587], [1063.56,586.244], [1053.23,537.686], [1052.97,580.342]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.56,586.271], [1063.25,629.514], [1052.97,580.369], [1052.71,622.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.51,317.737], [1065.18,363.585], [1054.56,318.14], [1054.29,362.886]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.18,363.585], [1064.85,408.959], [1054.29,362.886], [1054.02,407.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.85,408.988], [1064.52,453.923], [1054.02,407.208], [1053.76,451.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.52,453.952], [1064.2,498.455], [1053.76,451.111], [1053.49,494.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.63,714.86], [1093.61,712.458], [1062.33,756.894], [1093.17,754.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.33,756.894], [1093.17,754.24], [1062.05,795.522], [1092.76,792.637]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.56,586.271], [1063.25,629.514], [1094.98,584.659], [1094.52,627.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.25,629.541], [1062.94,672.375], [1094.52,627.66], [1094.06,670.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.94,672.402], [1094.06,670.258], [1062.63,714.833], [1093.61,712.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.52,453.952], [1064.2,498.455], [1096.39,453.176], [1095.91,497.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.2,498.483], [1063.88,542.56], [1095.91,497.423], [1095.44,541.221]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.88,542.587], [1063.56,586.244], [1095.44,541.248], [1094.98,584.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.51,317.737], [1065.18,363.585], [1097.83,317.847], [1097.34,363.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.18,363.585], [1064.85,408.959], [1097.35,363.394], [1096.86,408.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.85,408.988], [1064.52,453.923], [1096.86,408.502], [1096.39,453.147]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.27,720.029], [1102.77,762.608], [1093.61,712.458], [1093.17,754.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.77,762.608], [1102.31,801.731], [1093.17,754.24], [1092.76,792.637]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.29,633.59], [1103.78,676.989], [1094.52,627.66], [1094.06,670.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.78,677.016], [1103.27,720.002], [1094.06,670.258], [1093.61,712.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.32,545.471], [1104.8,589.715], [1095.44,541.248], [1094.98,584.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.8,589.743], [1104.29,633.562], [1094.98,584.659], [1094.52,627.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.92,410.036], [1106.38,455.595], [1096.86,408.502], [1096.39,453.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.38,455.624], [1105.85,500.738], [1096.39,453.176], [1095.91,497.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.85,500.766], [1105.32,545.443], [1095.91,497.422], [1095.44,541.221]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.01,317.5], [1107.46,363.997], [1097.83,317.847], [1097.35,363.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.46,363.997], [1106.92,410.007], [1097.34,363.394], [1096.86,408.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.77,762.608], [1102.31,801.731], [1187.39,755.164], [1186.58,793.641]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.78,677.016], [1103.27,720.003], [1189.18,671.004], [1188.28,713.268]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.27,720.03], [1102.77,762.608], [1188.28,713.294], [1187.39,755.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.8,589.743], [1104.29,633.562], [1191,585.22], [1190.08,628.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.29,633.59], [1103.78,676.989], [1190.08,628.315], [1189.18,670.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.85,500.767], [1105.32,545.443], [1192.85,497.792], [1191.92,541.687]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.32,545.471], [1104.8,589.715], [1191.92,541.714], [1191,585.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.92,410.036], [1106.38,455.595], [1194.74,408.671], [1193.79,453.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.38,455.624], [1105.85,500.738], [1193.79,453.446], [1192.85,497.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.46,363.997], [1106.92,410.007], [1195.7,363.46], [1194.74,408.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.01,317.5], [1107.46,363.997], [1196.67,317.809], [1195.7,363.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.77,760.552], [1193.91,799.497], [1187.39,755.164], [1186.58,793.641]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.65,675.356], [1195.7,718.142], [1189.18,671.004], [1188.28,713.268]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.7,718.169], [1194.77,760.552], [1188.28,713.294], [1187.39,755.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.6,632.133], [1196.65,675.329], [1190.08,628.315], [1189.18,670.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.56,588.494], [1197.6,632.105], [1191,585.22], [1190.08,628.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.53,544.433], [1198.56,588.466], [1191.92,541.714], [1191,585.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.52,499.945], [1199.53,544.405], [1192.85,497.792], [1191.92,541.687]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.51,455.022], [1200.52,499.916], [1193.79,453.446], [1192.85,497.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.51,409.659], [1201.51,454.993], [1194.74,408.671], [1193.79,453.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.77,760.552], [1193.91,799.497], [1243.21,756.229], [1242.15,794.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.52,363.849], [1202.51,409.63], [1195.7,363.461], [1194.74,408.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.7,718.169], [1194.77,760.552], [1244.36,714.258], [1243.21,756.229]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.54,317.585], [1203.52,363.849], [1196.67,317.809], [1195.7,363.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.65,675.356], [1195.7,718.142], [1245.53,671.865], [1244.36,714.232]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.6,632.133], [1196.65,675.329], [1246.7,629.07], [1245.53,671.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.56,588.494], [1197.6,632.105], [1247.89,585.867], [1246.7,629.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.53,544.433], [1198.56,588.466], [1249.09,542.252], [1247.89,585.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.52,499.945], [1199.53,544.405], [1250.3,498.217], [1249.09,542.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.51,455.022], [1200.52,499.916], [1251.52,453.757], [1250.3,498.189]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.51,409.659], [1201.51,454.993], [1252.75,408.866], [1251.52,453.729]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.52,363.849], [1202.51,409.63], [1253.99,363.537], [1252.75,408.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.54,317.585], [1203.52,363.849], [1255.25,317.764], [1253.99,363.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.63,751.989], [1238.6,790.191], [1284.93,747.991], [1283.72,785.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.76,710.422], [1239.63,751.989], [1286.25,706.805], [1284.93,747.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.89,668.441], [1240.76,710.396], [1287.59,665.213], [1286.25,706.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.04,626.066], [1241.89,668.414], [1288.93,623.235], [1287.59,665.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.2,583.292], [1243.04,626.039], [1290.29,580.865], [1288.94,623.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.36,540.113], [1244.2,583.265], [1291.67,538.098], [1290.29,580.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.54,496.524], [1245.36,540.086], [1293.05,494.928], [1291.67,538.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.73,452.518], [1246.54,496.496], [1294.45,451.35], [1293.05,494.9]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1251.37,317.94], [1252.61,272.236], [1298.72,318.106], [1300.18,272.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.93,408.089], [1247.73,452.49], [1295.86,407.357], [1294.45,451.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.15,363.232], [1248.93,408.061], [1297.29,362.945], [1295.86,407.329]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.37,317.94], [1250.15,363.232], [1298.73,318.105], [1297.29,362.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1275.34,742.103], [1274.19,779.445], [1351.98,735.448], [1350.53,772.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.6,701.479], [1275.34,742.103], [1353.56,695.461], [1351.98,735.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.87,660.461], [1276.6,701.454], [1355.15,655.091], [1353.56,695.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.16,619.066], [1277.87,660.435], [1356.76,614.357], [1355.15,655.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.45,577.291], [1279.16,619.04], [1358.39,573.255], [1356.76,614.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.76,535.131], [1280.45,577.265], [1360.03,531.78], [1358.39,573.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.08,492.579], [1281.76,535.104], [1361.68,489.927], [1360.03,531.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.41,449.631], [1283.08,492.552], [1363.35,447.69], [1361.68,489.9]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.75,406.28], [1284.41,449.603], [1365.03,405.064], [1363.35,447.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.11,362.521], [1285.75,406.252], [1366.73,362.044], [1365.03,405.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.48,318.349], [1287.11,362.521], [1368.45,318.624], [1366.73,362.044]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1288.48,318.349], [1289.86,273.786], [1368.45,318.624], [1370.18,274.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1331.8,724.518], [1330.46,760.327], [1356.57,722.435], [1355.15,758.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1333.25,685.579], [1331.8,724.518], [1358.12,683.695], [1356.57,722.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.71,646.275], [1333.25,685.554], [1359.68,644.595], [1358.12,683.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.18,606.628], [1334.71,646.25], [1361.26,605.155], [1359.69,644.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1337.67,566.632], [1336.18,606.603], [1362.85,565.37], [1361.26,605.13]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.17,526.283], [1337.67,566.607], [1364.46,525.236], [1362.85,565.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.69,485.576], [1339.18,526.257], [1366.07,484.747], [1364.46,525.21]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1342.22,444.507], [1340.69,485.55], [1367.71,443.901], [1366.07,484.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.76,403.07], [1342.22,444.481], [1369.35,402.69], [1367.71,443.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.32,361.261], [1343.76,403.044], [1371.02,361.112], [1369.35,402.664]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.89,319.074], [1345.32,361.261], [1372.69,319.16], [1371.02,361.112]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1346.89,319.074], [1348.47,276.532], [1372.69,319.16], [1374.38,276.857]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[619.164,316.735], [617.271,268.271], [585.149,316.628], [583.077,267.948]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[585.055,316.62], [582.982,267.923], [591.605,317.681], [589.655,271.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.164,316.735], [621.039,364.748], [585.149,316.628], [587.202,364.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.039,364.748], [622.895,412.258], [587.202,364.854], [589.234,412.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[587.11,364.862], [589.142,412.596], [593.539,363.81], [595.453,409.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.896,412.288], [589.235,412.602], [624.734,459.331], [591.247,459.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[589.143,412.626], [591.156,459.889], [595.454,409.502], [597.349,454.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[624.735,459.361], [591.248,459.879], [626.555,505.944], [593.239,506.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[591.157,459.919], [593.15,506.718], [597.35,454.763], [599.228,499.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.556,505.974], [593.241,506.693], [628.358,552.104], [595.213,553.02]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.151,506.747], [595.125,553.089], [599.23,499.599], [601.09,543.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.359,552.133], [595.214,553.049], [630.143,597.818], [597.167,598.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.126,553.118], [597.08,599.01], [601.091,544.015], [602.934,587.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.144,597.846], [597.169,598.955], [631.911,643.091], [599.103,644.388]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.081,599.038], [599.016,644.486], [602.935,588.018], [604.761,631.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.913,643.119], [599.104,644.416], [633.663,687.93], [601.019,689.412]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.018,644.514], [600.934,689.524], [604.762,631.613], [606.571,674.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.935,689.553], [602.834,734.131], [606.573,674.807], [608.365,717.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.664,687.958], [601.021,689.44], [635.398,732.342], [602.918,734.006]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.835,734.159], [604.715,778.313], [608.366,717.604], [610.142,759.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[635.399,732.37], [602.919,734.034], [637.116,776.332], [604.798,778.174]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.116,776.332], [604.798,778.174], [638.694,816.726], [606.525,818.729]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.715,778.313], [606.442,818.881], [610.142,759.984], [611.775,798.937]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[717.923,316.252], [716.497,266.809], [615.259,315.919], [613.281,265.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.923,316.252], [719.337,365.227], [615.259,315.919], [617.218,365.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.337,365.227], [720.735,413.679], [617.217,365.557], [619.155,414.658]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.736,413.709], [722.121,461.675], [619.156,414.689], [621.074,463.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.121,461.706], [621.075,463.322], [723.492,509.194], [622.974,511.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.493,509.224], [622.975,511.465], [724.85,556.242], [624.854,559.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.851,556.271], [624.855,559.123], [726.194,602.825], [626.716,606.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.195,602.854], [626.717,606.306], [727.526,648.951], [628.559,652.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.526,648.98], [628.561,653.019], [728.844,694.627], [630.385,699.241]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.845,694.656], [630.386,699.27], [730.149,739.859], [632.192,745.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.15,739.887], [632.193,745.066], [731.442,784.653], [633.981,790.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.442,784.653], [633.981,790.384], [732.629,825.778], [635.624,832.012]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[717.657,315.852], [775.94,316.044], [716.206,265.596], [774.799,266.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.657,315.852], [719.095,365.624], [775.94,316.044], [777.069,365.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.095,365.624], [777.069,365.433], [720.517,414.855], [778.186,414.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.518,414.887], [778.187,414.321], [721.926,463.617], [779.293,462.685]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.927,463.648], [779.294,462.715], [723.32,511.885], [780.389,510.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.321,511.916], [780.39,510.624], [724.701,559.668], [781.474,558.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.701,559.698], [781.474,558.053], [726.067,606.971], [782.548,604.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.068,607.001], [782.548,605.01], [727.42,653.803], [783.611,651.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.421,653.832], [783.611,651.503], [728.759,700.17], [784.664,697.509]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.76,700.199], [784.664,697.538], [730.086,746.079], [785.706,743.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.086,746.108], [785.707,743.122], [731.399,791.537], [786.739,788.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.399,791.538], [786.739,788.233], [732.604,833.266], [787.686,829.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[776.465,315.732], [777.606,365.743], [837.198,315.935], [838.018,365.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[777.606,365.743], [778.735,415.209], [838.018,365.542], [838.83,414.612]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[778.736,415.24], [838.831,414.644], [779.853,464.2], [839.634,463.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[779.854,464.231], [839.635,463.247], [780.959,512.693], [840.43,511.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[780.96,512.724], [840.431,511.36], [782.054,560.696], [841.218,558.96]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.055,560.726], [841.219,558.991], [783.139,608.215], [841.999,606.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[783.139,608.245], [841.999,606.145], [784.212,655.258], [842.771,652.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.213,655.288], [842.771,652.831], [785.275,701.832], [843.536,699.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.275,701.862], [843.536,699.055], [786.327,747.945], [844.293,744.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.327,747.974], [844.293,744.824], [787.368,793.602], [845.043,790.117]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[788.509,318.411], [787.537,273.348], [944.229,318.876], [943.987,274.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.368,793.602], [845.043,790.117], [788.324,835.512], [845.731,831.721]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.578,316.326], [836.394,365.154], [937.814,316.662], [938.11,364.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.394,365.154], [837.201,413.462], [938.11,364.821], [938.404,412.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.202,413.493], [838.001,461.318], [938.404,412.504], [938.694,459.687]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.001,461.348], [838.793,508.699], [938.694,459.717], [938.982,506.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.793,508.729], [839.577,555.611], [938.982,506.468], [939.267,552.733]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.577,555.641], [840.353,602.062], [939.267,552.762], [939.549,598.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.354,602.091], [841.122,648.058], [939.55,598.607], [939.829,643.981]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.122,648.087], [939.829,644.01], [841.883,693.607], [940.106,688.947]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.884,693.636], [940.106,688.976], [842.637,738.713], [940.38,733.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[842.637,738.742], [940.38,733.512], [843.384,783.385], [940.652,777.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[843.384,783.385], [940.652,777.596], [844.069,824.399], [940.901,818.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.582,317.164], [933.893,364.324], [966.082,317.268], [966.234,364.22]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.893,364.324], [934.201,410.998], [966.234,364.221], [966.384,410.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.201,411.027], [934.505,457.251], [966.384,410.72], [966.533,456.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.506,457.28], [934.808,503.06], [966.533,456.772], [966.681,502.356]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[934.808,503.089], [966.681,502.385], [935.107,548.432], [966.827,547.535]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.107,548.46], [966.827,547.563], [935.403,593.372], [966.972,592.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.403,593.4], [966.972,592.314], [935.697,637.886], [967.116,636.615]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.697,637.914], [967.116,636.643], [935.987,681.982], [967.258,680.529]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[935.988,682.01], [967.258,680.557], [936.276,725.664], [967.399,724.033]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.276,725.692], [967.399,724.06], [936.561,768.938], [967.538,767.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.561,768.938], [967.538,767.132], [936.823,808.681], [967.667,806.716]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1028.87,319.129], [1029.01,275.521], [1188.99,319.607], [1189.84,276.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.24,719.647], [1056.96,762.245], [1049.53,710.604], [1049.29,752.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.96,762.245], [1056.71,801.398], [1049.29,752.231], [1049.08,790.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.65,500.48], [1058.36,545.109], [1050.73,496.581], [1050.48,540.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.36,545.137], [1058.07,589.349], [1050.48,540.171], [1050.24,583.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.07,589.377], [1057.79,633.177], [1050.24,583.363], [1050,626.135]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.79,633.205], [1057.51,676.598], [1050,626.162], [1049.76,668.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.51,676.626], [1057.24,719.619], [1049.76,668.574], [1049.53,710.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.83,317.551], [1059.53,363.94], [1051.73,318.129], [1051.47,363.367]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.53,363.94], [1059.23,409.858], [1051.47,363.367], [1051.22,408.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.23,409.887], [1058.94,455.37], [1051.22,408.184], [1050.97,452.559]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.94,455.399], [1058.65,500.451], [1050.97,452.587], [1050.73,496.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.51,676.626], [1089.87,675.121], [1057.24,719.62], [1089.45,717.93]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.24,719.647], [1089.45,717.957], [1056.96,762.245], [1089.03,760.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.96,762.245], [1089.03,760.374], [1056.71,801.398], [1088.64,799.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.65,500.48], [1058.36,545.109], [1091.61,499.751], [1091.17,544.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.36,545.137], [1058.07,589.349], [1091.17,544.209], [1090.73,588.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.07,589.377], [1090.73,588.253], [1057.79,633.177], [1090.3,631.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.79,633.205], [1090.3,631.888], [1057.51,676.598], [1089.87,675.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.53,363.94], [1059.23,409.858], [1092.96,363.833], [1092.5,409.54]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.23,409.887], [1058.94,455.37], [1092.5,409.569], [1092.05,454.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.94,455.399], [1058.65,500.451], [1092.05,454.873], [1091.61,499.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.83,317.551], [1059.53,363.94], [1093.41,317.659], [1092.96,363.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.28,682.091], [1096.82,725.755], [1089.87,675.121], [1089.45,717.93]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.82,725.783], [1096.35,769.04], [1089.45,717.957], [1089.03,760.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.35,769.04], [1095.93,808.792], [1089.03,760.374], [1088.64,799.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.23,593.461], [1097.76,637.958], [1090.73,588.253], [1090.3,631.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.76,637.986], [1097.28,682.063], [1090.3,631.888], [1089.87,675.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.2,503.128], [1098.71,548.482], [1091.61,499.751], [1091.17,544.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.71,548.51], [1098.23,593.432], [1091.17,544.209], [1090.73,588.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.19,411.045], [1099.69,457.279], [1092.5,409.569], [1092.05,454.844]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.69,457.309], [1099.2,503.099], [1092.05,454.873], [1091.61,499.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.19,317.158], [1100.69,364.33], [1093.41,317.659], [1092.96,363.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.69,364.33], [1100.19,411.015], [1092.96,363.833], [1092.5,409.54]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.82,725.783], [1096.35,769.04], [1185.97,721.005], [1185.1,763.749]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.35,769.04], [1095.93,808.792], [1185.1,763.749], [1184.3,803.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.76,637.986], [1097.28,682.063], [1187.73,634.262], [1186.85,677.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.28,682.091], [1096.82,725.755], [1186.85,677.835], [1185.97,720.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.71,548.51], [1098.23,593.432], [1189.53,545.883], [1188.63,590.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.23,593.461], [1097.76,637.958], [1188.63,590.281], [1187.73,634.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.69,457.309], [1099.2,503.099], [1191.36,455.821], [1190.44,501.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.2,503.129], [1098.71,548.482], [1190.44,501.066], [1189.53,545.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.69,364.33], [1100.19,411.015], [1193.22,364.026], [1192.29,410.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.19,411.045], [1099.69,457.279], [1192.29,410.143], [1191.36,455.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.19,317.158], [1100.69,364.33], [1194.17,317.464], [1193.22,364.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.12,769.393], [1190.28,809.176], [1185.1,763.749], [1184.3,803.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.03,726.102], [1191.12,769.393], [1185.97,721.005], [1185.1,763.749]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.94,682.375], [1192.03,726.075], [1186.85,677.835], [1185.97,720.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.87,638.234], [1192.94,682.347], [1187.73,634.263], [1186.85,677.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.8,593.673], [1193.87,638.206], [1188.63,590.281], [1187.73,634.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.75,548.686], [1194.81,593.645], [1189.53,545.884], [1188.63,590.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.7,503.266], [1195.75,548.657], [1190.44,501.066], [1189.53,545.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.12,769.393], [1190.28,809.176], [1242.4,766.293], [1241.35,805.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.66,457.408], [1196.7,503.237], [1191.36,455.821], [1190.44,501.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.03,726.102], [1191.12,769.393], [1243.54,723.302], [1242.4,766.293]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.62,364.35], [1198.64,411.075], [1193.22,364.026], [1192.29,410.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.63,411.105], [1197.66,457.379], [1192.29,410.143], [1191.36,455.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.94,682.375], [1192.03,726.075], [1244.69,679.881], [1243.54,723.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.61,317.137], [1199.62,364.35], [1194.17,317.464], [1193.22,364.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.87,638.234], [1192.94,682.347], [1245.85,636.052], [1244.69,679.854]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.8,593.673], [1193.87,638.206], [1247.02,591.809], [1245.85,636.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.75,548.686], [1194.8,593.645], [1248.21,547.146], [1247.02,591.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.7,503.266], [1195.75,548.657], [1249.4,502.057], [1248.21,547.118]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.66,457.408], [1196.7,503.237], [1250.61,456.536], [1249.41,502.028]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.63,411.105], [1197.66,457.379], [1251.83,410.577], [1250.61,456.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.62,364.35], [1198.64,411.075], [1253.06,364.172], [1251.83,410.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.61,317.137], [1199.62,364.35], [1254.31,317.317], [1253.06,364.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.93,761.897], [1238.9,801.019], [1288.12,759.015], [1286.9,797.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.05,719.332], [1239.93,761.897], [1289.45,716.729], [1288.12,759.015]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.17,676.346], [1241.05,719.305], [1290.79,674.028], [1289.45,716.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.31,632.96], [1242.18,676.318], [1292.15,630.932], [1290.79,674.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.46,589.168], [1243.31,632.932], [1293.52,587.436], [1292.15,630.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.62,544.965], [1244.46,589.14], [1294.9,543.534], [1293.52,587.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.79,500.344], [1245.62,544.936], [1296.29,499.221], [1294.9,543.506]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.98,455.301], [1246.79,500.316], [1297.7,454.491], [1296.29,499.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.17,409.828], [1247.98,455.272], [1299.12,409.338], [1297.7,454.463]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1251.59,317.571], [1252.82,270.803], [1302,317.737], [1303.46,271.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.37,363.92], [1249.17,409.799], [1300.55,363.755], [1299.12,409.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.59,317.57], [1250.37,363.92], [1302,317.737], [1300.55,363.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.86,752.781], [1278.69,791.097], [1361.87,747.954], [1360.38,785.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.14,711.1], [1279.86,752.781], [1363.49,706.743], [1361.87,747.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.42,669.016], [1281.14,711.074], [1365.13,665.136], [1363.5,706.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.72,626.548], [1282.42,668.989], [1366.79,623.155], [1365.13,665.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.03,583.692], [1283.72,626.521], [1368.45,580.795], [1366.79,623.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.35,540.443], [1285.03,583.665], [1370.14,538.051], [1368.46,580.768]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.68,496.794], [1286.35,540.415], [1371.84,494.917], [1370.14,538.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.03,452.741], [1287.68,496.767], [1373.55,451.388], [1371.84,494.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.38,408.278], [1289.03,452.713], [1375.28,407.458], [1373.55,451.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.75,363.398], [1290.39,408.25], [1377.03,363.123], [1375.28,407.43]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.14,318.097], [1291.75,363.398], [1378.79,318.375], [1377.03,363.122]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1293.14,318.097], [1294.53,272.397], [1378.79,318.375], [1380.57,273.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.91,736.299], [1342.53,773.154], [1370.5,734.782], [1369.02,771.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.4,696.222], [1343.91,736.299], [1372.11,694.853], [1370.5,734.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.92,655.771], [1345.4,696.196], [1373.73,654.552], [1372.11,694.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.44,614.966], [1346.92,655.745], [1375.37,613.901], [1373.73,654.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1349.98,573.804], [1348.44,614.941], [1377.02,572.895], [1375.37,613.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.53,532.28], [1349.98,573.778], [1378.68,531.529], [1377.02,572.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.1,490.387], [1351.54,532.253], [1380.36,489.799], [1378.68,531.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1354.68,448.123], [1353.1,490.361], [1382.06,447.699], [1380.36,489.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.28,405.481], [1354.68,448.096], [1383.77,405.224], [1382.06,447.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.89,362.457], [1356.28,405.454], [1385.49,362.371], [1383.77,405.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.51,319.045], [1357.89,362.457], [1387.23,319.132], [1385.49,362.371]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1359.51,319.045], [1361.15,275.269], [1387.23,319.133], [1388.99,275.532]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[616.135,317.201], [614.306,269.58], [583.096,317.132], [581.104,269.394]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[582.965,317.122], [580.971,269.369], [594.729,318.372], [592.877,272.718]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.948,364.399], [616.135,317.201], [585.071,364.444], [583.096,317.132]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.948,364.399], [619.742,411.121], [585.071,364.444], [587.026,411.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.941,364.45], [586.897,411.3], [596.565,363.639], [598.384,408.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.898,411.329], [588.835,457.736], [598.385,408.495], [600.187,452.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.743,411.15], [621.521,457.432], [587.027,411.308], [588.963,457.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.837,457.765], [590.756,503.736], [600.188,452.945], [601.974,496.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.522,457.461], [623.283,503.31], [588.964,457.729], [590.882,503.685]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.284,503.338], [590.883,503.714], [625.029,548.759], [592.784,549.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.757,503.765], [592.658,549.306], [601.975,496.996], [603.745,540.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.03,548.787], [592.785,549.269], [626.758,593.786], [594.667,594.371]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.66,549.334], [594.543,594.451], [603.747,540.652], [605.501,583.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.759,593.814], [594.668,594.4], [628.471,638.396], [596.533,639.084]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[594.544,594.479], [596.41,639.178], [605.502,583.918], [607.24,626.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.472,638.424], [596.534,639.112], [630.169,682.596], [598.382,683.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.412,639.206], [598.26,683.492], [607.241,626.801], [608.965,669.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.17,682.624], [598.383,683.412], [631.851,726.392], [600.214,727.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.262,683.52], [600.093,727.399], [608.966,669.304], [610.674,711.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.852,726.419], [600.215,727.306], [633.518,769.788], [602.029,770.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.095,727.426], [601.91,770.905], [610.675,711.434], [612.368,753.168]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.518,769.788], [602.029,770.771], [635.049,809.65], [603.697,810.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[601.909,770.905], [603.578,810.867], [612.368,753.169], [613.925,791.542]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[708.669,316.455], [707.247,267.58], [608.149,316.237], [606.218,266.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.077,364.884], [708.669,316.455], [610.062,365.025], [608.149,316.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.077,364.884], [711.471,412.812], [610.062,365.025], [611.955,413.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.472,412.843], [712.852,460.308], [611.956,413.337], [613.831,461.148]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.853,460.338], [714.221,507.348], [613.832,461.178], [615.688,508.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.221,507.377], [715.576,553.937], [615.69,508.557], [617.528,555.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.577,553.966], [716.918,600.082], [617.529,555.478], [619.35,601.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.919,600.111], [718.247,645.79], [619.351,601.95], [621.155,647.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.248,645.819], [719.564,691.067], [621.156,647.977], [622.943,693.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.565,691.096], [720.869,735.919], [622.944,693.568], [624.713,738.699]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.869,735.947], [624.714,738.727], [722.161,780.351], [626.467,783.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.161,780.351], [626.467,783.433], [723.348,821.157], [628.078,824.514]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[763.938,316.103], [762.775,266.637], [706.318,315.976], [704.861,266.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.091,365.112], [763.938,316.103], [707.761,365.194], [706.318,315.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.091,365.112], [766.231,413.609], [707.761,365.195], [709.189,413.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.232,413.64], [767.361,461.663], [709.19,413.928], [710.604,462.152]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.362,461.693], [710.605,462.182], [768.48,509.249], [712.005,509.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.481,509.279], [712.006,509.966], [769.589,556.375], [713.392,557.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.589,556.404], [713.393,557.285], [770.686,603.046], [714.766,604.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.687,603.076], [714.767,604.146], [771.773,649.27], [716.127,650.526]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.774,649.299], [716.128,650.556], [772.85,695.053], [717.475,696.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.851,695.082], [717.476,696.521], [773.916,740.401], [718.809,742.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.917,740.43], [718.81,742.048], [774.973,785.321], [720.132,787.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.973,785.321], [720.132,787.114], [775.943,826.569], [721.346,828.523]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.162,365.268], [823.296,315.862], [763.986,365.356], [762.813,315.727]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.162,365.269], [825.019,414.156], [763.986,365.357], [765.146,414.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.02,414.187], [765.147,414.493], [825.869,462.592], [766.296,463.111]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.869,462.622], [766.297,463.142], [826.71,510.553], [767.434,511.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.711,510.583], [767.435,511.313], [827.543,558.046], [768.561,558.981]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.544,558.076], [768.562,559.011], [828.368,605.078], [769.677,606.215]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.368,605.108], [769.678,606.245], [829.185,651.655], [770.783,652.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.185,651.685], [770.783,653.02], [829.994,697.785], [771.877,699.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.995,697.814], [771.878,699.342], [830.795,743.473], [772.961,745.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.796,743.502], [772.962,745.22], [831.589,788.726], [774.035,790.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.589,788.726], [774.035,790.63], [832.318,830.278], [775.021,832.352]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[788.611,318.927], [787.67,274.203], [944.598,319.239], [944.363,275.038]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.611,364.96], [823.761,316.336], [926.878,364.814], [926.533,316.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.611,364.961], [825.453,413.081], [926.878,364.814], [927.219,412.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.454,413.111], [927.219,412.599], [826.287,460.764], [927.557,459.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.288,460.794], [927.557,459.924], [827.113,507.987], [927.892,506.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.114,508.017], [927.892,506.796], [827.931,554.757], [928.223,553.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.932,554.786], [928.224,553.221], [828.742,601.079], [928.552,599.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.742,601.109], [928.552,599.205], [829.544,646.961], [928.877,644.726]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.545,646.99], [928.877,644.755], [830.339,692.408], [929.199,689.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.34,692.437], [929.2,689.876], [831.127,737.427], [929.519,734.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.127,737.455], [929.519,734.576], [831.907,782.023], [929.835,778.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.907,782.023], [929.835,778.831], [832.623,822.978], [930.125,819.502]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.319,364.414], [924.974,317.178], [958.072,364.368], [957.885,317.249]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.319,364.415], [925.66,411.173], [958.072,364.369], [958.258,411.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.66,411.203], [958.258,411.043], [925.998,457.521], [958.442,457.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.999,457.551], [958.442,457.278], [926.334,503.434], [958.625,503.051]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.334,503.463], [958.625,503.08], [926.666,548.919], [958.805,548.427]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.666,548.947], [958.806,548.456], [926.994,593.98], [958.984,593.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.995,594.009], [958.985,593.411], [927.32,638.625], [959.162,637.923]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.321,638.653], [959.162,637.951], [927.643,682.858], [959.338,682.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.643,682.886], [959.338,682.082], [927.963,726.686], [959.512,725.782]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.963,726.714], [959.512,725.81], [928.28,770.114], [959.685,769.111]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.28,770.114], [959.685,769.111], [928.571,810.006], [959.843,808.913]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1030.61,319.41], [1030.76,275.498], [1195.78,319.741], [1196.64,276.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.39,680.007], [1051.15,723.447], [1046.52,671.815], [1046.3,714.232]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.15,723.475], [1050.9,766.522], [1046.3,714.258], [1046.09,756.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.9,766.522], [1050.68,806.093], [1046.09,756.301], [1045.89,794.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.65,456.573], [1052.4,502.062], [1047.64,453.796], [1047.41,498.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.4,502.091], [1052.14,547.159], [1047.41,498.19], [1047.18,542.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.14,547.188], [1051.89,591.84], [1047.18,542.184], [1046.96,585.755]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.89,591.869], [1051.64,636.112], [1046.96,585.783], [1046.74,628.964]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.64,636.14], [1051.39,679.979], [1046.74,628.991], [1046.52,671.787]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.17,364.25], [1053.44,317.432], [1048.1,363.782], [1048.33,318.152]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.17,364.25], [1052.91,410.599], [1048.1,363.782], [1047.87,408.966]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.91,410.628], [1052.65,456.544], [1047.87,408.995], [1047.64,453.767]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.64,636.14], [1085.07,635.402], [1051.39,679.979], [1084.68,679.134]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.39,680.007], [1084.68,679.161], [1051.15,723.447], [1084.28,722.497]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.15,723.475], [1084.28,722.524], [1050.9,766.522], [1083.89,765.468]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.9,766.522], [1083.89,765.468], [1050.68,806.093], [1083.53,804.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.65,456.573], [1052.4,502.062], [1086.71,456.287], [1086.29,501.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.4,502.091], [1086.29,501.689], [1052.14,547.159], [1085.88,546.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.14,547.188], [1085.88,546.671], [1051.89,591.84], [1085.48,591.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.89,591.869], [1085.48,591.241], [1051.64,636.112], [1085.07,635.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.17,364.25], [1053.44,317.432], [1087.55,364.201], [1087.97,317.506]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.17,364.25], [1052.91,410.599], [1087.55,364.201], [1087.13,410.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.91,410.628], [1052.65,456.544], [1087.13,410.46], [1086.71,456.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1089.64,686.288], [1089.21,730.512], [1084.68,679.161], [1084.28,722.497]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1089.21,730.54], [1088.79,774.357], [1084.28,722.524], [1083.89,765.468]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1088.79,774.357], [1088.4,814.628], [1083.89,765.468], [1083.53,804.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.5,596.537], [1090.07,641.594], [1085.48,591.241], [1085.07,635.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.07,641.622], [1089.64,686.26], [1085.07,635.402], [1084.68,679.134]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.83,458.705], [1091.38,505.055], [1086.71,456.287], [1086.29,501.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.38,505.085], [1090.94,550.997], [1086.29,501.689], [1085.88,546.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.94,551.026], [1090.5,596.508], [1085.88,546.671], [1085.48,591.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.74,364.609], [1092.28,411.852], [1087.55,364.202], [1087.13,410.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.28,411.882], [1091.83,458.676], [1087.13,410.46], [1086.71,456.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.74,364.609], [1093.2,316.879], [1087.55,364.201], [1087.97,317.506]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1088.79,774.357], [1088.4,814.628], [1180.86,771.351], [1180.09,811.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1089.64,686.288], [1089.21,730.512], [1182.56,683.877], [1181.71,727.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1089.21,730.54], [1088.79,774.357], [1181.7,727.829], [1180.86,771.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.5,596.537], [1090.07,641.594], [1184.28,594.745], [1183.42,639.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.07,641.622], [1089.64,686.26], [1183.41,639.518], [1182.56,683.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.83,458.705], [1091.38,505.055], [1186.93,457.887], [1186.04,503.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.38,505.085], [1090.94,550.997], [1186.04,503.936], [1185.16,549.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.94,551.026], [1090.5,596.508], [1185.16,549.553], [1184.28,594.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.74,364.609], [1092.28,411.852], [1188.74,364.471], [1187.83,411.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.28,411.882], [1091.83,458.676], [1187.83,411.401], [1186.93,457.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.74,364.609], [1093.2,316.879], [1188.74,364.471], [1189.66,317.091]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.38,777.208], [1184.58,817.734], [1180.86,771.351], [1180.09,811.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.26,733.112], [1185.38,777.208], [1181.7,727.829], [1180.86,771.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.14,688.575], [1186.26,733.084], [1182.56,683.877], [1181.71,727.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.03,643.618], [1187.14,688.546], [1183.41,639.518], [1182.56,683.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.84,552.424], [1188.93,598.208], [1185.16,549.553], [1184.28,594.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.93,598.237], [1188.03,643.59], [1184.28,594.745], [1183.42,639.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.76,506.175], [1189.84,552.395], [1186.04,503.936], [1185.16,549.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.38,777.208], [1184.58,817.734], [1239.08,775.43], [1238.05,815.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.69,459.482], [1190.76,506.145], [1186.93,457.887], [1186.04,503.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.14,688.575], [1186.26,733.084], [1241.34,687.149], [1240.21,731.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.26,733.112], [1185.38,777.208], [1240.2,731.508], [1239.08,775.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.62,412.339], [1191.69,459.452], [1187.83,411.401], [1186.93,457.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.03,643.618], [1187.14,688.546], [1242.48,642.373], [1241.34,687.12]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.57,364.74], [1192.62,412.309], [1188.74,364.471], [1187.83,411.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.93,598.237], [1188.03,643.59], [1243.63,597.177], [1242.48,642.345]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.57,364.739], [1194.52,316.677], [1188.74,364.471], [1189.66,317.091]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.84,552.425], [1188.93,598.208], [1244.8,551.553], [1243.63,597.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.76,506.175], [1189.84,552.395], [1245.97,505.495], [1244.8,551.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.69,459.482], [1190.76,506.145], [1247.16,458.998], [1245.97,505.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.62,412.339], [1191.69,459.452], [1248.36,412.054], [1247.16,458.968]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.57,364.74], [1192.62,412.309], [1249.57,364.658], [1248.36,412.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.57,364.739], [1194.52,316.677], [1249.57,364.658], [1250.79,316.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.83,770.912], [1236.81,810.875], [1288.58,769.25], [1287.36,809.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.93,727.433], [1237.83,770.912], [1289.91,725.934], [1288.58,769.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.04,683.526], [1238.93,727.406], [1291.26,682.193], [1289.91,725.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.17,639.211], [1240.05,683.498], [1292.61,638.048], [1291.26,682.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.3,594.484], [1241.17,639.183], [1293.98,593.493], [1292.61,638.02]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.45,549.338], [1242.3,594.456], [1295.36,548.524], [1293.98,593.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.61,503.768], [1243.45,549.31], [1296.76,503.133], [1295.36,548.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.77,457.768], [1244.61,503.739], [1298.17,457.315], [1296.76,503.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.95,411.331], [1245.77,457.738], [1299.59,411.065], [1298.17,457.286]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.14,364.451], [1246.95,411.301], [1301.02,364.375], [1299.59,411.035]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1249.34,317.122], [1250.55,269.368], [1302.47,317.24], [1303.93,269.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.14,364.451], [1249.34,317.122], [1301.02,364.375], [1302.47,317.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.84,762.704], [1280.67,801.933], [1368.8,759.901], [1367.28,798.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.12,720.032], [1281.84,762.704], [1370.46,717.504], [1368.8,759.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.42,676.946], [1283.12,720.004], [1372.14,674.699], [1370.46,717.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.72,633.469], [1284.42,676.919], [1373.83,631.508], [1372.14,674.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.04,589.594], [1285.72,633.441], [1375.54,587.925], [1373.83,631.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.36,545.318], [1287.04,589.567], [1377.26,543.946], [1375.54,587.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.7,500.633], [1288.36,545.29], [1379,499.564], [1377.26,543.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.06,455.535], [1289.7,500.605], [1380.75,454.774], [1379,499.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.42,410.018], [1291.06,455.507], [1382.52,409.57], [1380.75,454.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.8,364.075], [1292.42,409.989], [1384.3,363.947], [1382.52,409.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.8,364.075], [1295.19,317.701], [1384.3,363.947], [1386.11,317.898]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1295.19,317.701], [1296.59,270.919], [1386.11,317.898], [1387.93,271.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.42,747.561], [1381.73,746.676], [1352,785.431], [1380.21,784.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1354.96,706.379], [1383.4,705.582], [1353.42,747.561], [1381.73,746.676]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.52,664.812], [1354.96,706.353], [1385.08,664.104], [1383.4,705.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.09,622.882], [1356.52,664.786], [1386.77,622.264], [1385.08,664.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.68,580.583], [1358.09,622.855], [1388.48,580.057], [1386.77,622.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.28,537.91], [1359.68,580.556], [1390.2,537.478], [1388.48,580.03]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1362.89,494.859], [1361.28,537.883], [1391.94,494.522], [1390.2,537.451]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1364.52,451.424], [1362.89,494.832], [1393.69,451.184], [1391.94,494.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.16,407.601], [1364.52,451.396], [1395.46,407.46], [1393.69,451.157]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.82,363.383], [1366.16,407.573], [1397.24,363.343], [1395.46,407.432]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.82,363.383], [1369.49,318.766], [1397.24,363.343], [1399.05,318.828]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1369.49,318.766], [1371.18,273.773], [1399.05,318.828], [1400.86,273.94]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[616.995,317.995], [615.236,271.33], [585.231,317.981], [583.325,271.292]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[585.066,317.971], [583.159,271.267], [601.531,319.307], [599.778,274.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.738,364.263], [616.995,317.996], [587.121,364.27], [585.231,317.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.738,364.263], [620.464,410.079], [587.121,364.27], [588.992,410.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.958,364.275], [588.83,410.128], [603.269,363.626], [604.991,407.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.831,410.156], [590.687,455.593], [604.992,407.557], [606.698,451.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.465,410.108], [622.176,455.508], [588.993,410.137], [590.848,455.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.177,455.537], [623.872,500.527], [590.849,455.587], [592.687,500.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.688,455.621], [592.527,500.646], [606.699,451.105], [608.391,494.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.528,500.674], [594.351,545.294], [608.392,494.276], [610.07,537.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.873,500.555], [625.554,545.14], [592.688,500.627], [594.509,545.232]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.555,545.168], [627.219,589.354], [594.51,545.26], [596.315,589.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[594.352,545.322], [596.158,589.541], [610.071,537.075], [611.734,579.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[627.22,589.381], [596.316,589.494], [628.871,633.173], [598.104,633.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.159,589.569], [597.949,633.394], [611.735,579.506], [613.384,621.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.872,633.2], [598.106,633.332], [630.507,676.603], [599.878,676.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.95,633.421], [599.724,676.856], [613.385,621.574], [615.019,663.257]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.508,676.63], [599.879,676.782], [632.129,719.649], [601.636,719.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.725,676.883], [601.483,719.934], [615.02,663.284], [616.641,704.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.13,719.676], [601.638,719.847], [633.737,762.316], [603.379,762.506]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[601.484,719.961], [603.227,762.633], [616.642,704.639], [618.249,745.62]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[702.622,317.008], [701.216,268.849], [605.303,316.961], [603.43,268.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.737,762.316], [603.379,762.506], [635.214,801.521], [604.981,801.728]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[603.227,762.633], [604.829,801.867], [618.249,745.62], [619.727,783.313]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.015,364.743], [702.622,317.008], [607.159,364.765], [605.303,316.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.015,364.743], [705.395,411.998], [607.159,364.766], [608.997,412.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.396,412.028], [706.763,458.84], [608.998,412.119], [610.818,459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.764,458.87], [708.118,505.246], [610.82,459.029], [612.623,505.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.118,505.275], [709.46,551.221], [612.624,505.501], [614.411,551.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.461,551.25], [710.79,596.772], [614.412,551.541], [616.183,597.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.791,596.8], [712.108,641.903], [616.184,597.155], [617.938,642.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.108,641.932], [713.413,686.622], [617.939,642.349], [619.677,687.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.414,686.65], [714.707,730.933], [619.678,687.129], [621.4,731.472]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.708,730.961], [715.989,774.843], [621.401,731.5], [623.107,775.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.989,774.843], [717.167,815.179], [623.107,775.441], [624.676,815.831]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[754.616,316.517], [753.44,267.614], [698.32,316.489], [696.87,267.544]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.781,364.981], [754.616,316.517], [699.756,364.995], [698.32,316.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.781,364.982], [756.935,412.953], [699.757,364.995], [701.179,413.007]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.936,412.983], [758.078,460.498], [701.18,413.037], [702.588,460.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.079,460.528], [759.211,507.594], [702.589,460.622], [703.984,507.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.211,507.624], [760.333,554.246], [703.985,507.756], [705.368,554.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.333,554.275], [761.444,600.461], [705.368,554.446], [706.738,600.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.445,600.49], [762.545,646.244], [706.738,600.698], [708.095,646.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.545,646.273], [708.096,646.518], [763.635,691.602], [709.439,691.883]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.636,691.631], [709.44,691.912], [764.716,736.542], [710.772,736.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.717,736.57], [710.772,736.886], [765.787,781.067], [712.092,781.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.787,781.067], [712.092,781.418], [766.77,821.964], [713.304,822.347]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.325,365.166], [811.422,316.136], [753.113,365.181], [751.919,316.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.325,365.167], [813.219,413.693], [753.113,365.181], [754.293,413.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.22,413.724], [814.105,461.783], [754.294,413.781], [755.464,461.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.106,461.814], [814.982,509.413], [755.464,461.914], [756.623,509.555]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.983,509.443], [815.851,556.589], [756.623,509.585], [757.771,556.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.852,556.62], [757.771,556.802], [816.712,603.319], [758.908,603.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.713,603.348], [758.909,603.571], [817.565,649.607], [760.034,649.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.565,649.636], [760.035,649.898], [818.409,695.46], [761.15,695.761]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.41,695.489], [761.151,695.79], [819.246,740.885], [762.255,741.223]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.247,740.914], [762.256,741.252], [820.075,785.887], [763.35,786.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.075,785.888], [763.35,786.263], [820.836,827.218], [764.356,827.627]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[945.459,319.642], [945.232,275.465], [790.666,319.573], [789.759,275.292]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.401,364.888], [916.012,316.708], [814.786,364.913], [813.909,316.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.401,364.889], [916.785,412.582], [814.786,364.913], [815.654,412.679]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.786,412.612], [917.166,459.854], [815.655,412.709], [816.515,460.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.167,459.884], [917.544,506.682], [816.515,460.053], [817.367,506.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.544,506.711], [917.918,553.071], [817.367,506.951], [818.211,553.379]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.918,553.1], [818.212,553.409], [918.289,599.028], [819.048,599.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.289,599.057], [819.049,599.433], [918.656,644.558], [819.877,645.001]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.656,644.587], [819.877,645.03], [919.02,689.668], [820.698,690.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.02,689.697], [820.698,690.205], [919.38,734.363], [821.511,734.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.38,734.392], [821.512,734.964], [919.737,778.65], [822.317,779.284]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.737,778.65], [822.317,779.285], [920.065,819.329], [823.058,820.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.298,364.548], [950.077,317.409], [917.496,364.556], [917.121,317.394]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.298,364.548], [917.496,364.556], [950.517,411.219], [917.868,411.25]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.517,411.249], [917.868,411.279], [950.734,457.488], [918.236,457.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.734,457.517], [918.236,457.57], [950.949,503.33], [918.601,503.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.949,503.359], [918.601,503.435], [951.162,548.753], [918.962,548.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.162,548.782], [918.963,548.879], [951.373,593.761], [919.32,593.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.373,593.79], [919.321,593.909], [951.582,638.36], [919.675,638.5]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.583,638.389], [919.676,638.529], [951.79,682.556], [920.027,682.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.79,682.584], [920.027,682.745], [951.995,726.355], [920.376,726.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.995,726.382], [920.376,726.563], [952.199,769.76], [920.721,769.961]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[952.199,769.761], [920.721,769.962], [952.386,809.638], [921.038,809.857]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1032.06,319.681], [1032.22,275.563], [1200.91,319.756], [1201.8,275.752]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.42,726.144], [1044.21,769.496], [1042.55,716.834], [1042.35,759.161]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.21,769.497], [1044.02,809.35], [1042.35,759.161], [1042.17,798.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.51,503.26], [1045.29,548.625], [1043.56,499.368], [1043.35,543.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.29,548.653], [1045.07,593.605], [1043.35,543.638], [1043.15,587.487]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.07,593.633], [1044.85,638.176], [1043.15,587.514], [1042.95,630.975]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.85,638.204], [1044.64,682.345], [1042.95,631.003], [1042.75,674.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.64,682.373], [1044.42,726.117], [1042.75,674.108], [1042.55,716.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.18,364.538], [1046.41,317.43], [1044.19,364.142], [1044.4,318.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.18,364.538], [1045.95,411.178], [1044.19,364.143], [1043.98,409.597]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.95,411.208], [1045.73,457.417], [1043.98,409.626], [1043.77,454.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.73,457.447], [1045.51,503.231], [1043.77,454.699], [1043.56,499.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.64,682.373], [1078.5,682.202], [1044.43,726.117], [1078.13,725.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.42,726.144], [1078.13,725.951], [1044.21,769.496], [1077.77,769.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.21,769.497], [1077.77,769.282], [1044.02,809.35], [1077.44,809.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.51,503.26], [1079.99,503.179], [1045.29,548.625], [1079.61,548.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.29,548.653], [1079.61,548.549], [1045.07,593.605], [1079.24,593.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.07,593.633], [1079.24,593.506], [1044.85,638.176], [1078.87,638.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1044.85,638.204], [1078.86,638.055], [1044.64,682.345], [1078.5,682.174]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.18,364.538], [1046.41,317.43], [1081.14,364.529], [1081.54,317.447]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.18,364.538], [1045.95,411.178], [1081.14,364.529], [1080.75,411.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.95,411.208], [1080.75,411.175], [1045.73,457.417], [1080.37,457.36]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.73,457.447], [1080.37,457.39], [1045.51,503.231], [1079.99,503.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.12,778.311], [1079.77,818.96], [1077.77,769.282], [1077.44,809.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.89,689.426], [1080.5,734.058], [1078.5,682.202], [1078.13,725.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.5,734.087], [1080.12,778.311], [1078.13,725.951], [1077.77,769.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.06,552.936], [1081.66,598.827], [1079.61,548.549], [1079.24,593.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.66,598.856], [1081.27,644.322], [1079.24,593.506], [1078.87,638.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.27,644.351], [1080.89,689.397], [1078.86,638.055], [1078.5,682.174]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.26,412.56], [1082.86,459.764], [1080.75,411.175], [1080.37,457.36]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.86,459.794], [1082.45,506.554], [1080.37,457.39], [1079.99,503.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.45,506.584], [1082.06,552.906], [1079.99,503.179], [1079.61,548.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.5,734.087], [1175.38,733.531], [1080.12,778.311], [1174.57,777.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.12,778.311], [1174.57,777.695], [1079.77,818.96], [1173.83,818.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.67,364.875], [1084.08,316.735], [1081.14,364.529], [1081.54,317.447]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.67,364.876], [1083.26,412.53], [1081.14,364.53], [1080.75,411.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.66,598.856], [1081.27,644.322], [1177.87,598.491], [1177.03,643.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.27,644.351], [1080.89,689.397], [1177.03,643.921], [1176.2,688.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.89,689.426], [1176.2,688.932], [1080.5,734.058], [1175.38,733.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.45,506.584], [1082.06,552.906], [1179.56,506.351], [1178.71,552.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.06,552.936], [1081.66,598.827], [1178.71,552.636], [1177.87,598.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.67,364.875], [1083.26,412.53], [1182.16,364.852], [1181.29,412.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.26,412.56], [1082.86,459.764], [1181.29,412.465], [1180.42,459.6]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.86,459.794], [1082.45,506.554], [1180.42,459.63], [1179.56,506.322]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.67,364.875], [1084.08,316.735], [1182.16,364.852], [1183.04,316.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.47,783.716], [1176.7,824.851], [1174.57,777.695], [1173.83,818.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.31,738.957], [1177.47,783.716], [1175.38,733.531], [1174.57,777.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180,648.121], [1179.15,693.722], [1177.03,643.921], [1176.2,688.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.15,693.751], [1178.31,738.928], [1176.2,688.933], [1175.38,733.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.86,602.06], [1180,648.092], [1177.87,598.491], [1177.03,643.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.47,783.716], [1233.08,783.348], [1176.7,824.851], [1232.08,824.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.73,555.563], [1180.86,602.031], [1178.71,552.636], [1177.87,598.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.15,693.751], [1235.28,693.457], [1178.31,738.928], [1234.18,738.597]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.31,738.957], [1234.18,738.625], [1177.47,783.716], [1233.08,783.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.61,508.623], [1181.73,555.534], [1179.56,506.351], [1178.71,552.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180,648.121], [1236.4,647.864], [1179.15,693.722], [1235.28,693.428]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.5,461.234], [1182.61,508.593], [1180.42,459.63], [1179.56,506.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.86,602.06], [1180,648.092], [1237.52,601.842], [1236.4,647.835]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.29,365.083], [1184.39,413.359], [1182.16,364.852], [1181.29,412.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.39,413.39], [1183.5,461.204], [1181.29,412.465], [1180.42,459.6]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.73,555.563], [1180.86,602.031], [1238.66,555.384], [1237.52,601.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.29,365.083], [1186.21,316.307], [1182.16,364.852], [1183.04,316.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.61,508.623], [1181.73,555.534], [1239.81,508.484], [1238.66,555.355]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.5,461.234], [1182.61,508.593], [1240.96,461.136], [1239.81,508.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.39,413.39], [1183.5,461.204], [1242.13,413.333], [1240.97,461.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.29,365.083], [1186.21,316.307], [1243.32,365.069], [1244.51,316.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.29,365.083], [1184.39,413.359], [1243.32,365.069], [1242.14,413.303]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.12,778.747], [1286.01,778.401], [1232.13,819.435], [1284.79,819.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.2,734.48], [1287.33,734.168], [1233.12,778.747], [1286.01,778.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.3,689.775], [1288.67,689.498], [1234.2,734.451], [1287.33,734.139]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.4,644.655], [1235.3,689.746], [1290.02,644.413], [1288.67,689.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.51,599.115], [1236.4,644.626], [1291.38,598.909], [1290.02,644.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.64,553.148], [1237.52,599.085], [1292.76,552.979], [1291.38,598.88]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.77,506.748], [1238.64,553.118], [1294.15,506.618], [1292.76,552.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.92,459.91], [1239.77,506.718], [1295.55,459.818], [1294.15,506.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.08,412.627], [1240.92,459.88], [1296.96,412.574], [1295.55,459.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.24,364.892], [1242.08,412.596], [1298.39,364.879], [1296.96,412.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.24,364.892], [1244.42,316.7], [1298.39,364.879], [1299.83,316.727]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1244.42,316.7], [1245.61,268.075], [1299.83,316.728], [1301.29,268.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.97,771.589], [1279.79,811.631], [1372.27,771], [1370.72,810.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.25,728.029], [1280.97,771.589], [1373.96,727.499], [1372.27,771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.54,684.047], [1282.25,728.002], [1375.67,683.576], [1373.96,727.472]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.85,639.663], [1283.54,684.019], [1377.39,639.253], [1375.67,683.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.16,594.872], [1284.85,639.635], [1379.13,594.524], [1377.39,639.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.49,549.669], [1286.16,594.844], [1380.89,549.384], [1379.13,594.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.83,504.048], [1287.49,549.641], [1382.66,503.827], [1380.89,549.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.19,458.003], [1288.83,504.019], [1384.44,457.847], [1382.66,503.798]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.55,411.529], [1290.19,457.974], [1386.25,411.438], [1384.44,457.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.93,364.618], [1291.56,411.499], [1388.07,364.596], [1386.25,411.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.93,364.618], [1294.33,317.265], [1388.07,364.595], [1389.91,317.311]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1294.33,317.265], [1295.73,269.494], [1389.91,317.312], [1391.76,269.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.86,758.037], [1389.74,757.85], [1358.4,796.854], [1388.17,796.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.45,715.821], [1391.46,715.653], [1359.86,758.037], [1389.74,757.85]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.04,673.208], [1393.19,673.059], [1361.45,715.795], [1391.46,715.626]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1364.66,630.219], [1394.93,630.089], [1363.05,673.181], [1393.19,673.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.29,586.849], [1364.66,630.192], [1396.69,586.738], [1394.93,630.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.93,543.092], [1366.29,586.821], [1398.47,543.002], [1396.7,586.711]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.58,498.944], [1367.93,543.065], [1400.26,498.874], [1398.47,542.974]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.26,454.4], [1369.59,498.917], [1402.07,454.35], [1400.27,498.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.94,409.453], [1371.26,454.372], [1403.9,409.425], [1402.07,454.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1374.65,364.099], [1372.94,409.425], [1405.74,364.092], [1403.9,409.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1374.65,364.099], [1376.36,318.332], [1405.74,364.092], [1407.6,318.347]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.36,318.332], [1378.1,272.176], [1407.6,318.347], [1409.47,272.213]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[621.629,319], [619.943,273.397], [591.389,319.043], [589.57,273.504]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.3,364.226], [621.629,319], [593.192,364.207], [591.389,319.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.3,364.226], [624.956,409.022], [593.192,364.207], [594.979,408.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[624.957,409.05], [626.598,453.452], [594.98,408.97], [596.75,453.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.599,453.48], [628.226,497.492], [596.751,453.34], [598.507,497.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.227,497.52], [629.839,541.147], [598.508,497.32], [600.248,540.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[629.84,541.175], [631.438,584.423], [600.249,540.917], [601.973,584.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.439,584.45], [633.024,627.323], [601.974,584.135], [603.684,626.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.025,627.35], [634.596,669.853], [603.685,626.979], [605.38,669.427]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[699.848,317.84], [698.464,270.544], [606.646,317.979], [604.836,270.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.597,669.88], [605.382,669.453], [636.154,712.018], [607.062,711.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.22,364.73], [699.848,317.84], [608.441,364.67], [606.646,317.979]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.155,712.044], [607.063,711.564], [637.699,753.822], [608.729,753.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.22,364.73], [702.578,411.16], [608.44,364.67], [610.217,410.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.699,753.822], [608.729,753.288], [639.119,792.243], [610.262,791.661]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.579,411.189], [703.926,457.195], [610.218,410.934], [611.979,456.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[703.927,457.224], [705.26,502.811], [611.98,456.777], [613.724,502.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.261,502.84], [706.583,548.014], [613.725,502.204], [615.454,547.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.584,548.042], [707.894,592.81], [615.455,547.223], [617.169,591.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.895,592.838], [709.193,637.203], [617.17,591.837], [618.868,636.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.194,637.231], [710.481,681.201], [618.869,636.052], [620.552,679.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.482,681.228], [711.757,724.806], [620.553,679.874], [622.221,723.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.758,724.834], [713.022,768.026], [622.222,723.308], [623.875,766.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.022,768.026], [714.184,807.737], [623.875,766.332], [625.395,805.889]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[748.129,317.24], [746.948,269.068], [693.76,317.322], [692.325,269.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.3,364.991], [748.129,317.24], [695.182,364.955], [693.76,317.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.3,364.991], [750.459,412.265], [695.182,364.955], [696.591,412.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.459,412.295], [751.608,459.13], [696.592,412.144], [697.987,458.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.608,459.159], [752.746,505.56], [697.988,458.895], [699.37,505.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.746,505.59], [753.873,551.563], [699.371,505.214], [700.74,551.077]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.874,551.592], [754.991,597.143], [700.741,551.106], [702.098,596.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.992,597.172], [756.098,642.307], [702.099,596.579], [703.444,641.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.099,642.336], [757.195,687.061], [703.444,641.638], [704.777,686.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.196,687.089], [758.282,731.41], [704.778,686.288], [706.098,730.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.283,731.438], [759.36,775.359], [706.099,730.535], [707.407,774.356]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.36,775.359], [707.407,774.356], [760.349,815.734], [708.61,814.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.738,365.208], [801.806,316.739], [745.175,365.17], [743.97,316.828]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.738,365.209], [803.661,413.187], [745.175,365.17], [746.367,413.025]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.661,413.218], [804.575,460.744], [746.368,413.055], [747.55,460.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.576,460.774], [805.482,507.853], [747.55,460.489], [748.721,507.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.482,507.883], [806.379,554.522], [748.721,507.478], [749.881,553.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.38,554.552], [807.269,600.756], [749.881,554.029], [751.03,600.118]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.269,600.786], [808.15,646.562], [751.031,600.148], [752.169,645.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.15,646.591], [809.023,691.946], [752.17,645.84], [753.297,691.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.023,691.975], [809.888,736.912], [753.298,691.112], [754.415,735.941]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.888,736.941], [754.416,735.969], [810.745,781.468], [755.523,780.39]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.745,781.468], [755.523,780.39], [811.532,822.395], [756.54,821.219]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[946.818,320.076], [946.598,276.043], [794.657,320.284], [793.784,276.555]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.738,365.208], [801.806,316.739], [807.107,364.979], [806.21,317.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.738,365.209], [803.661,413.187], [807.107,364.979], [807.995,412.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.661,413.218], [804.576,460.744], [807.996,412.246], [808.875,459.043]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.576,460.774], [805.482,507.853], [808.876,459.073], [809.748,505.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.482,507.883], [806.38,554.522], [809.748,505.467], [810.612,551.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.884,365.045], [906.455,317.116], [807.107,364.979], [806.21,317.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.38,554.552], [807.269,600.756], [810.613,551.434], [811.469,596.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.884,365.045], [907.308,412.494], [807.107,364.979], [807.995,412.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.269,600.786], [808.15,646.562], [811.469,596.979], [812.317,642.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.308,412.524], [907.729,459.53], [807.996,412.246], [808.876,459.043]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.151,646.591], [809.023,691.946], [812.318,642.108], [813.158,686.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.729,459.559], [908.146,506.128], [808.876,459.073], [809.748,505.437]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.023,691.974], [809.888,736.912], [813.159,686.828], [813.991,731.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.146,506.158], [908.559,552.296], [809.749,505.467], [810.612,551.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.559,552.326], [908.968,598.039], [810.613,551.433], [811.469,596.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.888,736.941], [810.745,781.468], [813.992,731.143], [814.817,775.031]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.968,598.068], [909.374,643.362], [811.469,596.979], [812.317,642.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.745,781.468], [811.532,822.396], [814.817,775.031], [815.576,815.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.374,643.391], [909.775,688.272], [812.318,642.108], [813.158,686.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.776,688.3], [910.174,732.774], [813.159,686.828], [813.991,731.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.174,732.802], [910.568,776.873], [813.992,731.143], [814.817,775.031]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.568,776.873], [910.93,817.385], [814.817,775.031], [815.576,815.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.884,365.045], [906.455,317.116], [910.579,364.74], [910.177,317.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.884,365.045], [907.308,412.494], [910.58,364.74], [910.978,411.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.309,412.524], [907.729,459.53], [910.979,411.231], [911.374,457.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.729,459.559], [908.146,506.128], [911.374,457.296], [911.765,502.914]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.146,506.158], [908.559,552.296], [911.766,502.943], [912.154,548.147]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.559,552.326], [908.968,598.039], [912.154,548.176], [912.538,592.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.969,598.068], [909.374,643.362], [912.539,593.001], [912.919,637.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.374,643.391], [909.776,688.272], [912.92,637.423], [913.297,681.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.058,364.76], [942.806,317.77], [910.579,364.74], [910.177,317.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.058,364.761], [943.308,411.29], [910.579,364.74], [910.978,411.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[909.776,688.3], [910.174,732.774], [913.297,681.448], [913.672,725.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.174,732.802], [910.568,776.873], [913.672,725.082], [914.043,768.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.568,776.873], [910.931,817.385], [914.043,768.302], [914.384,808.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.308,411.319], [943.555,457.422], [910.978,411.231], [911.373,457.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.556,457.451], [911.374,457.296], [943.801,503.134], [911.765,502.914]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.801,503.163], [911.765,502.943], [944.044,548.432], [912.153,548.147]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.045,548.46], [912.154,548.176], [944.286,593.32], [912.538,592.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.286,593.348], [912.538,593.001], [944.524,637.804], [912.919,637.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.525,637.832], [912.919,637.423], [944.761,681.89], [913.297,681.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.762,681.918], [913.297,681.448], [944.996,725.584], [913.671,725.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.996,725.612], [913.672,725.082], [945.229,768.889], [914.042,768.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.229,768.889], [914.042,768.302], [945.443,808.678], [914.383,808.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.058,364.76], [942.806,317.77], [945.157,364.547], [944.917,318.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.058,364.761], [943.308,411.29], [945.157,364.547], [945.393,410.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.308,411.319], [943.556,457.422], [945.394,410.414], [945.628,455.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.556,457.451], [943.802,503.134], [945.628,455.866], [945.861,500.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.802,503.163], [944.045,548.432], [945.861,500.911], [946.091,545.525]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.045,548.46], [944.286,593.32], [946.091,545.553], [946.32,589.77]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.286,593.348], [944.525,637.804], [946.32,589.797], [946.546,633.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.525,637.832], [944.762,681.89], [946.547,633.65], [946.771,677.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.762,681.918], [944.997,725.584], [946.771,677.115], [946.993,720.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.997,725.611], [945.229,768.889], [946.994,720.199], [947.214,762.879]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.229,768.889], [945.443,808.678], [947.214,762.879], [947.417,802.124]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1033.19,319.957], [1033.34,275.752], [1204.19,319.723], [1205.09,275.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.72,639.705], [1037.51,639.262], [1071.39,684.04], [1037.33,683.531]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.39,684.068], [1037.33,683.56], [1071.05,728.006], [1037.15,727.433]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.05,728.034], [1037.15,727.461], [1070.72,771.579], [1036.98,770.943]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.72,771.579], [1036.98,770.943], [1070.42,811.612], [1036.81,810.918]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.79,364.856], [1038.63,364.834], [1073.44,411.695], [1038.44,411.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.44,411.725], [1038.44,411.629], [1073.09,458.132], [1038.25,457.964]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.09,458.161], [1038.25,457.993], [1072.74,504.143], [1038.06,503.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.74,504.172], [1038.06,503.933], [1072.4,549.733], [1037.88,549.425]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.4,549.762], [1037.88,549.454], [1072.06,594.909], [1037.69,594.533]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.06,594.938], [1037.69,594.562], [1071.72,639.677], [1037.51,639.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.79,364.856], [1074.15,317.55], [1038.63,364.834], [1038.82,317.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.79,736.212], [1166.96,737.874], [1070.45,780.659], [1166.18,782.504]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.45,780.659], [1166.18,782.504], [1070.14,821.513], [1165.47,823.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.81,600.307], [1169.33,601.398], [1071.46,645.999], [1168.54,647.284]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.46,646.027], [1168.54,647.312], [1071.12,691.298], [1167.74,692.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.12,691.327], [1167.74,692.802], [1070.79,736.183], [1166.96,737.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.51,507.579], [1170.95,508.272], [1072.16,554.13], [1170.14,555.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.16,554.159], [1170.14,555.053], [1071.81,600.278], [1169.33,601.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.58,365.179], [1073.22,413.065], [1173.44,365.245], [1172.6,413.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.22,413.095], [1172.6,413.374], [1072.86,460.53], [1171.77,461.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.86,460.56], [1171.77,461.047], [1072.51,507.549], [1170.95,508.242]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.58,365.179], [1073.94,316.806], [1173.44,365.245], [1174.28,316.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.15,743.392], [1225.31,744.393], [1167.36,788.629], [1224.25,789.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.36,788.629], [1224.25,789.741], [1166.63,830.202], [1223.28,831.414]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.95,697.701], [1226.39,698.591], [1168.15,743.363], [1225.32,744.364]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.76,651.58], [1227.47,652.355], [1168.95,697.672], [1226.39,698.561]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.57,605.023], [1228.56,605.681], [1169.76,651.551], [1227.47,652.326]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.4,558.023], [1229.66,558.562], [1170.57,604.993], [1228.56,605.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.07,462.668], [1172.23,510.543], [1231.9,462.962], [1230.77,510.961]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.23,510.573], [1230.77,510.991], [1171.4,557.993], [1229.66,558.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.92,414.3], [1173.07,462.637], [1233.03,414.469], [1231.9,462.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.77,365.464], [1173.92,414.269], [1234.18,365.504], [1233.03,414.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.77,365.464], [1175.64,316.151], [1234.18,365.503], [1235.33,316.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.66,785.104], [1280.13,786.157], [1224.69,826.359], [1278.92,827.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.71,740.216], [1281.44,741.165], [1225.66,785.104], [1280.13,786.157]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.78,694.882], [1282.76,695.724], [1226.71,740.187], [1281.44,741.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.85,649.124], [1284.1,649.858], [1227.78,694.853], [1282.76,695.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.94,602.937], [1285.45,603.56], [1228.86,649.095], [1284.1,649.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.04,556.313], [1286.81,556.824], [1229.94,602.907], [1285.45,603.53]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.14,509.249], [1231.04,556.284], [1288.18,509.644], [1286.81,556.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.26,461.735], [1232.15,509.218], [1289.57,462.014], [1288.19,509.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.39,413.767], [1233.26,461.705], [1290.97,413.927], [1289.57,461.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.53,365.338], [1234.39,413.736], [1292.39,365.376], [1290.97,413.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.53,365.338], [1236.68,316.441], [1292.39,365.376], [1293.82,316.354]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1236.68,316.441], [1237.84,267.101], [1293.82,316.355], [1295.26,266.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.96,779.135], [1275.78,819.851], [1371.78,780.939], [1370.21,821.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.23,734.839], [1276.96,779.135], [1373.5,736.464], [1371.78,780.939]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.45,603.56], [1284.1,649.829], [1282.13,599.405], [1280.82,644.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.52,690.108], [1278.23,734.811], [1375.23,691.551], [1373.5,736.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.82,644.966], [1279.52,690.08], [1376.98,646.222], [1375.23,691.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.13,599.405], [1280.82,644.937], [1378.74,600.472], [1376.98,646.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.18,509.644], [1286.81,556.794], [1284.79,507.007], [1283.46,553.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.46,553.421], [1282.13,599.376], [1380.53,554.295], [1378.75,600.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.79,507.007], [1283.46,553.392], [1382.32,507.684], [1380.53,554.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.14,460.157], [1284.79,506.977], [1384.14,460.634], [1382.32,507.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.5,412.865], [1286.14,460.127], [1385.97,413.138], [1384.14,460.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.88,365.125], [1287.5,412.835], [1387.82,365.19], [1385.97,413.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.88,365.125], [1290.26,316.93], [1387.82,365.189], [1389.69,316.782]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1290.26,316.931], [1291.66,268.306], [1389.69,316.783], [1391.57,267.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1362.74,767.438], [1393.97,768.014], [1361.25,807.095], [1392.35,807.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1364.36,724.304], [1395.73,724.822], [1362.74,767.438], [1393.97,768.014]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366,680.758], [1397.51,681.218], [1364.36,724.277], [1395.73,724.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.65,636.822], [1399.3,637.222], [1366,680.73], [1397.51,681.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.31,592.49], [1401.11,592.83], [1367.65,636.794], [1399.3,637.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371,547.758], [1402.94,548.036], [1369.32,592.462], [1401.12,592.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.69,502.619], [1371,547.729], [1404.79,502.835], [1402.94,548.008]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1374.4,457.068], [1372.69,502.59], [1406.65,457.22], [1404.79,502.806]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1376.13,411.1], [1374.4,457.039], [1408.53,411.187], [1406.65,457.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.87,364.709], [1376.13,411.071], [1410.42,364.729], [1408.53,411.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.87,364.709], [1379.63,317.888], [1410.42,364.729], [1412.33,317.841]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1379.63,317.888], [1381.41,270.663], [1412.33,317.841], [1414.26,270.547]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[629.759,320.048], [628.145,275.6], [601.233,320.141], [599.5,275.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.359,364.138], [629.759,320.049], [602.952,364.093], [601.233,320.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.359,364.138], [632.945,407.818], [602.953,364.093], [604.656,407.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.946,407.845], [634.518,451.148], [604.657,407.665], [606.346,450.835]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.519,451.175], [636.077,494.106], [606.347,450.862], [608.021,493.661]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.078,494.133], [637.623,536.696], [608.022,493.688], [609.682,536.123]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[637.624,536.723], [639.156,578.924], [609.683,536.15], [611.328,578.224]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[700.258,318.821], [698.899,272.521], [611.916,319.118], [610.171,273.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[639.157,578.95], [640.676,620.793], [611.33,578.251], [612.961,619.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.604,364.73], [700.258,318.821], [613.647,364.587], [611.917,319.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.604,364.73], [702.938,410.197], [613.647,364.587], [615.36,409.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[640.677,620.819], [642.183,662.309], [612.962,619.995], [614.581,661.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.184,662.335], [643.677,703.475], [614.582,661.388], [616.186,702.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.939,410.226], [704.261,455.284], [615.362,409.649], [617.06,454.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.678,703.501], [645.159,744.296], [616.187,702.434], [617.778,743.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.262,455.313], [705.572,499.968], [617.061,454.31], [618.745,498.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.159,744.296], [646.521,781.821], [617.778,743.112], [619.242,780.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.573,499.996], [706.871,544.254], [618.746,498.576], [620.415,542.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.872,544.282], [708.159,588.148], [620.416,542.451], [622.07,585.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.159,588.176], [709.435,631.654], [622.071,585.941], [623.711,629.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.436,631.682], [710.7,674.778], [623.712,629.05], [625.337,671.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.701,674.805], [711.954,717.525], [625.338,671.785], [626.949,714.122]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.955,717.552], [713.197,759.9], [626.95,714.149], [628.548,756.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.197,759.9], [714.34,798.839], [628.548,756.121], [630.017,794.719]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[744.497,318.167], [743.316,270.88], [692.572,318.344], [691.157,271.326]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.667,365.046], [744.497,318.167], [693.975,364.96], [692.572,318.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.667,365.046], [746.826,411.464], [693.975,364.96], [695.364,411.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.827,411.493], [747.975,457.486], [695.365,411.149], [696.741,456.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.976,457.515], [749.114,503.087], [696.742,456.916], [698.106,502.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.115,503.116], [750.242,548.275], [698.107,502.268], [699.458,547.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.243,548.303], [751.36,593.053], [699.459,547.211], [700.799,591.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.361,593.082], [752.468,637.429], [700.8,591.748], [702.127,635.859]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.469,637.457], [753.566,681.406], [702.128,635.887], [703.444,679.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.567,681.434], [754.654,724.991], [703.444,679.633], [704.748,722.962]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.655,725.019], [755.733,768.189], [704.749,722.99], [706.042,765.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.733,768.189], [756.724,807.879], [706.042,765.937], [707.23,805.423]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.52,365.322], [794.565,317.593], [740.216,365.23], [739.006,317.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.52,365.323], [796.466,412.575], [740.216,365.23], [741.415,412.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.467,412.605], [797.404,459.416], [741.416,412.232], [742.603,458.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.405,459.446], [798.334,505.822], [742.603,458.798], [743.779,504.904]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.334,505.852], [799.254,551.799], [743.78,504.933], [744.945,550.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.255,551.828], [800.167,597.353], [744.946,550.645], [746.101,595.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.167,597.382], [801.07,642.489], [746.102,595.938], [747.246,640.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.071,642.518], [801.966,687.214], [747.246,640.819], [748.38,685.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.967,687.242], [802.853,731.532], [748.381,685.293], [749.504,729.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.854,731.56], [803.733,775.45], [749.505,729.365], [750.619,773.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.733,775.45], [804.541,815.795], [750.619,773.013], [751.642,813.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.52,365.322], [794.565,317.593], [801.66,365.086], [800.748,318.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.52,365.323], [796.467,412.575], [801.66,365.086], [802.564,411.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.467,412.605], [797.405,459.416], [802.564,411.654], [803.46,457.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.405,459.446], [798.334,505.822], [803.46,457.794], [804.347,503.482]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.335,505.852], [799.255,551.799], [804.348,503.511], [805.227,548.783]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[948.654,320.502], [948.444,276.736], [800.476,320.961], [799.639,277.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.255,551.828], [800.167,597.353], [805.227,548.812], [806.098,593.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.167,597.382], [801.071,642.489], [806.099,593.702], [806.962,638.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.491,365.246], [898.025,317.752], [801.66,365.086], [800.748,318.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.491,365.246], [898.953,412.267], [801.66,365.086], [802.564,411.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.071,642.518], [801.966,687.214], [806.963,638.187], [807.818,682.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.953,412.297], [899.41,458.881], [802.564,411.654], [803.46,457.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.967,687.242], [802.854,731.532], [807.818,682.272], [808.666,725.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.411,458.911], [899.863,505.064], [803.46,457.793], [804.347,503.482]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.854,731.56], [803.733,775.45], [808.667,725.963], [809.507,769.237]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.864,505.094], [900.312,550.823], [804.348,503.511], [805.227,548.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.733,775.45], [804.541,815.795], [809.507,769.237], [810.279,809.022]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.313,550.852], [900.757,596.161], [805.227,548.812], [806.098,593.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.758,596.19], [901.198,641.087], [806.099,593.702], [806.962,638.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.198,641.115], [901.635,685.605], [806.963,638.187], [807.818,682.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.635,685.633], [902.068,729.72], [807.818,682.272], [808.666,725.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.068,729.748], [902.497,773.438], [808.667,725.963], [809.507,769.237]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.497,773.438], [902.891,813.602], [809.507,769.237], [810.279,809.022]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.491,365.246], [898.025,317.752], [904.683,364.927], [904.255,318.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.491,365.246], [898.953,412.267], [904.683,364.927], [905.107,410.987]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.953,412.297], [899.41,458.881], [905.107,411.016], [905.527,456.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.411,458.911], [899.864,505.064], [905.527,456.685], [905.943,501.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.864,505.094], [900.312,550.823], [905.943,501.941], [906.355,546.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.313,550.852], [900.757,596.161], [906.356,546.788], [906.764,591.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[900.758,596.19], [901.198,641.087], [906.765,591.233], [907.169,635.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.198,641.115], [901.635,685.605], [907.17,635.281], [907.571,678.909]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.635,685.633], [902.068,729.72], [907.571,678.937], [907.969,722.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.068,729.748], [902.497,773.438], [907.969,722.206], [908.364,765.066]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.497,773.438], [902.891,813.602], [908.364,765.066], [908.726,804.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.476,364.978], [936.194,318.306], [904.683,364.927], [904.255,318.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.476,364.979], [936.755,411.193], [904.683,364.927], [905.106,410.987]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.755,411.222], [937.032,457.015], [905.107,411.016], [905.527,456.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.033,457.044], [937.307,502.421], [905.527,456.685], [905.943,501.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.307,502.449], [937.579,547.415], [905.943,501.941], [906.355,546.76]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.579,547.444], [906.355,546.788], [937.848,592.005], [906.764,591.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.849,592.033], [906.764,591.233], [938.116,636.194], [907.169,635.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.116,636.222], [907.17,635.281], [938.38,679.99], [907.571,678.909]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.38,680.017], [907.571,678.937], [938.643,723.396], [907.969,722.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.643,723.423], [907.969,722.206], [938.903,766.418], [908.363,765.066]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.903,766.418], [908.363,765.066], [939.142,805.947], [908.726,804.473]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.476,364.978], [936.194,318.306], [940.348,364.754], [940.088,318.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.476,364.978], [936.756,411.193], [940.348,364.754], [940.606,410.292]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[936.756,411.222], [937.033,457.015], [940.606,410.321], [940.862,455.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.033,457.044], [937.307,502.421], [940.862,455.478], [941.115,500.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.307,502.449], [937.579,547.415], [941.115,500.231], [941.366,544.556]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.579,547.444], [937.849,592.005], [941.366,544.584], [941.615,588.516]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.849,592.033], [938.116,636.194], [941.615,588.544], [941.862,632.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.116,636.222], [938.381,679.99], [941.862,632.115], [942.106,675.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.381,680.017], [938.643,723.396], [942.106,675.303], [942.348,718.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.643,723.423], [938.903,766.418], [942.349,718.113], [942.589,760.523]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.903,766.418], [939.142,805.947], [942.589,760.523], [942.81,799.519]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.44,684.667], [1029.6,683.479], [1063.14,728.632], [1029.45,727.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.14,728.66], [1029.45,727.322], [1062.85,772.231], [1029.31,770.745]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1062.85,772.231], [1029.31,770.745], [1062.58,812.285], [1029.18,810.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.6,365.2], [1065.28,412.082], [1030.65,365.143], [1030.49,411.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.28,412.112], [1064.97,458.56], [1030.49,411.884], [1030.34,458.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.97,458.589], [1030.34,458.194], [1064.66,504.609], [1030.19,504.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.66,504.639], [1030.19,504.079], [1064.35,550.236], [1030.04,549.515]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.35,550.265], [1030.04,549.544], [1064.04,595.446], [1029.89,594.567]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.04,595.475], [1029.89,594.595], [1063.74,640.245], [1029.74,639.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.74,640.273], [1029.74,639.238], [1063.44,684.639], [1029.6,683.451]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.6,365.2], [1065.92,317.847], [1030.65,365.143], [1030.8,317.965]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1205.46,319.705], [1206.38,274.738], [1033.96,320.237], [1034.12,276.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.24,695.367], [1060.51,691.896], [1156.5,740.68], [1060.22,736.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.5,740.709], [1060.22,736.801], [1155.76,785.603], [1059.93,781.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.76,785.604], [1059.93,781.267], [1155.08,826.863], [1059.66,822.136]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.28,509.681], [1061.69,508.045], [1159.51,556.733], [1061.39,554.625]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1159.51,556.762], [1061.39,554.654], [1158.75,603.37], [1061.1,600.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1158.74,603.399], [1061.09,600.828], [1157.99,649.57], [1060.8,646.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.99,649.599], [1060.8,646.574], [1157.24,695.338], [1060.51,691.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.64,365.71], [1161.85,414.131], [1062.62,365.544], [1062.31,413.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.85,414.162], [1161.06,462.12], [1062.31,413.496], [1062,460.964]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.06,462.15], [1160.28,509.651], [1062,460.994], [1061.69,508.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.64,365.71], [1163.44,316.789], [1062.62,365.544], [1062.93,317.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.63,748.642], [1155.89,746.265], [1212.61,794.406], [1155.14,791.768]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.61,794.406], [1155.14,791.768], [1211.67,836.457], [1154.46,833.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.66,702.413], [1156.64,700.302], [1213.63,748.613], [1155.89,746.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.7,655.742], [1157.39,653.901], [1214.66,702.384], [1156.64,700.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1217.81,561.044], [1158.93,559.761], [1216.75,608.591], [1158.16,607.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.75,608.621], [1158.16,607.056], [1215.7,655.712], [1157.39,653.871]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.88,513.005], [1159.71,512.009], [1217.81,561.014], [1158.93,559.731]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1219.96,464.498], [1160.5,463.794], [1218.88,512.975], [1159.71,511.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1222.16,366.047], [1162.1,365.946], [1221.06,415.482], [1161.29,415.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1221.06,415.514], [1161.29,415.108], [1219.96,464.466], [1160.5,463.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1222.16,366.047], [1162.1,365.946], [1223.27,316.09], [1162.91,316.299]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.42,789.784], [1270.83,792.3], [1214.48,831.42], [1269.64,834.162]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1216.44,744.477], [1272.12,746.744], [1215.42,789.784], [1270.83,792.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1217.47,698.713], [1273.42,700.727], [1216.44,744.448], [1272.12,746.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.51,652.516], [1274.73,654.272], [1217.47,698.684], [1273.42,700.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.57,605.879], [1276.06,607.371], [1218.51,652.486], [1274.74,654.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.63,558.795], [1277.4,560.019], [1219.57,605.849], [1276.06,607.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.7,511.26], [1278.76,512.21], [1220.63,558.765], [1277.4,559.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.79,463.264], [1280.12,463.936], [1221.7,511.229], [1278.76,512.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.88,414.804], [1281.5,415.19], [1222.79,463.234], [1280.12,463.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.98,365.87], [1223.88,414.773], [1282.9,365.966], [1281.5,415.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.98,365.87], [1226.1,316.456], [1282.9,365.966], [1284.3,316.257]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1226.1,316.457], [1227.22,266.589], [1284.3,316.257], [1285.72,266.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1269.67,785.136], [1367,789.484], [1268.51,826.353], [1365.41,831.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.93,740.287], [1368.74,744.206], [1269.67,785.136], [1367,789.484]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.21,694.992], [1370.49,698.473], [1270.94,740.259], [1368.74,744.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1273.5,649.272], [1372.25,652.306], [1272.21,694.964], [1370.49,698.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1274.8,603.122], [1374.03,605.701], [1273.5,649.243], [1372.25,652.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.11,556.535], [1274.8,603.093], [1375.83,558.649], [1374.04,605.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.44,509.505], [1276.11,556.505], [1377.65,511.146], [1375.84,558.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.77,462.025], [1277.44,509.475], [1379.49,463.184], [1377.65,511.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.12,414.09], [1278.77,461.995], [1381.34,414.757], [1379.49,463.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.49,365.692], [1280.12,414.059], [1383.21,365.859], [1381.34,414.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.49,365.692], [1282.86,316.825], [1383.21,365.858], [1385.1,316.48]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1282.86,316.826], [1284.25,267.514], [1385.1,316.481], [1387.01,266.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.69,775.556], [1393.98,776.953], [1360.17,815.91], [1392.32,817.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.35,731.655], [1395.78,732.914], [1361.69,775.556], [1393.98,776.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365.02,687.326], [1397.61,688.444], [1363.35,731.627], [1395.78,732.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.7,642.591], [1399.45,643.566], [1365.02,687.298], [1397.61,688.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.4,597.444], [1401.3,598.272], [1366.7,642.563], [1399.45,643.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.12,551.88], [1403.18,552.558], [1368.4,597.416], [1401.3,598.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.85,505.891], [1405.07,506.418], [1370.12,551.85], [1403.18,552.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.6,459.474], [1371.85,505.862], [1406.98,459.846], [1405.07,506.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.34,414.757], [1379.49,463.154], [1375.36,412.621], [1373.6,459.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.36,412.621], [1373.6,459.444], [1408.91,412.835], [1406.98,459.816]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.14,365.327], [1375.36,412.591], [1410.85,365.38], [1408.91,412.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.14,365.327], [1378.94,317.584], [1410.85,365.38], [1412.82,317.473]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1378.94,317.584], [1380.75,269.418], [1412.82,317.473], [1414.8,269.141]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[640.899,320.981], [639.356,277.742], [614.215,321.105], [612.565,278.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.43,363.877], [640.899,320.982], [615.853,363.797], [614.215,321.106]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[642.43,363.877], [643.947,406.378], [615.853,363.797], [617.476,406.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.948,406.405], [645.452,448.544], [617.477,406.125], [619.086,448.068]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[703.558,319.801], [702.228,274.592], [620.613,320.2], [618.934,275.657]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.453,448.571], [646.944,490.353], [619.087,448.094], [620.682,489.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.877,364.633], [703.558,319.801], [622.28,364.378], [620.614,320.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.945,490.379], [648.424,531.809], [620.683,489.709], [622.265,530.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.876,364.633], [706.182,409.036], [622.28,364.378], [623.93,408.139]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.425,531.835], [649.891,572.916], [622.266,530.975], [623.835,571.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.892,572.942], [651.345,613.679], [623.836,571.895], [625.391,612.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.183,409.064], [707.478,453.072], [623.931,408.166], [625.567,451.544]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.479,453.1], [708.762,496.719], [625.568,451.571], [627.19,494.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.346,613.705], [652.788,654.103], [625.392,612.474], [626.935,652.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.762,496.746], [710.034,539.98], [627.191,494.597], [628.799,537.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[652.789,654.128], [654.219,694.19], [626.936,652.716], [628.466,692.601]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.035,540.008], [711.295,582.862], [628.8,537.249], [630.394,579.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[654.22,694.216], [655.638,733.947], [628.467,692.626], [629.984,732.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.296,582.889], [712.546,625.369], [630.395,579.532], [631.975,621.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[655.638,733.947], [656.942,770.496], [629.984,732.183], [631.38,768.573]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.546,625.396], [713.785,667.506], [631.976,621.451], [633.542,662.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.786,667.533], [715.014,709.279], [633.543,663.01], [635.096,704.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.015,709.305], [716.232,750.69], [635.097,704.214], [636.637,745.042]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.232,750.691], [717.351,788.749], [636.637,745.042], [638.053,782.592]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[743.546,319.158], [742.37,272.875], [694.467,319.398], [693.076,273.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.712,365.045], [743.546,319.158], [695.847,364.891], [694.467,319.398]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.712,365.045], [745.867,410.484], [695.847,364.892], [697.213,409.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.868,410.513], [747.012,455.538], [697.214,409.973], [698.568,454.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.012,455.566], [748.146,500.184], [698.568,454.647], [699.91,498.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.147,500.212], [749.27,544.427], [699.911,498.921], [701.24,542.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.271,544.455], [750.384,588.273], [701.241,542.798], [702.559,586.257]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.385,588.301], [751.488,631.727], [702.56,586.284], [703.866,629.358]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.489,631.754], [752.583,674.794], [703.867,629.385], [705.161,672.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.583,674.821], [753.667,717.48], [705.162,672.106], [706.445,714.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.668,717.507], [754.743,759.789], [706.446,714.451], [707.718,756.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.743,759.789], [755.73,798.665], [707.718,756.4], [708.888,794.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.626,365.42], [789.652,318.572], [738.078,365.253], [736.867,318.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.626,365.421], [791.59,411.802], [738.078,365.253], [739.276,411.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.591,411.831], [792.546,457.782], [739.277,411.243], [740.465,456.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.547,457.811], [793.494,503.336], [740.465,456.81], [741.642,501.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.494,503.365], [794.432,548.472], [741.643,501.96], [742.809,546.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.433,548.501], [795.362,593.194], [742.809,546.697], [743.965,591]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.363,593.222], [796.284,637.508], [743.965,591.028], [745.11,634.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.284,637.536], [797.197,681.42], [745.111,634.959], [746.245,678.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.197,681.448], [798.102,724.934], [746.246,678.494], [747.371,721.612]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.102,724.962], [798.998,768.058], [747.371,721.639], [748.486,764.373]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.998,768.058], [799.822,807.675], [748.486,764.373], [749.51,803.659]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.626,365.42], [789.652,318.572], [798.378,365.151], [797.454,318.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.626,365.42], [791.59,411.802], [798.377,365.151], [799.292,410.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.591,411.831], [792.546,457.782], [799.293,410.884], [800.199,456.17]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.547,457.811], [793.494,503.336], [800.2,456.199], [801.098,501.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.494,503.365], [794.432,548.472], [801.098,501.1], [801.988,545.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.433,548.501], [795.362,593.194], [801.989,545.594], [802.871,589.659]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.363,593.222], [796.284,637.508], [802.871,589.687], [803.745,633.355]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.284,637.536], [797.197,681.42], [803.746,633.383], [804.612,676.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.306,365.442], [890.805,318.539], [798.378,365.151], [797.454,318.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.197,681.447], [798.102,724.934], [804.613,676.688], [805.471,719.58]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.306,365.442], [891.801,411.877], [798.378,365.151], [799.292,410.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.102,724.962], [798.998,768.058], [805.472,719.607], [806.323,762.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.801,411.907], [892.292,457.91], [799.293,410.884], [800.199,456.17]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.998,768.058], [799.822,807.675], [806.323,762.119], [807.105,801.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.293,457.94], [892.779,503.517], [800.2,456.198], [801.098,501.071]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.779,503.546], [893.261,548.704], [801.099,501.1], [801.988,545.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.262,548.733], [893.739,593.476], [801.989,545.594], [802.871,589.659]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.739,593.505], [894.212,637.84], [802.871,589.687], [803.745,633.355]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.213,637.868], [894.681,681.8], [803.746,633.383], [804.612,676.66]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.682,681.828], [895.146,725.362], [804.613,676.688], [805.471,719.58]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.147,725.39], [895.607,768.533], [805.472,719.607], [806.323,762.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.607,768.533], [896.03,808.192], [806.323,762.119], [807.105,801.203]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[950.92,320.89], [950.718,277.499], [807.908,321.523], [807.105,279.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.306,365.442], [890.805,318.539], [899.847,365.074], [899.396,319.112]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.306,365.442], [891.801,411.877], [899.848,365.075], [900.294,410.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.802,411.907], [892.292,457.91], [900.295,410.615], [900.737,455.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.293,457.94], [892.779,503.517], [900.737,455.741], [901.176,500.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.78,503.546], [893.261,548.704], [901.176,500.458], [901.611,544.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.262,548.733], [893.739,593.476], [901.611,544.77], [902.042,588.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.74,593.505], [894.213,637.84], [902.042,588.684], [902.469,632.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.213,637.868], [894.682,681.8], [902.469,632.205], [902.892,675.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.682,681.828], [895.147,725.362], [902.892,675.338], [903.311,718.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.147,725.39], [895.607,768.533], [903.312,718.088], [903.727,760.433]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.607,768.533], [896.031,808.192], [903.727,760.433], [904.109,799.367]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.63,365.169], [930.319,318.965], [899.847,365.074], [899.396,319.112]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.629,365.169], [930.937,410.918], [899.847,365.075], [900.294,410.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.937,410.947], [931.241,456.277], [900.294,410.615], [900.737,455.713]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.242,456.306], [931.543,501.222], [900.737,455.741], [901.176,500.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.543,501.251], [931.842,545.759], [901.176,500.458], [901.61,544.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.843,545.788], [932.139,589.894], [901.611,544.77], [902.041,588.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.139,589.922], [932.433,633.632], [902.042,588.684], [902.468,632.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.433,633.659], [902.469,632.205], [932.724,676.977], [902.892,675.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.724,677.005], [902.892,675.338], [933.012,719.936], [903.311,718.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.013,719.964], [903.311,718.088], [933.298,762.514], [903.727,760.433]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.298,762.514], [903.727,760.433], [933.561,801.634], [904.109,799.367]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.63,365.169], [930.319,318.965], [936.192,364.909], [935.912,319.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.63,365.169], [930.937,410.918], [936.192,364.909], [936.47,410.006]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.937,410.947], [931.242,456.277], [936.47,410.034], [936.745,454.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.242,456.306], [931.544,501.222], [936.745,454.752], [937.018,499.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.544,501.251], [931.843,545.759], [937.018,499.067], [937.289,542.959]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.843,545.788], [932.139,589.894], [937.289,542.986], [937.557,586.486]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.139,589.922], [932.433,633.632], [937.557,586.514], [937.822,629.628]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.433,633.659], [932.724,676.977], [937.822,629.655], [938.086,672.388]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[932.724,677.004], [933.013,719.936], [938.086,672.415], [938.346,714.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.013,719.963], [933.299,762.514], [938.347,714.799], [938.605,756.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[933.299,762.514], [933.562,801.634], [938.605,756.786], [938.843,795.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.83,684.094], [1021.58,682.235], [1054.56,727.912], [1021.47,725.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.56,727.94], [1021.47,725.848], [1054.31,771.36], [1021.36,769.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.31,771.36], [1021.36,769.041], [1054.07,811.273], [1021.26,808.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.72,365.57], [1057.01,318.338], [1022.38,365.465], [1022.49,318.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.72,365.57], [1056.44,412.328], [1022.38,365.465], [1022.26,411.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.44,412.358], [1056.17,458.678], [1022.26,411.988], [1022.14,458.048]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.17,458.708], [1055.9,504.596], [1022.14,458.078], [1022.03,503.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.9,504.625], [1055.62,550.088], [1022.03,503.74], [1021.92,548.953]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.62,550.117], [1021.92,548.981], [1055.36,595.16], [1021.8,593.779]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.36,595.189], [1021.8,593.807], [1055.09,639.818], [1021.69,638.195]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.09,639.846], [1021.69,638.223], [1054.83,684.066], [1021.58,682.207]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1204.71,319.768], [1205.65,274.504], [1034.37,320.521], [1034.54,276.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.6,650.847], [1144.9,696.67], [1049.49,646.074], [1049.25,691.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.9,696.699], [1144.2,742.088], [1049.25,691.231], [1049.01,735.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.2,742.117], [1143.51,787.079], [1049.01,735.967], [1048.77,780.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.51,787.079], [1142.88,828.396], [1048.77,780.262], [1048.55,820.97]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.48,462.984], [1147.75,510.602], [1050.49,461.128], [1050.24,507.995]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.75,510.632], [1147.03,557.791], [1050.24,508.025], [1049.99,554.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.03,557.82], [1146.31,604.527], [1049.99,554.478], [1049.74,600.463]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.31,604.557], [1145.6,650.818], [1049.74,600.492], [1049.49,646.046]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.97,366.286], [1150.72,317.221], [1051,365.975], [1051.26,317.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.97,366.286], [1149.22,414.84], [1051,365.975], [1050.74,413.75]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.22,414.871], [1148.49,462.954], [1050.74,413.78], [1050.49,461.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.35,751.427], [1141.77,747.654], [1198.38,797.399], [1141.08,793.217]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.38,797.399], [1141.08,793.217], [1197.49,839.635], [1140.45,835.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.33,704.979], [1142.46,701.623], [1199.35,751.398], [1141.77,747.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.32,610.714], [1143.87,608.218], [1201.32,658.047], [1143.16,655.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.32,658.077], [1143.16,655.146], [1200.33,704.949], [1142.46,701.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.33,562.885], [1144.58,560.832], [1202.32,610.684], [1143.87,608.188]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.38,465.798], [1204.35,514.551], [1146.04,464.657], [1145.31,512.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.35,514.582], [1145.31,512.98], [1203.33,562.855], [1144.59,560.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.42,416.525], [1205.38,465.766], [1146.77,415.854], [1146.04,464.626]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.47,366.757], [1206.42,416.493], [1147.52,366.566], [1146.77,415.823]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.47,366.756], [1208.54,316.485], [1147.52,366.565], [1148.27,316.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.25,796.864], [1202.6,792.846], [1257.09,839.052], [1201.69,834.676]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.51,750.944], [1203.58,747.319], [1258.25,796.864], [1202.6,792.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.78,704.549], [1204.57,701.325], [1259.51,750.915], [1203.58,747.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.06,657.702], [1205.57,654.886], [1260.78,704.52], [1204.57,701.295]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.36,610.395], [1206.58,607.997], [1262.07,657.672], [1205.57,654.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.67,562.622], [1207.6,560.65], [1263.36,610.365], [1206.58,607.967]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.99,514.377], [1208.63,512.838], [1264.67,562.592], [1207.6,560.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.33,465.652], [1209.67,464.556], [1265.99,514.346], [1208.63,512.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.68,416.439], [1210.72,415.795], [1267.33,465.62], [1209.67,464.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.04,366.732], [1268.68,416.407], [1211.78,366.549], [1210.72,415.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.04,366.732], [1271.42,316.523], [1211.78,366.549], [1212.86,316.81]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1271.42,316.523], [1272.81,265.837], [1212.86,316.81], [1213.94,266.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.25,796.864], [1257.09,839.052], [1259.21,789.632], [1258.07,831.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.51,750.944], [1258.25,796.864], [1260.46,744.42], [1259.21,789.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.21,789.632], [1357.9,796.642], [1258.07,831.176], [1356.3,838.81]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.46,744.42], [1359.64,750.744], [1259.21,789.632], [1357.9,796.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.78,704.549], [1259.51,750.915], [1261.71,698.747], [1260.46,744.391]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.06,657.702], [1260.78,704.52], [1262.98,652.635], [1261.71,698.717]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.71,698.746], [1361.4,704.371], [1260.46,744.391], [1359.64,750.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.36,610.395], [1262.07,657.672], [1264.26,606.079], [1262.98,652.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.98,652.635], [1363.17,657.546], [1261.71,698.717], [1361.4,704.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.26,606.079], [1364.96,610.262], [1262.98,652.606], [1363.17,657.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.67,562.622], [1263.36,610.365], [1265.55,559.073], [1264.26,606.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.55,559.073], [1366.77,562.513], [1264.26,606.05], [1364.96,610.232]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.99,514.377], [1264.67,562.592], [1266.86,511.608], [1265.55,559.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.33,465.651], [1265.99,514.346], [1268.17,463.68], [1266.86,511.578]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.86,511.608], [1368.6,514.292], [1265.55,559.043], [1366.77,562.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.17,463.68], [1370.44,465.591], [1266.86,511.578], [1368.6,514.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.68,416.439], [1267.33,465.62], [1269.5,415.28], [1268.18,463.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1269.51,415.28], [1372.31,416.403], [1268.18,463.649], [1370.44,465.56]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.04,366.732], [1268.68,416.408], [1270.85,366.402], [1269.51,415.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.04,366.732], [1271.42,316.523], [1270.85,366.402], [1272.21,317.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.85,366.402], [1374.19,366.722], [1269.51,415.249], [1372.31,416.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.85,366.402], [1272.21,317.039], [1374.19,366.722], [1376.09,316.539]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1271.42,316.523], [1272.81,265.837], [1272.21,317.039], [1273.58,267.215]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1272.21,317.039], [1376.09,316.539], [1273.58,267.215], [1378.01,265.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1356.64,782.417], [1389.64,784.687], [1355.1,823.317], [1387.95,825.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.32,737.911], [1391.48,739.959], [1356.64,782.417], [1389.64,784.687]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.01,692.959], [1393.34,694.78], [1358.32,737.883], [1391.48,739.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.72,647.583], [1395.22,649.172], [1360.02,692.93], [1393.34,694.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.45,601.776], [1397.12,603.13], [1361.73,647.554], [1395.22,649.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365.19,555.534], [1399.03,556.647], [1363.45,601.747], [1397.12,603.101]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1366.95,508.849], [1400.96,509.717], [1365.2,555.505], [1399.03,556.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.73,461.714], [1402.91,462.333], [1366.96,508.819], [1400.96,509.687]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.53,414.125], [1404.88,414.488], [1368.73,461.685], [1402.91,462.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.34,366.073], [1370.53,414.095], [1406.87,366.177], [1404.88,414.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1372.34,366.073], [1374.17,317.552], [1406.87,366.177], [1408.88,317.391]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1374.17,317.552], [1408.88,317.391], [1376.01,268.587], [1410.91,268.156]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1376.09,316.539], [1378.01,265.879], [1374.17,317.553], [1376.01,268.587]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1399.03,556.647], [1397.12,603.101], [1395.72,548.068], [1393.9,592.668]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[654.541,321.68], [653.067,279.671], [629.77,321.811], [628.199,280.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.003,363.357], [654.541,321.68], [631.328,363.229], [629.77,321.812]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[709.393,320.658], [708.095,276.598], [632.195,321.082], [630.581,277.872]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.003,363.357], [657.452,404.655], [631.328,363.229], [632.872,404.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.681,364.352], [709.393,320.658], [633.797,363.94], [632.196,321.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[657.453,404.68], [658.889,445.629], [632.872,404.297], [634.403,444.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.681,364.352], [711.956,407.63], [633.797,363.94], [635.383,406.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.89,445.654], [660.314,486.258], [634.404,445.02], [635.922,485.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.957,407.657], [713.221,450.552], [635.384,406.423], [636.957,448.511]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.315,486.283], [661.728,526.546], [635.923,485.403], [637.429,525.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.222,450.579], [714.475,493.095], [636.958,448.538], [638.517,490.261]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.729,526.571], [663.129,566.498], [637.43,525.448], [638.923,565.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.475,493.122], [715.717,535.264], [638.518,490.288], [640.064,531.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.13,566.523], [664.519,606.118], [638.924,565.162], [640.404,604.522]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.718,535.291], [716.949,577.065], [640.065,531.678], [641.597,572.687]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[664.52,606.143], [665.898,645.409], [640.405,604.547], [641.874,643.583]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.95,577.091], [718.17,618.501], [641.598,572.712], [643.117,613.371]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.899,645.434], [667.265,684.377], [641.875,643.608], [643.331,682.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.171,618.528], [719.38,659.579], [643.118,613.397], [644.624,653.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[667.266,684.401], [668.621,723.025], [643.332,682.348], [644.776,720.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.381,659.605], [720.58,700.302], [644.625,653.735], [646.119,693.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.621,723.025], [669.867,758.556], [644.776,720.749], [646.105,756.077]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.581,700.328], [721.77,740.675], [646.12,693.731], [647.601,733.365]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.77,740.675], [722.863,777.779], [647.601,733.365], [648.963,769.819]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[745.029,320.091], [743.862,274.892], [699.088,320.347], [697.724,275.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.186,364.904], [745.029,320.091], [700.44,364.655], [699.088,320.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.186,364.904], [747.332,409.281], [700.44,364.655], [701.779,408.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.332,409.309], [748.468,453.282], [701.78,408.563], [703.107,452.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.468,453.31], [749.593,496.885], [703.108,452.076], [704.423,495.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.594,496.913], [750.709,540.096], [704.424,495.2], [705.728,537.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.71,540.124], [751.815,582.92], [705.729,537.94], [707.021,580.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.816,582.947], [752.911,625.361], [707.022,580.302], [708.302,622.263]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.911,625.388], [753.997,667.426], [708.303,622.289], [709.572,663.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.997,667.452], [755.073,709.118], [709.573,663.908], [710.832,705.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.074,709.145], [756.14,750.444], [710.832,705.163], [712.08,746.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.14,750.444], [757.121,788.415], [712.08,746.032], [713.227,783.612]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.924,365.422], [786.937,319.559], [738.513,365.149], [737.307,319.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.924,365.422], [788.902,410.827], [738.513,365.149], [739.706,410.012]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.903,410.856], [789.871,455.84], [739.707,410.04], [740.89,454.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.872,455.868], [790.831,500.436], [740.891,454.519], [742.063,498.563]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.832,500.464], [791.783,544.621], [742.063,498.591], [743.225,542.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.783,544.649], [792.726,588.401], [743.225,542.262], [744.376,585.51]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.726,588.429], [793.66,631.781], [744.377,585.537], [745.517,628.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.66,631.809], [794.585,674.768], [745.518,628.423], [746.648,670.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.586,674.795], [795.502,717.366], [746.649,670.923], [747.769,713.016]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.503,717.393], [796.411,759.58], [747.77,713.043], [748.88,754.762]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.411,759.58], [797.246,798.361], [748.88,754.762], [749.9,793.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.924,365.422], [786.937,319.559], [797.118,365.103], [796.187,319.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.924,365.422], [788.902,410.827], [797.118,365.103], [798.04,409.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.903,410.856], [789.871,455.84], [798.041,409.903], [798.954,454.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.872,455.868], [790.832,500.436], [798.954,454.292], [799.859,498.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.832,500.464], [791.783,544.621], [799.86,498.276], [800.756,541.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.784,544.649], [792.726,588.401], [800.757,541.861], [801.646,585.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.726,588.429], [793.66,631.781], [801.646,585.051], [802.527,627.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.66,631.809], [794.585,674.768], [802.527,627.853], [803.4,670.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.586,674.795], [795.503,717.366], [803.401,670.272], [804.266,712.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.503,717.393], [796.411,759.58], [804.266,712.312], [805.123,753.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.355,365.582], [884.823,319.394], [797.118,365.103], [796.187,319.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.411,759.58], [797.246,798.361], [805.123,753.952], [805.911,792.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.355,365.582], [885.882,411.308], [797.118,365.103], [798.04,409.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.882,411.337], [886.404,456.634], [798.041,409.903], [798.954,454.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.404,456.662], [886.921,501.538], [798.954,454.292], [799.859,498.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.921,501.566], [887.434,546.025], [799.86,498.276], [800.756,541.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.434,546.053], [887.941,590.102], [800.757,541.861], [801.646,585.024]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.942,590.13], [888.444,633.774], [801.646,585.051], [802.527,627.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.445,633.801], [888.943,677.046], [802.527,627.853], [803.4,670.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.943,677.073], [889.437,719.924], [803.401,670.272], [804.266,712.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.437,719.951], [889.926,762.414], [804.266,712.312], [805.123,753.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.926,762.414], [890.376,801.446], [805.123,753.952], [805.911,792.235]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[953.557,321.22], [953.364,278.288], [816.712,321.91], [815.944,280.363]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.355,365.582], [884.823,319.394], [896.074,365.142], [895.602,319.846]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.355,365.582], [885.882,411.308], [896.074,365.143], [896.541,409.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.882,411.337], [886.404,456.634], [896.541,410.021], [897.004,454.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.404,456.662], [886.921,501.538], [897.005,454.488], [897.463,498.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.921,501.566], [887.434,546.025], [897.464,498.548], [897.918,542.179]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.434,546.053], [887.941,590.102], [897.919,542.207], [898.369,585.443]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.942,590.13], [888.444,633.774], [898.369,585.471], [898.816,628.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.445,633.801], [888.943,677.046], [898.816,628.345], [899.258,670.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.943,677.073], [889.437,719.924], [899.258,670.833], [899.697,712.916]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.437,719.951], [889.926,762.414], [899.697,712.943], [900.131,754.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.926,762.414], [890.376,801.446], [900.131,754.651], [900.531,792.996]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.562,365.299], [925.225,319.685], [896.074,365.142], [895.602,319.846]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.561,365.299], [925.895,410.461], [896.074,365.143], [896.541,409.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.895,410.49], [926.226,455.234], [896.541,410.021], [897.004,454.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.226,455.263], [926.553,499.595], [897.004,454.488], [897.463,498.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.553,499.624], [926.878,543.55], [897.463,498.548], [897.918,542.179]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.878,543.578], [927.2,587.104], [897.918,542.207], [898.369,585.443]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.2,587.131], [927.518,630.262], [898.369,585.471], [898.815,628.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.519,630.29], [927.834,673.031], [898.816,628.345], [899.258,670.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.835,673.058], [899.258,670.833], [928.147,715.414], [899.697,712.916]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.148,715.441], [899.697,712.943], [928.458,757.418], [900.131,754.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.458,757.419], [900.131,754.651], [928.743,796.009], [900.531,792.996]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.562,365.299], [925.225,319.685], [932.71,364.987], [932.411,320.006]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.562,365.299], [925.895,410.461], [932.71,364.987], [933.006,409.528]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.895,410.49], [926.226,455.234], [933.007,409.556], [933.3,453.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.226,455.263], [926.554,499.595], [933.3,453.718], [933.591,497.452]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.554,499.623], [926.878,543.55], [933.591,497.48], [933.88,540.819]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.879,543.578], [927.2,587.104], [933.88,540.846], [934.166,583.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.2,587.131], [927.519,630.262], [934.166,583.822], [934.449,626.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.519,630.289], [927.835,673.031], [934.449,626.413], [934.73,668.598]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.835,673.058], [928.148,715.414], [934.73,668.625], [935.008,710.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.148,715.441], [928.458,757.419], [935.008,710.462], [935.284,751.903]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.458,757.419], [928.743,796.009], [935.284,751.903], [935.537,790.004]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.17,594.187], [1045.94,638.524], [1013.58,592.309], [1013.51,636.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.94,638.552], [1013.51,636.353], [1045.71,682.478], [1013.43,679.963]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.71,682.506], [1013.43,679.991], [1045.49,726.024], [1013.36,723.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.49,726.052], [1013.36,723.228], [1045.27,769.17], [1013.29,766.043]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1045.27,769.17], [1013.29,766.043], [1045.07,808.799], [1013.22,805.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.34,365.966], [1047.58,319], [1013.97,365.788], [1014.05,319.182]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.34,365.966], [1047.1,412.453], [1013.97,365.788], [1013.89,411.923]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.1,412.483], [1046.86,458.528], [1013.89,411.952], [1013.81,457.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.86,458.557], [1046.63,504.167], [1013.81,457.68], [1013.73,502.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.63,504.195], [1046.4,549.375], [1013.73,502.978], [1013.66,547.824]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1046.4,549.403], [1046.17,594.159], [1013.66,547.852], [1013.58,592.28]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1201.99,319.967], [1202.94,274.519], [1034.45,320.812], [1034.62,277.06]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.01,696.928], [1130.36,742.216], [1037.58,689.487], [1037.39,733.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1130.36,742.245], [1129.73,787.098], [1037.39,733.891], [1037.2,777.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.73,787.098], [1129.14,828.307], [1037.2,777.85], [1037.03,818.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.32,463.595], [1133.65,511.154], [1038.55,460.995], [1038.36,507.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.65,511.184], [1132.98,558.275], [1038.36,507.577], [1038.16,553.682]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.98,558.305], [1132.31,604.935], [1038.16,553.711], [1037.96,599.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.31,604.965], [1131.66,651.141], [1037.96,599.403], [1037.77,644.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.66,651.17], [1131.01,696.899], [1037.77,644.66], [1037.58,689.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.7,366.986], [1136.39,317.951], [1038.96,366.459], [1039.16,318.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.7,366.986], [1135.01,415.501], [1038.96,366.459], [1038.76,413.928]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.01,415.532], [1134.32,463.565], [1038.76,413.958], [1038.55,460.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.88,798.862], [1125.48,793.143], [1181.04,841.103], [1124.91,834.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.71,706.398], [1126.74,701.794], [1182.79,752.844], [1126.11,747.677]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.79,752.874], [1126.11,747.706], [1181.88,798.862], [1125.48,793.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.58,612.046], [1184.64,659.428], [1128.02,608.603], [1127.38,655.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.64,659.458], [1127.38,655.428], [1183.71,706.368], [1126.74,701.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.53,564.156], [1185.58,612.016], [1128.67,561.31], [1128.02,608.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.46,466.909], [1187.49,515.748], [1129.99,465.297], [1129.33,513.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.49,515.779], [1186.53,564.125], [1129.33,513.544], [1128.67,561.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.44,417.538], [1188.46,466.878], [1130.66,416.562], [1129.99,465.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.43,367.657], [1191.43,317.26], [1131.34,367.33], [1132.03,317.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.43,367.657], [1189.44,417.506], [1131.34,367.331], [1130.67,416.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.67,799.965], [1187.48,794.43], [1241.55,842.303], [1186.63,836.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.88,753.87], [1188.41,748.869], [1242.67,799.965], [1187.48,794.43]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.11,707.286], [1189.35,702.83], [1243.88,753.841], [1188.41,748.84]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.61,612.711], [1191.26,609.378], [1246.35,660.206], [1190.3,656.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.35,660.236], [1190.3,656.335], [1245.11,707.257], [1189.35,702.8]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.87,564.705], [1192.23,561.951], [1247.61,612.68], [1191.26,609.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.15,516.21], [1248.87,564.674], [1193.21,514.047], [1192.23,561.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.45,467.22], [1250.15,516.179], [1194.2,465.66], [1193.21,514.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.75,417.726], [1251.45,467.189], [1195.2,416.781], [1194.2,465.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.07,367.72], [1252.75,417.694], [1196.21,367.404], [1195.2,416.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.07,367.72], [1255.4,317.195], [1196.21,367.404], [1197.23,317.52]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1255.4,317.195], [1256.75,266.175], [1197.23,317.521], [1198.26,267.155]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.67,799.965], [1241.55,842.303], [1245.81,792.744], [1244.7,834.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.88,753.87], [1242.67,799.965], [1247.02,747.346], [1245.81,792.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1245.11,707.286], [1243.88,753.841], [1248.25,701.473], [1247.02,747.317]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.35,660.235], [1245.11,707.257], [1249.48,655.147], [1248.25,701.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.62,802.492], [1245.81,792.744], [1343.03,845.051], [1244.7,834.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.36,756.154], [1247.02,747.346], [1344.62,802.492], [1245.81,792.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.61,612.711], [1246.35,660.206], [1250.73,608.363], [1249.48,655.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.11,709.321], [1248.25,701.473], [1346.36,756.124], [1247.02,747.317]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.87,564.705], [1247.61,612.68], [1251.99,561.112], [1250.73,608.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1349.87,662.017], [1249.48,655.147], [1348.11,709.292], [1248.25,701.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.15,516.21], [1248.88,564.674], [1253.27,513.389], [1251.99,561.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.45,467.22], [1250.15,516.179], [1254.56,465.185], [1253.27,513.358]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.66,614.233], [1250.73,608.363], [1349.87,661.987], [1249.48,655.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.46,565.963], [1351.66,614.203], [1251.99,561.112], [1250.73,608.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.75,417.726], [1251.45,467.189], [1255.85,416.494], [1254.56,465.154]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.28,517.198], [1353.46,565.932], [1253.27,513.388], [1252,561.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.07,367.72], [1252.75,417.694], [1257.17,367.308], [1255.86,416.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.12,467.932], [1355.28,517.167], [1254.56,465.185], [1253.27,513.358]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.07,367.72], [1255.4,317.195], [1257.17,367.308], [1258.49,317.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.98,418.157], [1357.12,467.901], [1255.86,416.494], [1254.56,465.154]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1255.4,317.195], [1256.75,266.175], [1258.49,317.619], [1259.83,267.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.86,367.865], [1358.98,418.126], [1257.17,367.308], [1255.86,416.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.86,367.865], [1362.76,317.046], [1257.17,367.308], [1258.49,317.619]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1362.76,317.047], [1364.68,265.727], [1258.49,317.619], [1259.83,267.453]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.62,802.492], [1343.03,845.052], [1347.66,788.116], [1346.1,829.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.36,756.154], [1344.62,802.492], [1349.35,743.164], [1347.66,788.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1380.99,791.3], [1347.66,788.116], [1379.28,832.877], [1346.1,829.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.11,709.321], [1346.36,756.124], [1351.06,697.747], [1349.35,743.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1349.87,662.017], [1348.11,709.292], [1352.78,651.887], [1351.06,697.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1382.86,746.04], [1349.35,743.164], [1380.99,791.3], [1347.66,788.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.66,614.233], [1349.87,661.987], [1354.53,605.577], [1352.78,651.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.74,700.31], [1351.06,697.747], [1382.86,746.012], [1349.35,743.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1386.65,654.13], [1352.78,651.887], [1384.74,700.281], [1351.06,697.718]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.46,565.963], [1351.66,614.203], [1356.29,558.811], [1354.53,605.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.57,607.493], [1354.52,605.577], [1386.65,654.1], [1352.78,651.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.28,517.198], [1353.46,565.932], [1358.06,511.581], [1356.29,558.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1390.51,560.394], [1356.28,558.811], [1388.57,607.464], [1354.53,605.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.12,467.932], [1355.28,517.167], [1359.86,463.882], [1358.06,511.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1358.98,418.157], [1357.12,467.901], [1361.67,415.705], [1359.86,463.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.47,512.824], [1358.06,511.581], [1390.51,560.364], [1356.29,558.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.45,464.778], [1359.86,463.882], [1392.47,512.794], [1358.06,511.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.86,367.865], [1358.98,418.126], [1363.5,367.044], [1361.67,415.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.45,416.247], [1361.67,415.705], [1394.45,464.747], [1359.86,463.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.86,367.865], [1362.76,317.046], [1363.5,367.044], [1365.35,317.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.47,367.225], [1363.5,367.044], [1396.45,416.217], [1361.67,415.674]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1362.76,317.047], [1364.68,265.727], [1365.35,317.891], [1367.22,268.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.47,367.225], [1400.52,317.704], [1363.5,367.044], [1365.35,317.891]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1400.52,317.704], [1365.35,317.891], [1402.58,267.708], [1367.22,268.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1380.99,791.3], [1379.28,832.877], [1383.4,773.52], [1381.74,813.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1382.86,746.041], [1380.99,791.3], [1385.2,729.98], [1383.4,773.52]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1384.74,700.31], [1382.86,746.012], [1387.02,686.003], [1385.2,729.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1386.65,654.13], [1384.74,700.281], [1388.86,641.612], [1387.02,685.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1388.57,607.493], [1386.65,654.1], [1390.71,596.8], [1388.86,641.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1390.51,560.394], [1388.57,607.464], [1392.59,551.561], [1390.71,596.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.47,512.824], [1390.51,560.364], [1394.48,505.889], [1392.59,551.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1394.45,464.778], [1392.47,512.794], [1396.39,459.778], [1394.48,505.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1396.45,416.247], [1394.45,464.747], [1398.31,413.221], [1396.39,459.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.47,367.225], [1396.45,416.217], [1400.26,366.213], [1398.31,413.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.47,367.225], [1400.52,317.704], [1400.26,366.213], [1402.22,318.745]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1400.52,317.704], [1402.58,267.708], [1402.22,318.745], [1404.21,270.843]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[717.371,321.276], [716.107,278.384], [646.108,321.643], [644.56,279.757]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.371,321.276], [718.624,363.811], [646.108,321.643], [647.644,363.19]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.624,363.811], [719.866,405.941], [647.644,363.19], [649.166,404.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.866,405.968], [721.097,447.724], [649.167,404.375], [650.675,445.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.098,447.75], [722.317,489.137], [650.676,445.204], [652.171,485.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.318,489.164], [723.527,530.187], [652.172,485.68], [653.655,525.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.528,530.213], [724.726,570.877], [653.655,525.808], [655.125,565.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.727,570.903], [725.914,611.212], [655.126,565.592], [656.583,605.013]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.915,611.238], [727.093,651.198], [656.584,605.038], [658.029,644.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.093,651.223], [728.261,690.838], [658.03,644.149], [659.463,682.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.261,690.863], [729.419,730.136], [659.464,682.93], [660.884,721.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.419,730.136], [730.483,766.253], [660.884,721.361], [662.191,756.708]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[748.639,320.843], [747.485,276.766], [706.026,321.067], [704.694,277.602]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.639,320.843], [749.783,364.543], [706.026,321.067], [707.348,364.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.783,364.543], [750.915,407.815], [707.348,364.165], [708.656,406.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.916,407.842], [752.038,450.72], [708.657,406.875], [709.954,449.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.039,450.747], [753.151,493.236], [709.955,449.2], [711.24,491.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.152,493.263], [754.254,535.368], [711.241,491.147], [712.515,532.694]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.255,535.395], [755.347,577.122], [712.516,532.72], [713.778,573.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.348,577.148], [756.43,618.502], [713.779,573.924], [715.031,614.739]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.431,618.528], [757.504,659.513], [715.031,614.765], [716.272,655.221]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.505,659.539], [758.568,700.161], [716.272,655.247], [717.502,695.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.569,700.186], [759.623,740.449], [717.503,695.374], [718.722,735.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.623,740.449], [760.591,777.468], [718.722,735.127], [719.842,771.68]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.22,320.428], [787.216,365.244], [740.014,320.674], [741.21,364.829]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.216,365.245], [788.202,409.612], [741.21,364.83], [742.394,408.549]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.203,409.64], [789.18,453.593], [742.395,408.577], [743.568,451.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.18,453.621], [790.148,497.165], [743.569,451.922], [744.732,494.842]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.148,497.193], [791.107,540.334], [744.732,494.87], [745.884,537.398]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.108,540.362], [792.057,583.105], [745.885,537.426], [747.026,579.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.058,583.133], [792.999,625.484], [747.027,579.595], [748.158,621.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793,625.511], [793.932,667.476], [748.159,621.383], [749.28,662.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.933,667.503], [794.857,709.087], [749.28,662.795], [750.391,703.81]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.858,709.113], [795.773,750.321], [750.392,703.837], [751.493,744.486]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.773,750.321], [796.615,788.2], [751.493,744.486], [752.505,781.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.22,320.428], [787.216,365.244], [796.748,320.651], [797.682,364.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.216,365.245], [788.202,409.612], [797.682,364.868], [798.606,408.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.203,409.64], [789.18,453.593], [798.607,408.677], [799.522,452.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.18,453.621], [790.148,497.165], [799.523,452.081], [800.43,495.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.148,497.193], [791.107,540.334], [800.431,495.087], [801.33,537.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.108,540.362], [792.058,583.105], [801.331,537.7], [802.222,579.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.058,583.132], [792.999,625.484], [802.222,579.926], [803.105,621.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793,625.511], [793.932,667.476], [803.106,621.769], [803.981,663.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.933,667.503], [794.857,709.087], [803.981,663.236], [804.849,704.304]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.858,709.113], [795.773,750.321], [804.849,704.33], [805.708,745.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.773,750.321], [796.615,788.2], [805.708,745.032], [806.499,782.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.052,320.216], [880.612,365.604], [796.748,320.651], [797.682,364.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.612,365.604], [881.167,410.532], [797.682,364.868], [798.606,408.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.168,410.561], [881.717,455.064], [798.607,408.677], [799.523,452.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.718,455.092], [882.262,499.176], [799.523,452.081], [800.431,495.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.262,499.204], [882.802,542.876], [800.431,495.087], [801.33,537.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.802,542.903], [883.336,586.167], [801.331,537.7], [802.222,579.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.337,586.195], [883.866,629.057], [802.223,579.926], [803.105,621.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.866,629.084], [884.391,671.55], [803.106,621.769], [803.981,663.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.391,671.577], [884.911,713.652], [803.982,663.236], [804.849,704.304]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.911,713.679], [885.426,755.369], [804.849,704.33], [805.709,745.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.426,755.369], [885.899,793.688], [805.709,745.032], [806.499,782.45]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[956.503,321.45], [956.32,279.035], [826.637,322.064], [825.905,281.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.052,320.216], [880.612,365.604], [892.827,320.526], [893.318,365.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.613,365.604], [881.167,410.532], [893.318,365.079], [893.803,409.188]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.168,410.561], [881.717,455.064], [893.804,409.216], [894.285,452.915]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.718,455.092], [882.262,499.176], [894.285,452.943], [894.761,496.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.262,499.204], [882.802,542.876], [894.762,496.266], [895.234,539.163]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.802,542.903], [883.336,586.167], [895.234,539.19], [895.702,581.694]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.337,586.195], [883.866,629.057], [895.702,581.721], [896.166,623.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.866,629.084], [884.391,671.55], [896.166,623.864], [896.625,665.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.391,671.577], [884.911,713.652], [896.626,665.625], [897.081,706.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.911,713.679], [885.426,755.369], [897.081,707.009], [897.532,747.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.426,755.369], [885.899,793.688], [897.532,747.994], [897.947,785.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.915,320.383], [921.277,365.321], [892.827,320.526], [893.318,365.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.277,365.322], [921.635,409.809], [893.318,365.079], [893.803,409.188]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.635,409.837], [921.99,453.908], [893.803,409.216], [894.284,452.915]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.99,453.936], [922.341,497.596], [894.285,452.943], [894.761,496.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.342,497.623], [922.69,540.878], [894.761,496.266], [895.234,539.163]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.69,540.905], [923.035,583.761], [895.234,539.19], [895.702,581.694]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.035,583.788], [923.377,626.249], [895.702,581.721], [896.166,623.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.378,626.276], [923.716,668.348], [896.166,623.864], [896.625,665.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.716,668.375], [924.052,710.064], [896.625,665.625], [897.081,706.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.052,710.091], [924.385,751.401], [897.081,707.008], [897.532,747.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.385,751.402], [924.691,789.375], [897.532,747.994], [897.947,785.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.915,320.383], [921.277,365.321], [929.576,320.604], [929.893,364.947]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.277,365.321], [921.635,409.809], [929.893,364.947], [930.206,408.85]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.635,409.837], [921.99,453.908], [930.206,408.878], [930.517,452.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.99,453.936], [922.342,497.596], [930.517,452.402], [930.825,495.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.342,497.623], [922.69,540.878], [930.825,495.526], [931.13,538.229]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.691,540.905], [923.036,583.761], [931.13,538.256], [931.432,580.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.036,583.788], [923.378,626.249], [931.432,580.595], [931.732,622.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.378,626.276], [923.717,668.348], [931.732,622.551], [932.029,664.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.717,668.375], [924.052,710.064], [932.029,664.127], [932.323,705.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.053,710.09], [924.385,751.402], [932.323,705.329], [932.614,746.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.385,751.402], [924.691,789.375], [932.614,746.137], [932.882,783.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.61,366.355], [1037.42,412.455], [1005.55,366.076], [1005.51,411.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.42,412.484], [1037.22,458.137], [1005.51,411.772], [1005.47,456.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.22,458.166], [1037.03,503.378], [1005.47,457.027], [1005.43,501.822]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.03,503.407], [1036.84,548.184], [1005.43,501.85], [1005.39,546.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.84,548.212], [1036.65,592.561], [1005.39,546.246], [1005.36,590.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.65,592.589], [1036.47,636.516], [1005.36,590.221], [1005.32,633.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.47,636.543], [1036.28,680.054], [1005.32,633.781], [1005.28,676.905]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.28,680.081], [1036.1,723.182], [1005.28,676.932], [1005.25,719.653]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.1,723.209], [1005.25,719.68], [1035.92,765.904], [1005.21,762.004]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.92,765.904], [1005.21,762.004], [1035.75,805.138], [1005.18,800.899]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.81,319.771], [1037.61,366.355], [1005.59,319.936], [1005.55,366.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.28,741.285], [1114.7,785.88], [1025.57,730.791], [1025.44,774.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.7,785.88], [1114.17,826.843], [1025.44,774.285], [1025.32,814.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.5,416.142], [1118.88,463.979], [1026.55,414.017], [1026.41,460.586]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.88,464.009], [1118.26,511.361], [1026.41,460.615], [1026.27,506.725]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.26,511.391], [1117.65,558.266], [1026.27,506.754], [1026.13,552.411]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.65,558.296], [1117.05,604.702], [1026.13,552.44], [1025.99,597.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.05,604.731], [1116.45,650.674], [1025.98,597.68], [1025.85,642.453]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.45,650.703], [1115.86,696.19], [1025.85,642.482], [1025.71,686.822]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.86,696.219], [1115.28,741.257], [1025.71,686.85], [1025.57,730.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.76,318.925], [1120.12,367.783], [1026.85,319.417], [1026.7,366.953]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.12,367.783], [1119.5,416.112], [1026.7,366.953], [1026.55,413.987]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1197.4,320.311], [1198.36,274.776], [1034.21,321.083], [1034.38,277.661]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.49,798.993], [1162.72,841.086], [1108.7,791.769], [1108.19,833.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.19,706.819], [1164.33,753.125], [1109.82,700.979], [1109.26,746.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.33,753.155], [1163.49,798.993], [1109.26,746.615], [1108.7,791.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.92,612.713], [1166.05,659.977], [1110.96,608.315], [1110.39,654.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.05,660.007], [1165.19,706.789], [1110.38,654.881], [1109.82,700.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.8,564.927], [1166.92,612.682], [1111.54,561.273], [1110.96,608.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.58,467.854], [1168.68,516.613], [1112.71,465.735], [1112.12,513.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.68,516.644], [1167.8,564.897], [1112.12,513.749], [1111.54,561.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.41,368.724], [1170.49,418.519], [1113.92,368.206], [1113.31,417.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.49,418.551], [1169.58,467.823], [1113.31,417.223], [1112.71,465.704]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.33,318.368], [1171.41,368.724], [1114.53,318.675], [1113.92,368.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.45,801.774], [1170.43,794.732], [1223.38,844.106], [1169.63,836.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.78,709.068], [1172.18,703.374], [1225.61,755.643], [1171.3,749.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.61,755.673], [1171.3,749.298], [1224.45,801.774], [1170.43,794.732]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.96,661.982], [1226.78,709.038], [1173.07,656.983], [1172.18,703.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.16,614.407], [1227.96,661.952], [1173.97,610.118], [1173.07,656.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.37,566.335], [1229.16,614.376], [1174.87,562.772], [1173.97,610.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.59,517.759], [1230.37,566.305], [1175.79,514.936], [1174.87,562.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.83,468.671], [1231.59,517.728], [1176.72,466.604], [1175.79,514.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.08,419.062], [1232.83,468.64], [1177.65,417.767], [1176.72,466.573]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.34,368.924], [1234.08,419.03], [1178.6,368.418], [1177.65,417.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.61,318.249], [1235.34,368.924], [1179.55,318.549], [1178.6,368.418]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1236.61,318.25], [1237.9,267.061], [1179.55,318.549], [1180.52,268.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.45,801.774], [1223.38,844.106], [1229.78,794.644], [1228.71,836.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.61,755.673], [1224.45,801.774], [1230.95,749.217], [1229.78,794.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.78,709.068], [1225.61,755.643], [1232.13,703.302], [1230.95,749.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.96,661.982], [1226.78,709.038], [1233.32,656.92], [1232.13,703.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.16,614.407], [1227.97,661.952], [1234.53,610.064], [1233.33,656.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.37,566.335], [1229.16,614.376], [1235.75,562.727], [1234.53,610.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1327.47,807.164], [1325.9,849.959], [1229.78,794.644], [1228.71,836.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1329.17,760.553], [1327.47,807.164], [1230.95,749.217], [1229.78,794.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.59,517.759], [1230.37,566.305], [1236.98,514.901], [1235.75,562.697]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.9,713.428], [1329.17,760.523], [1232.13,703.302], [1230.95,749.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.83,468.671], [1231.59,517.728], [1238.22,466.578], [1236.98,514.87]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.64,665.81], [1330.9,713.398], [1233.32,656.92], [1232.13,703.273]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.08,419.062], [1232.83,468.64], [1239.48,417.751], [1238.22,466.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.34,368.924], [1234.08,419.03], [1240.75,368.412], [1239.48,417.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.4,617.691], [1332.64,665.779], [1234.53,610.064], [1233.33,656.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.18,569.065], [1334.4,617.661], [1235.75,562.727], [1234.53,610.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.61,318.249], [1235.34,368.924], [1242.03,318.552], [1240.75,368.412]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1337.98,519.922], [1336.18,569.034], [1236.98,514.9], [1235.75,562.697]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1236.61,318.249], [1237.9,267.061], [1242.03,318.553], [1243.32,268.197]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.8,470.255], [1337.98,519.891], [1238.22,466.578], [1236.98,514.87]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.63,420.054], [1339.8,470.223], [1239.48,417.751], [1238.22,466.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.49,369.312], [1341.64,420.022], [1240.75,368.412], [1239.48,417.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.37,318.019], [1343.49,369.312], [1242.03,318.552], [1240.75,368.412]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1345.37,318.02], [1347.26,266.201], [1242.03,318.553], [1243.33,268.197]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1327.47,807.164], [1325.9,849.959], [1334.94,792.793], [1333.39,834.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1329.17,760.553], [1327.47,807.164], [1336.64,747.541], [1334.94,792.793]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.9,713.428], [1329.17,760.523], [1338.34,701.806], [1336.64,747.513]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.64,665.81], [1330.9,713.398], [1340.07,655.607], [1338.35,701.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.4,617.691], [1332.64,665.779], [1341.81,608.937], [1340.07,655.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.22,796.918], [1334.94,792.793], [1366.49,838.832], [1333.39,834.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.18,569.065], [1334.4,617.661], [1343.58,561.79], [1341.82,608.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.09,751.276], [1336.63,747.541], [1368.22,796.918], [1334.94,792.793]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1337.98,519.922], [1336.18,569.034], [1345.36,514.159], [1343.58,561.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.98,705.141], [1338.34,701.805], [1370.09,751.247], [1336.64,747.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1339.8,470.255], [1337.98,519.891], [1347.15,466.035], [1345.36,514.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.9,658.534], [1340.07,655.606], [1371.99,705.112], [1338.34,701.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1341.63,420.054], [1339.8,470.223], [1348.97,417.411], [1347.16,466.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.83,611.449], [1341.81,608.937], [1373.9,658.505], [1340.07,655.577]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.49,369.312], [1341.64,420.022], [1350.81,368.279], [1348.97,417.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.79,563.877], [1343.58,561.79], [1375.83,611.419], [1341.81,608.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.37,318.019], [1343.49,369.312], [1352.66,318.631], [1350.81,368.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.76,515.812], [1345.35,514.159], [1377.79,563.847], [1343.58,561.76]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1345.37,318.02], [1347.26,266.2], [1352.66,318.632], [1354.53,268.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.75,467.245], [1347.15,466.035], [1379.76,515.781], [1345.36,514.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1383.77,418.169], [1381.76,467.214], [1348.97,417.411], [1347.15,466.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.81,368.575], [1383.77,418.138], [1350.81,368.279], [1348.97,417.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.86,318.456], [1385.81,368.575], [1352.66,318.631], [1350.81,368.279]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1387.86,318.456], [1389.94,267.835], [1352.66,318.631], [1354.53,268.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1368.22,796.918], [1366.49,838.832], [1376.14,779.049], [1374.45,819.422]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1370.09,751.276], [1368.22,796.918], [1377.98,735.102], [1376.14,779.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.99,705.141], [1370.09,751.247], [1379.84,690.698], [1377.98,735.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.9,658.534], [1371.99,705.112], [1381.71,645.858], [1379.84,690.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.83,611.449], [1373.9,658.505], [1383.61,600.576], [1381.71,645.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.79,563.877], [1375.83,611.419], [1385.52,554.845], [1383.61,600.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.76,515.812], [1377.79,563.847], [1387.46,508.658], [1385.52,554.816]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.75,467.245], [1379.76,515.782], [1389.41,462.009], [1387.46,508.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1383.77,418.169], [1381.76,467.214], [1391.38,414.89], [1389.41,461.979]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.81,368.575], [1383.77,418.138], [1393.37,367.294], [1391.38,414.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.86,318.456], [1385.81,368.575], [1395.39,319.214], [1393.37,367.294]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1387.86,318.456], [1389.94,267.834], [1395.39,319.214], [1397.42,270.675]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[727.163,321.608], [725.937,279.877], [661.911,321.841], [660.43,281.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.163,321.608], [728.379,362.99], [661.911,321.841], [663.379,362.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[728.379,362.99], [729.582,403.975], [663.379,362.109], [664.834,402.002]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.583,404.001], [730.776,444.622], [664.835,402.027], [666.277,441.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.777,444.647], [731.96,484.907], [666.278,441.599], [667.707,480.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.96,484.932], [733.133,524.836], [667.708,480.829], [669.125,519.696]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.133,524.862], [734.295,564.415], [669.126,519.721], [670.532,558.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.296,564.44], [735.447,603.646], [670.533,558.28], [671.926,596.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.448,603.671], [736.59,642.536], [671.927,596.51], [673.308,634.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.591,642.56], [737.722,681.088], [673.309,634.416], [674.679,671.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.723,681.112], [738.845,719.306], [674.679,672], [676.038,709.245]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.845,719.306], [739.877,754.429], [676.038,709.245], [677.287,743.503]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[754.112,321.358], [752.976,278.415], [714.943,321.501], [713.646,279.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.112,321.358], [755.237,363.932], [714.943,321.501], [716.229,363.394]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.237,363.932], [756.352,406.087], [716.229,363.395], [717.503,404.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.353,406.113], [757.457,447.881], [717.504,404.908], [718.766,446.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.458,447.908], [758.553,489.295], [718.767,446.048], [720.018,486.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.553,489.321], [759.638,530.332], [720.018,486.817], [721.258,527.197]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.638,530.358], [760.713,570.998], [721.259,527.222], [722.487,567.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.714,571.023], [761.779,611.297], [722.488,567.268], [723.706,606.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.78,611.323], [762.835,651.236], [723.707,606.958], [724.914,646.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.836,651.261], [763.882,690.818], [724.915,646.299], [726.111,685.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.882,690.843], [764.919,730.049], [726.112,685.293], [727.298,723.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.919,730.049], [765.872,766.093], [727.298,723.922], [728.388,759.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.318,321.115], [788.316,364.853], [744.718,321.271], [745.898,364.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.316,364.854], [789.305,408.151], [745.898,364.261], [747.067,406.823]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.306,408.178], [790.285,451.068], [747.068,406.851], [748.226,449.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.286,451.095], [791.256,493.583], [748.227,449.046], [749.374,490.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.256,493.61], [792.217,535.701], [749.375,490.852], [750.512,532.249]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.218,535.728], [793.17,577.428], [750.513,532.275], [751.639,573.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.171,577.455], [794.114,618.769], [751.64,573.32], [752.756,613.966]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.115,618.796], [795.05,659.731], [752.757,613.992], [753.863,654.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.05,659.757], [795.976,700.316], [753.864,654.295], [754.96,694.211]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.977,700.342], [796.895,740.532], [754.961,694.236], [756.047,733.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.895,740.533], [797.738,777.474], [756.047,733.794], [757.046,770.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[787.318,321.115], [788.316,364.853], [798.955,321.229], [799.886,364.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.316,364.853], [789.305,408.151], [799.886,364.42], [800.809,407.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.306,408.178], [790.285,451.068], [800.809,407.207], [801.723,449.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.286,451.095], [791.256,493.583], [801.724,449.596], [802.629,491.565]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.256,493.61], [792.218,535.701], [802.63,491.592], [803.526,533.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.218,535.728], [793.17,577.428], [803.527,533.202], [804.416,574.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.171,577.455], [794.114,618.769], [804.416,574.429], [805.297,615.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.115,618.796], [795.05,659.731], [805.297,615.281], [806.17,655.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.05,659.757], [795.977,700.316], [806.171,655.761], [807.035,695.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.977,700.342], [796.895,740.533], [807.036,695.875], [807.893,735.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.895,740.533], [797.738,777.474], [807.893,735.602], [808.681,772.122]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.456,320.949], [877.042,365.479], [798.955,321.229], [799.886,364.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.042,365.479], [877.621,409.552], [799.886,364.42], [800.809,407.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.622,409.58], [878.196,453.231], [800.809,407.207], [801.723,449.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.196,453.259], [878.764,496.493], [801.724,449.595], [802.629,491.565]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.765,496.52], [879.328,539.344], [802.63,491.592], [803.527,533.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.328,539.371], [879.886,581.791], [803.527,533.202], [804.416,574.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.886,581.817], [880.439,623.838], [804.416,574.429], [805.297,615.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.439,623.864], [880.986,665.491], [805.298,615.281], [806.17,655.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.987,665.517], [881.529,706.756], [806.171,655.761], [807.036,695.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.529,706.783], [882.066,747.639], [807.036,695.875], [807.893,735.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.066,747.639], [882.56,785.187], [807.893,735.602], [808.681,772.122]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[959.704,321.581], [959.533,279.723], [837.481,321.98], [836.787,282.062]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.456,320.949], [877.042,365.479], [891.028,321.111], [891.534,364.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.042,365.479], [877.622,409.552], [891.534,364.868], [892.035,408.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.622,409.58], [878.196,453.231], [892.035,408.21], [892.531,451.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.196,453.259], [878.764,496.493], [892.532,451.144], [893.023,493.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.765,496.521], [879.328,539.344], [893.023,493.676], [893.51,535.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.328,539.371], [879.886,581.791], [893.511,535.81], [893.993,577.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.886,581.818], [880.439,623.838], [893.993,577.553], [894.471,618.884]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.439,623.864], [880.986,665.491], [894.472,618.91], [894.945,659.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.987,665.517], [881.529,706.756], [894.945,659.887], [895.415,700.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.529,706.783], [882.066,747.639], [895.415,700.488], [895.88,740.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.066,747.639], [882.56,785.187], [895.88,740.693], [896.307,777.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.388,321.018], [917.772,365.219], [891.028,321.111], [891.534,364.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.772,365.22], [918.153,408.971], [891.534,364.868], [892.034,408.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.153,408.999], [918.53,452.334], [892.035,408.21], [892.531,451.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.53,452.361], [918.903,495.286], [892.531,451.144], [893.023,493.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.904,495.313], [919.274,537.833], [893.023,493.676], [893.51,535.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.274,537.86], [919.64,579.981], [893.51,535.81], [893.993,577.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.641,580.008], [920.004,621.736], [893.993,577.553], [894.471,618.884]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.004,621.762], [920.363,663.102], [894.471,618.91], [894.945,659.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.364,663.128], [920.72,704.086], [894.945,659.887], [895.414,700.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.72,704.112], [921.073,744.692], [895.415,700.488], [895.88,740.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.073,744.692], [921.398,781.989], [895.88,740.693], [896.307,777.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.388,321.018], [917.772,365.219], [927.394,321.134], [927.726,364.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.772,365.22], [918.153,408.971], [927.726,364.781], [928.055,407.989]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.153,408.998], [918.53,452.334], [928.056,408.016], [928.381,450.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.531,452.361], [918.904,495.286], [928.382,450.845], [928.704,493.247]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.904,495.313], [919.274,537.833], [928.705,493.273], [929.024,535.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.274,537.86], [919.641,579.981], [929.025,535.307], [929.341,576.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.641,580.008], [920.004,621.736], [929.341,576.95], [929.655,618.184]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.004,621.762], [920.364,663.102], [929.656,618.21], [929.967,659.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.364,663.128], [920.72,704.086], [929.967,659.091], [930.275,699.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[920.721,704.112], [921.074,744.692], [930.275,699.598], [930.581,739.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[921.074,744.692], [921.398,781.989], [930.581,739.711], [930.861,776.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.85,320.619], [1027.7,366.726], [997.234,320.727], [997.235,366.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.7,366.726], [1027.55,412.344], [997.235,366.317], [997.236,411.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.55,412.373], [1027.4,457.539], [997.236,411.457], [997.237,456.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.4,457.568], [1027.25,502.288], [997.237,456.154], [997.238,500.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.25,502.316], [1027.1,546.597], [997.238,500.415], [997.239,544.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1027.1,546.625], [1026.96,590.472], [997.239,544.246], [997.24,587.626]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.96,590.5], [1026.81,633.921], [997.24,587.653], [997.241,630.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.81,633.949], [1026.67,676.95], [997.241,630.643], [997.242,673.194]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.67,676.977], [1026.53,719.564], [997.242,673.221], [997.243,715.366]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.53,719.59], [1026.39,761.769], [997.243,715.392], [997.244,757.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1026.39,761.769], [1026.26,800.52], [997.244,757.138], [997.245,795.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.1,320.107], [1103.53,368.66], [1014.49,320.431], [1014.41,367.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.53,368.66], [1102.98,416.674], [1014.41,367.434], [1014.32,413.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.98,416.705], [1102.43,464.217], [1014.32,413.96], [1014.24,459.986]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.43,464.247], [1101.88,511.266], [1014.24,460.015], [1014.15,505.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.88,511.296], [1101.34,557.829], [1014.15,505.607], [1014.07,550.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.34,557.859], [1100.81,603.914], [1014.07,550.742], [1013.99,595.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.81,603.943], [1100.28,649.526], [1013.99,595.428], [1013.9,639.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.28,649.555], [1099.76,694.675], [1013.9,639.671], [1013.82,683.449]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.76,694.704], [1099.24,739.367], [1013.82,683.477], [1013.74,726.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.24,739.395], [1098.73,783.608], [1013.74,726.854], [1013.66,769.779]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.73,783.608], [1098.26,824.21], [1013.66,769.779], [1013.59,809.211]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1191.06,320.826], [1192.02,275.29], [1033.67,321.34], [1033.84,278.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.35,752.41], [1143.58,797.954], [1091.53,744.542], [1091.05,789.283]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.58,797.954], [1142.88,839.766], [1091.05,789.283], [1090.61,830.364]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.9,659.82], [1145.12,706.328], [1092.5,653.614], [1092.01,699.284]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.12,706.358], [1144.35,752.381], [1092.01,699.313], [1091.53,744.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.48,565.254], [1146.69,612.757], [1093.5,560.782], [1093,607.41]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.68,612.788], [1145.9,659.79], [1093,607.44], [1092.5,653.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.1,468.648], [1148.29,517.179], [1094.51,465.987], [1094,513.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.29,517.21], [1147.48,565.223], [1094,513.634], [1093.5,560.753]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1150.75,369.936], [1149.92,419.528], [1095.55,369.165], [1095.03,417.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.92,419.56], [1149.1,468.617], [1095.03,417.833], [1094.51,465.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.59,319.768], [1150.75,369.936], [1096.08,319.973], [1095.55,369.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.96,802.426], [1202.96,844.614], [1151.78,793.913], [1151.05,835.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.04,756.467], [1203.96,802.426], [1152.58,748.743], [1151.78,793.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.14,709.992], [1205.04,756.438], [1153.38,703.074], [1152.58,748.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.38,615.547], [1207.26,662.991], [1155.02,610.295], [1154.2,656.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.26,663.021], [1206.15,709.962], [1154.2,656.927], [1153.38,703.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.52,567.561], [1208.38,615.516], [1155.86,563.169], [1155.03,610.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.67,519.056], [1209.52,567.531], [1156.7,515.543], [1155.86,563.139]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.83,470.022], [1210.67,519.025], [1157.55,467.407], [1156.7,515.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213,420.451], [1211.83,469.991], [1158.41,418.755], [1157.55,467.377]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.39,319.663], [1214.19,370.334], [1160.16,319.863], [1159.28,369.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.19,370.334], [1213,420.419], [1159.28,369.576], [1158.41,418.724]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1215.39,319.663], [1216.6,268.46], [1160.16,319.864], [1161.05,269.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.96,802.426], [1202.96,844.614], [1211.45,795.466], [1210.43,837.068]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.04,756.467], [1203.96,802.426], [1212.56,750.152], [1211.45,795.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.14,709.992], [1205.04,756.438], [1213.68,704.336], [1212.56,750.123]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.26,663.021], [1206.15,709.962], [1214.82,658.038], [1213.68,704.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.38,615.547], [1207.26,662.991], [1215.96,611.253], [1214.82,658.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.52,567.561], [1208.38,615.516], [1217.12,563.97], [1215.96,611.223]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.67,519.056], [1209.52,567.531], [1218.29,516.183], [1217.12,563.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.83,470.022], [1210.67,519.025], [1219.48,467.884], [1218.3,516.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.75,810.747], [1305.23,853.633], [1211.45,795.466], [1210.43,837.068]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213,420.451], [1211.83,469.991], [1220.68,419.064], [1219.48,467.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.41,764.018], [1306.75,810.747], [1212.56,750.152], [1211.45,795.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.19,370.334], [1213,420.419], [1221.89,369.714], [1220.68,419.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.09,716.756], [1308.41,763.989], [1213.68,704.336], [1212.56,750.123]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.39,319.663], [1214.19,370.334], [1223.11,319.827], [1221.89,369.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.78,668.981], [1310.09,716.726], [1214.82,658.038], [1213.68,704.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.5,620.684], [1311.78,668.95], [1215.96,611.252], [1214.82,658.009]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1215.39,319.663], [1216.6,268.46], [1223.11,319.827], [1224.35,269.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.23,571.858], [1313.5,620.653], [1217.12,563.97], [1215.96,611.223]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1316.98,522.493], [1315.23,571.827], [1218.3,516.183], [1217.12,563.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1318.76,472.581], [1316.98,522.462], [1219.48,467.884], [1218.3,516.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1320.55,422.112], [1318.76,472.549], [1220.68,419.064], [1219.48,467.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.36,371.077], [1320.55,422.08], [1221.89,369.715], [1220.68,419.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.19,319.466], [1322.36,371.077], [1223.11,319.827], [1221.89,369.714]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1324.19,319.466], [1326.04,267.303], [1223.11,319.827], [1224.35,269.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.75,810.747], [1305.23,853.634], [1318.73,796.545], [1317.2,838.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.41,764.018], [1306.75,810.747], [1320.41,751.131], [1318.73,796.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.09,716.756], [1308.41,763.989], [1322.1,705.212], [1320.41,751.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.78,668.981], [1310.09,716.726], [1323.8,658.81], [1322.1,705.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.5,620.684], [1311.78,668.95], [1325.53,611.918], [1323.81,658.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.23,571.858], [1313.5,620.654], [1327.28,564.526], [1325.53,611.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1316.98,522.493], [1315.23,571.827], [1329.04,516.628], [1327.28,564.496]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1318.76,472.581], [1316.98,522.462], [1330.82,468.215], [1329.04,516.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.52,801.627], [1318.73,796.545], [1349.81,843.747], [1317.2,838.237]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1320.55,422.112], [1318.76,472.549], [1332.62,419.279], [1330.82,468.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.39,755.742], [1320.4,751.13], [1351.52,801.627], [1318.73,796.544]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.36,371.077], [1320.55,422.08], [1334.44,369.81], [1332.62,419.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.27,709.342], [1322.09,705.212], [1353.39,755.713], [1320.41,751.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.17,662.448], [1323.8,658.81], [1355.27,709.313], [1322.1,705.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.19,319.466], [1322.36,371.077], [1336.28,319.801], [1334.44,369.81]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1324.19,319.466], [1326.04,267.303], [1336.29,319.802], [1338.15,269.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.1,615.053], [1325.53,611.918], [1357.18,662.419], [1323.8,658.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.04,567.148], [1327.27,564.526], [1359.1,615.023], [1325.53,611.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.01,518.725], [1361.04,567.118], [1329.04,516.628], [1327.28,564.496]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365,469.776], [1363.01,518.695], [1330.82,468.215], [1329.04,516.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.01,420.292], [1365,469.745], [1332.62,419.279], [1330.82,468.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.04,370.263], [1367.01,420.26], [1334.44,369.81], [1332.62,419.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.09,319.681], [1369.04,370.263], [1336.28,319.801], [1334.44,369.81]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1371.09,319.682], [1373.17,268.57], [1336.28,319.802], [1338.14,269.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1351.52,801.627], [1349.81,843.747], [1365.11,783.863], [1363.4,824.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.39,755.742], [1351.52,801.627], [1366.97,739.626], [1365.11,783.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.27,709.342], [1353.39,755.713], [1368.86,694.911], [1366.98,739.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.17,662.448], [1355.27,709.313], [1370.76,649.738], [1368.86,694.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.1,615.053], [1357.18,662.419], [1372.68,604.1], [1370.76,649.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.04,567.148], [1359.1,615.023], [1374.62,557.99], [1372.68,604.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.01,518.725], [1361.04,567.118], [1376.58,511.401], [1374.62,557.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365,469.776], [1363.01,518.695], [1378.56,464.326], [1376.58,511.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.01,420.291], [1365,469.745], [1380.56,416.755], [1378.56,464.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.04,370.263], [1367.01,420.26], [1382.58,368.683], [1380.56,416.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.09,319.681], [1369.04,370.263], [1384.63,320.1], [1382.58,368.683]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1371.09,319.681], [1373.17,268.57], [1384.63,320.1], [1386.69,271.03]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[738.442,321.61], [737.258,281.007], [679.183,321.639], [677.773,282.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.442,321.61], [739.615,361.869], [679.183,321.639], [680.582,360.686]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[739.615,361.87], [740.778,401.741], [680.582,360.686], [681.968,399.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.778,401.766], [741.93,441.28], [681.968,399.391], [683.342,437.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.931,441.304], [743.073,480.465], [683.343,437.759], [684.704,475.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.073,480.489], [744.205,519.301], [684.705,475.794], [686.055,513.476]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.205,519.325], [745.327,557.793], [686.056,513.5], [687.394,550.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.328,557.817], [746.439,595.945], [687.395,550.882], [688.722,587.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.44,595.969], [747.542,633.763], [688.723,587.944], [690.038,624.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.542,633.786], [748.634,671.249], [690.039,624.689], [691.343,661.1]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.635,671.273], [749.718,708.409], [691.344,661.123], [692.637,697.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.718,708.409], [750.713,742.557], [692.637,697.226], [693.827,730.432]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[761.166,321.58], [760.053,279.752], [725.491,321.598], [724.234,280.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.166,321.58], [762.268,363.044], [725.491,321.598], [726.737,362.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.268,363.044], [763.36,404.097], [726.737,362.319], [727.972,402.642]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.361,404.123], [764.442,444.796], [727.973,402.668], [729.196,442.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.443,444.822], [765.515,485.12], [729.196,442.65], [730.408,482.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.516,485.146], [766.577,525.076], [730.409,482.271], [731.61,521.511]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.578,525.101], [767.63,564.666], [731.611,521.536], [732.801,560.423]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.631,564.691], [768.674,603.897], [732.802,560.448], [733.982,598.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.674,603.922], [769.707,642.774], [733.983,599.013], [735.152,637.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.708,642.798], [770.732,681.3], [735.153,637.236], [736.312,675.097]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.733,681.325], [771.747,719.482], [736.312,675.121], [737.461,712.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.747,719.482], [772.68,754.56], [737.461,712.648], [738.517,747.153]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.011,321.551], [791.007,364.212], [751.123,321.571], [752.283,363.41]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.007,364.212], [791.993,406.439], [752.283,363.41], [753.431,404.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.994,406.465], [792.97,448.29], [753.432,404.858], [754.57,445.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.971,448.317], [793.938,489.746], [754.571,445.918], [755.698,486.571]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.939,489.772], [794.897,530.811], [755.698,486.597], [756.815,526.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.898,530.837], [795.847,571.491], [756.816,526.9], [757.922,566.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.847,571.516], [796.788,611.791], [757.923,566.832], [759.019,606.374]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.788,611.816], [797.72,651.716], [759.02,606.399], [760.106,645.58]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.72,651.742], [798.643,691.273], [760.107,645.604], [761.183,684.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.644,691.298], [799.558,730.465], [761.184,684.454], [762.251,722.929]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.558,730.465], [800.399,766.463], [762.251,722.929], [763.231,758.296]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.011,321.551], [791.007,364.212], [802.601,321.563], [803.525,363.727]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.007,364.212], [791.993,406.439], [803.525,363.727], [804.441,405.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.994,406.465], [792.97,448.29], [804.441,405.493], [805.348,446.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[792.971,448.317], [793.938,489.746], [805.349,446.866], [806.247,487.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.939,489.772], [794.897,530.811], [806.247,487.852], [807.137,528.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.898,530.837], [795.847,571.491], [807.138,528.456], [808.02,568.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.847,571.516], [796.788,611.791], [808.02,568.683], [808.894,608.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.788,611.816], [797.72,651.716], [808.894,608.54], [809.76,648.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.721,651.742], [798.643,691.273], [809.76,648.03], [810.618,687.134]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.644,691.298], [799.558,730.465], [810.618,687.159], [811.468,725.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.558,730.465], [800.399,766.463], [811.468,725.907], [812.249,761.524]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.965,321.526], [874.572,365.171], [802.601,321.563], [803.525,363.727]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.572,365.172], [875.172,408.362], [803.525,363.727], [804.441,405.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.173,408.39], [875.767,451.16], [804.441,405.493], [805.348,446.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.768,451.187], [876.356,493.544], [805.349,446.866], [806.247,487.826]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.357,493.571], [876.94,535.519], [806.248,487.852], [807.138,528.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.94,535.546], [877.517,577.092], [807.138,528.456], [808.02,568.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.518,577.118], [878.09,618.268], [808.02,568.683], [808.894,608.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.09,618.294], [878.656,659.053], [808.894,608.539], [809.76,648.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.657,659.078], [879.218,699.452], [809.76,648.03], [810.618,687.134]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.218,699.478], [879.774,739.471], [810.618,687.159], [811.468,725.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.774,739.471], [880.285,776.222], [811.468,725.907], [812.249,761.524]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[963.109,321.593], [962.949,280.308], [849.046,321.645], [848.393,282.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.965,321.526], [874.572,365.171], [890.131,321.544], [890.65,364.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.572,365.172], [875.172,408.362], [890.65,364.481], [891.164,406.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.173,408.39], [875.767,451.16], [891.164,407.004], [891.672,449.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.768,451.187], [876.356,493.544], [891.673,449.12], [892.176,490.809]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.357,493.571], [876.94,535.519], [892.176,490.836], [892.675,532.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.94,535.546], [877.517,577.092], [892.675,532.155], [893.17,573.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.518,577.118], [878.09,618.268], [893.17,573.085], [893.659,613.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.09,618.294], [878.656,659.053], [893.66,613.63], [894.144,653.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.657,659.079], [879.218,699.452], [894.145,653.797], [894.625,693.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.218,699.478], [879.774,739.471], [894.625,693.589], [895.101,732.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.774,739.471], [880.285,776.222], [895.101,732.988], [895.539,769.197]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.613,321.531], [915.018,364.964], [890.131,321.544], [890.65,364.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.018,364.964], [915.419,407.947], [890.65,364.481], [891.163,406.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.419,407.974], [915.816,450.54], [891.164,407.004], [891.672,449.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.816,450.567], [916.209,492.724], [891.672,449.12], [892.176,490.809]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.209,492.75], [916.599,534.503], [892.176,490.836], [892.675,532.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.599,534.529], [916.984,575.883], [892.675,532.155], [893.169,573.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.985,575.909], [917.366,616.87], [893.17,573.085], [893.659,613.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.367,616.896], [917.745,657.469], [893.659,613.63], [894.144,653.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.745,657.495], [918.12,697.686], [894.145,653.797], [894.625,693.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.12,697.712], [918.491,737.527], [894.625,693.589], [895.101,732.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.491,737.527], [918.832,774.116], [895.101,732.988], [895.538,769.197]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.613,321.531], [915.018,364.964], [925.832,321.544], [926.178,364.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.018,364.964], [915.419,407.947], [926.178,364.466], [926.521,406.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.419,407.974], [915.816,450.54], [926.521,406.976], [926.86,449.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.816,450.567], [916.21,492.724], [926.86,449.079], [927.196,490.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.21,492.75], [916.599,534.503], [927.197,490.781], [927.529,532.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.599,534.529], [916.985,575.883], [927.529,532.087], [927.859,572.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.985,575.909], [917.367,616.87], [927.859,573.004], [928.186,613.511]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.367,616.895], [917.745,657.469], [928.186,613.537], [928.509,653.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.746,657.495], [918.12,697.687], [928.51,653.69], [928.83,693.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.121,697.712], [918.492,737.527], [928.83,693.471], [929.148,732.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.492,737.527], [918.833,774.116], [929.148,732.858], [929.439,769.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.83,321.479], [1017.73,367.043], [989.078,321.493], [989.12,366.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.73,367.043], [1017.63,412.113], [989.12,366.474], [989.162,410.974]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.63,412.142], [1017.52,456.754], [989.162,411.002], [989.203,455.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.52,456.783], [1017.42,500.945], [989.203,455.084], [989.244,498.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.42,500.973], [1017.32,544.691], [989.244,498.726], [989.285,541.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.32,544.719], [1017.22,588], [989.285,541.934], [989.325,584.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.22,588.027], [1017.12,630.877], [989.325,584.716], [989.365,627.051]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.12,630.904], [1017.03,673.331], [989.365,627.078], [989.405,668.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1017.03,673.357], [1016.93,715.365], [989.405,669.025], [989.444,710.538]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1016.93,715.392], [1016.84,756.988], [989.444,710.564], [989.482,751.675]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1016.84,756.988], [1016.75,795.197], [989.482,751.675], [989.518,789.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1086.7,321.415], [1086.21,369.565], [1002.27,321.459], [1002.25,367.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1086.21,369.565], [1085.74,417.166], [1002.25,367.855], [1002.22,413.74]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.74,417.196], [1085.26,464.286], [1002.22,413.769], [1002.2,459.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.26,464.316], [1084.79,510.904], [1002.2,459.209], [1002.17,504.152]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.79,510.934], [1084.33,557.028], [1002.17,504.181], [1002.15,548.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.33,557.057], [1083.87,602.664], [1002.15,548.693], [1002.12,592.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.87,602.693], [1083.42,647.822], [1002.12,592.752], [1002.1,636.338]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.42,647.85], [1082.97,692.507], [1002.1,636.365], [1002.08,679.512]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.97,692.536], [1082.53,736.729], [1002.08,679.539], [1002.05,722.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.53,736.757], [1082.09,780.494], [1002.05,722.28], [1002.03,764.567]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.09,780.494], [1081.68,820.648], [1002.03,764.567], [1002.01,803.404]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1183.11,321.492], [1184.06,276.024], [1032.85,321.561], [1033.02,278.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.89,705.154], [1123.21,750.779], [1073.63,696.95], [1073.23,741.645]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.21,750.807], [1122.54,795.945], [1073.23,741.673], [1072.84,785.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.54,795.945], [1121.92,837.371], [1072.84,785.9], [1072.47,826.5]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.97,565.185], [1125.27,612.321], [1074.86,559.899], [1074.45,606.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.27,612.351], [1124.57,658.975], [1074.45,606.071], [1074.04,651.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.57,659.004], [1123.89,705.125], [1074.04,651.752], [1073.63,696.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.4,469.284], [1126.68,517.469], [1075.7,466.053], [1075.28,513.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.68,517.5], [1125.97,565.155], [1075.28,513.23], [1074.86,559.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.86,371.23], [1128.12,420.5], [1076.56,370.147], [1076.13,418.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.12,420.531], [1127.4,469.253], [1076.13,418.362], [1075.7,466.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.6,321.373], [1128.86,371.23], [1077,321.401], [1076.56,370.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.6,802.094], [1180.69,844.025], [1131.89,792.166], [1131.23,833.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.61,756.4], [1181.6,802.094], [1132.6,747.37], [1131.89,792.165]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.64,663.446], [1183.62,710.148], [1134.06,656.275], [1133.33,702.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.62,710.178], [1182.61,756.371], [1133.33,702.066], [1132.6,747.342]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.68,616.198], [1184.64,663.417], [1134.8,609.987], [1134.06,656.245]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.72,568.424], [1185.68,616.168], [1135.54,563.196], [1134.8,609.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.85,471.265], [1187.78,520.085], [1137.06,468.068], [1136.3,515.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.78,520.116], [1186.73,568.394], [1136.3,515.892], [1135.55,563.166]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.94,421.861], [1188.85,471.234], [1137.84,419.714], [1137.07,468.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.03,371.894], [1189.94,421.829], [1138.62,370.823], [1137.84,419.683]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.14,321.356], [1191.03,371.894], [1139.41,321.383], [1138.62,370.822]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1192.14,321.357], [1193.26,270.27], [1139.41,321.384], [1140.21,271.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.6,802.094], [1180.69,844.025], [1191.18,795.38], [1190.22,836.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.61,756.4], [1181.6,802.094], [1192.22,750.294], [1191.18,795.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.62,710.178], [1182.61,756.371], [1193.27,704.692], [1192.22,750.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.64,663.446], [1183.62,710.148], [1194.33,658.596], [1193.27,704.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.68,616.198], [1184.64,663.417], [1195.4,611.998], [1194.33,658.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.73,568.424], [1185.68,616.168], [1196.49,564.888], [1195.4,611.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.78,520.116], [1186.73,568.394], [1197.58,517.259], [1196.49,564.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.85,471.265], [1187.78,520.085], [1198.69,469.102], [1197.58,517.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.94,421.861], [1188.85,471.234], [1199.81,420.409], [1198.69,469.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.03,371.894], [1189.94,421.829], [1200.95,371.169], [1199.82,420.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.89,813.367], [1281.43,856.221], [1191.18,795.38], [1190.22,836.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.14,321.356], [1191.03,371.894], [1202.1,321.374], [1200.95,371.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.48,766.656], [1282.89,813.367], [1192.22,750.294], [1191.18,795.38]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1192.14,321.357], [1193.26,270.27], [1202.1,321.375], [1203.26,271.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.09,719.392], [1284.48,766.626], [1193.27,704.692], [1192.22,750.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.71,671.595], [1286.09,719.362], [1194.33,658.596], [1193.27,704.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.36,623.257], [1287.71,671.565], [1195.4,611.998], [1194.33,658.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.02,574.368], [1289.36,623.226], [1196.49,564.888], [1195.4,611.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.7,524.92], [1291.02,574.337], [1197.58,517.259], [1196.49,564.858]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.4,474.901], [1292.7,524.888], [1198.69,469.102], [1197.58,517.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.12,424.303], [1294.4,474.869], [1199.82,420.409], [1198.69,469.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.87,373.114], [1296.13,424.27], [1200.95,371.169], [1199.82,420.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.63,321.325], [1297.87,373.114], [1202.1,321.374], [1200.95,371.169]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1299.63,321.326], [1301.41,268.96], [1202.1,321.375], [1203.26,271.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.89,813.367], [1281.43,856.222], [1299.35,799.501], [1297.85,841.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.48,766.656], [1282.89,813.367], [1300.98,754.041], [1299.35,799.501]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.09,719.392], [1284.48,766.626], [1302.63,708.058], [1300.98,754.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.71,671.595], [1286.09,719.362], [1304.3,661.573], [1302.63,708.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.36,623.257], [1287.71,671.565], [1305.99,614.575], [1304.3,661.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.02,574.368], [1289.36,623.226], [1307.7,567.058], [1305.99,614.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.7,524.92], [1291.02,574.337], [1309.42,519.012], [1307.7,567.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.4,474.901], [1292.7,524.888], [1311.17,470.429], [1309.42,518.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.12,424.303], [1294.4,474.869], [1312.93,421.299], [1311.17,470.398]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.87,373.114], [1296.13,424.27], [1314.72,371.614], [1312.93,421.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.63,321.325], [1297.87,373.114], [1316.52,321.363], [1314.71,371.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1331.24,805.539], [1299.35,799.501], [1329.57,847.753], [1297.85,841.219]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1299.63,321.326], [1301.41,268.96], [1316.52,321.364], [1318.34,270.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1333.07,759.534], [1300.98,754.041], [1331.24,805.539], [1299.35,799.5]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.92,712.993], [1302.63,708.058], [1333.07,759.505], [1300.98,754.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.79,665.936], [1304.3,661.572], [1334.92,712.964], [1302.63,708.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1338.68,618.354], [1305.99,614.575], [1336.79,665.906], [1304.3,661.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.59,570.24], [1338.68,618.324], [1307.7,567.058], [1305.99,614.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1342.53,521.583], [1340.59,570.209], [1309.42,519.012], [1307.7,567.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.48,472.375], [1342.53,521.552], [1311.17,470.429], [1309.42,518.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.46,422.606], [1344.48,472.344], [1312.93,421.299], [1311.17,470.398]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.46,372.267], [1346.46,422.575], [1314.71,371.614], [1312.93,421.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.48,321.347], [1348.46,372.267], [1316.52,321.363], [1314.71,371.614]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1350.48,321.347], [1352.53,269.869], [1316.52,321.363], [1318.34,270.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1331.24,805.539], [1329.57,847.753], [1350.55,788.084], [1348.84,828.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1333.07,759.534], [1331.24,805.539], [1352.41,743.658], [1350.55,788.084]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.92,712.993], [1333.07,759.505], [1354.29,698.733], [1352.41,743.63]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.79,665.936], [1334.92,712.964], [1356.2,653.328], [1354.3,698.704]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1338.68,618.354], [1336.79,665.906], [1358.12,607.435], [1356.2,653.299]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.59,570.24], [1338.68,618.324], [1360.07,561.048], [1358.13,607.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1342.53,521.583], [1340.59,570.209], [1362.04,514.157], [1360.07,561.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.48,472.375], [1342.53,521.552], [1364.03,466.755], [1362.04,514.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.46,422.606], [1344.48,472.344], [1366.04,418.833], [1364.03,466.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.46,372.267], [1346.46,422.575], [1368.07,370.382], [1366.04,418.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.48,321.347], [1348.46,372.267], [1370.12,321.394], [1368.07,370.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1337.2,785.574], [1335.56,826.147], [1354.83,770.115], [1353.17,809.411]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1350.48,321.347], [1352.53,269.869], [1370.12,321.394], [1372.2,271.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1338.98,741.376], [1337.2,785.574], [1356.65,727.322], [1354.83,770.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1340.78,696.684], [1338.98,741.348], [1358.48,684.065], [1356.65,727.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1342.61,651.516], [1340.78,696.655], [1360.33,640.364], [1358.48,684.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1344.45,605.867], [1342.61,651.487], [1362.2,596.213], [1360.33,640.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.31,559.728], [1344.45,605.838], [1364.09,551.605], [1362.2,596.185]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.19,513.091], [1346.31,559.698], [1366,506.531], [1364.09,551.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.09,465.948], [1348.19,513.061], [1367.93,460.986], [1366,506.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1352.02,418.292], [1350.09,465.918], [1369.88,414.962], [1367.93,460.957]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1353.96,370.112], [1352.02,418.261], [1371.85,368.45], [1369.88,414.932]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.93,321.402], [1353.96,370.112], [1373.84,321.444], [1371.85,368.45]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1355.93,321.401], [1357.9,272.466], [1373.84,321.443], [1375.84,274.238]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[750.944,321.287], [749.807,281.765], [697.606,321.058], [696.269,282.851]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.944,321.287], [752.072,360.472], [697.606,321.058], [698.932,358.952]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.072,360.472], [753.188,399.276], [698.932,358.952], [700.245,396.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.189,399.301], [754.295,437.754], [700.246,396.512], [701.548,433.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.296,437.778], [755.392,475.883], [701.549,433.743], [702.839,470.625]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.393,475.907], [756.479,513.671], [702.84,470.649], [704.12,507.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.48,513.694], [757.556,551.12], [704.12,507.234], [705.389,543.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.557,551.143], [758.624,588.236], [705.39,543.502], [706.647,579.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.625,588.259], [759.683,625.023], [706.648,579.458], [707.894,615.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.683,625.046], [760.732,661.485], [707.895,615.105], [709.131,650.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.732,661.508], [761.771,697.627], [709.132,650.448], [710.357,685.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.771,697.627], [762.727,730.837], [710.357,685.469], [711.485,717.677]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[769.567,321.5], [768.483,280.752], [737.392,321.36], [736.18,281.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.567,321.5], [770.641,361.89], [737.392,321.36], [738.594,360.956]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.641,361.891], [771.705,401.876], [738.594,360.956], [739.784,400.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.705,401.902], [772.759,441.514], [739.785,400.188], [740.964,439.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.76,441.539], [773.803,480.783], [740.964,439.061], [742.133,477.555]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.804,480.808], [774.838,519.689], [742.134,477.58], [743.291,515.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.839,519.714], [775.863,558.237], [743.292,515.749], [744.439,553.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.864,558.261], [776.879,596.431], [744.44,553.573], [745.577,591.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.88,596.455], [777.886,634.276], [745.578,591.057], [746.704,628.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.886,634.3], [778.883,671.778], [746.705,628.205], [747.822,664.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.884,671.802], [779.871,708.94], [747.823,665.023], [748.929,701.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.871,708.94], [780.779,743.079], [748.929,701.49], [749.947,735.018]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.114,321.715], [795.101,363.32], [758.986,321.56], [760.119,362.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.101,363.321], [796.078,404.497], [760.119,362.286], [761.241,402.601]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.079,404.524], [797.047,445.304], [761.242,402.626], [762.354,442.561]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.047,445.33], [798.006,485.721], [762.354,442.587], [763.455,482.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.006,485.746], [798.956,525.752], [763.456,482.173], [764.547,521.365]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.956,525.777], [799.897,565.404], [764.547,521.39], [765.628,560.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.897,565.429], [800.829,604.681], [765.629,560.242], [766.699,598.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.83,604.706], [801.752,643.59], [766.7,598.736], [767.761,636.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.753,643.614], [802.667,682.134], [767.762,636.875], [768.813,674.641]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.668,682.159], [803.573,720.321], [768.813,674.665], [769.855,712.087]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.573,720.321], [804.406,755.391], [769.855,712.087], [770.812,746.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.114,321.715], [795.101,363.32], [807.508,321.636], [808.421,362.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[795.101,363.321], [796.078,404.497], [808.421,362.795], [809.324,403.535]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[796.079,404.524], [797.047,445.304], [809.325,403.561], [810.219,443.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[797.047,445.33], [798.006,485.721], [810.22,443.938], [811.106,483.908]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.007,485.746], [798.956,525.752], [811.106,483.933], [811.984,523.526]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[798.957,525.777], [799.897,565.404], [811.984,523.551], [812.854,562.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.898,565.429], [800.829,604.681], [812.854,562.797], [813.716,601.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.83,604.706], [801.752,643.59], [813.716,601.677], [814.57,640.171]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.753,643.614], [802.667,682.134], [814.57,640.195], [815.416,678.333]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.668,682.159], [803.573,720.321], [815.416,678.357], [816.254,716.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.573,720.321], [804.406,755.391], [816.254,716.144], [817.024,750.873]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.508,321.919], [873.132,364.674], [807.508,321.636], [808.421,362.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.132,364.674], [873.749,406.978], [808.421,362.795], [809.324,403.535]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.749,407.005], [874.36,448.89], [809.325,403.561], [810.219,443.912]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.36,448.917], [874.965,490.39], [810.22,443.938], [811.106,483.908]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.965,490.417], [875.564,531.485], [811.106,483.933], [811.984,523.526]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.565,531.511], [876.158,572.179], [811.984,523.551], [812.854,562.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.158,572.204], [876.745,612.478], [812.855,562.797], [813.716,601.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.746,612.504], [877.327,652.389], [813.716,601.677], [814.57,640.171]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.328,652.414], [877.904,691.917], [814.57,640.195], [815.416,678.333]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.904,691.942], [878.475,731.068], [815.416,678.357], [816.254,716.144]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.475,731.068], [878.999,767.015], [816.254,716.144], [817.024,750.873]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[966.673,321.493], [966.527,280.784], [861.179,321.083], [860.569,282.734]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.508,321.919], [873.132,364.674], [890.072,321.805], [890.599,363.919]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.132,364.674], [873.749,406.978], [890.6,363.919], [891.122,405.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.749,407.005], [874.36,448.89], [891.122,405.62], [891.639,446.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.36,448.917], [874.965,490.39], [891.64,446.916], [892.152,487.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.965,490.417], [875.564,531.485], [892.152,487.811], [892.659,528.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.565,531.511], [876.158,572.179], [892.66,528.312], [893.162,568.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.158,572.204], [876.745,612.478], [893.162,568.424], [893.66,608.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.746,612.504], [877.327,652.389], [893.66,608.154], [894.153,647.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.328,652.414], [877.904,691.917], [894.154,647.506], [894.642,686.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.904,691.942], [878.475,731.068], [894.642,686.485], [895.126,725.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.475,731.068], [878.999,767.015], [895.126,725.073], [895.57,760.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.56,321.901], [912.982,364.552], [890.072,321.805], [890.599,363.919]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.982,364.553], [913.4,406.755], [890.599,363.919], [891.122,405.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.4,406.782], [913.814,448.568], [891.122,405.62], [891.639,446.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.814,448.594], [914.224,489.971], [891.64,446.915], [892.152,487.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.225,489.997], [914.631,530.97], [892.152,487.811], [892.659,528.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.631,530.996], [915.033,571.57], [892.66,528.312], [893.162,568.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.033,571.596], [915.431,611.778], [893.162,568.424], [893.66,608.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.431,611.803], [915.826,651.599], [893.66,608.154], [894.153,647.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.826,651.624], [916.216,691.039], [894.153,647.506], [894.642,686.461]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.217,691.064], [916.603,730.103], [894.642,686.485], [895.125,725.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.603,730.103], [916.959,765.972], [895.125,725.073], [895.57,760.532]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.56,321.901], [912.982,364.552], [924.858,321.818], [925.215,364.006]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.982,364.553], [913.4,406.755], [925.215,364.006], [925.569,405.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.401,406.782], [913.814,448.568], [925.569,405.78], [925.919,447.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.815,448.594], [914.225,489.971], [925.92,447.147], [926.266,488.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.225,489.997], [914.631,530.97], [926.267,488.112], [926.61,528.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.631,530.996], [915.033,571.57], [926.61,528.681], [926.951,568.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.033,571.596], [915.432,611.778], [926.951,568.861], [927.288,608.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.432,611.803], [915.826,651.599], [927.288,608.657], [927.621,648.048]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.826,651.624], [916.217,691.039], [927.622,648.073], [927.952,687.091]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.217,691.064], [916.604,730.103], [927.952,687.116], [928.28,725.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.604,730.103], [916.959,765.972], [928.28,725.766], [928.581,761.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.88,322.313], [1007.82,367.288], [981.192,322.199], [981.276,366.535]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.82,367.288], [1007.77,411.765], [981.276,366.535], [981.359,410.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.77,411.793], [1007.71,455.809], [981.359,410.415], [981.442,453.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.71,455.836], [1007.66,499.396], [981.442,453.845], [981.523,496.806]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.66,499.424], [1007.61,542.536], [981.523,496.833], [981.604,539.358]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.61,542.564], [1007.56,585.235], [981.604,539.384], [981.684,581.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.56,585.262], [1007.51,627.499], [981.684,581.507], [981.763,623.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.51,627.525], [1007.45,669.334], [981.763,623.206], [981.841,664.463]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.45,669.361], [1007.4,710.749], [981.841,664.489], [981.919,705.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.4,710.775], [1007.35,751.748], [981.919,705.362], [981.996,745.804]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1007.35,751.748], [1007.31,789.376], [981.996,745.805], [982.066,782.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.81,322.79], [1068.41,370.458], [990.31,322.448], [990.348,368.187]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.41,370.458], [1068.02,417.569], [990.348,368.187], [990.385,413.411]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1068.02,417.599], [1067.63,464.191], [990.385,413.44], [990.423,458.187]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.63,464.22], [1067.25,510.303], [990.423,458.215], [990.459,502.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.25,510.332], [1066.87,555.912], [990.459,502.52], [990.496,546.333]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.87,555.941], [1066.49,601.028], [990.496,546.361], [990.532,589.719]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.49,601.057], [1066.12,645.658], [990.532,589.746], [990.568,632.655]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.12,645.686], [1065.75,689.81], [990.568,632.683], [990.603,675.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.75,689.838], [1065.39,733.491], [990.603,675.177], [990.638,717.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.39,733.519], [1065.03,776.71], [990.638,717.236], [990.673,758.841]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.03,776.71], [1064.7,816.353], [990.673,758.841], [990.705,797.043]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1173.68,322.299], [1174.62,276.953], [1031.79,321.747], [1031.96,279.579]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.26,748.484], [1100.69,793.126], [1054.64,738.159], [1054.34,781.8]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.69,793.126], [1100.17,834.086], [1054.34,781.8], [1054.06,821.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.01,611.464], [1102.42,657.618], [1055.58,604.282], [1055.27,649.365]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.42,657.647], [1101.84,703.288], [1055.27,649.394], [1054.95,693.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.84,703.317], [1101.26,748.455], [1054.95,694.017], [1054.64,738.131]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.82,469.753], [1104.21,517.496], [1056.55,465.935], [1056.23,512.531]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.21,517.526], [1103.61,564.73], [1056.23,512.561], [1055.9,558.645]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.6,564.76], [1103.01,611.434], [1055.9,558.674], [1055.58,604.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.69,323.106], [1106.06,372.552], [1057.56,322.888], [1057.22,371.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.06,372.553], [1105.43,421.401], [1057.22,371.107], [1056.89,418.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.43,421.432], [1104.82,469.723], [1056.89,418.786], [1056.55,465.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.67,755.585], [1157.78,800.914], [1111.7,745.312], [1111.08,789.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.78,800.914], [1156.95,842.497], [1111.08,789.647], [1110.51,830.329]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.5,663.326], [1159.58,709.686], [1112.96,655.111], [1112.33,700.431]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.58,709.715], [1158.67,755.556], [1112.33,700.46], [1111.7,745.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.43,616.407], [1160.5,663.296], [1113.61,609.257], [1112.96,655.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.32,520.945], [1162.37,568.919], [1114.92,516], [1114.26,562.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.37,568.95], [1161.43,616.377], [1114.26,562.89], [1113.61,609.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.29,472.383], [1163.33,520.914], [1115.58,468.579], [1114.92,515.97]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1166.25,373.549], [1165.26,423.223], [1116.93,372.108], [1116.25,420.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.26,423.255], [1164.29,472.352], [1116.25,420.619], [1115.58,468.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.24,323.256], [1166.25,373.549], [1117.62,323.038], [1116.93,372.108]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1167.24,323.256], [1168.25,272.399], [1117.62,323.039], [1118.32,273.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.78,800.914], [1156.95,842.497], [1169.32,794.52], [1168.45,835.591]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.67,755.585], [1157.78,800.914], [1170.27,749.754], [1169.32,794.519]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.58,709.715], [1158.67,755.556], [1171.23,704.462], [1170.27,749.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.5,663.326], [1159.58,709.686], [1172.2,658.663], [1171.23,704.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.43,616.407], [1160.5,663.296], [1173.19,612.348], [1172.2,658.633]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.33,520.945], [1162.37,568.919], [1175.19,518.138], [1174.18,565.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.37,568.95], [1161.43,616.377], [1174.18,565.509], [1173.19,612.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.29,472.383], [1163.33,520.914], [1176.2,470.223], [1175.19,518.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.26,423.254], [1164.29,472.352], [1177.23,421.758], [1176.2,470.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1166.25,373.549], [1165.26,423.223], [1178.27,372.731], [1177.23,421.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.24,323.256], [1166.25,373.549], [1179.33,323.132], [1178.27,372.731]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1167.24,323.256], [1168.25,272.398], [1179.33,323.133], [1180.39,272.986]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.8,768.536], [1256.31,815.114], [1170.27,749.754], [1169.32,794.52]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.31,815.114], [1254.94,857.829], [1169.32,794.52], [1168.45,835.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.31,721.387], [1257.8,768.506], [1171.23,704.462], [1170.27,749.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.84,673.688], [1259.31,721.357], [1172.2,658.663], [1171.23,704.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.39,625.429], [1260.84,673.658], [1173.19,612.348], [1172.2,658.633]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.95,576.599], [1262.39,625.398], [1174.18,565.509], [1173.19,612.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.54,527.188], [1263.96,576.568], [1175.19,518.137], [1174.18,565.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.14,477.187], [1265.54,527.157], [1176.2,470.223], [1175.19,518.107]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.76,426.585], [1267.14,477.156], [1177.23,421.758], [1176.2,470.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.41,375.37], [1268.77,426.553], [1178.27,372.731], [1177.23,421.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.07,323.53], [1270.41,375.369], [1179.33,323.132], [1178.27,372.731]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1272.07,323.531], [1273.75,271.09], [1179.33,323.133], [1180.39,272.986]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.31,815.114], [1254.94,857.829], [1277.12,801.75], [1275.68,843.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.8,768.536], [1256.31,815.114], [1278.69,756.347], [1277.12,801.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.31,721.387], [1257.8,768.506], [1280.28,710.402], [1278.69,756.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.84,673.688], [1259.31,721.357], [1281.88,663.935], [1280.28,710.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.39,625.429], [1260.84,673.658], [1283.51,616.937], [1281.88,663.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.95,576.599], [1262.39,625.398], [1285.15,569.4], [1283.51,616.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.54,527.188], [1263.96,576.568], [1286.81,521.312], [1285.15,569.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.14,477.187], [1265.54,527.157], [1288.5,472.666], [1286.82,521.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.76,426.585], [1267.14,477.156], [1290.2,423.45], [1288.5,472.635]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.41,375.37], [1268.77,426.553], [1291.92,373.656], [1290.2,423.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.07,323.53], [1270.41,375.369], [1293.66,323.272], [1291.92,373.656]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1272.07,323.531], [1273.75,271.09], [1293.66,323.272], [1295.42,272.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.71,808.73], [1277.12,801.75], [1306.09,850.937], [1275.68,843.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.47,762.713], [1278.69,756.347], [1307.71,808.73], [1277.12,801.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.26,716.139], [1280.27,710.402], [1309.47,762.683], [1278.69,756.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.07,669.028], [1311.26,716.109], [1281.88,663.935], [1280.28,710.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.9,621.371], [1313.07,668.998], [1283.51,616.937], [1281.88,663.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1316.75,573.158], [1314.9,621.341], [1285.15,569.399], [1283.51,616.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1318.62,524.38], [1316.75,573.128], [1286.81,521.312], [1285.15,569.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1320.52,475.026], [1318.63,524.349], [1288.5,472.665], [1286.81,521.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.44,425.086], [1320.52,474.995], [1290.2,423.45], [1288.5,472.635]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.38,374.55], [1322.44,425.055], [1291.92,373.656], [1290.2,423.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.34,323.407], [1324.38,374.55], [1293.66,323.272], [1291.92,373.656]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1326.34,323.407], [1328.33,271.678], [1293.66,323.272], [1295.42,272.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.71,808.73], [1306.09,850.937], [1332.66,791.792], [1330.97,832.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.47,762.713], [1307.71,808.73], [1334.5,747.267], [1332.66,791.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.26,716.139], [1309.47,762.683], [1336.37,702.221], [1334.5,747.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.07,669.028], [1311.26,716.109], [1338.25,656.674], [1336.37,702.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.9,621.371], [1313.07,668.998], [1340.16,610.617], [1338.25,656.645]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1316.75,573.158], [1314.9,621.341], [1342.09,564.043], [1340.16,610.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1318.62,524.38], [1316.75,573.128], [1344.04,516.941], [1342.09,564.013]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1320.52,475.026], [1318.63,524.349], [1346.01,469.303], [1344.04,516.911]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1322.44,425.086], [1320.52,474.995], [1348,421.12], [1346.01,469.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1324.38,374.55], [1322.44,425.055], [1350.02,372.382], [1348.01,421.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.34,323.407], [1324.38,374.55], [1352.06,323.08], [1350.02,372.382]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1326.34,323.407], [1328.33,271.678], [1352.06,323.08], [1354.13,273.235]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1319.8,788.891], [1318.18,829.512], [1342.49,773.855], [1340.82,813.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1321.56,744.622], [1319.8,788.891], [1344.32,730.917], [1342.49,773.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1323.34,699.839], [1321.56,744.594], [1346.16,687.494], [1344.32,730.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1325.14,654.56], [1323.34,699.81], [1348.03,643.607], [1346.16,687.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1326.96,608.778], [1325.14,654.531], [1349.91,599.248], [1348.03,643.579]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1328.81,562.483], [1326.97,608.748], [1351.82,554.409], [1349.92,599.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1330.67,515.669], [1328.81,562.454], [1353.75,509.082], [1351.82,554.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1332.55,468.324], [1330.67,515.639], [1355.7,463.26], [1353.75,509.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1334.46,420.442], [1332.55,468.294], [1357.67,416.933], [1355.7,463.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1336.39,372.012], [1334.46,420.411], [1359.66,370.095], [1357.67,416.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1338.34,323.024], [1336.39,372.012], [1361.67,322.735], [1359.66,370.095]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1338.34,323.024], [1340.29,273.787], [1361.67,322.735], [1363.69,275.153]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[764.434,320.65], [763.348,282.145], [716.9,320.123], [715.639,282.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.434,320.65], [765.51,358.824], [716.9,320.123], [718.15,356.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.51,358.824], [766.576,396.622], [718.15,356.944], [719.388,393.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.577,396.646], [767.633,434.099], [719.389,393.44], [720.616,429.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.634,434.123], [768.68,471.234], [720.617,429.612], [721.833,465.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.681,471.257], [769.718,508.032], [721.834,465.467], [723.04,500.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.718,508.055], [770.746,544.498], [723.041,501.008], [724.236,536.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.747,544.521], [771.765,580.635], [724.237,536.238], [725.422,571.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.766,580.658], [772.775,616.45], [725.423,571.163], [726.597,605.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.776,616.473], [773.776,651.945], [726.598,605.787], [727.763,640.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.777,651.968], [774.768,687.126], [727.763,640.112], [728.918,674.122]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.768,687.126], [775.68,719.449], [728.918,674.122], [729.98,705.399]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[779.096,321.117], [778.046,281.394], [750.392,320.792], [749.23,281.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.096,321.117], [780.136,360.486], [750.392,320.792], [751.545,359.329]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.136,360.487], [781.166,399.458], [751.545,359.329], [752.685,397.484]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.167,399.483], [782.187,438.086], [752.686,397.508], [753.816,435.311]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.188,438.111], [783.198,476.351], [753.817,435.335], [754.937,472.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.199,476.376], [784.2,514.259], [754.938,472.813], [756.047,509.925]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.201,514.283], [785.192,551.813], [756.048,509.948], [757.147,546.721]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.193,551.837], [786.176,589.02], [757.148,546.745], [758.238,583.185]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.176,589.044], [787.15,625.883], [758.238,583.208], [759.318,619.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.15,625.907], [788.115,662.409], [759.319,619.341], [760.389,655.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.116,662.432], [789.072,698.6], [760.389,655.15], [761.45,690.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.072,698.6], [789.95,731.844], [761.45,690.615], [762.425,723.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.438,321.594], [800.411,362.184], [768.074,321.233], [769.176,360.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.41,362.185], [801.373,402.352], [769.176,360.9], [770.266,400.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.374,402.378], [802.327,442.155], [770.266,400.187], [771.346,439.076]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.328,442.18], [803.272,481.572], [771.346,439.101], [772.416,477.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.272,481.597], [804.207,520.609], [772.417,477.647], [773.476,515.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.208,520.634], [805.134,559.272], [773.477,515.829], [774.526,553.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.134,559.296], [806.052,597.565], [774.526,553.653], [775.566,591.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.052,597.59], [806.961,635.496], [775.567,591.125], [776.597,628.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.961,635.52], [807.861,673.067], [776.597,628.248], [777.618,665.004]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.862,673.091], [808.753,710.285], [777.618,665.028], [778.629,701.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.753,710.285], [809.572,744.463], [778.629,701.446], [779.559,734.917]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[799.438,321.594], [800.411,362.184], [813.504,321.439], [814.399,361.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[800.411,362.184], [801.373,402.352], [814.398,361.633], [815.284,401.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[801.374,402.378], [802.327,442.155], [815.285,401.438], [816.162,440.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[802.328,442.18], [803.272,481.572], [816.162,440.859], [817.031,479.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[803.272,481.597], [804.207,520.609], [817.031,479.902], [817.892,518.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.208,520.634], [805.134,559.272], [817.892,518.572], [818.745,556.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.135,559.296], [806.052,597.566], [818.745,556.875], [819.589,594.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.052,597.59], [806.961,635.496], [819.59,594.816], [820.426,632.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.961,635.52], [807.861,673.067], [820.427,632.4], [821.255,669.609]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.862,673.091], [808.753,710.285], [821.255,669.632], [822.076,706.494]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.753,710.285], [809.572,744.463], [822.076,706.494], [822.83,740.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.002,322.099], [872.638,363.981], [813.504,321.439], [814.399,361.633]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.638,363.981], [873.267,405.414], [814.399,361.633], [815.284,401.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.268,405.44], [873.891,446.457], [815.285,401.438], [816.162,440.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.891,446.483], [874.508,487.091], [816.162,440.859], [817.031,479.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.508,487.117], [875.118,527.321], [817.032,479.902], [817.892,518.548]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.119,527.346], [875.723,567.153], [817.893,518.572], [818.745,556.851]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.723,567.178], [876.322,606.593], [818.745,556.875], [819.589,594.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.322,606.618], [876.915,645.647], [819.59,594.816], [820.426,632.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.915,645.671], [877.502,684.32], [820.427,632.4], [821.255,669.609]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.503,684.345], [878.084,722.618], [821.256,669.632], [822.076,706.494]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.084,722.618], [878.617,757.779], [822.076,706.494], [822.83,740.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.002,322.099], [872.638,363.981], [890.773,321.874], [891.307,363.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.638,363.981], [873.267,405.414], [891.307,363.181], [891.835,404.051]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[970.356,321.281], [970.224,281.132], [873.742,320.312], [873.179,282.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.268,405.44], [873.891,446.457], [891.835,404.077], [892.357,444.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.891,446.483], [874.508,487.091], [892.358,444.568], [892.875,484.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.508,487.117], [875.118,527.321], [892.875,484.661], [893.388,524.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.119,527.346], [875.723,567.153], [893.388,524.36], [893.895,563.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.724,567.178], [876.322,606.593], [893.896,563.672], [894.398,602.577]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.322,606.618], [876.915,645.647], [894.398,602.602], [894.896,641.131]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.915,645.671], [877.502,684.32], [894.896,641.156], [895.389,679.315]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.503,684.345], [878.084,722.618], [895.389,679.339], [895.877,717.133]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.084,722.618], [878.618,757.779], [895.877,717.133], [896.325,751.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.183,322.098], [911.62,363.978], [890.773,321.874], [891.307,363.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.62,363.979], [912.052,405.41], [891.307,363.181], [891.834,404.051]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.052,405.436], [912.481,446.452], [891.835,404.077], [892.357,444.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.481,446.478], [912.905,487.084], [892.358,444.568], [892.875,484.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.905,487.11], [913.325,527.312], [892.875,484.661], [893.387,524.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.325,527.338], [913.741,567.143], [893.388,524.36], [893.895,563.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.741,567.168], [914.153,606.581], [893.895,563.672], [894.398,602.577]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.153,606.606], [914.56,645.634], [894.398,602.602], [894.895,641.131]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.561,645.659], [914.964,684.306], [894.896,641.156], [895.388,679.315]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.964,684.33], [915.364,722.603], [895.389,679.339], [895.877,717.133]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.364,722.603], [915.731,757.762], [895.877,717.133], [896.325,751.857]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.183,322.098], [911.62,363.978], [924.429,321.935], [924.796,363.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.62,363.978], [912.052,405.41], [924.796,363.398], [925.158,404.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.053,405.436], [912.481,446.452], [925.158,404.446], [925.517,445.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.481,446.478], [912.905,487.084], [925.518,445.087], [925.873,485.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.906,487.11], [913.325,527.312], [925.873,485.325], [926.225,525.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.326,527.338], [913.741,567.143], [926.225,525.168], [926.574,564.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.742,567.168], [914.153,606.581], [926.574,564.62], [926.919,603.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.153,606.606], [914.561,645.634], [926.919,603.689], [927.261,642.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.561,645.658], [914.965,684.306], [927.261,642.378], [927.599,680.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.965,684.33], [915.364,722.603], [927.6,680.694], [927.935,718.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.364,722.603], [915.732,757.762], [927.935,718.618], [928.243,753.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.074,323.069], [998.071,367.433], [973.635,322.801], [973.761,366.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.071,367.433], [998.068,411.296], [973.761,366.478], [973.886,409.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.068,411.323], [998.064,454.719], [973.886,409.696], [974.009,452.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.064,454.747], [998.061,497.684], [974.009,452.462], [974.131,494.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.061,497.711], [998.058,540.197], [974.131,494.783], [974.252,536.638]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.058,540.224], [998.055,582.265], [974.252,536.665], [974.371,578.089]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.055,582.292], [998.051,623.896], [974.371,578.115], [974.489,619.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.051,623.922], [998.048,665.095], [974.489,619.141], [974.606,659.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.048,665.122], [998.045,705.871], [974.606,659.749], [974.722,699.919]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.045,705.896], [998.042,746.228], [974.722,699.944], [974.837,739.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[998.042,746.228], [998.039,783.259], [974.837,739.709], [974.942,776.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.67,324.153], [1050.36,371.286], [978.713,323.34], [978.815,368.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.36,371.286], [1050.06,417.855], [978.815,368.396], [978.916,412.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.06,417.885], [1049.77,463.928], [978.916,412.963], [979.016,457.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.77,463.957], [1049.47,509.484], [979.016,457.049], [979.115,500.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.47,509.513], [1049.18,554.531], [979.115,500.662], [979.213,543.782]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.18,554.56], [1048.9,599.079], [979.213,543.809], [979.31,586.471]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.9,599.107], [1048.61,643.135], [979.31,586.498], [979.406,628.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.61,643.162], [1048.33,686.707], [979.406,628.736], [979.5,670.504]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.33,686.734], [1048.05,729.804], [979.5,670.53], [979.594,711.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1048.05,729.831], [1047.78,772.433], [979.594,711.888], [979.687,752.789]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1047.78,772.433], [1047.53,811.525], [979.687,752.789], [979.772,790.338]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1162.94,323.211], [1163.84,278.024], [1030.5,321.883], [1030.67,280.161]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.23,610.188], [1079.76,655.807], [1036.65,602.148], [1036.43,646.613]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.76,655.835], [1079.29,700.935], [1036.43,646.641], [1036.21,690.613]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.29,700.963], [1078.83,745.552], [1036.21,690.64], [1036,734.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.83,745.58], [1078.37,789.667], [1036,734.155], [1035.79,777.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.37,789.667], [1077.95,830.106], [1035.79,777.165], [1035.59,816.628]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.18,422.218], [1081.69,470.007], [1037.54,419.073], [1037.32,465.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.69,470.037], [1081.2,517.268], [1037.32,465.625], [1037.09,511.619]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.2,517.298], [1080.71,563.983], [1037.09,511.649], [1036.87,557.125]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.71,564.012], [1080.23,610.159], [1036.87,557.153], [1036.65,602.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.19,324.87], [1082.69,373.833], [1038.01,324.35], [1037.78,371.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.69,373.833], [1082.18,422.188], [1037.78,371.985], [1037.55,419.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.85,799.033], [1132.13,840.202], [1089.66,786.521], [1089.18,826.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.42,708.701], [1133.63,754.113], [1090.7,698.365], [1090.17,742.677]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.63,754.142], [1132.85,799.033], [1090.17,742.705], [1089.66,786.521]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.03,616.219], [1135.22,662.701], [1091.77,608.164], [1091.23,653.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.22,662.73], [1134.42,708.672], [1091.23,653.521], [1090.7,698.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.67,521.538], [1136.85,569.128], [1092.86,515.876], [1092.31,562.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.85,569.158], [1136.03,616.189], [1092.31,562.285], [1091.77,608.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.36,424.58], [1138.51,473.318], [1093.97,421.426], [1093.41,468.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.51,473.349], [1137.67,521.507], [1093.41,468.926], [1092.86,515.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.22,375.221], [1139.36,424.548], [1094.54,373.367], [1093.97,421.396]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1141.09,325.261], [1141.97,274.722], [1095.12,324.739], [1095.7,275.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1141.09,325.26], [1140.22,375.22], [1095.12,324.739], [1094.54,373.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.85,799.033], [1132.13,840.202], [1146.21,793.025], [1145.44,833.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.63,754.142], [1132.85,799.033], [1147.06,748.65], [1146.21,793.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.42,708.701], [1133.63,754.113], [1147.92,703.737], [1147.06,748.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.03,616.219], [1135.22,662.701], [1149.66,612.35], [1148.79,658.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.22,662.73], [1134.42,708.672], [1148.79,658.307], [1147.92,703.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.85,569.158], [1136.03,616.189], [1150.55,565.856], [1149.67,612.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.67,521.538], [1136.85,569.128], [1151.45,518.818], [1150.55,565.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.51,473.348], [1137.67,521.507], [1152.36,471.224], [1151.45,518.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.22,375.22], [1139.36,424.548], [1154.21,374.33], [1153.28,423.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.36,424.58], [1138.51,473.318], [1153.28,423.064], [1152.36,471.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1141.09,325.26], [1140.22,375.22], [1155.15,325.01], [1154.21,374.33]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1141.09,325.261], [1141.97,274.722], [1155.15,325.01], [1156.1,275.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.82,769.739], [1227.45,816.09], [1147.06,748.65], [1146.21,793.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.45,816.09], [1226.19,858.582], [1146.21,793.025], [1145.44,833.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.21,722.801], [1228.82,769.709], [1147.92,703.737], [1147.06,748.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.62,675.296], [1230.21,722.771], [1148.79,658.307], [1147.92,703.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.04,627.214], [1231.62,675.266], [1149.67,612.35], [1148.79,658.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.48,578.543], [1233.04,627.183], [1150.55,565.856], [1149.67,612.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.94,529.273], [1234.48,578.512], [1151.45,518.818], [1150.55,565.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.91,428.891], [1237.42,479.361], [1153.28,423.064], [1152.36,471.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.42,479.393], [1235.94,529.242], [1152.36,471.224], [1151.45,518.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.43,377.756], [1238.91,428.859], [1154.21,374.33], [1153.28,423.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.96,325.974], [1240.43,377.755], [1155.15,325.01], [1154.21,374.33]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1241.96,325.975], [1243.51,273.57], [1155.15,325.01], [1156.1,275.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.45,816.09], [1226.19,858.582], [1252.4,803.39], [1251.04,844.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.82,769.739], [1227.45,816.09], [1253.89,758.125], [1252.4,803.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.21,722.801], [1228.82,769.709], [1255.39,712.302], [1253.89,758.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.62,675.296], [1230.21,722.772], [1256.91,665.938], [1255.39,712.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.04,627.214], [1231.62,675.266], [1258.45,619.025], [1256.91,665.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.48,578.543], [1233.04,627.183], [1260,571.553], [1258.45,618.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.94,529.273], [1234.48,578.512], [1261.58,523.512], [1260,571.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.42,479.393], [1235.94,529.242], [1263.17,474.891], [1261.58,523.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.91,428.891], [1237.42,479.361], [1264.78,425.679], [1263.17,474.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.43,377.755], [1238.91,428.859], [1266.41,375.867], [1264.78,425.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.96,325.974], [1240.43,377.755], [1268.07,325.442], [1266.41,375.867]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1241.96,325.975], [1243.51,273.57], [1268.07,325.443], [1269.74,274.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.3,811.282], [1252.4,803.39], [1279.77,853.401], [1251.04,844.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.98,765.342], [1253.89,758.125], [1281.3,811.282], [1252.4,803.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.68,718.825], [1282.98,765.312], [1255.39,712.301], [1253.89,758.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.4,671.752], [1284.68,718.796], [1256.91,665.938], [1255.39,712.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.14,624.112], [1286.4,671.722], [1258.44,619.025], [1256.91,665.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.9,575.895], [1288.14,624.082], [1260,571.553], [1258.45,618.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.68,527.09], [1289.9,575.865], [1261.57,523.511], [1260,571.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.49,477.687], [1291.68,527.059], [1263.17,474.89], [1261.58,523.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.31,427.674], [1293.49,477.656], [1264.78,425.679], [1263.17,474.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.16,377.04], [1295.31,427.642], [1266.41,375.867], [1264.78,425.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.04,325.773], [1297.16,377.04], [1268.07,325.442], [1266.41,375.867]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1299.04,325.773], [1300.93,273.895], [1268.07,325.443], [1269.74,274.427]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.3,811.282], [1279.77,853.401], [1311.74,795.07], [1310.09,835.931]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.98,765.342], [1281.3,811.282], [1313.53,750.519], [1311.74,795.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.68,718.825], [1282.98,765.313], [1315.35,705.427], [1313.54,750.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.4,671.752], [1284.68,718.796], [1317.19,659.812], [1315.36,705.398]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.14,624.112], [1286.4,671.722], [1319.06,613.666], [1317.2,659.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.9,575.895], [1288.14,624.082], [1320.94,566.98], [1319.06,613.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.68,527.09], [1289.9,575.865], [1322.85,519.743], [1320.94,566.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.49,477.687], [1291.68,527.06], [1324.78,471.947], [1322.85,519.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.31,427.674], [1293.49,477.656], [1326.73,423.58], [1324.78,471.916]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.16,377.04], [1295.31,427.642], [1328.7,374.633], [1326.73,423.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.04,325.773], [1297.16,377.04], [1330.7,325.095], [1328.7,374.633]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1299.04,325.773], [1300.93,273.894], [1330.7,325.095], [1332.72,274.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.52,791.786], [1297.94,832.39], [1327.16,777.35], [1325.49,816.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.23,747.517], [1299.52,791.786], [1328.98,734.324], [1327.16,777.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.97,702.714], [1301.23,747.489], [1330.82,690.793], [1328.98,734.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.73,657.395], [1302.97,702.685], [1332.68,646.777], [1330.82,690.766]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.5,611.552], [1304.73,657.366], [1334.56,602.267], [1332.68,646.749]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.3,565.176], [1306.5,611.523], [1336.46,557.255], [1334.56,602.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.12,518.257], [1308.3,565.146], [1338.38,511.732], [1336.46,557.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.96,470.786], [1310.12,518.227], [1340.32,465.69], [1338.38,511.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.82,422.752], [1311.96,470.755], [1342.29,419.12], [1340.33,465.661]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.71,374.146], [1313.82,422.721], [1344.28,372.012], [1342.29,419.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1317.61,324.958], [1315.71,374.146], [1346.29,324.358], [1344.28,372.012]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1317.61,324.958], [1319.53,275.496], [1346.29,324.357], [1348.32,276.455]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[777.707,282.192], [778.737,319.751], [735.693,282.762], [736.873,318.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.737,319.751], [779.758,356.982], [736.873,318.899], [738.044,354.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[779.758,356.982], [780.768,393.844], [738.044,354.734], [739.203,390.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.769,393.868], [781.77,430.389], [739.204,390.248], [740.353,425.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.771,430.412], [782.763,466.597], [740.354,425.446], [741.492,460.311]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.764,466.62], [783.747,502.473], [741.493,460.333], [742.622,494.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.748,502.496], [784.722,538.022], [742.622,494.911], [743.741,529.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.722,538.044], [785.688,573.248], [743.742,529.185], [744.851,563.139]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.688,573.27], [786.645,608.156], [744.852,563.16], [745.951,596.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.645,608.178], [787.593,642.749], [745.952,596.839], [747.042,630.204]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.594,642.771], [788.533,677.033], [747.042,630.225], [748.123,663.303]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.533,677.033], [789.397,708.53], [748.123,663.303], [749.117,693.72]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[788.577,281.711], [789.587,320.471], [763.199,282.063], [764.306,319.945]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.587,320.471], [790.588,358.881], [764.306,319.945], [765.404,357.494]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.588,358.881], [791.579,396.899], [765.404,357.494], [766.49,394.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.58,396.923], [792.561,434.579], [766.491,394.691], [767.567,431.518]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.562,434.603], [793.534,471.901], [767.568,431.542], [768.634,468.027]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.535,471.924], [794.497,508.87], [768.635,468.05], [769.692,504.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.498,508.893], [795.452,545.491], [769.692,504.221], [770.739,540.036]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.452,545.515], [796.397,581.77], [770.74,540.059], [771.777,575.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.398,581.793], [797.334,617.71], [771.778,575.569], [772.806,610.733]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[797.334,617.733], [798.262,653.318], [772.806,610.755], [773.825,645.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.262,653.34], [799.181,688.596], [773.825,645.622], [774.835,680.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.181,688.596], [800.026,720.999], [774.835,680.153], [775.762,711.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.838,321.214], [806.79,360.841], [778.213,320.629], [779.276,359.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.79,360.841], [807.732,400.052], [779.276,359.3], [780.328,397.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.733,400.077], [808.665,438.901], [780.329,397.598], [781.371,435.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.666,438.926], [809.59,477.371], [781.372,435.527], [782.404,473.07]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.59,477.395], [810.505,515.465], [782.404,473.094], [783.426,510.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.505,515.489], [811.411,553.19], [783.427,510.304], [784.44,547.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.412,553.214], [812.309,590.551], [784.44,547.161], [785.443,583.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.309,590.575], [813.198,627.553], [785.444,583.671], [786.437,619.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.198,627.576], [814.078,664.201], [786.438,619.839], [787.422,655.646]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.079,664.224], [814.951,700.501], [787.423,655.669], [788.398,691.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.951,700.501], [815.751,733.832], [788.398,691.143], [789.294,723.745]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.838,321.214], [806.79,360.841], [820.452,321.001], [821.324,360.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.79,360.841], [807.732,400.052], [821.324,360.281], [822.187,399.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.733,400.077], [808.665,438.901], [822.187,399.175], [823.041,437.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.666,438.926], [809.59,477.371], [823.042,437.69], [823.888,475.806]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[809.59,477.395], [810.505,515.465], [823.888,475.83], [824.726,513.579]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.505,515.489], [811.411,553.19], [824.727,513.603], [825.556,550.989]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.412,553.214], [812.309,590.551], [825.557,551.012], [826.379,588.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.31,590.575], [813.198,627.553], [826.379,588.064], [827.193,624.739]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.198,627.576], [814.078,664.201], [827.194,624.762], [828,661.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.079,664.224], [828,661.113], [814.951,700.501], [828.799,697.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.951,700.501], [828.799,697.098], [815.751,733.832], [829.533,730.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.379,322.076], [873.022,363.114], [820.452,321.001], [821.324,360.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.022,363.115], [873.659,403.707], [821.324,360.281], [822.187,399.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.659,403.733], [874.289,443.912], [822.187,399.175], [823.041,437.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.29,443.937], [874.914,483.708], [823.042,437.689], [823.888,475.806]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.914,483.734], [875.532,523.104], [823.888,475.83], [824.726,513.579]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.532,523.129], [876.143,562.105], [824.727,513.603], [825.556,550.989]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.144,562.129], [876.749,600.715], [825.557,551.012], [826.379,588.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.749,600.74], [877.348,638.943], [826.379,588.064], [827.193,624.739]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.349,638.967], [877.942,676.792], [827.194,624.762], [828,661.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.942,676.816], [878.53,714.269], [828,661.113], [828.799,697.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.53,714.269], [879.069,748.671], [828.799,697.098], [829.533,730.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.379,322.076], [873.022,363.114], [892.176,321.765], [892.711,362.295]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.022,363.115], [873.659,403.707], [892.711,362.295], [893.241,402.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.659,403.733], [874.289,443.912], [893.241,402.415], [893.765,442.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.29,443.937], [874.914,483.708], [893.765,442.131], [894.284,481.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.914,483.734], [875.532,523.104], [894.284,481.449], [894.798,520.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.532,523.129], [876.143,562.105], [894.798,520.376], [895.307,558.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.144,562.129], [876.749,600.716], [895.307,558.916], [895.81,597.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.749,600.74], [877.348,638.943], [895.811,597.077], [896.309,634.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.349,638.967], [877.942,676.792], [896.309,634.863], [896.803,672.256]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.942,676.816], [878.53,714.269], [896.803,672.28], [897.292,709.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.53,714.269], [879.069,748.671], [897.292,709.31], [897.741,743.326]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[974.012,281.369], [974.128,320.982], [886.124,282.437], [886.637,319.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.446,322.132], [910.895,363.263], [892.176,321.765], [892.711,362.295]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.895,363.264], [911.339,403.946], [892.711,362.295], [893.24,402.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.339,403.972], [911.778,444.239], [893.241,402.415], [893.765,442.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.779,444.265], [912.213,484.123], [893.765,442.131], [894.284,481.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.214,484.149], [912.644,523.604], [894.284,481.449], [894.798,520.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.644,523.629], [913.071,562.688], [894.798,520.376], [895.306,558.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.071,562.713], [913.493,601.38], [895.307,558.916], [895.81,597.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.493,601.405], [913.911,639.688], [895.811,597.077], [896.309,634.839]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.911,639.712], [914.324,677.615], [896.309,634.863], [896.803,672.256]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.325,677.639], [914.734,715.169], [896.803,672.28], [897.292,709.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.734,715.169], [915.11,749.641], [897.292,709.31], [897.741,743.326]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.446,322.132], [910.895,363.263], [924.513,321.906], [924.886,362.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.895,363.263], [911.339,403.946], [924.886,362.665], [925.255,402.985]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.339,403.972], [911.779,444.24], [925.255,403.01], [925.62,442.922]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.779,444.265], [912.214,484.123], [925.62,442.947], [925.982,482.457]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.214,484.148], [912.644,523.604], [925.982,482.482], [926.34,521.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.645,523.629], [913.071,562.688], [926.34,521.62], [926.694,560.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.071,562.712], [913.493,601.38], [926.694,560.369], [927.045,598.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.493,601.405], [913.911,639.688], [927.045,598.733], [927.392,636.694]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.911,639.712], [914.325,677.615], [927.393,636.718], [927.736,674.307]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.325,677.639], [927.737,674.33], [914.734,715.169], [928.077,711.552]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.734,715.169], [928.077,711.552], [915.11,749.641], [928.39,745.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.503,323.731], [988.552,367.475], [966.451,323.287], [966.618,366.306]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.552,367.475], [988.6,410.715], [966.618,366.306], [966.783,408.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.6,410.743], [988.648,453.513], [966.783,408.863], [966.947,450.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.648,453.54], [988.696,495.849], [966.947,450.966], [967.109,492.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.696,495.875], [988.743,537.73], [967.109,492.622], [967.269,533.811]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.743,537.756], [988.789,579.163], [967.269,533.837], [967.428,574.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.789,579.189], [988.835,620.157], [967.428,574.62], [967.584,614.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.46,325.456], [1032.26,372.018], [967.567,324.11], [967.733,368.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.26,372.018], [1032.06,418.01], [967.733,368.472], [967.898,412.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1032.06,418.039], [1031.86,463.5], [967.898,412.344], [968.06,455.706]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1031.86,463.528], [1031.66,508.467], [968.061,455.733], [968.221,498.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1031.66,508.495], [1031.46,552.921], [968.221,498.647], [968.38,541.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1031.46,552.949], [1031.27,596.87], [968.38,541.094], [968.538,583.054]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1031.27,596.898], [1031.08,640.324], [968.538,583.081], [968.693,624.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.835,620.182], [988.881,660.717], [967.584,614.976], [967.74,654.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.881,660.742], [988.926,700.851], [967.74,654.912], [967.893,694.411]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.926,700.876], [988.97,740.565], [967.893,694.436], [968.045,733.528]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.97,740.565], [989.011,776.998], [968.045,733.528], [968.185,769.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1031.08,640.351], [1030.89,683.289], [968.693,624.616], [968.847,665.68]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1030.89,683.317], [1030.7,725.776], [968.847,665.706], [969,706.332]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1030.7,725.802], [1030.52,767.79], [969,706.357], [969.15,746.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1030.52,767.79], [1030.35,806.31], [969.15,746.553], [969.289,783.447]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.51,698.172], [1056.17,742.169], [1017.6,686.916], [1017.49,729.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.17,742.197], [1055.83,785.687], [1017.49,729.775], [1017.38,772.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.83,785.687], [1055.52,825.569], [1017.38,772.127], [1017.28,810.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.4,326.596], [1059.02,375.019], [1018.56,325.732], [1018.44,372.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.02,375.019], [1058.65,422.826], [1018.44,372.744], [1018.31,419.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.65,422.857], [1058.29,470.09], [1018.31,419.205], [1018.19,465.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.28,470.12], [1057.92,516.789], [1018.19,465.124], [1018.07,510.482]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.92,516.819], [1057.56,562.935], [1018.07,510.511], [1017.95,555.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.56,562.964], [1057.21,608.536], [1017.95,555.374], [1017.84,599.696]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.21,608.565], [1056.86,653.603], [1017.84,599.724], [1017.72,643.54]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.86,653.631], [1056.51,698.144], [1017.72,643.568], [1017.6,686.888]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1151.87,279.21], [1151,324.209], [1029.17,280.7], [1029.01,321.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1108.46,707.196], [1107.8,752.124], [1068.7,695.861], [1068.29,739.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.8,752.152], [1107.15,796.551], [1068.29,739.646], [1067.89,782.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.15,796.551], [1106.55,837.256], [1067.89,782.903], [1067.51,822.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.8,615.657], [1109.12,661.672], [1069.54,606.749], [1069.12,651.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.12,661.701], [1108.46,707.167], [1069.12,651.564], [1068.7,695.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.87,474.131], [1111.17,521.852], [1070.83,469.093], [1070.39,515.493]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.17,521.882], [1110.48,569.024], [1070.39,515.523], [1069.96,561.376]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.48,569.054], [1109.8,615.627], [1069.96,561.405], [1069.54,606.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.29,376.847], [1112.57,425.758], [1071.72,374.551], [1071.27,422.076]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.57,425.79], [1111.87,474.101], [1071.27,422.106], [1070.83,469.064]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1114.75,277.144], [1114.01,327.292], [1072.62,277.729], [1072.17,326.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.01,327.291], [1113.29,376.846], [1072.17,326.419], [1071.72,374.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.8,752.152], [1107.15,796.551], [1122.9,747.057], [1122.17,790.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.15,796.551], [1106.55,837.256], [1122.17,790.991], [1121.5,831.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1108.46,707.196], [1107.8,752.124], [1123.64,702.577], [1122.9,747.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.8,615.657], [1109.12,661.672], [1125.15,612.026], [1124.39,657.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1109.12,661.701], [1108.46,707.167], [1124.39,657.57], [1123.64,702.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1110.48,569.054], [1109.8,615.627], [1125.91,565.936], [1125.15,611.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.87,474.131], [1111.17,521.852], [1127.47,472.077], [1126.69,519.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1111.17,521.882], [1110.48,569.024], [1126.69,519.29], [1125.91,565.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1112.57,425.789], [1111.87,474.1], [1128.27,424.287], [1127.47,472.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.01,327.291], [1113.29,376.846], [1129.89,326.935], [1129.07,375.91]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1113.29,376.846], [1112.57,425.758], [1129.07,375.91], [1128.27,424.257]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1114.75,277.144], [1114.01,327.291], [1130.71,277.383], [1129.89,326.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.95,770.302], [1196.72,816.35], [1122.9,747.057], [1122.17,790.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.72,816.35], [1195.6,858.549], [1122.17,790.991], [1121.5,831.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.19,723.654], [1197.95,770.273], [1123.64,702.577], [1122.9,747.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.72,628.601], [1200.45,676.394], [1125.15,612.026], [1124.39,657.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.45,676.424], [1199.19,723.624], [1124.39,657.57], [1123.64,702.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.01,580.173], [1201.72,628.57], [1125.91,565.936], [1125.15,611.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.32,531.131], [1203.01,580.143], [1126.69,519.29], [1125.91,565.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.64,481.46], [1204.32,531.099], [1127.47,472.077], [1126.69,519.26]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.34,380.189], [1206.98,431.119], [1129.07,375.911], [1128.27,424.257]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.98,431.151], [1205.64,481.429], [1128.27,424.287], [1127.47,472.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.72,328.562], [1208.34,380.189], [1129.89,326.935], [1129.07,375.91]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1211.11,276.291], [1209.72,328.562], [1130.71,277.382], [1129.89,326.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.72,816.351], [1195.6,858.549], [1225.55,804.47], [1224.29,845.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.95,770.302], [1196.72,816.35], [1226.92,759.411], [1225.55,804.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.19,723.654], [1197.95,770.273], [1228.31,713.777], [1226.92,759.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.45,676.424], [1199.19,723.624], [1229.71,667.587], [1228.31,713.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.72,628.601], [1200.45,676.394], [1231.14,620.831], [1229.72,667.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.01,580.173], [1201.72,628.57], [1232.58,573.498], [1231.14,620.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.32,531.131], [1203.01,580.143], [1234.04,525.578], [1232.58,573.468]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.64,481.46], [1204.32,531.099], [1235.52,477.059], [1234.04,525.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.98,431.15], [1205.64,481.429], [1237.01,427.931], [1235.52,477.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.34,380.189], [1206.98,431.118], [1238.53,378.182], [1237.01,427.9]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.72,328.562], [1208.34,380.189], [1240.06,327.798], [1238.53,378.181]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1211.11,276.291], [1209.72,328.562], [1241.61,276.803], [1240.06,327.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.39,813.228], [1250.96,855.192], [1225.55,804.47], [1224.29,845.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.95,767.44], [1252.39,813.228], [1226.92,759.41], [1225.55,804.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.53,721.057], [1253.95,767.41], [1228.31,713.776], [1226.92,759.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.13,674.101], [1255.53,721.028], [1229.71,667.587], [1228.31,713.747]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.75,626.558], [1257.13,674.071], [1231.14,620.831], [1229.71,667.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.39,578.418], [1258.75,626.528], [1232.58,573.498], [1231.14,620.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.05,529.67], [1260.39,578.388], [1234.04,525.578], [1232.58,573.468]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.74,480.303], [1262.06,529.639], [1235.51,477.059], [1234.04,525.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.44,430.304], [1263.74,480.271], [1237.01,427.931], [1235.52,477.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.17,379.661], [1265.44,430.272], [1238.53,378.181], [1237.01,427.9]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.91,328.361], [1267.17,379.661], [1240.06,327.798], [1238.53,378.181]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1270.68,276.426], [1268.91,328.361], [1241.61,276.803], [1240.06,327.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.39,813.228], [1250.96,855.192], [1288.04,797.951], [1286.46,838.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.95,767.44], [1252.39,813.228], [1289.76,753.435], [1288.04,797.951]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.53,721.058], [1253.95,767.41], [1291.51,708.359], [1289.76,753.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.13,674.101], [1255.53,721.028], [1293.28,662.741], [1291.51,708.33]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.75,626.558], [1257.13,674.071], [1295.07,616.571], [1293.28,662.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.39,578.418], [1258.75,626.528], [1296.88,569.839], [1295.07,616.542]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.05,529.67], [1260.39,578.388], [1298.71,522.535], [1296.88,569.809]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.74,480.303], [1262.06,529.639], [1300.57,474.648], [1298.71,522.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.44,430.303], [1263.74,480.271], [1302.45,426.167], [1300.57,474.618]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.17,379.661], [1265.44,430.272], [1304.35,377.082], [1302.45,426.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.91,328.361], [1267.17,379.661], [1306.28,327.381], [1304.35,377.082]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1270.68,276.425], [1268.91,328.361], [1308.22,277.083], [1306.28,327.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.61,794.297], [1275.1,834.831], [1309.01,780.643], [1307.38,820.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.26,750.086], [1276.61,794.297], [1310.8,737.576], [1309.01,780.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.92,705.323], [1278.26,750.058], [1312.61,693.984], [1310.8,737.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.61,660.026], [1279.92,705.295], [1314.43,649.887], [1312.61,693.956]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.31,614.185], [1281.61,659.997], [1316.28,605.275], [1314.44,649.859]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1285.04,567.79], [1283.31,614.155], [1318.16,560.139], [1316.29,605.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.79,520.831], [1285.04,567.76], [1320.05,514.471], [1318.16,560.111]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.56,473.298], [1286.79,520.801], [1321.96,468.26], [1320.05,514.442]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.35,425.18], [1288.56,473.268], [1323.9,421.497], [1321.97,468.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.16,376.467], [1290.35,425.15], [1325.87,374.172], [1323.9,421.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294,327.147], [1292.16,376.467], [1327.85,326.275], [1325.87,374.172]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1295.84,277.529], [1294,327.147], [1329.85,278.105], [1327.85,326.274]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.42,773.272], [1282.94,812.21], [1310.03,762.869], [1308.45,801.013]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.04,730.823], [1284.42,773.272], [1311.76,721.295], [1310.03,762.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.68,687.866], [1286.04,730.796], [1313.5,679.234], [1311.76,721.269]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.34,644.417], [1287.68,687.838], [1315.27,636.703], [1313.5,679.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.01,600.47], [1289.34,644.39], [1317.05,593.694], [1315.27,636.676]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.71,556.015], [1291.01,600.442], [1318.86,550.199], [1317.05,593.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1294.42,511.043], [1292.71,555.986], [1320.68,506.21], [1318.86,550.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.16,465.545], [1294.43,511.014], [1322.53,461.719], [1320.68,506.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.92,419.513], [1296.16,465.516], [1324.39,416.717], [1322.53,461.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.69,372.936], [1297.92,419.483], [1326.28,371.195], [1324.4,416.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.49,325.805], [1299.69,372.936], [1328.19,325.143], [1326.28,371.195]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1303.31,278.14], [1301.49,325.805], [1330.13,278.583], [1328.19,325.143]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[792.705,281.914], [793.674,318.607], [756.235,282.181], [757.332,317.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.674,318.607], [794.635,354.977], [757.332,317.419], [758.42,352.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.635,354.977], [795.586,390.983], [758.419,352.361], [759.497,386.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.587,391.006], [796.529,426.675], [759.497,386.988], [760.565,421.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.53,426.698], [797.464,462.035], [760.566,421.303], [761.624,455.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[797.464,462.058], [798.389,497.068], [761.624,455.312], [762.673,488.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.39,497.09], [799.306,531.778], [762.674,489.018], [763.713,522.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.307,531.8], [800.215,566.17], [763.714,522.426], [764.744,555.518]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[800.216,566.192], [801.116,600.248], [764.744,555.539], [765.765,588.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.116,600.269], [802.008,634.016], [765.766,588.361], [766.778,620.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.008,634.037], [802.892,667.478], [766.779,620.896], [767.782,653.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.892,667.479], [803.704,698.218], [767.782,653.128], [768.705,682.766]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[799.898,281.697], [800.864,319.569], [777.891,281.862], [778.939,318.835]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[800.864,319.569], [801.82,357.095], [778.939,318.835], [779.977,355.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.82,357.096], [802.767,394.235], [779.977,355.48], [781.005,391.755]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.768,394.259], [803.705,431.041], [781.006,391.778], [782.024,427.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[803.706,431.064], [804.635,467.493], [782.024,427.735], [783.033,463.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.635,467.516], [805.555,503.597], [783.034,463.355], [784.033,498.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.556,503.62], [806.467,539.358], [784.033,498.642], [785.023,533.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[806.467,539.381], [807.37,574.781], [785.024,533.602], [786.005,568.217]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.37,574.804], [808.264,609.871], [786.005,568.239], [786.977,602.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.265,609.893], [809.15,644.631], [786.978,602.557], [787.941,636.54]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.151,644.654], [810.028,679.068], [787.941,636.561], [788.895,670.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.15,320.572], [814.075,359.304], [789.213,319.756], [790.233,357.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.028,679.068], [810.835,710.695], [788.895,670.234], [789.772,701.185]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.075,359.304], [814.991,397.625], [790.233,357.508], [791.242,394.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.992,397.649], [815.899,435.588], [791.242,394.891], [792.241,431.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.899,435.613], [816.797,473.176], [792.242,431.913], [793.231,468.554]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.798,473.2], [817.687,510.394], [793.232,468.577], [794.212,504.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.687,510.418], [818.568,547.247], [794.213,504.889], [795.183,540.831]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.568,547.271], [819.44,583.741], [795.184,540.854], [796.145,576.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.441,583.764], [820.304,619.88], [796.146,576.477], [797.098,611.74]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.304,619.903], [821.159,655.671], [797.099,611.762], [798.042,646.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.16,655.693], [822.007,691.117], [798.043,646.715], [798.977,681.319]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.007,691.117], [822.785,723.662], [798.977,681.319], [799.836,713.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.15,320.572], [814.075,359.304], [828.204,320.32], [829.047,358.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.075,359.304], [814.991,397.625], [829.047,358.751], [829.882,396.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.992,397.649], [815.899,435.588], [829.882,396.8], [830.709,434.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.899,435.613], [816.797,473.176], [830.709,434.474], [831.528,471.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.798,473.2], [817.687,510.394], [831.528,471.777], [832.338,508.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.687,510.418], [818.568,547.247], [832.339,508.716], [833.141,545.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.568,547.271], [819.44,583.741], [833.142,545.296], [833.936,581.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.441,583.764], [820.304,619.88], [833.937,581.522], [834.724,617.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.304,619.903], [834.724,617.398], [821.159,655.671], [835.504,652.909]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.16,655.693], [835.504,652.931], [822.007,691.117], [836.276,688.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.007,691.117], [836.276,688.103], [822.785,723.662], [836.986,720.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.547,321.83], [874.193,362.072], [828.204,320.32], [829.047,358.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.193,362.073], [874.833,401.872], [829.047,358.751], [829.882,396.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.833,401.898], [875.466,441.286], [829.882,396.8], [830.709,434.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.467,441.311], [876.093,480.295], [830.709,434.474], [831.528,471.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.094,480.319], [876.714,518.904], [831.528,471.777], [832.338,508.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.714,518.929], [877.328,557.121], [832.339,508.716], [833.141,545.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.329,557.145], [877.936,594.951], [833.142,545.296], [833.936,581.499]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.937,594.975], [878.538,632.4], [833.937,581.522], [834.724,617.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.539,632.424], [879.134,669.473], [834.724,617.398], [835.504,652.909]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.134,669.497], [879.724,706.177], [835.504,652.931], [836.276,688.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.724,706.177], [880.265,739.865], [836.276,688.103], [836.986,720.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.547,321.83], [874.193,362.072], [894.203,321.46], [894.736,361.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.193,362.073], [874.833,401.872], [894.736,361.259], [895.263,400.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.833,401.898], [875.467,441.286], [895.263,400.648], [895.785,439.611]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.467,441.311], [876.093,480.295], [895.785,439.636], [896.302,478.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.094,480.32], [876.714,518.904], [896.302,478.227], [896.813,516.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.714,518.929], [877.328,557.121], [896.814,516.428], [897.32,554.22]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.329,557.145], [877.936,594.951], [897.32,554.244], [897.821,591.657]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.937,594.975], [878.538,632.4], [897.822,591.681], [898.318,628.722]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.539,632.424], [879.134,669.473], [898.318,628.746], [898.809,665.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.134,669.497], [879.724,706.177], [898.809,665.442], [899.296,701.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.724,706.177], [880.265,739.865], [899.296,701.754], [899.742,735.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.296,321.979], [910.753,362.4], [894.203,321.46], [894.736,361.258]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.753,362.401], [911.205,402.375], [894.736,361.259], [895.263,400.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.205,402.401], [911.652,441.96], [895.263,400.648], [895.785,439.611]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.653,441.986], [912.095,481.137], [895.785,439.636], [896.302,478.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.096,481.162], [912.534,519.911], [896.302,478.227], [896.813,516.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.534,519.936], [912.967,558.289], [896.814,516.428], [897.32,554.22]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.968,558.313], [913.397,596.277], [897.32,554.244], [897.821,591.657]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.397,596.301], [913.822,633.88], [897.822,591.681], [898.318,628.722]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.822,633.904], [914.243,671.105], [898.318,628.745], [898.809,665.419]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[977.86,281.469], [977.958,320.584], [899.303,281.979], [899.763,318.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.243,671.128], [914.659,707.957], [898.809,665.442], [899.296,701.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.659,707.957], [915.042,741.779], [899.296,701.754], [899.742,735.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.296,321.979], [910.753,362.4], [925.063,321.707], [925.44,361.804]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.753,362.4], [911.205,402.375], [925.44,361.804], [925.812,401.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.205,402.4], [911.653,441.961], [925.813,401.485], [926.181,440.734]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.653,441.985], [912.095,481.137], [926.181,440.758], [926.546,479.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.096,481.162], [912.534,519.911], [926.546,479.629], [926.907,518.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.534,519.936], [912.968,558.289], [926.907,518.104], [927.265,556.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.968,558.313], [913.397,596.277], [927.265,556.188], [927.619,593.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.397,596.301], [913.822,633.88], [927.619,593.888], [927.969,631.187]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.823,633.904], [927.969,631.21], [914.243,671.105], [928.316,668.136]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.243,671.128], [928.316,668.16], [914.66,707.957], [928.659,704.718]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.66,707.957], [928.659,704.719], [915.042,741.779], [928.975,738.296]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.38,326.614], [1014.28,372.594], [956.931,324.697], [957.161,368.381]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.28,372.594], [1014.18,417.999], [957.161,368.381], [957.387,411.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.18,418.028], [1014.08,462.898], [957.388,411.572], [957.612,454.251]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1014.08,462.926], [1013.98,507.27], [957.612,454.278], [957.834,496.482]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.98,507.298], [1013.88,551.125], [957.834,496.509], [958.054,538.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.88,551.152], [1013.79,594.471], [958.054,538.271], [958.271,579.547]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.79,594.499], [1013.7,637.318], [958.271,579.573], [958.485,620.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.7,637.345], [1013.6,679.674], [958.485,620.422], [958.698,660.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.6,679.701], [1013.51,721.547], [958.698,660.826], [958.908,700.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.51,721.574], [1013.42,762.946], [958.908,700.792], [959.116,740.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.42,762.946], [1013.34,800.894], [959.116,740.301], [959.306,776.558]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.58,328.181], [1035.34,376.035], [999.396,326.947], [999.384,373.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.34,376.035], [1035.11,423.268], [999.384,373.324], [999.372,419.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.11,423.298], [1034.87,469.952], [999.372,419.147], [999.361,464.395]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.87,469.981], [1034.65,516.066], [999.361,464.424], [999.349,509.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.65,516.095], [1034.42,561.621], [999.349,509.166], [999.338,553.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.42,561.65], [1034.2,606.627], [999.338,553.381], [999.327,597.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.2,606.655], [1033.98,651.094], [999.327,597.08], [999.316,640.244]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.98,651.122], [1033.76,695.031], [999.316,640.271], [999.305,682.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.76,695.059], [1033.55,738.448], [999.305,682.963], [999.295,725.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.55,738.475], [1033.33,781.354], [999.295,725.165], [999.284,766.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1033.33,781.354], [1033.14,820.667], [999.284,766.858], [999.274,805.096]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1138.85,280.422], [1138.03,325.226], [1027.5,281.146], [1027.34,322.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1082.03,705.3], [1081.52,749.714], [1046.59,693.056], [1046.3,736.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1081.51,749.742], [1081.01,793.62], [1046.3,736.272], [1046.01,778.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1081.01,793.62], [1080.54,833.837], [1046.01,778.955], [1045.75,818.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.14,521.97], [1083.61,568.628], [1047.78,514.947], [1047.48,560.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.61,568.657], [1083.07,614.738], [1047.48,560.28], [1047.18,605.041]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.07,614.768], [1082.55,660.283], [1047.18,605.069], [1046.88,649.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1082.55,660.312], [1082.03,705.271], [1046.88,649.325], [1046.59,693.028]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.8,378.336], [1085.24,426.79], [1048.72,375.586], [1048.4,422.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.24,426.821], [1084.69,474.665], [1048.4,422.61], [1048.09,469.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.69,474.695], [1084.15,521.94], [1048.09,469.06], [1047.78,514.918]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1086.94,279.519], [1086.37,329.229], [1049.36,279.802], [1049.03,327.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.37,329.228], [1085.8,378.336], [1049.03,327.976], [1048.72,375.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1081.52,749.742], [1098.1,745.095], [1081.01,793.62], [1097.5,788.561]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1081.01,793.62], [1097.5,788.561], [1080.54,833.837], [1096.95,828.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1082.55,660.312], [1082.03,705.271], [1099.33,656.52], [1098.71,701.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1082.03,705.3], [1081.52,749.714], [1098.71,701.075], [1098.1,745.067]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.61,568.657], [1083.07,614.739], [1100.58,565.766], [1099.95,611.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.07,614.768], [1082.55,660.283], [1099.95,611.421], [1099.33,656.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.69,474.695], [1084.15,521.94], [1101.86,472.75], [1101.22,519.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.15,521.97], [1083.61,568.628], [1101.22,519.546], [1100.58,565.737]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.8,378.336], [1085.24,426.79], [1103.18,377.386], [1102.52,425.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.24,426.82], [1084.69,474.665], [1102.52,425.367], [1101.86,472.72]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1086.94,279.519], [1086.37,329.229], [1104.53,279.617], [1103.85,328.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.37,329.228], [1085.8,378.336], [1103.85,328.796], [1103.18,377.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.58,816.014], [1163.61,857.874], [1097.5,788.561], [1096.95,828.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1166.71,724.012], [1165.63,770.29], [1098.71,701.075], [1098.1,745.067]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.63,770.319], [1164.58,816.014], [1098.1,745.095], [1097.5,788.561]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.89,629.604], [1167.79,677.081], [1099.95,611.421], [1099.33,656.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.79,677.111], [1166.71,723.983], [1099.33,656.52], [1098.71,701.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.01,581.479], [1168.89,629.574], [1100.58,565.766], [1099.95,611.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.28,483.326], [1171.14,532.693], [1101.86,472.75], [1101.22,519.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.14,532.724], [1170.01,581.448], [1101.22,519.546], [1100.58,565.737]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.44,433.274], [1172.28,483.295], [1102.52,425.367], [1101.87,472.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.81,331.15], [1174.62,382.553], [1103.85,328.796], [1103.18,377.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.62,382.553], [1173.44,433.242], [1103.18,377.386], [1102.52,425.337]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1177.01,279.085], [1175.81,331.15], [1104.53,279.616], [1103.85,328.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.58,816.014], [1163.61,857.874], [1196.93,805.095], [1195.8,846.155]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.63,770.319], [1164.58,816.014], [1198.17,760.284], [1196.93,805.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1166.71,724.012], [1165.63,770.29], [1199.42,714.885], [1198.17,760.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.79,677.111], [1166.71,723.983], [1200.69,668.916], [1199.42,714.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.89,629.604], [1167.79,677.081], [1201.98,622.366], [1200.69,668.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.01,581.479], [1168.89,629.574], [1203.28,575.223], [1201.98,622.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.14,532.724], [1170.01,581.448], [1204.6,527.476], [1203.28,575.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.28,483.326], [1171.14,532.693], [1205.93,479.113], [1204.6,527.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.44,433.274], [1172.28,483.295], [1207.28,430.123], [1205.93,479.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.62,382.553], [1173.44,433.242], [1208.65,380.494], [1207.28,430.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.81,331.15], [1174.62,382.553], [1210.04,330.211], [1208.65,380.494]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1177.01,279.085], [1175.81,331.15], [1211.45,279.297], [1210.04,330.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.4,814.662], [1220.1,856.424], [1196.93,805.095], [1195.8,846.155]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.82,769.077], [1221.4,814.662], [1198.17,760.284], [1196.93,805.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.25,722.882], [1222.82,769.048], [1199.42,714.885], [1198.17,760.255]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.7,676.096], [1224.25,722.853], [1200.69,668.916], [1199.42,714.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.17,628.707], [1225.7,676.066], [1201.98,622.365], [1200.69,668.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.66,580.704], [1227.17,628.677], [1203.28,575.222], [1201.98,622.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.17,532.074], [1228.66,580.673], [1204.6,527.476], [1203.28,575.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.7,482.804], [1230.17,532.043], [1205.93,479.113], [1204.6,527.445]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.25,432.883], [1231.7,482.773], [1207.28,430.123], [1205.93,479.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.82,382.297], [1233.25,432.852], [1208.65,380.494], [1207.28,430.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.41,331.033], [1234.82,382.297], [1210.04,330.211], [1208.65,380.494]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1238.02,279.111], [1236.41,331.034], [1211.45,279.296], [1210.04,330.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.4,814.662], [1220.1,856.424], [1261.9,800.516], [1260.41,841.24]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.82,769.077], [1221.4,814.662], [1263.53,756.076], [1261.9,800.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.25,722.882], [1222.82,769.048], [1265.17,711.059], [1263.53,756.048]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.7,676.096], [1224.25,722.853], [1266.84,665.481], [1265.17,711.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.17,628.707], [1225.7,676.067], [1268.53,619.332], [1266.84,665.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.66,580.704], [1227.17,628.677], [1270.24,572.601], [1268.53,619.303]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.17,532.074], [1228.66,580.673], [1271.97,525.277], [1270.24,572.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.7,482.804], [1230.17,532.043], [1273.72,477.349], [1271.97,525.247]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.25,432.883], [1231.7,482.773], [1275.5,428.804], [1273.72,477.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.82,382.297], [1233.25,432.852], [1277.3,379.632], [1275.5,428.774]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.41,331.033], [1234.82,382.297], [1279.12,329.819], [1277.3,379.632]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1238.02,279.111], [1236.41,331.033], [1280.96,279.385], [1279.12,329.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.41,796.51], [1249.99,836.94], [1288.31,783.813], [1286.72,823.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.96,752.397], [1251.41,796.51], [1290.03,740.734], [1288.31,783.813]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.52,707.714], [1252.96,752.369], [1291.79,697.111], [1290.04,740.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.11,662.478], [1254.53,707.685], [1293.56,652.963], [1291.79,697.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.72,616.681], [1256.11,662.449], [1295.35,608.281], [1293.56,652.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.35,570.31], [1257.72,616.651], [1297.17,563.054], [1295.35,608.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261,523.356], [1259.35,570.281], [1299,517.272], [1297.17,563.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.67,475.807], [1261,523.326], [1300.86,470.925], [1299,517.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.36,427.652], [1262.67,475.777], [1302.75,424.004], [1300.86,470.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.07,378.879], [1264.36,427.621], [1304.65,376.496], [1302.75,423.974]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.8,329.476], [1266.07,378.879], [1306.58,328.391], [1304.65,376.496]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1269.55,279.752], [1267.8,329.476], [1308.53,279.989], [1306.58,328.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.51,775.695], [1264.07,814.588], [1294.61,765.999], [1293.05,804.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.08,733.278], [1265.51,775.695], [1296.31,724.376], [1294.61,765.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1268.67,690.335], [1267.08,733.251], [1298.04,682.246], [1296.32,724.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.27,646.884], [1268.67,690.308], [1299.78,639.628], [1298.04,682.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1271.9,602.915], [1270.27,646.856], [1301.54,596.513], [1299.78,639.601]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1273.54,558.419], [1271.9,602.887], [1303.33,552.891], [1301.55,596.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1275.2,513.388], [1273.54,558.391], [1305.13,508.755], [1303.33,552.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.89,467.81], [1275.2,513.359], [1306.96,464.095], [1305.14,508.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.59,421.676], [1276.89,467.781], [1308.81,418.901], [1306.96,464.066]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.32,374.975], [1278.59,421.646], [1310.68,373.164], [1308.81,418.872]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1282.07,327.698], [1280.32,374.975], [1312.57,326.874], [1310.68,373.164]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1283.83,279.864], [1282.07,327.698], [1314.49,280.05], [1312.57,326.873]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[808.222,281.356], [809.127,317.27], [777.147,281.313], [778.157,315.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.127,317.27], [810.024,352.864], [778.157,315.75], [779.159,349.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.024,352.864], [810.912,388.099], [779.159,349.894], [780.151,383.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.912,388.122], [811.792,423.024], [780.151,383.728], [781.134,417.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.792,423.046], [812.664,457.62], [781.135,417.255], [782.109,450.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.664,457.642], [813.527,491.893], [782.11,450.48], [783.075,483.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.528,491.915], [814.383,525.847], [783.076,483.407], [784.032,516.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.383,525.869], [815.231,559.487], [784.033,516.039], [784.981,548.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.231,559.508], [816.071,592.817], [784.982,548.382], [785.922,580.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.071,592.838], [816.903,625.84], [785.922,580.438], [786.854,612.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.903,625.861], [817.727,658.563], [786.855,612.212], [787.778,643.687]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.727,658.563], [818.485,688.62], [787.778,643.687], [788.627,672.627]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[811.886,281.389], [812.802,318.455], [793.178,281.363], [794.162,317.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.802,318.455], [813.71,355.179], [794.162,317.515], [795.136,353.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.71,355.179], [814.608,391.522], [795.136,353.344], [796.101,388.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.608,391.545], [815.498,427.533], [796.102,388.831], [797.057,423.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.498,427.556], [816.379,463.195], [797.058,423.98], [798.004,458.775]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.379,463.218], [817.252,498.514], [798.005,458.797], [798.943,493.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.252,498.537], [818.116,533.494], [798.943,493.287], [799.872,527.432]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.117,533.516], [818.972,568.14], [799.873,527.454], [800.793,561.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.255,319.701], [822.149,357.614], [800.943,318.656], [801.914,355.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.973,568.162], [819.82,602.457], [800.793,561.302], [801.705,594.815]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.821,602.478], [820.66,636.449], [801.706,594.836], [802.609,628.039]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.149,357.614], [823.034,395.12], [801.914,355.572], [802.874,392.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.661,636.47], [821.492,670.121], [802.609,628.06], [803.504,660.959]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.034,395.144], [823.91,432.272], [802.875,392.125], [803.826,428.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.492,670.121], [822.257,701.042], [803.504,660.959], [804.327,691.195]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.91,432.296], [824.777,469.054], [803.827,428.32], [804.769,464.141]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.778,469.077], [825.636,505.469], [804.77,464.163], [805.702,499.636]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.637,505.492], [826.486,541.524], [805.703,499.659], [806.627,534.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.487,541.547], [827.328,577.224], [806.628,534.812], [807.543,569.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.329,577.247], [828.162,612.574], [807.543,569.628], [808.45,604.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.163,612.596], [828.988,647.579], [808.45,604.111], [809.348,638.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.988,647.601], [829.805,682.244], [809.348,638.267], [810.238,672.078]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.805,682.244], [830.556,714.069], [810.238,672.078], [811.055,703.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.255,319.701], [822.149,357.614], [836.651,319.431], [837.461,357.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[822.149,357.614], [823.034,395.12], [837.461,357.086], [838.263,394.339]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.034,395.143], [823.91,432.272], [838.263,394.363], [839.057,431.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[823.91,432.296], [824.777,469.054], [839.057,431.268], [839.843,467.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[824.778,469.077], [825.636,505.469], [839.844,467.807], [840.622,503.961]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[825.637,505.492], [826.486,541.524], [840.623,503.984], [841.393,539.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[826.487,541.547], [827.328,577.224], [841.394,539.806], [842.156,575.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[827.329,577.247], [842.157,575.277], [828.162,612.574], [842.913,610.381]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.163,612.596], [842.913,610.403], [828.988,647.579], [843.661,645.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.988,647.601], [843.662,645.189], [829.805,682.244], [844.403,679.617]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.805,682.244], [844.403,679.617], [830.556,714.069], [845.083,711.246]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.437,321.374], [876.082,360.88], [836.651,319.431], [837.461,357.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.082,360.88], [876.721,399.946], [837.461,357.086], [838.263,394.339]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.721,399.971], [877.353,438.627], [838.263,394.363], [839.057,431.245]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.353,438.652], [877.978,476.906], [839.058,431.268], [839.844,467.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.978,476.93], [878.597,514.788], [839.844,467.807], [840.622,503.961]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.597,514.812], [879.209,552.279], [840.623,503.984], [841.393,539.783]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.209,552.303], [879.815,589.386], [841.394,539.806], [842.157,575.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.816,589.41], [880.415,626.115], [842.157,575.277], [842.913,610.381]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.416,626.138], [881.009,662.471], [842.913,610.403], [843.661,645.167]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.009,662.494], [881.597,698.459], [843.662,645.189], [844.403,679.617]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.597,698.459], [882.136,731.486], [844.403,679.617], [845.083,711.246]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.437,321.374], [876.082,360.88], [896.795,320.974], [897.322,360.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.083,360.881], [876.721,399.946], [897.323,360.098], [897.844,398.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.721,399.971], [877.353,438.627], [897.844,398.815], [898.36,437.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.353,438.652], [877.978,476.906], [898.36,437.13], [898.871,475.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.978,476.93], [878.597,514.788], [898.871,475.05], [899.377,512.557]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.597,514.812], [879.209,552.279], [899.377,512.581], [899.877,549.705]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.209,552.303], [879.815,589.386], [899.878,549.729], [900.373,586.476]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.816,589.41], [880.415,626.115], [900.373,586.499], [900.863,622.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.416,626.138], [881.009,662.471], [900.864,622.898], [901.349,658.908]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.009,662.494], [881.597,698.459], [901.349,658.931], [901.83,694.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.597,698.459], [882.136,731.486], [901.83,694.581], [902.271,727.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.691,321.645], [911.152,361.41], [896.795,320.974], [897.322,360.098]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.152,361.41], [911.609,400.728], [897.322,360.098], [897.844,398.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.609,400.753], [912.061,439.656], [897.844,398.815], [898.36,437.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.062,439.681], [912.509,478.177], [898.36,437.13], [898.871,475.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.509,478.202], [912.951,516.296], [898.871,475.05], [899.377,512.557]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.952,516.32], [913.39,554.02], [899.377,512.581], [899.877,549.705]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.39,554.044], [913.823,591.354], [899.878,549.729], [900.373,586.476]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.823,591.378], [914.252,628.305], [900.373,586.499], [900.863,622.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.253,628.329], [914.677,664.879], [900.864,622.898], [901.349,658.908]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.678,664.902], [915.098,701.081], [901.349,658.931], [901.829,694.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.098,701.081], [915.484,734.302], [901.829,694.581], [902.271,727.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.691,321.645], [911.152,361.41], [926.044,321.351], [926.421,360.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.152,361.41], [911.609,400.728], [926.421,360.834], [926.794,399.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.609,400.753], [912.061,439.656], [926.795,399.903], [927.164,438.538]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.062,439.681], [912.509,478.177], [927.164,438.562], [927.53,476.795]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.509,478.201], [912.952,516.296], [927.53,476.819], [927.892,514.656]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[981.745,281.436], [981.826,320.102], [912.654,281.353], [913.058,317.147]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.952,516.32], [913.39,554.02], [927.892,514.68], [928.25,552.128]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.39,554.044], [913.823,591.354], [928.25,552.151], [928.604,589.215]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.824,591.378], [928.605,589.238], [914.253,628.305], [928.955,625.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.253,628.328], [928.956,625.947], [914.677,664.879], [929.303,662.261]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.678,664.902], [929.303,662.284], [915.098,701.081], [929.646,698.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.098,701.081], [929.646,698.231], [915.484,734.302], [929.962,731.241]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.55,327.58], [996.556,372.983], [946.846,325.082], [947.138,368.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.556,372.983], [996.561,417.81], [947.138,368.114], [947.426,410.626]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.561,417.838], [996.567,462.125], [947.426,410.653], [947.711,452.68]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.567,462.153], [996.572,505.911], [947.711,452.706], [947.992,494.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.572,505.939], [996.577,549.177], [947.993,494.284], [948.271,535.367]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.577,549.204], [996.582,591.932], [948.271,535.392], [948.547,576.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.582,591.959], [996.587,634.185], [948.547,576.041], [948.819,616.21]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.587,634.212], [996.592,675.945], [948.819,616.236], [949.088,655.96]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.592,675.971], [996.597,717.22], [949.089,655.985], [949.355,695.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.597,717.246], [996.602,758.019], [949.355,695.297], [949.618,734.153]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[996.602,758.019], [996.606,795.409], [949.618,734.153], [949.86,769.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.94,329.555], [1011.84,376.831], [980.655,327.943], [980.758,373.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.84,376.831], [1011.75,423.483], [980.758,373.692], [980.859,418.854]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.75,423.512], [1011.66,469.58], [980.859,418.883], [980.96,463.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.66,469.609], [1011.58,515.104], [980.96,463.526], [981.059,507.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.58,515.133], [1011.49,560.065], [981.059,507.633], [981.157,551.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.49,560.094], [1011.4,604.474], [981.157,551.211], [981.254,594.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.4,604.503], [1011.32,648.341], [981.254,594.271], [981.35,636.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.32,648.369], [1011.23,691.675], [981.35,636.821], [981.444,678.845]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.23,691.703], [1011.15,734.487], [981.444,678.872], [981.538,720.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.15,734.514], [1011.07,776.786], [981.538,720.43], [981.63,761.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1011.07,776.786], [1010.99,815.533], [981.63,761.48], [981.715,799.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.4,703.077], [1055.04,746.967], [1024.56,690.027], [1024.39,732.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.04,746.995], [1054.69,790.343], [1024.39,732.675], [1024.23,774.787]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1054.69,790.344], [1054.36,830.065], [1024.23,774.787], [1024.09,813.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.65,427.625], [1057.27,474.982], [1025.58,422.907], [1025.4,468.785]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.27,475.011], [1056.88,521.762], [1025.4,468.814], [1025.23,514.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.88,521.791], [1056.51,567.948], [1025.23,514.153], [1025.06,558.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.51,567.977], [1056.13,613.55], [1025.06,558.933], [1024.89,603.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.13,613.579], [1055.77,658.58], [1024.89,603.166], [1024.72,646.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.77,658.609], [1055.4,703.049], [1024.72,646.86], [1024.56,690]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1058.85,281.742], [1058.44,330.987], [1026.12,281.696], [1025.93,329.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.45,330.987], [1058.05,379.621], [1025.93,329.344], [1025.75,376.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.05,379.621], [1057.65,427.595], [1025.75,376.421], [1025.58,422.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1054.69,790.344], [1072.45,785.832], [1054.36,830.066], [1072.03,825.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.77,658.609], [1073.85,655.201], [1055.4,703.049], [1073.38,699.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.4,703.077], [1073.38,699.292], [1055.04,746.967], [1072.91,742.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.04,746.994], [1072.91,742.841], [1054.69,790.343], [1072.45,785.832]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.51,567.977], [1056.13,613.55], [1074.81,565.352], [1074.33,610.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.13,613.579], [1055.77,658.581], [1074.33,610.558], [1073.85,655.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.65,427.625], [1057.27,474.981], [1076.3,426.255], [1075.8,473.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.27,475.011], [1056.88,521.762], [1075.8,473.212], [1075.3,519.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.88,521.791], [1056.51,567.948], [1075.3,519.574], [1074.81,565.323]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1058.85,281.742], [1058.45,330.987], [1077.85,281.729], [1077.33,330.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.45,330.987], [1058.05,379.621], [1077.33,330.51], [1076.81,378.692]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.05,379.621], [1057.66,427.595], [1076.81,378.692], [1076.3,426.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.26,769.841], [1131.39,815.151], [1072.91,742.842], [1072.45,785.832]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.39,815.151], [1130.59,856.646], [1072.45,785.833], [1072.03,825.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.04,677.372], [1133.14,723.879], [1073.85,655.201], [1073.38,699.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.14,723.909], [1132.26,769.812], [1073.38,699.292], [1072.91,742.814]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.86,582.435], [1134.94,630.188], [1074.81,565.352], [1074.33,610.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.94,630.218], [1134.04,677.342], [1074.33,610.557], [1073.85,655.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.73,484.929], [1136.79,533.979], [1075.8,473.212], [1075.3,519.545]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.79,534.009], [1135.86,582.404], [1075.3,519.574], [1074.81,565.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.66,384.749], [1138.69,435.149], [1076.81,378.692], [1076.3,426.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.69,435.18], [1137.73,484.898], [1076.3,426.255], [1075.8,473.183]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1141.63,281.816], [1140.64,333.622], [1077.85,281.729], [1077.33,330.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.64,333.621], [1139.66,384.749], [1077.33,330.51], [1076.81,378.692]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1132.26,769.841], [1131.39,815.151], [1167.97,760.787], [1166.89,805.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1131.39,815.151], [1130.59,856.646], [1166.89,805.322], [1165.9,846.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.14,723.909], [1132.26,769.812], [1169.06,715.652], [1167.97,760.759]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.04,677.372], [1133.14,723.88], [1170.17,669.934], [1169.07,715.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.94,630.218], [1134.04,677.342], [1171.3,623.621], [1170.17,669.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.86,582.435], [1134.94,630.188], [1172.44,576.701], [1171.3,623.591]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.79,534.009], [1135.86,582.404], [1173.59,529.163], [1172.44,576.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.73,484.929], [1136.79,533.979], [1174.76,480.994], [1173.59,529.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.69,435.18], [1137.73,484.898], [1175.94,432.182], [1174.76,480.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.66,384.749], [1138.69,435.149], [1177.14,382.714], [1175.94,432.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.64,333.621], [1139.66,384.749], [1178.36,332.575], [1177.14,382.714]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1141.63,281.816], [1140.64,333.622], [1179.59,281.787], [1178.36,332.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.7,815.629], [1187.56,857.159], [1166.89,805.322], [1165.9,846.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.94,770.282], [1188.7,815.629], [1167.97,760.787], [1166.89,805.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.2,724.311], [1189.94,770.253], [1169.06,715.652], [1167.97,760.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.48,677.734], [1191.2,724.282], [1170.17,669.934], [1169.06,715.623]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.77,630.539], [1192.48,677.705], [1171.3,623.62], [1170.17,669.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.08,582.714], [1193.77,630.51], [1172.43,576.701], [1171.3,623.591]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.41,534.246], [1195.08,582.684], [1173.59,529.163], [1172.44,576.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.76,485.121], [1196.41,534.215], [1174.76,480.994], [1173.59,529.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.12,435.326], [1197.76,485.09], [1175.94,432.182], [1174.76,480.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.51,384.848], [1199.12,435.295], [1177.14,382.714], [1175.94,432.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.91,333.672], [1200.51,384.848], [1178.36,332.575], [1177.14,382.714]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1203.33,281.817], [1201.91,333.673], [1179.59,281.786], [1178.36,332.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.7,815.629], [1187.56,857.159], [1233.62,802.799], [1232.25,843.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.94,770.282], [1188.7,815.629], [1235.12,758.463], [1233.62,802.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.2,724.311], [1189.94,770.253], [1236.64,713.533], [1235.12,758.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.48,677.734], [1191.2,724.282], [1238.18,668.025], [1236.64,713.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.77,630.539], [1192.48,677.705], [1239.73,621.928], [1238.18,667.996]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.08,582.714], [1193.77,630.51], [1241.31,575.23], [1239.74,621.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.41,534.246], [1195.08,582.684], [1242.91,527.92], [1241.31,575.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.76,485.121], [1196.41,534.215], [1244.53,479.985], [1242.91,527.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.12,435.326], [1197.76,485.09], [1246.17,431.414], [1244.53,479.955]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.51,384.848], [1199.13,435.295], [1247.84,382.192], [1246.18,431.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.91,333.672], [1200.51,384.848], [1249.52,332.308], [1247.84,382.192]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1203.33,281.817], [1201.91,333.672], [1251.23,281.779], [1249.52,332.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.19,798.466], [1222.88,838.771], [1265.25,786.895], [1263.74,826.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.61,754.474], [1224.19,798.466], [1266.9,743.82], [1265.25,786.895]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.06,709.895], [1225.61,754.445], [1268.57,700.184], [1266.9,743.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.52,664.749], [1227.06,709.867], [1270.25,656.003], [1268.57,700.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230,619.023], [1228.52,664.72], [1271.97,611.269], [1270.26,655.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.51,572.706], [1230.01,618.993], [1273.7,565.97], [1271.97,611.241]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.03,525.787], [1231.51,572.676], [1275.45,520.097], [1273.7,565.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.57,478.254], [1233.03,525.757], [1277.23,473.636], [1275.45,520.067]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.13,430.095], [1234.57,478.224], [1279.03,426.578], [1277.23,473.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.71,381.297], [1236.13,430.064], [1280.85,378.911], [1279.03,426.548]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.32,331.848], [1237.71,381.297], [1282.7,330.622], [1280.85,378.911]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1240.93,282.055], [1239.32,331.848], [1284.56,282.014], [1282.7,330.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.52,778.067], [1243.15,816.906], [1276.89,769.206], [1275.37,807.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.01,735.693], [1244.52,778.067], [1278.55,727.539], [1276.89,769.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.52,692.777], [1246.01,735.666], [1280.23,685.347], [1278.55,727.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.05,649.336], [1247.52,692.75], [1281.93,642.649], [1280.23,685.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.6,605.359], [1249.05,649.308], [1283.65,599.433], [1281.93,642.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.17,560.838], [1250.6,605.332], [1285.39,555.693], [1283.65,599.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.76,515.761], [1252.17,560.81], [1287.15,511.416], [1285.39,555.665]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.37,470.119], [1253.76,515.733], [1288.93,466.595], [1287.15,511.388]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257,423.9], [1255.37,470.09], [1290.74,421.218], [1288.94,466.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.65,377.094], [1257,423.871], [1292.57,375.275], [1290.74,421.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.32,329.69], [1258.65,377.094], [1294.42,328.756], [1292.57,375.275]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1262.01,281.705], [1260.32,329.689], [1296.29,281.679], [1294.42,328.755]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[824.159,280.559], [824.996,315.785], [798.334,280.214], [799.254,313.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.996,315.785], [825.825,350.694], [799.255,313.948], [800.167,347.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.825,350.694], [826.646,385.248], [800.167,347.392], [801.071,380.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.646,385.269], [827.459,419.494], [801.072,380.53], [801.967,413.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.46,419.515], [828.265,453.415], [801.968,413.366], [802.855,445.883]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.265,453.436], [829.063,487.016], [802.856,445.903], [803.735,478.126]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.063,487.037], [829.854,520.302], [803.736,478.146], [804.607,510.079]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.854,520.323], [830.637,553.276], [804.608,510.099], [805.471,541.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.637,553.297], [831.413,585.944], [805.472,541.765], [806.328,573.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.413,585.965], [832.181,618.309], [806.328,573.148], [807.177,604.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.182,618.33], [832.943,650.376], [807.177,604.253], [808.018,635.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.943,650.376], [833.643,679.829], [808.018,635.064], [808.791,663.391]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[824.434,280.819], [825.296,317.167], [808.949,280.606], [809.865,316.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[825.296,317.167], [826.15,353.176], [809.865,316.031], [810.771,351.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.15,353.176], [826.995,388.808], [810.772,351.136], [811.669,385.881]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.995,388.83], [827.832,424.112], [811.67,385.902], [812.559,420.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.832,424.134], [828.661,459.07], [812.56,420.336], [813.44,454.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.046,318.632], [830.903,355.808], [813.286,317.368], [814.204,353.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.662,459.092], [829.482,493.689], [813.441,454.442], [814.313,488.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.903,355.808], [831.751,392.581], [814.204,353.537], [815.112,389.326]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.482,493.711], [830.295,527.973], [814.314,488.224], [815.178,521.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.752,392.605], [832.592,429.005], [815.113,389.348], [816.012,424.783]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.296,527.994], [831.1,561.926], [815.178,521.687], [816.034,554.815]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.592,429.029], [833.423,465.062], [816.012,424.806], [816.902,459.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.101,561.947], [831.898,595.553], [816.035,554.836], [816.883,587.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.424,465.085], [834.247,500.756], [816.903,459.915], [817.784,494.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.898,595.575], [832.688,628.86], [816.883,587.674], [817.723,620.187]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.247,500.779], [835.062,536.094], [817.785,494.682], [818.658,529.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.062,536.117], [835.869,571.081], [818.659,529.11], [819.523,563.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.688,628.881], [833.47,661.85], [817.724,620.207], [818.556,652.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.47,661.851], [834.188,692.144], [818.556,652.418], [819.321,682.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.869,571.103], [836.668,605.721], [819.523,563.205], [820.38,596.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.668,605.743], [837.459,640.021], [820.38,596.972], [821.228,630.393]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.459,640.043], [838.242,673.985], [821.229,630.415], [822.069,663.518]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.242,673.985], [838.961,705.163], [822.069,663.518], [822.84,693.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.046,318.632], [830.903,355.808], [845.696,318.361], [846.469,355.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.903,355.808], [831.752,392.581], [846.469,355.321], [847.233,391.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.752,392.605], [832.592,429.005], [847.234,391.907], [847.99,428.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.592,429.028], [833.423,465.062], [847.991,428.123], [848.74,463.954]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.424,465.085], [834.247,500.756], [848.741,463.977], [849.482,499.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.247,500.779], [849.483,499.472], [835.062,536.094], [850.217,534.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.062,536.117], [850.218,534.615], [835.869,571.081], [850.945,569.388]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.869,571.103], [850.945,569.411], [836.668,605.721], [851.665,603.842]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.668,605.743], [851.665,603.864], [837.459,640.021], [852.378,637.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.459,640.043], [852.379,637.98], [838.242,673.985], [853.085,671.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.242,673.985], [853.085,671.743], [838.961,705.163], [853.733,702.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.982,320.722], [878.621,359.559], [845.696,318.361], [846.469,355.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.621,359.559], [879.253,397.959], [846.469,355.321], [847.233,391.883]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.254,397.983], [879.879,435.976], [847.234,391.907], [847.991,428.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.88,436], [880.499,473.593], [847.991,428.123], [848.74,463.954]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.499,473.617], [881.111,510.815], [848.741,463.977], [849.482,499.45]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.112,510.839], [881.718,547.65], [849.483,499.472], [850.217,534.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.718,547.673], [882.318,584.102], [850.218,534.615], [850.945,569.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.319,584.125], [882.912,620.178], [850.945,569.41], [851.665,603.842]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.913,620.201], [883.5,655.883], [851.665,603.864], [852.378,637.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.5,655.906], [884.082,691.224], [852.379,637.98], [853.085,671.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.082,691.224], [884.616,723.654], [853.085,671.743], [853.733,702.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.982,320.722], [878.621,359.559], [899.897,320.318], [900.415,358.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[878.621,359.559], [879.253,397.959], [900.415,358.834], [900.927,396.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.254,397.983], [879.879,435.976], [900.927,396.944], [901.434,434.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[879.88,436], [880.499,473.593], [901.434,434.653], [901.935,471.945]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[880.499,473.617], [881.111,510.815], [901.936,471.968], [902.432,508.872]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.112,510.839], [881.718,547.65], [902.432,508.896], [902.923,545.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.718,547.673], [882.318,584.102], [902.924,545.441], [903.409,581.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.319,584.125], [882.912,620.178], [903.41,581.61], [903.891,617.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.913,620.201], [903.891,617.409], [883.5,655.884], [904.367,652.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.5,655.906], [904.367,652.844], [884.082,691.224], [904.839,687.897]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.082,691.224], [904.839,687.897], [884.616,723.654], [905.271,720.085]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.586,321.138], [912.05,360.306], [899.897,320.318], [900.415,358.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.049,360.307], [912.508,399.03], [900.415,358.834], [900.927,396.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.508,399.054], [912.961,437.364], [900.927,396.944], [901.434,434.629]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.962,437.388], [913.41,475.29], [901.434,434.653], [901.935,471.945]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.41,475.315], [913.854,512.816], [901.936,471.968], [902.432,508.872]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.854,512.84], [914.294,549.948], [902.432,508.895], [902.923,545.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.294,549.971], [914.729,586.691], [902.923,545.441], [903.409,581.587]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.729,586.714], [915.159,623.051], [903.41,581.61], [903.891,617.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.159,623.074], [915.585,659.036], [903.891,617.409], [904.367,652.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.585,659.058], [916.006,694.649], [904.367,652.844], [904.839,687.897]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.006,694.649], [916.393,727.326], [904.839,687.897], [905.271,720.085]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.586,321.138], [912.05,360.306], [927.418,320.84], [927.794,359.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.05,360.306], [912.508,399.03], [927.794,359.771], [928.165,398.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.508,399.054], [912.961,437.364], [928.165,398.287], [928.533,436.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.962,437.388], [913.41,475.291], [928.533,436.394], [928.897,474.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.411,475.314], [913.854,512.817], [928.897,474.098], [929.257,511.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.855,512.84], [914.294,549.948], [929.257,511.406], [929.613,548.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.294,549.971], [929.613,548.325], [914.729,586.691], [929.966,584.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.729,586.714], [929.966,584.859], [915.159,623.052], [930.315,620.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.159,623.074], [930.315,621.016], [915.585,659.036], [930.66,656.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.585,659.058], [930.66,656.8], [916.006,694.65], [931.002,692.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.006,694.65], [931.002,692.196], [916.393,727.326], [931.316,724.695]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[985.65,281.267], [985.712,319.544], [926.123,280.583], [926.468,315.91]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.093,328.302], [979.207,373.153], [937.336,325.238], [937.688,367.662]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.207,373.153], [979.319,417.425], [937.688,367.662], [938.036,409.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.319,417.453], [979.43,461.183], [938.036,409.592], [938.379,451.011]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.43,461.211], [979.539,504.41], [938.379,451.037], [938.719,491.98]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.539,504.437], [979.647,547.114], [938.719,492.006], [939.054,532.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.647,547.141], [979.754,589.306], [939.055,532.505], [939.386,572.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.754,589.333], [979.86,630.994], [939.386,572.545], [939.714,612.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.86,631.021], [979.964,672.188], [939.715,612.132], [940.039,651.249]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[979.964,672.214], [980.067,712.896], [940.039,651.273], [940.36,689.953]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.067,712.922], [980.169,753.127], [940.36,689.978], [940.677,728.228]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[980.169,753.127], [980.262,789.989], [940.677,728.228], [940.968,763.318]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.659,330.65], [988.716,377.359], [962.451,328.671], [962.669,373.815]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.716,377.36], [988.772,423.441], [962.669,373.815], [962.884,418.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.772,423.471], [988.827,468.966], [962.884,418.4], [963.096,462.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.827,468.995], [988.881,513.914], [963.097,462.436], [963.306,505.906]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.881,513.943], [988.935,558.298], [963.307,505.933], [963.514,548.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.935,558.326], [988.988,602.127], [963.514,548.902], [963.719,591.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[988.988,602.155], [989.041,645.412], [963.719,591.352], [963.921,633.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.041,645.439], [989.092,688.163], [963.921,633.292], [964.121,674.705]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.093,688.19], [989.144,730.39], [964.121,674.731], [964.319,715.652]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.144,730.417], [989.194,772.102], [964.319,715.678], [964.514,756.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.194,772.102], [989.241,810.305], [964.514,756.117], [964.693,793.191]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1030.71,283.707], [1030.49,332.481], [1003.08,283.324], [1003.05,330.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.49,332.481], [1030.27,380.638], [1003.05,330.453], [1003.01,377.008]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.27,380.638], [1030.06,428.128], [1003.01,377.008], [1002.98,422.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.06,428.158], [1029.84,475.026], [1002.98,422.967], [1002.94,468.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.84,475.055], [1029.63,521.312], [1002.94,468.344], [1002.91,513.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.63,521.341], [1029.42,566.998], [1002.91,513.148], [1002.87,557.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.42,567.027], [1029.22,612.097], [1002.87,557.391], [1002.84,601.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.22,612.125], [1029.01,656.619], [1002.84,601.083], [1002.8,644.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.01,656.647], [1028.81,700.575], [1002.8,644.235], [1002.77,686.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.81,700.603], [1028.61,743.976], [1002.77,686.856], [1002.74,728.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.61,744.004], [1028.42,786.833], [1002.74,728.956], [1002.71,770.518]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.42,786.833], [1028.24,826.07], [1002.71,770.518], [1002.68,808.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.61,744.003], [1047.56,740.383], [1028.42,786.833], [1047.25,782.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.42,786.833], [1047.25,782.909], [1028.24,826.07], [1046.96,821.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.63,521.341], [1029.42,566.998], [1049.18,519.368], [1048.85,564.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.42,567.027], [1029.22,612.097], [1048.85,564.707], [1048.52,609.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.22,612.125], [1048.52,609.468], [1029.01,656.619], [1048.2,653.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.01,656.647], [1048.2,653.66], [1028.81,700.575], [1047.88,697.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.81,700.603], [1047.88,697.295], [1028.61,743.976], [1047.56,740.356]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1030.71,283.707], [1030.49,332.481], [1050.91,283.614], [1050.55,331.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.49,332.481], [1030.27,380.638], [1050.56,331.992], [1050.2,379.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.27,380.638], [1030.06,428.128], [1050.2,379.763], [1049.86,426.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.06,428.158], [1029.84,475.026], [1049.86,426.908], [1049.52,473.41]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.84,475.055], [1029.63,521.312], [1049.52,473.439], [1049.18,519.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.19,768.933], [1097.52,813.847], [1047.56,740.383], [1047.25,782.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.52,813.847], [1096.91,854.969], [1047.25,782.909], [1046.96,821.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.24,630.448], [1099.55,677.202], [1048.52,609.467], [1048.2,653.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1099.55,677.232], [1098.86,723.36], [1048.2,653.66], [1047.88,697.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.86,723.389], [1098.19,768.904], [1047.88,697.295], [1047.56,740.356]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1102.37,486.211], [1101.65,534.921], [1049.52,473.439], [1049.18,519.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.65,534.951], [1100.94,582.995], [1049.18,519.368], [1048.85,564.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.94,583.026], [1100.24,630.418], [1048.85,564.707], [1048.52,609.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1104.6,335.857], [1103.85,386.679], [1050.56,331.992], [1050.2,379.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1103.85,386.679], [1103.1,436.761], [1050.2,379.763], [1049.86,426.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1103.1,436.792], [1102.37,486.18], [1049.86,426.908], [1049.52,473.41]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1105.36,284.344], [1104.6,335.857], [1050.91,283.614], [1050.56,331.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.52,813.847], [1096.91,854.969], [1135.74,805.222], [1134.91,845.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.86,723.389], [1098.19,768.904], [1137.56,716.111], [1136.64,760.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.19,768.933], [1097.52,813.847], [1136.64,760.972], [1135.74,805.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1099.55,677.232], [1098.86,723.36], [1138.49,670.655], [1137.56,716.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.94,583.026], [1100.24,630.418], [1140.38,577.912], [1139.43,624.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.24,630.448], [1099.55,677.202], [1139.43,624.593], [1138.49,670.626]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.65,534.951], [1100.94,582.995], [1141.35,530.6], [1140.38,577.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1103.1,436.792], [1102.37,486.18], [1143.32,434.03], [1142.33,482.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1102.37,486.211], [1101.65,534.921], [1142.33,482.644], [1141.35,530.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1103.85,386.679], [1103.1,436.761], [1144.33,384.746], [1143.32,433.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1104.6,335.857], [1103.85,386.679], [1145.35,334.776], [1144.33,384.746]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1105.36,284.344], [1104.6,335.857], [1146.38,284.14], [1145.35,334.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.64,816.191], [1153.68,857.475], [1135.74,805.222], [1134.91,845.744]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.69,771.096], [1154.64,816.191], [1136.64,760.971], [1135.74,805.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.75,725.367], [1155.69,771.068], [1137.56,716.11], [1136.64,760.943]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.83,679.019], [1156.75,725.338], [1138.49,670.655], [1137.56,716.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.92,632.04], [1157.83,678.99], [1139.43,624.592], [1138.49,670.626]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.15,536.135], [1160.03,584.386], [1141.35,530.599], [1140.38,577.882]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.03,584.416], [1158.92,632.01], [1140.38,577.912], [1139.43,624.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.29,487.182], [1161.15,536.104], [1142.33,482.644], [1141.35,530.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.44,437.543], [1162.29,487.151], [1143.32,434.03], [1142.33,482.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.61,387.204], [1163.44,437.512], [1144.33,384.746], [1143.32,433.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.8,336.151], [1164.61,387.204], [1145.35,334.776], [1144.33,384.746]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1167,284.4], [1165.8,336.151], [1146.38,284.14], [1145.35,334.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.64,816.191], [1153.68,857.475], [1203.5,804.846], [1202.26,845.342]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.69,771.097], [1154.64,816.191], [1204.84,760.625], [1203.5,804.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.75,725.367], [1155.69,771.068], [1206.21,715.793], [1204.84,760.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.83,679.02], [1156.75,725.339], [1207.59,670.368], [1206.21,715.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.92,632.04], [1157.83,678.99], [1208.99,624.337], [1207.59,670.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.03,584.416], [1158.92,632.01], [1210.41,577.689], [1208.99,624.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.15,536.135], [1160.03,584.386], [1211.85,530.41], [1210.41,577.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.29,487.182], [1161.15,536.104], [1213.31,482.488], [1211.85,530.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.44,437.543], [1162.29,487.151], [1214.78,433.91], [1213.31,482.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.61,387.204], [1163.44,437.512], [1216.28,384.661], [1214.78,433.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.8,336.151], [1164.61,387.204], [1217.8,334.729], [1216.28,384.662]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1167,284.399], [1165.8,336.151], [1219.34,284.131], [1217.8,334.729]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.23,800.214], [1194.06,840.387], [1240.07,789.93], [1238.66,829.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.51,756.35], [1195.23,800.214], [1241.61,746.86], [1240.07,789.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.81,711.886], [1196.51,756.322], [1243.17,703.213], [1241.61,746.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.12,666.838], [1197.81,711.858], [1244.75,659.004], [1243.18,703.185]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.46,621.195], [1199.12,666.81], [1246.36,614.223], [1244.76,658.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.81,574.945], [1200.46,621.166], [1247.98,568.858], [1246.36,614.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.17,528.076], [1201.81,574.916], [1249.62,522.898], [1247.98,568.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.56,480.575], [1203.18,528.046], [1251.29,476.331], [1249.62,522.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.97,432.429], [1204.56,480.544], [1252.97,429.146], [1251.29,476.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.39,383.625], [1205.97,432.398], [1254.68,381.328], [1252.97,429.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.84,334.15], [1207.39,383.625], [1256.42,332.867], [1254.68,381.328]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1210.29,284.311], [1208.84,334.15], [1258.16,284.063], [1256.42,332.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.65,780.438], [1220.37,819.227], [1257.03,772.536], [1255.57,810.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.04,738.104], [1221.65,780.438], [1258.62,730.817], [1257.03,772.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.46,695.213], [1223.04,738.078], [1260.23,688.555], [1258.62,730.79]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.89,651.78], [1224.46,695.186], [1261.87,645.769], [1260.23,688.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.34,607.795], [1225.89,651.752], [1263.52,602.448], [1261.87,645.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.81,563.248], [1227.34,607.767], [1265.19,558.582], [1263.52,602.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.3,518.127], [1228.81,563.219], [1266.89,514.16], [1265.19,558.554]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.81,472.422], [1230.3,518.099], [1268.6,469.173], [1266.89,514.132]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1233.34,426.121], [1231.81,472.393], [1270.34,423.608], [1268.61,469.144]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234.88,379.213], [1233.34,426.092], [1272.1,377.456], [1270.34,423.579]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.45,331.685], [1234.88,379.213], [1273.89,330.704], [1272.1,377.456]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1238.04,283.556], [1236.45,331.685], [1275.69,283.371], [1273.89,330.704]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[840.457,279.591], [841.222,314.22], [819.749,278.963], [820.577,312.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.222,314.22], [841.98,348.535], [820.577,312.092], [821.398,344.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.98,348.535], [842.73,382.497], [821.398,344.934], [822.21,377.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.73,382.519], [843.473,416.155], [822.211,377.473], [823.016,409.692]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.473,416.176], [844.209,449.49], [823.017,409.713], [823.815,441.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.209,449.511], [844.938,482.508], [823.815,441.657], [824.606,473.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.938,482.529], [845.66,515.214], [824.606,473.311], [825.39,504.658]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[837.472,280.048], [838.276,315.766], [825.139,279.659], [825.982,314.45]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.661,515.234], [846.375,547.611], [825.39,504.677], [826.166,535.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[838.276,315.766], [839.072,351.149], [825.982,314.45], [826.817,348.925]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.45,317.419], [840.266,353.943], [826.17,315.955], [827.03,351.468]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.376,547.631], [847.084,579.704], [826.167,535.76], [826.936,566.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.266,353.944], [841.073,390.07], [827.03,351.469], [827.88,386.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.072,351.15], [839.86,386.159], [826.817,348.925], [827.644,383.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.861,386.181], [840.641,420.843], [827.645,383.064], [828.464,416.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.085,579.725], [847.786,611.498], [826.937,566.564], [827.699,597.073]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.073,390.093], [841.872,425.85], [827.881,386.627], [828.723,421.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.641,420.865], [841.413,455.185], [828.464,416.875], [829.275,450.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.787,611.518], [848.482,642.996], [827.7,597.092], [828.455,627.329]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.482,642.996], [849.12,671.925], [828.455,627.329], [829.15,655.128]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.873,425.872], [842.664,461.266], [828.724,421.437], [829.558,455.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[842.664,461.288], [843.447,496.323], [829.558,455.901], [830.384,490.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.414,455.207], [842.179,489.191], [829.276,450.36], [830.079,483.504]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[843.447,496.345], [844.222,531.027], [830.385,490.027], [831.203,523.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.179,489.213], [842.936,522.865], [830.079,483.525], [830.875,516.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.223,531.049], [844.99,565.384], [831.203,523.818], [832.013,557.259]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.937,522.886], [843.687,556.211], [830.875,516.375], [831.664,548.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.687,556.232], [844.43,589.236], [831.664,548.914], [832.445,581.126]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.99,565.406], [845.75,599.398], [832.013,557.28], [832.815,590.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.43,589.256], [845.166,621.942], [832.445,581.146], [833.219,613.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[845.75,599.42], [846.502,633.075], [832.816,590.417], [833.61,623.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[846.503,633.096], [847.247,666.419], [833.61,623.235], [834.397,655.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.166,621.963], [845.895,654.336], [833.219,613.076], [833.985,644.687]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[847.247,666.419], [847.931,697.027], [834.397,655.716], [835.12,685.558]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.895,654.336], [846.564,684.078], [833.985,644.688], [834.689,673.738]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.45,317.419], [840.266,353.943], [855.275,317.164], [856.006,353.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[840.266,353.944], [841.073,390.07], [856.006,353.513], [856.729,389.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.073,390.093], [841.872,425.85], [856.729,389.49], [857.445,425.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[841.873,425.872], [842.664,461.266], [857.445,425.101], [858.153,460.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[842.664,461.288], [858.154,460.352], [843.447,496.323], [858.855,495.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[843.447,496.345], [858.855,495.247], [844.222,531.027], [859.549,529.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.223,531.049], [859.55,529.793], [844.99,565.384], [860.237,563.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.99,565.406], [860.237,563.994], [845.75,599.398], [860.918,597.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[845.75,599.42], [860.918,597.856], [846.502,633.075], [861.592,631.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[846.503,633.096], [861.592,631.383], [847.247,666.419], [862.259,664.56]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[847.247,666.42], [862.259,664.56], [847.931,697.027], [862.872,695.035]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.131,319.909], [881.76,358.151], [855.275,317.164], [856.006,353.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.76,358.152], [882.382,395.958], [856.006,353.513], [856.729,389.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.382,395.982], [882.998,433.385], [856.729,389.49], [857.445,425.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.998,433.408], [883.607,470.412], [857.445,425.101], [858.154,460.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.607,470.436], [884.21,507.048], [858.154,460.352], [858.855,495.225]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.21,507.071], [884.806,543.298], [858.855,495.247], [859.549,529.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.806,543.321], [885.396,579.168], [859.55,529.793], [860.237,563.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.397,579.19], [885.98,614.664], [860.237,563.994], [860.918,597.834]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.981,614.686], [886.558,649.791], [860.918,597.856], [861.592,631.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.559,649.814], [887.13,684.557], [861.592,631.383], [862.259,664.56]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.13,684.557], [887.655,716.455], [862.259,664.56], [862.872,695.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.131,319.909], [881.76,358.151], [903.468,319.527], [903.973,357.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.76,358.152], [882.382,395.959], [903.973,357.507], [904.472,395.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.382,395.982], [882.998,433.385], [904.473,395.081], [904.966,432.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.998,433.408], [883.607,470.413], [904.967,432.255], [905.455,469.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.607,470.436], [884.21,507.048], [905.456,469.036], [905.939,505.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.21,507.071], [884.806,543.298], [905.939,505.43], [906.418,541.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.806,543.321], [906.418,541.444], [885.396,579.168], [906.892,577.06]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.397,579.19], [906.892,577.082], [885.98,614.664], [907.36,612.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.981,614.686], [907.361,612.352], [886.558,649.791], [907.824,647.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.559,649.814], [907.825,647.258], [887.13,684.557], [908.284,681.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.13,684.557], [908.284,681.784], [887.655,716.455], [908.705,713.485]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.951,320.486], [913.413,359.126], [903.468,319.527], [903.973,357.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.413,359.126], [913.87,397.322], [903.973,357.507], [904.472,395.057]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.87,397.346], [914.322,435.128], [904.473,395.081], [904.966,432.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.322,435.152], [914.769,472.529], [904.967,432.255], [905.455,469.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.769,472.552], [915.211,509.529], [905.456,469.036], [905.939,505.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.211,509.552], [915.648,546.135], [905.939,505.43], [906.418,541.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.649,546.158], [916.081,582.354], [906.418,541.443], [906.892,577.06]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.082,582.377], [916.51,618.191], [906.892,577.082], [907.36,612.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.51,618.214], [916.934,653.653], [907.361,612.352], [907.824,647.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.934,653.676], [917.353,688.746], [907.825,647.258], [908.284,681.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.353,688.746], [917.738,720.94], [908.284,681.784], [908.705,713.485]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.951,320.486], [913.413,359.126], [929.16,320.203], [929.532,358.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.413,359.126], [913.87,397.322], [929.532,358.649], [929.899,396.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.87,397.346], [914.322,435.128], [929.899,396.678], [930.262,434.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.322,435.152], [914.769,472.529], [930.262,434.298], [930.622,471.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.769,472.552], [915.211,509.529], [930.622,471.516], [930.977,508.314]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.211,509.552], [930.977,508.337], [915.649,546.135], [931.329,544.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.649,546.158], [931.329,544.769], [916.081,582.354], [931.677,580.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.082,582.377], [931.678,580.816], [916.51,618.191], [932.022,616.464]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.51,618.214], [932.022,616.486], [916.934,653.653], [932.363,651.762]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.934,653.676], [932.363,651.785], [917.353,688.746], [932.7,686.695]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.353,688.746], [932.7,686.695], [917.738,720.94], [933.01,718.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.097,328.761], [962.319,373.094], [928.421,325.172], [928.83,367.038]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.319,373.094], [962.538,416.846], [928.83,367.038], [929.234,408.385]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.538,416.873], [962.754,460.083], [929.234,408.411], [929.634,449.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.755,460.11], [962.968,502.787], [929.634,449.299], [930.029,489.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.968,502.814], [963.18,544.967], [930.029,489.712], [930.419,529.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.18,544.994], [963.388,586.634], [930.419,529.656], [930.805,569.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.388,586.661], [963.594,627.797], [930.805,569.14], [931.186,608.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.594,627.823], [963.798,668.465], [931.186,608.172], [931.563,646.736]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.798,668.491], [963.999,708.647], [931.563,646.761], [931.936,684.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.999,708.672], [964.198,748.35], [931.936,684.912], [932.304,722.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.198,748.35], [964.38,784.724], [932.304,722.61], [932.642,757.19]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.891,331.431], [966.097,377.596], [944.871,329.112], [945.203,373.685]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.097,377.596], [966.301,423.132], [945.203,373.685], [945.531,417.671]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.301,423.161], [966.502,468.109], [945.531,417.699], [945.854,461.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.502,468.137], [966.7,512.509], [945.855,461.164], [946.174,504.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.701,512.537], [966.896,556.343], [946.174,504.091], [946.49,546.462]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.897,556.37], [967.09,599.621], [946.49,546.489], [946.802,588.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.09,599.648], [967.281,642.354], [946.802,588.368], [947.11,629.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.281,642.381], [967.469,684.553], [947.11,629.737], [947.414,670.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.47,684.58], [967.656,726.228], [947.414,670.607], [947.715,710.959]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.656,726.254], [967.84,767.387], [947.715,710.984], [948.012,750.855]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.84,767.387], [968.008,805.078], [948.012,750.855], [948.284,787.402]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1002.76,285.344], [1002.73,333.654], [980.411,284.636], [980.523,331.268]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.73,333.654], [1002.69,381.342], [980.523,331.268], [980.633,377.321]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.69,381.342], [1002.65,428.36], [980.633,377.321], [980.742,422.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.65,428.39], [1002.62,474.781], [980.742,422.777], [980.849,467.618]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.62,474.81], [1002.58,520.586], [980.85,467.647], [980.956,511.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.58,520.615], [1002.55,565.789], [980.956,511.943], [981.061,555.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.55,565.817], [1002.52,610.4], [981.061,555.675], [981.164,598.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.52,610.429], [1002.48,654.432], [981.164,598.855], [981.266,641.465]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.48,654.46], [1002.45,697.896], [981.266,641.492], [981.367,683.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.45,697.923], [1002.42,740.802], [981.367,683.598], [981.467,725.155]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.42,740.829], [1002.39,783.161], [981.467,725.181], [981.565,766.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.39,783.162], [1002.36,821.936], [981.565,766.225], [981.656,803.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.55,565.817], [1022.88,563.836], [1002.52,610.4], [1022.72,608.14]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.52,610.429], [1022.72,608.168], [1002.49,654.432], [1022.55,651.9]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.49,654.46], [1022.55,651.927], [1002.45,697.896], [1022.39,695.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.45,697.923], [1022.39,695.126], [1002.42,740.802], [1022.23,737.747]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.42,740.829], [1022.23,737.774], [1002.39,783.162], [1022.08,779.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.39,783.162], [1022.08,779.856], [1002.36,821.936], [1021.93,818.404]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1002.76,285.344], [1002.73,333.654], [1023.92,285.205], [1023.74,333.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.73,333.654], [1002.69,381.342], [1023.74,333.187], [1023.56,380.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.69,381.342], [1002.65,428.36], [1023.56,380.556], [1023.39,427.263]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.65,428.39], [1002.62,474.781], [1023.39,427.292], [1023.22,473.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.62,474.81], [1002.59,520.586], [1023.22,473.41], [1023.05,518.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1002.59,520.615], [1002.55,565.789], [1023.05,518.92], [1022.88,563.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.63,676.695], [1064.17,722.443], [1022.55,651.927], [1022.39,695.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.17,722.472], [1063.72,767.601], [1022.39,695.126], [1022.23,737.747]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.72,767.629], [1063.27,812.15], [1022.23,737.774], [1022.08,779.856]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.27,812.15], [1062.87,852.902], [1022.08,779.856], [1021.93,818.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.52,388.263], [1067.02,438.012], [1023.56,380.556], [1023.39,427.263]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.02,438.044], [1066.53,487.091], [1023.39,427.292], [1023.22,473.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.53,487.122], [1066.04,535.482], [1023.22,473.41], [1023.05,518.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.04,535.512], [1065.56,583.198], [1023.05,518.92], [1022.88,563.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.56,583.228], [1065.09,630.255], [1022.88,563.836], [1022.72,608.14]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.09,630.285], [1064.63,676.666], [1022.72,608.168], [1022.55,651.9]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1068.53,286.563], [1068.02,337.763], [1023.92,285.205], [1023.74,333.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.02,337.763], [1067.52,388.262], [1023.74,333.187], [1023.56,380.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.72,767.629], [1063.27,812.15], [1104.46,760.857], [1103.75,804.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1063.27,812.151], [1062.86,852.902], [1103.75,804.827], [1103.1,845.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.63,676.695], [1064.17,722.443], [1105.91,671.073], [1105.18,716.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1064.17,722.472], [1063.72,767.601], [1105.18,716.267], [1104.46,760.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.56,583.228], [1065.09,630.255], [1107.4,578.824], [1106.65,625.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1065.09,630.285], [1064.63,676.666], [1106.65,625.263], [1105.91,671.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.53,487.122], [1066.04,535.482], [1108.93,484.006], [1108.16,531.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.04,535.512], [1065.56,583.198], [1108.16,531.742], [1107.4,578.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.52,388.262], [1067.02,438.012], [1110.51,386.51], [1109.72,435.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.02,438.044], [1066.53,487.091], [1109.72,435.599], [1108.93,483.975]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1068.53,286.562], [1068.02,337.763], [1112.13,286.253], [1111.31,336.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.02,337.763], [1067.52,388.262], [1111.31,336.722], [1110.51,386.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.54,816.368], [1118.78,857.406], [1103.75,804.827], [1103.1,845.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120.37,771.53], [1119.54,816.368], [1104.46,760.857], [1103.75,804.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.08,679.934], [1121.22,726.018], [1105.91,671.073], [1105.18,716.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.22,726.047], [1120.38,771.501], [1105.18,716.267], [1104.46,760.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.94,633.178], [1122.08,679.904], [1106.65,625.263], [1105.91,671.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1124.72,537.685], [1123.83,585.737], [1108.16,531.742], [1107.4,578.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.83,585.767], [1122.95,633.149], [1107.4,578.824], [1106.65,625.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.62,488.919], [1124.72,537.654], [1108.93,484.005], [1108.16,531.712]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.54,439.453], [1125.63,488.888], [1109.72,435.599], [1108.93,483.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.48,389.273], [1126.54,439.422], [1110.51,386.51], [1109.72,435.569]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1129.38,286.74], [1128.42,338.363], [1112.13,286.253], [1111.31,336.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.42,338.363], [1127.48,389.273], [1111.31,336.722], [1110.51,386.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.54,816.368], [1118.78,857.406], [1171.79,806.664], [1170.72,847.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.22,726.047], [1120.38,771.501], [1174.14,717.823], [1172.95,762.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120.37,771.53], [1119.54,816.368], [1172.95,762.555], [1171.79,806.664]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.08,679.934], [1121.22,726.018], [1175.34,672.483], [1174.14,717.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.94,633.178], [1122.08,679.905], [1176.56,626.522], [1175.34,672.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.83,585.767], [1122.95,633.149], [1177.79,579.928], [1176.56,626.493]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1124.72,537.685], [1123.83,585.737], [1179.04,532.687], [1177.79,579.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1125.62,488.919], [1124.72,537.654], [1180.31,484.787], [1179.04,532.657]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1126.54,439.453], [1125.63,488.888], [1181.6,436.212], [1180.31,484.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1127.48,389.273], [1126.54,439.422], [1182.9,386.949], [1181.6,436.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1128.42,338.363], [1127.48,389.273], [1184.23,336.983], [1182.9,386.949]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1129.38,286.74], [1128.42,338.363], [1185.57,286.331], [1184.23,336.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1164.79,801.766], [1163.77,841.812], [1212.97,792.918], [1211.68,832.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1165.9,758.026], [1164.79,801.766], [1214.38,749.846], [1212.97,792.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1167.03,713.674], [1165.9,757.998], [1215.81,706.181], [1214.38,749.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.17,668.724], [1167.03,713.646], [1217.25,661.938], [1215.81,706.153]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.33,623.165], [1168.17,668.695], [1218.72,617.105], [1217.25,661.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.5,576.984], [1169.33,623.136], [1220.2,571.67], [1218.72,617.076]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.69,530.168], [1170.5,576.954], [1221.71,525.621], [1220.2,571.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.9,482.704], [1171.69,530.138], [1223.23,478.946], [1221.71,525.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.12,434.579], [1172.9,482.674], [1224.78,431.632], [1223.23,478.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.36,385.778], [1174.12,434.548], [1226.35,383.666], [1224.78,431.602]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.62,336.288], [1175.36,385.778], [1227.93,335.033], [1226.35,383.666]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1177.88,286.414], [1176.62,336.287], [1229.54,286.037], [1227.93,335.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.07,782.821], [1195.9,821.572], [1235.16,775.997], [1233.79,814.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1198.35,740.514], [1197.07,782.821], [1236.67,734.208], [1235.16,775.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.64,697.635], [1198.35,740.487], [1238.19,691.861], [1236.67,734.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.96,654.199], [1199.64,697.607], [1239.73,648.972], [1238.19,691.834]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.28,610.195], [1200.96,654.171], [1241.29,605.529], [1239.73,648.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.63,565.613], [1202.29,610.167], [1242.87,561.524], [1241.29,605.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205,520.44], [1203.63,565.584], [1244.48,516.943], [1242.88,561.496]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.38,474.665], [1205,520.411], [1246.1,471.777], [1244.48,516.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.78,428.276], [1206.38,474.636], [1247.75,426.012], [1246.1,471.748]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.2,381.261], [1207.78,428.247], [1249.41,379.639], [1247.75,425.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.64,333.606], [1209.2,381.261], [1251.1,332.643], [1249.41,379.639]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1212.1,285.329], [1210.64,333.606], [1252.81,285.043], [1251.1,332.643]]
            },],[{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.389,316.092], [850.159,352.057], [839.515,314.454], [840.313,349.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.159,352.057], [850.921,387.627], [840.313,349.408], [841.103,383.987]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[857.057,278.487], [857.746,312.615], [841.345,277.607], [842.077,310.231]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[850.931,279.106], [851.672,314.289], [841.678,278.562], [842.446,312.817]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.921,387.65], [851.675,422.854], [841.104,384.009], [841.885,418.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.672,314.289], [852.407,349.14], [842.446,312.817], [843.206,346.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.676,422.876], [852.422,457.72], [841.886,418.264], [842.66,452.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.422,457.742], [853.161,492.23], [842.66,452.178], [843.427,485.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.161,492.252], [853.893,526.39], [843.427,485.757], [844.186,518.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.893,526.412], [854.617,560.206], [844.186,519.004], [844.938,551.903]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.617,560.227], [855.334,593.682], [844.938,551.924], [845.682,584.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.334,593.703], [856.043,626.824], [845.683,584.524], [846.419,616.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.044,626.845], [856.746,659.636], [846.42,616.806], [847.15,648.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.746,659.636], [857.391,689.753], [847.15,648.757], [847.82,678.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.389,316.092], [850.159,352.057], [865.32,315.869], [866.005,351.696]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.159,352.057], [850.921,387.627], [866.004,351.697], [866.682,387.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.922,387.65], [851.675,422.854], [866.682,387.154], [867.352,422.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.676,422.876], [867.353,422.249], [852.422,457.72], [868.016,456.963]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.422,457.742], [868.016,456.985], [853.161,492.23], [868.673,491.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.161,492.252], [868.674,491.368], [853.893,526.39], [869.324,525.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[853.893,526.412], [869.324,525.404], [854.617,560.206], [869.967,559.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[854.617,560.227], [869.968,559.098], [855.334,593.682], [870.605,592.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.334,593.703], [870.605,592.455], [856.043,626.824], [871.236,625.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.044,626.845], [871.236,625.48], [856.746,659.636], [871.861,658.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.746,659.636], [871.861,658.157], [857.391,689.753], [872.434,688.17]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.827,318.95], [885.442,356.679], [865.32,315.869], [866.005,351.696]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.442,356.68], [886.05,393.976], [866.005,351.697], [866.682,387.132]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.05,393.999], [886.651,430.892], [866.682,387.154], [867.352,422.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.652,430.915], [887.246,467.412], [867.353,422.249], [868.016,456.963]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.247,467.435], [887.835,503.542], [868.017,456.985], [868.673,491.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.835,503.565], [888.418,539.288], [868.674,491.368], [869.324,525.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.418,539.311], [888.994,574.656], [869.324,525.404], [869.968,559.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.994,574.678], [889.564,609.652], [869.968,559.098], [870.605,592.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.565,609.674], [890.128,644.281], [870.605,592.455], [871.236,625.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.129,644.303], [890.687,678.551], [871.236,625.48], [871.861,658.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.687,678.551], [891.199,709.991], [871.861,658.157], [872.435,688.17]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.827,318.95], [885.442,356.679], [907.464,318.615], [907.952,356.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.442,356.68], [886.05,393.976], [907.952,356.137], [908.435,393.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.05,393.999], [886.651,430.892], [908.435,393.254], [908.913,429.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.652,430.915], [887.246,467.412], [908.913,429.973], [909.386,466.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.247,467.435], [887.835,503.542], [909.386,466.299], [909.854,502.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.835,503.565], [909.854,502.239], [888.418,539.288], [910.317,537.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.418,539.311], [910.317,537.799], [888.994,574.656], [910.775,572.963]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.994,574.678], [910.775,572.985], [889.564,609.652], [911.228,607.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.565,609.674], [911.229,607.803], [890.128,644.281], [911.677,642.237]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.129,644.303], [911.677,642.258], [890.687,678.551], [912.121,676.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.687,678.551], [912.121,676.336], [891.199,709.991], [912.528,707.621]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.748,319.695], [915.205,357.883], [907.464,318.615], [907.952,356.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.205,357.884], [915.657,395.628], [907.952,356.137], [908.435,393.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.657,395.652], [916.104,432.984], [908.435,393.254], [908.913,429.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.104,433.008], [916.546,469.934], [908.913,429.973], [909.386,466.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.546,469.958], [916.984,506.485], [909.386,466.299], [909.854,502.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.984,506.508], [917.416,542.642], [909.854,502.239], [910.317,537.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.417,542.665], [917.844,578.412], [910.317,537.799], [910.775,572.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.845,578.435], [918.268,613.802], [910.775,572.985], [911.228,607.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.268,613.824], [918.687,648.817], [911.229,607.803], [911.677,642.237]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.687,648.839], [919.101,683.464], [911.677,642.258], [912.121,676.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.101,683.464], [919.482,715.246], [912.121,676.336], [912.528,707.621]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.748,319.695], [915.205,357.883], [931.24,319.446], [931.604,357.48]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.205,357.884], [915.657,395.628], [931.604,357.481], [931.964,395.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.657,395.652], [916.104,432.984], [931.965,395.099], [932.321,432.284]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.104,433.008], [932.321,432.308], [916.546,469.934], [932.673,469.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.546,469.958], [932.674,469.114], [916.984,506.485], [933.022,505.5]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.984,506.508], [933.022,505.523], [917.416,542.642], [933.367,541.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.417,542.665], [933.367,541.542], [917.844,578.412], [933.709,577.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[917.845,578.435], [933.709,577.178], [918.268,613.802], [934.046,612.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.268,613.824], [934.047,612.436], [918.687,648.817], [934.381,647.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[918.687,648.839], [934.381,647.322], [919.102,683.464], [934.711,681.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[919.102,683.464], [934.711,681.82], [919.482,715.246], [935.015,713.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.629,328.92], [945.958,372.784], [920.101,324.866], [920.564,366.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.958,372.784], [946.283,416.066], [920.564,366.24], [921.022,407.094]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.284,416.094], [946.604,458.833], [921.022,407.12], [921.474,447.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.605,458.86], [946.922,501.066], [921.475,447.516], [921.921,487.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.922,501.093], [947.235,542.776], [921.922,487.437], [922.363,526.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.235,542.802], [947.544,583.971], [922.364,526.891], [922.8,565.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.544,583.997], [947.849,624.662], [922.8,565.885], [923.232,604.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.85,624.688], [948.151,664.858], [923.232,604.429], [923.659,642.505]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[948.151,664.884], [948.449,704.568], [923.659,642.529], [924.08,680.17]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[948.45,704.593], [948.744,743.8], [924.081,680.193], [924.497,717.406]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[948.744,743.8], [949.014,779.737], [924.497,717.406], [924.88,751.536]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[943.747,331.849], [944.102,377.509], [927.978,329.229], [928.421,373.283]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.102,377.509], [944.453,422.541], [928.421,373.283], [928.859,416.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.453,422.57], [944.799,467.013], [928.859,416.778], [929.291,459.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[944.799,467.041], [945.141,510.907], [929.291,459.725], [929.718,502.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.141,510.935], [945.478,554.236], [929.718,502.134], [930.14,543.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.478,554.263], [945.811,597.009], [930.14,544.014], [930.556,585.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.811,597.036], [946.14,639.237], [930.556,585.377], [930.967,626.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.14,639.264], [946.464,680.932], [930.968,626.231], [931.374,666.559]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.465,680.958], [946.785,722.102], [931.374,666.585], [931.775,706.424]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.785,722.128], [947.101,762.757], [931.775,706.449], [932.171,745.807]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.101,762.757], [947.391,799.981], [932.171,745.807], [932.534,781.881]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[975.175,286.565], [975.329,334.439], [958.221,285.563], [958.482,331.735]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.329,334.438], [975.48,381.686], [958.482,331.734], [958.739,377.326]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.48,381.686], [975.63,428.261], [958.739,377.326], [958.993,422.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.63,428.29], [975.777,474.235], [958.993,422.318], [959.244,466.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.777,474.264], [975.922,519.593], [959.244,466.723], [959.491,510.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.922,519.621], [976.066,564.345], [959.492,510.553], [959.736,553.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.066,564.373], [976.208,608.504], [959.736,553.818], [959.977,596.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.208,608.532], [976.347,652.082], [959.977,596.53], [960.215,638.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.348,652.11], [976.485,695.09], [960.215,638.698], [960.45,680.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.485,695.118], [976.622,737.54], [960.45,680.334], [960.682,721.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.622,737.567], [976.756,779.441], [960.683,721.447], [960.912,762.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.756,779.441], [976.879,817.79], [960.912,762.022], [961.122,799.196]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[975.176,286.565], [975.329,334.439], [997.068,286.412], [997.071,334.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.329,334.438], [975.48,381.686], [997.071,334.024], [997.073,381.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.48,381.686], [975.63,428.261], [997.073,381.018], [997.076,427.346]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.63,428.29], [975.777,474.235], [997.076,427.375], [997.078,473.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.777,474.264], [997.078,473.11], [975.923,519.593], [997.081,518.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[975.923,519.621], [997.081,518.233], [976.066,564.345], [997.083,562.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.066,564.373], [997.083,562.758], [976.208,608.504], [997.085,606.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.208,608.532], [997.085,606.696], [976.348,652.082], [997.088,650.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.348,652.11], [997.088,650.058], [976.486,695.09], [997.09,692.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.486,695.118], [997.09,692.856], [976.622,737.54], [997.092,735.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.622,737.566], [997.092,735.101], [976.756,779.441], [997.094,776.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[976.756,779.441], [997.094,776.778], [976.879,817.791], [997.096,814.948]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1031.48,288.345], [1031.23,339.236], [997.068,286.412], [997.071,334.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.23,339.236], [1030.98,389.418], [997.071,334.024], [997.073,381.018]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.99,389.418], [1030.74,438.843], [997.073,381.018], [997.076,427.346]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.74,438.874], [1030.5,487.59], [997.076,427.376], [997.078,473.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.5,487.62], [1030.27,535.642], [997.078,473.11], [997.081,518.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.27,535.672], [1030.04,583.013], [997.081,518.233], [997.083,562.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.04,583.043], [1029.81,629.719], [997.083,562.758], [997.085,606.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.81,629.748], [1029.58,675.773], [997.085,606.696], [997.088,650.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.58,675.802], [1029.36,721.189], [997.088,650.058], [997.09,692.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.36,721.217], [1029.14,765.979], [997.09,692.856], [997.092,735.075]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.14,766.008], [1028.92,810.158], [997.092,735.102], [997.095,776.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.92,810.158], [1028.72,850.562], [997.095,776.778], [997.097,814.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.58,675.802], [1029.36,721.189], [1072.73,671.215], [1072.21,716.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.36,721.217], [1029.14,765.98], [1072.21,716.166], [1071.7,760.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.14,766.008], [1071.7,760.505], [1028.92,810.158], [1071.2,804.217]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1028.92,810.158], [1071.2,804.217], [1028.72,850.562], [1070.74,844.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.74,438.874], [1030.5,487.59], [1075.42,436.822], [1074.87,485.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.5,487.62], [1030.27,535.642], [1074.87,485.031], [1074.32,532.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.27,535.672], [1030.04,583.013], [1074.32,532.561], [1073.78,579.397]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.04,583.043], [1029.81,629.719], [1073.78,579.426], [1073.25,625.611]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1029.81,629.748], [1029.58,675.773], [1073.25,625.639], [1072.73,671.186]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1031.48,288.345], [1031.23,339.236], [1077.13,288], [1076.55,338.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1031.23,339.236], [1030.98,389.418], [1076.55,338.305], [1075.98,387.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1030.98,389.418], [1030.74,438.843], [1075.98,387.918], [1075.42,436.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.32,771.637], [1083.72,816.235], [1071.7,760.504], [1071.2,804.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.72,816.235], [1083.17,857.043], [1071.2,804.216], [1070.74,844.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.54,680.496], [1084.93,726.357], [1072.73,671.215], [1072.21,716.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.93,726.386], [1084.32,771.609], [1072.21,716.166], [1071.7,760.477]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.81,586.745], [1086.17,633.924], [1073.78,579.426], [1073.25,625.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.17,633.954], [1085.55,680.467], [1073.25,625.639], [1072.73,671.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.1,490.272], [1087.45,538.826], [1074.87,485.031], [1074.32,532.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.45,538.856], [1086.81,586.715], [1074.32,532.561], [1073.78,579.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.44,390.955], [1088.77,440.945], [1075.98,387.918], [1075.42,436.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.77,440.976], [1088.1,490.241], [1075.42,436.821], [1074.87,485.001]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.12,340.19], [1089.44,390.955], [1076.55,338.305], [1075.98,387.918]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1090.82,288.699], [1090.12,340.19], [1077.13,287.999], [1076.55,338.305]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1083.72,816.235], [1083.17,857.043], [1138.77,808.304], [1137.88,848.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.93,726.386], [1084.32,771.609], [1140.72,719.641], [1139.74,764.262]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1084.32,771.637], [1083.72,816.235], [1139.74,764.291], [1138.77,808.304]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.54,680.496], [1084.93,726.357], [1141.71,674.37], [1140.72,719.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.81,586.745], [1086.17,633.924], [1143.75,581.914], [1142.73,628.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.17,633.954], [1085.55,680.467], [1142.72,628.466], [1141.71,674.342]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.1,490.272], [1087.45,538.826], [1145.84,486.812], [1144.79,534.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.45,538.856], [1086.81,586.715], [1144.79,534.701], [1143.75,581.884]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.77,440.976], [1088.1,490.241], [1146.91,438.233], [1145.84,486.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.12,340.19], [1089.44,390.955], [1149.1,338.945], [1148,388.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.44,390.955], [1088.77,440.945], [1148,388.95], [1146.91,438.203]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1090.82,288.699], [1090.12,340.19], [1150.21,288.237], [1149.1,338.945]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1133.12,803.177], [1132.28,843.115], [1184.17,795.901], [1183.02,835.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.05,759.541], [1133.12,803.176], [1185.42,752.805], [1184.17,795.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1134.98,715.282], [1134.05,759.514], [1186.69,709.099], [1185.42,752.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1135.93,670.412], [1134.98,715.253], [1187.97,664.799], [1186.69,709.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.89,624.92], [1135.93,670.384], [1189.28,619.893], [1187.97,664.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.86,578.793], [1136.89,624.891], [1190.6,574.369], [1189.28,619.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.85,532.017], [1137.86,578.764], [1191.94,528.213], [1190.6,574.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.85,484.578], [1138.85,531.987], [1193.3,481.412], [1191.94,528.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.87,436.463], [1139.85,484.548], [1194.67,433.953], [1193.3,481.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1141.9,387.656], [1140.87,436.432], [1196.07,385.822], [1194.67,433.923]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1142.94,338.142], [1141.9,387.656], [1197.49,337.005], [1196.07,385.822]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1144,288.229], [1142.94,338.142], [1198.92,287.803], [1197.49,337.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.98,785.263], [1169.94,824.004], [1211.46,779.628], [1210.19,817.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.12,742.955], [1170.98,785.263], [1212.85,737.739], [1211.46,779.628]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.28,700.061], [1172.12,742.928], [1214.26,695.276], [1212.85,737.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.45,656.596], [1173.28,700.034], [1215.69,652.253], [1214.26,695.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.63,612.548], [1174.45,656.568], [1217.13,608.661], [1215.69,652.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.84,567.906], [1175.63,612.52], [1218.6,564.486], [1217.14,608.633]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1178.05,522.657], [1176.84,567.878], [1220.09,519.718], [1218.6,564.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1179.29,476.79], [1178.05,522.629], [1221.59,474.345], [1220.09,519.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1180.54,430.291], [1179.29,476.761], [1223.12,428.354], [1221.59,474.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1181.81,383.147], [1180.54,430.261], [1224.66,381.732], [1223.12,428.325]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.1,335.345], [1181.81,383.147], [1226.23,334.467], [1224.66,381.732]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1184.4,286.901], [1183.1,335.344], [1227.82,286.575], [1226.23,334.467]]
            },],[{
            tipo:"Valle",
            name:"Torre3",
            verts:[[859.823,314.718], [860.543,350.215], [853.286,312.939], [854.018,347.427]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[860.543,350.216], [861.255,385.321], [854.018,347.427], [854.743,381.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.255,385.344], [861.96,420.086], [854.743,381.566], [855.461,415.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.961,420.108], [862.658,454.492], [855.461,415.361], [856.172,448.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.658,454.514], [863.349,488.546], [856.172,448.818], [856.875,481.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.349,488.567], [864.032,522.252], [856.876,481.942], [857.572,514.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.033,522.273], [864.709,555.616], [857.573,514.737], [858.262,547.188]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[864.776,278.064], [865.452,312.807], [858.542,277.391], [859.23,311.206]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.71,555.637], [865.379,588.644], [858.262,547.209], [858.945,579.342]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.38,588.665], [866.042,621.339], [858.945,579.362], [859.621,611.181]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.043,621.36], [866.699,653.708], [859.622,611.201], [860.291,642.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[859.823,314.718], [860.543,350.215], [875.794,314.539], [876.429,349.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[860.543,350.216], [876.429,349.936], [861.255,385.321], [877.056,384.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.699,653.708], [867.302,683.417], [860.291,642.711], [860.906,671.657]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.255,385.344], [877.057,384.965], [861.96,420.086], [877.678,419.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.961,420.108], [877.678,419.632], [862.658,454.492], [878.293,453.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.658,454.514], [878.293,453.943], [863.349,488.546], [878.902,487.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.349,488.567], [878.902,487.903], [864.032,522.252], [879.505,521.497]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.033,522.273], [879.505,521.518], [864.709,555.616], [880.101,554.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.71,555.637], [880.102,554.792], [865.379,588.644], [880.692,587.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.38,588.665], [880.692,587.732], [866.043,621.339], [881.277,620.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.043,621.36], [881.277,620.342], [866.699,653.708], [881.856,652.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.699,653.709], [881.856,652.607], [867.302,683.417], [882.387,682.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.038,317.897], [889.634,355.196], [875.794,314.539], [876.429,349.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.634,355.197], [890.224,392.065], [876.429,349.936], [877.056,384.942]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.224,392.089], [890.807,428.556], [877.057,384.965], [877.678,419.61]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.807,428.579], [891.384,464.651], [877.678,419.632], [878.293,453.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.385,464.674], [891.955,500.359], [878.294,453.943], [878.902,487.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.955,500.381], [892.52,535.684], [878.903,487.903], [879.505,521.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.52,535.706], [893.078,570.632], [879.505,521.518], [880.101,554.771]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.079,570.654], [893.631,605.211], [880.102,554.792], [880.692,587.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.631,605.233], [894.178,639.425], [880.693,587.732], [881.277,620.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.178,639.446], [894.719,673.28], [881.277,620.342], [881.856,652.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.719,673.28], [895.216,704.338], [881.856,652.606], [882.387,682.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.038,317.897], [889.634,355.196], [911.857,317.627], [912.326,354.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.634,355.197], [890.224,392.065], [912.326,354.774], [912.789,391.493]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.224,392.089], [890.807,428.556], [912.79,391.517], [913.248,427.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[890.807,428.579], [913.248,427.861], [891.384,464.651], [913.702,463.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.385,464.674], [913.702,463.813], [891.955,500.359], [914.151,499.358]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[891.955,500.381], [914.151,499.38], [892.52,535.684], [914.595,534.546]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[892.52,535.706], [914.595,534.568], [893.078,570.632], [915.034,569.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.079,570.654], [915.034,569.383], [893.631,605.211], [915.469,603.808]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.631,605.233], [915.469,603.83], [894.178,639.425], [915.899,637.894]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.178,639.446], [915.899,637.916], [894.719,673.28], [916.325,671.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.719,673.28], [916.325,671.624], [895.216,704.338], [916.715,702.568]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.955,318.808], [917.404,356.625], [911.857,317.627], [912.326,354.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.744,328.781], [930.179,372.233], [912.38,324.347], [912.894,365.296]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.321,331.894], [922.823,377.099], [911.821,329.031], [912.372,372.623]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[922.823,377.099], [923.318,421.676], [912.372,372.623], [912.916,415.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.318,421.705], [923.807,465.694], [912.917,415.657], [913.454,458.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[923.807,465.722], [924.289,509.135], [913.454,458.144], [913.984,500.068]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.289,509.162], [924.765,552.01], [913.984,500.095], [914.508,541.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.765,552.038], [925.235,594.332], [914.508,541.518], [915.025,582.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.235,594.359], [925.698,636.11], [915.026,582.425], [915.536,622.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.699,636.136], [926.156,677.354], [915.537,622.825], [916.041,662.701]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.157,677.38], [926.608,718.075], [916.041,662.727], [916.539,702.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.609,718.101], [927.055,758.284], [916.54,702.14], [917.032,741.048]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[916.955,318.808], [917.404,356.625], [933.639,318.607], [933.994,356.31]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.055,758.284], [927.463,795.094], [917.032,741.049], [917.483,776.707]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[948.11,287.336], [948.454,334.808], [936.615,286.085], [937.023,331.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.455,334.807], [948.794,381.651], [937.023,331.842], [937.427,377.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.794,381.651], [949.128,427.822], [937.427,377.019], [937.824,421.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.128,427.851], [949.458,473.391], [937.825,421.596], [938.217,465.558]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.458,473.419], [949.784,518.341], [938.217,465.586], [938.605,508.972]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.784,518.369], [950.105,562.686], [938.605,509], [938.987,551.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.105,562.714], [950.421,606.437], [938.987,551.849], [939.365,594.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.422,606.464], [950.734,649.606], [939.365,594.145], [939.738,635.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.734,649.633], [951.043,692.205], [939.738,635.897], [940.106,677.091]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.043,692.232], [951.347,734.245], [940.106,677.117], [940.469,717.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.347,734.271], [951.648,775.736], [940.469,717.815], [940.828,757.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.648,775.736], [951.923,813.706], [940.828,757.975], [941.156,794.765]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[948.111,287.336], [948.455,334.808], [970.51,287.195], [970.697,334.473]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.455,334.807], [948.794,381.651], [970.697,334.472], [970.881,381.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.794,381.651], [949.128,427.822], [970.881,381.128], [971.063,427.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.128,427.851], [971.063,427.145], [949.458,473.391], [971.242,472.506]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.458,473.419], [971.242,472.535], [949.784,518.341], [971.419,517.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[949.784,518.369], [971.419,517.312], [950.105,562.686], [971.594,561.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.105,562.714], [971.594,561.487], [950.422,606.437], [971.766,605.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.422,606.464], [971.766,605.074], [950.734,649.606], [971.936,648.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[950.734,649.633], [971.936,648.083], [951.043,692.205], [972.104,690.5]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.043,692.232], [972.104,690.527], [951.347,734.245], [972.27,732.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.347,734.271], [972.27,732.415], [951.648,775.736], [972.433,773.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[951.648,775.736], [972.433,773.734], [951.923,813.706], [972.583,811.571]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[994.474,289.62], [994.497,340.215], [970.51,287.194], [970.697,334.472]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.496,340.214], [994.518,390.094], [970.697,334.472], [970.881,381.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.518,390.094], [994.54,439.212], [970.881,381.128], [971.063,427.116]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.54,439.243], [994.561,487.646], [971.063,427.144], [971.242,472.506]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.561,487.677], [994.581,535.381], [971.242,472.535], [971.419,517.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.582,535.411], [994.602,582.431], [971.419,517.312], [971.594,561.46]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.602,582.461], [994.622,628.812], [971.594,561.487], [971.766,605.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.622,628.841], [994.642,674.537], [971.766,605.074], [971.936,648.056]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.642,674.566], [994.662,719.621], [971.937,648.083], [972.104,690.5]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.662,719.649], [994.681,764.076], [972.104,690.527], [972.27,732.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.681,764.104], [994.7,807.915], [972.27,732.415], [972.433,773.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.7,807.915], [994.718,848.003], [972.433,773.734], [972.583,811.571]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[994.474,289.62], [994.496,340.215], [1041.64,289.3], [1041.32,339.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.496,340.214], [994.518,390.094], [1041.32,339.456], [1040.99,388.911]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.518,390.094], [994.539,439.212], [1041,388.911], [1040.68,437.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.539,439.243], [994.56,487.646], [1040.68,437.647], [1040.37,485.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.56,487.676], [994.581,535.381], [1040.37,485.68], [1040.06,532.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.581,535.411], [994.602,582.431], [1040.06,533.025], [1039.76,579.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.602,582.461], [994.622,628.812], [1039.76,579.697], [1039.46,625.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.622,628.841], [1039.46,625.711], [994.642,674.537], [1039.16,671.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.642,674.566], [1039.16,671.079], [994.662,719.621], [1038.87,715.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.662,719.649], [1038.87,715.816], [994.681,764.076], [1038.59,759.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.681,764.104], [1038.59,759.934], [994.7,807.915], [1038.3,803.42]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[994.7,807.915], [1038.3,803.42], [994.718,848.003], [1038.05,843.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.78,771.43], [1047.43,815.814], [1038.59,759.934], [1038.3,803.42]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.43,815.814], [1047.1,856.417], [1038.3,803.42], [1038.05,843.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.24,587.32], [1048.87,634.315], [1039.76,579.697], [1039.46,625.682]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.87,634.345], [1048.5,680.666], [1039.46,625.71], [1039.16,671.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.5,680.695], [1048.14,726.357], [1039.16,671.079], [1038.87,715.788]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.14,726.385], [1047.78,771.401], [1038.87,715.816], [1038.59,759.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.4,442.051], [1050.01,491.158], [1040.68,437.646], [1040.37,485.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.01,491.189], [1049.62,539.576], [1040.37,485.679], [1040.06,532.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.62,539.607], [1049.24,587.29], [1040.06,533.025], [1039.76,579.668]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1051.61,290.184], [1051.2,341.549], [1041.64,289.299], [1041.32,339.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1051.2,341.549], [1050.8,392.176], [1041.32,339.456], [1040.99,388.911]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.8,392.176], [1050.4,442.019], [1040.99,388.911], [1040.68,437.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.78,771.43], [1105.42,765.823], [1047.43,815.814], [1104.67,809.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.43,815.814], [1104.67,809.769], [1047.1,856.417], [1103.98,849.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.5,680.695], [1048.14,726.357], [1106.95,676.004], [1106.18,721.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.14,726.385], [1047.78,771.401], [1106.18,721.23], [1105.42,765.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.62,539.607], [1049.24,587.291], [1109.33,536.395], [1108.52,583.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.24,587.32], [1048.87,634.315], [1108.52,583.601], [1107.73,630.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.87,634.345], [1048.5,680.666], [1107.73,630.133], [1106.95,675.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.8,392.176], [1050.4,442.02], [1111.81,390.582], [1110.97,439.871]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.4,442.051], [1050.01,491.158], [1110.97,439.901], [1110.14,488.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1050.01,491.189], [1049.62,539.577], [1110.14,488.5], [1109.33,536.365]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1051.61,290.184], [1051.2,341.549], [1113.53,289.752], [1112.67,340.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1051.2,341.549], [1050.8,392.176], [1112.67,340.527], [1111.81,390.582]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.44,804.453], [1099.79,844.313], [1153.84,798.873], [1152.86,838.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.16,760.892], [1100.44,804.452], [1154.91,755.718], [1153.84,798.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1102.61,671.88], [1101.88,716.668], [1157.1,667.553], [1156,711.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.88,716.696], [1101.16,760.864], [1155.99,711.94], [1154.91,755.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1103.36,626.43], [1102.61,671.851], [1158.21,622.546], [1157.1,667.525]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1104.11,580.332], [1103.36,626.401], [1159.35,576.904], [1158.21,622.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1105.65,486.138], [1104.88,533.543], [1161.66,483.662], [1160.5,530.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1104.88,533.573], [1104.11,580.303], [1160.5,530.614], [1159.35,576.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1106.44,438.013], [1105.65,486.108], [1162.84,436.034], [1161.66,483.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1107.24,389.182], [1106.44,437.982], [1164.04,387.715], [1162.84,436.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1108.05,339.63], [1107.24,389.182], [1165.26,338.69], [1164.04,387.715]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1108.87,289.663], [1108.05,339.63], [1166.49,289.263], [1165.26,338.69]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1143.54,787.768], [1186.04,783.425], [1142.64,826.532], [1184.89,821.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1144.52,745.422], [1187.29,741.397], [1143.54,787.768], [1186.04,783.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1145.51,702.477], [1144.52,745.395], [1188.57,698.778], [1187.3,741.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1146.52,658.948], [1145.51,702.45], [1189.86,655.585], [1188.57,698.751]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1147.54,614.822], [1146.52,658.92], [1191.16,611.804], [1189.86,655.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1148.58,570.087], [1147.54,614.794], [1192.49,567.424], [1191.17,611.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1149.63,524.731], [1148.58,570.059], [1193.83,522.433], [1192.49,567.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1150.69,478.74], [1149.63,524.702], [1195.2,476.818], [1193.83,522.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1151.77,432.101], [1150.69,478.711], [1196.58,430.566], [1195.2,476.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1152.87,384.8], [1151.77,432.071], [1197.98,383.663], [1196.58,430.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.98,336.824], [1152.87,384.8], [1199.4,336.095], [1197.98,383.663]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1155.1,288.187], [1153.98,336.823], [1200.84,287.879], [1199.4,336.095]]
            },],[{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.702,313.334], [871.368,348.461], [867.438,311.452], [868.102,345.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.368,348.461], [872.027,383.199], [868.102,345.573], [868.758,379.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.027,383.221], [872.679,417.598], [868.758,379.348], [869.408,412.761]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.679,417.62], [873.324,451.641], [869.408,412.782], [870.052,445.859]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.325,451.662], [873.963,485.333], [870.052,445.88], [870.689,478.625]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.702,313.334], [886.656,313.21], [871.368,348.461], [887.237,348.271]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[871.368,348.461], [887.237,348.271], [872.027,383.199], [887.812,382.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.964,485.354], [874.596,518.68], [870.689,478.646], [871.32,511.066]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.596,518.701], [875.222,551.687], [871.32,511.086], [871.944,543.185]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.027,383.221], [887.812,382.966], [872.679,417.598], [888.381,417.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.222,551.708], [875.841,584.36], [871.945,543.205], [872.563,574.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.841,584.38], [876.454,616.703], [872.563,575.008], [873.175,606.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[872.679,417.62], [888.381,417.301], [873.324,451.641], [888.944,451.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.325,451.662], [888.944,451.281], [873.963,485.333], [889.501,484.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.455,616.723], [877.062,648.721], [873.175,606.498], [873.781,637.662]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[873.964,485.354], [889.502,484.912], [874.596,518.68], [890.053,518.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[874.596,518.701], [890.053,518.199], [875.222,551.687], [890.599,551.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.062,648.721], [877.619,678.107], [873.781,637.662], [874.338,666.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.222,551.708], [890.6,551.148], [875.841,584.36], [891.14,583.743]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[878.97,276.959], [879.576,311.36], [875.698,276.188], [876.304,309.664]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[875.842,584.38], [891.14,583.763], [876.454,616.703], [891.675,616.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[876.455,616.723], [891.675,616.05], [877.062,648.721], [892.205,647.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[877.062,648.721], [892.205,647.993], [877.619,678.107], [892.691,677.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.722,316.771], [894.296,353.733], [886.656,313.21], [887.237,348.271]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.296,353.733], [894.863,390.265], [887.237,348.271], [887.812,382.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.863,390.288], [895.424,426.42], [887.812,382.966], [888.381,417.279]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.425,426.443], [895.979,462.181], [888.381,417.301], [888.944,451.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.98,462.204], [896.529,497.556], [888.944,451.281], [889.501,484.891]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.529,497.578], [897.072,532.549], [889.502,484.912], [890.053,518.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.072,532.572], [897.609,567.168], [890.054,518.199], [890.599,551.127]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.61,567.19], [898.141,601.418], [890.6,551.148], [891.14,583.743]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.142,601.44], [898.667,635.305], [891.14,583.763], [891.675,616.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.668,635.326], [899.188,668.835], [891.675,616.05], [892.205,647.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.188,668.835], [899.665,699.592], [892.205,647.993], [892.691,677.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[893.722,316.771], [894.296,353.733], [916.617,316.583], [917.063,353.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.296,353.733], [917.063,353.445], [894.863,390.265], [917.504,389.879]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[894.863,390.288], [917.504,389.902], [895.424,426.42], [917.94,425.938]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.425,426.443], [917.94,425.961], [895.979,462.181], [918.371,461.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[901.678,331.545], [902.322,376.357], [896.426,328.503], [897.081,371.704]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[895.98,462.204], [918.372,461.628], [896.529,497.556], [918.798,496.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[896.529,497.578], [918.798,496.911], [897.072,532.549], [919.22,531.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.322,376.358], [902.957,420.544], [897.081,371.704], [897.726,414.322]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.072,532.572], [919.221,531.814], [897.609,567.168], [919.638,566.323]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[897.61,567.19], [919.638,566.345], [898.141,601.418], [920.051,600.487]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[902.957,420.572], [903.584,464.172], [897.727,414.349], [898.364,456.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.584,464.199], [904.202,507.224], [898.364,456.448], [898.994,497.986]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.142,601.44], [920.052,600.509], [898.667,635.305], [920.461,634.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.203,507.252], [904.813,549.714], [898.994,498.012], [899.615,539.025]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.813,549.74], [905.415,591.65], [899.616,539.051], [900.229,579.549]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[898.668,635.326], [920.461,634.311], [899.188,668.835], [920.865,667.737]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[899.188,668.835], [920.865,667.737], [899.665,699.592], [921.236,698.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.416,591.676], [906.01,633.044], [900.23,579.575], [900.835,619.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.01,633.07], [906.597,673.907], [900.836,619.594], [901.434,659.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.597,673.933], [907.177,714.248], [901.434,659.117], [902.025,698.128]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.177,714.274], [907.749,754.078], [902.026,698.152], [902.609,736.686]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.749,754.078], [908.273,790.54], [902.609,736.686], [903.144,771.998]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.477,328.33], [915.013,371.438], [905.248,323.613], [905.809,364.218]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[921.691,287.6], [922.223,334.722], [915.667,286.16], [916.221,331.565]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.223,334.722], [922.748,381.215], [916.221,331.565], [916.767,376.388]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.748,381.216], [923.265,427.036], [916.767,376.388], [917.305,420.585]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.266,427.065], [923.776,472.255], [917.306,420.613], [917.837,464.223]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.776,472.283], [924.279,516.855], [917.837,464.25], [918.362,507.285]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.28,516.883], [924.776,560.85], [918.362,507.313], [918.88,549.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.776,560.878], [925.266,604.251], [918.88,549.811], [919.391,591.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.266,604.279], [925.749,647.072], [919.391,591.756], [919.895,633.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.75,647.099], [926.227,689.322], [919.896,633.159], [920.393,674.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.227,689.349], [926.697,731.014], [920.393,674.031], [920.885,714.355]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.697,731.04], [927.162,772.158], [920.885,714.38], [921.37,754.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.162,772.158], [927.587,809.806], [921.37,754.193], [921.815,790.662]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[921.691,287.6], [922.223,334.722], [944.375,287.493], [944.746,334.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.223,334.722], [944.747,334.487], [922.748,381.215], [945.113,380.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.748,381.215], [945.113,380.857], [923.265,427.036], [945.475,426.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.266,427.065], [945.475,426.586], [923.776,472.255], [945.831,471.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.776,472.283], [945.832,471.687], [924.28,516.855], [946.183,516.145]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.28,516.883], [946.183,516.173], [924.776,560.85], [946.53,560.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.776,560.878], [946.53,560.057], [925.266,604.251], [946.873,603.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.267,604.279], [946.873,603.35], [925.75,647.072], [947.211,646.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.75,647.099], [947.211,646.065], [926.227,689.322], [947.544,688.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.227,689.349], [947.544,688.213], [926.697,731.014], [947.873,729.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.698,731.04], [947.873,729.805], [927.162,772.158], [948.197,770.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.162,772.158], [948.198,770.827], [927.587,809.806], [948.494,808.388]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[957.762,290.296], [958.059,340.626], [944.375,287.493], [944.747,334.487]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.059,340.626], [958.353,390.237], [944.747,334.487], [945.113,380.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.353,390.238], [958.642,439.084], [945.113,380.857], [945.475,426.557]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.642,439.115], [958.927,487.244], [945.475,426.586], [945.831,471.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.927,487.275], [959.208,534.702], [945.832,471.687], [946.183,516.145]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.208,534.732], [959.484,581.473], [946.183,516.173], [946.53,560.029]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.484,581.503], [959.757,627.572], [946.531,560.057], [946.873,603.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.757,627.601], [960.026,673.013], [946.873,603.35], [947.211,646.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.026,673.042], [960.291,717.81], [947.211,646.065], [947.544,688.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.291,717.838], [960.552,761.977], [947.544,688.213], [947.873,729.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.552,762.005], [960.81,805.527], [947.873,729.806], [948.198,770.827]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.81,805.527], [961.045,845.345], [948.198,770.827], [948.495,808.388]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[957.761,290.296], [958.059,340.626], [1005.91,290.052], [1005.85,340.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.059,340.626], [958.353,390.237], [1005.85,340.092], [1005.79,389.422]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.353,390.237], [958.642,439.084], [1005.79,389.422], [1005.73,437.996]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.642,439.115], [1005.73,438.027], [958.927,487.244], [1005.67,485.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.927,487.275], [1005.67,485.921], [959.207,534.702], [1005.61,533.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.208,534.732], [1005.61,533.121], [959.484,581.473], [1005.55,579.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.484,581.503], [1005.55,579.642], [959.757,627.572], [1005.49,625.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.757,627.601], [1005.49,625.498], [960.026,673.013], [1005.43,670.675]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.026,673.042], [1005.43,670.703], [960.291,717.81], [1005.38,715.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.291,717.838], [1005.38,715.271], [960.552,761.977], [1005.32,759.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.552,762.005], [1005.32,759.216], [960.81,805.527], [1005.27,802.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.81,805.528], [1005.27,802.523], [961.045,845.345], [1005.22,842.147]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.41,587.49], [1011.3,634.338], [1005.55,579.642], [1005.49,625.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.3,634.367], [1011.2,680.535], [1005.49,625.498], [1005.43,670.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.2,680.564], [1011.1,726.066], [1005.43,670.703], [1005.38,715.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.1,726.095], [1011.01,770.946], [1005.38,715.271], [1005.32,759.188]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.01,770.974], [1010.91,815.188], [1005.32,759.216], [1005.27,802.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1010.91,815.188], [1010.82,855.628], [1005.27,802.523], [1005.22,842.146]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1012.05,291.081], [1011.94,342.345], [1005.91,290.052], [1005.85,340.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.94,342.345], [1011.83,392.863], [1005.85,340.092], [1005.79,389.422]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.83,392.863], [1011.72,442.588], [1005.79,389.422], [1005.73,437.996]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.72,442.619], [1011.61,491.601], [1005.73,438.026], [1005.67,485.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.61,491.632], [1011.51,539.886], [1005.67,485.921], [1005.61,533.091]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.51,539.916], [1011.41,587.46], [1005.61,533.121], [1005.55,579.612]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.61,491.632], [1011.51,539.886], [1073.47,489.796], [1072.91,537.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.51,539.916], [1011.41,587.46], [1072.91,537.732], [1072.36,584.938]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.41,587.49], [1072.36,584.968], [1011.3,634.338], [1071.82,631.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.3,634.367], [1071.81,631.517], [1011.2,680.535], [1071.28,677.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.2,680.564], [1071.28,677.396], [1011.1,726.067], [1070.75,722.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.1,726.095], [1070.75,722.618], [1011.01,770.946], [1070.23,767.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.01,770.974], [1070.23,767.197], [1010.91,815.188], [1069.72,811.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1010.91,815.188], [1069.72,811.12], [1010.82,855.628], [1069.25,851.298]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1012.05,291.081], [1011.94,342.345], [1075.8,290.75], [1075.2,341.62]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.94,342.345], [1011.83,392.863], [1075.2,341.62], [1074.62,391.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.83,392.863], [1011.72,442.588], [1074.62,391.756], [1074.04,441.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1011.72,442.619], [1011.61,491.601], [1074.04,441.143], [1073.47,489.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1066.97,805.656], [1122.17,801.877], [1066.52,845.482], [1121.37,841.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.95,717.949], [1123.92,714.719], [1067.46,762.097], [1123.04,758.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1067.46,762.125], [1123.04,758.616], [1066.97,805.656], [1122.17,801.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.97,627.691], [1068.46,673.113], [1125.73,625.045], [1124.82,670.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1068.46,673.142], [1124.82,670.2], [1067.95,717.92], [1123.92,714.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.01,534.801], [1069.48,581.553], [1127.59,532.775], [1126.65,579.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.48,581.582], [1068.97,627.662], [1126.65,579.242], [1125.73,625.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.54,487.333], [1070.01,534.771], [1128.54,485.63], [1127.59,532.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.63,390.272], [1071.08,439.131], [1130.48,389.247], [1129.5,437.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.08,439.162], [1070.54,487.302], [1129.5,437.793], [1128.54,485.6]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1072.75,290.597], [1072.19,340.649], [1132.47,290.288], [1131.47,339.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.19,340.649], [1071.63,390.272], [1131.47,339.977], [1130.48,389.247]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.9,790.385], [1159.05,787.428], [1114.17,829.222], [1158.04,826.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.71,747.95], [1160.14,745.206], [1114.9,790.385], [1159.05,787.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1116.52,704.904], [1161.26,702.379], [1115.71,747.923], [1160.14,745.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1118.18,617.008], [1163.53,614.941], [1117.35,661.233], [1162.39,658.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1117.35,661.261], [1162.39,658.962], [1116.52,704.877], [1161.26,702.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.03,572.132], [1118.18,616.98], [1164.7,570.304], [1163.53,614.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.89,526.621], [1119.03,572.104], [1165.87,525.039], [1164.7,570.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120.77,480.46], [1119.89,526.592], [1167.07,479.132], [1165.87,525.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.65,433.636], [1120.77,480.431], [1168.28,432.568], [1167.07,479.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.55,386.134], [1121.65,433.607], [1169.51,385.335], [1168.28,432.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.47,337.94], [1122.55,386.134], [1170.76,337.417], [1169.51,385.335]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1124.39,289.069], [1123.47,337.94], [1172.02,288.83], [1170.76,337.417]]
            },],[{
            tipo:"Valle",
            name:"Torre3",
            verts:[[881.99,311.976], [897.875,311.913], [882.599,346.835], [898.399,346.74]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[893.486,275.823], [894.02,309.986], [893.13,274.991], [893.651,308.234]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[896.003,287.312], [896.718,334.152], [895.424,285.755], [896.117,330.883]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[896.003,287.312], [918.759,287.255], [896.719,334.152], [919.313,334.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.719,334.152], [897.425,380.365], [896.117,330.882], [896.802,375.429]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.719,334.152], [919.313,334.033], [897.425,380.365], [919.86,380.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.425,380.365], [919.86,380.186], [898.121,425.906], [920.399,425.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.425,380.365], [898.121,425.906], [896.802,375.429], [897.477,419.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.121,425.935], [898.807,470.846], [897.477,419.378], [898.143,462.714]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.121,425.935], [920.4,425.697], [898.807,470.846], [920.931,470.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.808,470.875], [899.485,515.169], [898.144,462.741], [898.801,505.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.808,470.875], [920.932,470.579], [899.485,515.169], [921.456,514.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.485,515.197], [921.456,514.846], [900.153,558.887], [921.974,558.482]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.485,515.197], [900.153,558.887], [898.801,505.53], [899.449,547.729]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.153,558.915], [900.812,602.013], [899.45,547.755], [900.09,589.403]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.153,558.915], [921.974,558.509], [900.812,602.013], [922.484,601.555]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.812,602.04], [901.462,644.558], [900.09,589.429], [900.722,630.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.812,602.04], [922.484,601.582], [901.462,644.558], [922.988,644.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.463,644.585], [922.988,644.076], [902.104,686.535], [923.485,685.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.462,644.585], [902.103,686.535], [900.722,630.562], [901.346,671.139]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.104,686.562], [902.736,727.954], [901.346,671.165], [901.962,711.221]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.104,686.561], [923.485,686.002], [902.737,727.954], [923.975,727.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.737,727.98], [903.361,768.827], [901.962,711.246], [902.569,750.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.361,768.827], [903.933,806.225], [902.569,750.793], [903.126,787.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.737,727.98], [923.976,727.373], [903.361,768.827], [924.459,768.172]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.361,768.827], [924.459,768.173], [903.933,806.225], [924.902,805.528]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[921.538,290.295], [922.111,340.413], [918.759,287.255], [919.313,334.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.111,340.412], [922.676,389.81], [919.313,334.033], [919.86,380.186]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.676,389.81], [923.233,438.441], [919.86,380.186], [920.399,425.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.233,438.471], [923.781,486.384], [920.4,425.697], [920.931,470.551]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[921.538,290.295], [970.145,290.165], [922.111,340.413], [970.35,340.14]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.781,486.414], [924.322,533.623], [920.932,470.579], [921.456,514.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.322,533.652], [924.854,580.174], [921.456,514.846], [921.974,558.482]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.111,340.412], [970.35,340.14], [922.676,389.81], [970.553,389.399]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.854,580.203], [925.379,626.052], [921.974,558.509], [922.484,601.555]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.379,626.08], [925.896,671.271], [922.485,601.582], [922.988,644.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.676,389.81], [970.553,389.399], [923.232,438.441], [970.753,437.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.233,438.471], [970.753,437.926], [923.781,486.384], [970.949,485.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.897,671.299], [926.406,715.846], [922.988,644.076], [923.485,685.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.407,715.873], [926.909,759.789], [923.485,686.002], [923.975,727.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.781,486.414], [970.95,485.739], [924.321,533.623], [971.143,532.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.322,533.652], [971.143,532.851], [924.854,580.174], [971.334,579.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.909,759.817], [927.405,803.115], [923.976,727.373], [924.459,768.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.405,803.115], [927.858,842.725], [924.459,768.173], [924.902,805.528]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.854,580.203], [971.334,579.279], [925.379,626.052], [971.522,625.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.379,626.08], [971.523,625.037], [925.896,671.271], [971.708,670.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[925.896,671.299], [971.708,670.141], [926.406,715.846], [971.891,714.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.406,715.873], [971.891,714.603], [926.909,759.789], [972.071,758.41]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[926.909,759.817], [972.071,758.437], [927.404,803.115], [972.249,801.63]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[927.404,803.115], [972.249,801.63], [927.857,842.725], [972.412,841.144]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[972.392,291.289], [972.586,342.497], [970.145,290.165], [970.35,340.14]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.585,342.497], [972.776,392.952], [970.35,340.14], [970.553,389.399]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.776,392.952], [972.963,442.609], [970.553,389.399], [970.753,437.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.964,442.639], [973.148,491.546], [970.753,437.926], [970.949,485.708]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.148,491.577], [973.33,539.751], [970.949,485.738], [971.143,532.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.33,539.781], [973.51,587.238], [971.143,532.851], [971.334,579.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.51,587.268], [973.686,634.024], [971.334,579.279], [971.522,625.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.686,634.054], [973.86,680.125], [971.522,625.037], [971.708,670.112]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[972.392,291.289], [972.585,342.497], [1037.24,291.111], [1036.94,342.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.861,680.154], [974.032,725.555], [971.708,670.14], [971.891,714.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.032,725.583], [974.201,770.329], [971.891,714.602], [972.071,758.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.201,770.357], [974.368,814.46], [972.071,758.437], [972.249,801.63]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.368,814.46], [974.52,854.795], [972.249,801.63], [972.412,841.144]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.585,342.497], [972.776,392.952], [1036.94,342.124], [1036.63,392.391]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.776,392.952], [1036.63,392.391], [972.963,442.609], [1036.34,441.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[972.963,442.64], [1036.34,441.895], [973.148,491.546], [1036.04,490.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.148,491.577], [1036.04,490.655], [973.33,539.751], [1035.76,538.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.33,539.781], [1035.76,538.686], [973.51,587.238], [1035.47,585.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.51,587.268], [1035.47,586.006], [973.686,634.025], [1035.19,632.601]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.686,634.054], [1035.19,632.63], [973.86,680.125], [1034.92,678.544]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[973.86,680.154], [1034.92,678.573], [974.032,725.555], [1034.65,723.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.032,725.583], [1034.65,723.85], [974.201,770.329], [1034.38,768.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.201,770.357], [1034.38,768.476], [974.367,814.46], [1034.11,812.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[974.367,814.46], [1034.11,812.436], [974.52,854.795], [1033.87,852.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1033.39,719.086], [1090.65,717.465], [1033.13,763.276], [1089.99,761.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1033.13,763.304], [1089.99,761.545], [1032.88,806.869], [1089.34,804.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1032.88,806.87], [1089.34,804.975], [1032.65,846.719], [1088.74,844.704]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1034.45,535.679], [1093.4,534.657], [1034.18,582.51], [1092.7,581.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1034.18,582.54], [1092.7,581.361], [1033.91,628.689], [1092.01,627.358]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1033.91,628.718], [1092.01,627.387], [1033.65,674.2], [1091.33,672.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1033.65,674.229], [1091.32,672.751], [1033.39,719.058], [1090.65,717.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1035.29,390.849], [1035,439.819], [1095.57,390.325], [1094.83,439.123]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1035,439.85], [1034.72,488.091], [1094.83,439.154], [1094.11,487.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1034.72,488.121], [1094.11,487.259], [1034.45,535.649], [1093.4,534.627]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1035.87,290.916], [1035.58,341.102], [1097.06,290.749], [1096.31,340.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1035.58,341.102], [1035.29,390.849], [1096.31,340.754], [1095.57,390.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.22,793.181], [1130.61,791.691], [1084.67,832.153], [1129.77,830.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1085.83,750.59], [1131.53,749.206], [1085.22,793.181], [1130.61,791.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.08,663.552], [1133.42,662.391], [1086.45,707.348], [1132.47,706.074]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1086.45,707.376], [1132.47,706.101], [1085.83,750.563], [1131.53,749.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1087.72,619.107], [1134.38,618.061], [1087.08,663.524], [1133.42,662.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.02,528.295], [1136.35,527.492], [1088.36,573.997], [1135.36,573.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1088.36,574.025], [1135.36,573.099], [1087.72,619.078], [1134.38,618.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1089.68,481.901], [1137.35,481.225], [1089.02,528.266], [1136.35,527.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.04,387.065], [1090.35,434.8], [1139.4,386.654], [1138.37,434.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1090.35,434.83], [1089.68,481.872], [1138.37,434.284], [1137.35,481.196]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1092.43,289.427], [1091.73,338.593], [1141.52,289.297], [1140.45,338.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.73,338.593], [1091.04,387.066], [1140.45,338.321], [1139.4,386.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1115.75,717.535], [1133.98,717.018], [1114.98,757.571], [1133.1,757.014]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1114.98,757.571], [1133.1,757.014], [1114.29,794.237], [1132.29,793.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1116.52,676.95], [1134.87,676.474], [1115.75,717.509], [1133.98,716.992]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1117.3,635.83], [1135.77,635.397], [1116.52,676.924], [1134.87,676.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1118.1,594.166], [1136.69,593.777], [1117.3,635.804], [1135.77,635.371]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1118.9,551.947], [1137.62,551.602], [1118.1,594.14], [1136.69,593.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1119.72,509.16], [1138.56,508.861], [1118.9,551.92], [1137.62,551.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1120.54,465.795], [1139.51,465.544], [1119.72,509.133], [1138.56,508.834]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1123.96,286.339], [1123.09,332.109], [1143.45,286.291], [1142.45,332.008]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1121.38,421.839], [1140.48,421.637], [1120.55,465.767], [1139.51,465.516]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1122.23,377.282], [1141.45,377.13], [1121.38,421.812], [1140.48,421.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1123.09,332.11], [1122.23,377.282], [1142.45,332.009], [1141.45,377.129]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[893.727,286.449], [871.101,286.447], [894.46,333.092], [871.994,333.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.46,333.092], [871.994,333.088], [895.183,379.11], [872.875,379.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.183,379.11], [872.875,379.104], [895.896,424.458], [873.743,424.45]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.896,424.486], [873.744,424.479], [896.599,469.205], [874.6,469.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.6,469.234], [874.6,469.225], [897.293,513.338], [875.445,513.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.293,513.366], [875.445,513.355], [897.977,556.867], [876.278,556.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[897.977,556.894], [876.279,556.882], [898.652,599.805], [877.1,599.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[898.652,599.833], [877.101,599.818], [899.318,642.165], [877.911,642.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.318,642.192], [877.912,642.176], [899.974,683.958], [878.711,683.94]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.975,683.984], [878.712,683.967], [900.623,725.195], [879.501,725.176]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.623,725.221], [879.501,725.202], [901.262,765.886], [880.28,765.866]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.262,765.887], [880.28,765.866], [901.847,803.118], [880.993,803.096]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[934.5,289.57], [934.977,339.548], [885.951,289.566], [886.795,339.54]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[934.977,339.548], [886.795,339.539], [935.447,388.805], [887.628,388.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[935.447,388.805], [887.628,388.792], [935.91,437.296], [888.448,437.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[935.91,437.327], [888.448,437.31], [936.366,485.099], [889.256,485.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.366,485.129], [889.256,485.108], [936.816,532.198], [890.052,532.173]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.816,532.227], [890.052,532.202], [937.258,578.608], [890.836,578.579]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.259,578.637], [890.837,578.609], [937.695,624.346], [891.609,624.313]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.695,624.374], [891.61,624.342], [938.125,669.424], [892.371,669.388]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.125,669.453], [892.372,669.417], [938.549,713.859], [893.122,713.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.549,713.886], [893.123,713.847], [938.967,757.662], [893.863,757.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.967,757.69], [893.863,757.647], [939.379,800.848], [894.593,800.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.379,800.848], [894.593,800.802], [939.756,840.328], [895.26,840.279]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[998.068,290.735], [932.828,290.729], [998.063,341.956], [933.33,341.944]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.063,341.956], [933.33,341.944], [998.058,392.419], [933.824,392.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.058,392.419], [933.824,392.401], [998.053,442.078], [934.311,442.055]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.053,442.109], [934.311,442.086], [998.049,491.014], [934.79,490.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.049,491.045], [934.791,491.016], [998.044,539.212], [935.262,539.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.044,539.243], [935.263,539.208], [998.039,586.69], [935.728,586.65]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.039,586.719], [935.728,586.68], [998.035,633.461], [936.186,633.417]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.035,633.491], [936.186,633.446], [998.031,679.544], [936.637,679.494]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.031,679.573], [936.638,679.523], [998.026,724.952], [937.082,724.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.026,724.98], [937.082,724.926], [998.022,769.7], [937.521,769.641]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.022,769.728], [937.521,769.669], [998.018,813.803], [937.953,813.74]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.018,813.803], [937.953,813.74], [998.014,854.108], [938.348,854.041]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[998.396,290.522], [1060.43,290.527], [998.388,340.909], [1059.95,340.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.388,340.909], [1059.95,340.921], [998.381,390.848], [1059.47,390.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.381,390.849], [1059.47,390.865], [998.374,440], [1059,440.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.374,440.031], [1059,440.053], [998.367,488.444], [1058.54,488.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.367,488.474], [1058.54,488.502], [998.36,536.165], [1058.08,536.197]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.36,536.195], [1058.08,536.227], [998.353,583.179], [1057.63,583.216]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.353,583.209], [1057.63,583.246], [998.347,629.502], [1057.19,629.544]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.347,629.531], [1057.19,629.573], [998.34,675.149], [1056.75,675.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.34,675.178], [1056.75,675.224], [998.333,720.134], [1056.32,720.185]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.333,720.163], [1056.32,720.214], [998.327,764.473], [1055.9,764.528]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.327,764.501], [1055.9,764.556], [998.321,808.178], [1055.48,808.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[998.321,808.178], [1055.48,808.238], [998.315,848.125], [1055.1,848.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.78,808.269], [1055.4,848.222], [1054.61,796.229], [1054.25,835.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.06,675.248], [1056.63,720.212], [1055.84,665.847], [1055.42,709.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.63,720.24], [1056.2,764.557], [1055.42,709.933], [1055.02,753.371]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.42,709.933], [1102.3,709.973], [1055.02,753.371], [1101.56,753.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.02,753.398], [1101.56,753.442], [1054.61,796.229], [1100.83,796.276]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1054.61,796.229], [1100.83,796.276], [1054.25,835.413], [1100.17,835.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.94,583.265], [1057.5,629.566], [1056.68,575.759], [1056.26,621.098]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.5,629.595], [1057.06,675.22], [1056.26,621.127], [1055.84,665.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.26,621.127], [1103.81,621.16], [1055.84,665.819], [1103.05,665.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1055.84,665.847], [1103.05,665.883], [1055.42,709.905], [1102.3,709.945]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.85,488.516], [1058.39,536.214], [1057.55,483.023], [1057.12,529.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.56,483.023], [1106.15,483.044], [1057.12,529.7], [1105.36,529.725]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1057.12,529.729], [1105.36,529.754], [1056.68,575.73], [1104.58,575.759]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1056.68,575.759], [1104.58,575.788], [1056.26,621.098], [1103.81,621.131]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.45,387.52], [1107.77,387.533], [1058,435.595], [1106.96,435.612]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1059.79,390.874], [1059.32,440.034], [1058.45,387.52], [1058,435.595]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058,435.625], [1106.96,435.642], [1057.56,482.993], [1106.15,483.014]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1059.38,289.155], [1058.91,338.691], [1109.45,289.16], [1108.6,338.7]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1060.75,290.237], [1060.27,340.926], [1059.38,289.155], [1058.91,338.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1058.91,338.692], [1108.6,338.7], [1058.45,387.52], [1107.77,387.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.17,721.004], [1113.78,721.021], [1094.53,761.344], [1113.02,761.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.53,761.344], [1113.02,761.362], [1093.94,798.281], [1112.32,798.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.82,680.103], [1114.55,680.118], [1095.17,720.979], [1113.78,720.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.47,638.656], [1115.33,638.669], [1095.82,680.077], [1114.55,680.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.82,554.077], [1116.93,554.088], [1097.14,596.624], [1116.13,596.636]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.14,596.651], [1116.13,596.663], [1096.48,638.629], [1115.33,638.643]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.5,510.923], [1117.74,510.932], [1097.82,554.05], [1116.93,554.061]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1102.07,286.045], [1121.99,286.046], [1101.33,332.258], [1121.12,332.261]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1109.45,289.16], [1108.6,338.7], [1102.07,286.045], [1101.33,332.258]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1099.9,422.825], [1119.41,422.831], [1099.19,467.148], [1118.57,467.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1099.19,467.176], [1118.57,467.184], [1098.5,510.895], [1117.74,510.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1100.61,377.857], [1120.26,377.861], [1099.9,422.797], [1119.41,422.803]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1101.33,332.258], [1121.12,332.261], [1100.61,377.856], [1120.26,377.861]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1121.99,286.047], [1121.12,332.261], [1117.66,284.521], [1116.85,329.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.13,742.589], [1123.39,778.305], [1120.08,726.171], [1119.39,760.812]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.93,703.6], [1124.13,742.589], [1120.83,688.371], [1120.08,726.171]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.74,664.088], [1124.93,703.575], [1121.59,650.081], [1120.83,688.347]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.41,583.528], [1126.57,624.041], [1123.15,572.062], [1122.37,611.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.57,624.067], [1125.75,664.063], [1122.37,611.314], [1121.59,650.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1128.25,542.461], [1127.41,583.502], [1123.94,532.315], [1123.15,572.036]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.11,500.854], [1128.25,542.434], [1124.74,492.065], [1123.94,532.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1129.98,458.699], [1129.11,500.828], [1125.55,451.302], [1124.74,492.04]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.75,372.695], [1130.86,415.955], [1127.21,368.196], [1126.37,409.989]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1130.86,415.983], [1129.98,458.672], [1126.37,410.015], [1125.55,451.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.66,328.824], [1131.75,372.695], [1128.05,325.832], [1127.21,368.196]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1133.58,284.386], [1132.66,328.824], [1128.9,282.942], [1128.05,325.832]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[869.284,285.007], [870.19,331.623], [846.975,284.947], [848.037,331.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.19,331.623], [871.084,377.614], [848.037,331.498], [849.085,377.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.084,377.614], [849.085,377.425], [871.965,422.935], [850.118,422.684]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.965,422.964], [850.118,422.713], [872.834,467.657], [851.137,467.346]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[899.073,288.161], [899.821,338.24], [851.065,288.023], [852.174,337.951]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.835,467.685], [851.137,467.374], [873.691,511.763], [852.142,511.393]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[899.821,338.24], [900.557,387.595], [852.174,337.951], [853.267,387.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.692,511.791], [852.142,511.421], [874.537,555.267], [853.133,554.84]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[900.557,387.595], [901.282,436.181], [853.267,387.159], [854.342,435.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.537,555.294], [853.134,554.867], [875.371,598.18], [854.111,597.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.283,436.211], [901.997,484.074], [854.343,435.633], [855.403,483.358]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.371,598.208], [854.112,597.725], [876.193,640.515], [855.076,639.979]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[901.997,484.105], [855.404,483.388], [902.701,531.261], [856.448,530.411]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.194,640.542], [855.076,640.006], [877.005,682.283], [856.028,681.695]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[902.702,531.291], [856.449,530.44], [903.395,577.757], [857.478,576.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.006,682.31], [856.028,681.721], [877.806,723.496], [856.967,722.856]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[903.396,577.786], [857.478,576.806], [904.079,623.576], [858.492,622.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.807,723.522], [856.967,722.882], [878.596,764.164], [857.894,763.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[904.079,623.605], [858.493,622.499], [904.753,668.734], [859.492,667.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.596,764.164], [857.894,763.475], [879.32,801.373], [858.741,800.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[904.753,668.763], [859.493,667.534], [905.417,713.245], [860.478,711.897]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[905.418,713.273], [860.479,711.925], [906.072,757.122], [861.45,755.659]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.072,757.15], [861.451,755.687], [906.717,800.38], [862.408,798.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.717,800.38], [862.408,798.805], [907.308,839.923], [863.284,838.247]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[958.422,289.48], [958.727,341.006], [893.484,289.288], [894.293,340.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.727,341.005], [959.027,391.764], [894.293,340.605], [895.091,391.16]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.028,391.764], [959.323,441.709], [895.091,391.16], [895.875,440.908]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.324,441.74], [959.615,490.921], [895.876,440.939], [896.649,489.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.615,490.952], [896.649,489.96], [959.902,539.387], [897.41,538.21]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.902,539.417], [897.411,538.24], [960.184,587.123], [898.161,585.766]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.184,587.152], [898.161,585.796], [960.463,634.145], [898.9,632.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.463,634.174], [898.9,632.644], [960.737,680.47], [899.628,678.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.737,680.499], [899.628,678.8], [961.007,726.113], [900.345,724.25]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.008,726.141], [900.346,724.278], [961.274,771.088], [901.052,769.067]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.274,771.116], [901.053,769.095], [961.536,815.411], [901.749,813.236]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.536,815.411], [901.749,813.236], [961.776,855.914], [902.386,853.6]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[958.422,289.48], [958.727,341.006], [960.473,288.984], [960.759,339.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[958.727,341.006], [959.028,391.764], [960.759,339.966], [961.04,390.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.028,391.764], [959.324,441.709], [961.04,390.198], [961.318,439.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.324,441.74], [959.615,490.921], [961.318,439.663], [961.591,488.349]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1022.72,289.462], [1022.52,340.346], [960.474,289.279], [960.759,339.966]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.615,490.952], [959.902,539.387], [961.591,488.38], [961.86,536.335]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[959.902,539.417], [960.184,587.123], [961.86,536.365], [962.125,583.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.185,587.153], [960.463,634.145], [962.125,583.635], [962.387,630.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.463,634.175], [962.387,630.206], [960.737,680.47], [962.644,676.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.52,340.347], [1022.33,390.771], [960.759,339.967], [961.04,390.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.33,390.771], [961.04,390.198], [1022.14,440.392], [961.318,439.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.14,440.423], [961.318,439.663], [1021.95,489.29], [961.591,488.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[960.737,680.499], [962.644,676.093], [961.007,726.113], [962.898,721.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.008,726.141], [962.898,721.311], [961.274,771.088], [963.147,765.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.274,771.117], [963.148,765.875], [961.536,815.411], [963.394,809.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[961.536,815.411], [963.394,809.77], [961.776,855.914], [963.619,849.913]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.95,489.321], [961.591,488.38], [1021.76,537.452], [961.86,536.335]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.76,537.482], [961.86,536.365], [1021.58,584.893], [962.125,583.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.58,584.922], [962.125,583.635], [1021.4,631.629], [962.387,630.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.4,631.658], [962.387,630.206], [1021.23,677.676], [962.644,676.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.23,677.705], [962.644,676.093], [1021.05,723.05], [962.898,721.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.05,723.079], [962.898,721.311], [1020.88,767.765], [963.147,765.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1020.88,767.793], [963.148,765.875], [1020.71,811.834], [963.394,809.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1020.71,811.834], [963.394,809.77], [1020.56,852.11], [963.619,849.914]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.52,677.738], [1021.35,723.086], [1023.72,668.229], [1023.53,712.66]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.35,723.114], [1021.17,767.804], [1023.53,712.688], [1023.35,756.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.17,767.832], [1021,811.876], [1023.35,756.515], [1023.17,799.696]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021,811.876], [1020.85,852.154], [1023.17,799.696], [1023,839.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.52,340.347], [1022.33,390.771], [1025.12,338.115], [1024.91,387.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.64,390.782], [1022.44,440.407], [1024.91,387.406], [1024.71,435.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.44,440.438], [1022.25,489.309], [1024.71,435.96], [1024.5,483.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.25,489.34], [1022.07,537.474], [1024.5,483.794], [1024.3,530.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.07,537.504], [1021.88,584.919], [1024.3,530.922], [1024.11,577.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.88,584.948], [1021.7,631.659], [1024.11,577.361], [1023.91,623.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.7,631.688], [1021.52,677.709], [1023.91,623.125], [1023.72,668.201]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1023.03,289.169], [1022.83,340.354], [1025.33,288.101], [1025.12,338.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.85,714.095], [1023.53,712.688], [1070.33,758.015], [1023.35,756.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.33,758.042], [1023.35,756.515], [1069.81,801.34], [1023.17,799.696]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.81,801.34], [1023.17,799.696], [1069.34,840.945], [1023,839.196]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.16,436.564], [1024.71,435.96], [1073.58,484.511], [1024.5,483.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.58,484.541], [1024.5,483.794], [1073.02,531.78], [1024.3,530.892]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.02,531.809], [1024.3,530.922], [1072.47,578.355], [1024.11,577.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.47,578.384], [1024.11,577.361], [1071.92,624.251], [1023.91,623.096]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.92,624.28], [1023.91,623.125], [1071.38,669.484], [1023.72,668.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.38,669.512], [1023.72,668.229], [1070.85,714.067], [1023.53,712.66]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1075.92,288.245], [1075.32,338.416], [1025.33,288.101], [1025.12,338.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.32,338.417], [1025.12,338.115], [1074.74,387.861], [1024.91,387.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.74,387.861], [1024.91,387.406], [1074.16,436.534], [1024.71,435.93]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.81,801.34], [1069.34,840.946], [1073.14,765.82], [1072.68,803.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.85,714.095], [1070.33,758.015], [1074.15,683.724], [1073.64,725.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.33,758.042], [1069.81,801.34], [1073.64,725.059], [1073.14,765.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.92,624.28], [1071.38,669.484], [1075.2,599.367], [1074.67,641.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.38,669.512], [1070.85,714.067], [1074.67,641.831], [1074.15,683.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.47,578.384], [1071.92,624.251], [1075.73,556.321], [1075.2,599.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.58,484.542], [1073.02,531.78], [1076.82,468.434], [1076.27,512.653]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.02,531.81], [1072.47,578.355], [1076.27,512.68], [1075.73,556.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.5,725.632], [1073.64,725.059], [1091.87,766.438], [1073.14,765.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.87,766.438], [1073.14,765.82], [1091.29,803.795], [1072.68,803.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.74,387.861], [1074.16,436.534], [1077.94,378.069], [1077.38,423.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.16,436.564], [1073.58,484.511], [1077.38,423.567], [1076.82,468.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.78,642.312], [1074.67,641.831], [1093.14,684.226], [1074.15,683.698]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.14,684.252], [1074.15,683.724], [1092.5,725.606], [1073.64,725.033]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1075.92,288.245], [1075.32,338.416], [1079.09,285.15], [1078.51,331.924]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1075.32,338.417], [1074.74,387.861], [1078.51,331.924], [1077.94,378.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.11,556.704], [1075.73,556.321], [1094.44,599.772], [1075.2,599.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.44,599.799], [1075.2,599.367], [1093.78,642.285], [1074.67,641.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.47,468.713], [1076.82,468.434], [1095.78,512.984], [1076.27,512.653]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.78,513.012], [1076.27,512.68], [1095.11,556.676], [1075.73,556.293]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.86,378.239], [1077.94,378.069], [1097.16,423.764], [1077.38,423.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.16,423.793], [1077.38,423.567], [1096.47,468.685], [1076.82,468.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.58,332.037], [1078.51,331.924], [1097.86,378.238], [1077.94,378.069]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1099.3,285.203], [1079.09,285.15], [1098.58,332.037], [1078.51,331.924]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1091.87,766.438], [1091.29,803.795], [1092.88,748.875], [1092.32,785.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1092.5,725.632], [1091.87,766.438], [1093.5,709.334], [1092.88,748.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.78,642.312], [1093.14,684.226], [1094.75,628.652], [1094.12,669.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1093.14,684.252], [1092.5,725.606], [1094.12,669.255], [1093.5,709.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.11,556.704], [1094.44,599.772], [1096.04,545.831], [1095.39,587.488]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1094.44,599.799], [1093.78,642.285], [1095.39,587.514], [1094.75,628.626]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1095.78,513.012], [1095.11,556.676], [1096.7,503.593], [1096.04,545.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1096.47,468.713], [1095.78,512.984], [1097.36,460.787], [1096.7,503.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.86,378.239], [1097.16,423.764], [1098.73,373.427], [1098.04,417.374]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1097.16,423.793], [1096.47,468.685], [1098.04,417.402], [1097.37,460.759]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1098.58,332.037], [1097.86,378.238], [1099.42,328.849], [1098.73,373.427]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1099.3,285.204], [1098.58,332.037], [1100.12,283.685], [1099.42,328.849]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.08,708.332], [1108.37,747.795], [1109.51,692.804], [1108.82,731.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.37,747.795], [1107.71,783.939], [1108.82,731.053], [1108.19,766.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.8,668.333], [1109.08,708.307], [1110.21,654.051], [1109.51,692.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.54,627.813], [1109.8,668.308], [1110.93,614.81], [1110.22,654.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.03,545.164], [1111.28,586.733], [1112.37,534.825], [1111.65,575.046]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.28,586.759], [1110.54,627.787], [1111.65,575.071], [1110.93,614.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.79,503.014], [1112.03,545.137], [1113.11,494.061], [1112.38,534.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.57,460.3], [1112.79,502.987], [1113.86,452.77], [1113.11,494.035]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1116.82,275.182], [1101.75,275.151], [1116.17,310.966], [1101.19,310.902]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.14,373.132], [1114.35,416.982], [1115.39,368.566], [1114.62,410.915]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.35,417.01], [1113.57,460.273], [1114.62,410.942], [1113.86,452.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.95,328.654], [1115.14,373.132], [1116.16,325.63], [1115.39,368.565]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1116.76,283.592], [1115.95,328.654], [1116.95,282.153], [1116.16,325.63]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[863.958,285.963], [864.971,336.238], [816.976,285.713], [818.338,335.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.972,336.237], [865.97,385.786], [818.338,335.689], [819.68,384.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.97,385.787], [866.953,434.563], [819.68,384.948], [821.002,433.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[866.954,434.594], [867.923,482.646], [821.002,433.473], [822.304,481.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[867.923,482.676], [868.878,530.019], [822.305,481.283], [823.588,528.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[868.878,530.049], [869.819,576.699], [823.589,528.391], [824.853,574.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.819,576.728], [870.746,622.701], [824.854,574.814], [826.1,620.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.746,622.73], [826.101,620.565], [871.66,668.039], [827.329,665.633]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.66,668.067], [827.33,665.661], [872.561,712.727], [828.541,710.086]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.561,712.755], [828.541,710.114], [873.449,756.78], [829.735,753.911]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.449,756.808], [829.736,753.939], [874.324,800.211], [830.913,797.121]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.324,800.211], [830.913,797.121], [875.124,839.914], [831.989,836.625]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[918.41,287.343], [919.03,339.267], [854.479,286.994], [855.592,338.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.03,339.267], [919.641,390.416], [855.592,338.502], [856.687,389.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.641,390.416], [920.241,440.743], [856.687,389.246], [857.766,439.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.242,440.774], [920.833,490.329], [857.766,439.213], [858.828,488.388]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.834,490.36], [921.416,539.161], [858.829,488.419], [859.875,536.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.417,539.191], [921.99,587.255], [859.875,536.882], [860.905,584.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.991,587.285], [922.556,634.628], [860.906,584.619], [861.921,631.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.556,634.658], [923.113,681.297], [861.921,631.646], [862.921,677.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.113,681.326], [862.922,677.979], [923.662,727.276], [863.907,723.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.662,727.305], [863.908,723.632], [924.203,772.581], [864.878,768.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.203,772.609], [864.879,768.622], [924.736,817.227], [865.836,812.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.736,817.227], [865.836,812.933], [925.223,858.023], [866.711,853.454]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[918.41,287.343], [919.03,339.268], [922.193,286.887], [922.777,338.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.03,339.267], [919.641,390.416], [922.777,338.266], [923.352,388.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[919.641,390.416], [920.242,440.743], [923.352,388.887], [923.918,438.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.242,440.775], [920.833,490.329], [923.918,438.733], [924.476,487.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[920.834,490.36], [921.416,539.161], [924.476,487.823], [925.026,536.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.417,539.192], [921.99,587.255], [925.026,536.173], [925.567,583.77]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[983.984,287.52], [984.089,338.998], [922.196,287.184], [922.777,338.266]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[921.991,587.285], [922.556,634.629], [925.567,583.8], [926.1,630.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[922.556,634.658], [926.1,630.721], [923.113,681.297], [926.625,676.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.089,338.999], [984.193,390.005], [922.777,338.267], [923.352,388.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.193,390.005], [984.295,440.194], [923.352,388.887], [923.918,438.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.113,681.326], [926.626,676.95], [923.662,727.276], [927.143,722.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.295,440.226], [984.395,489.647], [923.918,438.733], [924.476,487.792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.395,489.678], [984.494,538.35], [924.476,487.823], [925.026,536.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[923.662,727.305], [927.144,722.504], [924.203,772.581], [927.653,767.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.203,772.61], [927.654,767.396], [924.736,817.227], [928.156,811.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.495,538.381], [984.592,586.319], [925.026,536.173], [925.567,583.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.592,586.349], [925.567,583.8], [984.688,633.57], [926.1,630.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[924.736,817.227], [928.156,811.614], [925.223,858.023], [928.616,852.05]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.688,633.6], [926.1,630.721], [984.783,680.121], [926.625,676.921]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.783,680.151], [926.626,676.95], [984.876,725.986], [927.143,722.475]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.876,726.015], [927.144,722.504], [984.968,771.181], [927.653,767.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.968,771.209], [927.654,767.396], [985.058,815.719], [928.156,811.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[985.058,815.719], [928.156,811.614], [985.141,856.419], [928.616,852.05]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[984.288,287.225], [984.391,339.008], [990.345,286.232], [990.399,336.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.089,338.999], [984.193,390.005], [990.4,336.83], [990.453,386.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.492,390.02], [984.592,440.214], [990.453,386.691], [990.505,435.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.592,440.245], [984.69,489.671], [990.505,435.802], [990.557,484.148]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.69,489.702], [984.787,538.378], [990.557,484.178], [990.608,531.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.787,538.409], [984.882,586.351], [990.608,531.836], [990.658,578.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.882,586.382], [984.976,633.608], [990.658,578.793], [990.708,625.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[984.976,633.637], [985.069,680.162], [990.708,625.063], [990.757,670.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[985.069,680.192], [985.16,726.031], [990.757,670.661], [990.805,715.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[985.16,726.06], [985.25,771.229], [990.805,715.602], [990.852,759.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[985.25,771.258], [985.338,815.772], [990.852,759.9], [990.899,803.542]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[985.338,815.772], [985.419,856.475], [990.899,803.542], [990.942,843.459]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1040.96,286.499], [1040.62,337.415], [990.345,286.232], [990.4,336.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.62,337.415], [1040.29,387.586], [990.4,336.83], [990.453,386.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.29,387.586], [1039.97,436.965], [990.453,386.691], [990.506,435.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.97,436.996], [1039.65,485.633], [990.506,435.802], [990.557,484.148]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.65,485.663], [990.557,484.178], [1039.33,533.574], [990.608,531.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.33,533.604], [990.609,531.836], [1039.02,580.804], [990.659,578.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.02,580.834], [990.659,578.793], [1038.72,627.34], [990.708,625.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.72,627.369], [990.708,625.063], [1038.42,673.196], [990.757,670.632]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.42,673.225], [990.757,670.661], [1038.12,718.387], [990.805,715.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.12,718.415], [990.805,715.602], [1037.83,762.928], [990.853,759.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1037.83,762.956], [990.853,759.9], [1037.54,806.833], [990.9,803.542]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1037.54,806.833], [990.9,803.542], [1037.27,846.962], [990.942,843.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1037.54,806.833], [1037.27,846.962], [1050.78,770.964], [1050.45,808.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.72,627.369], [1038.42,673.196], [1052.24,602.275], [1051.87,645.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.42,673.225], [1038.12,718.387], [1051.87,645.318], [1051.5,687.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1038.12,718.416], [1037.83,762.928], [1051.5,687.776], [1051.14,729.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1037.83,762.956], [1037.54,806.833], [1051.14,729.663], [1050.78,770.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.65,485.663], [1039.33,533.574], [1053.4,469.524], [1053.01,514.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.33,533.604], [1039.02,580.804], [1053.01,514.391], [1052.62,558.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.02,580.834], [1038.72,627.34], [1052.62,558.637], [1052.24,602.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.62,337.415], [1040.29,387.586], [1054.6,331.062], [1054.19,377.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1040.29,387.586], [1039.97,436.965], [1054.19,377.873], [1053.79,423.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1039.97,436.996], [1039.65,485.633], [1053.79,424.022], [1053.4,469.495]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1040.96,286.499], [1040.62,337.415], [1055.01,283.605], [1054.6,331.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.6,772.205], [1050.78,770.964], [1069.16,810.093], [1050.45,808.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.58,688.836], [1051.5,687.776], [1070.09,730.789], [1051.14,729.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.09,730.815], [1051.14,729.663], [1069.6,772.205], [1050.78,770.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.11,559.404], [1052.62,558.637], [1071.59,603.115], [1052.24,602.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.59,603.142], [1052.24,602.275], [1071.08,646.255], [1051.87,645.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.08,646.282], [1051.87,645.318], [1070.58,688.809], [1051.5,687.75]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.69,424.47], [1053.79,424.022], [1073.16,470.052], [1053.4,469.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.16,470.081], [1053.4,469.524], [1072.63,515.026], [1053.01,514.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.63,515.054], [1053.01,514.391], [1072.11,559.376], [1052.62,558.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.79,331.281], [1054.6,331.062], [1074.24,378.208], [1054.19,377.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.24,378.208], [1054.19,377.873], [1073.69,424.441], [1053.79,423.993]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1075.35,283.705], [1074.79,331.281], [1055.01,283.606], [1054.6,331.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1069.6,772.205], [1069.16,810.093], [1075.51,754.433], [1075.05,791.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.58,688.836], [1070.09,730.789], [1076.54,673.675], [1076.02,714.304]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1070.09,730.815], [1069.6,772.205], [1076.02,714.33], [1075.51,754.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.59,603.143], [1071.08,646.255], [1077.59,590.742], [1077.06,632.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1071.08,646.283], [1070.58,688.809], [1077.06,632.483], [1076.54,673.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.63,515.054], [1072.11,559.376], [1078.67,505.574], [1078.13,548.416]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1072.11,559.404], [1071.59,603.115], [1078.13,548.443], [1077.59,590.716]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.69,424.47], [1073.16,470.052], [1079.78,418.077], [1079.22,462.094]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1073.16,470.081], [1072.63,515.026], [1079.22,462.122], [1078.67,505.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.79,331.281], [1074.24,378.208], [1080.92,328.155], [1080.35,373.425]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1074.24,378.208], [1073.69,424.441], [1080.35,373.425], [1079.78,418.049]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1075.35,283.705], [1074.79,331.281], [1081.51,282.283], [1080.92,328.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.56,753.831], [1091,790.516], [1096.68,736.862], [1096.1,772.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.79,673.161], [1092.17,713.746], [1097.93,658.699], [1097.3,698.014]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.17,713.771], [1091.56,753.83], [1097.3,698.039], [1096.68,736.862]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.06,590.322], [1093.42,631.989], [1099.22,578.505], [1098.57,618.832]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.42,632.015], [1092.79,673.135], [1098.57,618.858], [1097.93,658.674]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.71,548.072], [1094.06,590.296], [1099.88,537.631], [1099.22,578.479]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.03,461.853], [1095.36,505.225], [1101.22,454.279], [1100.55,496.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.36,505.253], [1094.71,548.045], [1100.55,496.226], [1099.88,537.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1096.7,417.861], [1096.03,461.825], [1101.9,411.78], [1101.22,454.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1098.07,328.05], [1097.38,373.264], [1103.3,325.08], [1102.6,368.717]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1097.38,373.264], [1096.7,417.832], [1102.6,368.717], [1101.9,411.753]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.21,674.029], [1076.78,672.829], [1098.7,705.397], [1076.38,704.116]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1098.77,282.235], [1098.07,328.05], [1104.01,280.884], [1103.3,325.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.33,605.257], [1077.65,604.238], [1099.77,639.821], [1077.22,638.71]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.77,639.842], [1077.22,638.732], [1099.21,674.029], [1076.78,672.829]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.48,534.929], [1078.55,534.099], [1100.91,570.266], [1078.1,569.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.91,570.288], [1078.1,569.363], [1100.33,605.235], [1077.65,604.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.77,639.842], [1099.21,674.029], [1107,620.176], [1106.43,652.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.21,674.029], [1098.7,705.397], [1106.43,652.773], [1105.91,682.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.07,499.173], [1079,498.441], [1101.48,534.906], [1078.55,534.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.91,570.288], [1100.33,605.235], [1108.15,553.911], [1107.57,587.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.33,605.257], [1099.77,639.821], [1107.57,587.217], [1107,620.156]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1105.71,275.941], [1105.09,314.2], [1081.83,275.848], [1081.35,313.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.25,426.443], [1079.92,425.915], [1102.66,462.99], [1079.46,462.359]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.66,463.013], [1079.46,462.382], [1102.07,499.15], [1079,498.419]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.48,534.929], [1100.91,570.266], [1108.74,520.252], [1108.15,553.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.47,352.044], [1080.87,351.728], [1103.86,389.432], [1080.39,389.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.86,389.456], [1080.39,389.032], [1103.25,426.42], [1079.92,425.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.66,463.013], [1102.07,499.15], [1109.93,451.852], [1109.33,486.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.07,499.173], [1101.48,534.906], [1109.33,486.234], [1108.74,520.23]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.09,314.2], [1104.47,352.044], [1081.35,313.994], [1080.87,351.728]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.86,389.456], [1103.25,426.42], [1111.15,381.971], [1110.54,417.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.25,426.443], [1102.66,462.99], [1110.54,417.1], [1109.93,451.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.47,352.044], [1103.86,389.432], [1111.77,346.46], [1111.15,381.949]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1105.71,275.941], [1105.09,314.2], [1113.03,274.29], [1112.39,310.561]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.09,314.2], [1104.47,352.044], [1112.39,310.561], [1111.77,346.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.79,653.502], [1106.43,652.773], [1120.2,683.477], [1105.91,682.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.09,587.836], [1107.57,587.217], [1121.44,620.83], [1107,620.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.44,620.851], [1107,620.177], [1120.79,653.502], [1106.43,652.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.41,520.755], [1108.74,520.252], [1122.75,554.451], [1108.15,553.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.75,554.473], [1108.15,553.911], [1122.09,587.815], [1107.57,587.196]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.76,452.234], [1109.93,451.852], [1124.08,486.655], [1109.33,486.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.08,486.677], [1109.33,486.234], [1123.41,520.733], [1108.74,520.23]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.45,417.42], [1110.54,417.1], [1124.76,452.212], [1109.93,451.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.84,346.652], [1111.77,346.461], [1126.14,382.205], [1111.15,381.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.14,382.227], [1111.15,381.971], [1125.45,417.397], [1110.54,417.077]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1128.27,274.347], [1127.55,310.686], [1113.03,274.29], [1112.39,310.561]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.55,310.686], [1112.39,310.561], [1126.84,346.651], [1111.77,346.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.79,653.502], [1120.2,683.477], [1124.3,641.976], [1123.71,671.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.44,620.851], [1120.79,653.502], [1124.94,610.191], [1124.3,641.976]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.75,554.473], [1122.09,587.815], [1126.25,545.603], [1125.59,578.041]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.09,587.836], [1121.44,620.83], [1125.59,578.062], [1124.94,610.171]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.08,486.677], [1123.41,520.733], [1127.58,479.676], [1126.91,512.788]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.41,520.755], [1122.75,554.451], [1126.91,512.809], [1126.25,545.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.76,452.234], [1124.08,486.655], [1128.26,446.197], [1127.58,479.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.45,417.42], [1124.76,452.212], [1128.94,412.368], [1128.26,446.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.84,346.652], [1126.14,382.205], [1130.34,343.635], [1129.64,378.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.14,382.227], [1125.45,417.397], [1129.64,378.182], [1128.95,412.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1127.55,310.686], [1126.84,346.651], [1131.04,308.721], [1130.34,343.635]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1128.27,274.347], [1127.55,310.686], [1131.76,273.455], [1131.04,308.721]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[829.324,283.081], [830.595,333.622], [783.868,282.759], [785.468,332.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.595,333.622], [831.848,383.436], [785.468,332.853], [787.046,382.232]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.848,383.436], [833.081,432.476], [787.046,382.233], [788.599,430.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.082,432.507], [834.297,480.822], [788.6,430.882], [790.131,478.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[834.298,480.852], [835.495,528.457], [790.132,478.819], [791.64,526.027]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[835.496,528.487], [836.676,575.398], [791.641,526.057], [793.127,572.583]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[836.677,575.428], [837.839,621.66], [793.128,572.613], [794.593,618.471]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[837.84,621.689], [838.986,667.257], [794.594,618.5], [796.039,663.705]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[838.987,667.285], [840.117,712.203], [796.039,663.734], [797.463,708.299]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.117,712.231], [841.231,756.512], [797.464,708.327], [798.868,752.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.232,756.54], [798.869,752.294], [842.33,800.198], [800.253,795.621]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.33,800.199], [800.253,795.621], [843.334,840.137], [801.52,835.26]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[878.199,284.412], [879.134,336.804], [816.019,283.96], [817.424,335.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.133,336.804], [880.054,388.413], [817.424,335.724], [818.808,386.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.054,388.413], [880.96,439.193], [818.808,386.724], [820.17,436.914]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.961,439.224], [881.853,489.226], [820.171,436.945], [821.513,486.375]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.854,489.257], [882.732,538.498], [821.514,486.406], [822.835,535.093]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.733,538.529], [883.598,587.026], [822.836,535.123], [824.138,583.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[883.599,587.057], [884.451,634.828], [824.139,583.113], [825.422,630.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[884.452,634.858], [885.291,681.918], [825.422,630.393], [826.686,676.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.292,681.948], [886.119,728.313], [826.687,676.977], [827.932,722.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.12,728.342], [886.935,774.029], [827.933,722.881], [829.16,768.092]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.935,774.057], [887.738,819.079], [829.161,768.121], [830.371,812.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[887.738,819.079], [888.473,860.245], [830.371,812.681], [831.477,853.432]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[878.199,284.412], [879.133,336.804], [883.707,284.021], [884.589,335.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.134,336.804], [880.054,388.413], [884.589,335.869], [885.458,386.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.054,388.413], [880.96,439.193], [885.458,386.951], [886.314,437.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.961,439.225], [881.853,489.226], [886.314,437.251], [887.157,486.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.854,489.257], [882.732,538.498], [887.157,486.789], [887.987,535.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.733,538.529], [883.598,587.027], [887.987,535.58], [888.805,583.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[883.599,587.057], [884.451,634.828], [888.805,583.643], [889.611,630.963]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[944.333,284.76], [944.747,336.909], [883.712,284.321], [884.589,335.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.747,336.91], [945.158,388.578], [884.589,335.869], [885.458,386.95]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[884.451,634.858], [889.611,630.992], [885.291,681.918], [890.405,677.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.158,388.578], [945.562,439.415], [885.458,386.951], [886.314,437.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[885.292,681.948], [890.405,677.645], [886.119,728.313], [891.187,723.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.562,439.448], [945.96,489.505], [886.314,437.251], [887.157,486.758]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.119,728.343], [891.187,723.615], [886.935,774.029], [891.958,768.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.96,489.536], [946.352,538.831], [887.157,486.789], [887.987,535.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[886.935,774.057], [891.958,768.918], [887.738,819.079], [892.718,813.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.352,538.862], [946.738,587.412], [887.987,535.581], [888.805,583.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[887.738,819.079], [892.718,813.541], [888.473,860.245], [893.412,854.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.738,587.443], [947.118,635.264], [888.805,583.643], [889.611,630.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.118,635.295], [947.493,682.404], [889.611,630.992], [890.405,677.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.493,682.434], [947.862,728.847], [890.405,677.645], [891.187,723.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.862,728.877], [948.226,774.609], [891.187,723.615], [891.958,768.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.226,774.638], [891.958,768.918], [948.584,819.704], [892.718,813.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.584,819.704], [892.718,813.541], [948.912,860.911], [893.412,854.348]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[944.62,284.461], [945.034,336.92], [954.486,283.601], [954.816,334.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[944.747,336.91], [945.158,388.578], [954.816,334.866], [955.141,385.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.443,388.595], [945.845,439.438], [955.141,385.381], [955.46,435.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[945.845,439.47], [946.241,489.533], [955.46,435.133], [955.775,484.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.241,489.565], [946.631,538.865], [955.775,484.139], [956.085,532.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[946.631,538.896], [947.015,587.451], [956.085,532.414], [956.391,579.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.015,587.482], [947.393,635.309], [956.391,579.977], [956.692,626.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.393,635.339], [947.765,682.453], [956.692,626.841], [956.989,672.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[947.766,682.483], [948.133,728.902], [956.989,673.022], [957.281,718.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.133,728.931], [948.494,774.668], [957.281,718.536], [957.57,763.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.495,774.697], [948.851,819.768], [957.57,763.396], [957.854,807.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[948.851,819.768], [949.177,860.978], [957.854,807.589], [958.114,848.009]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1004.56,283.952], [1004.51,335.704], [954.487,283.601], [954.816,334.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.51,335.704], [1004.45,386.693], [954.816,334.866], [955.141,385.381]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.45,386.693], [1004.4,436.872], [955.141,385.381], [955.46,435.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.4,436.903], [1004.35,486.322], [955.461,435.133], [955.775,484.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.35,486.353], [1004.3,535.03], [955.776,484.139], [956.086,532.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.3,535.06], [1004.25,583.01], [956.086,532.414], [956.391,579.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.25,583.041], [1004.2,630.281], [956.391,579.976], [956.693,626.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.2,630.31], [956.693,626.841], [1004.15,676.856], [956.989,672.993]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.15,676.886], [956.989,673.022], [1004.1,722.752], [957.282,718.507]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.1,722.781], [957.282,718.536], [1004.05,767.983], [957.57,763.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.05,768.011], [957.57,763.396], [1004,812.564], [957.854,807.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004,812.564], [957.854,807.589], [1003.96,853.307], [958.114,848.009]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1004.56,283.952], [1004.51,335.704], [1029.8,281.429], [1029.57,329.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.51,335.704], [1004.45,386.693], [1029.57,329.671], [1029.34,377.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.45,386.693], [1004.4,436.872], [1029.34,377.252], [1029.11,424.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.4,436.903], [1004.35,486.322], [1029.11,424.156], [1028.89,470.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.35,486.354], [1004.3,535.03], [1028.89,470.397], [1028.67,515.96]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.3,535.06], [1004.25,583.011], [1028.67,515.988], [1028.45,560.916]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.25,583.041], [1004.2,630.281], [1028.45,560.945], [1028.23,605.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.2,630.31], [1004.15,676.856], [1028.23,605.279], [1028.02,648.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.15,676.886], [1004.1,722.752], [1028.02,649.004], [1027.81,692.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.1,722.781], [1004.05,767.983], [1027.81,692.131], [1027.61,734.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004.05,768.012], [1004,812.564], [1027.61,734.675], [1027.4,776.618]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1004,812.564], [1003.96,853.307], [1027.4,776.618], [1027.22,815.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.5,736.423], [1027.61,734.675], [1046.17,778.504], [1027.4,776.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.17,778.504], [1027.4,776.619], [1045.86,817.02], [1027.22,815.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.23,516.986], [1028.67,515.988], [1047.87,562.073], [1028.45,560.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.87,562.101], [1028.45,560.945], [1047.52,606.562], [1028.23,605.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.52,606.59], [1028.23,605.279], [1047.18,650.437], [1028.02,648.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.18,650.464], [1028.02,649.004], [1046.83,693.711], [1027.81,692.105]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.83,693.738], [1027.81,692.132], [1046.5,736.396], [1027.61,734.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.7,329.986], [1049.32,377.745], [1029.57,329.671], [1029.34,377.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.32,377.746], [1029.34,377.252], [1048.95,424.793], [1029.11,424.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.95,424.822], [1029.11,424.156], [1048.59,471.202], [1028.89,470.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.59,471.231], [1028.89,470.397], [1048.23,516.957], [1028.67,515.96]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1050.08,281.561], [1049.7,329.986], [1029.8,281.429], [1029.57,329.671]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.5,736.423], [1046.17,778.504], [1057.51,719.871], [1057.12,760.646]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.17,778.504], [1045.86,817.02], [1057.12,760.646], [1056.76,797.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.52,606.59], [1047.18,650.437], [1058.72,594.186], [1058.32,636.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.18,650.464], [1046.83,693.711], [1058.32,636.639], [1057.91,678.504]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1046.83,693.738], [1046.5,736.396], [1057.91,678.531], [1057.52,719.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.59,471.231], [1048.23,516.957], [1059.98,463.341], [1059.56,507.521]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.23,516.986], [1047.87,562.073], [1059.56,507.549], [1059.14,551.132]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1047.87,562.101], [1047.52,606.562], [1059.14,551.16], [1058.72,594.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.7,329.986], [1049.32,377.745], [1061.29,327.01], [1060.85,373.084]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1049.32,377.746], [1048.95,424.793], [1060.85,373.084], [1060.41,418.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1048.95,424.822], [1048.59,471.202], [1060.41,418.523], [1059.98,463.312]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1050.08,281.561], [1049.7,329.986], [1061.74,280.317], [1061.29,327.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.62,760.55], [1073.17,797.88], [1083.56,743.464], [1083.06,779.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.63,678.449], [1074.12,719.756], [1084.66,663.912], [1084.11,703.928]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.12,719.782], [1073.62,760.55], [1084.11,703.953], [1083.56,743.464]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.67,594.12], [1075.15,636.538], [1085.79,582.274], [1085.22,623.33]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.15,636.565], [1074.63,678.423], [1085.22,623.356], [1084.66,663.886]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.73,507.498], [1076.2,551.074], [1086.95,498.494], [1086.37,540.63]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.19,551.101], [1075.67,594.093], [1086.36,540.657], [1085.79,582.248]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.82,418.49], [1077.27,463.27], [1088.14,412.485], [1087.54,455.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.27,463.298], [1076.73,507.47], [1087.54,455.773], [1086.95,498.467]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.95,326.994], [1078.38,373.059], [1089.36,324.159], [1088.75,368.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.38,373.059], [1077.82,418.461], [1088.75,368.618], [1088.14,412.458]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1079.52,280.31], [1078.95,326.994], [1089.98,279.126], [1089.36,324.159]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.6,679.742], [1081.09,677.92], [1103.06,711.635], [1080.67,709.689]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.38,574.246], [1082.48,572.845], [1104.78,609.787], [1082.01,608.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.78,609.81], [1082.01,608.265], [1104.19,644.958], [1081.55,643.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.19,644.98], [1081.55,643.295], [1103.6,679.742], [1081.09,677.92]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1071.52,279.016], [1071.02,323.895], [1089.78,277.083], [1089.2,319.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.6,501.911], [1083.44,500.808], [1105.99,538.259], [1082.96,537.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.99,538.282], [1082.96,537.028], [1105.38,574.223], [1082.49,572.823]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1110.44,274.764], [1109.78,313.703], [1086.45,274.641], [1085.94,313.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.85,427.92], [1084.42,427.128], [1107.22,465.102], [1083.93,464.153]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.22,465.126], [1083.93,464.177], [1106.6,501.888], [1083.44,500.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.49,390.286], [1107.85,427.896], [1084.92,389.656], [1084.42,427.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.78,313.703], [1109.13,352.216], [1085.94,313.407], [1085.43,351.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.13,352.216], [1108.49,390.262], [1085.43,351.751], [1084.92,389.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.6,679.742], [1103.06,711.636], [1116.86,658.376], [1116.29,688.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.78,609.81], [1104.19,644.958], [1118.13,591.709], [1117.49,625.207]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.19,644.98], [1103.6,679.742], [1117.49,625.228], [1116.86,658.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.99,538.282], [1105.38,574.223], [1119.41,523.596], [1118.77,557.812]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1105.38,574.246], [1104.78,609.787], [1118.77,557.834], [1118.13,591.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.6,501.911], [1105.99,538.259], [1120.07,488.991], [1119.41,523.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.85,427.92], [1107.22,465.102], [1121.4,418.654], [1120.73,453.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.22,465.126], [1106.6,501.888], [1120.73,454.013], [1120.07,488.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.49,390.286], [1107.85,427.896], [1122.08,382.91], [1121.4,418.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.78,313.703], [1109.13,352.216], [1123.45,310.237], [1122.76,346.773]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.13,352.216], [1108.49,390.262], [1122.76,346.773], [1122.08,382.887]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1110.44,274.764], [1109.78,313.703], [1124.15,273.32], [1123.45,310.237]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.33,659.486], [1116.86,658.376], [1130.69,689.992], [1116.29,688.804]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.04,626.255], [1117.49,625.228], [1131.33,659.486], [1116.86,658.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.47,558.686], [1118.77,557.834], [1132.75,592.628], [1118.13,591.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.75,592.649], [1118.13,591.709], [1132.04,626.233], [1117.49,625.207]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.2,524.359], [1119.41,523.596], [1133.47,558.664], [1118.77,557.812]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.68,454.59], [1120.73,454.013], [1134.94,489.64], [1120.07,488.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.94,489.662], [1120.07,488.991], [1134.2,524.337], [1119.41,523.574]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.2,383.292], [1122.08,382.91], [1136.44,419.112], [1121.4,418.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.44,419.135], [1121.4,418.654], [1135.68,454.567], [1120.73,453.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.97,347.055], [1122.76,346.773], [1137.2,383.27], [1122.08,382.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1138.74,310.417], [1137.97,347.055], [1123.45,310.237], [1122.76,346.773]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1139.53,273.395], [1138.74,310.417], [1124.15,273.32], [1123.45,310.238]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.04,626.255], [1131.33,659.486], [1138.83,615.527], [1138.11,647.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1131.33,659.486], [1130.69,689.992], [1138.11,647.878], [1137.45,677.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1132.75,592.649], [1132.04,626.233], [1139.56,582.823], [1138.83,615.506]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1133.47,558.686], [1132.75,592.628], [1140.3,549.78], [1139.56,582.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.94,489.662], [1134.2,524.337], [1141.79,482.657], [1141.04,516.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1134.2,524.359], [1133.47,558.664], [1141.04,516.393], [1140.3,549.759]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1135.68,454.589], [1134.94,489.64], [1142.55,448.566], [1141.79,482.635]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1136.44,419.135], [1135.68,454.567], [1143.32,414.115], [1142.55,448.544]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.97,347.055], [1137.2,383.27], [1144.88,344.109], [1144.09,379.276]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1137.2,383.292], [1136.44,419.112], [1144.09,379.298], [1143.32,414.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1138.74,310.417], [1137.97,347.055], [1145.67,308.542], [1144.88,344.109]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1139.53,273.395], [1138.74,310.417], [1146.47,272.614], [1145.67,308.542]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[795.372,279.601], [796.888,330.462], [751.944,279.264], [753.765,329.528]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.889,330.462], [798.384,380.597], [753.765,329.528], [755.56,379.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.383,380.597], [799.855,429.959], [755.56,379.083], [757.328,427.883]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.856,429.99], [801.307,478.626], [757.329,427.913], [759.071,476.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.308,478.657], [802.737,526.584], [759.072,476.035], [760.789,523.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.738,526.614], [804.146,573.848], [760.79,523.462], [762.483,570.182]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.147,573.878], [805.535,620.432], [762.484,570.211], [764.152,616.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.536,620.461], [806.905,666.352], [764.153,616.295], [765.798,661.701]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[806.906,666.38], [808.255,711.621], [765.799,661.73], [767.421,706.499]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.255,711.649], [809.586,756.252], [767.422,706.527], [769.021,750.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.586,756.28], [810.898,800.261], [769.022,750.701], [770.599,794.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.898,800.261], [812.098,840.497], [770.6,794.238], [772.043,834.074]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[838.011,280.76], [839.256,333.67], [778.342,280.283], [780.025,332.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.255,333.67], [840.482,385.792], [780.025,332.35], [781.684,383.655]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.482,385.792], [841.689,437.08], [781.684,383.655], [783.317,434.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.69,437.112], [842.878,487.617], [783.318,434.182], [784.927,483.919]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.879,487.649], [844.049,537.388], [784.928,483.951], [786.512,532.946]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.05,537.419], [845.203,586.41], [786.513,532.976], [788.074,581.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.204,586.441], [846.34,634.701], [788.075,581.276], [789.613,628.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.34,634.731], [847.459,682.276], [789.614,628.865], [791.129,675.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.46,682.306], [848.562,729.151], [791.13,675.761], [792.624,721.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.563,729.181], [849.649,775.342], [792.624,721.976], [794.096,767.499]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.65,775.371], [850.72,820.863], [794.097,767.527], [795.548,812.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.72,820.863], [851.699,862.462], [795.548,812.4], [796.875,853.44]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[838.011,280.76], [839.256,333.67], [845.22,280.455], [846.396,332.825]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[839.256,333.67], [840.482,385.792], [846.396,332.825], [847.556,384.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[840.482,385.792], [841.689,437.08], [847.556,384.424], [848.696,435.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[841.69,437.112], [842.878,487.617], [848.697,435.238], [849.821,485.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[842.879,487.649], [844.049,537.388], [849.821,485.282], [850.928,534.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.05,537.419], [845.203,586.411], [850.929,534.577], [852.019,583.106]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[903.928,281.226], [904.658,334.107], [845.227,280.758], [846.396,332.825]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.204,586.441], [846.339,634.701], [852.02,583.136], [853.094,630.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[904.658,334.108], [905.381,386.501], [846.396,332.825], [847.556,384.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.34,634.732], [853.095,630.979], [847.459,682.276], [854.153,678.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[905.381,386.501], [906.093,438.051], [847.556,384.424], [848.696,435.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.46,682.306], [854.154,678.119], [848.562,729.151], [855.197,724.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.563,729.181], [855.198,724.572], [849.649,775.342], [856.225,770.325]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.093,438.084], [906.794,488.843], [848.697,435.238], [849.821,485.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.65,775.371], [856.226,770.354], [850.72,820.864], [857.239,815.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.794,488.875], [907.484,538.861], [849.821,485.283], [850.928,534.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.485,538.892], [908.164,588.123], [850.929,534.577], [852.019,583.106]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.72,820.864], [857.239,815.45], [851.699,862.462], [858.166,856.691]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[908.165,588.154], [908.834,636.645], [852.02,583.137], [853.094,630.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[908.835,636.676], [909.494,684.445], [853.095,630.979], [854.153,678.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.494,684.475], [910.144,731.538], [854.154,678.119], [855.197,724.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.144,731.568], [910.784,777.941], [855.198,724.572], [856.225,770.325]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.785,777.97], [911.416,823.667], [856.226,770.354], [857.239,815.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.416,823.667], [911.992,865.45], [857.239,815.45], [858.166,856.691]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[904.195,280.923], [904.927,334.119], [917.887,280.245], [918.498,332.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[904.658,334.108], [905.381,386.501], [918.498,332.244], [919.1,383.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[905.648,386.52], [906.358,438.077], [919.1,383.483], [919.692,433.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.358,438.109], [907.057,488.875], [919.692,433.947], [920.275,483.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.057,488.907], [907.746,538.9], [920.276,483.654], [920.85,532.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.746,538.931], [908.424,588.168], [920.851,532.619], [921.417,580.831]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[908.424,588.199], [909.092,636.696], [921.417,580.861], [921.975,628.364]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.092,636.727], [909.749,684.502], [921.975,628.394], [922.525,675.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.75,684.532], [910.398,731.601], [922.525,675.234], [923.067,721.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.398,731.631], [911.036,778.009], [923.067,721.397], [923.601,766.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.037,778.038], [911.666,823.741], [923.601,766.897], [924.127,811.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.666,823.741], [912.241,865.529], [924.127,811.719], [924.609,852.715]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.832,280.621], [967.07,333.285], [917.888,280.245], [918.498,332.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.07,333.286], [967.304,385.169], [918.498,332.244], [919.1,383.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.304,385.169], [967.535,436.227], [919.1,383.483], [919.692,433.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.535,436.259], [967.762,486.54], [919.693,433.947], [920.276,483.622]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.763,486.572], [967.986,536.094], [920.276,483.654], [920.851,532.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.986,536.125], [968.207,584.906], [920.851,532.619], [921.417,580.831]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.207,584.937], [968.424,632.993], [921.417,580.861], [921.975,628.364]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.424,633.023], [968.638,680.37], [921.975,628.394], [922.525,675.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.638,680.4], [968.849,727.054], [922.525,675.235], [923.067,721.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.849,727.083], [969.057,773.059], [923.067,721.397], [923.601,766.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[969.057,773.088], [923.602,766.897], [969.261,818.4], [924.128,811.719]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[969.261,818.4], [924.128,811.719], [969.449,859.836], [924.609,852.715]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.832,280.621], [967.07,333.285], [1003.47,278.617], [1003.42,327.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.07,333.286], [967.304,385.169], [1003.42,327.738], [1003.38,376.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.304,385.17], [967.535,436.227], [1003.38,376.183], [1003.34,423.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.535,436.259], [967.762,486.54], [1003.34,423.934], [1003.29,470.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.762,486.572], [967.986,536.094], [1003.29,471.008], [1003.25,517.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.986,536.125], [968.206,584.907], [1003.25,517.418], [1003.21,563.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.207,584.937], [968.424,632.993], [1003.21,563.179], [1003.17,608.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.424,633.023], [968.638,680.371], [1003.17,608.304], [1003.13,652.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.638,680.4], [968.849,727.054], [1003.13,652.805], [1003.09,696.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.849,727.083], [969.056,773.059], [1003.09,696.697], [1003.06,739.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[969.057,773.088], [969.261,818.4], [1003.06,739.991], [1003.02,782.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[969.261,818.4], [969.448,859.836], [1003.02,782.672], [1002.98,821.738]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1023.48,278.759], [1023.29,328.132], [1003.47,278.617], [1003.42,327.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1023.29,328.132], [1023.11,376.82], [1003.42,327.738], [1003.38,376.183]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1023.11,376.821], [1022.92,424.779], [1003.38,376.183], [1003.34,423.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.92,424.809], [1022.74,472.084], [1003.34,423.934], [1003.29,470.979]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.74,472.114], [1003.29,471.008], [1022.56,518.719], [1003.25,517.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.56,518.748], [1003.25,517.418], [1022.39,564.697], [1003.21,563.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.38,564.726], [1003.21,563.179], [1022.21,610.034], [1003.17,608.275]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.21,610.062], [1003.17,608.304], [1022.04,654.741], [1003.13,652.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.04,654.769], [1003.13,652.805], [1021.87,698.833], [1003.09,696.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.87,698.861], [1003.09,696.697], [1021.7,742.321], [1003.06,739.964]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.7,742.349], [1003.06,739.991], [1021.54,785.219], [1003.02,782.673]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.54,785.219], [1003.02,782.673], [1021.39,824.454], [1002.98,821.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.54,785.219], [1021.39,824.454], [1037.67,767.409], [1037.42,805.452]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.56,518.748], [1022.39,564.698], [1039.32,509.459], [1039.03,553.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.38,564.726], [1022.21,610.034], [1039.03,553.915], [1038.75,597.743]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.21,610.062], [1022.04,654.741], [1038.75,597.771], [1038.48,641.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.04,654.769], [1021.87,698.833], [1038.48,641.04], [1038.2,683.706]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.87,698.861], [1021.7,742.321], [1038.2,683.732], [1037.93,725.834]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1021.7,742.349], [1021.54,785.219], [1037.93,725.86], [1037.67,767.409]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1023.48,278.76], [1023.29,328.132], [1040.8,277.768], [1040.49,325.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1023.29,328.132], [1023.11,376.82], [1040.49,325.385], [1040.19,372.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1023.11,376.821], [1022.92,424.779], [1040.19,372.367], [1039.9,418.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.92,424.81], [1022.74,472.084], [1039.9,418.698], [1039.61,464.362]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1022.74,472.114], [1022.56,518.719], [1039.61,464.391], [1039.32,509.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.5,767.848], [1054.16,805.92], [1069.41,750.764], [1068.98,787.685]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.65,641.378], [1055.26,684.078], [1070.8,628.225], [1070.33,669.58]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.26,684.105], [1054.88,726.24], [1070.33,669.606], [1069.87,710.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.88,726.267], [1054.5,767.848], [1069.87,710.458], [1069.41,750.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.85,509.688], [1056.44,554.153], [1072.26,500.801], [1071.77,543.806]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.44,554.181], [1056.04,598.046], [1071.77,543.833], [1071.28,586.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.04,598.074], [1055.65,641.351], [1071.28,586.304], [1070.8,628.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.67,418.848], [1057.26,464.552], [1073.26,413.007], [1072.76,457.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.26,464.581], [1056.85,509.659], [1072.76,457.196], [1072.26,500.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.52,325.452], [1058.09,372.477], [1074.29,322.83], [1073.77,368.222]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.09,372.477], [1057.67,418.819], [1073.77,368.222], [1073.26,412.979]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1058.95,277.792], [1058.52,325.452], [1074.81,276.846], [1074.29,322.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.34,748.597], [1052.02,785.371], [1077.88,720.55], [1077.43,755.416]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.05,667.767], [1052.69,708.426], [1078.85,643.994], [1078.36,682.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.69,708.452], [1052.34,748.597], [1078.36,682.514], [1077.88,720.55]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1056.45,276.726], [1056.05,322.498], [1083.53,275.184], [1082.98,318.221]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.14,542.522], [1053.77,584.786], [1080.35,525.589], [1079.85,565.515]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.77,584.813], [1053.41,626.531], [1079.84,565.54], [1079.34,604.981]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1053.41,626.557], [1053.05,667.741], [1079.34,605.006], [1078.85,643.97]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.89,456.261], [1054.51,499.648], [1081.39,444.193], [1080.87,485.117]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1054.51,499.675], [1054.14,542.495], [1080.87,485.143], [1080.35,525.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.66,367.684], [1055.27,412.239], [1082.44,360.741], [1081.91,402.702]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1055.27,412.267], [1054.89,456.233], [1081.91,402.729], [1081.39,444.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1056.05,322.498], [1055.66,367.684], [1082.98,318.221], [1082.45,360.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.3,655.715], [1077.85,691.551], [1085.61,648.786], [1085.13,684.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.85,691.552], [1077.43,724.424], [1085.13,684.05], [1084.68,716.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.22,582.772], [1078.76,619.427], [1086.6,577.029], [1086.1,613.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.76,619.45], [1078.3,655.693], [1086.1,613.107], [1085.61,648.764]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1083.13,273.603], [1082.62,313.833], [1053.35,273.434], [1053.02,313.363]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.16,508.147], [1079.69,545.65], [1087.61,503.645], [1087.1,540.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.69,545.673], [1079.22,582.749], [1087.1,540.544], [1086.6,577.006]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.13,431.781], [1080.64,470.161], [1088.64,428.581], [1088.12,466.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.64,470.185], [1080.16,508.123], [1088.12,466.327], [1087.61,503.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.12,353.612], [1081.62,392.901], [1089.7,351.776], [1089.17,390.375]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.62,392.926], [1081.13,431.756], [1089.17,390.4], [1088.64,428.557]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1083.13,273.603], [1082.62,313.833], [1090.78,273.196], [1090.24,312.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.62,313.833], [1082.12,353.612], [1090.24,312.703], [1089.7,351.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.23,651.064], [1085.61,648.786], [1107.62,686.516], [1085.13,684.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.62,686.516], [1085.13,684.05], [1107.06,719.041], [1084.68,716.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.48,578.916], [1086.6,577.029], [1108.85,615.169], [1086.1,613.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.85,615.192], [1086.1,613.107], [1108.23,651.042], [1085.61,648.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.76,505.125], [1087.61,503.645], [1110.12,542.206], [1087.1,540.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.12,542.23], [1087.1,540.544], [1109.48,578.893], [1086.6,577.006]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.06,429.632], [1111.41,467.571], [1088.64,428.581], [1088.12,466.303]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.41,467.595], [1110.76,505.101], [1088.12,466.327], [1087.61,503.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.4,352.38], [1112.73,391.205], [1089.7,351.776], [1089.17,390.376]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.73,391.23], [1112.06,429.608], [1089.17,390.4], [1088.64,428.557]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1114.77,273.33], [1114.08,313.074], [1090.78,273.196], [1090.24,312.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.08,313.074], [1113.4,352.38], [1090.24,312.703], [1089.7,351.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.62,686.516], [1107.06,719.041], [1127.13,665.151], [1126.5,696.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.85,615.192], [1108.23,651.042], [1128.51,597.137], [1127.82,631.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.23,651.064], [1107.62,686.516], [1127.82,631.335], [1127.13,665.151]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.48,578.916], [1108.85,615.169], [1129.21,562.573], [1128.51,597.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.76,505.125], [1110.12,542.206], [1130.64,492.324], [1129.92,527.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.12,542.23], [1109.48,578.893], [1129.92,527.638], [1129.21,562.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.06,429.632], [1111.41,467.571], [1132.1,420.539], [1131.36,456.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.41,467.595], [1110.76,505.101], [1131.36,456.627], [1130.64,492.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.73,391.23], [1112.06,429.608], [1132.84,384.054], [1132.1,420.516]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.08,313.074], [1113.4,352.38], [1134.34,309.867], [1133.58,347.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.4,352.38], [1112.73,391.205], [1133.58,347.166], [1132.84,384.031]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1114.77,273.33], [1114.08,313.074], [1135.11,272.176], [1134.34,309.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.43,632.727], [1127.82,631.335], [1141.67,666.659], [1127.13,665.151]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1141.67,666.659], [1127.13,665.151], [1140.96,697.804], [1126.5,696.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.21,598.411], [1128.51,597.137], [1142.43,632.705], [1127.82,631.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.78,528.667], [1129.92,527.638], [1143.99,563.704], [1129.21,562.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.99,563.726], [1129.21,562.574], [1143.21,598.389], [1128.51,597.115]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.58,493.227], [1130.64,492.325], [1144.78,528.644], [1129.92,527.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.21,421.18], [1132.1,420.539], [1146.39,457.377], [1131.36,456.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.39,457.4], [1131.36,456.627], [1145.58,493.204], [1130.64,492.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.03,384.559], [1132.84,384.054], [1147.21,421.156], [1132.1,420.516]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.87,347.533], [1148.03,384.536], [1133.58,347.166], [1132.84,384.031]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1150.57,272.257], [1149.71,310.093], [1135.11,272.176], [1134.34,309.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.71,310.093], [1148.87,347.533], [1134.34,309.867], [1133.58,347.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1141.67,666.659], [1140.96,697.804], [1151.85,655.023], [1151.12,685.355]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1142.43,632.727], [1141.67,666.659], [1152.64,621.986], [1151.85,655.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.99,563.726], [1143.21,598.389], [1154.26,554.836], [1153.45,588.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1143.21,598.411], [1142.43,632.705], [1153.45,588.586], [1152.64,621.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1144.78,528.667], [1143.99,563.704], [1155.09,520.733], [1154.26,554.814]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1145.58,493.227], [1144.78,528.644], [1155.92,486.269], [1155.09,520.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1146.39,457.4], [1145.58,493.204], [1156.76,451.441], [1155.92,486.247]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.03,384.559], [1147.21,421.156], [1158.47,380.664], [1157.61,416.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1147.21,421.179], [1146.39,457.377], [1157.61,416.241], [1156.76,451.418]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1148.87,347.533], [1148.03,384.536], [1159.33,344.703], [1158.47,380.641]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1149.71,310.093], [1148.87,347.533], [1160.21,308.353], [1159.33,344.703]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1150.57,272.257], [1149.71,310.093], [1161.1,271.631], [1160.21,308.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1143.08,587.161], [1142.33,620.408], [1152.34,578.568], [1151.56,611.012]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1136.65,641.771], [1136.01,671.173], [1152.86,624.591], [1152.18,652.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.05,577.402], [1137.35,609.737], [1154.35,562.916], [1153.6,593.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1137.35,609.758], [1136.65,641.771], [1153.6,593.91], [1152.86,624.591]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1138.76,544.721], [1138.05,577.382], [1155.11,531.623], [1154.35,562.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1139.47,511.708], [1138.76,544.7], [1155.87,500.026], [1155.11,531.603]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.93,444.667], [1140.2,478.337], [1157.42,435.907], [1156.64,468.102]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1140.2,478.358], [1139.47,511.687], [1156.64,468.123], [1155.87,500.006]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1141.67,410.629], [1140.93,444.646], [1158.21,403.374], [1157.42,435.886]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1144.7,270.921], [1143.93,306.379], [1161.43,270.004], [1160.61,303.829]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1142.41,376.239], [1141.67,410.607], [1159,370.52], [1158.21,403.353]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1143.17,341.491], [1142.41,376.217], [1159.8,337.341], [1159,370.499]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1143.93,306.379], [1143.17,341.49], [1160.61,303.829], [1159.8,337.34]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[762.392,275.661], [764.137,326.87], [721.497,275.375], [723.516,325.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.138,326.869], [765.858,377.355], [723.516,325.837], [725.507,375.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[765.858,377.355], [767.552,427.069], [725.506,375.597], [727.467,424.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.553,427.101], [769.223,476.093], [727.469,424.639], [729.401,472.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.224,476.123], [770.87,524.409], [729.403,472.979], [731.308,520.601]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.871,524.439], [772.493,572.032], [731.309,520.631], [733.188,567.58]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.494,572.062], [774.093,618.978], [733.189,567.609], [735.041,613.9]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.094,619.008], [775.67,665.261], [735.042,613.929], [736.868,659.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.671,665.29], [777.225,710.895], [736.87,659.604], [738.671,704.618]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.226,710.924], [778.759,755.893], [738.672,704.646], [740.448,749.042]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.76,755.922], [780.271,800.269], [740.449,749.07], [742.201,792.861]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[798.169,276.52], [799.714,329.969], [741.789,276.114], [743.731,328.502]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.271,800.269], [781.654,840.847], [742.201,792.861], [743.805,832.936]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.714,329.969], [801.235,382.628], [743.731,328.502], [745.645,380.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.235,382.628], [802.733,434.45], [745.645,380.133], [747.529,430.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.734,434.483], [804.209,485.519], [747.53,430.991], [749.386,481.061]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.21,485.551], [805.662,535.82], [749.387,481.093], [751.216,530.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.663,535.852], [807.094,585.37], [751.217,530.455], [753.019,579.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.095,585.401], [808.505,634.185], [753.021,579.095], [754.796,626.997]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.506,634.216], [809.895,682.282], [754.797,627.027], [756.548,674.238]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.896,682.312], [811.264,729.677], [756.549,674.267], [758.274,720.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.265,729.706], [812.614,776.384], [758.275,720.83], [759.975,766.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.615,776.413], [813.945,822.419], [759.976,766.731], [761.653,811.955]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.945,822.419], [815.16,864.491], [761.653,811.955], [763.187,853.323]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[798.169,276.521], [799.714,329.969], [807.031,276.317], [808.492,329.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[799.714,329.969], [801.236,382.628], [808.492,329.234], [809.932,381.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[801.236,382.628], [802.733,434.45], [809.932,381.378], [811.349,432.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[802.734,434.483], [804.209,485.519], [811.35,432.734], [812.746,483.287]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[804.21,485.551], [805.662,535.82], [812.747,483.318], [814.122,533.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[805.663,535.852], [807.094,585.37], [814.123,533.149], [815.477,582.212]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[863.031,277.028], [864.076,330.671], [807.04,276.623], [808.492,329.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[807.095,585.401], [815.478,582.243], [808.505,634.185], [816.813,630.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.076,330.671], [865.112,383.823], [808.492,329.234], [809.932,381.378]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.506,634.216], [816.814,630.616], [809.895,682.282], [818.129,678.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.112,383.823], [866.132,436.121], [809.932,381.378], [811.349,432.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[809.896,682.312], [818.13,678.284], [811.264,729.677], [819.426,725.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[866.132,436.154], [867.136,487.653], [811.35,432.734], [812.746,483.286]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.265,729.706], [819.427,725.263], [812.614,776.384], [820.705,771.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.615,776.413], [820.706,771.566], [813.944,822.419], [821.965,817.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[867.137,487.686], [868.125,538.402], [812.747,483.318], [814.122,533.118]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[868.126,538.434], [869.1,588.387], [814.123,533.149], [815.477,582.212]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.944,822.419], [821.965,817.181], [815.16,864.491], [823.117,858.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.101,588.418], [870.06,637.623], [815.478,582.243], [816.813,630.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.06,637.655], [871.005,686.129], [816.814,630.616], [818.129,678.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.006,686.16], [871.937,733.92], [818.13,678.284], [819.426,725.233]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.937,733.951], [872.855,781.012], [819.427,725.263], [820.705,771.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.855,781.042], [873.759,827.42], [820.706,771.566], [821.965,817.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.759,827.42], [874.586,869.828], [821.965,817.181], [823.117,858.901]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[863.273,276.719], [864.323,330.683], [880.758,276.262], [881.651,329.035]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[864.076,330.671], [865.112,383.823], [881.652,329.035], [882.531,381.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[865.357,383.843], [866.375,436.15], [882.531,381.039], [883.397,432.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[866.375,436.182], [867.377,487.689], [883.398,432.258], [884.251,482.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[867.378,487.721], [868.365,538.446], [884.251,482.711], [885.092,532.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[868.366,538.477], [869.338,588.437], [885.092,532.414], [885.921,581.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[869.338,588.469], [870.296,637.681], [885.921,581.384], [886.737,629.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[870.296,637.712], [871.24,686.194], [886.737,629.637], [887.542,677.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[871.24,686.224], [872.17,733.992], [887.542,677.189], [888.335,724.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[872.17,734.021], [873.086,781.09], [888.335,724.054], [889.116,770.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.087,781.119], [873.989,827.504], [889.117,770.248], [889.887,815.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[873.989,827.504], [874.815,869.918], [889.887,815.756], [890.591,857.38]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[927.92,276.588], [928.461,330.211], [880.759,276.261], [881.652,329.034]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.461,330.211], [928.993,383.04], [881.652,329.035], [882.532,381.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.993,383.04], [929.517,435.026], [882.531,381.039], [883.398,432.226]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.518,435.059], [930.034,486.255], [883.398,432.258], [884.251,482.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.034,486.287], [930.542,536.71], [884.252,482.711], [885.092,532.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.543,536.742], [931.044,586.41], [885.093,532.414], [885.921,581.354]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.044,586.441], [931.537,635.371], [885.921,581.384], [886.737,629.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.537,635.401], [932.023,683.609], [886.738,629.637], [887.542,677.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.024,683.639], [932.503,731.14], [887.542,677.189], [888.335,724.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.503,731.17], [932.975,777.98], [888.335,724.054], [889.117,770.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.975,778.01], [933.44,824.144], [889.117,770.248], [889.887,815.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[933.44,824.144], [933.866,866.332], [889.887,815.756], [890.591,857.38]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[927.92,276.588], [928.46,330.211], [976.053,275.224], [976.208,325.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.461,330.211], [928.993,383.04], [976.208,325.295], [976.362,374.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[928.993,383.04], [929.517,435.026], [976.361,374.674], [976.512,423.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[929.517,435.059], [930.033,486.255], [976.513,423.346], [976.661,471.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.034,486.287], [930.542,536.711], [976.661,471.326], [976.808,518.599]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[930.542,536.742], [931.043,586.41], [976.808,518.629], [976.953,565.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.044,586.441], [931.537,635.371], [976.953,565.268], [977.095,611.229]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[931.537,635.401], [932.023,683.609], [977.095,611.258], [977.236,656.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.023,683.639], [932.502,731.14], [977.236,656.613], [977.375,701.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.503,731.17], [932.975,777.98], [977.375,701.344], [977.511,745.438]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[932.975,778.01], [933.44,824.144], [977.511,745.466], [977.646,788.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[933.44,824.144], [933.865,866.332], [977.646,788.963], [977.77,828.773]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[995.585,275.349], [995.599,325.742], [976.053,275.225], [976.208,325.295]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.599,325.743], [995.612,375.436], [976.208,325.295], [976.362,374.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.612,375.436], [995.625,424.383], [976.361,374.674], [976.512,423.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.625,424.414], [995.638,472.66], [976.512,423.346], [976.661,471.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.638,472.69], [995.651,520.251], [976.661,471.326], [976.808,518.599]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.651,520.281], [976.808,518.629], [995.663,567.171], [976.952,565.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.663,567.201], [976.952,565.268], [995.676,613.434], [977.095,611.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.676,613.463], [977.095,611.258], [995.688,659.053], [977.236,656.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.688,659.081], [977.236,656.613], [995.7,704.042], [977.374,701.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.7,704.07], [977.374,701.344], [995.712,748.413], [977.511,745.438]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.712,748.441], [977.511,745.466], [995.724,792.18], [977.646,788.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.724,792.18], [977.646,788.963], [995.735,832.209], [977.769,828.773]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[995.585,275.349], [995.599,325.743], [1018.66,274.672], [1018.51,323.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.599,325.743], [995.612,375.436], [1018.51,323.297], [1018.36,371.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.612,375.436], [995.625,424.383], [1018.36,371.272], [1018.22,418.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.625,424.414], [995.638,472.66], [1018.22,418.58], [1018.08,465.205]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.638,472.69], [995.651,520.251], [1018.08,465.234], [1017.93,511.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.651,520.281], [995.663,567.171], [1017.93,511.248], [1017.79,556.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.663,567.201], [995.676,613.434], [1017.79,556.635], [1017.66,601.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.676,613.463], [995.688,659.053], [1017.66,601.408], [1017.52,645.551]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.688,659.082], [995.7,704.042], [1017.52,645.578], [1017.39,689.132]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.7,704.07], [995.712,748.413], [1017.39,689.159], [1017.25,732.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.712,748.441], [995.724,792.18], [1017.25,732.162], [1017.12,774.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[995.724,792.18], [995.735,832.209], [1017.12,774.571], [1017,813.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.65,690.006], [1034.4,733.059], [1054.89,675.67], [1054.52,717.402]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.4,733.086], [1034.16,775.571], [1054.52,717.428], [1054.15,758.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.16,775.571], [1033.93,814.468], [1054.15,758.627], [1053.82,796.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.67,511.761], [1035.41,557.206], [1056.41,503.091], [1056.02,547.062]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.41,557.235], [1035.15,602.064], [1056.02,547.09], [1055.64,590.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.15,602.092], [1034.9,646.317], [1055.64,590.512], [1055.26,633.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1034.9,646.345], [1034.65,689.978], [1055.26,633.368], [1054.89,675.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.75,323.436], [1036.48,371.508], [1058.02,321.093], [1057.61,367.518]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.48,371.508], [1036.2,418.881], [1057.61,367.518], [1057.21,413.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1036.2,418.911], [1035.93,465.628], [1057.21,413.317], [1056.81,458.476]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1035.93,465.657], [1035.67,511.732], [1056.81,458.504], [1056.41,503.063]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1037.03,274.71], [1036.75,323.436], [1058.44,274.061], [1058.02,321.093]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1040.34,273.956], [1040.05,320.714], [1076.47,272.9], [1075.97,316.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.6,714.886], [1037.34,755.876], [1071.7,689.223], [1071.26,728.086]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.34,755.876], [1037.11,793.422], [1071.26,728.086], [1070.85,763.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.38,588.634], [1038.12,631.236], [1073.07,569.691], [1072.61,609.996]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.12,631.263], [1037.86,673.317], [1072.61,610.022], [1072.15,649.838]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1037.86,673.344], [1037.6,714.86], [1072.15,649.863], [1071.7,689.198]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.93,501.686], [1038.65,545.417], [1074.01,487.524], [1073.54,528.836]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1038.65,545.445], [1038.39,588.606], [1073.54,528.862], [1073.07,569.665]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.76,366.871], [1039.48,412.382], [1075.47,360.366], [1074.98,403.259]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.48,412.411], [1039.2,457.317], [1074.98,403.286], [1074.49,445.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1039.2,457.345], [1038.93,501.658], [1074.49,445.669], [1074.01,487.498]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1040.05,320.714], [1039.76,366.871], [1075.96,316.898], [1075.47,360.366]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.31,698.565], [1051.7,694.619], [1078.89,732.124], [1051.42,727.9]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.72,587.507], [1080.24,624.932], [1052.62,584.501], [1052.31,621.605]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.24,624.956], [1079.78,661.957], [1052.31,621.629], [1052,658.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.78,661.98], [1052,658.34], [1079.31,698.565], [1051.7,694.619]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1084.71,271.788], [1084.19,312.876], [1055.24,271.64], [1054.9,312.341]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.68,511.311], [1081.2,549.604], [1053.26,508.97], [1052.94,546.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.2,549.629], [1080.72,587.484], [1052.94,546.951], [1052.62,584.478]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.67,433.331], [1082.17,472.523], [1053.9,431.687], [1053.58,470.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.17,472.548], [1081.68,511.287], [1053.58,470.551], [1053.26,508.946]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.68,353.503], [1083.17,393.627], [1054.57,352.589], [1054.23,392.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.17,393.652], [1082.67,433.306], [1054.23,392.369], [1053.9,431.662]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.19,312.876], [1083.68,353.503], [1054.9,312.341], [1054.56,352.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.78,661.98], [1079.31,698.565], [1089.35,655.128], [1088.85,691.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.31,698.565], [1078.89,732.124], [1088.85,691.137], [1088.38,724.173]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.72,587.507], [1080.24,624.932], [1090.39,581.85], [1089.87,618.671]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.24,624.956], [1079.78,661.957], [1089.87,618.694], [1089.36,655.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.68,511.311], [1081.2,549.604], [1091.45,506.906], [1090.91,544.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.2,549.629], [1080.72,587.484], [1090.91,544.59], [1090.39,581.827]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.67,433.331], [1082.17,472.523], [1092.53,430.237], [1091.98,468.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.17,472.548], [1081.68,511.287], [1091.98,468.791], [1091.45,506.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.68,353.503], [1083.17,393.627], [1093.63,351.784], [1093.08,391.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.17,393.652], [1082.67,433.306], [1093.08,391.238], [1092.53,430.212]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1084.71,271.788], [1084.19,312.876], [1094.77,271.51], [1094.2,311.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.19,312.876], [1083.68,353.503], [1094.2,311.869], [1093.63,351.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.2,694.269], [1088.85,691.137], [1110.62,727.526], [1088.38,724.173]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.49,621.334], [1089.87,618.694], [1111.84,657.994], [1089.36,655.105]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.84,658.017], [1089.35,655.128], [1111.2,694.269], [1088.85,691.137]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.8,546.714], [1090.91,544.59], [1113.14,584.212], [1090.39,581.827]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.14,584.235], [1090.39,581.85], [1112.49,621.311], [1089.87,618.671]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.14,470.374], [1114.46,508.739], [1091.98,468.791], [1091.45,506.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.46,508.763], [1113.8,546.69], [1091.45,506.906], [1090.91,544.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.82,431.541], [1115.14,470.35], [1092.53,430.237], [1091.98,468.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.21,352.509], [1116.51,392.23], [1093.63,351.784], [1093.08,391.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.51,392.255], [1115.82,431.516], [1093.08,391.237], [1092.53,430.213]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1118.63,271.627], [1117.91,312.294], [1094.77,271.51], [1094.2,311.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.91,312.293], [1117.21,352.509], [1094.2,311.869], [1093.63,351.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.84,658.017], [1111.2,694.269], [1137.93,638.433], [1137.18,673.031]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.2,694.269], [1110.62,727.526], [1137.18,673.031], [1136.5,704.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.49,621.334], [1111.84,657.994], [1138.68,603.442], [1137.93,638.411]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.8,546.714], [1113.14,584.212], [1140.21,532.325], [1139.44,568.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.14,584.235], [1112.49,621.311], [1139.44,568.075], [1138.68,603.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.46,508.763], [1113.8,546.69], [1140.99,496.185], [1140.21,532.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.82,431.541], [1115.14,470.35], [1142.57,422.714], [1141.77,459.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.14,470.374], [1114.46,508.739], [1141.77,459.651], [1140.99,496.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.51,392.255], [1115.82,431.516], [1143.37,385.368], [1142.57,422.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.91,312.293], [1117.21,352.509], [1145,309.423], [1144.18,347.607]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.21,352.509], [1116.51,392.23], [1144.18,347.607], [1143.37,385.344]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1118.63,271.627], [1117.91,312.293], [1145.83,270.834], [1145,309.423]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.55,640.205], [1137.93,638.433], [1151.72,674.953], [1137.18,673.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.72,674.953], [1137.18,673.031], [1150.97,706.845], [1136.5,704.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.38,605.061], [1138.68,603.442], [1152.55,640.182], [1137.93,638.41]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1154.23,569.536], [1139.44,568.075], [1153.38,605.038], [1138.68,603.42]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.94,497.322], [1140.99,496.185], [1155.08,533.603], [1140.21,532.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.08,533.626], [1140.21,532.325], [1154.23,569.514], [1139.44,568.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.81,460.62], [1141.77,459.651], [1155.94,497.299], [1140.99,496.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.7,423.511], [1156.81,460.596], [1142.57,422.714], [1141.77,459.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1159.49,348.049], [1158.59,385.966], [1144.18,347.607], [1143.37,385.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1158.59,385.99], [1157.7,423.487], [1143.37,385.368], [1142.57,422.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.4,309.682], [1159.49,348.049], [1145,309.423], [1144.18,347.607]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1161.32,270.906], [1160.4,309.682], [1145.83,270.834], [1145,309.423]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1151.72,674.953], [1150.97,706.845], [1165.45,663.353], [1164.64,694.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1152.55,640.205], [1151.72,674.953], [1166.32,629.512], [1165.45,663.353]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1153.38,605.061], [1152.55,640.182], [1167.2,595.296], [1166.32,629.491]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.08,533.626], [1154.23,569.514], [1169,525.779], [1168.1,560.698]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1154.23,569.536], [1153.38,605.038], [1168.1,560.72], [1167.2,595.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1155.94,497.322], [1155.08,533.603], [1169.91,490.466], [1169,525.756]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1156.81,460.62], [1155.94,497.299], [1170.83,454.776], [1169.91,490.443]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1157.7,423.511], [1156.81,460.596], [1171.76,418.703], [1170.83,454.753]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1158.59,385.99], [1157.7,423.487], [1172.7,382.24], [1171.76,418.679]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1159.49,348.049], [1158.59,385.966], [1173.65,345.381], [1172.7,382.217]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1160.4,309.682], [1159.49,348.049], [1174.62,308.12], [1173.65,345.381]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1161.32,270.906], [1160.4,309.682], [1175.59,270.474], [1174.62,308.12]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.34,661.369], [1154.59,692.295], [1167.65,651.225], [1166.86,681.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.16,627.684], [1155.34,661.369], [1168.51,618.336], [1167.65,651.225]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.98,593.626], [1156.16,627.662], [1169.38,585.093], [1168.51,618.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1153.46,649.464], [1152.74,679.541], [1174.92,632.369], [1174.14,661.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.66,524.437], [1157.82,559.191], [1171.14,517.584], [1170.26,551.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.82,559.213], [1156.99,593.604], [1170.26,551.511], [1169.38,585.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1154.25,616.714], [1153.46,649.464], [1175.77,600.967], [1174.92,632.368]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.51,489.294], [1158.66,524.415], [1172.04,483.308], [1171.14,517.562]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.04,583.612], [1154.25,616.693], [1176.63,569.242], [1175.77,600.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.38,453.777], [1159.52,489.271], [1172.94,448.677], [1172.04,483.286]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1155.84,550.174], [1155.04,583.591], [1177.5,537.209], [1176.64,569.222]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.25,417.881], [1160.38,453.755], [1173.85,413.686], [1172.94,448.655]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1156.65,516.395], [1155.84,550.153], [1178.38,504.864], [1177.5,537.189]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1162.13,381.599], [1161.25,417.858], [1174.78,378.329], [1173.85,413.664]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1158.29,447.793], [1157.46,482.248], [1180.16,439.219], [1179.27,472.181]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1157.46,482.27], [1156.65,516.374], [1179.27,472.202], [1178.38,504.844]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.02,344.926], [1162.13,381.576], [1175.71,342.6], [1174.78,378.306]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.12,412.959], [1158.29,447.771], [1181.07,405.909], [1180.16,439.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1163.92,307.853], [1163.02,344.925], [1176.65,306.492], [1175.71,342.599]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1159.96,377.762], [1159.12,412.936], [1181.98,372.268], [1181.07,405.888]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1162.54,269.96], [1161.67,306.257], [1184.77,269.33], [1183.83,303.972]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1164.82,270.401], [1163.92,307.854], [1177.6,270.025], [1176.65,306.492]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1160.81,342.196], [1159.96,377.739], [1182.9,338.291], [1181.98,372.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1161.67,306.256], [1160.81,342.196], [1183.83,303.972], [1182.9,338.291]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[730.701,271.383], [732.654,322.946], [692.829,271.222], [695.02,321.891]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.655,322.946], [734.58,373.792], [695.02,321.891], [697.181,371.867]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.579,373.792], [736.476,423.872], [697.181,371.867], [699.31,421.104]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.477,423.904], [738.346,473.266], [699.312,421.135], [701.411,469.677]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.348,473.297], [740.19,521.957], [701.412,469.708], [703.482,517.571]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.191,521.987], [742.008,569.959], [703.483,517.601], [705.524,564.799]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.009,569.989], [743.8,617.288], [705.526,564.829], [707.538,611.376]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[759.055,271.818], [760.882,325.803], [706.728,271.588], [708.904,324.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.801,617.318], [745.568,663.958], [707.54,611.405], [709.525,657.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.882,325.803], [762.682,379], [708.904,324.296], [711.048,376.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.569,663.987], [747.31,709.981], [709.526,657.343], [711.484,702.627]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.682,379], [764.454,431.36], [711.048,376.254], [713.159,427.413]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.311,710.01], [749.029,755.372], [711.486,702.656], [713.417,747.328]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.456,431.393], [766.201,482.968], [713.161,427.445], [715.241,477.855]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.03,755.401], [750.725,800.144], [713.419,747.356], [715.325,791.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.202,483.001], [767.922,533.808], [715.243,477.887], [717.293,527.563]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.725,800.144], [752.275,841.091], [715.325,791.428], [717.069,831.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.923,533.84], [769.617,583.897], [717.294,527.595], [719.315,576.554]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.618,583.929], [771.287,633.252], [719.316,576.585], [721.308,624.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.288,633.283], [772.933,681.888], [721.309,624.873], [723.273,672.444]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.935,681.919], [774.556,729.821], [723.274,672.474], [725.21,719.373]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.557,729.851], [776.155,777.067], [725.211,719.403], [727.119,765.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.156,777.096], [777.731,823.639], [727.12,765.673], [729.002,811.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.731,823.639], [779.172,866.208], [729.002,811.27], [730.724,852.987]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[759.055,271.818], [760.882,325.803], [769.494,271.725], [771.225,325.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.882,325.803], [762.682,379], [771.225,325.192], [772.93,377.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.682,379], [764.454,431.36], [772.93,377.887], [774.609,429.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.455,431.393], [766.201,482.968], [774.61,429.793], [776.263,480.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.202,483.001], [767.922,533.808], [776.265,480.928], [777.894,531.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.923,533.84], [769.617,583.898], [777.895,531.309], [779.501,580.922]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[821.979,272.269], [823.335,326.681], [769.504,272.034], [771.225,325.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.618,583.929], [779.502,580.953], [771.287,633.252], [781.084,629.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.335,326.681], [824.678,380.6], [771.225,325.192], [772.93,377.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[771.288,633.283], [781.085,629.875], [772.933,681.888], [782.644,678.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.678,380.6], [826,433.659], [772.93,377.887], [774.609,429.76]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.934,681.919], [782.645,678.092], [774.556,729.821], [784.182,725.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.001,433.693], [827.303,485.946], [774.61,429.793], [776.263,480.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[774.557,729.852], [784.183,725.618], [776.155,777.067], [785.699,772.44]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.303,485.979], [828.586,537.444], [776.265,480.928], [777.894,531.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[776.156,777.096], [785.699,772.469], [777.731,823.639], [787.193,818.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.731,823.639], [787.193,818.629], [779.172,866.209], [788.56,860.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.586,537.477], [829.849,588.171], [777.895,531.309], [779.501,580.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[829.85,588.203], [831.094,638.145], [779.502,580.953], [781.084,629.845]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.095,638.176], [832.321,687.381], [781.085,629.876], [782.644,678.062]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.322,687.412], [833.53,735.897], [782.645,678.092], [784.182,725.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.53,735.928], [834.721,783.708], [784.183,725.619], [785.699,772.44]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[834.721,783.738], [835.895,830.829], [785.699,772.469], [787.193,818.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[835.895,830.829], [836.967,873.892], [787.193,818.629], [788.56,860.854]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[822.193,271.954], [823.555,326.692], [843.381,271.743], [844.552,325.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.335,326.681], [824.678,380.6], [844.553,325.307], [845.707,378.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.897,380.62], [826.217,433.689], [845.707,378.095], [846.844,430.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[826.218,433.722], [827.518,485.984], [846.844,430.093], [847.964,481.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[827.519,486.017], [828.8,537.491], [847.965,481.316], [849.068,531.752]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[828.8,537.523], [830.062,588.227], [849.069,531.783], [850.156,581.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[830.063,588.259], [831.306,638.208], [850.156,581.511], [851.227,630.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[831.306,638.24], [832.531,687.453], [851.228,630.514], [852.284,678.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[832.532,687.484], [833.738,735.976], [852.284,678.809], [853.325,726.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[833.739,736.006], [834.928,783.794], [853.326,726.412], [854.351,773.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[834.929,783.824], [836.101,830.922], [854.352,773.336], [855.363,819.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[836.101,830.922], [837.172,873.991], [855.363,819.568], [856.288,861.857]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[888.078,271.93], [888.925,326.536], [843.381,271.742], [844.553,325.306]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[888.925,326.536], [889.761,380.335], [844.553,325.307], [845.708,378.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[889.761,380.335], [890.583,433.279], [845.707,378.095], [846.844,430.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.583,433.312], [891.393,485.454], [846.845,430.093], [847.964,481.284]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.393,485.486], [892.191,536.843], [847.965,481.316], [849.068,531.752]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.191,536.875], [892.977,587.465], [849.069,531.783], [850.156,581.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.977,587.497], [893.751,637.336], [850.157,581.511], [851.228,630.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.752,637.367], [894.514,686.473], [851.229,630.514], [852.284,678.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.515,686.504], [895.266,734.893], [852.285,678.809], [853.325,726.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.266,734.923], [896.007,782.61], [853.326,726.412], [854.352,773.307]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.007,782.64], [896.737,829.641], [854.352,773.336], [855.364,819.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.737,829.641], [897.405,872.622], [855.364,819.568], [856.289,861.857]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[888.077,271.93], [888.925,326.535], [947.668,271.294], [948.029,322.366]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[888.925,326.536], [889.761,380.335], [948.029,322.366], [948.385,372.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[889.76,380.335], [890.582,433.279], [948.384,372.734], [948.735,422.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[890.583,433.312], [891.393,485.454], [948.735,422.382], [949.081,471.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[891.393,485.486], [892.191,536.843], [949.081,471.325], [949.422,519.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.191,536.875], [892.977,587.465], [949.422,519.577], [949.758,567.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[892.977,587.497], [893.751,637.336], [949.758,567.154], [950.09,614.04]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[893.751,637.367], [894.514,686.473], [950.09,614.07], [950.417,660.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[894.514,686.504], [895.266,734.893], [950.417,660.337], [950.739,705.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[895.266,734.923], [896.007,782.61], [950.739,705.97], [951.057,750.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.007,782.64], [896.737,829.641], [951.057,750.982], [951.371,795.356]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[896.737,829.641], [897.404,872.622], [951.371,795.356], [951.658,835.971]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.468,271.366], [966.695,322.838], [947.667,271.294], [948.028,322.366]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.695,322.838], [966.918,373.594], [948.029,322.366], [948.385,372.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.918,373.594], [967.138,423.588], [948.384,372.734], [948.735,422.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.138,423.619], [967.354,472.897], [948.735,422.382], [949.081,471.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.355,472.928], [967.568,521.507], [949.081,471.325], [949.422,519.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.568,521.537], [967.779,569.43], [949.422,519.577], [949.758,567.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.779,569.46], [949.758,567.154], [967.987,616.681], [950.089,614.04]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.987,616.711], [950.089,614.07], [968.192,663.276], [950.416,660.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.192,663.305], [950.417,660.337], [968.394,709.227], [950.739,705.942]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.394,709.255], [950.739,705.97], [968.593,754.547], [951.057,750.954]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.593,754.575], [951.057,750.982], [968.79,799.25], [951.371,795.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.79,799.25], [951.371,795.357], [968.969,840.135], [951.657,835.971]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[966.468,271.367], [966.695,322.838], [995.36,271.049], [995.375,320.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.695,322.838], [966.918,373.594], [995.375,320.753], [995.39,369.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[966.918,373.594], [967.138,423.588], [995.39,369.791], [995.404,418.117]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.138,423.619], [967.354,472.898], [995.404,418.147], [995.418,465.804]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.355,472.928], [967.568,521.506], [995.418,465.834], [995.432,512.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.568,521.537], [967.779,569.43], [995.432,512.866], [995.446,559.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.779,569.46], [967.987,616.681], [995.446,559.257], [995.459,604.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[967.987,616.711], [968.192,663.276], [995.459,605.019], [995.472,650.137]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.192,663.305], [968.394,709.227], [995.472,650.166], [995.486,694.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.394,709.256], [968.593,754.547], [995.486,694.709], [995.499,738.633]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.593,754.576], [968.79,799.25], [995.499,738.66], [995.511,782.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[968.79,799.25], [968.969,840.135], [995.511,782.005], [995.523,821.69]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.58,783.59], [1012.49,823.385], [1037.76,766.934], [1037.53,805.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.54,370.14], [1013.43,418.619], [1040.23,366.481], [1039.94,413.352]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.43,418.649], [1013.31,466.455], [1039.94,413.382], [1039.66,459.624]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.31,466.485], [1013.21,513.633], [1039.66,459.653], [1039.38,505.28]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.21,513.662], [1013.1,560.164], [1039.38,505.308], [1039.1,550.331]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.1,560.194], [1012.99,606.064], [1039.1,550.359], [1038.82,594.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.99,606.093], [1012.89,651.344], [1038.82,594.819], [1038.55,638.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.89,651.372], [1012.78,696.017], [1038.55,638.697], [1038.29,681.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.78,696.045], [1012.68,740.095], [1038.29,682.006], [1038.02,724.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1012.68,740.122], [1012.58,783.589], [1038.02,724.757], [1037.76,766.934]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1013.77,271.078], [1013.65,320.944], [1040.82,270.772], [1040.52,318.939]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1013.65,320.944], [1013.54,370.14], [1040.52,318.939], [1040.23,366.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.84,636.152], [1021.69,679.16], [1065.05,615.413], [1064.64,656.177]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.69,679.187], [1021.53,721.644], [1064.64,656.202], [1064.24,696.472]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.53,721.671], [1021.38,763.588], [1064.24,696.498], [1063.83,736.283]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1021.38,763.588], [1021.24,801.983], [1063.83,736.283], [1063.47,772.75]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.49,458.283], [1022.33,503.604], [1066.75,447.135], [1066.32,489.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.33,503.633], [1022.16,548.358], [1066.32,489.992], [1065.89,532.291]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.16,548.386], [1022,592.528], [1065.89,532.318], [1065.47,574.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022,592.556], [1021.84,636.125], [1065.47,574.122], [1065.05,615.387]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1023,318.537], [1022.83,365.748], [1068.08,315.272], [1067.63,359.785]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.83,365.748], [1022.66,412.296], [1067.63,359.785], [1067.19,403.708]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1022.66,412.326], [1022.49,458.254], [1067.19,403.736], [1066.75,447.108]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1023.18,270.711], [1023,318.537], [1068.54,270.214], [1068.08,315.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.82,668.978], [1080.35,706.412], [1053.53,664.565], [1053.22,701.619]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.35,706.412], [1079.92,740.748], [1053.22,701.619], [1052.93,735.611]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1085.83,269.676], [1085.3,311.728], [1056.86,269.59], [1056.51,311.162]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.26,554.015], [1081.78,592.751], [1054.49,550.794], [1054.17,589.123]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.78,592.775], [1081.3,631.07], [1054.17,589.148], [1053.85,627.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.3,631.094], [1080.82,668.954], [1053.85,627.069], [1053.53,664.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.25,475.137], [1082.76,514.779], [1055.15,472.76], [1054.82,511.976]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.76,514.804], [1082.26,553.99], [1054.82,512], [1054.49,550.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.78,353.308], [1084.27,394.371], [1056.17,352.273], [1055.82,392.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.27,394.397], [1083.76,434.978], [1055.82,392.904], [1055.48,433.038]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.76,435.004], [1083.25,475.112], [1055.48,433.063], [1055.15,472.735]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.3,311.728], [1084.78,353.308], [1056.51,311.162], [1056.17,352.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.82,668.978], [1080.35,706.412], [1092.73,662.253], [1092.2,699.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.35,706.412], [1079.92,740.748], [1092.2,699.109], [1091.72,732.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.78,592.775], [1081.3,631.07], [1093.8,587.248], [1093.26,624.937]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.3,631.094], [1080.82,668.954], [1093.26,624.961], [1092.73,662.23]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.76,514.804], [1082.26,553.99], [1094.9,510.533], [1094.35,549.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.26,554.015], [1081.78,592.751], [1094.35,549.108], [1093.8,587.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.76,435.004], [1083.25,475.111], [1096.02,432.048], [1095.46,471.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.25,475.137], [1082.76,514.779], [1095.46,471.515], [1094.9,510.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.78,353.308], [1084.27,394.371], [1097.17,351.731], [1096.6,392.097]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.27,394.397], [1083.76,434.978], [1096.6,392.122], [1096.02,432.023]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1085.83,269.676], [1085.3,311.728], [1098.35,269.545], [1097.76,310.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.3,311.728], [1084.78,353.308], [1097.76,310.866], [1097.17,351.731]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.94,665.77], [1092.73,662.253], [1114.29,702.928], [1092.2,699.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.29,702.929], [1092.2,699.109], [1113.68,737.015], [1091.72,732.921]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.28,590.139], [1115.61,628.144], [1093.8,587.248], [1093.26,624.937]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.61,628.168], [1093.26,624.961], [1114.94,665.747], [1092.73,662.23]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.65,512.766], [1116.96,551.649], [1094.9,510.533], [1094.35,549.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.96,551.674], [1116.28,590.114], [1094.35,549.108], [1093.8,587.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.34,473.409], [1117.65,512.742], [1095.46,471.515], [1094.9,510.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.76,393.312], [1119.05,433.568], [1096.6,392.122], [1096.02,432.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.05,433.593], [1118.34,473.384], [1096.02,432.048], [1095.46,471.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.21,311.317], [1120.48,352.555], [1097.76,310.866], [1097.17,351.731]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.48,352.555], [1119.76,393.286], [1097.17,351.731], [1096.6,392.097]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1121.94,269.613], [1121.21,311.317], [1098.35,269.545], [1097.76,310.866]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.94,665.77], [1114.29,702.928], [1147.76,646.463], [1146.96,681.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.29,702.929], [1113.68,737.015], [1146.96,681.956], [1146.23,714.531]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.61,628.168], [1114.94,665.747], [1148.57,610.566], [1147.76,646.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.96,551.674], [1116.28,590.114], [1150.22,537.599], [1149.39,574.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.28,590.139], [1115.61,628.144], [1149.39,574.28], [1148.57,610.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.65,512.766], [1116.96,551.649], [1151.05,500.517], [1150.22,537.576]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.05,433.593], [1118.34,473.384], [1152.75,425.121], [1151.9,463.002]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.34,473.409], [1117.65,512.742], [1151.9,463.026], [1151.05,500.493]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.76,393.312], [1119.05,433.568], [1153.62,386.795], [1152.75,425.097]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.48,352.555], [1119.76,393.286], [1154.49,348.039], [1153.62,386.77]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1121.94,269.613], [1121.21,311.317], [1156.27,269.238], [1155.37,308.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.21,311.317], [1120.48,352.555], [1155.37,308.847], [1154.49,348.039]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.44,684.311], [1146.96,681.956], [1160.63,717.056], [1146.23,714.531]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.32,648.63], [1147.76,646.463], [1161.44,684.311], [1146.96,681.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.22,612.541], [1148.57,610.566], [1162.32,648.608], [1147.76,646.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.12,576.059], [1149.39,574.28], [1163.22,612.518], [1148.57,610.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.95,501.89], [1151.05,500.517], [1165.03,539.154], [1150.22,537.576]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.03,539.178], [1150.22,537.599], [1164.12,576.036], [1149.39,574.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.89,464.19], [1165.95,501.866], [1151.9,463.026], [1151.05,500.493]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.83,426.071], [1166.89,464.166], [1152.75,425.122], [1151.9,463.002]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.78,387.525], [1167.83,426.047], [1153.62,386.795], [1152.75,425.097]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.75,348.545], [1168.78,387.5], [1154.49,348.039], [1153.62,386.77]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.72,309.124], [1169.75,348.545], [1155.37,308.847], [1154.49,348.039]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1171.71,269.28], [1170.72,309.124], [1156.27,269.238], [1155.37,308.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1161.44,684.311], [1160.63,717.056], [1178.86,672.817], [1177.98,704.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1163.22,612.541], [1162.32,648.608], [1180.77,602.901], [1179.81,638.031]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1162.32,648.63], [1161.44,684.311], [1179.81,638.053], [1178.86,672.817]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1164.12,576.059], [1163.22,612.518], [1181.74,567.377], [1180.77,602.879]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.03,539.178], [1164.12,576.036], [1182.72,531.475], [1181.74,567.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1165.95,501.89], [1165.03,539.154], [1183.71,495.189], [1182.72,531.452]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1166.89,464.19], [1165.95,501.866], [1184.71,458.513], [1183.71,495.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1167.83,426.071], [1166.89,464.166], [1185.72,421.44], [1184.71,458.489]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1168.78,387.525], [1167.83,426.047], [1186.75,383.964], [1185.72,421.416]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1169.75,348.545], [1168.78,387.5], [1187.78,346.078], [1186.75,383.94]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.72,309.124], [1169.75,348.545], [1188.83,307.776], [1187.78,346.078]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1171.71,269.28], [1170.72,309.124], [1189.88,269.075], [1188.83,307.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1168.95,670.525], [1168.14,702.272], [1184.5,660.479], [1183.63,691.495]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.66,565.647], [1170.75,600.957], [1187.38,558.066], [1186.41,592.537]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1169.85,635.944], [1168.95,670.525], [1185.45,626.702], [1184.5,660.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.75,600.979], [1169.85,635.922], [1186.41,592.559], [1185.45,626.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.58,529.94], [1171.66,565.624], [1188.36,523.217], [1187.38,558.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.51,493.854], [1172.58,529.917], [1189.35,488.007], [1188.36,523.195]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.46,457.382], [1173.52,493.831], [1190.35,452.429], [1189.35,487.984]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1170.32,658.321], [1169.52,689.18], [1197.26,641.402], [1196.37,671.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.41,420.518], [1174.46,457.358], [1191.36,416.479], [1190.35,452.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1171.19,624.717], [1170.32,658.321], [1198.22,609.159], [1197.26,641.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.37,383.255], [1175.41,420.494], [1192.38,380.151], [1191.36,416.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.07,590.751], [1171.19,624.696], [1199.2,576.582], [1198.22,609.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1177.34,345.587], [1176.37,383.231], [1193.42,343.437], [1192.39,380.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1172.96,556.439], [1172.07,590.73], [1200.18,543.687], [1199.2,576.561]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1178.32,307.507], [1177.34,345.587], [1194.46,306.333], [1193.42,343.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1173.86,521.774], [1172.96,556.417], [1201.18,510.469], [1200.18,543.666]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1179.32,269.035], [1178.32,307.508], [1195.51,268.856], [1194.46,306.333]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1174.77,486.752], [1173.86,521.752], [1202.18,476.924], [1201.18,510.448]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1175.69,451.367], [1174.77,486.729], [1203.19,443.047], [1202.18,476.903]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1176.62,415.613], [1175.69,451.344], [1204.22,408.832], [1203.19,443.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1177.56,379.485], [1176.62,415.59], [1205.25,374.274], [1204.22,408.81]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1178.51,342.976], [1177.56,379.462], [1206.3,339.37], [1205.25,374.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1179.47,306.081], [1178.51,342.976], [1207.35,304.112], [1206.3,339.37]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1180.43,268.818], [1179.47,306.082], [1208.42,268.519], [1207.35,304.112]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[700.708,266.934], [702.842,318.831], [666.326,266.974], [668.659,317.832]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.842,318.831], [704.947,370.019], [668.659,317.832], [670.961,368.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.946,370.019], [707.019,420.45], [670.961,368.01], [673.23,417.459]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[721.16,266.833], [723.245,321.318], [673.629,266.891], [676.007,319.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.021,420.482], [709.065,470.202], [673.231,417.49], [675.468,466.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.066,470.233], [711.082,519.258], [675.47,466.287], [677.676,514.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.245,321.318], [725.301,375.021], [676.007,319.886], [678.351,372.142]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.083,519.288], [713.071,567.632], [677.678,514.414], [679.854,561.856]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.301,375.021], [727.325,427.891], [678.351,372.142], [680.66,423.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.326,427.924], [729.32,480.013], [680.662,423.641], [682.938,474.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.072,567.662], [715.032,615.339], [679.856,561.886], [682.003,608.686]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.033,615.369], [716.967,662.392], [682.004,608.715], [684.122,654.886]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.321,480.046], [731.286,531.371], [682.939,474.399], [685.182,524.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.968,662.422], [718.875,708.806], [684.124,654.916], [686.214,700.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.287,531.403], [733.223,581.981], [685.184,524.433], [687.395,573.726]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.876,708.835], [720.757,754.592], [686.215,700.499], [688.277,745.45]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.225,582.013], [735.133,631.86], [687.397,573.757], [689.577,622.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[720.758,754.62], [722.614,799.763], [688.278,745.478], [690.314,789.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.134,631.891], [737.015,681.022], [689.578,622.387], [691.728,670.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[722.614,799.763], [724.313,841.085], [690.314,789.837], [692.177,830.45]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.016,681.053], [738.87,729.485], [691.73,670.338], [693.85,717.594]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.871,729.515], [740.699,777.262], [693.851,717.623], [695.942,764.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.7,777.292], [742.502,824.368], [695.943,764.257], [698.006,810.223]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.502,824.368], [744.15,867.433], [698.006,810.223], [699.893,852.288]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[721.16,266.833], [723.245,321.318], [733.071,266.853], [735.049,320.839]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.245,321.318], [725.301,375.021], [735.049,320.839], [736.998,374.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.301,375.021], [727.325,427.891], [736.998,374.058], [738.917,426.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[727.326,427.925], [729.32,480.013], [738.919,426.491], [740.81,478.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[729.321,480.046], [731.286,531.371], [740.811,478.156], [742.675,529.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[731.287,531.403], [742.676,529.071], [733.223,581.981], [744.513,579.22]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[781.235,267.116], [782.887,322.266], [733.083,267.165], [735.049,320.839]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.224,582.013], [744.514,579.251], [735.133,631.86], [746.325,628.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.887,322.267], [784.525,376.926], [735.049,320.84], [736.998,374.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.134,631.891], [746.326,628.712], [737.014,681.023], [748.111,677.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.525,376.926], [786.136,430.724], [736.998,374.058], [738.917,426.458]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.016,681.054], [748.112,677.47], [738.87,729.485], [749.871,725.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.137,430.758], [787.725,483.746], [738.919,426.491], [740.81,478.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.871,729.516], [749.872,725.539], [740.698,777.262], [751.607,772.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.7,777.292], [751.608,772.934], [742.502,824.368], [753.319,819.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.726,483.78], [789.289,535.978], [740.811,478.157], [742.675,529.039]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.29,536.011], [790.831,587.436], [742.676,529.071], [744.513,579.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.502,824.368], [753.319,819.639], [744.15,867.433], [754.884,862.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.832,587.468], [792.35,638.137], [744.514,579.251], [746.325,628.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.351,638.169], [793.846,688.098], [746.326,628.712], [748.111,677.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[793.847,688.13], [795.321,737.335], [748.112,677.47], [749.871,725.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.322,737.367], [796.775,785.865], [749.872,725.539], [751.607,772.904]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.776,785.895], [798.208,833.7], [751.608,772.934], [753.319,819.639]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.208,833.701], [799.518,877.423], [753.319,819.639], [754.884,862.37]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[781.416,266.795], [783.077,322.277], [806.144,266.839], [807.584,321.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[782.887,322.267], [784.525,376.926], [807.585,321.177], [809.004,374.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.713,376.947], [786.323,430.755], [809.004,374.736], [810.401,427.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[786.324,430.789], [787.911,483.787], [810.402,427.5], [811.779,479.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.912,483.821], [789.474,536.028], [811.78,479.487], [813.137,530.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[789.475,536.061], [791.015,587.495], [813.138,530.713], [814.475,581.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.016,587.528], [792.532,638.206], [814.476,581.196], [815.794,630.919]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.533,638.237], [794.028,688.175], [815.795,630.951], [817.094,679.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.029,688.207], [795.502,737.421], [817.095,679.994], [818.375,728.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.503,737.452], [796.955,785.958], [818.376,728.339], [819.638,775.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.956,785.989], [798.387,833.802], [819.639,776.003], [820.884,822.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[798.387,833.802], [799.696,877.532], [820.884,822.969], [822.023,865.936]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[847.669,266.791], [848.822,322.365], [806.144,266.839], [807.585,321.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.822,322.366], [849.958,377.125], [807.585,321.177], [809.004,374.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.958,377.125], [851.076,431.02], [809.004,374.736], [810.402,427.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.077,431.053], [852.179,484.136], [810.403,427.5], [811.78,479.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.179,484.17], [853.265,536.459], [811.781,479.487], [813.137,530.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[853.265,536.492], [854.334,588.005], [813.138,530.713], [814.475,581.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[854.335,588.038], [855.388,638.792], [814.476,581.196], [815.794,630.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[855.389,638.824], [856.426,688.837], [815.795,630.951], [817.094,679.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[856.427,688.868], [857.45,738.155], [817.095,679.994], [818.375,728.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[857.451,738.186], [858.459,786.762], [818.376,728.339], [819.639,775.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[858.459,786.793], [859.453,834.674], [819.64,776.003], [820.884,822.97]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[859.453,834.674], [860.362,878.466], [820.884,822.97], [822.023,865.936]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[847.668,266.791], [848.821,322.365], [918.482,266.926], [919.052,319.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.822,322.366], [849.958,377.125], [919.052,319.023], [919.614,370.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.958,377.125], [851.076,431.02], [919.614,370.406], [920.168,421.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.077,431.054], [852.178,484.136], [920.168,421.056], [920.714,470.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.179,484.17], [853.264,536.459], [920.714,470.991], [921.253,520.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[853.265,536.492], [854.334,588.005], [921.253,520.224], [921.784,568.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[854.335,588.038], [855.388,638.792], [921.784,568.771], [922.308,616.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[855.388,638.824], [856.426,688.837], [922.308,616.646], [922.824,663.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[856.427,688.868], [857.45,738.155], [922.824,663.863], [923.334,710.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[857.45,738.186], [858.458,786.762], [923.334,710.434], [923.836,756.345]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[858.459,786.793], [859.452,834.674], [923.836,756.374], [924.332,801.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[859.452,834.674], [860.361,878.466], [924.332,801.667], [924.786,843.124]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[936.286,266.907], [936.732,319.483], [918.482,266.926], [919.052,319.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.732,319.483], [937.171,371.331], [919.052,319.023], [919.614,370.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.171,371.331], [937.604,422.402], [919.614,370.405], [920.168,421.024]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.604,422.434], [938.031,472.776], [920.168,421.056], [920.714,470.959]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.031,472.808], [938.452,522.437], [920.714,470.991], [921.252,520.193]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.452,522.468], [938.866,571.399], [921.253,520.224], [921.784,568.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.867,571.43], [939.276,619.678], [921.784,568.771], [922.307,616.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.276,619.708], [922.308,616.646], [939.679,667.286], [922.824,663.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.679,667.316], [922.824,663.863], [940.077,714.239], [923.333,710.405]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.077,714.268], [923.334,710.434], [940.469,760.549], [923.836,756.346]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.469,760.579], [923.836,756.375], [940.856,806.231], [924.332,801.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.856,806.231], [924.332,801.667], [941.21,848.012], [924.785,843.124]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[936.286,266.908], [936.732,319.483], [970.97,266.976], [971.157,317.802]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[936.732,319.483], [937.171,371.331], [971.157,317.802], [971.341,367.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.171,371.331], [937.604,422.402], [971.341,367.948], [971.522,417.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[937.604,422.434], [938.031,472.776], [971.522,417.398], [971.701,466.135]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.031,472.808], [938.452,522.437], [971.701,466.166], [971.877,514.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.452,522.468], [938.866,571.399], [971.877,514.265], [972.051,561.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[938.867,571.43], [939.276,619.677], [972.051,561.709], [972.223,608.482]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.276,619.708], [939.679,667.286], [972.223,608.511], [972.392,654.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[939.679,667.316], [940.077,714.239], [972.392,654.685], [972.559,700.215]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.077,714.268], [940.469,760.549], [972.559,700.243], [972.724,745.169]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.469,760.579], [940.856,806.231], [972.724,745.198], [972.887,789.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[940.856,806.231], [941.21,848.012], [972.887,789.532], [973.036,830.124]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[989.21,266.967], [989.268,318.021], [1021.95,267.032], [1021.78,316.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.268,318.021], [989.326,368.391], [1021.78,316.396], [1021.62,365.12]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.326,368.391], [989.383,418.026], [1021.62,365.12], [1021.46,413.156]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.383,418.057], [989.438,467.004], [1021.46,413.187], [1021.29,460.578]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.438,467.035], [989.493,515.308], [1021.29,460.608], [1021.14,507.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.493,515.338], [989.548,562.951], [1021.14,507.398], [1020.98,553.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.548,562.981], [989.601,609.947], [1020.98,553.568], [1020.82,599.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.601,609.977], [989.654,656.31], [1020.82,599.132], [1020.67,644.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.654,656.339], [989.706,702.051], [1020.67,644.1], [1020.52,688.457]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.707,702.08], [989.758,747.183], [1020.52,688.485], [1020.37,732.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.758,747.212], [989.809,791.719], [1020.37,732.297], [1020.23,775.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[989.809,791.719], [989.855,832.467], [1020.23,775.521], [1020.09,815.11]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.54,685.173], [1004.49,728.636], [1056.26,662.907], [1055.91,704.193]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.49,728.663], [1004.45,771.573], [1055.91,704.219], [1055.55,745.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.45,771.573], [1004.4,810.878], [1055.55,745.009], [1055.23,782.396]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.87,364.325], [1004.82,411.972], [1058.88,358.995], [1058.49,404.03]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.82,412.002], [1004.77,459.015], [1058.49,404.058], [1058.11,448.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.77,459.045], [1004.72,505.437], [1058.11,448.556], [1057.73,492.469]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.72,505.466], [1004.68,551.249], [1057.73,492.497], [1057.36,535.865]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.68,551.278], [1004.63,596.463], [1057.36,535.893], [1056.99,578.726]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.63,596.492], [1004.58,641.092], [1056.99,578.753], [1056.62,621.061]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.58,641.12], [1004.54,685.146], [1056.62,621.088], [1056.26,662.881]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1004.97,267.048], [1004.92,316.001], [1059.67,267.154], [1059.28,313.354]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1004.92,316.001], [1004.87,364.325], [1059.28,313.354], [1058.88,358.995]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.84,637.78], [1081.36,676.591], [1055.09,633.05], [1054.76,671.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.36,676.615], [1080.89,714.988], [1054.76,671.417], [1054.45,709.332]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.89,714.988], [1080.46,750.185], [1054.44,709.332], [1054.15,744.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.31,518.57], [1082.82,558.74], [1056.08,515.314], [1055.74,554.981]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.82,558.765], [1082.33,598.474], [1055.74,555.006], [1055.41,594.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.33,598.499], [1081.84,637.755], [1055.41,594.249], [1055.09,633.026]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.83,395.135], [1084.32,436.737], [1057.1,393.46], [1056.76,434.523]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.32,436.763], [1083.81,477.879], [1056.76,434.549], [1056.42,475.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.81,477.905], [1083.31,518.544], [1056.42,475.164], [1056.08,515.288]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1086.41,267.274], [1085.88,310.386], [1058.16,267.296], [1057.81,309.829]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.88,310.385], [1085.35,353.012], [1057.81,309.829], [1057.45,351.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.35,353.012], [1084.84,395.108], [1057.45,351.889], [1057.1,393.434]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.84,637.78], [1081.36,676.591], [1096.2,631.826], [1095.65,670.047]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.36,676.615], [1080.89,714.988], [1095.65,670.071], [1095.11,707.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.89,714.988], [1080.46,750.185], [1095.11,707.868], [1094.61,742.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.82,558.765], [1082.33,598.474], [1097.32,554.034], [1096.76,593.125]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.33,598.499], [1081.84,637.755], [1096.76,593.149], [1096.2,631.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.81,477.905], [1083.31,518.544], [1098.47,474.455], [1097.9,514.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.31,518.57], [1082.82,558.74], [1097.9,514.471], [1097.33,554.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.83,395.135], [1084.32,436.737], [1099.65,393.027], [1099.06,433.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.32,436.763], [1083.81,477.879], [1099.06,433.976], [1098.47,474.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.88,310.385], [1085.35,353.012], [1100.85,309.685], [1100.24,351.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.35,353.012], [1084.83,395.108], [1100.24,351.599], [1099.65,393]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1086.41,267.274], [1085.88,310.385], [1101.46,267.302], [1100.85,309.685]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.44,674.232], [1116.77,712.395], [1095.65,670.071], [1095.11,707.868]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.77,712.395], [1116.15,747.403], [1095.11,707.868], [1094.61,742.543]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.81,596.551], [1118.12,635.587], [1096.76,593.149], [1096.2,631.802]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.12,635.612], [1117.44,674.208], [1096.2,631.826], [1095.65,670.047]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.21,517.077], [1119.51,557.017], [1097.9,514.471], [1097.33,554.009]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.51,557.042], [1118.81,596.526], [1097.33,554.034], [1096.76,593.125]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.92,476.648], [1120.21,517.052], [1098.47,474.455], [1097.9,514.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.37,394.367], [1121.64,435.722], [1099.65,393.027], [1099.06,433.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.64,435.748], [1120.92,476.623], [1099.06,433.976], [1098.47,474.429]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.86,310.13], [1123.11,352.497], [1100.85,309.685], [1100.24,351.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.11,352.497], [1122.37,394.34], [1100.24,351.599], [1099.65,393.001]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1124.61,267.284], [1123.86,310.13], [1101.46,267.302], [1100.85,309.685]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.77,712.395], [1116.15,747.403], [1156.37,691.848], [1155.59,725.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.44,674.232], [1116.77,712.395], [1157.22,655.352], [1156.37,691.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.81,596.551], [1118.12,635.587], [1158.96,581.124], [1158.09,618.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.12,635.612], [1117.44,674.208], [1158.09,618.439], [1157.22,655.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.51,557.042], [1118.81,596.526], [1159.84,543.401], [1158.96,581.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.92,476.648], [1120.21,517.052], [1161.64,466.705], [1160.74,505.24]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.21,517.077], [1119.51,557.017], [1160.74,505.264], [1159.84,543.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.64,435.748], [1120.92,476.623], [1162.55,427.718], [1161.64,466.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.11,352.497], [1122.37,394.34], [1164.4,348.43], [1163.47,388.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.37,394.367], [1121.64,435.722], [1163.47,388.295], [1162.55,427.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.86,310.13], [1123.11,352.497], [1165.35,308.113], [1164.4,348.43]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1124.61,267.284], [1123.86,310.13], [1166.3,267.365], [1165.35,308.113]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.64,657.93], [1157.22,655.352], [1170.71,694.654], [1156.37,691.848]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.71,694.654], [1156.37,691.848], [1169.85,728.356], [1155.59,725.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.59,620.782], [1158.09,618.439], [1171.64,657.906], [1157.22,655.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.55,583.229], [1158.96,581.124], [1172.59,620.759], [1158.09,618.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.52,545.262], [1159.84,543.401], [1173.55,583.205], [1158.96,581.1]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.5,506.875], [1174.52,545.238], [1160.74,505.264], [1159.84,543.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.49,468.061], [1175.5,506.85], [1161.64,466.705], [1160.74,505.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.49,428.813], [1176.49,468.036], [1162.55,427.718], [1161.64,466.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.5,389.123], [1177.49,428.787], [1163.47,388.295], [1162.55,427.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.53,348.984], [1178.5,389.097], [1164.4,348.43], [1163.47,388.27]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1181.61,267.354], [1180.56,308.388], [1166.3,267.365], [1165.35,308.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.56,308.388], [1179.53,348.984], [1165.35,308.113], [1164.4,348.43]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1170.71,694.654], [1169.85,728.355], [1191.97,683.348], [1191.03,716.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1171.64,657.93], [1170.71,694.654], [1193,647.544], [1191.97,683.348]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1172.59,620.782], [1171.64,657.906], [1194.03,611.339], [1193,647.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1173.55,583.229], [1172.59,620.759], [1195.08,574.748], [1194.03,611.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1174.52,545.262], [1173.55,583.205], [1196.14,537.766], [1195.08,574.725]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1175.5,506.875], [1174.52,545.238], [1197.21,500.386], [1196.14,537.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1176.49,468.061], [1175.5,506.85], [1198.29,462.601], [1197.21,500.362]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1177.49,428.813], [1176.49,468.036], [1199.38,424.405], [1198.29,462.577]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1178.5,389.123], [1177.49,428.787], [1200.48,385.791], [1199.38,424.38]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.53,348.984], [1178.5,389.097], [1201.6,346.753], [1200.48,385.767]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.56,308.388], [1179.53,348.984], [1202.73,307.282], [1201.6,346.752]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1181.61,267.354], [1180.56,308.388], [1203.87,267.399], [1202.73,307.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1182.33,680.737], [1181.45,713.409], [1201.27,670.856], [1200.31,702.794]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1183.3,645.147], [1182.33,680.737], [1202.31,636.074], [1201.27,670.856]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1184.28,609.159], [1183.3,645.124], [1203.36,600.912], [1202.31,636.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1185.27,572.791], [1184.28,609.136], [1204.42,565.388], [1203.36,600.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1186.27,536.036], [1185.27,572.768], [1205.5,529.495], [1204.42,565.365]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.27,498.889], [1186.27,536.013], [1206.58,493.227], [1205.5,529.472]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.3,461.341], [1187.28,498.865], [1207.68,456.579], [1206.58,493.204]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.33,423.388], [1188.3,461.317], [1208.79,419.546], [1207.68,456.556]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.37,385.023], [1189.33,423.364], [1209.91,382.119], [1208.79,419.522]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.42,346.238], [1190.37,384.998], [1211.04,344.294], [1209.91,382.095]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1187.14,668.282], [1186.26,700.028], [1219.82,651.645], [1218.82,682.149]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.49,307.027], [1191.42,346.238], [1212.18,306.064], [1211.04,344.294]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1188.1,633.711], [1187.14,668.282], [1220.9,618.44], [1219.82,651.645]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1193.57,267.409], [1192.49,307.028], [1213.34,267.448], [1212.18,306.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1189.08,598.764], [1188.1,633.688], [1221.99,584.889], [1220.9,618.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1190.06,563.46], [1189.08,598.742], [1223.09,551.009], [1221.99,584.868]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1191.05,527.791], [1190.06,563.437], [1224.2,516.795], [1223.09,550.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1192.05,491.754], [1191.05,527.769], [1225.33,482.241], [1224.21,516.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1193.07,455.34], [1192.05,491.73], [1226.47,447.342], [1225.33,482.219]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1194.09,418.546], [1193.07,455.317], [1227.61,412.094], [1226.47,447.32]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.13,381.364], [1194.09,418.522], [1228.77,376.491], [1227.61,412.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.17,343.789], [1195.13,381.34], [1229.94,340.528], [1228.77,376.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.23,305.814], [1196.17,343.789], [1231.12,304.199], [1229.94,340.528]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1198.3,267.458], [1197.23,305.814], [1232.32,267.522], [1231.12,304.199]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[672.851,262.48], [675.135,314.664], [642.385,262.792], [644.827,313.799]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[685.04,261.753], [687.354,316.672], [642.99,262.203], [645.534,315.427]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[675.136,314.664], [677.389,366.152], [644.827,313.799], [647.238,364.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.353,316.672], [689.634,370.818], [645.534,315.427], [648.043,367.926]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[677.388,366.152], [679.609,416.893], [647.238,364.141], [649.614,413.768]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.634,370.818], [691.88,424.14], [648.043,367.926], [650.516,419.648]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[679.611,416.925], [681.801,466.966], [649.616,413.799], [651.96,462.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.882,424.173], [694.096,476.721], [650.517,419.681], [652.955,470.676]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[681.803,466.997], [683.963,516.353], [651.961,462.787], [654.274,511.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.097,476.754], [696.278,528.546], [652.956,470.708], [655.359,520.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.964,516.384], [686.095,565.068], [654.276,511.119], [656.557,558.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.28,528.579], [698.43,579.631], [655.361,521.023], [657.731,570.609]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[686.097,565.099], [688.199,613.125], [656.559,558.808], [658.811,605.837]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.432,579.663], [700.552,629.99], [657.732,570.64], [660.07,619.543]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[688.2,613.155], [690.274,660.537], [658.812,605.866], [661.034,652.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.553,630.022], [702.643,679.64], [660.071,619.574], [662.377,667.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[690.275,660.567], [692.322,707.317], [661.036,652.306], [663.229,698.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.644,679.671], [704.705,728.596], [662.378,667.838], [664.652,715.417]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.323,707.346], [694.342,753.477], [663.23,698.141], [665.395,743.352]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.707,728.626], [706.739,776.871], [664.654,715.447], [666.897,762.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.344,753.506], [696.336,799.03], [665.397,743.381], [667.534,788.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.74,776.901], [708.744,824.48], [666.899,762.414], [669.112,808.723]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.336,799.03], [698.161,840.711], [667.534,788.01], [669.491,828.884]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.744,824.48], [710.578,868.016], [669.112,808.723], [671.138,851.112]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[685.04,261.753], [687.353,316.672], [698.285,261.879], [700.481,316.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.354,316.672], [689.634,370.818], [700.481,316.324], [702.647,370.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.634,370.818], [691.88,424.14], [702.647,370.01], [704.78,422.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.882,424.173], [694.095,476.721], [704.781,422.918], [706.883,475.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.097,476.754], [696.278,528.546], [706.885,475.066], [708.957,526.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.28,528.579], [708.958,526.469], [698.43,579.631], [711.001,577.112]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[741.354,261.752], [743.282,317.576], [698.298,262.194], [700.481,316.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.431,579.663], [711.002,577.143], [700.551,629.99], [713.017,627.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.282,317.576], [745.193,372.916], [700.481,316.325], [702.647,370.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.553,630.022], [713.018,627.105], [702.643,679.64], [715.004,676.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.193,372.916], [747.074,427.395], [702.647,370.01], [704.78,422.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.644,679.672], [715.005,676.368], [704.705,728.596], [716.963,724.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.075,427.43], [748.928,481.102], [704.781,422.918], [706.883,475.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.706,728.627], [716.965,724.948], [706.739,776.871], [718.896,772.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.74,776.901], [718.897,772.859], [708.744,824.48], [720.802,820.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.93,481.136], [750.756,534.019], [706.885,475.066], [708.957,526.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.744,824.48], [720.802,820.083], [710.578,868.016], [722.546,863.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.757,534.053], [752.556,586.164], [708.958,526.469], [711.001,577.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.557,586.196], [754.331,637.552], [711.002,577.143], [713.017,627.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.332,637.585], [756.08,688.202], [713.018,627.105], [715.004,676.337]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.081,688.234], [757.803,738.128], [715.005,676.368], [716.963,724.918]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.805,738.159], [759.503,787.345], [716.965,724.948], [718.896,772.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.504,787.376], [761.179,835.87], [718.897,772.859], [720.802,820.083]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.179,835.87], [762.71,880.231], [720.802,820.083], [722.546,863.3]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[741.499,261.424], [743.437,317.585], [769.525,261.716], [771.217,316.777]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.282,317.576], [745.193,372.916], [771.217,316.777], [772.886,371.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.347,372.936], [747.228,427.427], [772.885,371.06], [774.528,424.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.229,427.461], [749.081,481.144], [774.529,424.549], [776.148,477.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[749.082,481.178], [750.908,534.072], [776.149,477.26], [777.745,529.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.909,534.105], [752.708,586.226], [777.746,529.21], [779.318,580.384]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[752.709,586.259], [754.481,637.625], [779.319,580.417], [780.87,630.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.482,637.657], [756.23,688.284], [780.87,630.895], [782.399,680.628]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[756.231,688.316], [757.953,738.219], [782.4,680.66], [783.907,729.696]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.954,738.251], [759.652,787.446], [783.908,729.727], [785.394,778.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.653,787.477], [761.326,835.98], [785.395,778.111], [786.86,825.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.326,835.98], [762.858,880.348], [786.86,825.795], [788.201,869.427]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[807.172,261.335], [808.621,317.828], [769.525,261.716], [771.217,316.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.621,317.828], [810.049,373.502], [771.217,316.777], [772.886,371.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.049,373.502], [811.455,428.305], [772.886,371.06], [774.528,424.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.456,428.339], [812.841,482.325], [774.529,424.549], [776.148,477.227]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.842,482.359], [814.206,535.547], [776.149,477.26], [777.745,529.178]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.207,535.58], [815.551,587.987], [777.746,529.21], [779.319,580.385]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.552,588.02], [816.877,639.663], [779.319,580.417], [780.87,630.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.878,639.695], [818.184,690.591], [780.871,630.895], [782.399,680.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.185,690.623], [819.471,740.787], [782.4,680.66], [783.907,729.696]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.472,740.818], [820.741,790.267], [783.908,729.727], [785.394,778.08]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.742,790.298], [821.992,839.046], [785.395,778.111], [786.86,825.795]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.992,839.046], [823.136,883.637], [786.86,825.795], [788.201,869.427]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[807.171,261.335], [808.62,317.828], [888.747,262.232], [889.526,315.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[808.621,317.828], [810.049,373.502], [889.526,315.348], [890.294,367.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[810.049,373.502], [811.455,428.305], [890.294,367.741], [891.05,419.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[811.456,428.339], [812.84,482.325], [891.051,419.394], [891.797,470.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.841,482.359], [814.206,535.547], [891.797,470.321], [892.533,520.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[814.207,535.58], [815.551,587.987], [892.533,520.539], [893.259,570.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.552,588.02], [816.877,639.663], [893.259,570.063], [893.974,618.874]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.878,639.695], [818.183,690.591], [893.975,618.905], [894.681,667.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.184,690.623], [819.471,740.787], [894.681,667.081], [895.377,714.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[819.472,740.818], [820.74,790.267], [895.378,714.604], [896.064,761.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.741,790.298], [821.992,839.046], [896.065,761.487], [896.742,807.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.992,839.047], [823.136,883.637], [896.742,807.713], [897.363,850.029]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[905.278,262.084], [905.945,315.76], [888.747,262.232], [889.525,315.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[905.945,315.76], [906.603,368.697], [889.526,315.348], [890.294,367.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.603,368.697], [907.251,420.846], [890.293,367.741], [891.05,419.361]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.251,420.879], [907.89,472.289], [891.05,419.394], [891.796,470.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.891,472.321], [908.521,523.007], [891.797,470.321], [892.532,520.508]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[908.521,523.039], [909.142,573.016], [892.533,520.539], [893.258,570.031]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.143,573.048], [909.755,622.331], [893.259,570.063], [893.974,618.875]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.755,622.362], [910.359,670.966], [893.975,618.905], [894.68,667.051]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.36,670.997], [894.681,667.081], [910.956,718.936], [895.377,714.574]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.956,718.966], [895.377,714.604], [911.544,766.253], [896.064,761.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.544,766.283], [896.065,761.487], [912.124,812.931], [896.742,807.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[912.124,812.931], [896.742,807.714], [912.654,855.627], [897.362,850.029]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[905.278,262.084], [905.945,315.76], [945.633,262.538], [945.996,314.503]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[905.945,315.76], [906.603,368.697], [945.996,314.503], [946.355,365.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[906.603,368.697], [907.251,420.846], [946.355,365.776], [946.708,416.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.251,420.879], [907.89,472.289], [946.708,416.341], [947.056,466.179]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[907.891,472.321], [908.521,523.007], [947.056,466.211], [947.4,515.37]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[908.521,523.039], [909.142,573.016], [947.4,515.4], [947.739,563.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.143,573.048], [909.755,622.331], [947.739,563.924], [948.073,611.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[909.755,622.362], [910.359,670.966], [948.073,611.794], [948.403,658.994]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.36,670.997], [910.956,718.936], [948.403,659.024], [948.729,705.598]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[910.956,718.966], [911.544,766.253], [948.729,705.627], [949.05,751.587]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[911.544,766.283], [912.124,812.931], [949.05,751.616], [949.367,796.973]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[912.124,812.931], [912.654,855.627], [949.367,796.973], [949.657,838.503]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[963.478,262.459], [963.717,314.723], [1001.87,262.9], [1001.84,313.502]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.717,314.723], [963.953,366.288], [1001.84,313.502], [1001.81,363.449]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[963.953,366.288], [964.186,417.104], [1001.81,363.449], [1001.78,412.693]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.186,417.136], [964.415,467.251], [1001.78,412.724], [1001.75,461.309]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.416,467.282], [964.642,516.709], [1001.75,461.339], [1001.73,509.278]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.642,516.74], [964.865,565.493], [1001.73,509.308], [1001.7,556.614]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[964.865,565.524], [965.086,613.618], [1001.7,556.644], [1001.67,603.329]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.086,613.648], [965.303,661.095], [1001.67,603.358], [1001.64,649.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.303,661.125], [965.518,707.939], [1001.64,649.464], [1001.61,694.944]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.518,707.968], [965.729,754.161], [1001.61,694.972], [1001.59,739.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.73,754.19], [965.938,799.774], [1001.59,739.895], [1001.56,784.216]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.938,799.774], [966.13,841.51], [1001.56,784.216], [1001.54,824.81]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[985.78,263.028], [985.859,313.146], [1049.84,263.747], [1049.5,311.154]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[985.858,313.146], [985.936,362.621], [1049.5,311.154], [1049.17,357.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[985.936,362.621], [986.013,411.406], [1049.17,357.988], [1048.84,404.202]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.013,411.437], [986.089,459.575], [1048.84,404.231], [1048.52,449.864]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.089,459.605], [986.163,507.109], [1048.52,449.893], [1048.2,494.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.164,507.139], [986.237,554.021], [1048.2,494.985], [1047.89,539.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.237,554.051], [986.31,600.324], [1047.89,539.518], [1047.58,583.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.31,600.353], [986.382,646.028], [1047.58,583.502], [1047.27,626.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.382,646.057], [986.453,691.146], [1047.27,626.947], [1046.97,669.837]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.453,691.175], [986.523,735.689], [1046.97,669.864], [1046.67,712.235]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.523,735.717], [986.592,779.667], [1046.67,712.261], [1046.37,754.122]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[986.592,779.667], [986.655,819.927], [1046.37,754.123], [1046.1,792.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.33,684.787], [1080.86,724.18], [1055.65,678.797], [1055.33,717.648]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.86,724.18], [1080.43,760.313], [1055.33,717.648], [1055.03,753.291]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.79,563.806], [1082.3,604.57], [1056.64,559.518], [1056.31,599.702]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.3,604.596], [1081.81,644.895], [1056.31,599.727], [1055.98,639.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.81,644.92], [1081.33,684.762], [1055.98,639.484], [1055.65,678.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.29,438.566], [1083.78,480.773], [1057.67,436.104], [1057.32,477.688]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.78,480.8], [1083.28,522.518], [1057.32,477.715], [1056.98,518.824]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.28,522.544], [1082.79,563.78], [1056.98,518.85], [1056.64,559.492]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.84,308.837], [1085.32,352.594], [1058.73,308.334], [1058.37,351.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.32,352.594], [1084.8,395.806], [1058.37,351.422], [1058.02,393.982]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.8,395.834], [1084.29,438.539], [1058.02,394.009], [1057.67,436.077]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1086.37,264.583], [1085.84,308.837], [1059.1,264.765], [1058.73,308.334]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.86,724.18], [1080.43,760.313], [1097.49,717.308], [1096.98,752.925]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.81,644.92], [1081.33,684.762], [1098.61,639.2], [1098.05,678.46]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.33,684.787], [1080.86,724.18], [1098.05,678.484], [1097.49,717.308]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.79,563.806], [1082.3,604.57], [1099.76,559.295], [1099.18,599.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.3,604.596], [1081.81,644.895], [1099.18,599.473], [1098.61,639.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.78,480.8], [1083.28,522.518], [1100.94,477.554], [1100.34,518.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.28,522.544], [1082.79,563.78], [1100.34,518.657], [1099.76,559.269]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.8,395.834], [1084.29,438.539], [1102.14,393.914], [1101.53,435.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.29,438.566], [1083.78,480.773], [1101.53,435.975], [1100.94,477.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.84,308.837], [1085.32,352.594], [1103.37,308.308], [1102.75,351.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.32,352.594], [1084.8,395.806], [1102.75,351.361], [1102.14,393.887]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1086.37,264.583], [1085.84,308.837], [1103.99,264.774], [1103.37,308.308]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.54,722.561], [1117.92,758.573], [1097.49,717.308], [1096.98,752.925]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.92,643.572], [1119.23,683.277], [1098.61,639.2], [1098.05,678.459]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.23,683.302], [1118.54,722.561], [1098.05,678.484], [1097.49,717.308]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.33,562.743], [1120.62,603.363], [1099.76,559.294], [1099.18,599.448]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.62,603.389], [1119.92,643.547], [1099.18,599.473], [1098.61,639.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.77,480.035], [1122.04,521.602], [1100.94,477.554], [1100.34,518.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.04,521.628], [1121.33,562.717], [1100.34,518.657], [1099.76,559.269]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.5,437.955], [1122.77,480.008], [1101.53,435.975], [1100.94,477.527]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.99,352.303], [1124.24,395.354], [1102.75,351.361], [1102.14,393.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.24,395.381], [1123.5,437.929], [1102.14,393.914], [1101.53,435.949]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1126.52,264.628], [1125.75,308.713], [1103.99,264.774], [1103.37,308.308]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.75,308.712], [1124.99,352.303], [1103.37,308.308], [1102.75,351.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.54,722.561], [1117.92,758.573], [1165.28,702.62], [1164.45,737.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.92,643.572], [1119.23,683.277], [1167.1,626.982], [1166.19,664.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.23,683.302], [1118.54,722.561], [1166.19,665.017], [1165.28,702.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.62,603.389], [1119.92,643.547], [1168.03,588.533], [1167.1,626.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.04,521.628], [1121.33,562.717], [1169.91,510.362], [1168.96,549.637]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.33,562.743], [1120.62,603.363], [1168.96,549.662], [1168.03,588.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.77,480.035], [1122.04,521.602], [1170.87,470.627], [1169.91,510.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.5,437.955], [1122.77,480.008], [1171.83,430.449], [1170.87,470.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.99,352.303], [1124.24,395.354], [1173.8,348.733], [1172.81,389.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.24,395.381], [1123.5,437.929], [1172.81,389.82], [1171.83,430.423]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.75,308.712], [1124.99,352.303], [1174.8,307.18], [1173.8,348.733]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1126.52,264.628], [1125.75,308.712], [1175.81,265.18], [1174.8,307.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.37,668.019], [1166.19,665.017], [1179.38,705.894], [1165.28,702.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.38,705.894], [1165.28,702.62], [1178.47,740.651], [1164.45,737.129]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.37,629.706], [1167.1,626.982], [1180.37,667.995], [1166.19,664.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.38,590.971], [1168.03,588.533], [1181.37,629.681], [1167.1,626.958]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.4,551.808], [1182.38,590.946], [1168.96,549.662], [1168.03,588.508]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.44,512.211], [1183.4,551.783], [1169.91,510.362], [1168.96,549.637]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.48,472.17], [1184.44,512.185], [1170.87,470.627], [1169.91,510.337]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.54,431.68], [1185.48,472.145], [1171.83,430.449], [1170.87,470.602]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.61,390.732], [1186.54,431.654], [1172.81,389.82], [1171.83,430.423]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.69,349.318], [1187.61,390.705], [1173.8,348.733], [1172.81,389.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.78,307.431], [1188.69,349.318], [1174.8,307.18], [1173.8,348.733]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1190.88,265.09], [1189.78,307.431], [1175.81,265.181], [1174.8,307.18]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1179.38,705.894], [1178.47,740.651], [1204.66,694.87], [1203.66,728.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1180.37,668.019], [1179.38,705.894], [1205.76,657.913], [1204.66,694.87]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1181.37,629.706], [1180.37,667.995], [1206.87,620.539], [1205.76,657.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1182.38,590.971], [1181.37,629.681], [1207.99,582.766], [1206.87,620.515]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1183.4,551.808], [1182.38,590.946], [1209.12,544.585], [1207.99,582.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1184.44,512.211], [1183.4,551.783], [1210.27,505.992], [1209.12,544.561]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1185.48,472.17], [1184.44,512.185], [1211.43,466.979], [1210.27,505.967]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1186.54,431.68], [1185.48,472.144], [1212.6,427.539], [1211.43,466.954]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.61,390.732], [1186.54,431.654], [1213.78,387.665], [1212.6,427.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.69,349.318], [1187.61,390.705], [1214.98,347.35], [1213.78,387.639]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.78,307.431], [1188.69,349.318], [1216.19,306.587], [1214.98,347.35]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1190.88,265.09], [1189.78,307.431], [1217.41,265.394], [1216.19,306.587]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1195.36,691.929], [1194.4,725.629], [1217.83,682.291], [1216.79,715.259]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1196.4,655.218], [1195.36,691.929], [1218.96,646.386], [1217.83,682.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1197.45,618.095], [1196.4,655.194], [1220.1,610.088], [1218.96,646.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1198.51,580.578], [1197.45,618.072], [1221.26,573.412], [1220.11,610.064]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1199.59,542.66], [1198.51,580.554], [1222.43,536.355], [1221.26,573.389]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1200.67,504.335], [1199.59,542.636], [1223.61,498.908], [1222.43,536.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1201.77,465.596], [1200.67,504.31], [1224.8,461.067], [1223.61,498.884]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1202.88,426.436], [1201.77,465.571], [1226,422.825], [1224.8,461.043]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204,386.848], [1202.88,426.411], [1227.22,384.175], [1226.01,422.8]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.13,346.826], [1204,386.823], [1228.45,345.111], [1227.22,384.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1206.28,306.362], [1205.13,346.826], [1229.7,305.627], [1228.45,345.111]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1207.44,265.475], [1206.28,306.362], [1230.95,265.74], [1229.7,305.627]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1203.83,679.28], [1202.86,712.018], [1242.53,663.049], [1241.42,694.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1204.88,643.628], [1203.83,679.28], [1243.72,628.76], [1242.53,663.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1205.94,607.587], [1204.88,643.605], [1244.93,594.112], [1243.72,628.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.02,571.175], [1205.95,607.564], [1246.16,559.121], [1244.93,594.089]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.1,534.386], [1207.02,571.151], [1247.39,523.784], [1246.16,559.099]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1209.2,497.214], [1208.1,534.362], [1248.64,488.093], [1247.39,523.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.31,459.653], [1209.2,497.19], [1249.9,452.045], [1248.64,488.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.43,421.698], [1210.31,459.629], [1251.17,415.634], [1249.9,452.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.56,383.341], [1211.43,421.673], [1252.45,378.853], [1251.17,415.61]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.7,344.576], [1212.56,383.316], [1253.75,341.699], [1252.46,378.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.86,305.397], [1213.7,344.576], [1255.06,304.164], [1253.75,341.698]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1216.02,265.823], [1214.86,305.397], [1256.39,266.267], [1255.06,304.164]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[651.379,256.822], [653.882,312.067], [615.414,257.754], [618.083,311.112]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.882,312.067], [656.351,366.552], [618.083,311.112], [620.717,363.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.351,366.552], [658.783,420.226], [620.716,363.763], [623.312,415.655]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.784,420.26], [661.181,473.173], [623.314,415.688], [625.874,466.869]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.183,473.207], [663.547,525.376], [625.876,466.901], [628.401,517.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.548,525.409], [665.878,576.849], [628.402,517.418], [630.894,567.221]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.88,576.882], [668.178,627.609], [630.895,567.253], [633.353,616.387]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.18,627.64], [670.446,677.669], [633.355,616.418], [635.779,664.898]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.448,677.7], [672.683,727.044], [635.781,664.929], [638.174,712.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.685,727.074], [674.89,775.748], [638.175,712.797], [640.537,760.005]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.891,775.778], [677.067,823.795], [640.538,760.035], [642.869,806.627]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[677.067,823.795], [679.058,867.743], [642.869,806.627], [645.003,849.29]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[651.379,256.823], [653.882,312.067], [665.784,257.041], [668.164,311.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.882,312.067], [656.351,366.552], [668.164,311.843], [670.511,365.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.351,366.552], [658.782,420.226], [670.511,365.899], [672.823,419.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.784,420.26], [661.181,473.174], [672.825,419.189], [675.105,471.697]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[661.183,473.207], [675.106,471.73], [663.546,525.376], [677.354,523.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.548,525.409], [677.356,523.538], [665.878,576.849], [679.573,574.596]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[703.044,256.424], [705.217,312.81], [665.798,257.358], [668.164,311.843]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.88,576.882], [679.574,574.628], [668.178,627.609], [681.761,624.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.217,312.81], [707.372,368.723], [668.164,311.844], [670.511,365.899]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[668.179,627.641], [681.762,625.014], [670.446,677.669], [683.919,674.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.372,368.723], [709.494,423.783], [670.511,365.899], [672.823,419.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.447,677.7], [683.92,674.712], [672.683,727.044], [686.047,723.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.495,423.817], [711.586,478.077], [672.825,419.189], [675.105,471.697]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.684,727.075], [686.049,723.734], [674.89,775.748], [688.147,772.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.588,478.111], [713.649,531.587], [675.106,471.73], [677.354,523.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.891,775.779], [688.148,772.096], [677.066,823.795], [690.219,819.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.65,531.621], [715.681,584.331], [677.356,523.538], [679.573,574.596]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[677.066,823.795], [690.219,819.779], [679.057,867.743], [692.114,863.428]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.683,584.364], [717.685,636.325], [679.574,574.628], [681.761,624.982]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.686,636.358], [719.661,687.584], [681.762,625.014], [683.919,674.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.662,687.617], [721.609,738.125], [683.92,674.712], [686.047,723.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.61,738.157], [723.529,787.962], [686.049,723.734], [688.147,772.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.531,787.993], [725.423,837.109], [688.148,772.096], [690.219,819.779]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.423,837.109], [727.155,882.05], [690.219,819.779], [692.114,863.428]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[703.15,256.09], [705.335,312.817], [734.141,256.604], [736.06,312.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[705.217,312.81], [707.372,368.723], [736.06,312.292], [737.953,367.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.49,368.742], [709.611,423.814], [737.953,367.207], [739.818,421.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.613,423.848], [711.703,478.119], [739.819,421.333], [741.657,474.653]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.705,478.154], [713.765,531.641], [741.658,474.687], [743.47,527.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[713.766,531.675], [715.797,584.396], [743.471,527.284], [745.257,579.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[715.799,584.43], [717.801,636.401], [745.258,579.141], [747.02,630.241]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[717.802,636.433], [719.776,687.671], [747.021,630.272], [748.758,680.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.777,687.703], [721.724,738.221], [748.759,680.695], [750.472,730.39]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.725,738.253], [723.644,788.068], [750.473,730.422], [752.163,779.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.645,788.099], [752.164,779.468], [725.538,837.225], [753.83,827.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[725.538,837.225], [753.83,827.817], [727.269,882.175], [755.355,872.066]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[767.227,255.802], [768.954,313.111], [734.141,256.603], [736.06,312.291]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.954,313.111], [770.657,369.602], [736.06,312.291], [737.953,367.207]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.657,369.602], [772.333,425.222], [737.953,367.207], [739.818,421.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.334,425.257], [773.985,480.06], [739.819,421.333], [741.657,474.653]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.986,480.095], [775.614,534.1], [741.658,474.687], [743.47,527.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.615,534.133], [777.219,587.357], [743.471,527.284], [745.257,579.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.22,587.39], [778.8,639.849], [745.259,579.141], [747.02,630.241]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.801,639.881], [780.36,691.592], [747.021,630.273], [748.758,680.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.361,691.624], [781.897,742.603], [748.759,680.695], [750.472,730.391]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.898,742.634], [783.413,792.896], [750.473,730.422], [752.163,779.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.414,792.927], [784.907,842.487], [752.164,779.468], [753.83,827.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.907,842.487], [786.273,887.827], [753.83,827.817], [755.356,872.066]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[767.227,255.802], [768.954,313.111], [858.826,257.396], [859.807,311.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[768.954,313.111], [770.657,369.602], [859.807,311.48], [860.775,364.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.656,369.602], [772.332,425.222], [860.775,364.837], [861.73,417.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[772.333,425.257], [773.985,480.06], [861.73,417.448], [862.671,469.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[773.986,480.095], [775.613,534.1], [862.672,469.329], [863.6,520.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[775.614,534.133], [777.218,587.357], [863.6,520.495], [864.516,570.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[777.219,587.39], [778.8,639.849], [864.516,570.96], [865.419,620.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[778.801,639.882], [780.359,691.592], [865.42,620.74], [866.31,669.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[780.36,691.625], [781.896,742.603], [866.311,669.848], [867.19,718.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[781.897,742.635], [783.412,792.896], [867.19,718.297], [868.057,766.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.413,792.927], [784.906,842.487], [868.058,766.101], [868.913,813.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.906,842.487], [786.273,887.827], [868.913,813.242], [869.697,856.401]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[873.797,257.079], [874.683,311.804], [858.825,257.396], [859.807,311.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.683,311.805], [875.557,365.785], [859.807,311.48], [860.775,364.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.557,365.786], [876.418,418.97], [860.775,364.837], [861.729,417.415]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.418,419.003], [877.267,471.441], [861.73,417.448], [862.671,469.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.268,471.474], [878.105,523.181], [862.671,469.329], [863.599,520.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.105,523.213], [878.931,574.204], [863.6,520.495], [864.515,570.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.931,574.236], [879.745,624.526], [864.516,570.961], [865.419,620.709]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.746,624.558], [880.549,674.161], [865.419,620.74], [866.31,669.817]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.549,674.193], [881.341,723.123], [866.311,669.848], [867.189,718.267]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.342,723.154], [867.19,718.297], [882.123,771.426], [868.057,766.071]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.124,771.456], [868.058,766.101], [882.895,819.082], [868.913,813.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.895,819.082], [868.913,813.242], [883.6,862.679], [869.696,856.402]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[873.797,257.079], [874.683,311.805], [919.577,257.893], [920.118,310.971]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[874.683,311.805], [875.557,365.785], [920.118,310.971], [920.652,363.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[875.557,365.786], [876.417,418.97], [920.652,363.349], [921.178,414.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[876.418,419.003], [877.267,471.441], [921.179,415.009], [921.698,465.933]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[877.268,471.474], [878.105,523.181], [921.698,465.965], [922.21,516.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.105,523.213], [878.931,574.204], [922.211,516.232], [922.716,565.791]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[878.931,574.236], [879.745,624.526], [922.716,565.822], [923.215,614.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[879.746,624.558], [880.549,674.161], [923.215,614.751], [923.707,663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[880.549,674.193], [881.341,723.123], [923.707,663.031], [924.193,710.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[881.342,723.154], [882.123,771.426], [924.193,710.674], [924.672,757.665]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.124,771.456], [882.895,819.082], [924.673,757.694], [925.145,804.073]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[882.895,819.082], [883.6,862.679], [925.145,804.074], [925.578,846.544]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[936.773,257.708], [937.197,311.161], [980.676,258.503], [980.79,310.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.197,311.161], [937.616,363.903], [980.79,310.346], [980.902,361.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[937.616,363.903], [938.029,415.885], [980.902,361.521], [981.013,411.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.029,415.918], [938.436,467.186], [981.013,412.011], [981.122,461.796]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.437,467.218], [938.839,517.788], [981.122,461.828], [981.23,510.955]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.839,517.82], [939.235,567.705], [981.23,510.986], [981.337,559.468]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.235,567.737], [939.626,616.952], [981.337,559.498], [981.442,607.347]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.626,616.983], [940.012,665.541], [981.442,607.378], [981.546,654.606]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.012,665.571], [940.393,713.485], [981.546,654.636], [981.648,701.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.393,713.515], [940.769,760.798], [981.648,701.285], [981.749,747.308]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.769,760.828], [941.14,807.491], [981.749,747.337], [981.849,792.774]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[941.14,807.491], [941.479,850.219], [981.849,792.774], [981.94,834.394]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[965.714,258.78], [965.927,310.062], [1038.99,260.079], [1038.72,308.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[965.927,310.062], [966.137,360.691], [1038.72,308.73], [1038.46,356.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.137,360.691], [966.345,410.618], [1038.46,356.794], [1038.2,404.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.345,410.649], [966.55,459.918], [1038.2,404.254], [1037.95,451.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.55,459.949], [966.752,508.573], [1037.95,451.119], [1037.7,497.373]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.752,508.604], [966.952,556.596], [1037.7,497.402], [1037.45,543.084]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[966.952,556.626], [967.148,603.997], [1037.45,543.113], [1037.2,588.234]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.149,604.027], [967.343,650.791], [1037.2,588.262], [1036.96,632.833]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.343,650.82], [967.535,696.988], [1036.96,632.861], [1036.72,676.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.535,697.017], [967.724,742.599], [1036.72,676.918], [1036.48,720.416]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.724,742.628], [967.911,787.636], [1036.48,720.444], [1036.25,763.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[967.911,787.636], [968.083,828.868], [1036.25,763.421], [1036.03,802.814]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.59,610.955], [1081.11,652.359], [1056.79,605.477], [1056.46,646.222]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.11,652.386], [1080.64,693.322], [1056.46,646.248], [1056.13,686.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.64,693.348], [1080.17,733.824], [1056.13,686.566], [1055.81,726.412]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.17,733.824], [1079.74,770.952], [1055.81,726.413], [1055.51,762.969]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.06,483.769], [1082.56,526.628], [1057.81,480.364], [1057.47,522.516]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.56,526.655], [1082.07,569.02], [1057.47,522.543], [1057.13,564.218]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.07,569.047], [1081.59,610.928], [1057.13,564.245], [1056.79,605.451]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.07,396.481], [1083.56,440.353], [1058.51,394.542], [1058.16,437.673]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.56,440.38], [1083.06,483.741], [1058.16,437.7], [1057.81,480.337]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1085.62,261.655], [1085.1,307.113], [1059.59,262.047], [1059.23,306.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.1,307.113], [1084.58,352.062], [1059.23,306.71], [1058.87,350.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.58,352.062], [1084.07,396.453], [1058.87,350.882], [1058.51,394.515]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.64,693.348], [1080.17,733.824], [1099.8,687.353], [1099.23,727.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.17,733.824], [1079.74,770.952], [1099.23,727.273], [1098.71,763.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.59,610.955], [1081.11,652.359], [1100.95,606.113], [1100.37,646.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.11,652.386], [1080.64,693.322], [1100.37,646.961], [1099.8,687.328]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.56,526.655], [1082.07,569.02], [1102.13,523.02], [1101.54,564.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.07,569.047], [1081.59,610.928], [1101.54,564.802], [1100.95,606.087]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.56,440.38], [1083.06,483.741], [1103.34,438.011], [1102.73,480.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.06,483.769], [1082.56,526.628], [1102.73,480.759], [1102.13,522.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.58,352.062], [1084.07,396.453], [1104.58,351.019], [1103.95,394.74]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.07,396.481], [1083.56,440.353], [1103.95,394.767], [1103.34,437.984]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1085.62,261.655], [1085.1,307.113], [1105.84,262.002], [1105.2,306.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1085.1,307.113], [1084.58,352.062], [1105.2,306.757], [1104.58,351.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.16,692.836], [1119.47,733.264], [1099.8,687.353], [1099.23,727.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.47,733.264], [1118.84,770.349], [1099.23,727.273], [1098.71,763.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.56,610.541], [1120.86,651.896], [1100.95,606.113], [1100.37,646.935]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.86,651.922], [1120.16,692.81], [1100.37,646.961], [1099.8,687.328]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.28,568.684], [1121.56,610.515], [1101.54,564.802], [1100.95,606.087]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.73,483.511], [1123,526.317], [1102.73,480.759], [1102.13,522.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123,526.344], [1122.28,568.658], [1102.13,523.02], [1101.54,564.776]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.21,396.335], [1124.47,440.15], [1103.95,394.767], [1103.34,437.984]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.47,440.178], [1123.73,483.484], [1103.34,438.011], [1102.73,480.732]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.97,351.973], [1125.21,396.307], [1104.58,351.019], [1103.95,394.74]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1127.51,261.685], [1126.73,307.083], [1105.84,262.002], [1105.2,306.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.73,307.083], [1125.97,351.973], [1105.2,306.757], [1104.58,351.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.47,733.264], [1118.84,770.349], [1173.53,714.138], [1172.66,749.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.86,651.922], [1120.16,692.81], [1175.44,636.089], [1174.48,675.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.16,692.836], [1119.47,733.264], [1174.48,675.336], [1173.53,714.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.56,610.541], [1120.86,651.896], [1176.42,596.412], [1175.44,636.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123,526.344], [1122.28,568.658], [1178.39,515.742], [1177.4,556.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.28,568.685], [1121.56,610.515], [1177.4,556.299], [1176.42,596.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.73,483.511], [1123,526.317], [1179.4,474.735], [1178.39,515.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.47,440.178], [1123.73,483.484], [1180.42,433.269], [1179.4,474.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.97,351.973], [1125.21,396.307], [1182.48,348.932], [1181.44,391.311]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.21,396.335], [1124.47,440.15], [1181.44,391.338], [1180.42,433.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.73,307.083], [1125.97,351.973], [1183.54,306.045], [1182.48,348.932]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1127.51,261.684], [1126.73,307.083], [1184.6,262.695], [1183.54,306.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.27,717.899], [1173.53,714.138], [1186.32,753.799], [1172.66,749.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.31,678.777], [1174.48,675.337], [1187.27,717.899], [1173.53,714.138]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.36,639.201], [1175.44,636.089], [1188.31,678.752], [1174.48,675.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.41,599.189], [1189.36,639.176], [1176.42,596.412], [1175.44,636.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.48,558.732], [1190.41,599.163], [1177.4,556.299], [1176.42,596.386]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.57,517.825], [1191.48,558.707], [1178.39,515.742], [1177.4,556.273]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.66,476.459], [1192.57,517.799], [1179.4,474.735], [1178.39,515.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.77,434.626], [1193.66,476.432], [1180.42,433.27], [1179.4,474.709]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.89,392.319], [1194.77,434.599], [1181.44,391.338], [1180.42,433.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.02,349.529], [1195.89,392.292], [1182.48,348.933], [1181.45,391.311]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.16,306.249], [1197.02,349.529], [1183.54,306.045], [1182.48,348.932]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1199.32,262.497], [1198.16,306.249], [1184.6,262.695], [1183.54,306.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1187.27,717.899], [1186.32,753.799], [1216.73,707.267], [1215.66,742.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.31,678.777], [1187.27,717.899], [1217.89,669.052], [1216.73,707.267]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.36,639.201], [1188.31,678.752], [1219.07,630.404], [1217.89,669.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.41,599.189], [1189.36,639.176], [1220.26,591.341], [1219.07,630.379]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.48,558.732], [1190.41,599.163], [1221.47,551.855], [1220.26,591.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.57,517.825], [1191.48,558.707], [1222.69,511.94], [1221.47,551.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.66,476.459], [1192.57,517.799], [1223.92,471.588], [1222.69,511.914]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.77,434.626], [1193.66,476.432], [1225.16,430.793], [1223.92,471.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.89,392.319], [1194.77,434.599], [1226.42,389.548], [1225.16,430.767]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.02,349.529], [1195.89,392.292], [1227.69,347.844], [1226.42,389.521]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.16,306.249], [1197.02,349.529], [1228.98,305.673], [1227.69,347.843]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1199.32,262.497], [1198.16,306.249], [1230.28,263.057], [1228.98,305.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1207.84,703.987], [1206.82,738.808], [1234,694.684], [1232.88,728.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1208.95,666.052], [1207.84,703.987], [1235.22,657.547], [1234,694.684]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1210.07,627.691], [1208.95,666.028], [1236.46,620], [1235.22,657.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1211.2,588.921], [1210.07,627.667], [1237.7,582.062], [1236.46,619.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1212.35,549.735], [1211.2,588.896], [1238.96,543.726], [1237.7,582.037]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1213.51,510.126], [1212.35,549.71], [1240.24,504.986], [1238.96,543.701]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1214.68,470.087], [1213.51,510.1], [1241.52,465.835], [1240.24,504.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1215.86,429.613], [1214.68,470.062], [1242.82,426.268], [1241.52,465.81]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1217.06,388.694], [1215.87,429.587], [1244.14,386.276], [1242.82,426.242]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1218.27,347.325], [1217.06,388.668], [1245.46,345.854], [1244.14,386.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.5,305.496], [1218.27,347.324], [1246.81,304.995], [1245.46,345.854]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1220.73,263.229], [1219.5,305.496], [1248.16,263.717], [1246.81,304.995]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.22,691.215], [1219.17,725.043], [1265.23,675.536], [1264.02,708.138]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.36,654.375], [1220.22,691.215], [1266.54,640.045], [1265.23,675.536]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1222.51,617.133], [1221.36,654.352], [1267.87,604.18], [1266.54,640.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.67,579.505], [1222.51,617.109], [1269.22,567.958], [1267.87,604.157]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.85,541.486], [1223.67,579.481], [1270.57,531.375], [1269.22,567.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.03,503.07], [1224.85,541.462], [1271.94,494.424], [1270.57,531.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1227.24,464.251], [1226.04,503.046], [1273.33,457.101], [1271.94,494.401]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.45,425.022], [1227.24,464.226], [1274.73,419.4], [1273.33,457.077]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.67,385.376], [1228.45,424.996], [1276.14,381.314], [1274.73,419.375]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.91,345.307], [1229.68,385.35], [1277.57,342.838], [1276.14,381.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.17,304.808], [1230.91,345.307], [1279.01,303.966], [1277.57,342.838]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1233.43,263.899], [1232.17,304.808], [1280.46,264.718], [1279.01,303.966]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[623.484,307.674], [620.835,252.24], [594.186,307.093], [591.435,253.717]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.484,307.674], [626.098,362.368], [594.186,307.093], [596.901,359.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.098,362.368], [628.675,416.268], [596.901,359.784], [599.579,411.738]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.676,416.302], [631.217,469.459], [599.58,411.77], [602.222,463.033]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.219,469.493], [633.724,521.922], [602.224,463.065], [604.831,513.651]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.726,521.955], [636.198,573.672], [604.833,513.683], [607.406,563.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.199,573.704], [638.638,624.722], [607.407,563.637], [609.947,612.91]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.639,624.754], [641.045,675.087], [609.948,612.94], [612.455,661.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.047,675.119], [643.42,724.781], [612.456,661.606], [614.93,709.614]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.422,724.812], [645.764,773.817], [614.932,709.645], [617.375,757.04]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.766,773.847], [648.077,822.208], [617.376,757.07], [619.788,803.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.077,822.208], [650.193,866.486], [619.788,803.863], [621.997,846.726]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[623.484,307.674], [620.834,252.24], [638.718,307.56], [636.195,252.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.484,307.674], [626.099,362.368], [638.718,307.56], [641.208,361.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.098,362.368], [628.674,416.268], [641.208,361.861], [643.662,415.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.676,416.302], [631.217,469.46], [643.663,415.414], [646.083,468.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.218,469.493], [646.085,468.233], [633.724,521.922], [648.472,520.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[633.726,521.955], [648.474,520.335], [636.198,573.672], [650.829,571.7]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[669.422,308.152], [667.04,251.351], [638.718,307.56], [636.21,252.848]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.199,573.704], [650.83,571.732], [638.638,624.722], [653.153,622.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[669.422,308.153], [671.784,364.497], [638.718,307.56], [641.208,361.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.639,624.754], [653.155,622.44], [641.045,675.087], [655.448,672.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[671.784,364.497], [674.111,420.001], [641.208,361.861], [643.662,415.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.046,675.119], [655.449,672.473], [643.42,724.781], [657.711,721.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.113,420.036], [676.407,474.752], [643.663,415.414], [646.083,468.2]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.422,724.812], [657.712,721.843], [645.764,773.817], [659.945,770.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.765,773.848], [659.946,770.564], [648.077,822.208], [662.149,818.618]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.408,474.786], [678.67,528.73], [646.085,468.233], [648.472,520.302]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.672,528.764], [680.902,581.953], [648.474,520.335], [650.829,571.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.077,822.208], [662.149,818.618], [650.193,866.486], [664.167,862.619]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.903,581.987], [683.102,634.436], [650.83,571.732], [653.153,622.408]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.103,634.469], [685.272,686.195], [653.155,622.44], [655.448,672.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.274,686.227], [687.412,737.243], [655.449,672.473], [657.711,721.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.414,737.276], [689.524,787.597], [657.712,721.843], [659.945,770.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.525,787.628], [691.606,837.269], [659.946,770.564], [662.149,818.617]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.606,837.269], [693.511,882.703], [662.149,818.618], [664.167,862.619]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[669.5,308.156], [667.105,251.011], [702.758,307.886], [700.642,251.701]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[669.422,308.153], [671.784,364.497], [702.759,307.886], [704.846,363.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[671.863,364.514], [674.19,420.031], [704.846,363.31], [706.903,417.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.191,420.066], [676.485,474.794], [706.904,417.954], [708.932,471.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.487,474.829], [678.748,528.785], [708.934,471.835], [710.934,524.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.75,528.819], [680.98,582.02], [710.935,524.968], [712.907,577.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.981,582.053], [683.18,634.514], [712.909,577.369], [714.854,629.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[683.182,634.547], [685.35,686.284], [714.855,629.053], [716.774,680.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.352,686.316], [716.775,680.035], [687.491,737.343], [718.668,730.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.492,737.375], [718.67,730.329], [689.602,787.707], [720.537,779.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.603,787.739], [720.539,779.948], [691.684,837.39], [722.381,828.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.684,837.39], [722.381,828.876], [693.589,882.833], [724.069,873.667]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[730.534,308.392], [728.556,250.409], [702.759,307.885], [700.643,251.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.534,308.393], [732.484,365.564], [702.759,307.886], [704.846,363.309]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.484,365.564], [734.405,421.872], [704.846,363.309], [706.903,417.92]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.407,421.907], [736.3,477.403], [706.904,417.954], [708.933,471.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.301,477.438], [738.167,532.14], [708.934,471.835], [710.934,524.935]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.169,532.174], [740.008,586.1], [710.935,524.968], [712.908,577.336]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.01,586.134], [741.823,639.299], [712.909,577.369], [714.854,629.021]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.825,639.332], [743.613,691.753], [714.855,629.054], [716.775,680.003]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.614,691.786], [745.378,743.477], [716.776,680.035], [718.669,730.298]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.379,743.51], [747.118,794.488], [718.67,730.329], [720.538,779.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.119,794.52], [748.834,844.799], [720.539,779.948], [722.382,828.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.834,844.799], [750.404,890.809], [722.382,828.876], [724.069,873.667]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[730.533,308.392], [728.555,250.409], [830.329,307.542], [829.155,252.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.534,308.393], [732.484,365.564], [830.329,307.542], [831.487,361.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.484,365.565], [734.405,421.872], [831.487,361.781], [832.629,415.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[734.406,421.907], [736.3,477.403], [832.63,415.273], [833.756,468]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[736.301,477.438], [738.167,532.14], [833.757,468.033], [834.868,520.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.168,532.174], [740.008,586.1], [834.868,520.077], [835.964,571.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.009,586.134], [741.823,639.299], [835.965,571.419], [837.046,622.041]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[741.824,639.332], [743.613,691.753], [837.047,622.072], [838.114,672.02]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.614,691.786], [745.377,743.477], [838.114,672.052], [839.167,721.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.378,743.51], [747.117,794.488], [839.168,721.37], [840.207,770.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.119,794.52], [748.834,844.799], [840.207,770.041], [841.233,818.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.834,844.799], [750.404,890.809], [841.233,818.047], [842.171,862.004]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[843.385,307.745], [842.289,252.058], [830.329,307.542], [829.155,252.576]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.385,307.745], [844.467,362.686], [830.329,307.542], [831.487,361.781]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.467,362.686], [845.533,416.826], [831.487,361.781], [832.629,415.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.534,416.86], [846.585,470.251], [832.63,415.273], [833.756,468]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.586,470.284], [847.623,522.94], [833.756,468.033], [834.867,520.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.623,522.973], [848.646,574.91], [834.868,520.077], [835.964,571.386]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.647,574.943], [849.656,626.175], [835.965,571.419], [837.046,622.041]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.656,626.207], [850.651,676.749], [837.047,622.072], [838.113,672.02]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.652,676.781], [851.634,726.646], [838.114,672.052], [839.167,721.339]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.634,726.677], [852.603,775.879], [839.167,721.37], [840.206,770.011]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.604,775.91], [840.207,770.041], [853.56,824.462], [841.232,818.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[853.56,824.462], [841.232,818.047], [854.435,868.914], [842.171,862.005]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[843.385,307.745], [842.289,252.058], [893.827,307.307], [893.11,253.175]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[843.385,307.745], [844.467,362.686], [893.827,307.307], [894.534,360.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[844.467,362.686], [845.533,416.826], [894.534,360.734], [895.232,413.403]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[845.534,416.86], [846.585,470.251], [895.232,413.436], [895.92,465.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[846.586,470.284], [847.623,522.94], [895.921,465.428], [896.6,516.693]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[847.623,522.974], [848.646,574.91], [896.6,516.725], [897.27,567.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[848.647,574.943], [849.656,626.175], [897.27,567.339], [897.931,617.254]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[849.656,626.207], [850.651,676.749], [897.932,617.286], [898.584,666.546]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[850.652,676.781], [851.634,726.646], [898.584,666.577], [899.228,715.194]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[851.634,726.677], [852.603,775.879], [899.229,715.225], [899.864,763.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[852.604,775.91], [853.56,824.462], [899.865,763.244], [900.492,810.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[853.56,824.462], [854.435,868.914], [900.492,810.615], [901.066,853.999]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[910,307.434], [909.39,252.85], [958.794,307.002], [958.532,253.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910,307.434], [910.602,361.3], [958.794,307.002], [959.053,359.378]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[910.602,361.3], [911.196,414.397], [959.053,359.378], [959.308,411.025]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.196,414.43], [911.781,466.806], [959.308,411.058], [959.56,462.022]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[911.781,466.839], [912.359,518.507], [959.56,462.054], [959.808,512.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.359,518.54], [912.929,569.516], [959.808,512.382], [960.054,562.022]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[912.929,569.548], [913.491,619.846], [960.054,562.053], [960.296,611.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[913.492,619.877], [914.046,669.51], [960.296,611.081], [960.535,659.447]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.047,669.541], [914.594,718.522], [960.535,659.478], [960.771,707.226]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[914.595,718.553], [915.135,766.894], [960.771,707.256], [961.004,754.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.135,766.925], [915.668,814.639], [961.004,754.426], [961.234,800.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[915.668,814.639], [916.157,858.334], [961.234,800.972], [961.444,843.611]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[945.304,306.822], [944.955,254.407], [1026.95,306.114], [1027.14,256.209]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.304,306.822], [945.649,358.578], [1026.95,306.114], [1026.77,355.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.649,358.578], [945.989,409.62], [1026.77,355.422], [1026.58,404.082]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[945.989,409.653], [946.325,460.029], [1026.58,404.113], [1026.4,452.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.325,460.061], [946.656,509.784], [1026.4,452.198], [1026.22,499.658]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.656,509.815], [946.984,558.897], [1026.22,499.688], [1026.05,546.565]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[946.984,558.928], [947.307,607.382], [1026.05,546.594], [1025.87,592.898]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.307,607.412], [947.625,655.25], [1025.87,592.927], [1025.7,638.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.626,655.28], [947.94,702.512], [1025.7,638.698], [1025.53,683.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[947.941,702.542], [948.251,749.181], [1025.53,683.916], [1025.36,728.564]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[948.252,749.21], [948.558,795.267], [1025.36,728.592], [1025.19,772.707]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[948.558,795.267], [948.84,837.463], [1025.19,772.707], [1025.04,813.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.71,677.416], [1005.66,721.366], [1029.49,671.869], [1029.3,715.222]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.66,721.394], [1005.61,764.828], [1029.3,715.25], [1029.12,758.101]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.61,764.828], [1005.57,804.651], [1029.12,758.101], [1028.95,797.397]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1006.01,402.185], [1005.96,449.429], [1030.66,400.541], [1030.46,447.095]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.96,449.459], [1005.91,496.13], [1030.46,447.124], [1030.26,493.121]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.91,496.159], [1005.86,542.266], [1030.26,493.15], [1030.06,538.599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.86,542.295], [1005.81,587.847], [1030.06,538.628], [1029.87,583.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.81,587.876], [1005.76,632.885], [1029.87,583.567], [1029.68,627.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1005.76,632.914], [1005.71,677.388], [1029.68,627.978], [1029.49,671.841]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1006.12,305.868], [1006.17,256.835], [1031.06,305.658], [1031.27,257.369]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1006.12,305.868], [1006.07,354.324], [1031.06,305.658], [1030.86,353.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1006.07,354.324], [1006.01,402.154], [1030.86,353.389], [1030.66,400.511]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.65,660.043], [1079.19,702.121], [1056.48,653.216], [1056.15,694.555]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.19,702.147], [1078.73,743.754], [1056.15,694.581], [1055.83,735.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.73,743.754], [1078.31,781.92], [1055.83,735.466], [1055.53,772.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.07,530.817], [1080.59,574.358], [1057.48,526.311], [1057.14,569.062]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.59,574.386], [1080.12,617.431], [1057.14,569.089], [1056.81,611.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.12,617.459], [1079.65,660.016], [1056.81,611.388], [1056.48,653.19]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.54,397.042], [1082.05,442.125], [1058.52,395.026], [1058.17,439.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.05,442.154], [1081.56,486.714], [1058.17,439.288], [1057.82,483.02]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.56,486.742], [1081.07,530.789], [1057.82,483.047], [1057.48,526.284]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1083.55,305.211], [1084.07,258.504], [1059.23,304.954], [1059.59,259.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.55,305.211], [1083.05,351.397], [1059.23,304.954], [1058.87,350.25]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.05,351.397], [1082.54,397.013], [1058.87,350.25], [1058.52,394.997]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.73,743.754], [1078.31,781.92], [1100.23,737.604], [1099.71,775.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.65,660.043], [1079.19,702.121], [1101.38,654.977], [1100.8,696.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.19,702.147], [1078.73,743.754], [1100.8,696.533], [1100.23,737.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.59,574.386], [1080.12,617.431], [1102.55,570.455], [1101.96,612.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.12,617.459], [1079.65,660.016], [1101.96,612.953], [1101.38,654.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.56,486.742], [1081.07,530.789], [1103.75,484], [1103.15,527.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.07,530.817], [1080.59,574.358], [1103.15,527.473], [1102.55,570.428]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.54,397.042], [1082.05,442.125], [1104.98,395.545], [1104.37,439.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.05,442.154], [1081.56,486.714], [1104.37,440.027], [1103.76,483.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.55,305.211], [1083.05,351.397], [1106.24,305.02], [1105.61,350.546]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.05,351.397], [1082.54,397.013], [1105.61,350.546], [1104.98,395.517]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1083.55,305.211], [1084.07,258.503], [1106.24,305.02], [1106.88,258.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.11,702.683], [1119.42,744.34], [1100.8,696.533], [1100.23,737.604]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.42,744.34], [1118.79,782.552], [1100.23,737.604], [1099.71,775.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.51,617.888], [1120.81,660.499], [1101.96,612.953], [1101.38,654.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.81,660.526], [1120.11,702.656], [1101.38,654.977], [1100.8,696.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.22,574.761], [1121.51,617.861], [1102.55,570.455], [1101.96,612.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.67,487.004], [1122.94,531.108], [1103.76,484], [1103.15,527.446]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.94,531.136], [1122.22,574.733], [1103.15,527.473], [1102.55,570.428]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.16,397.185], [1124.41,442.328], [1104.98,395.545], [1104.37,439.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.41,442.356], [1123.67,486.976], [1104.37,440.027], [1103.76,483.972]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.91,351.479], [1125.16,397.156], [1105.61,350.546], [1104.99,395.517]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1126.67,305.23], [1127.45,258.457], [1106.24,305.021], [1106.88,258.988]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.67,305.229], [1125.91,351.479], [1106.24,305.02], [1105.61,350.546]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.11,702.683], [1119.42,744.34], [1181.91,686.18], [1180.92,726.262]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.42,744.34], [1118.79,782.552], [1180.92,726.262], [1180.01,763.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.81,660.526], [1120.11,702.656], [1182.92,645.637], [1181.91,686.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.51,617.888], [1120.81,660.499], [1183.93,604.649], [1182.92,645.611]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.94,531.136], [1122.22,574.733], [1186,521.313], [1184.96,563.184]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.22,574.761], [1121.51,617.861], [1184.96,563.211], [1183.93,604.623]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.67,487.004], [1122.94,531.108], [1187.05,478.949], [1186,521.287]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.41,442.356], [1123.67,486.976], [1188.11,436.111], [1187.05,478.922]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.91,351.479], [1125.16,397.156], [1190.27,348.979], [1189.18,392.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.16,397.185], [1124.41,442.328], [1189.18,392.79], [1188.11,436.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1126.67,305.229], [1125.91,351.479], [1191.37,304.669], [1190.27,348.979]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1126.67,305.229], [1127.45,258.457], [1191.37,304.669], [1192.48,259.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.18,730.525], [1180.92,726.262], [1193.19,767.646], [1180.01,763.044]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.25,690.072], [1181.91,686.181], [1194.18,730.525], [1180.92,726.262]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.34,649.147], [1195.25,690.046], [1182.92,645.637], [1181.91,686.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.44,607.77], [1196.34,649.121], [1183.93,604.65], [1182.92,645.611]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.55,565.933], [1197.44,607.744], [1184.96,563.211], [1183.93,604.623]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.68,523.628], [1198.55,565.906], [1186,521.313], [1184.96,563.184]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.81,480.847], [1199.68,523.601], [1187.05,478.949], [1186,521.286]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.96,437.582], [1200.82,480.819], [1188.11,436.111], [1187.05,478.922]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.13,393.825], [1201.97,437.554], [1189.18,392.79], [1188.11,436.083]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.3,349.568], [1203.13,393.797], [1190.27,348.979], [1189.18,392.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.49,304.801], [1204.3,349.568], [1191.37,304.669], [1190.27,348.979]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1205.49,304.801], [1206.7,259.546], [1191.37,304.669], [1192.48,259.881]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1194.18,730.525], [1193.19,767.646], [1227.94,720.412], [1226.81,756.73]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.25,690.072], [1194.18,730.525], [1229.17,680.842], [1227.94,720.411]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.34,649.147], [1195.25,690.046], [1230.42,640.822], [1229.17,680.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.44,607.77], [1196.34,649.121], [1231.67,600.369], [1230.42,640.796]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.55,565.933], [1197.44,607.744], [1232.95,559.478], [1231.68,600.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.68,523.628], [1198.55,565.906], [1234.23,518.14], [1232.95,559.451]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.81,480.847], [1199.68,523.601], [1235.53,476.348], [1234.23,518.113]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.96,437.582], [1200.82,480.819], [1236.85,434.094], [1235.53,476.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.13,393.825], [1201.97,437.554], [1238.17,391.372], [1236.85,434.067]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.3,349.568], [1203.13,393.797], [1239.52,348.173], [1238.18,391.345]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.49,304.801], [1204.3,349.568], [1240.88,304.488], [1239.52,348.172]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1205.49,304.801], [1206.7,259.546], [1240.88,304.489], [1242.25,260.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1219.56,716.784], [1218.49,752.814], [1249.57,707.924], [1248.37,743.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1220.74,677.532], [1219.56,716.784], [1250.88,669.448], [1249.57,707.923]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1221.93,637.836], [1220.74,677.506], [1252.2,630.547], [1250.88,669.424]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1223.13,597.716], [1221.93,637.811], [1253.53,591.239], [1252.2,630.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1224.35,557.164], [1223.13,597.69], [1254.88,551.516], [1253.53,591.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1225.57,516.173], [1224.35,557.138], [1256.25,511.373], [1254.88,551.491]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1226.82,474.735], [1225.58,516.146], [1257.62,470.802], [1256.25,511.347]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1228.07,432.845], [1226.82,474.709], [1259.02,429.796], [1257.63,470.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1229.34,390.493], [1228.07,432.818], [1260.42,388.35], [1259.02,429.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.62,347.673], [1229.34,390.466], [1261.85,346.455], [1260.43,388.323]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.92,304.376], [1230.62,347.673], [1263.29,304.103], [1261.85,346.454]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1231.92,304.377], [1233.23,260.624], [1263.29,304.104], [1264.74,261.317]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.1,703.975], [1234.98,738.984], [1287.73,689.019], [1286.41,722.831]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.33,665.847], [1236.1,703.975], [1289.16,652.208], [1287.73,689.019]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1238.57,627.301], [1237.33,665.823], [1290.61,615.007], [1289.16,652.184]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.82,588.354], [1238.57,627.276], [1292.08,577.434], [1290.61,614.983]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.08,549.001], [1239.82,588.329], [1293.56,539.483], [1292.08,577.409]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.36,509.235], [1241.08,548.976], [1295.05,501.149], [1293.56,539.459]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.65,469.05], [1242.36,509.21], [1296.57,462.426], [1295.06,501.125]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.95,428.44], [1243.65,469.025], [1298.09,423.309], [1296.57,462.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.27,387.396], [1244.96,428.413], [1299.63,383.789], [1298.09,423.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.61,345.912], [1246.27,387.37], [1301.19,343.863], [1299.63,383.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.95,303.982], [1247.61,345.912], [1302.76,303.523], [1301.19,343.863]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1248.95,303.982], [1250.31,261.625], [1302.76,303.523], [1304.35,262.789]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[596.88,303.689], [594.13,248.235], [574.42,303.537], [571.631,250.286]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.88,303.689], [599.594,358.426], [574.42,303.537], [577.174,356.129]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.594,358.427], [602.27,412.393], [577.174,356.129], [579.89,408.008]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.272,412.427], [604.912,465.672], [579.892,408.04], [582.573,459.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.914,465.706], [607.519,518.244], [582.575,459.284], [585.223,509.842]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.52,518.277], [610.091,570.122], [585.224,509.873], [587.838,559.789]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.093,570.154], [612.63,621.32], [587.84,559.821], [590.42,609.108]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.631,621.352], [615.135,671.851], [590.422,609.138], [592.971,657.808]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.137,671.883], [617.608,721.728], [592.972,657.838], [595.489,705.901]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[596.88,303.689], [594.13,248.235], [612.838,303.664], [610.215,248.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.61,721.759], [620.049,770.964], [595.49,705.931], [597.976,753.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.88,303.689], [599.594,358.426], [612.838,303.664], [615.427,358.052]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.051,770.995], [622.46,819.572], [597.978,753.43], [600.433,800.314]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.594,358.427], [602.27,412.393], [615.427,358.053], [617.98,411.68]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.46,819.572], [624.666,864.065], [600.433,800.314], [602.682,843.277]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.271,412.427], [617.982,411.713], [604.911,465.673], [620.501,464.628]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.913,465.706], [620.503,464.661], [607.518,518.244], [622.989,516.877]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.52,518.277], [622.99,516.91], [610.09,570.122], [625.443,568.441]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[636.728,303.82], [634.181,246.791], [612.838,303.664], [610.23,248.887]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.092,570.155], [625.445,568.474], [612.629,621.32], [627.866,619.334]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.728,303.82], [639.255,360.413], [612.838,303.665], [615.427,358.052]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.631,621.352], [627.868,619.366], [615.135,671.851], [630.258,669.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[639.255,360.413], [641.745,416.184], [615.427,358.053], [617.98,411.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.136,671.883], [630.26,669.599], [617.608,721.728], [632.619,719.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.609,721.76], [632.62,719.187], [620.049,770.965], [634.949,768.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.747,416.219], [644.202,471.219], [617.982,411.713], [620.501,464.628]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.204,471.254], [646.626,525.499], [620.503,464.661], [622.989,516.877]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.051,770.996], [634.951,768.141], [622.459,819.572], [637.25,816.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[622.459,819.572], [637.25,816.443], [624.665,864.065], [639.357,860.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.628,525.533], [649.017,579.039], [622.99,516.91], [625.443,568.441]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.018,579.073], [651.375,631.854], [625.445,568.474], [627.866,619.334]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.377,631.888], [653.702,683.96], [627.868,619.366], [630.258,669.568]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.703,683.992], [655.997,735.369], [630.26,669.6], [632.619,719.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[655.999,735.401], [658.262,786.096], [632.62,719.187], [634.949,768.11]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[636.765,303.821], [634.203,246.446], [672.061,303.762], [669.785,247.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.264,786.128], [660.498,836.155], [634.951,768.141], [637.25,816.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.728,303.82], [639.255,360.413], [672.061,303.762], [674.308,359.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.498,836.155], [662.543,881.958], [637.25,816.443], [639.357,860.688]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[639.293,360.428], [641.783,416.213], [674.308,359.527], [676.521,414.493]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.785,416.247], [644.241,471.261], [676.523,414.528], [678.707,468.745]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[644.242,471.295], [646.665,525.554], [678.708,468.78], [680.862,522.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[646.666,525.587], [649.056,579.106], [680.864,522.297], [682.989,575.063]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[649.057,579.14], [651.414,631.934], [682.99,575.096], [685.087,627.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[651.416,631.967], [685.088,627.191], [653.741,684.05], [687.157,678.562]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[653.743,684.083], [687.159,678.594], [656.037,735.471], [689.201,729.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[656.039,735.503], [689.202,729.321], [658.302,786.209], [691.217,779.353]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[658.304,786.241], [691.218,779.384], [660.538,836.279], [693.207,828.765]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.538,836.279], [693.207,828.765], [662.583,882.092], [695.029,873.985]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[694.208,303.896], [692.013,245.429], [672.061,303.761], [669.785,247.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.208,303.896], [696.373,361.564], [672.061,303.762], [674.308,359.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.373,361.564], [698.505,418.379], [674.308,359.527], [676.521,414.493]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.507,418.415], [700.609,474.43], [676.523,414.528], [678.707,468.746]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.611,474.466], [702.684,529.698], [678.708,468.78], [680.862,522.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.685,529.733], [704.73,584.198], [680.864,522.297], [682.989,575.063]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.731,584.232], [706.747,637.947], [682.99,575.096], [685.087,627.158]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.749,637.981], [708.737,690.96], [685.089,627.191], [687.158,678.562]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.739,690.994], [710.7,743.253], [687.159,678.594], [689.201,729.289]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.701,743.286], [712.637,794.839], [689.202,729.321], [691.217,779.353]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.638,794.871], [714.547,845.733], [691.218,779.384], [693.207,828.765]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[694.207,303.896], [692.013,245.429], [801.638,303.707], [800.288,247.99]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.547,845.733], [716.294,892.29], [693.207,828.766], [695.029,873.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.208,303.896], [696.373,361.564], [801.638,303.707], [802.971,358.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.372,361.564], [698.505,418.38], [802.971,358.7], [804.285,412.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.506,418.415], [700.609,474.43], [804.286,412.949], [805.582,466.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.61,474.466], [702.683,529.698], [805.583,466.469], [806.862,519.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.685,529.733], [704.729,584.198], [806.863,519.276], [808.125,571.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.731,584.233], [706.747,637.947], [808.126,571.382], [809.371,622.77]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.748,637.981], [708.737,690.96], [809.372,622.803], [810.601,673.519]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[708.738,690.994], [710.7,743.253], [810.602,673.551], [811.815,723.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[710.701,743.286], [712.636,794.839], [811.816,723.639], [813.014,773.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.637,794.871], [714.546,845.733], [813.015,773.08], [814.197,821.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.546,845.733], [716.294,892.29], [814.197,821.857], [815.28,866.531]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[812.618,303.762], [811.325,247.249], [801.638,303.707], [800.287,247.991]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.618,303.762], [813.894,359.529], [801.638,303.707], [802.971,358.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.894,359.529], [815.151,414.498], [802.971,358.7], [804.285,412.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.152,414.532], [816.393,468.752], [804.285,412.949], [805.582,466.436]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.393,468.786], [817.617,522.272], [805.583,466.47], [806.862,519.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.618,522.306], [818.825,575.073], [806.862,519.276], [808.125,571.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.826,575.107], [820.017,627.17], [808.125,571.382], [809.371,622.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.018,627.203], [821.193,678.576], [809.372,622.803], [810.601,673.519]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.194,678.608], [822.354,729.305], [810.602,673.551], [811.815,723.607]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[812.618,303.762], [811.325,247.25], [867.532,303.663], [866.646,248.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[812.618,303.762], [813.894,359.529], [867.532,303.663], [868.406,358.036]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[822.355,729.337], [823.499,779.37], [811.816,723.639], [813.013,773.049]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.5,779.402], [824.63,828.785], [813.014,773.081], [814.196,821.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[813.894,359.529], [815.151,414.498], [868.406,358.036], [869.268,411.649]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.63,828.785], [825.664,874.006], [814.196,821.857], [815.279,866.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[815.152,414.532], [816.393,468.752], [869.269,411.683], [870.12,464.583]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[816.393,468.786], [817.617,522.272], [870.12,464.616], [870.96,516.818]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[817.618,522.306], [818.825,575.074], [870.96,516.851], [871.788,568.369]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[818.826,575.107], [820.017,627.17], [871.789,568.401], [872.607,619.248]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[820.018,627.203], [821.193,678.576], [872.607,619.28], [873.414,669.469]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[821.194,678.608], [822.354,729.305], [873.415,669.501], [874.212,719.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[822.355,729.337], [823.499,779.37], [874.212,719.076], [874.999,767.987]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[823.5,779.402], [824.63,828.785], [874.999,768.018], [875.776,816.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[824.63,828.785], [825.664,874.006], [875.776,816.308], [876.487,860.542]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[882.526,303.7], [881.734,248.092], [936.106,303.602], [935.695,249.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.526,303.7], [883.306,358.587], [936.106,303.602], [936.512,357.106]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.306,358.587], [884.076,412.7], [936.513,357.106], [936.913,409.873]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.077,412.734], [884.836,466.121], [936.913,409.906], [937.309,461.983]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.836,466.155], [885.586,518.831], [937.309,462.016], [937.699,513.416]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.586,518.864], [886.326,570.844], [937.699,513.448], [938.085,564.185]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.326,570.877], [887.056,622.173], [938.085,564.217], [938.465,614.304]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.056,622.205], [887.776,672.832], [938.465,614.336], [938.841,663.784]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.777,672.864], [888.488,722.833], [938.841,663.815], [939.212,712.638]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.488,722.865], [889.19,772.191], [939.212,712.669], [939.578,760.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.19,772.222], [889.883,820.916], [939.578,760.908], [939.94,808.513]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.883,820.916], [890.517,865.515], [939.94,808.513], [940.271,852.129]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[924.242,303.553], [923.758,250.078], [1014.23,303.392], [1014.34,252.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.242,303.553], [924.721,356.363], [1014.23,303.392], [1014.13,353.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[924.721,356.363], [925.193,408.454], [1014.13,353.92], [1014.02,403.788]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.193,408.487], [925.659,459.905], [1014.02,403.82], [1013.92,453.072]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[925.659,459.938], [926.119,510.697], [1013.92,453.103], [1013.82,501.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.119,510.729], [926.573,560.842], [1013.82,501.781], [1013.72,549.835]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[926.574,560.874], [927.022,610.352], [1013.72,549.865], [1013.62,597.336]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.022,610.383], [927.465,659.239], [1013.62,597.366], [1013.52,644.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.465,659.27], [927.902,707.515], [1013.52,644.294], [1013.43,690.631]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.903,707.545], [928.334,755.191], [1013.43,690.66], [1013.33,736.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.335,755.221], [928.761,802.278], [1013.33,736.474], [1013.24,781.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.761,802.278], [929.152,845.397], [1013.24,781.716], [1013.15,823.192]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.5,637.996], [995.512,683.527], [1021.89,633.528], [1021.75,678.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.512,683.556], [995.523,728.554], [1021.75,678.516], [1021.61,722.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.523,728.583], [995.534,773.058], [1021.61,722.984], [1021.47,766.914]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.534,773.058], [995.544,813.839], [1021.47,766.914], [1021.34,807.201]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[995.416,303.325], [995.404,253.171], [1022.93,303.277], [1023.09,253.818]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.417,303.325], [995.429,352.895], [1022.93,303.277], [1022.77,352.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.429,352.895], [995.441,401.83], [1022.78,352.169], [1022.62,400.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.441,401.861], [995.453,450.202], [1022.62,400.473], [1022.47,448.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.453,450.233], [995.465,497.992], [1022.47,448.199], [1022.32,495.327]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.465,498.022], [995.477,545.209], [1022.32,495.357], [1022.18,541.929]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.477,545.239], [995.489,591.864], [1022.18,541.959], [1022.03,587.983]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[995.489,591.893], [995.5,637.967], [1022.03,588.013], [1021.89,633.5]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.89,710.983], [1076.45,753.741], [1055.64,702.653], [1055.32,744.594]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.45,753.741], [1076.04,792.966], [1055.32,744.595], [1055.03,783.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.25,579.7], [1077.79,623.93], [1056.61,573.935], [1056.29,617.29]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.79,623.958], [1077.34,667.688], [1056.28,617.317], [1055.96,660.194]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.34,667.716], [1076.89,710.956], [1055.96,660.221], [1055.64,702.626]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.66,443.845], [1079.18,489.624], [1057.62,440.828], [1057.28,485.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.18,489.653], [1078.72,534.906], [1057.28,485.698], [1056.95,530.036]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.72,534.935], [1078.25,579.672], [1056.95,530.064], [1056.61,573.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.12,303.175], [1080.62,350.615], [1058.67,303.104], [1058.31,349.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.62,350.615], [1080.14,397.473], [1058.31,349.54], [1057.97,395.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.14,397.502], [1079.66,443.816], [1057.97,395.444], [1057.62,440.799]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1081.12,303.175], [1081.61,255.201], [1058.67,303.104], [1059.02,256.158]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.89,710.983], [1076.45,753.741], [1100.92,705.828], [1100.35,748.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.45,753.741], [1076.04,792.966], [1100.35,748.081], [1099.83,786.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.79,623.958], [1077.34,667.688], [1102.08,619.848], [1101.5,663.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.34,667.716], [1076.89,710.956], [1101.49,663.077], [1100.92,705.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.72,534.935], [1078.25,579.672], [1103.26,531.92], [1102.67,576.103]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1078.25,579.7], [1077.79,623.93], [1102.67,576.132], [1102.08,619.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.66,443.845], [1079.18,489.624], [1104.48,441.977], [1103.87,487.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.18,489.653], [1078.72,534.906], [1103.87,487.205], [1103.26,531.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.62,350.615], [1080.14,397.473], [1105.72,349.949], [1105.09,396.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.14,397.502], [1079.66,443.815], [1105.09,396.228], [1104.48,441.948]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1081.12,303.175], [1081.61,255.201], [1106.35,303.131], [1106.98,255.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.12,303.175], [1080.62,350.615], [1106.35,303.131], [1105.72,349.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.92,712.638], [1118.24,755.558], [1100.92,705.828], [1100.35,748.081]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.24,755.558], [1117.61,794.929], [1100.35,748.081], [1099.83,786.847]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.6,669.205], [1118.92,712.611], [1101.5,663.077], [1100.92,705.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121,580.846], [1120.3,625.249], [1102.67,576.131], [1102.08,619.82]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.3,625.277], [1119.61,669.177], [1102.08,619.848], [1101.5,663.05]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.44,490.438], [1121.72,535.874], [1103.87,487.205], [1103.26,531.892]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.72,535.902], [1121,580.817], [1103.26,531.92], [1102.67,576.104]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.16,444.444], [1122.44,490.409], [1104.48,441.977], [1103.87,487.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.65,350.829], [1123.9,397.882], [1105.72,349.949], [1105.09,396.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.9,397.911], [1123.16,444.415], [1105.09,396.228], [1104.48,441.948]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1125.4,303.189], [1126.16,255.011], [1106.35,303.131], [1106.99,255.794]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.4,303.189], [1124.65,350.829], [1106.35,303.131], [1105.72,349.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.92,712.638], [1118.24,755.558], [1188.24,697.369], [1187.21,738.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.24,755.558], [1117.61,794.929], [1187.21,738.792], [1186.26,776.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.6,669.205], [1118.92,712.611], [1189.28,655.468], [1188.24,697.342]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121,580.846], [1120.3,625.249], [1191.39,570.28], [1190.33,613.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.3,625.277], [1119.6,669.177], [1190.33,613.107], [1189.28,655.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.72,535.902], [1121,580.817], [1192.47,526.977], [1191.39,570.252]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.44,490.439], [1121.72,535.874], [1193.55,483.192], [1192.47,526.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.9,397.911], [1123.16,444.415], [1195.77,394.141], [1194.65,438.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1123.16,444.444], [1122.44,490.409], [1194.65,438.916], [1193.55,483.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1124.65,350.829], [1123.9,397.882], [1196.89,348.858], [1195.77,394.112]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1125.4,303.189], [1126.16,255.01], [1198.03,303.059], [1199.18,256.764]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1125.4,303.189], [1124.65,350.829], [1198.03,303.059], [1196.89,348.858]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.82,743.568], [1187.21,738.792], [1198.8,781.968], [1186.26,776.805]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.93,701.718], [1188.24,697.369], [1199.82,743.568], [1187.21,738.792]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.05,659.38], [1200.93,701.691], [1189.28,655.468], [1188.24,697.342]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.19,616.572], [1202.05,659.353], [1190.33,613.107], [1189.28,655.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.33,573.288], [1203.19,616.545], [1191.39,570.28], [1190.33,613.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.49,529.518], [1204.33,573.26], [1192.47,526.977], [1191.39,570.252]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.67,485.255], [1205.49,529.49], [1193.55,483.192], [1192.47,526.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.85,440.489], [1206.67,485.226], [1194.65,438.916], [1193.56,483.164]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.05,395.214], [1207.85,440.461], [1195.77,394.141], [1194.65,438.888]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.26,349.419], [1209.05,395.185], [1196.89,348.858], [1195.77,394.112]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.49,303.096], [1210.26,349.419], [1198.03,303.059], [1196.89,348.858]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1211.49,303.096], [1212.73,256.266], [1198.03,303.059], [1199.18,256.765]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.82,743.568], [1198.8,781.968], [1238,734.12], [1236.82,771.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.93,701.718], [1199.82,743.568], [1239.29,693.115], [1238,734.12]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1202.05,659.38], [1200.93,701.691], [1240.59,651.642], [1239.29,693.089]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.19,616.572], [1202.05,659.353], [1241.91,609.719], [1240.59,651.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.33,573.288], [1203.19,616.545], [1243.25,567.339], [1241.91,609.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.49,529.518], [1204.33,573.26], [1244.59,524.494], [1243.25,567.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.67,485.255], [1205.49,529.49], [1245.96,481.176], [1244.59,524.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.85,440.489], [1206.67,485.226], [1247.33,437.379], [1245.96,481.149]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.05,395.214], [1207.85,440.461], [1248.73,393.093], [1247.33,437.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.26,349.419], [1209.05,395.185], [1250.13,348.311], [1248.73,393.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.49,303.096], [1210.26,349.419], [1251.56,303.023], [1250.13,348.31]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1211.49,303.096], [1212.73,256.266], [1251.56,303.023], [1253,257.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1230.25,730.139], [1229.12,767.449], [1264.23,721.846], [1262.95,758.48]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1231.49,689.491], [1230.25,730.139], [1265.61,681.942], [1264.23,721.846]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1232.74,648.383], [1231.49,689.465], [1267.02,641.595], [1265.62,681.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1234,606.833], [1232.74,648.357], [1268.44,600.823], [1267.02,641.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1235.28,564.834], [1234,606.806], [1269.88,559.618], [1268.44,600.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1236.57,522.379], [1235.28,564.807], [1271.33,517.976], [1269.88,559.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1237.88,479.46], [1236.57,522.351], [1272.79,475.887], [1271.33,517.949]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.2,436.07], [1237.88,479.432], [1274.27,433.345], [1272.79,475.86]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.53,392.2], [1239.2,436.042], [1275.77,390.343], [1274.27,433.318]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1241.88,347.844], [1240.53,392.172], [1277.28,346.874], [1275.77,390.316]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.25,302.992], [1241.88,347.844], [1278.81,302.928], [1277.28,346.874]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1243.25,302.992], [1244.63,257.666], [1278.81,302.929], [1280.36,258.529]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.2,717.399], [1250,753.67], [1309.73,703.368], [1308.3,738.489]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.51,677.895], [1251.2,717.399], [1311.28,665.128], [1309.73,703.367]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.83,637.956], [1252.51,677.87], [1312.85,626.481], [1311.28,665.103]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.16,597.602], [1253.83,637.931], [1314.44,587.445], [1312.86,626.456]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.51,556.824], [1255.17,597.576], [1316.05,548.014], [1314.44,587.42]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.88,515.617], [1256.52,556.798], [1317.67,508.182], [1316.05,547.988]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.26,473.973], [1257.88,515.59], [1319.3,467.942], [1317.67,508.156]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.65,431.886], [1259.26,473.946], [1320.96,427.29], [1319.3,467.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.06,389.349], [1260.65,431.859], [1322.63,386.217], [1320.96,427.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.48,346.354], [1262.06,389.322], [1324.31,344.719], [1322.63,386.191]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.92,302.894], [1263.48,346.354], [1326.02,302.787], [1324.31,344.718]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1264.92,302.895], [1266.38,258.99], [1326.02,302.787], [1327.74,260.443]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[574.754,300.279], [571.951,245.001], [559.3,300.576], [556.517,247.613]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[574.754,300.279], [577.521,354.868], [559.3,300.576], [562.05,352.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[577.521,354.868], [580.251,408.713], [562.05,352.906], [564.764,404.552]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[580.253,408.747], [582.948,461.895], [564.766,404.584], [567.447,455.59]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[582.949,461.929], [585.609,514.395], [567.448,455.622], [570.096,505.999]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[585.611,514.428], [588.237,566.225], [570.097,506.03], [572.712,555.79]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[574.753,300.279], [571.951,245.001], [591.187,300.319], [588.508,245.349]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.238,566.257], [590.831,617.397], [572.714,555.821], [575.297,604.976]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[574.754,300.279], [577.521,354.868], [591.187,300.319], [593.832,354.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.833,617.429], [593.393,667.925], [575.299,605.006], [577.851,653.566]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[577.521,354.868], [580.251,408.713], [593.832,354.607], [596.441,408.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.394,667.957], [595.922,717.82], [577.852,653.596], [580.373,701.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[580.252,408.747], [596.443,408.193], [582.947,461.896], [599.019,461.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.924,717.851], [598.42,767.094], [580.375,701.602], [582.866,749.004]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.422,767.125], [600.887,815.759], [582.868,749.034], [585.329,795.873]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[582.949,461.929], [599.02,461.09], [585.608,514.395], [601.563,513.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[585.61,514.428], [601.565,513.312], [588.236,566.225], [604.076,564.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.887,815.759], [603.146,860.322], [585.329,795.873], [587.586,838.811]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[607.973,300.012], [605.309,242.977], [591.187,300.319], [588.523,245.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.238,566.258], [604.077,564.87], [590.83,617.397], [606.556,615.746]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.832,617.43], [606.558,615.779], [593.392,667.925], [609.006,666.017]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.973,300.012], [610.618,356.635], [591.187,300.319], [593.832,354.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.618,356.635], [613.226,412.459], [593.832,354.607], [596.441,408.159]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.394,667.957], [609.007,666.049], [595.922,717.82], [611.425,715.662]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[613.227,412.495], [615.8,467.571], [596.443,408.193], [599.019,461.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.923,717.852], [611.426,715.693], [598.42,767.094], [613.814,764.692]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.421,767.125], [613.815,764.723], [600.887,815.759], [616.173,813.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.802,467.606], [618.34,521.948], [599.02,461.09], [601.563,513.279]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.887,815.759], [616.173,813.119], [603.146,860.322], [618.334,857.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.342,521.983], [620.846,575.607], [601.565,513.312], [604.076,564.838]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.848,575.641], [623.32,628.561], [604.077,564.87], [606.556,615.746]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[607.969,300.01], [605.289,242.629], [644.739,300.107], [642.344,243.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.321,628.594], [625.761,680.823], [606.558,615.779], [609.006,666.017]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.973,300.012], [610.618,356.635], [644.74,300.107], [647.104,356.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.763,680.856], [628.171,732.408], [609.007,666.049], [611.425,715.662]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.615,356.648], [613.223,412.486], [647.104,356.01], [649.436,411.134]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.172,732.441], [630.549,783.328], [611.426,715.693], [613.814,764.692]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[613.225,412.521], [615.798,467.611], [649.438,411.169], [651.739,465.564]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.551,783.361], [632.897,833.597], [613.815,764.723], [616.173,813.119]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[615.8,467.646], [618.339,522.002], [651.74,465.598], [654.011,519.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.897,833.597], [635.047,879.609], [616.173,813.119], [618.334,857.466]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[618.34,522.036], [654.012,519.311], [620.846,575.673], [656.253,572.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[620.847,575.707], [656.255,572.323], [623.32,628.639], [658.467,624.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[623.322,628.673], [658.468,624.647], [625.762,680.914], [660.652,676.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[625.763,680.947], [660.653,676.297], [628.172,732.511], [662.808,727.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.174,732.543], [662.81,727.285], [630.551,783.443], [664.938,777.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[630.553,783.475], [664.939,777.624], [632.9,833.723], [667.041,827.295]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[632.9,833.723], [667.041,827.295], [635.05,879.745], [668.965,872.796]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[660.886,299.84], [658.516,241.125], [644.74,300.107], [642.344,243.479]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.886,299.84], [663.225,357.775], [644.74,300.107], [647.104,356.01]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.225,357.775], [665.529,414.875], [647.104,356.01], [649.436,411.134]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.531,414.911], [667.804,471.228], [649.438,411.169], [651.739,465.564]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[667.805,471.264], [670.048,526.814], [651.74,465.598], [654.011,519.278]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.049,526.849], [672.261,581.649], [654.012,519.311], [656.253,572.29]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.262,581.683], [674.445,635.747], [656.255,572.323], [658.467,624.615]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[660.886,299.84], [658.516,241.125], [774.363,300.15], [772.857,243.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.446,635.781], [676.599,689.123], [658.468,624.647], [660.652,676.265]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.601,689.156], [678.725,741.792], [660.653,676.297], [662.809,727.253]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[660.886,299.84], [663.225,357.775], [774.363,300.15], [775.85,355.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.727,741.825], [680.823,793.767], [662.81,727.285], [664.938,777.593]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[663.224,357.775], [665.529,414.875], [775.85,355.724], [777.316,410.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[665.53,414.911], [667.804,471.228], [777.317,410.561], [778.764,464.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.824,793.8], [682.894,845.063], [664.939,777.624], [667.041,827.296]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[667.805,471.264], [670.047,526.814], [778.765,464.678], [780.193,518.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[682.894,845.063], [684.788,892.003], [667.041,827.296], [668.965,872.797]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[670.049,526.849], [672.261,581.649], [780.194,518.087], [781.604,570.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[672.262,581.683], [674.444,635.747], [781.604,570.802], [782.996,622.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[674.446,635.781], [676.599,689.123], [782.997,622.838], [784.37,674.174]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[676.6,689.157], [678.725,741.792], [784.371,674.206], [785.727,724.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[678.726,741.825], [680.823,793.767], [785.728,724.92], [787.067,774.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[680.824,793.8], [682.893,845.063], [787.068,774.993], [788.39,824.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[682.893,845.063], [684.788,892.003], [788.39,824.404], [789.601,869.67]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[783.044,300.04], [781.575,242.889], [774.363,300.15], [772.857,243.861]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.044,300.04], [784.495,356.453], [774.363,300.15], [775.85,355.724]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.495,356.453], [785.925,412.073], [775.85,355.724], [777.316,410.527]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.926,412.108], [787.337,466.986], [777.317,410.561], [778.764,464.644]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.338,467.02], [788.73,521.17], [778.765,464.678], [780.193,518.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.731,521.204], [790.105,574.64], [780.194,518.087], [781.603,570.769]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[783.044,300.04], [781.575,242.889], [841.738,300.203], [840.695,244.33]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.106,574.674], [791.462,627.411], [781.604,570.802], [782.995,622.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[783.044,300.04], [784.495,356.453], [841.738,300.203], [842.768,355.372]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.463,627.444], [792.802,679.495], [782.996,622.838], [784.37,674.174]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[784.495,356.453], [785.925,412.073], [842.768,355.372], [843.784,409.782]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.802,679.527], [794.123,730.906], [784.371,674.206], [785.727,724.888]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.124,730.938], [795.429,781.657], [785.728,724.92], [787.067,774.961]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[785.926,412.108], [787.337,466.986], [843.785,409.816], [844.788,463.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[787.338,467.02], [788.73,521.17], [844.789,463.548], [845.778,516.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.429,781.689], [796.717,831.761], [787.067,774.993], [788.389,824.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[788.731,521.204], [790.105,574.64], [845.779,516.584], [846.756,568.902]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.717,831.761], [797.896,877.624], [788.389,824.404], [789.601,869.67]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[790.106,574.674], [791.462,627.411], [846.757,568.935], [847.721,620.583]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[791.463,627.444], [792.802,679.495], [847.722,620.616], [848.674,671.607]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[792.802,679.528], [794.123,730.906], [848.675,671.639], [849.615,721.985]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[794.124,730.938], [795.429,781.657], [849.615,722.017], [850.544,771.73]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[795.429,781.689], [796.717,831.761], [850.544,771.761], [851.461,820.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[796.717,831.761], [797.896,877.624], [851.461,820.854], [852.301,865.831]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[855.283,300.126], [854.32,243.65], [913.073,300.29], [912.514,245.092]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[855.283,300.126], [856.233,355.882], [913.073,300.29], [913.625,354.801]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[856.233,355.882], [857.171,410.863], [913.625,354.801], [914.169,408.57]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[857.171,410.898], [858.096,465.153], [914.169,408.604], [914.706,461.679]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[858.097,465.187], [859.01,518.731], [914.706,461.712], [915.237,514.107]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[859.01,518.765], [859.911,571.611], [915.237,514.14], [915.76,565.867]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[859.912,571.644], [860.801,623.807], [915.761,565.899], [916.278,616.971]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[860.802,623.84], [861.68,675.331], [916.278,617.003], [916.788,667.432]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[861.68,675.364], [862.547,726.198], [916.788,667.464], [917.292,717.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.548,726.23], [863.403,776.418], [917.293,717.294], [917.79,766.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.404,776.45], [864.249,826.005], [917.791,766.505], [918.282,815.077]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.249,826.005], [865.023,871.401], [918.282,815.077], [918.733,859.584]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[903.079,300.39], [902.463,245.975], [1000.65,300.661], [1000.67,248.363]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.079,300.39], [903.687,354.138], [1000.65,300.661], [1000.63,352.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[903.687,354.138], [904.288,407.164], [1000.63,352.343], [1000.61,403.357]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.288,407.197], [904.88,459.548], [1000.61,403.389], [1000.59,453.778]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[904.881,459.582], [905.466,511.27], [1000.59,453.81], [1000.57,503.585]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[905.466,511.303], [906.044,562.342], [1000.57,503.617], [1000.55,552.79]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.044,562.374], [906.615,612.776], [1000.55,552.821], [1000.54,601.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[906.615,612.808], [907.178,662.584], [1000.53,601.434], [1000.52,649.435]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.179,662.615], [907.735,711.777], [1000.52,649.465], [1000.5,696.896]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[907.735,711.808], [908.285,760.368], [1000.5,696.926], [1000.48,743.797]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.285,760.398], [908.828,808.366], [1000.48,743.827], [1000.46,790.147]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[908.828,808.366], [909.326,852.325], [1000.46,790.147], [1000.45,832.615]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.668,595.583], [984.743,642.669], [1013.52,592.181], [1013.43,638.734]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.743,642.699], [984.817,689.236], [1013.43,638.763], [1013.33,684.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.817,689.266], [984.89,735.264], [1013.33,684.809], [1013.24,730.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.89,735.293], [984.962,780.762], [1013.24,730.328], [1013.15,775.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.962,780.762], [985.028,822.459], [1013.15,775.301], [1013.07,816.548]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[984.2,300.8], [984.118,249.589], [1014.1,300.881], [1014.2,250.3]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.2,300.8], [984.28,351.422], [1014.1,300.881], [1014,350.887]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.28,351.422], [984.359,401.402], [1014,350.887], [1013.9,400.265]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.36,401.433], [984.438,450.813], [1013.9,400.297], [1013.8,449.09]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.438,450.844], [984.516,499.635], [1013.8,449.121], [1013.71,497.339]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.516,499.666], [984.592,547.878], [1013.71,497.369], [1013.61,545.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[984.592,547.909], [984.668,595.553], [1013.61,545.053], [1013.52,592.151]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.66,719.62], [1073.24,763.519], [1054.52,710.557], [1054.21,753.546]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.24,763.519], [1072.85,803.793], [1054.21,753.546], [1053.93,792.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.4,538.898], [1074.96,584.819], [1055.8,533.695], [1055.47,578.618]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.96,584.848], [1074.52,630.25], [1055.47,578.646], [1055.15,623.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.52,630.278], [1074.09,675.171], [1055.15,623.102], [1054.84,667.042]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.09,675.2], [1073.66,719.592], [1054.84,667.069], [1054.52,710.53]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.76,397.849], [1076.3,445.378], [1056.79,395.782], [1056.46,442.242]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.3,445.408], [1075.85,492.392], [1056.46,442.272], [1056.13,488.211]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.85,492.421], [1075.4,538.869], [1056.13,488.24], [1055.8,533.667]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1077.69,301.055], [1078.17,251.831], [1057.47,301.202], [1057.82,253.124]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.69,301.055], [1077.22,349.734], [1057.47,301.201], [1057.13,348.761]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.22,349.734], [1076.76,397.819], [1057.13,348.761], [1056.79,395.752]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.66,719.62], [1073.24,763.519], [1100.02,715.006], [1099.46,758.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.24,763.519], [1072.85,803.793], [1099.46,758.442], [1098.94,798.296]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.52,630.278], [1074.09,675.171], [1101.16,626.624], [1100.59,671.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.09,675.2], [1073.66,719.592], [1100.59,671.06], [1100.02,714.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.85,492.421], [1075.4,538.869], [1102.93,490.292], [1102.33,536.22]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1075.4,538.898], [1074.96,584.818], [1102.33,536.249], [1101.75,581.661]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1074.96,584.848], [1074.52,630.25], [1101.74,581.69], [1101.16,626.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.76,397.849], [1076.3,445.378], [1104.14,396.796], [1103.53,443.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1076.3,445.408], [1075.85,492.392], [1103.53,443.811], [1102.93,490.262]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.69,301.055], [1077.22,349.734], [1105.38,301.13], [1104.75,349.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1077.22,349.734], [1076.76,397.819], [1104.75,349.239], [1104.14,396.766]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1077.69,301.055], [1078.17,251.831], [1105.38,301.129], [1106.01,252.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.75,766.643], [1115.14,807.175], [1099.46,758.442], [1098.94,798.296]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.09,677.747], [1116.42,722.43], [1100.59,671.06], [1100.02,714.978]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.42,722.459], [1115.75,766.643], [1100.02,715.006], [1099.46,758.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.46,586.791], [1117.77,632.499], [1101.75,581.69], [1101.16,626.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.77,632.527], [1117.09,677.719], [1101.16,626.624], [1100.59,671.032]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.86,493.733], [1119.15,540.5], [1102.93,490.292], [1102.33,536.22]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.15,540.529], [1118.46,586.762], [1102.33,536.249], [1101.75,581.661]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.57,446.392], [1119.86,493.703], [1103.53,443.811], [1102.93,490.263]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.02,350.04], [1121.29,398.467], [1104.75,349.239], [1104.14,396.766]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.29,398.497], [1120.57,446.362], [1104.14,396.796], [1103.53,443.781]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1122.75,301.009], [1123.5,251.426], [1105.38,301.13], [1106.01,252.49]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.75,301.009], [1122.02,350.04], [1105.38,301.129], [1104.75,349.239]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.75,766.643], [1115.14,807.175], [1192.11,751.481], [1191.14,790.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.09,677.747], [1116.42,722.431], [1194.24,665.386], [1193.17,708.654]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.42,722.459], [1115.75,766.643], [1193.17,708.681], [1192.11,751.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.77,632.527], [1117.09,677.718], [1195.32,621.616], [1194.24,665.359]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.46,586.791], [1117.77,632.499], [1196.41,577.363], [1195.32,621.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.86,493.733], [1119.15,540.5], [1198.63,487.375], [1197.51,532.59]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1119.15,540.529], [1118.46,586.762], [1197.51,532.619], [1196.41,577.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1120.57,446.392], [1119.86,493.703], [1199.76,441.623], [1198.63,487.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.02,350.04], [1121.29,398.467], [1202.06,348.56], [1200.9,395.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1121.29,398.497], [1120.57,446.362], [1200.9,395.354], [1199.76,441.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1122.75,301.009], [1122.02,350.04], [1203.23,301.232], [1202.06,348.56]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1122.75,301.009], [1123.5,251.426], [1203.23,301.232], [1204.41,253.391]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.9,756.773], [1202.86,796.489], [1192.11,751.481], [1191.14,790.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.03,713.49], [1203.9,756.773], [1193.17,708.681], [1192.11,751.481]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.18,669.7], [1205.03,713.462], [1194.24,665.386], [1193.17,708.653]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.34,625.424], [1206.18,669.672], [1195.32,621.617], [1194.24,665.359]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.51,580.653], [1207.34,625.396], [1196.41,577.363], [1195.32,621.588]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.7,535.379], [1208.51,580.624], [1197.51,532.619], [1196.41,577.335]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.9,489.592], [1209.7,535.349], [1198.63,487.375], [1197.51,532.59]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.11,443.286], [1210.9,489.563], [1199.76,441.623], [1198.63,487.346]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.34,396.45], [1212.11,443.256], [1200.9,395.354], [1199.76,441.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.58,349.076], [1213.34,396.42], [1202.06,348.56], [1200.9,395.325]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.83,301.154], [1214.58,349.076], [1203.23,301.232], [1202.06,348.56]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1215.83,301.154], [1217.1,252.706], [1203.23,301.232], [1204.41,253.391]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.9,756.773], [1202.86,796.489], [1246.54,748.16], [1245.31,787.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.03,713.49], [1203.9,756.773], [1247.88,705.664], [1246.54,748.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.18,669.7], [1205.03,713.462], [1249.24,662.68], [1247.88,705.637]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.34,625.424], [1206.18,669.672], [1250.61,619.228], [1249.24,662.653]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.51,580.653], [1207.34,625.396], [1252,575.3], [1250.61,619.201]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.7,535.378], [1208.51,580.624], [1253.4,530.888], [1252,575.272]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.9,489.592], [1209.7,535.349], [1254.82,485.984], [1253.4,530.86]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.11,443.286], [1210.9,489.563], [1256.25,440.58], [1254.82,485.955]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.34,396.45], [1212.11,443.256], [1257.7,394.667], [1256.25,440.551]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.58,349.076], [1213.34,396.42], [1259.17,348.237], [1257.7,394.638]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.83,301.154], [1214.58,349.076], [1260.65,301.281], [1259.17,348.237]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1215.83,301.154], [1217.1,252.706], [1260.65,301.281], [1262.15,253.82]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1239.55,743.825], [1238.37,782.465], [1277.58,736.243], [1276.23,774.252]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1240.84,701.727], [1239.55,743.825], [1279.05,694.84], [1277.58,736.243]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1242.15,659.149], [1240.84,701.7], [1280.53,652.974], [1279.05,694.813]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1243.47,616.112], [1242.15,659.122], [1282.03,610.664], [1280.54,652.947]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1244.8,572.609], [1243.47,616.085], [1283.55,567.903], [1282.04,610.637]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1246.15,528.631], [1244.8,572.581], [1285.08,524.684], [1283.55,567.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.52,484.17], [1246.15,528.602], [1286.63,481], [1285.08,524.657]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.9,439.22], [1247.52,484.142], [1288.2,436.843], [1286.63,480.972]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.29,393.771], [1248.9,439.191], [1289.78,392.205], [1288.2,436.815]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.7,347.815], [1250.29,393.742], [1291.38,347.079], [1289.78,392.177]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.12,301.344], [1251.7,347.815], [1293,301.455], [1291.38,347.078]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1253.12,301.345], [1254.56,254.38], [1293,301.456], [1294.63,255.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.15,731.281], [1263.88,768.876], [1330.83,718.412], [1329.3,754.929]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.54,690.334], [1265.15,731.281], [1332.51,678.649], [1330.83,718.412]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.94,648.934], [1266.54,690.308], [1334.2,638.46], [1332.51,678.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1269.36,607.1], [1267.94,648.907], [1335.91,597.862], [1334.2,638.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1270.79,564.825], [1269.36,607.073], [1337.63,556.85], [1335.91,597.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1272.23,522.104], [1270.79,564.798], [1339.38,515.418], [1337.63,556.824]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1273.7,478.927], [1272.23,522.076], [1341.14,473.559], [1339.38,515.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1275.17,435.289], [1273.7,478.9], [1342.92,431.266], [1341.14,473.532]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1276.67,391.182], [1275.17,435.261], [1344.72,388.532], [1342.92,431.239]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.18,346.597], [1276.67,391.154], [1346.54,345.351], [1344.72,388.505]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1279.7,301.528], [1278.18,346.597], [1348.37,301.716], [1346.54,345.351]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1279.7,301.528], [1281.24,255.996], [1348.37,301.716], [1350.23,257.647]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[557.766,297.596], [554.957,242.717], [549.303,298.319], [546.565,245.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[557.766,297.596], [560.541,351.817], [549.303,298.319], [552.011,350.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[560.541,351.817], [563.281,405.323], [552.011,350.206], [554.684,401.439]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[563.282,405.357], [565.987,458.196], [554.686,401.471], [557.327,452.091]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[557.766,297.596], [554.956,242.718], [574.412,297.673], [571.722,243.047]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[557.766,297.596], [560.542,351.817], [574.412,297.673], [577.071,351.646]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[565.989,458.229], [568.66,510.414], [557.329,452.123], [559.939,502.143]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[560.541,351.817], [577.071,351.646], [563.28,405.323], [579.694,404.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[568.662,510.447], [571.3,561.989], [559.94,502.174], [562.52,551.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[571.302,562.021], [573.908,612.932], [562.521,551.635], [565.07,600.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[563.282,405.357], [579.696,404.946], [565.987,458.196], [582.287,457.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[573.91,612.964], [576.484,663.256], [565.072,600.515], [567.591,648.796]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[565.988,458.23], [582.288,457.583], [568.66,510.414], [584.847,509.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[576.485,663.288], [579.029,712.972], [567.593,648.826], [570.082,696.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[568.661,510.447], [584.849,509.572], [571.3,561.989], [587.376,560.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[579.03,713.003], [581.543,762.089], [570.084,696.577], [572.545,743.747]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[584.006,296.921], [581.273,240.139], [574.412,297.673], [571.737,243.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[571.301,562.021], [587.378,560.923], [573.907,612.932], [589.875,611.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.545,762.12], [584.027,810.62], [572.547,743.777], [574.98,790.407]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[573.909,612.964], [589.876,611.648], [576.484,663.256], [592.343,661.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.006,296.922], [586.721,353.32], [574.412,297.673], [577.071,351.646]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.027,810.621], [586.303,855.079], [574.98,790.407], [577.211,833.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[576.485,663.288], [592.344,661.759], [579.028,712.972], [594.781,711.235]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.721,353.321], [589.398,408.948], [577.071,351.646], [579.694,404.912]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[589.4,408.984], [592.043,463.89], [579.696,404.946], [582.287,457.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[579.03,713.003], [594.783,711.267], [581.543,762.09], [597.19,760.151]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[583.962,296.917], [581.212,239.789], [621.59,297.107], [619.118,240.608]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.544,762.12], [597.192,760.182], [584.027,810.621], [599.571,808.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.044,463.925], [594.653,518.125], [582.288,457.583], [584.847,509.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.006,296.922], [586.721,353.32], [621.59,297.107], [624.032,352.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[594.655,518.159], [597.23,571.665], [584.849,509.572], [587.376,560.89]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.027,810.621], [599.571,808.485], [586.303,855.079], [601.752,852.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.677,353.331], [589.356,408.973], [624.032,352.907], [626.44,407.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.231,571.699], [599.774,624.525], [587.378,560.923], [589.875,611.616]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[589.357,409.008], [592.001,463.928], [626.442,407.987], [628.819,462.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.776,624.558], [602.286,676.717], [589.876,611.648], [592.343,661.727]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.003,463.963], [628.821,462.361], [594.612,518.176], [631.168,516.008]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.288,676.75], [604.766,728.254], [592.344,661.759], [594.781,711.235]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[594.614,518.21], [631.17,516.041], [597.19,571.73], [633.487,569.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.768,728.286], [607.216,779.147], [594.783,711.267], [597.19,760.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.192,571.764], [633.489,569.042], [599.735,624.602], [635.777,621.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.218,779.179], [609.635,829.41], [597.192,760.182], [599.571,808.485]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.737,624.636], [635.779,621.376], [602.248,676.807], [638.039,673.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.635,829.41], [611.85,875.434], [599.571,808.485], [601.752,852.764]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.25,676.84], [638.04,673.055], [604.729,728.356], [640.272,724.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.731,728.388], [640.273,724.092], [607.18,779.261], [642.477,774.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.181,779.293], [642.479,774.499], [609.6,829.535], [644.656,824.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.6,829.535], [644.656,824.256], [611.816,875.57], [646.651,869.851]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[631.537,296.448], [629.037,237.766], [621.59,297.107], [619.118,240.608]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.537,296.448], [634.005,354.376], [621.59,297.107], [624.032,352.907]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.005,354.376], [636.437,411.491], [624.032,352.907], [626.44,407.953]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.439,411.527], [638.839,467.883], [626.442,407.987], [628.819,462.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.841,467.918], [641.21,523.529], [628.821,462.361], [631.168,516.008]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[631.536,296.448], [629.037,237.766], [749.221,297.066], [747.585,240.433]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.537,296.448], [634.005,354.376], [749.221,297.067], [750.837,352.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.211,523.563], [643.549,578.444], [631.17,516.041], [633.487,569.009]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.55,578.478], [645.857,632.643], [633.489,569.042], [635.777,621.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[634.004,354.376], [636.437,411.491], [750.837,352.998], [752.432,408.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.859,632.676], [648.136,686.139], [635.779,621.376], [638.039,673.023]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[636.438,411.527], [638.839,467.883], [752.433,408.205], [754.007,462.668]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[638.84,467.918], [641.209,523.529], [754.008,462.703], [755.561,516.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.137,686.172], [650.385,738.946], [638.04,673.055], [640.272,724.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[650.387,738.979], [652.606,791.077], [640.273,724.092], [642.477,774.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[641.21,523.563], [643.548,578.444], [755.562,516.504], [757.096,569.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[652.607,791.11], [654.798,842.546], [642.479,774.499], [644.656,824.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[643.55,578.478], [645.857,632.643], [757.097,569.622], [758.612,622.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[654.798,842.546], [656.805,889.66], [644.656,824.256], [646.651,869.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[645.858,632.676], [648.135,686.139], [758.613,622.071], [760.109,673.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[648.137,686.172], [650.385,738.946], [760.11,673.862], [761.587,724.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[650.386,738.979], [652.605,791.077], [761.588,725.009], [763.046,775.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[652.607,791.11], [654.797,842.546], [763.047,775.522], [764.488,825.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[654.797,842.546], [656.804,889.66], [764.488,825.382], [765.808,871.072]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[755.433,296.79], [753.812,239.241], [749.221,297.066], [747.584,240.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.433,296.79], [757.034,353.614], [749.221,297.067], [750.837,352.998]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.034,353.614], [758.613,409.656], [750.837,352.998], [752.432,408.17]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.614,409.691], [760.172,465.001], [752.432,408.205], [754.006,462.668]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[755.433,296.79], [753.812,239.241], [817.055,297.12], [815.87,240.663]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.173,465.036], [761.711,519.629], [754.007,462.702], [755.561,516.47]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.433,296.79], [757.034,353.614], [817.055,297.12], [818.226,352.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.712,519.663], [763.231,573.552], [755.562,516.504], [757.096,569.589]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.034,353.614], [758.613,409.656], [818.226,352.879], [819.382,407.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.232,573.586], [764.73,626.784], [757.097,569.622], [758.612,622.038]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[758.614,409.691], [760.172,465.001], [819.382,407.92], [820.523,462.221]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.731,626.818], [766.211,679.34], [758.613,622.071], [760.108,673.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.173,465.036], [761.711,519.628], [820.523,462.255], [821.649,515.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.212,679.373], [767.673,731.23], [760.109,673.862], [761.586,724.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[761.712,519.663], [763.231,573.552], [821.65,515.898], [822.761,568.828]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.674,731.263], [769.117,782.469], [761.587,725.009], [763.046,775.49]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.232,573.586], [764.73,626.784], [822.762,568.862], [823.86,621.127]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.117,782.501], [770.542,833.068], [763.047,775.522], [764.488,825.382]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.731,626.818], [766.211,679.34], [823.86,621.16], [824.944,672.772]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.542,833.068], [771.847,879.396], [764.488,825.382], [765.808,871.072]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.212,679.373], [767.673,731.23], [824.945,672.805], [826.015,723.776]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.674,731.263], [826.016,723.808], [769.117,782.469], [827.073,774.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.117,782.501], [827.074,774.182], [770.542,833.068], [828.118,823.906]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.542,833.068], [828.118,823.906], [771.847,879.396], [829.075,869.473]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[828.898,296.917], [827.777,239.789], [890.149,297.25], [889.449,241.224]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.898,296.917], [830.005,353.331], [890.149,297.25], [890.84,352.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.005,353.331], [831.097,408.974], [890.84,352.59], [891.522,407.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.098,409.009], [832.175,463.93], [891.523,407.221], [892.196,461.123]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.176,463.965], [833.24,518.179], [892.196,461.157], [892.861,514.378]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.24,518.213], [834.291,571.733], [892.862,514.411], [893.518,566.963]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.291,571.767], [835.328,624.606], [893.518,566.996], [894.167,618.893]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.329,624.64], [836.352,676.811], [894.167,618.925], [894.807,670.178]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.353,676.844], [837.364,728.361], [894.808,670.21], [895.44,720.83]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[837.364,728.393], [838.363,779.267], [895.44,720.862], [896.065,770.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[838.363,779.299], [839.349,829.542], [896.065,770.894], [896.682,820.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[839.349,829.542], [840.252,875.577], [896.682,820.285], [897.248,865.55]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[882.246,297.505], [881.506,242.324], [986.368,298.061], [986.299,244.72]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.246,297.505], [882.977,352.021], [986.368,298.061], [986.436,350.781]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[882.977,352.02], [883.698,405.814], [986.436,350.781], [986.503,402.825]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[883.699,405.848], [884.411,458.968], [986.503,402.858], [986.569,454.271]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[884.412,459.001], [885.115,511.459], [986.57,454.303], [986.635,505.096]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.116,511.492], [885.811,563.3], [986.635,505.128], [986.7,555.313]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[885.811,563.333], [886.497,614.504], [986.7,555.344], [986.764,604.931]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[886.498,614.536], [887.176,665.081], [986.764,604.962], [986.827,653.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.176,665.113], [887.846,715.044], [986.827,653.993], [986.889,702.415]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[887.846,715.076], [888.508,764.404], [986.889,702.446], [986.951,750.302]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[888.508,764.435], [889.162,813.17], [986.951,750.332], [987.012,797.632]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[889.162,813.17], [889.761,857.841], [987.012,797.632], [987.068,841.002]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[972.618,298.419], [972.467,246.262], [1004.65,298.586], [1004.69,246.979]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.618,298.419], [972.767,349.983], [1004.65,298.586], [1004.61,349.612]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.767,349.983], [972.914,400.9], [1004.61,349.612], [1004.57,400.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[972.914,400.932], [973.06,451.244], [1004.57,400.035], [1004.52,449.835]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.06,451.276], [973.204,500.995], [1004.52,449.866], [1004.48,499.085]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.204,501.026], [973.346,550.162], [1004.48,499.116], [1004.44,547.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.346,550.193], [973.486,598.756], [1004.44,547.794], [1004.4,595.879]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.486,598.787], [973.625,646.787], [1004.4,595.91], [1004.36,643.444]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.625,646.817], [973.762,694.264], [1004.36,643.474], [1004.32,690.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.762,694.294], [1004.32,690.495], [973.898,741.197], [1004.28,736.954]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[973.898,741.227], [1004.28,736.983], [974.032,787.596], [1004.24,782.918]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[974.032,787.596], [1004.24,782.918], [974.155,830.124], [1004.21,825.052]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.42,727.761], [1069.02,772.75], [1052.74,718.018], [1052.44,762.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.02,772.75], [1068.65,814.026], [1052.44,762.005], [1052.17,802.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.63,589.662], [1070.22,636.182], [1053.66,583.066], [1053.35,628.514]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.22,636.212], [1069.82,682.213], [1053.35,628.543], [1053.04,673.496]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.82,682.242], [1069.42,727.733], [1053.04,673.524], [1052.74,717.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.89,446.807], [1071.47,494.938], [1054.6,443.58], [1054.28,490.563]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.47,494.969], [1071.05,542.554], [1054.28,490.593], [1053.97,537.056]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.05,542.584], [1070.63,589.632], [1053.97,537.086], [1053.66,583.037]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.2,298.947], [1072.76,348.806], [1055.58,299.328], [1055.25,347.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.76,348.806], [1072.32,398.058], [1055.25,347.956], [1054.92,396.007]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.32,398.089], [1071.89,446.776], [1054.92,396.037], [1054.6,443.55]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1073.2,298.947], [1073.64,248.535], [1055.58,299.328], [1055.91,250.174]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.82,682.242], [1069.42,727.732], [1098.51,678.676], [1097.96,723.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.42,727.761], [1069.02,772.75], [1097.96,723.776], [1097.41,768.355]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1069.02,772.75], [1097.41,768.356], [1068.66,814.026], [1096.9,809.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.63,589.662], [1070.22,636.182], [1099.64,586.964], [1099.07,633.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1070.22,636.212], [1069.82,682.213], [1099.07,633.074], [1098.51,678.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.47,494.969], [1071.05,542.554], [1100.8,493.178], [1100.22,540.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.05,542.584], [1070.63,589.632], [1100.22,540.334], [1099.64,586.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.76,348.806], [1072.32,398.058], [1102.58,348.458], [1101.98,397.219]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1072.32,398.089], [1071.89,446.776], [1101.98,397.25], [1101.38,445.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1071.89,446.807], [1071.47,494.938], [1101.38,445.487], [1100.8,493.148]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1073.2,298.947], [1073.64,248.534], [1103.19,299.103], [1103.8,249.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1073.2,298.947], [1072.76,348.806], [1103.19,299.103], [1102.58,348.458]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.45,731.838], [1111.81,777.245], [1097.96,723.776], [1097.41,768.356]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.81,777.245], [1111.22,818.901], [1097.41,768.356], [1096.9,809.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.1,685.89], [1112.45,731.809], [1098.51,678.676], [1097.96,723.748]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.42,592.423], [1113.75,639.392], [1099.64,586.963], [1099.07,633.045]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.75,639.421], [1113.1,685.861], [1099.07,633.074], [1098.51,678.647]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.76,496.801], [1115.09,544.856], [1100.8,493.178], [1100.22,540.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.09,544.886], [1114.42,592.393], [1100.22,540.334], [1099.64,586.934]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.14,398.949], [1116.45,448.128], [1101.98,397.25], [1101.38,445.456]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.45,448.159], [1115.76,496.771], [1101.38,445.487], [1100.8,493.148]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.85,349.162], [1117.14,398.918], [1102.58,348.458], [1101.98,397.219]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1118.56,298.787], [1119.28,247.847], [1103.19,299.103], [1103.8,249.205]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.56,298.787], [1117.85,349.162], [1103.19,299.103], [1102.58,348.458]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.81,777.245], [1111.22,818.901], [1195.29,764.005], [1194.3,804.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.45,731.838], [1111.81,777.245], [1196.37,719.831], [1195.29,764.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.75,639.422], [1113.1,685.861], [1198.56,629.97], [1197.46,675.118]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1113.1,685.89], [1112.45,731.809], [1197.45,675.146], [1196.37,719.803]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.09,544.886], [1114.42,592.393], [1200.79,538.108], [1199.67,584.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1114.42,592.423], [1113.75,639.392], [1199.67,584.293], [1198.56,629.941]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1115.76,496.801], [1115.09,544.856], [1201.93,491.407], [1200.79,538.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1116.45,448.159], [1115.76,496.771], [1203.08,444.18], [1201.93,491.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.85,349.162], [1117.14,398.918], [1205.42,348.114], [1204.24,396.388]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1117.14,398.949], [1116.45,448.128], [1204.24,396.419], [1203.08,444.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1118.56,298.787], [1117.85,349.162], [1206.61,299.257], [1205.42,348.114]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1118.56,298.787], [1119.27,247.847], [1206.61,299.257], [1207.81,249.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.05,769.808], [1204.99,810.835], [1195.29,764.005], [1194.3,804.541]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.2,725.094], [1206.05,769.808], [1196.37,719.832], [1195.29,764.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.36,679.855], [1207.2,725.065], [1197.45,675.146], [1196.37,719.803]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.53,634.112], [1208.36,679.826], [1198.56,629.97], [1197.46,675.118]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.72,587.855], [1209.53,634.082], [1199.67,584.293], [1198.56,629.941]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.92,541.078], [1210.72,587.826], [1200.79,538.109], [1199.67,584.264]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.14,493.77], [1211.93,541.048], [1201.93,491.407], [1200.79,538.079]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.37,445.923], [1213.14,493.74], [1203.08,444.18], [1201.93,491.377]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.61,397.527], [1214.37,445.892], [1204.24,396.419], [1203.08,444.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.87,348.573], [1215.61,397.496], [1205.42,348.114], [1204.24,396.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.05,769.808], [1204.99,810.835], [1253.11,762.218], [1251.84,802.603]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.14,299.051], [1216.87,348.573], [1206.61,299.257], [1205.42,348.114]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.2,725.094], [1206.05,769.808], [1254.5,718.212], [1253.11,762.218]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1218.14,299.051], [1219.43,248.984], [1206.61,299.257], [1207.81,249.869]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.36,679.855], [1207.2,725.065], [1255.9,673.697], [1254.5,718.183]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.53,634.112], [1208.36,679.826], [1257.32,628.695], [1255.9,673.669]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.72,587.855], [1209.53,634.082], [1258.75,583.197], [1257.32,628.666]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.92,541.078], [1210.72,587.826], [1260.19,537.195], [1258.75,583.168]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.14,493.77], [1211.93,541.048], [1261.66,490.68], [1260.2,537.165]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.37,445.923], [1213.14,493.74], [1263.14,443.644], [1261.66,490.65]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.61,397.527], [1214.37,445.892], [1264.64,396.078], [1263.14,443.614]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.87,348.573], [1215.61,397.496], [1266.15,347.973], [1264.64,396.048]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.14,299.051], [1216.87,348.573], [1267.68,299.32], [1266.15,347.973]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1218.14,299.051], [1219.43,248.984], [1267.68,299.32], [1269.23,250.141]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1247.04,757.538], [1245.81,797.525], [1289.15,750.833], [1287.73,790.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1248.37,713.969], [1247.04,757.538], [1290.69,707.891], [1289.15,750.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.73,669.901], [1248.37,713.94], [1292.24,664.465], [1290.69,707.863]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1251.09,625.357], [1249.73,669.873], [1293.82,620.576], [1292.24,664.437]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.48,580.326], [1251.1,625.328], [1295.41,576.215], [1293.82,620.547]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.87,534.802], [1252.48,580.297], [1297.02,531.376], [1295.41,576.187]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.29,488.776], [1253.88,534.773], [1298.64,486.051], [1297.02,531.348]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.72,442.24], [1255.29,488.747], [1300.28,440.231], [1298.64,486.022]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.16,395.186], [1256.72,442.21], [1301.94,393.909], [1300.28,440.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.62,347.604], [1258.16,395.156], [1303.62,347.075], [1301.95,393.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.1,299.486], [1259.62,347.604], [1305.32,299.722], [1303.62,347.075]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1261.1,299.486], [1262.59,250.853], [1305.32,299.723], [1307.04,251.872]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1277.49,745.346], [1276.15,784.298], [1350.49,733.917], [1348.85,771.894]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1278.95,702.918], [1277.49,745.346], [1352.29,692.562], [1350.49,733.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1280.43,660.018], [1278.95,702.891], [1354.1,650.758], [1352.29,692.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1281.92,616.666], [1280.43,659.99], [1355.92,608.525], [1354.1,650.731]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1283.43,572.854], [1281.92,616.638], [1357.77,565.857], [1355.93,608.498]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1284.95,528.576], [1283.43,572.826], [1359.64,522.747], [1357.77,565.83]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1286.49,483.823], [1284.95,528.547], [1361.53,479.188], [1359.64,522.72]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1288.05,438.589], [1286.49,483.795], [1363.43,435.173], [1361.53,479.16]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.62,392.865], [1288.05,438.56], [1365.36,390.694], [1363.43,435.145]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1291.21,346.643], [1289.62,392.836], [1367.3,345.746], [1365.36,390.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.82,299.916], [1291.21,346.643], [1369.27,300.318], [1367.3,345.745]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1292.82,299.916], [1294.44,252.705], [1369.27,300.318], [1371.26,254.435]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[546.394,295.705], [543.619,241.458], [544.72,296.791], [542.059,244.967]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[546.394,295.705], [562.995,295.793], [543.618,241.458], [560.331,241.741]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[546.394,295.705], [549.137,349.327], [544.72,296.791], [547.353,348.046]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[546.394,295.705], [549.137,349.327], [562.995,295.793], [565.628,349.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[549.137,349.327], [551.846,402.267], [547.353,348.046], [549.953,398.676]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[549.137,349.327], [565.628,349.224], [551.845,402.267], [568.227,401.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[551.847,402.3], [554.523,454.604], [549.955,398.708], [552.525,448.756]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[551.847,402.3], [568.229,402.011], [554.523,454.604], [570.797,454.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[554.525,454.637], [557.169,506.315], [552.526,448.787], [555.067,498.263]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[554.524,454.637], [570.799,454.166], [557.168,506.315], [573.337,505.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[557.17,506.348], [559.783,557.413], [555.069,498.294], [557.581,547.208]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[557.17,506.348], [573.338,505.7], [559.782,557.413], [575.846,556.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[559.784,557.445], [562.366,607.907], [557.582,547.239], [560.066,595.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[559.784,557.445], [575.848,556.624], [562.366,607.907], [578.326,606.917]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[565.52,294.659], [562.764,238.401], [562.995,295.793], [560.346,242.053]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[562.368,607.939], [564.919,657.809], [560.068,595.63], [562.523,643.448]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[565.437,294.652], [603.289,294.874], [562.664,238.053], [600.781,238.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[562.367,607.939], [578.327,606.949], [564.919,657.809], [580.777,656.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[564.921,657.841], [567.442,707.129], [562.525,643.478], [564.953,690.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[565.52,294.659], [568.258,350.562], [562.995,295.793], [565.628,349.224]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[564.92,657.841], [580.778,656.685], [567.442,707.129], [583.199,705.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[565.52,294.659], [568.258,350.562], [603.289,294.874], [605.767,350.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[568.258,350.562], [570.96,405.725], [565.628,349.224], [568.227,401.978]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[567.444,707.16], [569.936,755.876], [564.955,690.791], [567.356,737.549]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[567.443,707.16], [583.201,705.843], [569.936,755.876], [585.594,754.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[569.938,755.907], [572.401,804.061], [567.358,737.578], [569.732,783.819]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[568.177,350.57], [605.767,350.308], [570.88,405.747], [608.212,405.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[570.962,405.76], [573.63,460.233], [568.229,402.011], [570.797,454.133]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[572.401,804.061], [574.661,848.22], [569.732,783.819], [571.911,826.244]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[570.882,405.782], [608.214,405.05], [573.551,460.269], [610.629,459.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[573.632,460.267], [576.267,514.062], [570.799,454.166], [573.337,505.667]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[569.937,755.907], [585.595,754.433], [572.401,804.061], [587.96,802.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[572.401,804.062], [587.96,802.434], [574.66,848.22], [590.13,846.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[573.553,460.303], [610.631,459.112], [576.189,514.112], [613.016,512.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[576.269,514.096], [578.871,567.226], [573.338,505.7], [575.846,556.592]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[578.873,567.26], [581.443,619.736], [575.848,556.624], [578.326,606.917]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[576.191,514.145], [613.017,512.507], [578.795,567.288], [615.374,565.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[578.796,567.322], [615.375,565.247], [581.368,619.812], [617.703,617.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.445,619.77], [583.984,671.605], [578.328,606.949], [580.777,656.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[583.986,671.638], [586.494,722.844], [580.778,656.685], [583.199,705.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.369,619.844], [617.704,617.344], [583.91,671.693], [620.003,668.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.496,722.877], [588.974,773.465], [583.201,705.843], [585.594,754.402]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[583.911,671.725], [620.005,668.81], [586.421,722.944], [622.276,719.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.975,773.497], [591.424,823.479], [585.595,754.433], [587.96,802.434]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[586.422,722.976], [622.278,719.656], [588.901,773.577], [624.522,769.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[591.424,823.479], [593.668,869.293], [587.96,802.434], [590.13,846.454]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.903,773.609], [624.523,769.893], [591.352,823.602], [626.741,819.501]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[591.352,823.602], [626.741,819.501], [593.598,869.426], [628.774,864.977]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[607.031,293.871], [604.448,235.528], [603.289,294.873], [600.781,238.769]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.031,293.872], [609.582,351.49], [603.289,294.874], [605.767,350.308]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[607.031,293.871], [604.448,235.528], [726.924,294.601], [725.184,237.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.582,351.49], [612.099,408.324], [605.767,350.308], [608.212,405.016]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.031,293.872], [609.582,351.49], [726.924,294.602], [728.643,350.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.1,408.36], [614.584,464.461], [608.214,405.05], [610.629,459.078]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.582,351.49], [612.098,408.324], [728.643,350.629], [730.339,405.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[614.585,464.496], [617.037,519.878], [610.631,459.112], [613.016,512.474]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.1,408.36], [614.583,464.461], [730.34,405.949], [732.015,460.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.039,519.913], [619.46,574.59], [613.017,512.507], [615.374,565.214]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[614.585,464.496], [617.037,519.878], [732.016,460.575], [733.67,514.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.461,574.624], [621.851,628.609], [615.375,565.247], [617.702,617.312]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[617.039,519.913], [619.459,574.59], [733.671,514.52], [735.304,567.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.853,628.643], [624.213,681.949], [617.704,617.344], [620.003,668.778]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[619.461,574.624], [621.851,628.609], [735.305,567.796], [736.919,620.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[624.214,681.982], [626.545,734.622], [620.005,668.81], [622.276,719.624]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[621.852,628.643], [736.92,620.416], [624.212,681.949], [738.513,672.359]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.546,734.655], [628.848,786.642], [622.278,719.656], [624.522,769.862]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[624.214,681.982], [738.514,672.392], [626.544,734.622], [740.089,723.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.849,786.674], [631.122,838.019], [624.523,769.893], [626.741,819.501]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[626.546,734.655], [740.089,723.735], [628.847,786.642], [741.645,774.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.122,838.019], [633.205,885.066], [626.741,819.502], [628.774,864.977]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[628.849,786.674], [741.646,774.458], [631.122,838.019], [743.182,824.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[631.122,838.019], [743.182,824.539], [633.205,885.066], [744.59,870.443]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[730.565,294.174], [728.82,236.506], [726.924,294.602], [725.184,237.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.565,294.174], [732.289,351.133], [726.924,294.602], [728.643,350.629]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.29,351.133], [733.99,407.326], [728.643,350.629], [730.339,405.915]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[730.565,294.174], [728.82,236.507], [794.138,294.568], [792.829,237.78]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[730.565,294.174], [732.289,351.133], [794.138,294.568], [795.432,350.669]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.991,407.361], [735.67,462.837], [730.34,405.949], [732.015,460.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[732.289,351.133], [733.99,407.326], [795.432,350.669], [796.708,406.026]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.671,462.872], [737.329,517.645], [732.016,460.575], [733.669,514.486]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.33,517.679], [738.967,571.762], [733.671,514.52], [735.304,567.763]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[733.991,407.361], [735.67,462.837], [796.709,406.061], [797.969,460.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[735.671,462.872], [737.329,517.645], [797.97,460.756], [799.214,514.734]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.968,571.796], [740.584,625.202], [735.305,567.796], [736.918,620.383]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[737.33,517.679], [738.967,571.762], [799.215,514.768], [800.444,568.077]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.585,625.236], [742.181,677.978], [736.919,620.416], [738.513,672.359]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.182,678.011], [743.759,730.101], [738.514,672.392], [740.088,723.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[738.968,571.796], [800.445,568.111], [740.584,625.202], [801.659,620.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[740.585,625.236], [801.66,620.795], [742.181,677.978], [802.859,672.801]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.76,730.134], [745.317,781.584], [740.089,723.735], [741.644,774.426]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.318,781.616], [746.856,832.438], [741.645,774.458], [743.182,824.539]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[742.182,678.011], [802.86,672.834], [743.759,730.101], [804.044,724.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[743.76,730.134], [804.045,724.239], [745.317,781.584], [805.215,774.989]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.856,832.438], [748.266,879.013], [743.182,824.539], [744.59,870.443]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.318,781.616], [805.216,775.021], [746.856,832.438], [806.372,825.161]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[746.856,832.438], [806.372,825.161], [748.266,879.013], [807.431,871.118]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[804.063,294.241], [802.801,236.723], [867.871,294.642], [867.039,238.021]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[804.063,294.241], [805.309,351.054], [867.871,294.642], [868.693,350.581]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[805.309,351.055], [806.538,407.105], [868.693,350.581], [869.504,405.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[806.539,407.141], [807.752,462.478], [869.505,405.815], [870.306,460.322]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[807.753,462.513], [808.951,517.151], [870.306,460.357], [871.097,514.185]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[808.952,517.185], [810.135,571.137], [871.098,514.219], [871.879,567.382]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[810.136,571.171], [811.304,624.449], [871.879,567.415], [872.651,619.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[811.305,624.483], [812.459,677.1], [872.652,619.957], [873.414,671.824]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.46,677.133], [873.414,671.856], [813.599,729.101], [874.167,723.093]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.6,729.134], [874.168,723.126], [814.726,780.465], [874.911,773.744]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.726,780.498], [874.912,773.775], [815.838,831.204], [875.647,823.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.838,831.204], [875.647,823.786], [816.857,877.674], [876.32,869.626]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[862.238,295.044], [861.383,239.318], [971.612,295.72], [971.453,241.504]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[862.237,295.044], [863.082,350.108], [971.612,295.72], [971.769,349.311]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.082,350.108], [863.915,404.455], [971.769,349.311], [971.924,402.221]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[863.916,404.49], [864.739,458.166], [971.924,402.254], [972.077,454.529]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[864.739,458.2], [865.552,511.218], [972.077,454.562], [972.229,506.212]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[865.553,511.252], [866.356,563.624], [972.229,506.245], [972.378,557.282]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[866.357,563.657], [867.15,615.395], [972.378,557.315], [972.526,607.75]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.15,615.428], [867.934,666.543], [972.526,607.782], [972.672,657.625]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[867.935,666.575], [868.709,717.078], [972.672,657.657], [972.817,706.919]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[868.71,717.11], [869.475,767.013], [972.817,706.951], [972.959,755.642]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[869.475,767.044], [870.231,816.357], [972.959,755.673], [973.101,803.803]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[870.231,816.357], [870.925,861.565], [973.101,803.803], [973.23,847.94]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[960.871,296.288], [960.651,243.341], [994.701,296.492], [994.685,243.999]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[960.871,296.288], [961.088,348.64], [994.701,296.492], [994.717,348.399]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.088,348.64], [961.303,400.341], [994.717,348.4], [994.733,399.667]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.303,400.374], [961.515,451.468], [994.733,399.7], [994.749,450.371]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.515,451.5], [961.724,501.998], [994.749,450.403], [994.765,500.487]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.724,502.03], [961.932,551.943], [994.765,500.519], [994.78,550.027]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[961.932,551.974], [962.136,601.311], [994.78,550.058], [994.795,599]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.136,601.342], [994.795,599.031], [962.339,650.112], [994.81,647.417]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.339,650.143], [994.81,647.447], [962.539,698.358], [994.825,695.285]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.539,698.388], [994.825,695.315], [962.737,746.056], [994.84,742.615]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.737,746.086], [994.84,742.645], [962.932,793.217], [994.855,789.416]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[962.932,793.217], [994.855,789.416], [963.112,836.448], [994.868,832.321]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.48,688.576], [1064.11,735.068], [1050.53,679.334], [1050.24,724.716]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.11,735.097], [1063.74,781.079], [1050.24,724.744], [1049.96,769.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.74,781.079], [1063.4,823.267], [1049.96,769.64], [1049.7,810.843]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066,497.206], [1065.61,545.828], [1051.7,492.667], [1051.41,540.074]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.61,545.859], [1065.23,593.935], [1051.41,540.104], [1051.11,586.993]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.23,593.966], [1064.85,641.505], [1051.11,587.022], [1050.82,633.4]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.85,641.535], [1064.48,688.546], [1050.82,633.429], [1050.53,679.305]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.19,347.873], [1066.79,398.191], [1052.62,347.152], [1052.31,396.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.79,398.222], [1066.39,447.965], [1052.31,396.2], [1052.01,444.671]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.39,447.997], [1066,497.175], [1052.01,444.702], [1051.7,492.637]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1067.59,296.938], [1068,245.441], [1052.93,297.549], [1053.25,247.413]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.59,296.938], [1067.19,347.873], [1052.93,297.549], [1052.62,347.152]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1063.74,781.079], [1094.09,777.466], [1063.4,823.267], [1093.6,819.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.48,688.576], [1095.15,685.657], [1064.11,735.068], [1094.62,731.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.11,735.097], [1094.62,731.828], [1063.74,781.078], [1094.09,777.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.61,545.859], [1065.23,593.935], [1096.79,544.041], [1096.24,591.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1065.23,593.966], [1064.85,641.505], [1096.24,591.772], [1095.69,638.945]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1064.85,641.535], [1064.48,688.546], [1095.69,638.975], [1095.15,685.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.79,398.222], [1066.39,447.965], [1098.49,397.583], [1097.92,446.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066.39,447.997], [1066,497.175], [1097.92,446.956], [1097.35,495.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1066,497.206], [1065.61,545.828], [1097.35,495.772], [1096.79,544.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.59,296.938], [1067.19,347.873], [1099.66,297.131], [1099.07,347.645]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1067.19,347.873], [1066.79,398.191], [1099.07,347.645], [1098.49,397.552]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1067.59,296.938], [1068,245.441], [1099.66,297.131], [1100.25,246.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.89,740.447], [1106.28,786.988], [1094.62,731.828], [1094.09,777.466]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.28,786.989], [1105.72,829.685], [1094.09,777.467], [1093.6,819.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.13,645.725], [1107.5,693.323], [1095.69,638.975], [1095.15,685.627]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.5,693.353], [1106.89,740.418], [1095.15,685.657], [1094.62,731.799]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.39,548.835], [1108.76,597.525], [1096.79,544.041], [1096.24,591.742]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.76,597.556], [1108.13,645.695], [1096.24,591.772], [1095.69,638.945]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.69,449.702], [1110.04,499.522], [1097.92,446.956], [1097.35,495.741]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.04,499.554], [1109.39,548.804], [1097.35,495.772], [1096.79,544.01]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.35,399.269], [1110.69,449.67], [1098.49,397.583], [1097.92,446.924]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.69,296.622], [1112.01,348.246], [1099.66,297.131], [1099.07,347.645]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.02,348.246], [1111.35,399.237], [1099.07,347.645], [1098.49,397.552]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1112.69,296.622], [1113.37,244.419], [1099.66,297.131], [1100.25,246.064]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.89,740.447], [1106.28,786.988], [1197.49,730.503], [1196.41,776.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1106.28,786.989], [1105.72,829.685], [1196.41,776.003], [1195.41,817.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1107.5,693.353], [1106.89,740.418], [1198.59,684.474], [1197.49,730.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.76,597.556], [1108.13,645.695], [1200.83,590.883], [1199.7,637.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1108.13,645.725], [1107.5,693.323], [1199.7,637.937], [1198.59,684.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.04,499.554], [1109.39,548.804], [1203.11,495.191], [1201.96,543.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1109.39,548.835], [1108.76,597.525], [1201.96,543.304], [1200.83,590.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1110.69,449.702], [1110.04,499.522], [1204.27,446.534], [1203.11,495.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.01,348.246], [1111.35,399.237], [1206.63,347.553], [1205.45,397.293]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1111.35,399.269], [1110.69,449.67], [1205.45,397.324], [1204.27,446.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1112.69,296.622], [1112.01,348.246], [1207.84,297.209], [1206.63,347.553]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1112.69,296.622], [1113.37,244.419], [1207.84,297.209], [1209.05,246.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.91,782.297], [1204.85,824.59], [1196.41,776.003], [1195.41,817.754]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.06,736.2], [1205.91,782.297], [1197.49,730.503], [1196.41,776.003]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.23,689.561], [1207.06,736.171], [1198.59,684.474], [1197.49,730.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.41,642.399], [1208.23,689.531], [1199.7,637.937], [1198.59,684.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.6,594.706], [1209.41,642.368], [1200.83,590.883], [1199.7,637.907]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.81,546.472], [1210.6,594.675], [1201.96,543.304], [1200.83,590.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.03,497.69], [1211.81,546.441], [1203.11,495.191], [1201.96,543.274]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.26,448.348], [1213.03,497.658], [1204.27,446.534], [1203.11,495.16]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.51,398.438], [1214.27,448.317], [1205.45,397.324], [1204.27,446.503]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.91,782.297], [1204.85,824.59], [1257.25,775.937], [1255.95,817.682]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.78,347.95], [1215.51,398.406], [1206.63,347.553], [1205.45,397.293]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.06,736.2], [1205.91,782.297], [1258.67,730.443], [1257.25,775.936]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.06,296.873], [1216.78,347.95], [1207.84,297.209], [1206.63,347.553]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.23,689.561], [1207.06,736.171], [1260.1,684.421], [1258.67,730.414]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1218.06,296.873], [1219.35,245.231], [1207.84,297.209], [1209.05,246.317]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1209.41,642.399], [1208.23,689.531], [1261.55,637.89], [1260.1,684.391]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.6,594.706], [1209.41,642.369], [1263.02,590.843], [1261.55,637.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.81,546.472], [1210.6,594.675], [1264.5,543.271], [1263.02,590.813]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.03,497.69], [1211.81,546.441], [1266,495.165], [1264.5,543.241]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1214.26,448.348], [1213.03,497.658], [1267.51,446.515], [1266,495.134]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1215.51,398.438], [1214.27,448.317], [1269.05,397.313], [1267.52,446.484]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1216.78,347.95], [1215.51,398.406], [1270.6,347.549], [1269.05,397.281]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1218.06,296.873], [1216.78,347.95], [1272.17,297.213], [1270.6,347.548]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1218.06,296.873], [1219.35,245.231], [1272.17,297.213], [1273.75,246.328]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252.24,770.928], [1250.98,812.242], [1298.37,765.283], [1296.9,806.11]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.62,725.91], [1252.24,770.928], [1299.97,720.802], [1298.37,765.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.01,680.374], [1253.62,725.881], [1301.6,675.816], [1299.98,720.773]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.42,634.342], [1255.01,680.345], [1303.24,630.344], [1301.6,675.787]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.84,587.804], [1256.42,634.312], [1304.89,584.38], [1303.24,630.315]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.27,540.752], [1257.84,587.774], [1306.57,537.915], [1304.89,584.351]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.73,493.178], [1259.27,540.722], [1308.26,490.941], [1306.57,537.885]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.2,445.073], [1260.73,493.147], [1309.97,443.449], [1308.26,490.91]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.68,396.427], [1262.2,445.042], [1311.71,395.431], [1309.98,443.418]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.19,347.233], [1263.68,396.396], [1313.46,346.878], [1311.71,395.4]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.71,297.48], [1265.19,347.233], [1315.23,297.781], [1313.46,346.878]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1266.71,297.48], [1268.24,247.192], [1315.23,297.781], [1317.02,248.163]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1287.71,759.273], [1286.31,799.58], [1368.07,749.6], [1366.32,789.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1289.23,715.364], [1287.71,759.273], [1369.98,706.614], [1368.07,749.6]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1290.77,670.963], [1289.23,715.336], [1371.9,663.156], [1369.98,706.586]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1292.33,626.089], [1290.78,670.934], [1373.85,619.246], [1371.9,663.128]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1293.91,580.736], [1292.33,626.06], [1375.81,574.877], [1373.85,619.218]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.5,534.896], [1293.91,580.707], [1377.8,530.042], [1375.82,574.849]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1297.11,488.56], [1295.5,534.866], [1379.81,484.734], [1377.8,530.014]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1298.74,441.721], [1297.11,488.531], [1381.84,438.945], [1379.81,484.705]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.39,394.371], [1298.74,441.691], [1383.89,392.668], [1381.84,438.916]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.05,346.5], [1300.39,394.34], [1385.96,345.893], [1383.89,392.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.73,298.101], [1302.05,346.5], [1388.06,298.614], [1385.96,345.893]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1303.73,298.101], [1305.43,249.196], [1388.06,298.615], [1390.18,250.854]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1343.46,737.307], [1341.88,775.708], [1369.17,734.322], [1367.48,772.463]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1345.19,695.497], [1343.46,737.307], [1371.01,692.798], [1369.17,734.322]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1346.94,653.239], [1345.19,695.47], [1372.87,650.832], [1371.01,692.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1348.7,610.555], [1346.94,653.212], [1374.76,608.446], [1372.88,650.805]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1350.48,567.439], [1348.7,610.528], [1376.65,565.634], [1374.76,608.419]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1352.28,523.882], [1350.48,567.411], [1378.57,522.388], [1376.66,565.606]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1354.1,479.88], [1352.28,523.854], [1380.51,478.702], [1378.57,522.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1355.94,435.424], [1354.1,479.851], [1382.47,434.57], [1380.51,478.674]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1357.79,390.508], [1355.94,435.395], [1384.45,389.984], [1382.47,434.541]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1359.67,345.124], [1357.79,390.479], [1386.45,344.938], [1384.45,389.955]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1361.56,299.265], [1359.67,345.124], [1388.47,299.423], [1386.45,344.937]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1361.56,299.265], [1363.48,252.954], [1388.47,299.423], [1390.51,253.463]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[557.327,294.714], [541.021,294.638], [554.724,241.477], [538.314,241.264]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[559.902,347.362], [557.327,294.714], [543.698,347.419], [541.021,294.638]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[559.902,347.363], [543.697,347.42], [562.445,399.365], [546.341,399.553]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[562.447,399.398], [546.343,399.585], [564.96,450.799], [548.956,451.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[564.962,450.832], [548.958,451.146], [567.447,501.642], [551.541,502.081]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[590.448,293.491], [552.999,293.292], [587.942,238.065], [550.245,237.51]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[567.448,501.674], [551.543,502.113], [569.905,551.903], [554.096,552.464]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.925,348.276], [590.448,293.491], [555.838,348.419], [553.117,293.3]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[569.906,551.935], [554.098,552.495], [572.335,601.593], [556.622,602.272]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[592.925,348.277], [555.722,348.425], [595.371,402.365], [558.409,402.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[572.336,601.625], [556.624,602.304], [574.737,650.721], [559.12,651.517]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.372,402.399], [558.411,402.887], [597.789,455.838], [561.066,456.656]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[574.739,650.753], [559.121,651.548], [577.113,699.298], [561.589,700.206]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[559.122,651.548], [561.589,700.206], [562.899,637.467], [565.241,684.115]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.79,455.871], [561.068,456.69], [600.178,508.671], [563.691,509.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[577.114,699.328], [561.591,700.237], [579.462,747.331], [564.031,748.35]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.179,508.704], [563.692,509.845], [602.538,560.876], [566.284,562.332]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[579.463,747.361], [564.032,748.381], [581.785,794.83], [566.445,795.958]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.54,560.909], [566.285,562.365], [604.871,612.465], [568.846,614.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.785,794.83], [566.445,795.958], [583.914,838.378], [568.659,839.604]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.873,612.497], [568.848,614.261], [607.176,663.447], [571.378,665.511]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[607.178,663.479], [571.38,665.543], [609.455,713.835], [573.881,716.192]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[609.456,713.866], [573.882,716.223], [611.707,763.637], [576.354,766.28]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[611.708,763.668], [576.356,766.312], [613.933,812.865], [578.799,815.787]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[613.933,812.865], [578.799,815.787], [615.973,857.979], [581.039,861.154]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[588.183,292.233], [708.202,292.896], [585.561,234.557], [706.387,236.406]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.774,349.215], [588.184,292.233], [709.996,348.72], [708.202,292.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.774,349.215], [709.996,348.72], [593.33,405.444], [711.766,403.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.332,405.48], [711.768,403.857], [595.856,461.006], [713.516,458.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.858,461.041], [713.518,458.317], [598.351,515.878], [715.245,512.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.352,515.912], [715.246,512.115], [600.814,570.072], [716.953,565.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.816,570.106], [716.954,565.262], [603.248,623.601], [718.64,617.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[603.25,623.635], [718.641,617.769], [605.652,676.477], [720.307,669.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[605.654,676.511], [720.308,669.648], [608.027,728.713], [721.954,720.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[605.654,676.511], [608.027,728.713], [607.178,663.48], [609.455,713.835]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[608.028,728.745], [721.955,720.91], [610.373,780.318], [723.582,771.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.375,780.351], [612.691,831.306], [611.708,763.669], [613.933,812.865]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[610.374,780.351], [723.583,771.567], [612.691,831.306], [725.191,821.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[612.691,831.306], [725.191,821.597], [614.814,878.014], [726.664,867.467]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[709.252,292.351], [707.412,234.886], [708.202,292.896], [706.386,236.406]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[709.252,292.351], [707.412,234.886], [773.699,292.713], [772.286,235.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.069,349.127], [709.252,292.351], [709.996,348.72], [708.202,292.896]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.069,349.127], [709.252,292.351], [775.094,348.857], [773.699,292.713]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.069,349.127], [712.863,405.156], [709.996,348.72], [711.766,403.822]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.069,349.127], [712.863,405.156], [775.094,348.857], [776.471,404.27]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.864,405.192], [714.635,460.523], [711.767,403.857], [713.516,458.283]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[712.864,405.192], [776.472,404.305], [714.635,460.523], [777.833,459.036]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.636,460.558], [716.386,515.204], [713.517,458.317], [715.245,512.081]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[714.636,460.558], [777.834,459.07], [716.386,515.204], [779.177,513.13]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.387,515.238], [718.115,569.212], [715.246,512.115], [716.952,565.228]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[716.387,515.239], [779.178,513.164], [718.115,569.212], [780.505,566.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.116,569.246], [719.823,622.56], [716.953,565.262], [718.64,617.736]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[718.116,569.247], [780.506,566.6], [719.823,622.56], [781.818,619.357]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.824,622.594], [721.51,675.26], [718.641,617.769], [720.307,669.615]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[719.824,622.594], [781.818,619.39], [721.51,675.26], [783.114,671.512]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.511,675.293], [723.177,727.323], [720.308,669.648], [721.954,720.878]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[721.511,675.293], [783.115,671.544], [723.177,727.323], [784.395,723.044]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.178,727.355], [724.824,778.76], [721.955,720.91], [723.581,771.535]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[723.178,727.355], [784.396,723.076], [724.824,778.76], [785.66,773.963]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.824,778.793], [726.451,829.584], [723.583,771.567], [725.19,821.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[724.824,778.793], [785.661,773.995], [726.451,829.584], [786.911,824.281]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.451,829.584], [727.941,876.143], [725.19,821.597], [726.664,867.467]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[726.451,829.584], [786.911,824.281], [727.941,876.143], [788.057,870.382]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[781.539,292.279], [780.158,234.685], [846.866,292.651], [845.914,235.724]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.904,349.181], [781.539,292.279], [847.807,348.903], [846.866,292.651]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[782.904,349.181], [784.251,405.333], [847.807,348.903], [848.736,404.421]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[784.252,405.368], [785.582,460.819], [848.736,404.456], [849.653,459.289]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[785.582,460.854], [786.896,515.617], [849.654,459.323], [850.56,513.483]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[786.897,515.651], [850.56,513.517], [788.194,569.739], [851.455,567.017]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[788.195,569.773], [851.456,567.051], [789.476,623.198], [852.34,619.902]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[789.477,623.231], [852.341,619.935], [790.742,676.005], [853.214,672.15]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[790.743,676.039], [853.214,672.183], [791.994,728.174], [854.077,723.772]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[791.994,728.206], [854.078,723.805], [793.23,779.714], [854.931,774.78]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[793.23,779.747], [854.931,774.812], [794.451,830.638], [855.774,825.184]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[794.451,830.638], [855.774,825.184], [795.57,877.288], [856.546,871.363]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[843.624,293.172], [842.667,237.176], [956.687,293.806], [956.439,238.943]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.569,348.514], [843.624,293.172], [956.933,348.041], [956.687,293.806]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[844.57,348.514], [845.503,403.146], [956.933,348.041], [957.175,401.593]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[845.504,403.181], [846.426,457.149], [957.176,401.627], [957.415,454.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[846.427,457.183], [847.338,510.499], [957.415,454.575], [957.652,506.863]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[847.338,510.533], [848.238,563.21], [957.652,506.896], [957.886,558.569]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[848.239,563.243], [849.128,615.291], [957.886,558.602], [958.118,609.67]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[849.129,615.324], [850.008,666.755], [958.118,609.702], [958.346,660.176]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.008,666.787], [850.877,717.612], [958.346,660.208], [958.572,710.099]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[850.878,717.644], [851.736,767.873], [958.572,710.13], [958.796,759.447]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[851.736,767.904], [852.585,817.548], [958.796,759.478], [959.017,808.231]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[852.585,817.548], [853.363,863.067], [959.017,808.232], [959.219,852.944]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[949.214,294.553], [948.927,241.026], [984.425,294.745], [984.348,241.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.497,347.484], [949.214,294.553], [984.5,347.34], [984.424,294.745]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.497,347.484], [949.777,399.763], [984.501,347.34], [984.576,399.291]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[949.778,399.796], [950.055,451.467], [984.576,399.324], [984.65,450.675]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.055,451.5], [950.328,502.573], [984.65,450.707], [984.724,501.468]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.328,502.606], [950.599,553.093], [984.724,501.5], [984.796,551.681]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.599,553.125], [984.796,551.713], [950.867,603.035], [984.868,601.324]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[950.867,603.066], [984.868,601.356], [951.131,652.409], [984.939,650.407]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.131,652.44], [984.939,650.437], [951.393,701.226], [985.009,698.938]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.393,701.257], [985.009,698.968], [951.651,749.494], [985.079,746.927]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.652,749.525], [985.079,746.957], [951.907,797.223], [985.147,794.383]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[951.907,797.223], [985.147,794.384], [952.142,840.979], [985.21,837.893]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.38,788.078], [1057.08,831.037], [1046.72,776.053], [1046.48,817.962]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.38,645.992], [1058.04,693.858], [1047.52,637.519], [1047.25,684.175]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.04,693.888], [1057.71,741.227], [1047.25,684.205], [1046.99,730.361]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.71,741.257], [1057.38,788.078], [1046.99,730.39], [1046.72,776.053]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.77,448.949], [1059.42,499.015], [1048.64,445.601], [1048.35,494.343]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.42,499.046], [1059.07,548.549], [1048.35,494.374], [1048.07,542.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.07,548.58], [1058.72,597.528], [1048.07,542.612], [1047.8,590.294]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.72,597.558], [1058.38,645.961], [1047.8,590.324], [1047.53,637.489]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.49,347.021], [1060.85,295.172], [1049.21,346.415], [1049.5,295.983]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.49,347.021], [1060.13,398.245], [1049.21,346.415], [1048.92,396.253]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.13,398.277], [1059.77,448.917], [1048.92,396.284], [1048.64,445.57]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1060.85,295.172], [1061.22,242.751], [1049.5,295.984], [1049.8,245.013]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.71,741.257], [1089.89,738.786], [1057.38,788.078], [1089.39,785.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1057.38,788.078], [1089.39,785.344], [1057.08,831.037], [1088.93,828.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.72,597.558], [1091.43,595.913], [1058.38,645.961], [1090.91,644.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.38,645.991], [1090.91,644.065], [1058.04,693.858], [1090.4,691.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1058.04,693.888], [1090.4,691.686], [1057.71,741.227], [1089.89,738.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.77,448.949], [1059.42,499.015], [1093.03,448.187], [1092.49,497.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.42,499.046], [1059.07,548.549], [1092.49,497.983], [1091.96,547.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1059.07,548.58], [1058.72,597.527], [1091.96,547.222], [1091.43,595.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.49,347.021], [1060.13,398.245], [1094.13,346.883], [1093.57,397.791]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.13,398.277], [1059.77,448.917], [1093.57,397.824], [1093.03,448.155]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1060.85,295.172], [1061.22,242.751], [1094.68,295.356], [1095.24,243.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1060.49,347.021], [1060.85,295.172], [1094.13,346.883], [1094.68,295.356]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.63,747.89], [1099.07,795.415], [1089.89,738.786], [1089.39,785.344]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.07,795.415], [1098.54,839.014], [1089.39,785.344], [1088.93,828.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.79,651.165], [1100.21,699.769], [1090.91,644.065], [1090.4,691.656]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.21,699.799], [1099.63,747.859], [1090.4,691.686], [1089.89,738.757]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.97,552.226], [1101.38,601.945], [1091.96,547.222], [1091.43,595.882]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.38,601.977], [1100.79,651.134], [1091.43,595.913], [1090.91,644.034]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.58,501.902], [1101.97,552.194], [1092.49,497.983], [1091.96,547.191]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.8,399.495], [1103.18,450.962], [1093.57,397.824], [1093.03,448.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.18,450.995], [1102.58,501.869], [1093.03,448.187], [1092.49,497.952]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.42,347.392], [1105.05,294.675], [1094.13,346.883], [1094.68,295.356]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.42,347.392], [1103.8,399.462], [1094.13,346.883], [1093.58,397.791]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1105.05,294.675], [1105.69,241.367], [1094.68,295.357], [1095.24,243.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.63,747.89], [1099.07,795.415], [1196.18,740.3], [1195.1,787.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1099.07,795.415], [1098.54,839.014], [1195.1,787.019], [1194.1,829.886]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.79,651.165], [1100.21,699.769], [1198.39,645.245], [1197.28,693.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1100.21,699.8], [1099.63,747.86], [1197.28,693.035], [1196.18,740.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.97,552.226], [1101.38,601.945], [1200.65,548.054], [1199.51,596.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1101.38,601.977], [1100.79,651.134], [1199.51,596.921], [1198.39,645.215]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1102.57,501.902], [1101.97,552.194], [1201.8,498.635], [1200.65,548.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.8,399.495], [1103.18,450.962], [1204.13,398.101], [1202.96,448.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1103.18,450.995], [1102.58,501.869], [1202.96,448.654], [1201.8,498.603]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.42,347.392], [1105.05,294.675], [1205.32,346.968], [1206.52,295.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1104.42,347.392], [1103.8,399.462], [1205.32,346.968], [1204.13,398.069]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1105.05,294.675], [1105.69,241.367], [1206.52,295.243], [1207.74,242.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.1,793.766], [1202.05,837.221], [1195.1,787.019], [1194.1,829.886]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.25,746.399], [1203.1,793.766], [1196.18,740.3], [1195.1,787.019]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.41,698.471], [1204.25,746.369], [1197.28,693.035], [1196.18,740.27]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.58,650.002], [1205.41,698.44], [1198.39,645.245], [1197.28,693.005]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.76,600.984], [1206.58,649.971], [1199.51,596.921], [1198.39,645.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.96,551.406], [1207.77,600.952], [1200.65,548.054], [1199.51,596.89]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.18,501.26], [1208.96,551.374], [1201.8,498.635], [1200.65,548.023]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.4,450.535], [1210.18,501.228], [1202.96,448.654], [1201.8,498.603]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.1,793.766], [1202.05,837.221], [1258.41,788.853], [1257.09,831.88]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.65,399.221], [1211.41,450.502], [1204.13,398.101], [1202.96,448.622]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.25,746.399], [1203.1,793.766], [1259.85,741.958], [1258.41,788.853]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.9,347.309], [1212.65,399.189], [1205.32,346.968], [1204.13,398.069]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.41,698.471], [1204.25,746.369], [1261.3,694.513], [1259.85,741.928]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.9,347.309], [1215.17,294.787], [1205.32,346.968], [1206.52,295.243]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.58,650.002], [1205.41,698.44], [1262.77,646.538], [1261.3,694.482]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1215.17,294.787], [1216.46,241.679], [1206.52,295.243], [1207.74,242.951]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.76,600.984], [1206.58,649.971], [1264.26,598.025], [1262.77,646.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1208.96,551.406], [1207.77,600.952], [1265.77,548.965], [1264.26,597.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1210.18,501.26], [1208.96,551.374], [1267.29,499.348], [1265.77,548.933]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1211.4,450.535], [1210.18,501.228], [1268.83,449.165], [1267.29,499.316]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1212.65,399.221], [1211.41,450.502], [1270.39,398.406], [1268.83,449.133]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.9,347.309], [1212.65,399.189], [1271.96,347.061], [1270.39,398.373]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1213.9,347.309], [1215.17,294.787], [1271.96,347.06], [1273.56,295.119]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1215.17,294.787], [1216.46,241.679], [1273.55,295.119], [1275.17,242.605]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.65,783.547], [1253.36,826.111], [1304.6,779.163], [1303.08,821.344]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.05,737.162], [1254.65,783.547], [1306.26,733.2], [1304.6,779.163]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.47,690.239], [1256.05,737.132], [1307.93,686.709], [1306.26,733.171]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.9,642.799], [1257.47,690.209], [1309.63,639.71], [1307.93,686.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.35,594.832], [1258.9,642.768], [1311.34,592.194], [1309.63,639.679]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261.81,546.33], [1260.35,594.801], [1313.07,544.155], [1311.34,592.164]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1263.3,497.285], [1261.82,546.299], [1314.83,495.582], [1313.08,544.124]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.8,447.687], [1263.3,497.254], [1316.6,446.466], [1314.83,495.55]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1266.31,397.526], [1264.8,447.655], [1318.39,396.799], [1316.6,446.435]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.84,346.793], [1266.31,397.494], [1320.2,346.572], [1318.39,396.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.84,346.792], [1269.4,295.478], [1320.2,346.571], [1322.03,295.774]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1269.4,295.478], [1270.96,243.604], [1322.03,295.774], [1323.89,244.429]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1295.16,772.644], [1293.71,814.255], [1382.74,765.082], [1380.89,806.03]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1296.74,727.31], [1295.16,772.644], [1384.75,720.478], [1382.74,765.082]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1298.35,681.461], [1296.75,727.28], [1386.79,675.375], [1384.75,720.449]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.97,635.119], [1298.35,681.432], [1388.85,629.796], [1386.79,675.346]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1301.6,588.275], [1299.97,635.089], [1390.93,583.732], [1388.85,629.766]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1303.26,540.922], [1301.6,588.245], [1393.03,537.175], [1390.93,583.702]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.93,493.051], [1303.26,540.891], [1395.16,490.118], [1393.03,537.145]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.62,444.653], [1304.93,493.02], [1397.31,442.553], [1395.16,490.088]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1308.33,395.72], [1306.62,444.622], [1399.48,394.47], [1397.31,442.522]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.06,346.243], [1308.33,395.689], [1401.67,345.863], [1399.48,394.44]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1310.06,346.243], [1311.81,296.213], [1401.67,345.863], [1403.89,296.722]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1311.81,296.213], [1313.57,245.653], [1403.89,296.722], [1406.14,247.07]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1360.28,751.647], [1358.59,791.414], [1388.36,749.306], [1386.55,788.867]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1362.12,708.342], [1360.28,751.647], [1390.33,706.228], [1388.36,749.306]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1363.98,664.568], [1362.12,708.314], [1392.32,662.686], [1390.33,706.201]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1365.86,620.345], [1363.98,664.54], [1394.34,618.7], [1392.32,662.658]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1367.75,575.667], [1365.86,620.317], [1396.37,574.263], [1394.34,618.672]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1369.67,530.526], [1367.75,575.638], [1398.42,529.369], [1396.37,574.235]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1371.61,484.915], [1369.67,530.497], [1400.5,484.01], [1398.42,529.34]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.56,438.827], [1371.61,484.886], [1402.59,438.179], [1400.5,483.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.54,392.254], [1373.57,438.798], [1404.71,391.869], [1402.6,438.15]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.54,345.189], [1375.54,392.225], [1406.85,345.072], [1404.71,391.839]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.54,345.189], [1379.56,297.623], [1406.85,345.072], [1409.02,297.78]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1379.56,297.623], [1381.6,249.58], [1409.02,297.78], [1411.2,250.017]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[557.536,294.362], [555.018,242.173], [541.747,294.313], [539.134,242.045]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[560.028,345.994], [557.536,294.362], [544.332,346.021], [541.748,294.313]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[583.425,292.928], [580.952,238.464], [546.96,292.791], [544.259,238.109]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[560.028,345.994], [562.49,397.011], [544.332,346.021], [546.886,397.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[562.491,397.043], [546.887,397.146], [564.925,447.489], [549.413,447.666]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[585.87,346.784], [583.425,292.928], [549.778,346.854], [547.109,292.8]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[585.87,346.784], [588.286,399.973], [549.632,346.859], [552.27,400.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[549.415,447.698], [551.912,497.654], [559.528,442.413], [561.862,490.211]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[564.927,447.521], [549.414,447.698], [567.334,497.405], [551.911,497.654]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[567.336,497.437], [551.913,497.685], [569.716,546.768], [554.382,547.087]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[588.287,400.006], [590.674,452.575], [552.271,400.289], [554.878,453.06]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[551.913,497.685], [554.383,547.087], [561.863,490.24], [564.173,537.531]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[590.676,452.608], [554.88,453.093], [593.035,504.566], [557.457,505.249]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[569.717,546.799], [554.384,547.118], [572.072,595.587], [556.826,595.975]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[572.073,595.618], [556.828,596.006], [574.402,643.872], [559.243,644.327]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[593.036,504.599], [557.459,505.282], [595.368,555.957], [560.006,556.834]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[574.403,643.902], [559.245,644.358], [576.706,691.63], [561.634,692.151]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[595.37,555.99], [560.007,556.866], [597.675,606.759], [562.525,607.824]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[576.708,691.66], [561.635,692.181], [578.986,738.871], [563.998,739.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[597.677,606.791], [562.526,607.856], [599.956,656.981], [565.015,658.231]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[578.987,738.901], [564,739.486], [581.241,785.602], [566.337,786.251]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[599.957,657.012], [565.017,658.262], [602.21,706.633], [567.477,708.063]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[581.241,785.602], [566.337,786.251], [583.309,828.46], [568.483,829.167]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.212,706.664], [567.479,708.094], [604.439,755.725], [569.911,757.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[570.048,757.26], [572.452,805.931], [578.987,738.901], [581.241,785.602]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[604.441,755.756], [569.913,757.362], [606.644,804.266], [572.318,806.045]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[693.655,291.994], [691.791,236.047], [575.54,291.533], [572.918,234.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[606.644,804.266], [572.318,806.045], [608.664,848.765], [574.524,850.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.497,347.298], [693.655,291.994], [578.132,347.552], [575.54,291.533]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[695.497,347.298], [697.316,401.9], [578.132,347.552], [580.69,402.852]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[697.317,401.935], [699.115,455.883], [580.692,402.887], [583.219,457.515]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.116,455.917], [700.892,509.222], [583.221,457.55], [585.718,511.52]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[700.893,509.256], [702.648,561.93], [585.719,511.553], [588.186,564.876]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[702.649,561.963], [704.383,614.017], [588.188,564.91], [590.625,617.597]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[704.384,614.05], [590.627,617.63], [706.098,665.494], [593.036,669.693]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[706.099,665.527], [593.037,669.725], [707.793,716.373], [595.418,721.175]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[707.794,716.405], [595.419,721.207], [709.468,766.663], [597.771,772.054]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[709.469,766.695], [597.773,772.086], [711.124,816.374], [600.098,822.341]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[711.124,816.374], [600.098,822.341], [712.642,861.934], [602.23,868.422]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[756.39,291.635], [692.177,291.38], [754.896,235.118], [690.271,234.457]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.866,347.496], [756.39,291.635], [694.06,347.636], [692.177,291.38]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.866,347.496], [759.324,402.641], [694.06,347.636], [695.918,403.167]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[759.325,402.676], [695.92,403.202], [760.765,457.154], [697.756,458.057]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[760.766,457.189], [697.757,458.091], [762.189,511.012], [699.571,512.282]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[762.19,511.046], [699.572,512.316], [763.595,564.225], [701.364,565.853]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[763.596,564.258], [701.365,565.887], [764.985,616.805], [703.136,618.784]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[764.986,616.838], [703.137,618.817], [766.359,668.765], [704.887,671.085]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[766.36,668.797], [704.888,671.118], [767.716,720.113], [706.617,722.767]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[767.717,720.146], [706.618,722.799], [769.058,770.862], [708.327,773.841]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[769.058,770.894], [708.328,773.873], [770.384,821.022], [710.016,824.319]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[770.384,821.022], [710.016,824.319], [771.599,866.987], [711.565,870.572]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[762.048,291.127], [827.774,291.392], [760.568,233.802], [826.715,234.488]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[763.51,347.775], [762.048,291.127], [828.82,347.629], [827.774,291.392]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[763.51,347.775], [828.82,347.63], [764.953,403.689], [829.853,403.143]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[764.954,403.724], [829.853,403.178], [766.38,458.952], [830.874,458.015]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[766.38,458.987], [830.874,458.049], [767.789,513.541], [831.882,512.222]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[767.789,513.575], [831.883,512.257], [769.181,567.468], [832.879,565.777]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[769.181,567.502], [832.879,565.811], [770.556,620.746], [833.863,618.692]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[770.557,620.779], [833.864,618.725], [771.914,673.385], [834.836,670.977]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[771.915,673.418], [834.836,671.01], [773.257,725.398], [835.797,722.643]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[773.258,725.43], [835.798,722.676], [774.584,776.795], [836.747,773.703]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[774.584,776.827], [836.748,773.735], [775.895,827.587], [837.686,824.166]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[775.895,827.587], [837.686,824.166], [777.096,874.125], [838.546,870.405]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[826.973,291.989], [825.927,236.034], [941.964,292.445], [941.628,237.214]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.007,347.301], [826.973,291.989], [942.296,347.05], [941.964,292.445]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[828.007,347.301], [829.028,401.911], [942.296,347.05], [942.624,400.97]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[829.028,401.945], [830.037,455.901], [942.624,401.005], [942.949,454.287]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[830.038,455.935], [831.034,509.248], [942.949,454.321], [943.269,506.976]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[831.035,509.282], [832.02,561.963], [943.269,507.01], [943.586,559.049]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.02,561.996], [943.586,559.082], [832.994,614.057], [943.899,610.516]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[832.994,614.09], [943.899,610.549], [833.956,665.542], [944.209,661.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[833.957,665.574], [944.209,661.421], [834.907,716.427], [944.514,711.676]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[834.908,716.459], [944.515,711.708], [835.848,766.724], [944.817,761.389]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[835.848,766.755], [944.817,761.42], [836.777,816.441], [945.116,810.537]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[836.777,816.441], [945.116,810.537], [837.629,862.007], [945.39,855.585]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[937.94,293.314], [937.589,239.462], [974.044,293.454], [973.907,239.823]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.288,346.571], [937.94,293.314], [974.18,346.494], [974.044,293.454]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.288,346.571], [938.631,399.177], [974.18,346.495], [974.315,398.889]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.631,399.21], [938.971,451.208], [974.315,398.922], [974.448,450.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[938.971,451.241], [974.448,450.746], [939.306,502.642], [974.579,501.946]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.306,502.674], [974.579,501.978], [939.638,553.489], [974.709,552.595]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.638,553.521], [974.71,552.627], [939.966,603.758], [974.838,602.672]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[939.966,603.79], [974.838,602.703], [940.29,653.46], [974.965,652.186]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.291,653.492], [974.965,652.217], [940.611,702.604], [975.091,701.146]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.611,702.635], [975.091,701.177], [940.928,751.2], [975.215,749.562]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[940.928,751.231], [975.215,749.592], [941.242,799.256], [975.338,797.442]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[941.242,799.257], [975.338,797.443], [941.529,843.316], [975.45,841.342]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.16,600.246], [1050.86,649.302], [1043.72,592.783], [1043.47,640.545]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.86,649.333], [1050.57,697.845], [1043.47,640.575], [1043.22,687.821]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.57,697.876], [1050.27,745.854], [1043.22,687.851], [1042.98,734.591]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.27,745.884], [1049.98,793.337], [1042.97,734.62], [1042.73,780.861]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.98,793.337], [1049.72,836.876], [1042.73,780.861], [1042.51,823.301]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.39,398.27], [1052.08,449.595], [1044.75,396.292], [1044.49,446.2]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.08,449.627], [1051.77,500.37], [1044.49,446.232], [1044.23,495.589]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.77,500.402], [1051.46,550.574], [1044.23,495.62], [1043.97,544.437]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.46,550.605], [1051.16,600.214], [1043.97,544.468], [1043.72,592.753]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1053.03,293.769], [1053.35,240.639], [1045.28,294.726], [1045.55,243.113]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.71,346.321], [1053.03,293.769], [1045.02,345.794], [1045.28,294.726]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.71,346.321], [1052.39,398.237], [1045.02,345.794], [1044.75,396.26]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.57,697.876], [1084.22,696.453], [1050.27,745.854], [1083.74,744.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.27,745.884], [1083.74,744.286], [1049.98,793.337], [1083.27,791.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1049.98,793.337], [1083.27,791.566], [1049.72,836.876], [1082.84,834.949]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.77,500.402], [1086.18,499.723], [1051.46,550.574], [1085.68,549.702]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.46,550.605], [1085.68,549.734], [1051.16,600.214], [1085.19,599.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1051.16,600.246], [1085.19,599.186], [1050.86,649.302], [1084.7,648.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1050.86,649.333], [1084.7,648.089], [1050.57,697.845], [1084.22,696.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.71,346.321], [1052.39,398.237], [1087.7,346.246], [1087.19,397.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.39,398.27], [1052.08,449.595], [1087.19,397.989], [1086.68,449.112]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.08,449.627], [1051.77,500.37], [1086.68,449.145], [1086.18,499.691]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1053.03,293.769], [1053.35,240.639], [1088.23,293.905], [1088.75,240.99]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1052.71,346.321], [1053.03,293.769], [1087.7,346.246], [1088.23,293.905]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.68,753.777], [1090.16,802.076], [1083.74,744.286], [1083.27,791.566]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.16,802.076], [1089.68,846.383], [1083.27,791.566], [1082.84,834.95]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.74,655.473], [1091.2,704.871], [1084.7,648.089], [1084.22,696.422]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.2,704.902], [1090.68,753.746], [1084.22,696.453], [1083.74,744.255]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.82,554.91], [1092.27,605.447], [1085.68,549.734], [1085.19,599.155]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.27,605.478], [1091.74,655.441], [1085.19,599.186], [1084.7,648.059]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.93,452.01], [1093.37,503.725], [1086.68,449.145], [1086.18,499.691]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.37,503.757], [1092.82,554.878], [1086.18,499.723], [1085.68,549.702]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.06,346.691], [1094.49,399.625], [1087.7,346.246], [1087.19,397.956]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.49,399.658], [1093.93,451.977], [1087.19,397.989], [1086.68,449.113]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1095.64,293.097], [1096.22,238.901], [1088.23,293.905], [1088.75,240.991]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.06,346.691], [1095.64,293.097], [1087.7,346.246], [1088.23,293.905]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.68,753.777], [1090.16,802.076], [1192.13,748.816], [1191.05,796.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1090.16,802.076], [1089.68,846.383], [1191.05,796.583], [1190.07,840.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.74,655.473], [1091.2,704.871], [1194.31,651.613], [1193.21,700.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1091.2,704.902], [1090.68,753.746], [1193.21,700.486], [1192.13,748.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.82,554.91], [1092.27,605.446], [1196.55,552.204], [1195.42,602.157]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1092.27,605.479], [1091.74,655.441], [1195.42,602.189], [1194.31,651.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.93,452.01], [1093.37,503.725], [1198.83,450.512], [1197.68,501.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1093.37,503.757], [1092.82,554.878], [1197.68,501.648], [1196.55,552.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1094.49,399.658], [1093.93,451.977], [1199.99,398.785], [1198.83,450.479]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.06,346.691], [1095.64,293.097], [1201.17,346.458], [1202.36,293.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1095.06,346.691], [1094.49,399.625], [1201.17,346.458], [1199.99,398.752]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1095.64,293.097], [1096.22,238.9], [1202.36,293.52], [1203.56,239.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.32,803.725], [1196.29,848.176], [1191.05,796.583], [1190.07,840.408]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.45,755.267], [1197.32,803.725], [1192.13,748.817], [1191.05,796.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.59,706.229], [1198.45,755.235], [1193.21,700.486], [1192.13,748.786]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.74,656.632], [1199.59,706.197], [1194.31,651.613], [1193.21,700.455]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.91,606.466], [1200.74,656.6], [1195.42,602.189], [1194.31,651.582]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.08,555.723], [1201.91,606.434], [1196.55,552.204], [1195.42,602.158]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.32,803.725], [1196.29,848.176], [1256.1,800.474], [1254.77,844.64]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.28,504.391], [1203.08,555.69], [1197.68,501.648], [1196.55,552.172]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.45,755.267], [1197.32,803.725], [1257.55,752.33], [1256.1,800.474]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.48,452.46], [1204.28,504.358], [1198.83,450.512], [1197.68,501.616]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.7,399.921], [1205.48,452.427], [1199.99,398.786], [1198.83,450.479]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1199.59,706.229], [1198.45,755.235], [1259.01,703.614], [1257.55,752.299]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.94,346.761], [1206.7,399.887], [1201.17,346.459], [1200,398.753]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1200.74,656.632], [1199.59,706.197], [1260.49,654.347], [1259.01,703.583]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.94,346.761], [1209.19,292.97], [1201.17,346.458], [1202.36,293.52]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1201.91,606.466], [1200.74,656.6], [1261.99,604.519], [1260.49,654.315]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1203.08,555.723], [1201.91,606.434], [1263.5,554.121], [1261.99,604.487]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1209.19,292.97], [1210.45,238.573], [1202.36,293.52], [1203.56,239.994]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1204.28,504.391], [1203.08,555.69], [1265.03,503.142], [1263.5,554.088]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1205.48,452.46], [1204.28,504.358], [1266.58,451.573], [1265.03,503.109]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1206.7,399.921], [1205.48,452.427], [1268.15,399.404], [1266.58,451.54]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.94,346.761], [1206.7,399.887], [1269.73,346.623], [1268.15,399.37]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1207.94,346.761], [1209.19,292.97], [1269.73,346.623], [1271.34,293.22]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1209.19,292.97], [1210.45,238.573], [1271.34,293.221], [1272.96,239.22]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.76,794.919], [1252.46,838.597], [1307.18,792], [1305.62,835.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1255.17,747.313], [1253.76,794.919], [1308.88,744.677], [1307.18,792]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.61,699.148], [1255.17,747.283], [1310.6,696.801], [1308.88,744.647]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1258.05,650.444], [1256.61,699.117], [1312.34,648.394], [1310.6,696.771]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.52,601.193], [1258.06,650.413], [1314.1,599.445], [1312.34,648.363]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1261,551.384], [1259.52,601.161], [1315.88,549.947], [1314.1,599.414]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.5,501.009], [1261,551.352], [1317.67,499.889], [1315.88,549.915]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1264.02,450.058], [1262.5,500.977], [1319.49,449.263], [1317.68,499.857]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1265.55,398.521], [1264.02,450.026], [1321.33,398.058], [1319.49,449.23]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.1,346.388], [1265.55,398.488], [1323.2,346.265], [1321.33,398.025]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1267.1,346.388], [1268.67,293.648], [1323.2,346.264], [1325.08,293.872]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1268.67,293.648], [1270.26,240.325], [1325.08,293.872], [1326.98,240.905]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.23,785.008], [1297.73,827.813], [1393.6,779.934], [1391.65,822.292]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.86,738.364], [1299.23,785.008], [1395.72,733.783], [1393.6,779.934]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.51,691.182], [1300.86,738.334], [1397.86,687.106], [1395.72,733.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.18,643.485], [1302.51,691.152], [1400.03,639.924], [1397.86,687.076]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1305.87,595.263], [1304.18,643.454], [1402.21,592.229], [1400.03,639.893]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.57,546.507], [1305.87,595.232], [1404.43,544.012], [1402.22,592.198]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.3,497.209], [1307.57,546.476], [1406.66,495.265], [1404.43,543.981]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.04,447.359], [1309.3,497.177], [1408.93,445.979], [1406.67,495.234]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1312.81,396.949], [1311.04,447.327], [1411.21,396.146], [1408.93,445.948]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.59,345.969], [1312.81,396.917], [1413.53,345.755], [1411.22,396.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1314.59,345.969], [1316.39,294.408], [1413.53,345.754], [1415.87,294.797]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1316.39,294.409], [1318.22,242.292], [1415.87,294.797], [1418.23,243.297]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1373.84,765.388], [1404.23,763.811], [1372.06,806.46], [1402.3,804.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1375.79,720.654], [1373.84,765.388], [1406.32,719.23], [1404.23,763.811]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1377.76,675.425], [1375.79,720.625], [1408.44,674.159], [1406.33,719.202]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1379.75,629.723], [1377.76,675.396], [1410.59,628.617], [1408.45,674.13]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1381.76,583.54], [1379.75,629.693], [1412.75,582.598], [1410.59,628.588]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1383.79,536.869], [1381.76,583.51], [1414.94,536.095], [1412.75,582.569]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.85,489.702], [1383.79,536.839], [1417.15,489.099], [1414.94,536.065]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.92,442.03], [1385.85,489.671], [1419.39,441.603], [1417.15,489.069]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1390.02,393.846], [1387.92,442], [1421.64,393.598], [1419.39,441.572]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.14,345.142], [1390.02,393.816], [1423.93,345.076], [1421.64,393.567]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1392.14,345.142], [1394.28,295.909], [1423.93,345.076], [1426.23,296.029]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1394.28,295.909], [1396.45,246.17], [1426.23,296.029], [1428.56,246.481]]
            },],[{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[582.35,293.08], [579.934,239.845], [547.375,293.024], [544.752,239.703]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.739,345.735], [582.35,293.08], [550.143,345.758], [547.549,293.032]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[584.74,345.735], [587.1,397.755], [549.97,345.763], [552.534,397.864]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[587.102,397.788], [589.436,449.215], [552.535,397.897], [555.07,449.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[589.437,449.248], [591.745,500.094], [555.071,449.437], [557.577,500.36]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[591.746,500.125], [594.028,550.399], [557.579,500.392], [560.056,550.742]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[594.029,550.431], [560.058,550.774], [596.285,600.141], [562.507,600.559]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[596.286,600.173], [562.509,600.59], [598.517,649.33], [564.931,649.821]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[598.519,649.361], [564.933,649.852], [600.725,697.975], [567.328,698.536]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[683.733,291.87], [681.844,236.789], [569.39,291.68], [566.799,236.308]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[600.726,698.005], [567.33,698.567], [602.908,746.084], [569.699,746.715]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.6,346.331], [683.733,291.871], [571.951,346.425], [569.39,291.681]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[602.909,746.114], [569.7,746.745], [605.067,793.666], [572.044,794.366]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[685.6,346.331], [687.445,400.113], [571.951,346.425], [574.481,400.483]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[605.067,793.666], [572.044,794.366], [607.047,837.298], [574.193,838.058]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[687.446,400.147], [689.268,453.296], [574.482,400.517], [576.982,453.937]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[689.27,453.329], [691.071,505.856], [576.983,453.97], [579.453,506.762]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[691.072,505.889], [692.852,557.806], [579.455,506.795], [581.896,558.969]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[692.854,557.839], [694.613,609.155], [581.898,559.002], [584.311,610.57]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.614,609.187], [696.354,659.913], [584.312,610.602], [586.697,661.575]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[696.355,659.945], [698.075,710.092], [586.699,661.607], [589.056,711.994]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[698.076,710.123], [699.776,759.7], [589.058,712.025], [591.389,761.836]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[699.777,759.731], [701.458,808.747], [591.39,761.868], [593.694,811.113]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[701.458,808.747], [703,853.706], [593.694,811.113], [595.808,856.28]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[742.774,291.352], [741.219,235.478], [679.874,291.246], [677.929,235.209]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.312,346.586], [742.774,291.352], [681.797,346.639], [679.874,291.246]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[744.312,346.587], [745.83,401.124], [681.797,346.639], [683.696,401.331]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[745.831,401.159], [747.331,455.045], [683.697,401.366], [685.573,455.404]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[747.332,455.079], [748.814,508.327], [685.574,455.438], [687.427,508.833]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[748.815,508.36], [750.28,560.98], [687.428,508.867], [689.26,561.631]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[750.281,561.013], [689.261,561.664], [751.729,613.016], [691.071,613.807]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[751.73,613.049], [691.072,613.84], [753.16,664.446], [692.861,665.375]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[753.161,664.479], [692.862,665.407], [754.575,715.28], [694.63,716.343]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[694.632,716.375], [696.379,766.722], [698.075,710.123], [699.776,759.7]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[754.576,715.312], [694.632,716.375], [755.974,765.529], [696.379,766.722]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[755.975,765.56], [696.38,766.754], [757.357,815.202], [698.108,816.523]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[757.357,815.202], [698.108,816.523], [758.624,860.727], [699.692,862.165]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[811.212,290.927], [810.062,234.404], [746.226,290.816], [744.669,234.122]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.35,346.796], [811.212,290.927], [747.764,346.851], [746.226,290.816]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[812.35,346.796], [813.472,401.951], [747.764,346.851], [749.283,402.169]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[813.473,401.986], [814.582,456.476], [749.284,402.204], [750.785,456.852]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[814.583,456.511], [750.786,456.886], [815.679,510.347], [752.268,510.878]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[815.679,510.381], [752.269,510.912], [816.762,563.576], [753.734,564.257]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[816.763,563.609], [753.735,564.291], [817.833,616.174], [755.182,617.002]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[817.834,616.207], [755.183,617.036], [818.891,668.152], [756.613,669.124]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[818.892,668.185], [756.614,669.157], [819.937,719.521], [758.028,720.634]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[819.937,719.554], [758.029,720.667], [820.97,770.292], [759.426,771.542]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[820.971,770.324], [759.426,771.575], [821.992,820.476], [760.807,821.86]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[821.992,820.476], [760.807,821.86], [822.928,866.464], [762.073,867.969]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[927.856,291.74], [927.435,236.459], [812.822,291.546], [811.701,235.968]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.272,346.395], [927.856,291.74], [813.931,346.491], [812.822,291.546]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.272,346.395], [928.682,400.367], [813.931,346.491], [815.026,400.746]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.682,400.401], [815.027,400.78], [929.088,453.736], [816.109,454.391]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.089,453.77], [816.109,454.425], [929.489,506.479], [817.178,507.403]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.49,506.512], [817.179,507.437], [929.886,558.606], [818.236,559.793]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.886,558.639], [818.236,559.826], [930.278,610.128], [819.281,611.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.278,610.16], [819.281,611.605], [930.665,661.056], [820.314,662.751]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.665,661.088], [820.314,662.784], [931.048,711.399], [821.334,713.34]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.048,711.431], [821.335,713.372], [931.427,761.169], [822.344,763.35]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.427,761.2], [822.344,763.381], [931.801,810.374], [823.341,812.789]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.801,810.374], [823.341,812.789], [932.144,855.476], [824.256,858.103]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[927.37,292.654], [963.825,292.714], [926.957,238.768], [963.627,238.92]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.779,345.945], [927.37,292.654], [964.02,345.916], [963.824,292.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[927.778,345.945], [964.02,345.916], [928.181,398.586], [964.213,398.469]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.182,398.62], [964.213,398.503], [928.58,450.654], [964.404,450.452]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.581,450.687], [964.404,450.485], [928.975,502.126], [964.593,501.84]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[928.975,502.159], [964.593,501.873], [929.365,553.012], [964.78,552.644]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.365,553.044], [964.78,552.676], [929.75,603.321], [964.964,602.874]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[929.75,603.353], [964.965,602.906], [930.131,653.064], [965.147,652.539]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.131,653.096], [965.147,652.57], [930.508,702.25], [965.327,701.649]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.508,702.282], [965.328,701.68], [930.88,750.889], [965.506,750.213]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[930.881,750.92], [965.506,750.244], [931.249,798.989], [965.682,798.241]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[931.249,798.989], [965.682,798.241], [931.587,843.09], [965.844,842.275]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.4,651.318], [1042.15,700.215], [1038.68,642.367], [1038.46,689.965]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.15,700.246], [1041.9,748.602], [1038.46,689.995], [1038.24,737.08]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.9,748.632], [1041.65,796.455], [1038.24,737.11], [1038.02,783.691]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.65,796.455], [1041.43,840.332], [1038.02,783.691], [1037.82,826.441]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.43,450.002], [1043.17,501.158], [1039.6,446.554], [1039.37,496.288]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.17,501.191], [1042.91,551.768], [1039.37,496.32], [1039.14,545.507]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.91,551.8], [1042.65,601.807], [1039.14,545.538], [1038.91,594.187]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.65,601.839], [1042.4,651.286], [1038.91,594.217], [1038.68,642.336]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1044.23,292.857], [1044.5,239.281], [1040.32,293.877], [1040.56,241.86]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.96,345.845], [1044.23,292.857], [1040.08,345.342], [1040.32,293.877]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.96,345.845], [1043.69,398.19], [1040.08,345.342], [1039.84,396.199]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.69,398.223], [1043.43,449.969], [1039.84,396.231], [1039.6,446.522]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.65,796.455], [1075.76,795.714], [1041.43,840.332], [1075.36,839.526]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.65,601.839], [1077.52,601.396], [1042.4,651.286], [1077.07,650.767]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.4,651.318], [1077.07,650.798], [1042.15,700.215], [1076.63,699.619]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.15,700.246], [1076.63,699.65], [1041.9,748.602], [1076.19,747.932]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1041.9,748.632], [1076.19,747.963], [1041.65,796.455], [1075.76,795.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.69,398.223], [1043.43,449.969], [1079.36,398.108], [1078.89,449.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.43,450.002], [1078.89,449.801], [1043.17,501.158], [1078.43,500.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.17,501.191], [1078.43,500.908], [1042.91,551.768], [1077.97,551.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1042.91,551.8], [1077.97,551.436], [1042.65,601.807], [1077.52,601.364]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1044.23,292.857], [1044.5,239.281], [1080.31,292.916], [1080.8,239.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.96,345.845], [1044.23,292.857], [1079.84,345.816], [1080.31,292.916]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1043.96,345.845], [1043.69,398.19], [1079.84,345.816], [1079.36,398.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.63,806.525], [1079.2,851.289], [1075.76,795.714], [1075.36,839.526]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.56,708.338], [1080.09,757.694], [1076.63,699.65], [1076.19,747.932]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.09,757.725], [1079.63,806.525], [1076.19,747.963], [1075.76,795.714]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.52,607.858], [1081.04,658.353], [1077.52,601.396], [1077.07,650.767]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.04,658.385], [1080.56,708.306], [1077.07,650.798], [1076.63,699.62]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083,452.727], [1082.5,505.007], [1078.89,449.801], [1078.43,500.875]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.5,505.04], [1082.01,556.714], [1078.43,500.907], [1077.97,551.404]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.01,556.746], [1081.52,607.826], [1077.97,551.436], [1077.52,601.365]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.01,346.243], [1083.5,399.765], [1079.84,345.816], [1079.36,398.075]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.5,399.799], [1083,452.694], [1079.36,398.108], [1078.89,449.769]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1079.63,806.525], [1184.05,804.203], [1079.2,851.289], [1183.09,848.763]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1084.53,292.049], [1085.05,237.24], [1080.31,292.916], [1080.8,239.431]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.01,346.243], [1084.53,292.049], [1079.84,345.816], [1080.31,292.916]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.56,708.338], [1080.09,757.694], [1186.17,706.471], [1185.1,755.597]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1080.09,757.725], [1079.63,806.525], [1185.1,755.628], [1184.05,804.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.52,607.858], [1081.04,658.354], [1188.33,606.47], [1187.24,656.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1081.04,658.385], [1080.56,708.306], [1187.24,656.755], [1186.17,706.44]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.5,505.04], [1082.01,556.714], [1190.54,504.152], [1189.43,555.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1082.01,556.746], [1081.52,607.826], [1189.43,555.605], [1188.33,606.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083.5,399.799], [1083,452.694], [1192.8,399.435], [1191.66,452.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1083,452.727], [1082.5,505.007], [1191.66,452.098], [1190.54,504.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.01,346.243], [1084.53,292.049], [1193.95,346.151], [1195.12,292.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1084.01,346.243], [1083.5,399.765], [1193.95,346.151], [1192.8,399.401]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1084.53,292.049], [1085.05,237.24], [1195.12,292.236], [1196.29,237.711]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.37,811.656], [1187.37,856.871], [1184.05,804.203], [1183.09,848.763]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.46,762.359], [1188.37,811.656], [1185.1,755.628], [1184.05,804.203]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.57,712.462], [1189.46,762.327], [1186.17,706.471], [1185.1,755.596]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.68,661.989], [1190.57,712.43], [1187.24,656.755], [1186.17,706.44]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.81,610.928], [1191.68,661.956], [1188.33,606.47], [1187.24,656.723]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.96,559.27], [1192.81,610.895], [1189.43,555.605], [1188.33,606.438]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1188.37,811.656], [1249.92,810.266], [1187.37,856.871], [1248.6,855.358]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1189.46,762.359], [1251.36,761.103], [1188.37,811.656], [1249.92,810.266]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.11,507.003], [1193.96,559.236], [1190.54,504.152], [1189.43,555.573]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1190.57,712.462], [1252.81,711.344], [1189.46,762.327], [1251.36,761.071]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.28,454.118], [1195.11,506.97], [1191.66,452.099], [1190.54,504.119]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1191.68,661.989], [1190.57,712.43], [1254.28,661.012], [1252.81,711.312]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.47,400.603], [1196.28,454.084], [1192.8,399.435], [1191.66,452.065]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1192.81,610.928], [1191.68,661.956], [1255.77,610.096], [1254.29,660.98]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.66,346.447], [1197.47,400.569], [1193.95,346.152], [1192.8,399.402]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1193.96,559.269], [1192.81,610.895], [1257.28,558.586], [1255.77,610.063]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.66,346.446], [1199.88,291.637], [1193.95,346.151], [1195.12,292.236]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1195.11,507.003], [1193.96,559.236], [1258.81,506.471], [1257.28,558.553]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1199.88,291.637], [1201.1,236.199], [1195.12,292.236], [1196.3,237.712]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1196.28,454.118], [1195.11,506.97], [1260.35,453.741], [1258.81,506.437]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1197.47,400.603], [1196.28,454.084], [1261.91,400.385], [1260.35,453.707]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.66,346.446], [1197.47,400.569], [1263.49,346.391], [1261.91,400.351]]
            },{
            tipo:"Valle",
            name:"Torre3",
            verts:[[1198.66,346.446], [1199.88,291.637], [1263.49,346.391], [1265.09,291.749]]
            },{
            tipo:"PH Valle",
            name:"Torre3",
            verts:[[1199.88,291.637], [1201.1,236.199], [1265.09,291.749], [1266.7,236.481]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1249.15,804.526], [1305.49,803.269], [1247.85,849.115], [1303.9,847.746]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1250.56,755.92], [1307.22,754.784], [1249.15,804.526], [1305.49,803.269]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1252,706.731], [1250.56,755.889], [1308.97,705.72], [1307.22,754.753]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1253.45,656.982], [1252,706.7], [1310.74,656.099], [1308.97,705.689]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1254.91,606.663], [1253.45,656.95], [1312.53,605.911], [1310.74,656.067]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1256.4,555.764], [1254.91,606.631], [1314.34,555.146], [1312.53,605.879]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1257.9,504.275], [1256.4,555.732], [1316.17,503.794], [1314.34,555.114]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1259.42,452.186], [1257.9,504.242], [1318.02,451.846], [1316.17,503.761]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1260.95,399.486], [1259.42,452.153], [1319.9,399.289], [1318.02,451.812]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.51,346.164], [1260.95,399.452], [1321.79,346.115], [1319.9,399.256]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1262.51,346.164], [1264.08,292.21], [1321.79,346.114], [1323.71,292.31]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1264.08,292.21], [1265.67,237.646], [1323.71,292.311], [1325.65,237.901]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1299.3,795.863], [1297.77,839.688], [1399.71,793.657], [1397.68,837.288]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1300.97,748.098], [1299.3,795.863], [1401.93,746.106], [1399.71,793.657]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1302.65,699.77], [1300.97,748.067], [1404.16,697.998], [1401.93,746.076]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1304.36,650.903], [1302.65,699.74], [1406.43,649.355], [1404.17,697.968]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1306.08,601.485], [1304.36,650.871], [1408.72,600.168], [1406.43,649.324]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1307.83,551.509], [1306.09,601.454], [1411.03,550.427], [1408.72,600.136]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1309.6,500.965], [1307.83,551.477], [1413.37,500.122], [1411.03,550.395]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1311.38,449.842], [1309.6,500.932], [1415.74,449.246], [1413.37,500.09]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1313.19,398.131], [1311.38,449.809], [1418.13,397.786], [1415.74,449.213]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.01,345.822], [1313.19,398.098], [1420.55,345.735], [1418.13,397.754]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1315.01,345.822], [1316.86,292.904], [1420.55,345.735], [1423,293.08]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1316.86,292.904], [1318.73,239.401], [1423,293.081], [1425.48,239.847]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1383.27,778.082], [1415.78,777.392], [1381.39,820.335], [1413.74,819.584]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1385.32,732.048], [1418,731.425], [1383.27,778.082], [1415.78,777.392]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1387.39,685.492], [1420.25,684.938], [1385.32,732.018], [1418,731.396]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1389.49,638.436], [1387.4,685.462], [1422.52,637.953], [1420.25,684.909]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1391.61,590.871], [1389.49,638.406], [1424.81,590.46], [1422.52,637.922]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1393.75,542.79], [1391.61,590.841], [1427.13,542.452], [1424.81,590.429]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1395.92,494.182], [1393.75,542.758], [1429.47,493.92], [1427.13,542.421]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1398.11,445.042], [1395.92,494.151], [1431.84,444.856], [1429.47,493.889]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1400.32,395.357], [1398.11,445.01], [1434.24,395.25], [1431.84,444.824]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402.56,345.122], [1400.32,395.326], [1436.66,345.095], [1434.24,395.218]]
            },{
            tipo:"Rio",
            name:"Torre3",
            verts:[[1402.56,345.121], [1404.82,294.324], [1436.66,345.094], [1439.11,294.38]]
            },{
            tipo:"PH Rio",
            name:"Torre3",
            verts:[[1404.82,294.324], [1407.11,242.99], [1439.11,294.379], [1441.58,243.128]]
            },],]
        }
    }